
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3sQZZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a884da9d91f2c4a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5BRby = parcelRequire("5BRby");

var $8BZ1O = parcelRequire("8BZ1O");

var $jpVCp = parcelRequire("jpVCp");

var $egJIx = parcelRequire("egJIx");

var $8vncz = parcelRequire("8vncz");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $aYtGv = parcelRequire("aYtGv");

var $1ybV0 = parcelRequire("1ybV0");

var $fTv4c = parcelRequire("fTv4c");

var $5bIU1 = parcelRequire("5bIU1");

var $fD1Hq = parcelRequire("fD1Hq");

var $aeIT6 = parcelRequire("aeIT6");

var $fO5rB = parcelRequire("fO5rB");

var $bhwgQ = parcelRequire("bhwgQ");

var $jK1pm = parcelRequire("jK1pm");

var $8pOVC = parcelRequire("8pOVC");
const $a884da9d91f2c4a2$var$LIST_NAV_ITEM_SEEN_IT_FLAG = 'jsw.list.nav-item-flag';
const $a884da9d91f2c4a2$var$JiraSoftwareListApp = ()=>{
    const { data: features } = (0, $5bIU1.useFeatures)();
    const { data: board } = (0, $fTv4c.useBoard)();
    const isScrumProject = board?.type === 'scrum' || features?.hasSprint;
    const { data: project } = (0, $aeIT6.useProject)();
    const isSubtasksEnabled = (0, $fD1Hq.useIsSubtasksEnabled)();
    const isSimplifiedProject = Boolean(project?.isSimplified);
    const canCreateIssues = Boolean(project?.permissions.createIssues);
    const canCreateSubtask = canCreateIssues && (isSimplifiedProject || isSubtasksEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "software-list-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "software-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BZ1O.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $egJIx.ListFeaturesProvider), {
        featureView: "software-list",
        hasCreateSubtask: canCreateSubtask,
        canCreateIssues: canCreateIssues,
        isSoftwareFieldsEnabled: true,
        isBusinessFieldsEnabled: false,
        isScrumProject: isScrumProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7c3W1.ViewPreferencesProvider), {
        view: "list",
        preferences: (0, $ji3xf.LIST_VIEW_PREFERENCES)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $a884da9d91f2c4a2$var$pageContainerStyles,
            (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') && $a884da9d91f2c4a2$var$fullHeightPageContainerStyles
        ]
    }, !(0, $1ybV0.ff)('jsw.list.sidebar-layout-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pOVC.PageHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? $a884da9d91f2c4a2$var$listContainerStyles : $a884da9d91f2c4a2$var$listContainerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jpVCp.default), {
        header: (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pOVC.PageHeader), null)
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8vncz.SeenIt), {
        flag: $a884da9d91f2c4a2$var$LIST_NAV_ITEM_SEEN_IT_FLAG
    }))));
};
const $a884da9d91f2c4a2$var$PAGE_HEADER_HEIGHT = 75;
const $a884da9d91f2c4a2$var$LIST_PADDING = 24;
const $a884da9d91f2c4a2$var$pageContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200'
});
const $a884da9d91f2c4a2$var$fullHeightPageContainerStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $a884da9d91f2c4a2$var$listContainerStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $a884da9d91f2c4a2$var$listContainerStylesOld = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$a884da9d91f2c4a2$var$PAGE_HEADER_HEIGHT}px - ${$a884da9d91f2c4a2$var$LIST_PADDING}px)`
});
var $a884da9d91f2c4a2$export$2e2bcd8739ae039 = $a884da9d91f2c4a2$var$JiraSoftwareListApp;

});
parcelRegister("8BZ1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $80390eebeffb6a20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bDUCT = parcelRequire("bDUCT");
var $fDLFb = parcelRequire("fDLFb");
var $eZbpk = parcelRequire("eZbpk");
var $ePgRW = parcelRequire("ePgRW");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $jWIW7 = parcelRequire("jWIW7");

var $7IBv4 = parcelRequire("7IBv4");

var $8WuJm = parcelRequire("8WuJm");

var $kJlBc = parcelRequire("kJlBc");

var $aeIT6 = parcelRequire("aeIT6");

var $dWLk9 = parcelRequire("dWLk9");

var $hCCuu = parcelRequire("hCCuu");

var $k4xGW = parcelRequire("k4xGW");
const $80390eebeffb6a20$var$ProjectContextProvider = ({ children: children })=>{
    const { data: project, loading: loading, error: error } = (0, $aeIT6.useProject)();
    const { replace: replace } = (0, $kJlBc.useRouterActions)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = project?.id;
    const projectKey = project?.key;
    const projectType = project?.type;
    const isTeamManaged = Boolean(project?.isSimplified);
    const jqlContext = projectKey ? `project = '${projectKey}'` : '';
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectId: projectId,
            isTeamManaged: isTeamManaged,
            projectType: projectType
        }), [
        projectId,
        isTeamManaged,
        projectType
    ]);
    const entityData = (0, $eUqFw.useMemo)(()=>project?.permissions?.viewIssues ? {
            name: project.name,
            id: String(project.id)
        } : null, [
        project
    ]);
    const projects = (0, $eUqFw.useMemo)(()=>project ? [
            project
        ] : undefined, [
        project
    ]);
    const projectIdList = (0, $eUqFw.useMemo)(()=>projectId ? [
            projectId
        ] : undefined, [
        projectId
    ]);
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    if (project?.status === 'ARCHIVED') {
        replace('/jira/errors/project-archived');
        return null;
    }
    let content;
    if (loading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IBv4.ThemedLazySkeleton), null);
    else if (project == null || entityData == null || error) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4xGW.default), null), error && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceFailed), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE),
        error: error
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQAZu.ProjectHookProvider), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDLFb.BusinessEntityProvider), {
        data: entityData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ePgRW.RealtimeProvider), {
        ids: projectIdList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDUCT.AriProvider), {
        ari: projectAri
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZbpk.JqlProvider), {
        jqlContext: jqlContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWIW7.FiltersProvider), {
        projects: projects
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceSuccess), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        containerId: String(project?.id),
        containerType: "project",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessProjectContext",
        attributes: analyticsAttributes,
        // we set a key on the first element to force React to re-render when the context changes
        // to avoid query race-conditions that would lead to promises from a previous context
        // resolving in the current context view, and thus seeing unrelated data
        key: String(project?.id)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceStart), {
        experience: (0, $hCCuu.FETCH_PROJECT_EXPERIENCE)
    }), content);
};
var $80390eebeffb6a20$export$2e2bcd8739ae039 = $80390eebeffb6a20$var$ProjectContextProvider;

});
parcelRegister("bDUCT", function(module, exports) {

$parcel$export(module.exports, "AriProvider", () => $76c0a50c757f3bcd$export$c806f8ac05dc61fa);
$parcel$export(module.exports, "useEntityAri", () => $76c0a50c757f3bcd$export$badcacdc306567b8);

var $eUqFw = parcelRequire("eUqFw");
const $76c0a50c757f3bcd$var$AriContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $76c0a50c757f3bcd$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($76c0a50c757f3bcd$var$AriContext.Provider, {
        value: ari
    }, children);
const $76c0a50c757f3bcd$export$badcacdc306567b8 = ()=>(0, $eUqFw.useContext)($76c0a50c757f3bcd$var$AriContext);

});

parcelRegister("fDLFb", function(module, exports) {

$parcel$export(module.exports, "BusinessEntityProvider", () => $984e8248b41af828$export$c800e064c3c327ef);
$parcel$export(module.exports, "useBusinessEntity", () => $984e8248b41af828$export$ff2574b00bc1c100);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $984e8248b41af828$var$BusinessEntityContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $984e8248b41af828$export$c800e064c3c327ef = ({ data: data, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($984e8248b41af828$var$BusinessEntityContext.Provider, {
        value: data
    }, children);
const $984e8248b41af828$export$ff2574b00bc1c100 = ()=>{
    const entity = (0, $eUqFw.useContext)($984e8248b41af828$var$BusinessEntityContext);
    return {
        data: entity
    };
};

});

parcelRegister("eZbpk", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $28ab7b3257a6571c$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $28ab7b3257a6571c$export$f32e2f688fc08561);

var $eUqFw = parcelRequire("eUqFw");
const $28ab7b3257a6571c$var$JqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)('');
const $28ab7b3257a6571c$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28ab7b3257a6571c$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $28ab7b3257a6571c$export$f32e2f688fc08561 = ()=>(0, $eUqFw.useContext)($28ab7b3257a6571c$var$JqlContext);

});

parcelRegister("ePgRW", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $d87d469a5640e4cf$export$64d242981d970821);
$parcel$export(module.exports, "useRealtimeContext", () => $d87d469a5640e4cf$export$f39c07717ad8c35b);

var $eUqFw = parcelRequire("eUqFw");
const $d87d469a5640e4cf$var$RealtimeContext = /*#__PURE__*/ (0, $eUqFw.createContext)([]);
const $d87d469a5640e4cf$export$64d242981d970821 = ({ ids: ids, children: children })=>{
    const projectsIds = (0, $eUqFw.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
        ids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87d469a5640e4cf$var$RealtimeContext.Provider, {
        value: projectsIds
    }, children);
};
const $d87d469a5640e4cf$export$f39c07717ad8c35b = ()=>(0, $eUqFw.useContext)($d87d469a5640e4cf$var$RealtimeContext);

});

parcelRegister("kQAZu", function(module, exports) {

$parcel$export(module.exports, "ProjectHookProvider", () => $5a070342b3707183$export$f1938a4916a14d9f);
$parcel$export(module.exports, "useProject", () => $5a070342b3707183$export$51b1383ef8844a7);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $5a070342b3707183$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5a070342b3707183$export$f1938a4916a14d9f = ({ project: project, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a070342b3707183$var$Context.Provider, {
        value: project
    }, children);
const $5a070342b3707183$export$51b1383ef8844a7 = ()=>{
    const project = (0, $eUqFw.useContext)($5a070342b3707183$var$Context);
    if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
    return project;
};

});

parcelRegister("jWIW7", function(module, exports) {

$parcel$export(module.exports, "FiltersProvider", () => $85c94258ff14c8b6$export$905df3588d1d8c75);
$parcel$export(module.exports, "useAssigneesFilterQuery", () => $85c94258ff14c8b6$export$f39bce8705b01ff5);
$parcel$export(module.exports, "useProjectFilter", () => $85c94258ff14c8b6$export$b71768ffb8163578);
$parcel$export(module.exports, "useAllowedFieldTypes", () => $85c94258ff14c8b6$export$9dc8a291956c2fa9);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");
const $85c94258ff14c8b6$var$DEFAULT_VALUE = {
    assigneeQuery: '',
    projectFilter: {
        totalCount: 0,
        options: []
    }
};
const $85c94258ff14c8b6$var$FiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($85c94258ff14c8b6$var$DEFAULT_VALUE);
const $85c94258ff14c8b6$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
    const value = (0, $eUqFw.useMemo)(()=>{
        if (!projects) return $85c94258ff14c8b6$var$DEFAULT_VALUE;
        const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
        const projectFilter = {
            totalCount: projects.length,
            options: projects.map((project)=>({
                    label: project.name,
                    value: String(project.id),
                    avatar: project.avatarUrl,
                    square: true
                }))
        };
        return {
            assigneeQuery: assigneeQuery,
            projectFilter: projectFilter
        };
    }, [
        projects
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85c94258ff14c8b6$var$FiltersContext.Provider, {
        value: value
    }, children);
};
const $85c94258ff14c8b6$export$f39bce8705b01ff5 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).assigneeQuery;
const $85c94258ff14c8b6$export$b71768ffb8163578 = ()=>(0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext).projectFilter;
const $85c94258ff14c8b6$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
    const filtersContext = (0, $eUqFw.useContext)($85c94258ff14c8b6$var$FiltersContext);
    return (0, $eUqFw.useMemo)(()=>{
        const result = new Set(inputAllowedFieldTypes ?? (0, $9TEHc.BUSINESS_FIELD_TYPES));
        if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, $lO4Or.PROJECT_TYPE));
        return result;
    }, [
        filtersContext,
        inputAllowedFieldTypes
    ]);
};

});
parcelRegister("9TEHc", function(module, exports) {

$parcel$export(module.exports, "POPUP_WIDTH", () => $199ced4cefdf295b$export$b6d617db656efcca);
$parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", () => $199ced4cefdf295b$export$dd535f74d98d8b3);
$parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", () => $199ced4cefdf295b$export$dba112976ea61483);
$parcel$export(module.exports, "GAP_BETWEEN_OPTION", () => $199ced4cefdf295b$export$fe1082abeeda69ed);
$parcel$export(module.exports, "OPTION_SPAN_PADDING", () => $199ced4cefdf295b$export$17ed91292eb6c163);
$parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", () => $199ced4cefdf295b$export$fb22dccd99438559);
$parcel$export(module.exports, "POPUP_OFFSET_TOP", () => $199ced4cefdf295b$export$15839778e99d81e7);
$parcel$export(module.exports, "OPTION_MAX_WIDTH", () => $199ced4cefdf295b$export$39aa3a14ebf850c7);
$parcel$export(module.exports, "DATE_RANGE_TYPE", () => $199ced4cefdf295b$export$1178808c606e043b);
$parcel$export(module.exports, "BUSINESS_FIELD_TYPES", () => $199ced4cefdf295b$export$c269ba5d631cb115);
$parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", () => $199ced4cefdf295b$export$232814e45256d5dc);
$parcel$export(module.exports, "IMPLEMENTED_TYPES", () => $199ced4cefdf295b$export$9615a3d79408a88a);
$parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", () => $199ced4cefdf295b$export$a21166a4b76932b5);
$parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", () => $199ced4cefdf295b$export$1989c7236a398e8a);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");

var $lO4Or = parcelRequire("lO4Or");
const $199ced4cefdf295b$export$b6d617db656efcca = 360;
const $199ced4cefdf295b$export$90bfd0dcc25478e1 = (0, $c9TLT.gridSize) * 2.5;
const $199ced4cefdf295b$export$dd535f74d98d8b3 = 32;
const $199ced4cefdf295b$export$dba112976ea61483 = $199ced4cefdf295b$export$b6d617db656efcca - $199ced4cefdf295b$export$90bfd0dcc25478e1 * 2;
const $199ced4cefdf295b$export$fe1082abeeda69ed = (0, $c9TLT.gridSize) / 2;
const $199ced4cefdf295b$export$17ed91292eb6c163 = (0, $c9TLT.gridSize) * 2;
const $199ced4cefdf295b$export$fb22dccd99438559 = 14;
const $199ced4cefdf295b$export$15839778e99d81e7 = 215;
const $199ced4cefdf295b$export$de3cbeaaf9d2669 = 28;
const $199ced4cefdf295b$export$39aa3a14ebf850c7 = 150;
const $199ced4cefdf295b$export$1178808c606e043b = 'dateRange';
const $199ced4cefdf295b$export$c269ba5d631cb115 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.CREATED),
    $199ced4cefdf295b$export$1178808c606e043b,
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.PROJECT_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.GOALS_CF_TYPE),
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
    (0, $lO4Or.PARENT_FIELD_TYPE)
];
const $199ced4cefdf295b$export$232814e45256d5dc = [
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE)
];
const $199ced4cefdf295b$export$9615a3d79408a88a = new Set([
    ...$199ced4cefdf295b$export$c269ba5d631cb115,
    ...$199ced4cefdf295b$export$232814e45256d5dc
]);
const $199ced4cefdf295b$export$a21166a4b76932b5 = new Set([
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
]);
const $199ced4cefdf295b$export$90ca377eb0b24ff1 = {
    assignee: (0, $lO4Or.ASSIGNEE_TYPE),
    component: (0, $lO4Or.COMPONENTS_TYPE),
    created: (0, $lO4Or.CREATED),
    issuetype: (0, $lO4Or.ISSUE_TYPE),
    labels: (0, $lO4Or.LABELS_TYPE),
    priority: (0, $lO4Or.PRIORITY_TYPE),
    project: (0, $lO4Or.PROJECT_TYPE),
    reporter: (0, $lO4Or.REPORTER_TYPE),
    status: (0, $lO4Or.STATUS_TYPE),
    type: (0, $lO4Or.ISSUE_TYPE),
    updated: (0, $lO4Or.UPDATED)
};
const $199ced4cefdf295b$export$6a2e733db5135f27 = (0, $c9TLT.gridSize) * 3.5;
const $199ced4cefdf295b$export$1989c7236a398e8a = 50;
const $199ced4cefdf295b$export$91fc9d65fca142a3 = 'users';
const $199ced4cefdf295b$export$d74c70f8fb216c6b = 'recentlyUsedUsers';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hCCuu", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", () => $be9e1adc5e199dda$export$cb40bbf7ea51db63);
const $be9e1adc5e199dda$export$cb40bbf7ea51db63 = {
    experience: 'fetch-project',
    packageName: 'jiraBusinessEntityProjectProvider',
    teamName: 'wanjel'
};

});

parcelRegister("k4xGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1de8d4690ad3f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e1de8d4690ad3f8$var$NotFoundComponent = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3m77k")), {
    moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
});
const $7e1de8d4690ad3f8$var$NotFoundAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "not-found-component",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e1de8d4690ad3f8$var$NotFoundComponent, null));
var $7e1de8d4690ad3f8$export$2e2bcd8739ae039 = $7e1de8d4690ad3f8$var$NotFoundAsync;

});
parcelRegister("3m77k", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dX4bq');
        const value = parcelRequire('gutLJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dX4bq").then(()=>parcelRequire('gutLJ'));
}

});



parcelRegister("jpVCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $21c64313516c2064$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $7e8pf = parcelRequire("7e8pf");

var $fAoR8 = parcelRequire("fAoR8");
var $3555e = parcelRequire("3555e");

var $cWd72 = parcelRequire("cWd72");
var $6F6Wi = parcelRequire("6F6Wi");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $41WOo = parcelRequire("41WOo");

var $d3C6e = parcelRequire("d3C6e");

var $c7wtc = parcelRequire("c7wtc");

var $fWkFY = parcelRequire("fWkFY");

var $jasPp = parcelRequire("jasPp");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $gbsaq = parcelRequire("gbsaq");

var $egJIx = parcelRequire("egJIx");

var $dSE3z = parcelRequire("dSE3z");

var $k3EUD = parcelRequire("k3EUD");

var $aPQfg = parcelRequire("aPQfg");
const $21c64313516c2064$var$analyticsSourceName = 'listView';
const $21c64313516c2064$export$4b527a365d42af03 = /*#__PURE__*/ (0, $eUqFw.memo)(({ header: header })=>{
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = String(projectData.id);
    const projectKey = projectData.key;
    const projectName = projectData.name;
    const isTeamManaged = projectData.isSimplified;
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $lO4Or.STATUS_TYPE);
    const ConditionalWorkflowProvider = (0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || isGroupingByStatus ? (0, $c7wtc.WorkflowsProvider) : (0, $eUqFw.Fragment);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        objectType: "list",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: $21c64313516c2064$var$analyticsSourceName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aPQfg.default), {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isTeamManaged: isTeamManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            projectKey: projectKey
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7e8pf.default), {
        header: header,
        sidebarTheme: (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') && isSoftwareFieldsEnabled ? 'software' : 'business',
        withSidebar: true,
        withOverflow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $7T0RP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWd72.IssueTypesAndFieldsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ConditionalWorkflowProvider, {
        enabled: isGroupingByStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3C6e.IssueCreateProvider), {
        mutation: (0, $k3EUD.CREATE_ISSUE_MUTATION),
        query: (0, $k3EUD.ISSUE_REFETCH_QUERY)
    }, content)), (0, $41WOo.isJwmInlineFieldCreateEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6F6Wi.RefetchFieldsController), null))));
});
const $21c64313516c2064$export$d63bf888f7c02a67 = (props)=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    if (hasConfluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAoR8.ConfluenceModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$4b527a365d42af03, props)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$4b527a365d42af03, props);
};
const $21c64313516c2064$var$List = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4G5xU.ExperienceErrorBoundary), {
        experience: (0, $gbsaq.VIEW_EXPERIENCE),
        shouldStartExperience: true
    }, (0, $eI5EY.fg)('jira_list_add_401_error_handling') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jasPp.AuthenticationErrorBoundary), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$d63bf888f7c02a67, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21c64313516c2064$export$d63bf888f7c02a67, props));
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$21c64313516c2064$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($21c64313516c2064$var$List);

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $5pr8w = parcelRequire("5pr8w");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5pr8w)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("inzmU", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $2fFJv.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});

parcelRegister("5pr8w", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3f0456472e399d24$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3f0456472e399d24$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3f0456472e399d24$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3f0456472e399d24$var$getValidCacheKeyFn(options);
        this._cacheMap = $3f0456472e399d24$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $3f0456472e399d24$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$3f0456472e399d24$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3f0456472e399d24$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$3f0456472e399d24$var$resolvedPromise) $3f0456472e399d24$var$resolvedPromise = Promise.resolve();
    $3f0456472e399d24$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $3f0456472e399d24$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3f0456472e399d24$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $3f0456472e399d24$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3f0456472e399d24$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3f0456472e399d24$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3f0456472e399d24$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3f0456472e399d24$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3f0456472e399d24$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $3f0456472e399d24$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3f0456472e399d24$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3f0456472e399d24$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3f0456472e399d24$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3f0456472e399d24$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3f0456472e399d24$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3f0456472e399d24$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3f0456472e399d24$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3f0456472e399d24$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $3f0456472e399d24$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3f0456472e399d24$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

var $9ypom = parcelRequire("9ypom");
const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $5ECju.default)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});

parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});
parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $5ECju.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $5ECju.default).of({
                data: {}
            });
            return new (0, $5ECju.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fVaJL = parcelRequire("fVaJL");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fVaJL.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});

parcelRegister("9ypom", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4afc5439e22f0a$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $6ds0g = parcelRequire("6ds0g");
var $6f4afc5439e22f0a$var$docCache = new Map();
var $6f4afc5439e22f0a$var$fragmentSourceMap = new Map();
var $6f4afc5439e22f0a$var$printFragmentWarnings = true;
var $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
function $6f4afc5439e22f0a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $6f4afc5439e22f0a$var$cacheKeyFromLoc(loc) {
    return $6f4afc5439e22f0a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $6f4afc5439e22f0a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $6f4afc5439e22f0a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $6f4afc5439e22f0a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($6f4afc5439e22f0a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $6f4afc5439e22f0a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, ast), {
        definitions: definitions
    });
}
function $6f4afc5439e22f0a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $6f4afc5439e22f0a$var$parseDocument(source) {
    var cacheKey = $6f4afc5439e22f0a$var$normalize(source);
    if (!$6f4afc5439e22f0a$var$docCache.has(cacheKey)) {
        var parsed = (0, $6ds0g.parse)(source, {
            experimentalFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $6f4afc5439e22f0a$var$docCache.set(cacheKey, $6f4afc5439e22f0a$var$stripLoc($6f4afc5439e22f0a$var$processFragments(parsed)));
    }
    return $6f4afc5439e22f0a$var$docCache.get(cacheKey);
}
function $6f4afc5439e22f0a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $6f4afc5439e22f0a$var$parseDocument(result);
}
function $6f4afc5439e22f0a$export$657554ef4dc7ac2d() {
    $6f4afc5439e22f0a$var$docCache.clear();
    $6f4afc5439e22f0a$var$fragmentSourceMap.clear();
}
function $6f4afc5439e22f0a$export$e4294e638636c6ab() {
    $6f4afc5439e22f0a$var$printFragmentWarnings = false;
}
function $6f4afc5439e22f0a$export$78cf889af350c840() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = true;
}
function $6f4afc5439e22f0a$export$5290df9bbbd3cfa() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
}
var $6f4afc5439e22f0a$var$extras = {
    gql: $6f4afc5439e22f0a$export$72e4926bf8358653,
    resetCaches: $6f4afc5439e22f0a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $6f4afc5439e22f0a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $6f4afc5439e22f0a$var$extras.gql, gql_1.resetCaches = $6f4afc5439e22f0a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $6f4afc5439e22f0a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.disableExperimentalFragmentVariables;
})($6f4afc5439e22f0a$export$72e4926bf8358653 || ($6f4afc5439e22f0a$export$72e4926bf8358653 = {}));
$6f4afc5439e22f0a$export$72e4926bf8358653["default"] = $6f4afc5439e22f0a$export$72e4926bf8358653;
var $6f4afc5439e22f0a$export$2e2bcd8739ae039 = $6f4afc5439e22f0a$export$72e4926bf8358653;

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});



parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});
parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7e8pf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed5a3ae63b1b20d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kar7l = parcelRequire("kar7l");

var $1ybV0 = parcelRequire("1ybV0");


var $hSCS8 = parcelRequire("hSCS8");

var $eUu4u = parcelRequire("eUu4u");

var $2ESAZ = parcelRequire("2ESAZ");
// This wrapper should be agnostic, please don't add any project or overview logic here.
const $3ed5a3ae63b1b20d$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
    const [{ content: sidebarContent, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const isSidebarOpen = withSidebar && sidebarContent != null;
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, header, children);
    if (withSidebar) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUu4u.SidebarLayout), {
        theme: sidebarTheme
    }, (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $3ed5a3ae63b1b20d$var$contentWrapperStyles,
            isSidebarOpen && $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles
        ]
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ContentWrapper), {
        isSidebarOpen: isSidebarOpen,
        sidebarWidth: sidebarWidth
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ESAZ.ThemedContainer), {
        shouldAddPadding: shouldAddPadding,
        isSidebarOpen: isSidebarOpen,
        withSidebar: withSidebar,
        withDynamicHeight: withDynamicHeight,
        withOverflow: withOverflow,
        id: (0, $d02be44255a1478f$export$e5e75ff4daca6597),
        // Used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, jira/react/no-classname-attribute
        className: className
    }, content);
};
const $3ed5a3ae63b1b20d$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error - we need to use Tokens to correctly set the color value using CSS variables
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    color: (0, $kar7l.Tokens).COLOR_TEXT,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    maxWidth: '100%',
    minWidth: '0',
    width: 'auto'
});
const $3ed5a3ae63b1b20d$var$sidebarOpenContentWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
var $3ed5a3ae63b1b20d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($3ed5a3ae63b1b20d$var$BusinessAppWrapper);

});
const $d02be44255a1478f$export$e5e75ff4daca6597 = 'jwm-container';

parcelRegister("hSCS8", function(module, exports) {

$parcel$export(module.exports, "getSidebarQueryParams", () => $cda1eebb5d053035$export$ddc11e4d41e7cf62);
$parcel$export(module.exports, "useSidebar", () => $cda1eebb5d053035$export$54c70f22f548bff8);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $jGcn0 = parcelRequire("jGcn0");

var $iclz4 = parcelRequire("iclz4");

var $l0jym = parcelRequire("l0jym");
const $cda1eebb5d053035$export$86880b4b2e1a2384 = 'jwm.sidebar';
const $cda1eebb5d053035$export$b16f75f2e0c3c029 = 360;
const $cda1eebb5d053035$export$ddc11e4d41e7cf62 = ()=>[
        (0, $jGcn0.SELECTED_ISSUE_PARAM),
        (0, $jGcn0.SELECTED_COMMENT_PARAM)
    ];
const $cda1eebb5d053035$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content
        });
    };
const $cda1eebb5d053035$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newWidth = Math.max(width, $cda1eebb5d053035$export$b16f75f2e0c3c029);
        if (newWidth === state.sidebarWidth) return;
        setState({
            ...state,
            sidebarWidth: newWidth
        });
        (0, $l0jym.localStorage).set($cda1eebb5d053035$export$86880b4b2e1a2384, newWidth);
    };
const $cda1eebb5d053035$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            onSidebarClose: onSidebarClose
        });
    };
const $cda1eebb5d053035$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        state.onSidebarClose();
        setState({
            ...state,
            content: null,
            onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        });
    };
const $cda1eebb5d053035$var$actions = {
    setSidebarContent: $cda1eebb5d053035$var$setSidebarContent,
    setSidebarWidth: $cda1eebb5d053035$var$setSidebarWidth,
    setSidebarOnClose: $cda1eebb5d053035$var$setSidebarOnClose,
    closeSidebar: $cda1eebb5d053035$var$closeSidebar
};
const $cda1eebb5d053035$var$Store = (0, $a61MH.createStore)({
    initialState: {
        content: null,
        sidebarWidth: (0, $l0jym.localStorage).get($cda1eebb5d053035$export$86880b4b2e1a2384) || $cda1eebb5d053035$export$b16f75f2e0c3c029,
        onSidebarClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    actions: $cda1eebb5d053035$var$actions,
    name: 'JWMSidebarStore'
});
const $cda1eebb5d053035$var$useHook = (0, $ggKAj.createHook)($cda1eebb5d053035$var$Store);
const $cda1eebb5d053035$export$54c70f22f548bff8 = ()=>{
    const [state, hookActions] = $cda1eebb5d053035$var$useHook();
    const sidebarQueryParams = $cda1eebb5d053035$export$ddc11e4d41e7cf62();
    const [, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const resetSidebarQueryParams = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                [param]: undefined
            }), {});
        setQueryParams(newQueryParams);
    }, [
        setQueryParams,
        sidebarQueryParams
    ]);
    return [
        state,
        {
            ...hookActions,
            resetSidebarQueryParams: resetSidebarQueryParams
        }
    ];
};

});
parcelRegister("jGcn0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", () => $15ed10c690a013f2$export$8386e51ba415e85d);
$parcel$export(module.exports, "DEFAULT_AVATAR_RES", () => $15ed10c690a013f2$export$159fe44438c210e9);
$parcel$export(module.exports, "FILTER_PARAM", () => $15ed10c690a013f2$export$d8301e0b33832d94);
$parcel$export(module.exports, "INLINE_CREATE_PARAM", () => $15ed10c690a013f2$export$599c163c1570a353);
$parcel$export(module.exports, "INVITE_OPEN_PARAM", () => $15ed10c690a013f2$export$3a74d1a195d2f007);
$parcel$export(module.exports, "SELECTED_ISSUE_PARAM", () => $15ed10c690a013f2$export$c070acdc9b0f1be5);
$parcel$export(module.exports, "SELECTED_COMMENT_PARAM", () => $15ed10c690a013f2$export$3bcbd99d0f9ad6d8);
$parcel$export(module.exports, "GROUP_BY_ASSIGNEE", () => $15ed10c690a013f2$export$dba794af6c0f2afc);
$parcel$export(module.exports, "GROUP_BY_PRIORITY", () => $15ed10c690a013f2$export$56ecb5d2dfb80edc);
$parcel$export(module.exports, "GROUP_BY_CATEGORY", () => $15ed10c690a013f2$export$22ef551f315f2786);
$parcel$export(module.exports, "GROUP_BY_STATUS", () => $15ed10c690a013f2$export$6d69efb296b78a);
$parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e23e1d1ea45171c2);
$parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$e35c6e217c75dc4b);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", () => $15ed10c690a013f2$export$e5eab344feb92af9);
$parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", () => $15ed10c690a013f2$export$a311e1b78816c048);
$parcel$export(module.exports, "CARD_COVERS_TYPE", () => $15ed10c690a013f2$export$f5583ff4ab4d63e5);
$parcel$export(module.exports, "DEFAULT_PAGE_SIZE", () => $15ed10c690a013f2$export$5716e8bcb003888d);
$parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$1f9fb9f15184100f);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", () => $15ed10c690a013f2$export$c72ea455b368cdd9);

const $15ed10c690a013f2$export$8386e51ba415e85d = (0, $44cab0426b6cf0d7$export$1dee026a19752d6b);
const $15ed10c690a013f2$export$159fe44438c210e9 = '48x48';
const $15ed10c690a013f2$export$d8301e0b33832d94 = 'filter';
const $15ed10c690a013f2$export$599c163c1570a353 = 'inlineCreate';
const $15ed10c690a013f2$export$3a74d1a195d2f007 = 'inviteOpen';
const $15ed10c690a013f2$export$e1e3f9fa6f04d6d = 'quickFilters';
const $15ed10c690a013f2$export$c070acdc9b0f1be5 = 'selectedIssue';
const $15ed10c690a013f2$export$3bcbd99d0f9ad6d8 = 'selectedComment';
const $15ed10c690a013f2$export$dba794af6c0f2afc = 'assignee';
const $15ed10c690a013f2$export$56ecb5d2dfb80edc = 'priority';
const $15ed10c690a013f2$export$22ef551f315f2786 = 'category';
const $15ed10c690a013f2$export$6d69efb296b78a = 'status';
const $15ed10c690a013f2$export$e23e1d1ea45171c2 = 'startdate';
const $15ed10c690a013f2$export$e35c6e217c75dc4b = 'rank';
const $15ed10c690a013f2$export$e5eab344feb92af9 = 'remoteIssueLinks';
const $15ed10c690a013f2$export$a311e1b78816c048 = 'commentsummary';
const $15ed10c690a013f2$export$f5583ff4ab4d63e5 = 'cardCovers';
const $15ed10c690a013f2$export$5716e8bcb003888d = 25;
const $15ed10c690a013f2$export$1f9fb9f15184100f = 'storypoints';
const $15ed10c690a013f2$export$c72ea455b368cdd9 = 'storypointestimate';
const $15ed10c690a013f2$export$786b42b4618e6ee4 = 'sprint';

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("l0jym", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $9c968063af1d87e8$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $9c968063af1d87e8$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_common');

});


parcelRegister("eUu4u", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $b41642a7c0ef06fe$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $h585o = parcelRequire("h585o");

var $h5BJf = parcelRequire("h5BJf");

var $hSCS8 = parcelRequire("hSCS8");

var $lRBAz = parcelRequire("lRBAz");
const $b41642a7c0ef06fe$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            (0, $1ybV0.ff)('jwm-sidebar-resizer-limit_4m1km') ? $b41642a7c0ef06fe$var$sidebarStyles : $b41642a7c0ef06fe$var$oldSidebarStyles,
            theme === 'business' && $b41642a7c0ef06fe$var$businessSidebarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: sidebarWidth
        }
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarOld), {
        sidebarWidth: sidebarWidth
    }, children);
const $b41642a7c0ef06fe$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
    (0, $h585o.useSidebarQueryParams)();
    const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, $h5BJf.useResizer)();
    // reset sidebar content on view unmount
    (0, $eUqFw.useEffect)(()=>()=>{
            setSidebarContent(null);
        }, [
        setSidebarContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.Wrapper), {
        isResizing: isResizing,
        "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
    }, children, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41642a7c0ef06fe$var$Sidebar, {
        sidebarWidth: sidebarWidth,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.ResizeHandle), {
        onMouseDown: onMouseDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRBAz.SidebarContent), null, content)));
};
const $b41642a7c0ef06fe$var$oldSidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card'
});
const $b41642a7c0ef06fe$var$sidebarStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'elevation.surface',
    flexGrow: 0,
    flexShrink: 0,
    position: 'relative',
    zIndex: 'card',
    maxWidth: '75%'
});
const $b41642a7c0ef06fe$var$businessSidebarStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'border.radius.200',
    borderTopRightRadius: 'border.radius.200',
    boxShadow: 'elevation.shadow.overlay',
    marginRight: 'space.300',
    marginTop: 'space.300'
});

});
parcelRegister("h585o", function(module, exports) {

$parcel$export(module.exports, "useSidebarQueryParams", () => $357741b682c79613$export$34adbeffbeceba68);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $41WOo = parcelRequire("41WOo");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iclz4 = parcelRequire("iclz4");

var $hSCS8 = parcelRequire("hSCS8");
const $357741b682c79613$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
const $357741b682c79613$export$34adbeffbeceba68 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, $hSCS8.useSidebar)();
    const sidebarQueryParams = (0, $hSCS8.getSidebarQueryParams)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)(...sidebarQueryParams);
    const prevQueryParams = (0, $hzcvF.usePreviousWithInitial)(queryParams);
    const closeSidebar = (0, $eUqFw.useCallback)(()=>{
        // reset sidebar query params (IssueApp, Comments)
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) resetSidebarQueryParams();
        else setQueryParams({
            [(0, $jGcn0.SELECTED_ISSUE_PARAM)]: undefined,
            [(0, $jGcn0.SELECTED_COMMENT_PARAM)]: undefined
        });
        // reset sidebar content
        setSidebarContent(null);
    }, [
        resetSidebarQueryParams,
        setQueryParams,
        setSidebarContent
    ]);
    // keep only one sidebar-related query param at the time
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) sidebarQueryParams.forEach((queryParam)=>{
            if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                        [param]: undefined
                    }), {});
                setQueryParams(newQueryParams);
            }
        });
        else {
            // clear "selectedComment=X" query param when IssueApp Sidebar is open
            if (!prevQueryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM]) setQueryParams({
                [(0, $jGcn0.SELECTED_COMMENT_PARAM)]: undefined
            });
            // clear "selectedIssue=X" query param when Comments sidebar is open
            if (!prevQueryParams[0, $jGcn0.SELECTED_COMMENT_PARAM] && queryParams[0, $jGcn0.SELECTED_COMMENT_PARAM]) setQueryParams({
                [(0, $jGcn0.SELECTED_ISSUE_PARAM)]: undefined
            });
        }
    }, [
        prevQueryParams,
        queryParams,
        setQueryParams,
        sidebarQueryParams
    ]);
    // handle closing sidebar on Escape
    (0, $eUqFw.useEffect)(()=>{
        const handleKeydown = (event)=>{
            if (!queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && (0, $eI5EY.fg)('jira_list_keyboard_nav')) // sidebar is not open, exit
            return;
            if (queryParams[0, $jGcn0.SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') // should not close the sidebar if the sidebar and modal is open
            return;
            if ($357741b682c79613$var$isEscapeEvent(event)) {
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                closeSidebar();
            }
        };
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        closeSidebar,
        content?.key,
        createAnalyticsEvent,
        queryParams
    ]);
};

});

parcelRegister("h5BJf", function(module, exports) {

$parcel$export(module.exports, "useResizer", () => $2c653e9e7bda86ce$export$faede3f1542958fc);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $hSCS8 = parcelRequire("hSCS8");
const $2c653e9e7bda86ce$var$THROTTLE_TIME = 16;
const $2c653e9e7bda86ce$export$faede3f1542958fc = ()=>{
    const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, $hSCS8.useSidebar)();
    const startRef = (0, $eUqFw.useRef)(0);
    // storing width in a ref to avoid re-creating onMouseMove handler during resize
    const width = (0, $eUqFw.useRef)(0);
    const [isResizing, setIsResizing] = (0, $eUqFw.useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resize = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((clientX)=>{
        const proposedWidth = width.current + startRef.current - clientX;
        setSidebarWidth(proposedWidth);
    }, $2c653e9e7bda86ce$var$THROTTLE_TIME), [
        setSidebarWidth
    ]);
    const onMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        resize(event.clientX);
    }, [
        resize
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)(()=>{
        startRef.current = 0;
        width.current = 0;
        setIsResizing(false);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
        onMouseMove,
        onMouseUp
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        startRef.current = event.clientX;
        width.current = sidebarWidth;
        setIsResizing(true);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }, [
        onMouseMove,
        onMouseUp,
        sidebarWidth
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseMove: onMouseMove,
        isResizing: isResizing
    };
};

});

parcelRegister("lRBAz", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $8c2051301c5af547$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SidebarOld", () => $8c2051301c5af547$export$3c45ed53a787e357);
$parcel$export(module.exports, "SidebarContent", () => $8c2051301c5af547$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "ResizeHandle", () => $8c2051301c5af547$export$33f2411a0ad35be7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $8c2051301c5af547$var$SIDEBAR_Z_INDEX = 10;
const $8c2051301c5af547$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
            __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$3c45ed53a787e357 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_99zgm9": (0, $9t7rW.default)(`${__cmplp.sidebarWidth}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbge8f _1o9zidpf _11q7vuon _2rko15h0 _kqswh2mm _18s8hhfb _16qszotn _1pbyzo7u",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
            __cmplp.className
        ])
    });
});
const $8c2051301c5af547$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ESAZ", function(module, exports) {

$parcel$export(module.exports, "ThemedContainer", () => $c8a88c0524c1629a$export$2a4209ec8a7db359);
$parcel$export(module.exports, "ContentWrapper", () => $c8a88c0524c1629a$export$6ce170286acaa8d3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_LEFT = (0, $c9TLT.gridSize) * 3;
const $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_RIGHT = (0, $c9TLT.gridSize);
const $c8a88c0524c1629a$export$2a4209ec8a7db359 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
            !__cmplp.withSidebar && "_syaz1c2q",
            __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
            __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
            !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
            __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
            __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
});
const $c8a88c0524c1629a$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSidebarOpen: isSidebarOpen, sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_k62x1i": (0, $9t7rW.default)(__cmplp.sidebarWidth + $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_LEFT + $c8a88c0524c1629a$var$SIDEBAR_PADDING_HORIZONTAL_RIGHT, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _1e0c1txw _2lx21bp4 _ca0qidpf _19bvidpf",
            __cmplp.isSidebarOpen ? "_1bsb1izx" : "_1bsb1osq",
            __cmplp.isSidebarOpen ? "_u5f31tcg" : "_u5f3idpf",
            __cmplp.isSidebarOpen ? "_n3td1ejb" : "_n3tdidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fAoR8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceModalProvider", () => $c504526f38fce139$export$465701d340b2a0fb);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $fQ8Gt = parcelRequire("fQ8Gt");

var $38C70 = parcelRequire("38C70");

var $Mkrqy = parcelRequire("Mkrqy");

var $5bEwi = parcelRequire("5bEwi");
const $c504526f38fce139$export$465701d340b2a0fb = ({ children: children })=>{
    const viewModalControlNew = (0, $Mkrqy.useConfluenceViewModalNew)();
    const { createModalProps: createModalProps, showCreatePage: showCreatePage, hideCreatePage: hideCreatePage } = (0, $Mkrqy.useConfluenceCreatePageModal)();
    const confluenceContext = (0, $eUqFw.useMemo)(()=>({
            showConfluencePage: viewModalControlNew.showConfluencePage,
            showCreatePage: showCreatePage
        }), [
        viewModalControlNew.showConfluencePage,
        showCreatePage
    ]);
    const { confluencePageUrl: confluencePageUrl, viewMode: viewMode, onCloseCompleteCallback: onCloseCompleteCallback } = viewModalControlNew.viewModalProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ8Gt.confluencePagesContext).Provider, {
        value: confluenceContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, confluencePageUrl != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bEwi.default), {
        onClose: viewModalControlNew.hideConfluencePage,
        confluenceUrl: confluencePageUrl || '',
        mode: viewMode,
        onCloseComplete: onCloseCompleteCallback,
        isOpen: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38C70.default), {
        onClose: hideCreatePage,
        ...createModalProps
    }));
};

});
parcelRegister("fQ8Gt", function(module, exports) {

$parcel$export(module.exports, "confluencePagesContext", () => $37beefa91041e6e4$export$4cb8e522e2ecb030);
$parcel$export(module.exports, "useConfluencePagesModals", () => $37beefa91041e6e4$export$750ed67ce7764287);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $37beefa91041e6e4$export$4cb8e522e2ecb030 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    showConfluencePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showCreatePage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const $37beefa91041e6e4$export$750ed67ce7764287 = ()=>{
    const context = (0, $eUqFw.useContext)($37beefa91041e6e4$export$4cb8e522e2ecb030);
    const { showConfluencePage: showConfluencePage, showCreatePage: showCreatePage } = context;
    return {
        showConfluencePage: showConfluencePage,
        showCreatePage: showCreatePage
    };
};

});

parcelRegister("38C70", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a2043a17368e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ce5a2043a17368e7$var$LazyCreatePage = (0, $7rh0R.lazy)(()=>(parcelRequire("8AwfJ")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/create-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ce5a2043a17368e7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-page-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ce5a2043a17368e7$var$LazyCreatePage, props));

});
parcelRegister("8AwfJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('iWR0i')
        ]);
        const value = parcelRequire('4gJwS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("iWR0i")
    ]).then(()=>parcelRequire('4gJwS'));
}

});


parcelRegister("Mkrqy", function(module, exports) {

$parcel$export(module.exports, "useConfluenceCreatePageModal", () => $7c28d3b4703778fb$export$81799af04beb008f);
$parcel$export(module.exports, "useConfluenceViewModalNew", () => $7c28d3b4703778fb$export$3cac20211c8788d8);

var $eUqFw = parcelRequire("eUqFw");

var $eDn3S = parcelRequire("eDn3S");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");
const $7c28d3b4703778fb$export$81799af04beb008f = ()=>{
    const [createModalProps, setCreateModalProps] = (0, $eUqFw.useState)({
        showCreateModal: false,
        onCreate: undefined
    });
    const showCreatePage = (0, $eUqFw.useCallback)(({ onCreate: onCreate, onCloseComplete: onCloseComplete, onCancel: onCancel } = {})=>setCreateModalProps({
            showCreateModal: true,
            onCreate: onCreate,
            onCloseComplete: onCloseComplete,
            onCancel: onCancel
        }), []);
    const hideCreatePage = (0, $eUqFw.useCallback)(()=>setCreateModalProps({
            showCreateModal: false,
            onCreate: undefined
        }), []);
    return {
        createModalProps: createModalProps,
        showCreatePage: showCreatePage,
        hideCreatePage: hideCreatePage
    };
};
const $7c28d3b4703778fb$export$3cac20211c8788d8 = ()=>{
    const [viewModalProps, setViewModalProps] = (0, $eUqFw.useState)({
        confluencePageUrl: null,
        viewMode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        onCloseCompleteCallback: undefined
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const showConfluencePage = (0, $eUqFw.useCallback)(({ confluenceUrl: confluenceUrl, mode: mode, onCloseComplete: onCloseComplete })=>{
        setViewModalProps({
            confluencePageUrl: confluenceUrl,
            viewMode: mode || (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: onCloseComplete
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal viewed');
    }, [
        createAnalyticsEvent
    ]);
    /**
	 * Sets the modal props state back to a default state, which will cause the modal to close
	 *
	 * NOTE: There's a [StrictMode](https://react.dev/reference/react/StrictMode) bug using the
	 * `onCloseCompleteCallback` prop on `@atlaskit/modal-dialog`. This issue has been raised with the
	 * Design System team in the following [thread](https://atlassian.slack.com/archives/CFJ9DU39U/p1715670965075749).
	 * StrictMode is enabled by default in local development so this will not work in local dev
	 * until fixed but works in production.
	 */ const hideConfluencePage = (0, $eUqFw.useCallback)(()=>{
        setViewModalProps({
            confluencePageUrl: null,
            viewMode: (0, $eDn3S.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            onCloseCompleteCallback: undefined
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'jwmConfluenceModal closed');
    }, [
        createAnalyticsEvent
    ]);
    return {
        viewModalProps: viewModalProps,
        showConfluencePage: showConfluencePage,
        hideConfluencePage: hideConfluencePage
    };
};

});
parcelRegister("eDn3S", function(module, exports) {

$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", () => $244f576f48d8bb4b$export$816ef638e478449a);
var $244f576f48d8bb4b$export$816ef638e478449a;
(function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
})($244f576f48d8bb4b$export$816ef638e478449a || ($244f576f48d8bb4b$export$816ef638e478449a = {}));

});


parcelRegister("5bEwi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c1b8e81f1ff3d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal = (0, $7rh0R.lazy)(()=>(parcelRequire("8Qj3m")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/confluence-pages/src/ui/confluence-view-modal/view-page-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6c1b8e81f1ff3d7$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "view-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e6c1b8e81f1ff3d7$var$LazyConfluenceViewModal, props));

});
parcelRegister("8Qj3m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('bfFl5')
        ]);
        const value = parcelRequire('eCTVv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("bfFl5")
    ]).then(()=>parcelRequire('eCTVv'));
}

});



parcelRegister("3555e", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $583c95185f8eb6cc$export$964fe2dd9242a588);

var $e91YZ = parcelRequire("e91YZ");

var $j3FUN = parcelRequire("j3FUN");
const $583c95185f8eb6cc$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).CONFLUENCE]);
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});


parcelRegister("cWd72", function(module, exports) {

$parcel$export(module.exports, "IssueTypesAndFieldsContext", () => $c6421b4581e45226$export$31eaf35dc72d0fa0);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gEmpR = parcelRequire("gEmpR");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c6421b4581e45226$var$noop = ()=>{};
// track Apollo cache watchers 1 sec after availableFields query finishes to make sure UI is fully rendered
const $c6421b4581e45226$var$TRACKING_TIMEOUT = 1000;
const $c6421b4581e45226$export$31eaf35dc72d0fa0 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const IssueTypesAndFieldsViewContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const IssueTypesAndFieldsCreateContextProps = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return $c6421b4581e45226$var$noop;
        const timeoutId = setTimeout(()=>{
            // tracking the number of Apollo cache watches
            // the lower the number, the faster UI
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                // @ts-expect-error - TS2551 - Property 'watches' does not exist on type 'ApolloCache<object>'. Did you mean 'watch'?
                watches: client?.cache?.watches?.size
            });
        }, $c6421b4581e45226$var$TRACKING_TIMEOUT);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextView).Provider, {
        value: IssueTypesAndFieldsViewContextProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEmpR.IssueTypesAndFieldsContextCreate).Provider, {
        value: IssueTypesAndFieldsCreateContextProps
    }, children));
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("gEmpR", function(module, exports) {

$parcel$export(module.exports, "useIssueTypesAndFieldsService", () => $0655e80332547c29$export$3ef3324b7f7d6a38);
$parcel$export(module.exports, "IssueTypesAndFieldsContextView", () => $0655e80332547c29$export$77937175321fab39);
$parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", () => $0655e80332547c29$export$fbd286e14113bfc);
$parcel$export(module.exports, "useIssueTypesAndFields", () => $0655e80332547c29$export$d2121b02f0b65782);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $9zYls = parcelRequire("9zYls");

var $i2apV = parcelRequire("i2apV");

var $2RZxj = parcelRequire("2RZxj");

const $0655e80332547c29$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
const $0655e80332547c29$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
const $0655e80332547c29$var$isProjectPermissionError = (error)=>error.message.indexOf($0655e80332547c29$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($0655e80332547c29$export$4c72baf45fce4585) > -1 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 403 || // @ts-expect-error TS2339 - Property 'extensions' does not exist on type 'ApolloError'
    error.extensions?.statusCode === 404;
const $0655e80332547c29$export$6b9bc8a33ade0736 = (input)=>{
    const [routerState] = (0, $kJlBc.useRouter)();
    const { projectKey: projectKey } = (0, $9zYls.getProjectKeyId)(routerState?.match, routerState?.query);
    const variables = (0, $eUqFw.useMemo)(()=>({
            projectKey: projectKey,
            issueOperation: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            input.issueOperation,
            first: 100
        }), [
        input.issueOperation,
        projectKey
    ]);
    const { query: query, view: view } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "classic-business-form": { readonly view: "Form"; readonly query: DocumentNode; }; readonly "classic-business-form-submit": { readonly view: "FormSubmit"; readonly query: DocumentNode; }; ... 8 more ...; readonly default: { ...; }; }'.
    (0, $2RZxj.JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, $2RZxj.JWMQueryByRouteMap)[0, $i2apV.DEFAULT];
    return (0, $eUqFw.useMemo)(()=>({
            loading: false,
            query: query,
            view: view,
            variables: variables
        }), [
        query,
        view,
        variables
    ]);
};
const $0655e80332547c29$export$1768f0a0f85b4de9 = (input)=>{
    const client = (0, $iZuDo.useApolloClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { variables: queryVariables, query: query } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
    return (0, $eUqFw.useCallback)(({ findField: findField, updateItem: updateItem })=>{
        const getCacheData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: queryVariables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const cacheData = getCacheData();
        const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
        if (existingEdges == null) return;
        let shouldUpdate = false;
        const newEdges = existingEdges.map((edge)=>{
            const existingFields = edge?.node?.fields?.edges;
            if (existingFields == null) return edge;
            const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
            const existingField = existingFields[itemToUpdateIndex]?.node;
            if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
            const itemOverride = updateItem(existingField);
            if (itemOverride === undefined) return edge;
            const newFields = [
                ...existingFields
            ];
            newFields[itemToUpdateIndex] = {
                node: itemOverride,
                __typename: 'JiraIssueFieldEdge'
            };
            shouldUpdate = true;
            return {
                ...edge,
                node: {
                    ...edge?.node || {},
                    fields: {
                        edges: newFields,
                        __typename: 'JiraIssueFieldConnection'
                    }
                }
            };
        });
        if (!shouldUpdate) return;
        const newData = {
            ...cacheData,
            jiraBusinessAvailableFields: {
                ...cacheData?.jiraBusinessAvailableFields || {},
                edges: newEdges
            }
        };
        try {
            client.writeQuery({
                query: query,
                variables: queryVariables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: any; variables: { projectId: number | undefined; issueOperation: IssueOperation; first: number; } | undefined; notifyOnNetworkStatusChange: boolean; data: { jiraBusinessAvailableFields: { ...; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ jiraBusinessAvailableFields: { edges: (JiraBusinessAvailableFieldsListView_jiraBusinessAvailableFields_edges | { ...; } | null)[]; __typename?: "JiraBusinessAvailableFieldsConnection" | undefined; }; }, { ...; }>'.
                notifyOnNetworkStatusChange: true,
                data: newData
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(queryVariables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        query,
        queryVariables
    ]);
};
const $0655e80332547c29$export$3ef3324b7f7d6a38 = (input)=>{
    const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $eUqFw.useState)(false);
    const fetchAttempts = (0, $eUqFw.useRef)(0);
    const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $0655e80332547c29$export$6b9bc8a33ade0736(input);
    const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: queryVariables,
        fetchPolicy: 'cache-first',
        onError: (apolloError)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            // do not fire error if user doesn't have project permissions
            if ($0655e80332547c29$var$isProjectPermissionError(apolloError)) return;
            (0, $guiFP.default)({
                meta: {
                    id: `availableFields${view}ViewQuery`,
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: `Failed to fetch available fields in ${view} view`
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (onCompletedData)=>{
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$ac953882305d6102));
            onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                const fieldEdges = e?.node?.fields?.edges;
                if (fieldEdges == null || fieldEdges?.length === 0) {
                    const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                    const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                    // retrying due to intermittent error related to new projects: FUN-570
                    if (fetchAttempts.current < 1) {
                        fetchAttempts.current += 1;
                        refetch();
                    } else throw emptyFieldsError;
                }
            });
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        if (queryVariables && !hasStartedFetchingFields && !error) {
            setHasStartedFetchingFields(true);
            (0, $ZvXTS.markViewMetric)(view.toLowerCase(), (0, $78bb8734d7176028$export$7b887ee35f2b465e));
            getAvailableFields();
        }
    }, [
        error,
        getAvailableFields,
        hasStartedFetchingFields,
        queryVariables,
        view
    ]);
    const refetch = (0, $eUqFw.useCallback)(()=>{
        if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
        const err = new Error('availableFields refetch is undefined because the service has not been called yet');
        (0, $guiFP.default)({
            meta: {
                id: 'availableFieldsRefetchIsUndefined',
                packageName: 'jiraBusinessEntityProject',
                teamName: 'wanjel'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
        throw err;
    }, [
        called,
        refetchQuery,
        queryVariables
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
    }, [
        hasStartedFetchingFields,
        error
    ]);
    const result = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResult)(data), [
        data
    ]);
    const typesWithFields = (0, $eUqFw.useMemo)(()=>(0, $2RZxj.transformResultToTypesWithFields)(data), [
        data
    ]);
    const hierarchyLevels = (0, $eUqFw.useMemo)(()=>result.issueTypes.map((issueType)=>({
                level: issueType.hierarchyLevel,
                name: issueType.name,
                id: issueType.id
            })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
        result.issueTypes
    ]);
    // make sure "loading" flag starts from "true"
    const isFieldsLoading = hasStartedFetchingFields ? loading : true;
    return {
        error: error,
        loading: error ? false : isQueryLoading || isFieldsLoading,
        data: result,
        typesWithFields: typesWithFields,
        hierarchyLevels: hierarchyLevels,
        refetch: refetch
    };
};
const $0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue = {
    data: {
        fields: [],
        issueTypes: []
    },
    loading: false,
    error: undefined,
    typesWithFields: [],
    hierarchyLevels: []
};
const $0655e80332547c29$export$77937175321fab39 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$fbd286e14113bfc = /*#__PURE__*/ (0, $eUqFw.createContext)({
    ...$0655e80332547c29$var$issueTypesAndFieldsContextDefaultValue
});
const $0655e80332547c29$export$d2121b02f0b65782 = (input)=>{
    const issueTypesAndFieldsViewData = (0, $eUqFw.useContext)($0655e80332547c29$export$77937175321fab39);
    const issueTypesAndFieldsCreateData = (0, $eUqFw.useContext)($0655e80332547c29$export$fbd286e14113bfc);
    if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
    return issueTypesAndFieldsCreateData;
};

});
const $78bb8734d7176028$export$747aad128920134d = 3000;
const $78bb8734d7176028$export$e4f8d353742c04ac = 4000;
const $78bb8734d7176028$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $78bb8734d7176028$export$23e322eb7c526958 = 'REQUEST_START';
const $78bb8734d7176028$export$83ca21a50372ea3b = 'REQUEST_END';
const $78bb8734d7176028$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $78bb8734d7176028$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $78bb8734d7176028$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $78bb8734d7176028$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $78bb8734d7176028$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $78bb8734d7176028$export$88ea1e280513690f = 'UI_RENDER_END';

parcelRegister("i2apV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $3bfdf44128ce0634$export$e6952b12ade67489);
$parcel$export(module.exports, "HierarchyLevel", () => $3bfdf44128ce0634$export$7faaf3222dfd10db);
const $3bfdf44128ce0634$export$e6952b12ade67489 = 'default';
const $3bfdf44128ce0634$export$7faaf3222dfd10db = Object.freeze({
    EPIC: 1,
    BASE: 0,
    SUBTASK: -1
});

});

parcelRegister("2RZxj", function(module, exports) {

$parcel$export(module.exports, "transformResult", () => $36ea36a72d22859a$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "transformResultToTypesWithFields", () => $36ea36a72d22859a$export$55ab7865f91ba09b);
$parcel$export(module.exports, "JWMQueryByRouteMap", () => $36ea36a72d22859a$export$7188da46161cbb8f);

var $41WOo = parcelRequire("41WOo");

var $exb0h = parcelRequire("exb0h");

var $lO4Or = parcelRequire("lO4Or");

var $i2apV = parcelRequire("i2apV");

var $fEf9a = parcelRequire("fEf9a");
const $36ea36a72d22859a$export$b07b0d8dc0894ecf = {
    fields: [],
    issueTypes: []
};
const $36ea36a72d22859a$var$emptyArray = [];
const $36ea36a72d22859a$export$bffa388e20165996 = (node, issueType)=>{
    const fieldConfig = {
        isRequired: !!node.fieldConfig?.isRequired,
        isEditable: !!node.fieldConfig?.isEditable
    };
    if (node.type === 'priority') {
        fieldConfig.options = node.priorities.nodes;
        // Set middle priority as default if backend doesn't return any
        if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
        else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
    }
    if (node.type === 'issuetype') {
        fieldConfig.options = node.issueTypes.nodes;
        fieldConfig.avatarId = issueType.avatarId;
        fieldConfig.avatarUrl = issueType.avatar?.medium;
    }
    if (node.type === 'issuelinks') // 'is blocked by' / 'blocks' is used as the default issue link type
    fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find(// @ts-expect-error - TS7006 - Parameter 'linkNode' implicitly has an 'any' type.
    (linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || // take the first awailable otherwise
    node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
    if (node.type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || node.type === (0, $lO4Or.SELECT_CF_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        else // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value })=>{
            fieldOptions.push({
                value: value,
                label: value
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    if (node.type === (0, $lO4Or.CATEGORY_TYPE)) {
        // @ts-expect-error - TS2304 - Cannot find name 'SelectOption'.
        const fieldOptions = [];
        // convert so that it can be used by the select field
        // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type. | TS7031 - Binding element 'optionId' implicitly has an 'any' type.
        node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
            fieldOptions.push({
                value: value,
                label: value,
                optionId: optionId,
                color: color?.colorKey ?? null
            });
        });
        fieldConfig.selectOptions = fieldOptions;
    }
    return {
        id: node.fieldId,
        aliasFieldId: node.aliasFieldId,
        name: node.name,
        type: node.type,
        fieldConfig: fieldConfig,
        issueTypes: [],
        __typename: node.__typename
    };
};
const $36ea36a72d22859a$export$f13b29f9ed0c5a03 = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
        const issueFieldsById = {};
        const issueTypesById = {};
        data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => void' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => void'.
        ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
            issueTypesById[issueType.issueTypeId] = {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? null,
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            };
            fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).forEach((node)=>{
                if (node.fieldId) {
                    if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $36ea36a72d22859a$export$bffa388e20165996(node, issueType);
                    issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                }
            });
        });
        return {
            fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
            issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
        };
    }
    // @ts-expect-error - TS2322 - Type '{ readonly fields: readonly []; readonly issueTypes: readonly []; }' is not assignable to type '{ fields: BusinessIssueField[]; issueTypes: BusinessIssueType[]; }'.
    return $36ea36a72d22859a$export$b07b0d8dc0894ecf;
};
const $36ea36a72d22859a$export$55ab7865f91ba09b = (data)=>{
    if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(// @ts-expect-error - TS2345 - Argument of type '({ issueType, fields, isDefaultIssueType, }: { issueType: {    name: string;    issueTypeId: string;    type: string;    avatarId: string;    hierarchy?: {        level: number;    };}; fields: {    edges: {        nodes: [];    }[];}; isDefaultIssueType: boolean; }) => { issueType: { id: string; isDefault: boolean;...' is not assignable to parameter of type '(value: {}, index: number, array: {}[]) => { issueType: { id: string; isDefault: boolean; name: string; subtask: boolean; avatarId: string; hierarchyLevel: number; }; fields: BusinessIssueField[]; }'.
    ({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
            issueType: {
                id: issueType.issueTypeId,
                isDefault: isDefaultIssueType,
                name: issueType.name,
                subtask: issueType.type === 'SUB_TASK',
                avatarId: issueType.avatarId,
                avatarUrl: issueType.avatar?.medium ?? '',
                hierarchyLevel: issueType.hierarchy?.level ?? 0
            },
            fields: fields.edges// @ts-expect-error - TS2551 - Property 'node' does not exist on type '{ nodes: []; }'. Did you mean 'nodes'?
            .map((edge)=>edge && edge.node || {}).map((node)=>$36ea36a72d22859a$export$bffa388e20165996(node, issueType))
        }));
    return $36ea36a72d22859a$var$emptyArray;
};
const $36ea36a72d22859a$export$7188da46161cbb8f = {
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM]: {
        view: 'Form',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT]: {
        view: 'FormSubmit',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR]: {
        view: 'Calendar',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED]: {
        view: 'CalendarEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST]: {
        view: 'List',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_LIST_EMBED]: {
        view: 'ListEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE]: {
        view: 'Timeline',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED]: {
        view: 'TimelineEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD]: {
        view: 'Board',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $exb0h.ROUTE_NAMES).CLASSIC_BUSINESS_PROJECT_BOARD_EMBED]: {
        view: 'BoardEmbed',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
    },
    [(0, $i2apV.DEFAULT)]: {
        view: 'Common',
        query: (0, $fEf9a.ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
    }
};

});
parcelRegister("fEf9a", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", () => $546f0d2a9095de4c$export$ba5f98a8d6136727);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", () => $546f0d2a9095de4c$export$cba408dff1091b60);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", () => $546f0d2a9095de4c$export$363435cea078aa93);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", () => $546f0d2a9095de4c$export$1641a42cf2cdb09a);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", () => $546f0d2a9095de4c$export$7903c43b0ec55315);
$parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", () => $546f0d2a9095de4c$export$79304c172f5555ae);

var $9ypom = parcelRequire("9ypom");
const $546f0d2a9095de4c$export$ec2562ca5badac3b = (0, $9ypom.default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
const $546f0d2a9095de4c$export$ba5f98a8d6136727 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$cba408dff1091b60 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$363435cea078aa93 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$1641a42cf2cdb09a = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$7903c43b0ec55315 = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;
const $546f0d2a9095de4c$export$79304c172f5555ae = (0, $9ypom.default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$546f0d2a9095de4c$export$ec2562ca5badac3b}
`;

});




parcelRegister("6F6Wi", function(module, exports) {

$parcel$export(module.exports, "useRefetchFields", () => $3162568d5bd19ad8$export$715664166ba98964);
$parcel$export(module.exports, "RefetchFieldsController", () => $3162568d5bd19ad8$export$f1f4bd03b141f216);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $guiFP = parcelRequire("guiFP");

var $gEmpR = parcelRequire("gEmpR");
const $3162568d5bd19ad8$var$REFETCH_TIMEOUT = 500;
const $3162568d5bd19ad8$var$MAX_NUMBER_OF_RETRIES = 5;
const $3162568d5bd19ad8$var$actions = {
    setRefetchFields: (refetchFields)=>({ setState: setState })=>setState({
                refetchFields: refetchFields
            })
};
const $3162568d5bd19ad8$export$c87e497850d70653 = ()=>Promise.resolve(null);
const $3162568d5bd19ad8$var$Store = (0, $a61MH.createStore)({
    initialState: {
        refetchFields: $3162568d5bd19ad8$export$c87e497850d70653
    },
    actions: $3162568d5bd19ad8$var$actions,
    name: 'JWMRefetchFieldsStore'
});
const $3162568d5bd19ad8$var$useHook = (0, $ggKAj.createHook)($3162568d5bd19ad8$var$Store);
const $3162568d5bd19ad8$export$715664166ba98964 = ()=>{
    const [{ refetchFields: refetchFields }, { setRefetchFields: setRefetchFields }] = $3162568d5bd19ad8$var$useHook();
    return {
        refetchFields: refetchFields,
        setRefetchFields: setRefetchFields
    };
};
const $3162568d5bd19ad8$export$f1f4bd03b141f216 = ()=>{
    const pendingRefetch = (0, $eUqFw.useRef)();
    const retryCount = (0, $eUqFw.useRef)(0);
    const { setRefetchFields: setRefetchFields } = $3162568d5bd19ad8$export$715664166ba98964();
    const { refetch: refetchViewFields } = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'VIEW'
    });
    const { refetch: refetchCreateFields } = (0, $gEmpR.useIssueTypesAndFieldsService)({
        issueOperation: 'CREATE'
    });
    const setPendingRefetch = (refetch, resolve)=>{
        const toId = setTimeout(()=>{
            pendingRefetch.current = null;
            refetch();
        }, $3162568d5bd19ad8$var$REFETCH_TIMEOUT);
        pendingRefetch.current = {
            timeoutId: toId,
            resolve: resolve
        };
    };
    const clearPendingRefetch = ()=>{
        if (pendingRefetch.current) {
            const { timeoutId: toId, resolve: resolve } = pendingRefetch.current;
            clearTimeout(toId);
            resolve(null);
            pendingRefetch.current = null;
        }
    };
    (0, $eUqFw.useEffect)(()=>()=>{
            setRefetchFields($3162568d5bd19ad8$export$c87e497850d70653);
        }, [
        setRefetchFields
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            clearPendingRefetch();
        }, []);
    const refetchFields = (0, $eUqFw.useCallback)(({ shouldRetry: shouldRetry } = {})=>{
        clearPendingRefetch();
        return new Promise((resolve, reject)=>{
            const refetch = async ()=>{
                try {
                    const response = await Promise.all([
                        refetchViewFields(),
                        refetchCreateFields()
                    ]);
                    if (!shouldRetry || !shouldRetry(response)) {
                        resolve(response);
                        retryCount.current = 0;
                    } else if (retryCount.current < $3162568d5bd19ad8$var$MAX_NUMBER_OF_RETRIES) {
                        retryCount.current += 1;
                        // schedule another refetch
                        setPendingRefetch(refetch, resolve);
                    } else {
                        const error = new Error('refetching fields exceeded retries count');
                        (0, $guiFP.default)({
                            meta: {
                                id: 'JwmRefetchFields',
                                packageName: 'jiraBusinessEntityProject',
                                teamName: 'wanjel'
                            },
                            error: error,
                            attributes: {
                                message: `Failed to refetch fields after ${$3162568d5bd19ad8$var$MAX_NUMBER_OF_RETRIES} retries`
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            skipSentry: true
                        });
                        reject(error);
                    }
                } catch (error) {
                    reject(error);
                }
            };
            // A newly associated field doesn’t show up instantly because of the eventual consistency:
            // recomputation of the fields configuration executes as a background task.
            // That's why we need to wait for a bit here before refetching
            setPendingRefetch(refetch, resolve);
        });
    }, [
        refetchCreateFields,
        refetchViewFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setRefetchFields(refetchFields);
    }, [
        refetchFields,
        setRefetchFields
    ]);
    return null;
};

});

parcelRegister("d3C6e", function(module, exports) {

$parcel$export(module.exports, "IssueCreateProvider", () => $167db4325906604f$export$a975cd9627cdf4b6);
$parcel$export(module.exports, "useCreateIssue", () => $167db4325906604f$export$8af2d18142c8506c);
$parcel$export(module.exports, "isOptimisticIssue", () => $167db4325906604f$export$8512029c7fc94e58);
$parcel$export(module.exports, "useIsHighlighted", () => $167db4325906604f$export$2ecca9d8a7f031af);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");

var $lskA1 = parcelRequire("lskA1");

var $cWiVr = parcelRequire("cWiVr");

var $kjzom = parcelRequire("kjzom");

var $frfm9 = parcelRequire("frfm9");
class $167db4325906604f$var$IssueCreateJob {
    constructor(createParams){
        this.createParams = createParams;
        this.promise = new Promise((resolve, reject)=>{
            this.reject = reject;
            this.resolve = resolve;
        });
    }
}
const $167db4325906604f$var$IssueCreateContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $167db4325906604f$var$reducer = (state, action)=>{
    switch(action.type){
        case 'enqueue':
            return {
                ...state,
                jobQueue: [
                    ...state.jobQueue,
                    action.job
                ]
            };
        case 'start-job':
            return {
                ...state,
                runningJob: state.jobQueue[0],
                jobQueue: state.jobQueue.slice(1)
            };
        case 'end-job':
            return {
                ...state,
                runningJob: null
            };
        case 'highlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues,
                    action.issueId
                ])
            };
        case 'unhighlight':
            return {
                ...state,
                highlightedIssues: new Set([
                    ...state.highlightedIssues
                ].filter((id)=>id !== action.issueId))
            };
        case 'save-summary':
            return {
                ...state,
                summary: action.summary
            };
        default:
            return state;
    }
};
const $167db4325906604f$var$initialState = {
    jobQueue: [],
    runningJob: null,
    highlightedIssues: new Set(),
    summary: ''
};
const $167db4325906604f$export$a975cd9627cdf4b6 = ({ mutation: mutation, query: query, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const currentUser = user;
    // optimistic issue ids are negative numbers to distinguish them from real issue ids
    const nextIssueId = (0, $eUqFw.useRef)(-1);
    const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $eUqFw.useReducer)($167db4325906604f$var$reducer, $167db4325906604f$var$initialState);
    const createIssueController = (0, $kjzom.useCreateIssue)(mutation, query);
    const highlightIssue = (0, $eUqFw.useCallback)((issueId)=>dispatch({
            type: 'highlight',
            issueId: issueId
        }), []);
    const unhighlightIssue = (0, $eUqFw.useCallback)((issueId)=>setTimeout(()=>{
            dispatch({
                type: 'unhighlight',
                issueId: issueId
            });
        }, 2000), []);
    const createIssue = (0, $eUqFw.useCallback)((createParams)=>{
        const job = new $167db4325906604f$var$IssueCreateJob(createParams);
        dispatch({
            type: 'enqueue',
            job: job
        });
        let rank;
        if (createParams.input.rankAfter) rank = (0, $lskA1.getNextRank)(createParams.input.rankAfter.rank);
        else if (createParams.input.rankBefore) rank = (0, $lskA1.getPreviousRank)(createParams.input.rankBefore.rank);
        const reporter = {
            accountId: currentUser.accountId,
            avatarUrl: currentUser.avatarUrls['48x48'],
            displayName: currentUser.displayName
        };
        const optimisticIssuePayload = {
            issueId: nextIssueId.current--,
            rank: rank,
            reporter: reporter,
            ...createParams.input
        };
        return {
            optimisticIssuePayload: optimisticIssuePayload,
            promise: job.promise
        };
    }, [
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // dequeue and run the next job if there is one and there is no running job
        if (jobQueue.length > 0 && !runningJob) {
            const job = jobQueue[0];
            dispatch({
                type: 'start-job'
            });
            createIssueController({
                createParams: job.createParams,
                highlightIssue: highlightIssue,
                unhighlightIssue: unhighlightIssue,
                ignoreFiltersContext: ignoreFiltersContext
            }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                    type: 'end-job'
                }));
        }
    }, [
        createIssueController,
        highlightedIssues,
        jobQueue,
        runningJob,
        highlightIssue,
        unhighlightIssue,
        ignoreFiltersContext
    ]);
    (0, $frfm9.useCreateParamHandler)();
    const saveSummary = (0, $eUqFw.useCallback)((newSummary)=>{
        dispatch({
            type: 'save-summary',
            summary: newSummary
        });
    }, []);
    const value = (0, $eUqFw.useMemo)(()=>({
            createIssue: createIssue,
            highlightedIssues: highlightedIssues,
            summary: summary,
            saveSummary: saveSummary
        }), [
        createIssue,
        highlightedIssues,
        summary,
        saveSummary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($167db4325906604f$var$IssueCreateContext.Provider, {
        value: value
    }, children);
};
const $167db4325906604f$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
    const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
    const summaryRef = (0, $eUqFw.useRef)(summary);
    const hasExitedWithoutUserAction = (0, $eUqFw.useRef)(true);
    const submit = (0, $eUqFw.useCallback)((createParams)=>{
        const result = createIssue(createParams);
        onSubmit(result);
        hasExitedWithoutUserAction.current = false;
        setTimeout(()=>{
            // reset the value as the form can stay open after submitting
            hasExitedWithoutUserAction.current = true;
        }, 100);
        return result;
    }, [
        createIssue,
        onSubmit
    ]);
    const blur = (0, $eUqFw.useCallback)(()=>{
        onBlur?.();
        hasExitedWithoutUserAction.current = false;
    }, [
        onBlur
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // if the component has exited without the user blurring the form or submitting,
            // then save the summary value so it can be reapplied
            saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
        }, [
        saveSummary
    ]);
    return {
        summaryRef: summaryRef,
        submit: submit,
        blur: blur
    };
};
const $167db4325906604f$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
const $167db4325906604f$export$2ecca9d8a7f031af = ()=>{
    const context = (0, $eUqFw.useContext)($167db4325906604f$var$IssueCreateContext);
    if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
    const { highlightedIssues: highlightedIssues } = context;
    return (0, $eUqFw.useCallback)((issueId)=>$167db4325906604f$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
        highlightedIssues
    ]);
};

});
parcelRegister("lskA1", function(module, exports) {

$parcel$export(module.exports, "getNextRank", () => $7b4071d915fd0829$export$5c16a8b7eebff4b8);
$parcel$export(module.exports, "getPreviousRank", () => $7b4071d915fd0829$export$e2047b3433d9f565);
const $7b4071d915fd0829$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
const $7b4071d915fd0829$export$e2047b3433d9f565 = (s)=>{
    const lastCharCode = s.charCodeAt(s.length - 1);
    const previousLastChar = String.fromCharCode(lastCharCode - 1);
    if (lastCharCode === 0) return $7b4071d915fd0829$export$e2047b3433d9f565(s.substring(0, s.length - 1));
    return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
};

});

parcelRegister("kjzom", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $b3543cf4b0365df5$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $c7wtc = parcelRequire("c7wtc");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iNULk = parcelRequire("iNULk");

var $fop6E = parcelRequire("fop6E");

var $5ujax = parcelRequire("5ujax");

var $auegK = parcelRequire("auegK");

var $fOAem = parcelRequire("fOAem");

var $9Y2JR = parcelRequire("9Y2JR");
const $b3543cf4b0365df5$export$8edbb6d449614942 = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    return (0, $eUqFw.useCallback)((createInput)=>{
        if (createInput.status && workflows != null) {
            // find the workflow for the input issue type
            const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
            // find the first transition to the input status that is initial, or global but not conditional
            const { statusId: statusId } = createInput.status;
            const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
            return transition?.transitionId;
        }
    }, [
        workflows
    ]);
};
const $b3543cf4b0365df5$export$8af2d18142c8506c = (mutation, query)=>{
    const createIssue = (0, $iNULk.useCreateIssue)(mutation);
    const refetchIssue = (0, $fop6E.useRefetchIssue)(query);
    const showCreateSuccessFlag = (0, $fOAem.useShowCreateSuccessFlag)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const getTransitionId = $b3543cf4b0365df5$export$8edbb6d449614942();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
        const transitionId = getTransitionId(createParams.input);
        try {
            if (!(0, $5ujax.hasAllRequiredFields)({
                issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                createInput: createParams.input
            })) throw new (0, $7byHA.ValidationError)('Missing required fields');
            const response = await createIssue(createParams, {
                transitionId: transitionId
            });
            highlightIssue(response.itemIdentifiers.issueId);
            if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                location: createParams.location
            });
            unhighlightIssue(response.itemIdentifiers.issueId);
            return response.item;
        } catch (error) {
            let finalError = error;
            try {
                if (error instanceof (0, $7byHA.ValidationError)) {
                    const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                        transitionId: transitionId
                    });
                    highlightIssue(issueId);
                    const issue = await refetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                    if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                    unhighlightIssue(issueId);
                    return issue;
                }
            } catch (refetchError) {
                finalError = refetchError;
            }
            if (finalError instanceof (0, $auegK.CancelledError)) return null;
            showFlag({
                type: 'error',
                title: formatMessage((0, $9Y2JR.default).errorFlagTitleNonFinal),
                description: formatMessage((0, $9Y2JR.default).errorFlagDescriptionNonFinal)
            });
            throw finalError;
        }
    }, [
        getTransitionId,
        typesWithFields,
        createIssue,
        createAnalyticsEvent,
        showCreateSuccessFlag,
        showFlag,
        formatMessage,
        showCreateIssueDialog,
        refetchIssue
    ]);
};

});
parcelRegister("c7wtc", function(module, exports) {

$parcel$export(module.exports, "WorkflowsProvider", () => $0662fc67a6d31ad1$export$80a1d3130ff3ec75);
$parcel$export(module.exports, "useWorkflows", () => $0662fc67a6d31ad1$export$437f9bd807b88beb);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $6LdZl = parcelRequire("6LdZl");

var $8xqyO = parcelRequire("8xqyO");
const $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID = (0, $eo17r.toFlagId)('fetch-board-error-flag');
const $0662fc67a6d31ad1$var$WorkflowsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $0662fc67a6d31ad1$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { fetch: fetch, data: data, error: error } = (0, $6LdZl.useFetchWorkflows)();
    (0, $eUqFw.useEffect)(()=>{
        if ((!(0, $eI5EY.fg)('jwm_conditional_workflow_data_loading') || enabled) && workflows == null) fetch();
    }, [
        enabled,
        fetch,
        workflows
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) showFlag({
            id: $0662fc67a6d31ad1$var$FETCH_WORKFLOW_FLAG_ID,
            type: 'error',
            title: (0, $8xqyO.default).workflowsErrorTitle,
            description: (0, $8xqyO.default).workflowsErrorDescription
        });
    }, [
        error,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0662fc67a6d31ad1$var$WorkflowsContext.Provider, {
        value: workflows ?? data
    }, children);
};
const $0662fc67a6d31ad1$export$437f9bd807b88beb = ()=>(0, $eUqFw.useContext)($0662fc67a6d31ad1$var$WorkflowsContext);

});
parcelRegister("6LdZl", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflows", () => $999083320983ea8a$export$41ba56ef14d1b9b1);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $5Hc99 = parcelRequire("5Hc99");
const $999083320983ea8a$export$41ba56ef14d1b9b1 = ()=>{
    const project = (0, $kQAZu.useProject)();
    const [fetch, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $5Hc99.WORKFLOWS_QUERY), {
        variables: {
            projectId: project.id,
            first: 100
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jwmFetchWorkflows',
                    packageName: 'jiraBusinessWorkflows',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch workflows'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const workflowsDetails = (0, $eUqFw.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
            const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
            return {
                workflowId: workflow.workflowId,
                name: workflow?.name ?? undefined,
                transitions: workflow.transitions.edges.map((transitionEdge)=>({
                        transitionId: transitionEdge.node.transitionId,
                        name: transitionEdge.node.name ?? undefined,
                        isInitial: transitionEdge.node.isInitial,
                        isGlobal: transitionEdge.node.isGlobal,
                        isConditional: transitionEdge.node.isConditional,
                        to: {
                            statusId: transitionEdge.node.to.statusId
                        }
                    })),
                issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                        issueTypeId: issueTypeEdge.node.issueTypeId,
                        name: issueTypeEdge.node.name,
                        avatarUrl: issueTypeEdge.node.avatar.medium,
                        hierarchyLevel: issueTypeEdge.node.hierarchy.level
                    }))
            };
        }), [
        data
    ]);
    return {
        fetch: fetch,
        data: workflowsDetails,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5Hc99", function(module, exports) {

$parcel$export(module.exports, "WORKFLOWS_QUERY", () => $d1ebb9e47bb48695$export$d54deb6c2b9695b7);

var $9ypom = parcelRequire("9ypom");
const $d1ebb9e47bb48695$export$d54deb6c2b9695b7 = (0, $9ypom.default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;

});


parcelRegister("8xqyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2d03bd6919e7a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f2d03bd6919e7a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    workflowsErrorTitle: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-title",
        "defaultMessage": "Failed to load workflows details"
    },
    workflowsErrorDescription: {
        "id": "business-workflows.controllers.workflows-context.workflows-error-description",
        "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
    }
});

});


parcelRegister("iNULk", function(module, exports) {

$parcel$export(module.exports, "useCreateIssue", () => $7f9682590ce5c99c$export$8af2d18142c8506c);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $e4qlg = parcelRequire("e4qlg");
var $4S5hf = parcelRequire("4S5hf");

var $kkYfO = parcelRequire("kkYfO");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $7byHA = parcelRequire("7byHA");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $4xHig = parcelRequire("4xHig");


var $iWGMH = parcelRequire("iWGMH");
const $7f9682590ce5c99c$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $7f9682590ce5c99c$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $7f9682590ce5c99c$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $7f9682590ce5c99c$export$8af2d18142c8506c = (mutation)=>{
    const locale = (0, $4xHig.useLocale)();
    const { data: categoryField } = (0, $e4qlg.useCategoryField)();
    const { data: startDateField } = (0, $fD1Hq.useStartDateField)();
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointEstimateFieldPredicate);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$storyPointsFieldPredicate);
    const { data: sprintField } = (0, $4S5hf.useFindField)($7f9682590ce5c99c$var$sprintFieldPredicate);
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const [createIssue] = (0, $iZuDo.useMutation)(mutation);
    return (0, $eUqFw.useCallback)(async (createParams, extraPayload)=>{
        try {
            const input = (0, $iWGMH.buildInput)(createParams.input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            let isParentFieldVisible = false;
            let isDevSummaryFieldVisible = false;
            if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                isDevSummaryFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                isParentFieldVisible = fieldIdsSet.has((0, $908924b2d198da78$export$bf9df74e065af482));
                fieldIdsSet.delete((0, $908924b2d198da78$export$20b3b4741b8cfb64));
                fieldIdsSet.delete((0, $908924b2d198da78$export$bf9df74e065af482));
            }
            const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
            fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
            const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
            fieldIdsSet.delete((0, $jGcn0.CARD_COVERS_TYPE));
            const fieldIds = Array.from(fieldIdsSet);
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: fieldIds,
                    withCoverMedia: withCoverMedia,
                    withExtendedIssue: (0, $1ybV0.ff)('jwm.board-awesome-enhancements'),
                    withChildrenCount: false,
                    isParentFieldVisible: isParentFieldVisible,
                    isDevSummaryFieldVisible: isDevSummaryFieldVisible,
                    withIssueLinks: withIssueLinks,
                    withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                },
                // @ts-expect-error - errorPolicy is not in the types but does work
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, $7byHA.ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, $kkYfO.MutationError)(firstMutationError);
                }
                throw new (0, $dlVOn.GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    issueId: result.itemIdentifiers.issueId,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (!(error instanceof (0, $7byHA.ValidationError))) (0, $guiFP.default)({
                meta: {
                    id: 'JWMCreateIssueInline',
                    packageName: 'jiraBusinessIssueCreate',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        categoryField,
        createIssue,
        locale,
        sprintField,
        startDateField,
        storyPointEstimateField,
        storyPointsField,
        isLinkingEnabled
    ]);
};

});
parcelRegister("e4qlg", function(module, exports) {

$parcel$export(module.exports, "useCategoryField", () => $ce9b32995a7706e8$export$f7ac7f1f12b4c794);

var $lO4Or = parcelRequire("lO4Or");

var $gEmpR = parcelRequire("gEmpR");
const $ce9b32995a7706e8$export$f7ac7f1f12b4c794 = ()=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const categoryField = fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE)) ?? null;
    return {
        data: categoryField,
        loading: loading,
        error: error
    };
};

});

parcelRegister("4S5hf", function(module, exports) {

$parcel$export(module.exports, "useFindField", () => $8ce2e5c1390595df$export$4b0b80fa50e6b4be);

var $gEmpR = parcelRequire("gEmpR");
const $8ce2e5c1390595df$export$4b0b80fa50e6b4be = (predicate)=>{
    const { data: { fields: fields }, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const field = fields.find(predicate) ?? null;
    return {
        data: field,
        loading: loading,
        error: error
    };
};

});

parcelRegister("kkYfO", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $f83939e5f3c23160$export$10c788363424e94e);
const $f83939e5f3c23160$export$bd0568a021288e41 = 'MutationError';
class $f83939e5f3c23160$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
    }
}

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

const $908924b2d198da78$export$41b6c9f5441c22c5 = 'rankBefore';
const $908924b2d198da78$export$d564e563c2ee8c4f = 'rankAfter';
const $908924b2d198da78$export$20b3b4741b8cfb64 = 'devSummaryField';
const $908924b2d198da78$export$bf9df74e065af482 = 'parentField';

parcelRegister("iWGMH", function(module, exports) {

$parcel$export(module.exports, "buildInput", () => $6cba527c033852df$export$f4db126e014728a3);

var $lO4Or = parcelRequire("lO4Or");

var $8K9kM = parcelRequire("8K9kM");

const $6cba527c033852df$export$f4db126e014728a3 = (input, locale, extraPayload, categoryField, startDateField, sprintField, storyPointEstimateField, storyPointsField)=>{
    const result = {
        projectId: input.projectId,
        issueType: input.issueType.id,
        fields: {
            singleLineTextFields: [
                {
                    fieldId: (0, $lO4Or.SUMMARY_TYPE),
                    text: input.summary
                }
            ],
            singleSelectUserPickerFields: [],
            datePickerFields: [],
            numberFields: []
        },
        rank: {}
    };
    if (input.category && categoryField?.id) result.fields.singleLineTextFields.push({
        fieldId: categoryField.id,
        text: input.category.optionId
    });
    if (input.assignee) result.fields.singleSelectUserPickerFields.push({
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        user: {
            accountId: input.assignee.accountId
        }
    });
    if (input.startDate && startDateField?.id) result.fields.datePickerFields.push({
        fieldId: startDateField?.id,
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.startDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.dueDate) result.fields.datePickerFields.push({
        fieldId: (0, $lO4Or.DUE_DATE_TYPE),
        date: {
            formattedDate: (0, $8K9kM.formatTimezonedWithLocale)(input.dueDate, 'dd/MMM/yy', locale, 'UTC')
        }
    });
    if (input.priority) result.fields.priority = {
        priorityId: input.priority.priorityId
    };
    if (input.parentIssueId) result.fields.parentField = {
        issueId: input.parentIssueId
    };
    if (input.rankBefore) result.rank.before = {
        id: (0, $908924b2d198da78$export$41b6c9f5441c22c5),
        issueId: input.rankBefore.issueId
    };
    if (input.rankAfter) result.rank.after = {
        id: (0, $908924b2d198da78$export$d564e563c2ee8c4f),
        issueId: input.rankAfter.issueId
    };
    if (extraPayload.transitionId) result.transitionId = extraPayload.transitionId;
    if (input.storyPointEstimate != null && storyPointEstimateField?.id) result.fields.numberFields.push({
        fieldId: storyPointEstimateField.id,
        value: input.storyPointEstimate
    });
    if (input.storyPoints != null && storyPointsField?.id) result.fields.numberFields.push({
        fieldId: storyPointsField.id,
        value: input.storyPoints
    });
    if (input.sprint && sprintField?.id) result.fields.sprintsField = {
        fieldId: sprintField.id,
        sprints: [
            {
                sprintId: input.sprint.id
            }
        ]
    };
    return result;
};

});


parcelRegister("fop6E", function(module, exports) {

$parcel$export(module.exports, "useRefetchIssue", () => $afeef06c89f9a563$export$8bf876d423f9293d);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $lGxgz = parcelRequire("lGxgz");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $fD1Hq = parcelRequire("fD1Hq");

var $dWLk9 = parcelRequire("dWLk9");
function $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query) {
    const client = (0, $iZuDo.useApolloClient)();
    return (0, $eUqFw.useCallback)((variables)=>client.query({
            query: query,
            variables: variables,
            errorPolicy: 'all'
        }), [
        client,
        query
    ]);
}
const $afeef06c89f9a563$export$8bf876d423f9293d = (query)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const filtersJQL = (0, $lGxgz.useFilteredViewJQL)();
    const isLinkingEnabled = (0, $fD1Hq.useIsLinkingEnabled)();
    const refetchIssue = $afeef06c89f9a563$export$fd83eea6ecd2d8fa(query);
    return (0, $eUqFw.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
        const jql = (0, $i3K0B.generateJql)({
            jqlContext: jqlContext,
            quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
            issueIds: [
                issueId
            ]
        });
        const fieldIdsSet = new Set(fieldIds);
        const withIssueLinks = fieldIdsSet.has((0, $lO4Or.ISSUE_LINKS_TYPE)) && isLinkingEnabled && (0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
        fieldIdsSet.delete((0, $lO4Or.ISSUE_LINKS_TYPE));
        const withCoverMedia = fieldIdsSet.has((0, $jGcn0.CARD_COVERS_TYPE));
        const fieldIdsToRequest = Array.from(fieldIdsSet);
        const { data: data } = await refetchIssue({
            jql: jql,
            fieldIds: fieldIdsToRequest,
            cloudId: cloudId,
            first: 1,
            withCoverMedia: withCoverMedia,
            withExtendedIssue: (0, $1ybV0.ff)('jwm.board-awesome-enhancements'),
            withChildrenCount: false,
            isParentFieldVisible: false,
            isDevSummaryFieldVisible: false,
            withIssueLinks: withIssueLinks,
            withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
        });
        const viewItems = data?.jira?.jwmViewItems;
        if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issue = viewItems.edges?.[0]?.node;
        return issue ?? null;
    }, [
        cloudId,
        filtersJQL,
        jqlContext,
        refetchIssue,
        isLinkingEnabled
    ]);
};

});
parcelRegister("i3K0B", function(module, exports) {

$parcel$export(module.exports, "generateJql", () => $6bd61e247d9e0007$export$d43e55153d6948c0);
$parcel$export(module.exports, "getVariables", () => $6bd61e247d9e0007$export$a39eddd73bba62c1);

var $jGcn0 = parcelRequire("jGcn0");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_NEW = (0, $jGcn0.DEFAULT_PAGE_SIZE);
const $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_OLD = 100;
const $6bd61e247d9e0007$var$IS_EMPTY = 'IS EMPTY';
const $6bd61e247d9e0007$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
const $6bd61e247d9e0007$var$getFieldNameForJql = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};
const $6bd61e247d9e0007$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
    const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
    const defaultSorting = `ORDER BY Rank ${(0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION)}`;
    const jql = [];
    // Check if sorting direction is valid, the direction possible passed from the URL params which can be invalid
    const isValidDirection = (0, $1ybV0.ff)('jwm.fix-list-view-jql-query-errors_5jp7y') ? sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC' : true;
    const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${$6bd61e247d9e0007$var$getFieldNameForJql(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
    if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
    if (jqlContext) jql.push(jqlContext);
    else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
    if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
        // fetch items by hierarchyLevel + any item that doesn't have a parent (e.g. tasks that don't belong to any Epic)
        if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
        else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$6bd61e247d9e0007$var$IS_EMPTY})`);
    }
    if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
    // Controls the query to get all children for a single parent
    if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
    // Controls the query to get group items
    if (groupQuery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { jqlTerm: jqlTerm, value: value } = groupQuery;
        if (!value) jql.push(`${jqlTerm} ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        else jql.push(`${jqlTerm} = ${value}`);
        if (hierarchyParent === (0, $2a7b21c0842403e6$export$9355e489ad16f98e)) {
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') && typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$6bd61e247d9e0007$var$IS_EMPTY} OR (parent ${$6bd61e247d9e0007$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`parent ${$6bd61e247d9e0007$var$IS_EMPTY}`);
        }
    }
    if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
    return `${jql.join(' AND ')} ${sortByClause}`;
};
const $6bd61e247d9e0007$export$a39eddd73bba62c1 = (input)=>{
    const { fieldIds: fieldIds, parentIssue: parentIssue, parentIssues: parentIssues } = input;
    const defaultChildrenPerPage = (0, $1ybV0.ff)('jwm.remove-list-view-bulk-query') ? $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_NEW : $6bd61e247d9e0007$var$DEFAULT_CHILDREN_PER_PAGE_OLD;
    const isBulkQuery = Array.isArray(parentIssues) && parentIssues.length;
    const singleQueryJql = {
        jql: $6bd61e247d9e0007$export$d43e55153d6948c0(input, parentIssue)
    };
    const bulkQueryJql = isBulkQuery ? parentIssues.reduce((acc, currParentIssue)=>{
        acc[`jql${currParentIssue.issueId}`] = $6bd61e247d9e0007$export$d43e55153d6948c0(input, currParentIssue);
        return acc;
    }, {}) : {};
    const shouldUseChildrenPerPage = isBulkQuery ? true : parentIssue;
    // REMOTE_ISSUE_LINKS_TYPE should not be part of the fieldIds as it is only used to determine
    // whether legacyConfluenceLinks(JIS2) is fetched
    const newFieldIds = Array.isArray(fieldIds) ? [
        ...fieldIds
    ] : [];
    const remoteIssueLinksIndex = newFieldIds.indexOf((0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE));
    const hasConfluenceLinks = remoteIssueLinksIndex > -1;
    if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
    return {
        ...singleQueryJql,
        ...bulkQueryJql,
        first: shouldUseChildrenPerPage ? defaultChildrenPerPage : (0, $jGcn0.DEFAULT_PAGE_SIZE),
        fieldIds: newFieldIds,
        withConfluenceLinks: hasConfluenceLinks,
        includeDoneItems: input.isHidingDoneItems === false,
        isParentFieldVisible: input.isParentFieldVisible ?? false,
        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false,
        withParentRank: (0, $1ybV0.ff)('jwm.list_sort_parent_rank_first'),
        withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
    };
};

});
const $2a7b21c0842403e6$export$9355e489ad16f98e = 'TASK';
const $2a7b21c0842403e6$export$3cb4a99a332e4186 = 'EPIC';


parcelRegister("lGxgz", function(module, exports) {

$parcel$export(module.exports, "useFilteredViewJQL", () => $6fc881cfc8a36877$export$a50cc7c1087f7d9b);
$parcel$export(module.exports, "useFilteredViewContextInput", () => $6fc881cfc8a36877$export$d566b5d8a729afa0);

var $eUqFw = parcelRequire("eUqFw");


var $eZbpk = parcelRequire("eZbpk");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $iaCjO = parcelRequire("iaCjO");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $96etS = parcelRequire("96etS");

var $jQFcD = parcelRequire("jQFcD");
const $6fc881cfc8a36877$export$a50cc7c1087f7d9b = ()=>{
    const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, $96etS.useSimpleSearchJQL)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    // ensure views recieve filters jql that will not cause a page crash
    const jqlSanitised = (0, $eUqFw.useMemo)(()=>(0, $jQFcD.sanitiseJql)(jql), [
        jql
    ]);
    const filtersJQL = (0, $eUqFw.useMemo)(()=>{
        if (isHidingDoneItems) {
            const filtersJql = [
                jqlSanitised,
                "StatusCategory != 'Complete'"
            ].filter(Boolean).join(' AND ');
            return addSimpleSearchToJQL(filtersJql);
        }
        return addSimpleSearchToJQL(jqlSanitised || null);
    }, [
        jqlSanitised,
        addSimpleSearchToJQL,
        isHidingDoneItems
    ]);
    return filtersJQL;
};
const $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
const $6fc881cfc8a36877$export$d566b5d8a729afa0 = ({ view: view })=>{
    const filtersJQL = $6fc881cfc8a36877$export$a50cc7c1087f7d9b();
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const [sortingBy] = (0, $iaCjO.useSorting)();
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const isFiltering = jql != null || isSearching;
    const [isHidingDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    const jqlErrors = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jwm.filters.handle-invalid-jql')) return (0, $jQFcD.getJqlErrors)(jql);
        return [];
    }, [
        jql
    ]);
    const sorting = (0, $eUqFw.useMemo)(()=>{
        /*
			When sorting by a specific field, we use the fieldId in the JQL query.
			For the fix version field, the fieldId doesn’t work in JQL must be “fixVersion”.
			Apparently, "fixVersion" is the clause name. It's a legacy choice that was made from the very beginning, and now we're unable to change it.
		*/ if (sortingBy.sortBy === (0, $lO4Or.FIX_VERSIONS_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return {
            ...sortingBy,
            sortBy: $6fc881cfc8a36877$var$FIX_VERSION_SORTING_JQL
        };
        return sortingBy;
    }, [
        sortingBy
    ]);
    return {
        jqlContext: jqlContext,
        quickFiltersJql: filtersJQL,
        sorting: sorting,
        isFiltering: isFiltering,
        hierarchyParent: hierarchyParent,
        isHidingDoneItems: isHidingDoneItems,
        jqlErrors: jqlErrors
    };
};

});
parcelRegister("iaCjO", function(module, exports) {

$parcel$export(module.exports, "useSorting", () => $35b6a42c26975572$export$21ebc1ba2b2bee67);
$parcel$export(module.exports, "useSorter", () => $35b6a42c26975572$export$f161a6f9d84a6fea);

var $eUqFw = parcelRequire("eUqFw");

var $35jYz = parcelRequire("35jYz");
var $gEmpR = parcelRequire("gEmpR");

var $2i84A = parcelRequire("2i84A");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $a75Ge = parcelRequire("a75Ge");

var $a6BBe = parcelRequire("a6BBe");

var $iP9h2 = parcelRequire("iP9h2");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE = {};
const $35b6a42c26975572$export$21ebc1ba2b2bee67 = ()=>{
    const [sorting, setSorting] = (0, $7c3W1.useViewPreference)((0, $ji3xf.SORTING_PREFERENCE));
    return [
        sorting || $35b6a42c26975572$var$EMPTY_SORTING_ATTRIBUTE,
        setSorting
    ];
};
const $35b6a42c26975572$var$emptyArray = [];
const $35b6a42c26975572$export$f161a6f9d84a6fea = ()=>{
    const [sorting] = $35b6a42c26975572$export$21ebc1ba2b2bee67();
    const [sortingFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: sorting.sortBy
    });
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
    const { statuses: statuses } = (0, $1ybV0.ff)('jwm.list.filters.sort-by-project-statuses') ? (0, $a75Ge.useProjectStatuses)() : (0, $2i84A.useGlobalStatuses)();
    const priorities = priorityFieldConfig?.options || $35b6a42c26975572$var$emptyArray;
    const sortFunction = (0, $eUqFw.useCallback)((issues)=>{
        const getPrioritiesSortedList = ()=>[
                ...priorities
            ].reverse().reduce((acc, next, index)=>{
                acc[next.priorityId] = index;
                return acc;
            }, {});
        const getIssueTypesSortedList = ()=>[
                ...data.issueTypes
            ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                acc[next.name] = index;
                return acc;
            }, {});
        const getStatusSortOrder = (key)=>{
            if (key in (0, $a6BBe.STATUS_SORT_ORDER)) return (0, $a6BBe.STATUS_SORT_ORDER)[key];
            return -1;
        };
        const getStatusesSortedList = ()=>{
            const sortedStatus = (0, $eI5EY.fg)('list_view_status_sorting') ? [
                ...statuses
            ].sort((a, b)=>{
                const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                if (orderComparison !== 0) return orderComparison;
                // If the status category order is the same, then sort alphabetically by name.
                return a.name.localeCompare(b.name);
            }) : [
                ...statuses
            ];
            return sortedStatus.reduce((acc, next, index)=>{
                acc[(0, $eI5EY.fg)('list_view_status_sorting') ? next.name : next.id] = index;
                return acc;
            }, {});
        };
        const sortedLists = {
            priorities: getPrioritiesSortedList(),
            issueTypes: getIssueTypesSortedList(),
            statuses: getStatusesSortedList()
        };
        const { getters: getters, orders: orders } = (0, $iP9h2.createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
        return (0, $iP9h2.sortListBy)(issues, getters, orders);
    }, [
        sorting,
        sortingFieldConfigFieldType,
        priorities,
        data.issueTypes,
        statuses
    ]);
    return {
        sort: sortFunction
    };
};

});
parcelRegister("35jYz", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeFieldConfig", () => $81e81ebd14cd3d82$export$42e875bfb69ded2);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $gEmpR = parcelRequire("gEmpR");
const $81e81ebd14cd3d82$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [screen]: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(getState(), [
                    screen
                ], {}),
                [issueTypeId]: configs
            }
        });
    };
const $81e81ebd14cd3d82$var$actions = {
    merge: $81e81ebd14cd3d82$var$merge
};
const $81e81ebd14cd3d82$export$cbf0f7fe9ca42a65 = (0, $a61MH.createStore)({
    initialState: {},
    actions: $81e81ebd14cd3d82$var$actions,
    name: 'issueTypeFieldConfig'
});
const $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector = (0, $bj4JM.createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
    if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(state, [
        screen,
        issueTypeId,
        fieldId
    ], null);
});
const $81e81ebd14cd3d82$export$47647eb426e85a25 = (0, $ggKAj.createHook)($81e81ebd14cd3d82$export$cbf0f7fe9ca42a65, {
    selector: $81e81ebd14cd3d82$var$getIssueTypeFieldConfigSelector
});
const $81e81ebd14cd3d82$export$42e875bfb69ded2 = (props)=>{
    const [state, fieldsConfigActions] = $81e81ebd14cd3d82$export$47647eb426e85a25(props);
    const screen = props?.screen || 'VIEW';
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: screen
    });
    // store field config to be consumed at the cell level
    return (0, $eUqFw.useMemo)(()=>{
        if (state != null) return [
            state,
            fieldsConfigActions,
            {
                loading: false,
                error: undefined
            }
        ];
        if (loading === false && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, [
            'issueTypes'
        ], []).length > 0) data.issueTypes.forEach((issueType)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const config = {};
            data.fields.forEach((field)=>{
                if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                    ...field.fieldConfig,
                    fieldType: field.type
                };
            });
            fieldsConfigActions.merge(screen, issueType.id, config);
            if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
        });
        return [
            state,
            fieldsConfigActions,
            {
                loading: loading,
                error: error
            }
        ];
    }, [
        data,
        error,
        fieldsConfigActions,
        loading,
        screen,
        state
    ]);
};

});

parcelRegister("2i84A", function(module, exports) {

$parcel$export(module.exports, "useGlobalStatuses", () => $6dcdae727178c9b6$export$96ca88c93202037);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gUUjF = parcelRequire("gUUjF");
const $6dcdae727178c9b6$var$PACKAGE_LOCATION = 'jira-business.common.services.global-statuses';
const $6dcdae727178c9b6$var$MAX_RETRIES = 3;
const $6dcdae727178c9b6$var$set = (statuses)=>({ setState: setState })=>setState({
            statuses: statuses
        });
const $6dcdae727178c9b6$var$actions = {
    set: $6dcdae727178c9b6$var$set
};
const $6dcdae727178c9b6$var$GlobalStatusesStore = (0, $a61MH.createStore)({
    initialState: {
        statuses: []
    },
    actions: $6dcdae727178c9b6$var$actions,
    name: 'globalStatuses'
});
const $6dcdae727178c9b6$export$d8357dfc5f272b90 = (0, $ggKAj.createHook)($6dcdae727178c9b6$var$GlobalStatusesStore);
const $6dcdae727178c9b6$var$emptyArray = [];
const $6dcdae727178c9b6$export$96ca88c93202037 = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const [state, statusActions] = $6dcdae727178c9b6$export$d8357dfc5f272b90();
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (Array.isArray(state.statuses) && state.statuses.length > 0) return {
        statuses: state.statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch('/rest/api/3/status').then((response)=>response.json()).then((statuses)=>{
            statusActions.set(statuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($6dcdae727178c9b6$var$PACKAGE_LOCATION, `Failed to retrieve global statuses - Retry #${retriesCount}`);
            if (retriesCount < $6dcdae727178c9b6$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $6dcdae727178c9b6$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("ji3xf", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", () => $3ed190d907cd42b1$export$5d3f940b56d7af28);
$parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", () => $3ed190d907cd42b1$export$8019dfa5a44f6d46);
$parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", () => $3ed190d907cd42b1$export$3ef984a9f784490f);
$parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", () => $3ed190d907cd42b1$export$2df4c3d44dcb1e5b);
$parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", () => $3ed190d907cd42b1$export$638c3932e4cbdede);
$parcel$export(module.exports, "FIELDS_PREFERENCE", () => $3ed190d907cd42b1$export$e3ddfc509464e305);
$parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", () => $3ed190d907cd42b1$export$ffcb5603c64e12d0);
$parcel$export(module.exports, "FILTER_PREFERENCE", () => $3ed190d907cd42b1$export$f50d5db589fb1475);
$parcel$export(module.exports, "GROUPING_PREFERENCE", () => $3ed190d907cd42b1$export$ac8a4771da7f03af);
$parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", () => $3ed190d907cd42b1$export$4aace169721c2927);
$parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", () => $3ed190d907cd42b1$export$983f0d3325e2938);
$parcel$export(module.exports, "RANGE_MODE_PREFERENCE", () => $3ed190d907cd42b1$export$f43988a3762bf711);
$parcel$export(module.exports, "SORTING_PREFERENCE", () => $3ed190d907cd42b1$export$373eea1341dcff74);
$parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$4ec60be96e9eadc0);
$parcel$export(module.exports, "LIST_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$43fc1ec27b2f1801);
$parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$14e2a519a8c2881a);
$parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$8443f3f4fd94276);
$parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", () => $3ed190d907cd42b1$export$2e2923d9c9daba20);

var $jGcn0 = parcelRequire("jGcn0");

var $khRV9 = parcelRequire("khRV9");
const $3ed190d907cd42b1$export$5d3f940b56d7af28 = (0, $khRV9.createSimplePreference)('activeWorkflow');
const $3ed190d907cd42b1$export$8019dfa5a44f6d46 = (0, $khRV9.createSimplePreference)('collapsedColumns');
const $3ed190d907cd42b1$export$3ef984a9f784490f = (0, $khRV9.createSimplePreference)('columnOrder');
const $3ed190d907cd42b1$export$2df4c3d44dcb1e5b = (0, $khRV9.createSimplePreference)('createType');
const $3ed190d907cd42b1$export$638c3932e4cbdede = (0, $khRV9.createSimplePreference)('expandedIssues');
const $3ed190d907cd42b1$export$e3ddfc509464e305 = (0, $khRV9.createSimplePreference)('fields');
const $3ed190d907cd42b1$export$ffcb5603c64e12d0 = (0, $khRV9.createSimplePreference)('fieldsDetail');
const $3ed190d907cd42b1$export$f50d5db589fb1475 = (0, $khRV9.createSimpleUrlPreference)((0, $jGcn0.FILTER_PARAM));
const $3ed190d907cd42b1$export$ac8a4771da7f03af = (0, $khRV9.createSimpleUrlPreference)('groupBy');
const $3ed190d907cd42b1$export$4aace169721c2927 = (0, $khRV9.createSimpleUrlPreference)('hideDone');
const $3ed190d907cd42b1$export$983f0d3325e2938 = (0, $khRV9.createSimpleUrlPreference)('hideSoftwareRelease');
const $3ed190d907cd42b1$export$f43988a3762bf711 = (0, $khRV9.createSimpleUrlPreference)('rangeMode');
const $3ed190d907cd42b1$export$373eea1341dcff74 = {
    ...(0, $khRV9.createSimplePreference)('sorting'),
    queryParameter: {
        serialize: (value)=>({
                sortBy: value?.sortBy,
                direction: value?.direction
            }),
        deserialize: (value)=>value.sortBy ? {
                sortBy: value.sortBy,
                direction: value.direction
            } : undefined
    }
};
const $3ed190d907cd42b1$export$4ec60be96e9eadc0 = [
    $3ed190d907cd42b1$export$5d3f940b56d7af28,
    $3ed190d907cd42b1$export$8019dfa5a44f6d46,
    $3ed190d907cd42b1$export$3ef984a9f784490f,
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$638c3932e4cbdede,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af
];
const $3ed190d907cd42b1$export$43fc1ec27b2f1801 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$e3ddfc509464e305,
    $3ed190d907cd42b1$export$ffcb5603c64e12d0,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$ac8a4771da7f03af,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$373eea1341dcff74
];
const $3ed190d907cd42b1$export$14e2a519a8c2881a = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$983f0d3325e2938
];
const $3ed190d907cd42b1$export$8443f3f4fd94276 = [
    $3ed190d907cd42b1$export$2df4c3d44dcb1e5b,
    $3ed190d907cd42b1$export$f50d5db589fb1475,
    $3ed190d907cd42b1$export$4aace169721c2927,
    $3ed190d907cd42b1$export$f43988a3762bf711
];
const $3ed190d907cd42b1$export$2e2923d9c9daba20 = [
    $3ed190d907cd42b1$export$f50d5db589fb1475
];

});
parcelRegister("khRV9", function(module, exports) {

$parcel$export(module.exports, "createSimplePreference", () => $462fa2c618ea906f$export$464a71be397e5f3d);
$parcel$export(module.exports, "createSimpleUrlPreference", () => $462fa2c618ea906f$export$78f3983105936d30);

var $3QMTK = parcelRequire("3QMTK");
const $462fa2c618ea906f$export$464a71be397e5f3d = (id)=>({
        id: id,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
    });
const $462fa2c618ea906f$export$78f3983105936d30 = (queryParameter)=>({
        id: queryParameter,
        serialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        deserialize: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))),
        queryParameter: {
            serialize: (value)=>({
                    [queryParameter]: value
                }),
            deserialize: (value)=>value[queryParameter]
        }
    });

});


parcelRegister("7c3W1", function(module, exports) {

$parcel$export(module.exports, "ViewPreferencesProvider", () => $6117ab20ad9a3ccd$export$1db44e21d818b27);
$parcel$export(module.exports, "useViewPreference", () => $6117ab20ad9a3ccd$export$ee494de6c0ff45d7);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");

var $6YT9E = parcelRequire("6YT9E");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $6117ab20ad9a3ccd$var$ViewPreferencesContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $6117ab20ad9a3ccd$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const [{ query: query }, routerActions] = (0, $kJlBc.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { updateQueryParam: updateQueryParam } = routerActions;
    const prevQuery = (0, $hzcvF.usePreviousWithInitial)(query);
    const [store, setStore] = (0, $eUqFw.useState)(()=>preferences.reduce((acc, preference)=>{
            let value;
            const { id: id, queryParameter: queryParameter } = preference;
            // if the URL has a preference value set
            // we prioritize those values over the persisted ones
            const queryValue = queryParameter && queryParameter.deserialize(query);
            if (queryValue) value = queryValue;
            else if (persistChanges) // if the view is persisting changes, restore the preferences from local storage
            value = preference.deserialize((0, $6YT9E.getPreference)(entity.id, view, preference.id));
            acc[id] = value;
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}));
    const setPreferenceValue = (0, $eUqFw.useCallback)((preference, value, action)=>{
        // set the new preference value in the store
        setStore((prevStore)=>{
            const newStore = {
                ...prevStore,
                [preference.id]: value
            };
            return newStore;
        });
        // if the preference serialises to the URL, update the URL
        if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
        // if the view is persisting changes, update the preference in local storage
        if (persistChanges) {
            const serializedValue = preference.serialize(value);
            (0, $6YT9E.setPreference)(entity.id, view, preference.id, serializedValue);
        }
    }, [
        persistChanges,
        updateQueryParam,
        entity.id,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if the view is persisting changes, on initial mount
        // check all preferences that serialise to the URL, and set their values to the URL
        if (!persistChanges) return;
        let restoredQuery = {};
        for (const preference of preferences){
            const value = store[preference.id];
            if (value && preference.queryParameter) restoredQuery = {
                ...restoredQuery,
                ...preference.queryParameter.serialize(value)
            };
        }
        updateQueryParam({
            ...restoredQuery,
            ...query
        }, 'replace');
    // only run this effect on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // this effect updates the store value only when the query has changed
        // we shouldn't run it when the component is mounting the first time
        // or when the query hasn't changed
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevQuery, query)) {
            // update the store if the query is updated
            const newState = preferences.reduce((acc, preference)=>{
                const { id: id, queryParameter: queryParameter } = preference;
                if (queryParameter) {
                    const queryValue = queryParameter.deserialize(query);
                    acc[id] = queryValue;
                }
                return acc;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            }, {});
            setStore({
                ...store,
                ...newState
            });
        }
    }, [
        preferences,
        query,
        store,
        entity.id,
        view,
        prevQuery
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            store: store,
            setPreferenceValue: setPreferenceValue
        }), [
        store,
        setPreferenceValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6117ab20ad9a3ccd$var$ViewPreferencesContext.Provider, {
        value: contextValue
    }, children);
};
const $6117ab20ad9a3ccd$export$ee494de6c0ff45d7 = (preference)=>{
    const { store: store, setPreferenceValue: setPreferenceValue } = (0, $eUqFw.useContext)($6117ab20ad9a3ccd$var$ViewPreferencesContext);
    const setValue = (0, $eUqFw.useCallback)((value, action = 'push')=>{
        setPreferenceValue(preference, value, action);
    }, [
        preference,
        setPreferenceValue
    ]);
    const value = store[preference.id];
    return [
        value,
        setValue
    ];
};

});
parcelRegister("6YT9E", function(module, exports) {

$parcel$export(module.exports, "setPreference", () => $e32968ac8498b8dc$export$c6483f3cdc3e51e1);
$parcel$export(module.exports, "getPreference", () => $e32968ac8498b8dc$export$5fa261395d19a143);

var $aZaPn = parcelRequire("aZaPn");
const $e32968ac8498b8dc$var$store = (0, $aZaPn.createLocalStorageProvider)('jwm-view-preferences');
const $e32968ac8498b8dc$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
const $e32968ac8498b8dc$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    $e32968ac8498b8dc$var$store.set(key, value);
};
const $e32968ac8498b8dc$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
    const key = $e32968ac8498b8dc$var$buildPreferenceKey(entityId, viewId, preferenceId);
    return $e32968ac8498b8dc$var$store.get(key);
};

});


parcelRegister("a75Ge", function(module, exports) {

$parcel$export(module.exports, "useProjectStatuses", () => $342d49f1f4fd71f7$export$11ff6a520db76faf);

var $eUqFw = parcelRequire("eUqFw");

var $3G3gn = parcelRequire("3G3gn");

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $kQAZu = parcelRequire("kQAZu");

var $gUUjF = parcelRequire("gUUjF");
const $342d49f1f4fd71f7$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
const $342d49f1f4fd71f7$var$MAX_RETRIES = 3;
const $342d49f1f4fd71f7$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
            [projectKey]: statuses
        });
const $342d49f1f4fd71f7$var$actions = {
    set: $342d49f1f4fd71f7$var$set
};
const $342d49f1f4fd71f7$var$ProjectStatusesStore = (0, $a61MH.createStore)({
    initialState: {},
    actions: $342d49f1f4fd71f7$var$actions,
    name: 'projectStatuses'
});
const $342d49f1f4fd71f7$var$getProjectStatusesSelector = (0, $bj4JM.createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
    if (projectKey === undefined || state[projectKey] == null) return [];
    return state[projectKey];
});
const $342d49f1f4fd71f7$export$482f388228eef22c = (0, $ggKAj.createHook)($342d49f1f4fd71f7$var$ProjectStatusesStore, {
    selector: $342d49f1f4fd71f7$var$getProjectStatusesSelector
});
const $342d49f1f4fd71f7$var$emptyArray = [];
const $342d49f1f4fd71f7$export$11ff6a520db76faf = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $eUqFw.useState)(false);
    const [retriesCount, setRetriesCount] = (0, $eUqFw.useState)(0);
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const [statuses, statusActions] = $342d49f1f4fd71f7$export$482f388228eef22c({
        projectKey: projectKey
    });
    const retry = ()=>{
        setRetriesCount(retriesCount + 1);
        setIsLoading(false);
        setHasLoaded(false);
    };
    if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
        statuses: statuses,
        loading: isLoading
    };
    if (!isLoading && !hasLoaded) {
        fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
            const allStatuses = issueTypes.reduce(// @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'next' implicitly has an 'any' type.
            (acc, next)=>acc.concat(next.statuses), []);
            const dedupedResults = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(allStatuses, 'id');
            return (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(dedupedResults, [
                'name'
            ]);
        }).then((uniqueStatuses)=>{
            statusActions.set(projectKey, uniqueStatuses);
            setIsLoading(false);
            setHasLoaded(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($342d49f1f4fd71f7$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
            if (retriesCount < $342d49f1f4fd71f7$var$MAX_RETRIES) retry();
        });
        setIsLoading(true);
    }
    return {
        statuses: $342d49f1f4fd71f7$var$emptyArray,
        loading: isLoading
    };
};

});

parcelRegister("a6BBe", function(module, exports) {

$parcel$export(module.exports, "STATUS_SORT_ORDER", () => $4f70cf7d8b2e6b0e$export$de9c103e53e690d1);
const $4f70cf7d8b2e6b0e$export$de9c103e53e690d1 = {
    new: 1,
    indeterminate: 2,
    done: 3
};

});

parcelRegister("iP9h2", function(module, exports) {

$parcel$export(module.exports, "sortListBy", () => $61a5cf2a87fc48eb$export$3793ed28be8699ad);
$parcel$export(module.exports, "createSortingGettersAndOrders", () => $61a5cf2a87fc48eb$export$b3fdfcb601c683c3);

var $bDIST = parcelRequire("bDIST");

var $jGcn0 = parcelRequire("jGcn0");

var $6imc4 = parcelRequire("6imc4");

var $iJbbQ = parcelRequire("iJbbQ");

var $3uSNh = parcelRequire("3uSNh");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $90Dtq = parcelRequire("90Dtq");
const $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
const $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
const $61a5cf2a87fc48eb$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
const $61a5cf2a87fc48eb$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(nodes, getters, orders.map($61a5cf2a87fc48eb$var$toAcceptedOrder));
const $61a5cf2a87fc48eb$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, // eslint-disable-next-line @typescript-eslint/no-explicit-any
getMapValueCb)=>{
    // join array with space so alphabetical order can be applied.
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
    const fieldValue = (0, $3uSNh.safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
    return fieldValue.map(getMapValueCb).join(' ') || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
};
/* eslint-enable complexity */ const $61a5cf2a87fc48eb$var$resolvePriorityOrder = (fields, priorities)=>{
    const priorityId = (0, $3uSNh.safeGetValue)(fields, 'priority', 'priorityId', '');
    const priorityOrder = priorities[priorityId];
    if (priorityOrder == null) return -1;
    return priorityOrder;
};
const $61a5cf2a87fc48eb$var$resolveStatusOrder = (fields, statuses)=>{
    const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
    const statusName = (0, $3uSNh.safeGetValue)(fields, 'status', 'name', '');
    const statusOrder = statuses[(0, $eI5EY.fg)('list_view_status_sorting') ? statusName : statusId];
    if (statusOrder == null) return -1;
    return statusOrder;
};
const $61a5cf2a87fc48eb$var$resolveTypeOrder = (fields, types)=>{
    const typeName = (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'value', '');
    const typeOrder = types[typeName];
    if (typeOrder == null) return -1;
    return typeOrder;
};
const $61a5cf2a87fc48eb$var$resolveIssueKeyOrder = (fields)=>{
    const [, issueKeyNumber = 0] = (0, $3uSNh.safeGetValue)(fields, 'issuekey', 'value', '').split('-');
    return Number(issueKeyNumber);
};
const $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
    // wiki value will be null when empty
    const value = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', null);
    return value != null ? value.toLowerCase() : $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE; // empty values should rank lower
};
/* eslint-disable complexity */ const $61a5cf2a87fc48eb$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
        const { rank: rank, fields: fields = [] } = node;
        if (fieldType != null && (0, $6imc4.isSortingSupportedFieldTypePredicated)(fieldType) && (0, $6imc4.isSortingSupported)(fieldType) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            const field = (0, $3uSNh.getFieldValue)(fields, sortingField);
            if ((0, $iJbbQ.isNewTransformedFieldPredicated)(field)) return (0, $6imc4.getSorting)(fieldType, field) || $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
            return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
        }
        switch(fieldType){
            case 0, $lO4Or.LABELS_TYPE:
            case 0, $lO4Or.LABELS_CF_TYPE:
                // The backend will return [''] when it's empty so our default value might not be applied so we force return ~~ when it happens so empty items are ordered properly
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [
                    ''
                ], (label)=>label.toLowerCase());
            case 0, $lO4Or.PRIORITY_TYPE:
                return $61a5cf2a87fc48eb$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
            case 0, $lO4Or.STATUS_TYPE:
                return $61a5cf2a87fc48eb$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
            case 0, $lO4Or.ISSUE_TYPE:
                return $61a5cf2a87fc48eb$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
            case 0, $lO4Or.ASSIGNEE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 0, $lO4Or.USER_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.name', // unassigned items are ranked higher than the ones with an user :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
            case 'issuekey':
                return $61a5cf2a87fc48eb$var$resolveIssueKeyOrder(fields);
            case 0, $lO4Or.CREATED:
            case 0, $lO4Or.UPDATED:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '');
            case 0, $lO4Or.DATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', // empty dates are ranked higher than the ones with set date :shrug:
                $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $lO4Or.DATETIME_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_HIGHER_RANKING_VALUE);
            case 0, $jGcn0.RANK_ALIAS_FIELD_ID:
                if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                    // We want to check for l-1 if the new jql parent is on
                    if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first') && (0, $3uSNh.safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                } else if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first')) return (0, $90Dtq.resolveRank)((0, $3uSNh.safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                return rank ?? '';
            case 0, $lO4Or.SUMMARY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
            case 0, $lO4Or.TEXT_CF_TYPE:
                return $61a5cf2a87fc48eb$var$resolveCustomTextFieldOrder(fields, sortingField);
            case 0, $lO4Or.SELECT_CF_TYPE:
            case 0, $lO4Or.CATEGORY_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
            case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value.timeInSeconds', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.URL_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
            case 0, $lO4Or.NUMBER_CF_TYPE:
            case 0, $lO4Or.STORY_POINTS_TYPE:
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
            case 0, $lO4Or.COMPONENTS_TYPE:
                return $61a5cf2a87fc48eb$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
            case 0, $lO4Or.SPRINT_TYPE:
                {
                    const sprintValue = (0, $3uSNh.safeGetValue)(fields, sortingField, 'value', $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE);
                    if (Array.isArray(sprintValue) && sprintValue.length) {
                        const { name: name, state: state } = sprintValue[0];
                        if (state === 'CLOSED') {
                            const statusId = (0, $3uSNh.safeGetValue)(fields, 'status', 'value', '');
                            // closed sprints should not be shown if the status is not done
                            // means that this ticket is on the backlog
                            if (statusId?.toString() !== (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE].toString()) return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                        }
                        return name.toLowerCase();
                    }
                    return $61a5cf2a87fc48eb$var$DEFAULT_LOWER_RANKING_VALUE;
                }
            default:
                return (0, $3uSNh.safeGetValue)(fields, (0, $jGcn0.RANK_ALIAS_FIELD_ID), 'value', '');
        }
    };
const $61a5cf2a87fc48eb$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
    const getters = [];
    const orders = [];
    let sortFieldType = fieldType;
    // fieldType for key is not returned from useIssueTypeFieldConfig
    if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
    if (sorting != null && sorting.sortBy != null) {
        orders.push(sorting.direction, sorting.direction);
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    } else {
        orders.push((0, $jGcn0.DEFAULT_RANK_SORTING_DIRECTION));
        getters.push($61a5cf2a87fc48eb$var$createSortableGetter((0, $jGcn0.RANK_ALIAS_FIELD_ID), (0, $jGcn0.RANK_ALIAS_FIELD_ID)));
    }
    return {
        getters: getters,
        orders: orders
    };
};

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});

parcelRegister("6imc4", function(module, exports) {

$parcel$export(module.exports, "getSorting", () => $5172533d88399045$export$654dceec98f3061f);
$parcel$export(module.exports, "isSortingSupported", () => $5172533d88399045$export$c6c6084d02f37d7e);
$parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", () => $5172533d88399045$export$190ed2ad153b150b);
$parcel$export(module.exports, "getSortingDisabledFields", () => $5172533d88399045$export$56c924491e5617ad);

var $5iWql = parcelRequire("5iWql");

var $hPNnE = parcelRequire("hPNnE");

var $6Kxnm = parcelRequire("6Kxnm");

var $4dn6Q = parcelRequire("4dn6Q");

var $fgDTb = parcelRequire("fgDTb");

var $4kOft = parcelRequire("4kOft");

var $dnGVZ = parcelRequire("dnGVZ");

var $5GKSf = parcelRequire("5GKSf");

var $4ACib = parcelRequire("4ACib");

var $8DMfR = parcelRequire("8DMfR");

var $77PMd = parcelRequire("77PMd");

var $fGEjz = parcelRequire("fGEjz");
const $5172533d88399045$var$createSortingHandlers = (0, $5iWql.default)(()=>({
        ...(0, $4kOft.parentSortingHandler),
        ...(0, $fGEjz.versionSortingHandler),
        ...(0, $4ACib.resolutionSortingHandler),
        ...(0, $fgDTb.groupSortingHandler),
        ...(0, $5GKSf.radioSelectSortingHandler),
        ...(0, $hPNnE.cascadingSelectSortingHandler),
        ...(0, $dnGVZ.projectSortingHandler)
    }));
const $5172533d88399045$export$654dceec98f3061f = (fieldType, ...args)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $5172533d88399045$export$c6c6084d02f37d7e = (fieldType)=>{
    const handlers = $5172533d88399045$var$createSortingHandlers();
    return handlers[fieldType] != null;
};
const $5172533d88399045$export$190ed2ad153b150b = (fieldType)=>true;
const $5172533d88399045$export$56c924491e5617ad = (0, $5iWql.default)(()=>({
        ...(0, $6Kxnm.devSummaryDisabledSorting),
        ...(0, $77PMd.teamDisabledSorting),
        ...(0, $8DMfR.statusCategoryDisabledSorting),
        ...(0, $4dn6Q.goalsDisabledSorting)
    }));

});
parcelRegister("hPNnE", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSortingHandler", () => $9006c1312190fa14$export$7b0bfc6838ff3257);

var $lO4Or = parcelRequire("lO4Or");

var $yTRlI = parcelRequire("yTRlI");
const $9006c1312190fa14$var$getCascadingSelectSorting = (field)=>(0, $yTRlI.getCascadingSelectStringValue)(field.value);
const $9006c1312190fa14$export$7b0bfc6838ff3257 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $9006c1312190fa14$var$getCascadingSelectSorting
};

});
parcelRegister("yTRlI", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectStringValue", () => $501644a5d0f27e91$export$f110a74eb752aa7e);
$parcel$export(module.exports, "cascadingSelectStringValueHandler", () => $501644a5d0f27e91$export$f39c163ada81742a);

var $lO4Or = parcelRequire("lO4Or");
const $501644a5d0f27e91$export$f110a74eb752aa7e = (fieldValue)=>{
    if (fieldValue && fieldValue.parentOptionValue) {
        if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
        return `${fieldValue.parentOptionValue.value}`;
    }
    return '';
};
const $501644a5d0f27e91$var$getCascadingSelectValue = (field)=>$501644a5d0f27e91$export$f110a74eb752aa7e(field.value);
const $501644a5d0f27e91$export$f39c163ada81742a = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $501644a5d0f27e91$var$getCascadingSelectValue
};

});


parcelRegister("6Kxnm", function(module, exports) {

$parcel$export(module.exports, "devSummaryDisabledSorting", () => $13cd49fb2f12cee8$export$8cf683615a3ccf77);

var $lO4Or = parcelRequire("lO4Or");
const $13cd49fb2f12cee8$export$8cf683615a3ccf77 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: false
};

});

parcelRegister("4dn6Q", function(module, exports) {

$parcel$export(module.exports, "goalsDisabledSorting", () => $e609dcddc34139db$export$60ff70c996f5c362);

var $lO4Or = parcelRequire("lO4Or");
const $e609dcddc34139db$export$60ff70c996f5c362 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: false
};

});

parcelRegister("fgDTb", function(module, exports) {

$parcel$export(module.exports, "groupSortingHandler", () => $2965094b1aff09d1$export$a577fd60fa30451d);

var $lO4Or = parcelRequire("lO4Or");
const $2965094b1aff09d1$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
const $2965094b1aff09d1$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $2965094b1aff09d1$export$a577fd60fa30451d = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getSingleGroupSorting,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $2965094b1aff09d1$var$getMultipleGroupSorting
};

});

parcelRegister("4kOft", function(module, exports) {

$parcel$export(module.exports, "parentSortingHandler", () => $b1645a5228930c15$export$20dbdacc158507c9);

var $lO4Or = parcelRequire("lO4Or");
const $b1645a5228930c15$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
const $b1645a5228930c15$export$20dbdacc158507c9 = {
    [(0, $lO4Or.PARENT_TYPE)]: $b1645a5228930c15$var$getParentSorting
};

});

parcelRegister("dnGVZ", function(module, exports) {

$parcel$export(module.exports, "projectSortingHandler", () => $b535da34585ea13f$export$18c888fa7805bbf9);

var $lO4Or = parcelRequire("lO4Or");
const $b535da34585ea13f$var$getProjectSorting = (field)=>field.value?.name ?? '';
const $b535da34585ea13f$export$18c888fa7805bbf9 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $b535da34585ea13f$var$getProjectSorting
};

});

parcelRegister("5GKSf", function(module, exports) {

$parcel$export(module.exports, "radioSelectSortingHandler", () => $090676a3e9c576f9$export$d622730346571a2b);

var $lO4Or = parcelRequire("lO4Or");
const $090676a3e9c576f9$var$getRadioSelectSorting = (field)=>field.value ? field.value.label : '';
const $090676a3e9c576f9$export$d622730346571a2b = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $090676a3e9c576f9$var$getRadioSelectSorting
};

});

parcelRegister("4ACib", function(module, exports) {

$parcel$export(module.exports, "resolutionSortingHandler", () => $2a63ab07413670f0$export$596a643f093db9a7);

var $lO4Or = parcelRequire("lO4Or");
const $2a63ab07413670f0$var$getResolutionSorting = (field)=>field.value?.name ?? '';
const $2a63ab07413670f0$export$596a643f093db9a7 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $2a63ab07413670f0$var$getResolutionSorting
};

});

parcelRegister("8DMfR", function(module, exports) {

$parcel$export(module.exports, "statusCategoryDisabledSorting", () => $14c4f6b294c727dd$export$117cb43589655b27);

var $lO4Or = parcelRequire("lO4Or");
const $14c4f6b294c727dd$export$117cb43589655b27 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: false
};

});

parcelRegister("77PMd", function(module, exports) {

$parcel$export(module.exports, "teamDisabledSorting", () => $4318536e894fadd9$export$1626c947db580b0f);

var $lO4Or = parcelRequire("lO4Or");
const $4318536e894fadd9$export$1626c947db580b0f = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: false
};

});

parcelRegister("fGEjz", function(module, exports) {

$parcel$export(module.exports, "versionSortingHandler", () => $478431d0e41552b9$export$f2894a637a250eaa);

var $lO4Or = parcelRequire("lO4Or");
const $478431d0e41552b9$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
const $478431d0e41552b9$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $478431d0e41552b9$export$f2894a637a250eaa = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $478431d0e41552b9$var$getSingleVersionSorting,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $478431d0e41552b9$var$getMultipleVersionSorting
};

});


parcelRegister("iJbbQ", function(module, exports) {

$parcel$export(module.exports, "isNewTransformedFieldPredicated", () => $1f6d8e2cada4a475$export$b018c2b58ea7e0de);

var $edHli = parcelRequire("edHli");
const $1f6d8e2cada4a475$export$b018c2b58ea7e0de = (field)=>field != null;

});
parcelRegister("edHli", function(module, exports) {

$parcel$export(module.exports, "isJiraBusinessFields", () => $58b3a50c72d1bd9f$export$257745f9c8865601);
const $58b3a50c72d1bd9f$export$257745f9c8865601 = (_)=>true;

});


parcelRegister("3uSNh", function(module, exports) {

$parcel$export(module.exports, "getFieldValue", () => $0a411223ee962893$export$2e85048acc9aea83);
$parcel$export(module.exports, "safeGetValue", () => $0a411223ee962893$export$f17a5eaf5fe57cff);
$parcel$export(module.exports, "safeGetTransformedFieldValue", () => $0a411223ee962893$export$16456470899ab77f);
$parcel$export(module.exports, "safeGetTransformedValue", () => $0a411223ee962893$export$c1cc7bc9b4953394);

var $illlw = parcelRequire("illlw");
const $0a411223ee962893$export$2e85048acc9aea83 = (fields, fieldKey)=>{
    if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
    return undefined;
};
const $0a411223ee962893$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, attributeName, defaultValue);
};
const $0a411223ee962893$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
    const field = $0a411223ee962893$export$2e85048acc9aea83(fields, fieldKey);
    return $0a411223ee962893$export$c1cc7bc9b4953394(field, defaultValue);
};
const $0a411223ee962893$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(field, 'value', defaultValue);

});

parcelRegister("90Dtq", function(module, exports) {

$parcel$export(module.exports, "resolveRank", () => $668a01cc7ea88012$export$992090b26f7c7f11);

var $1ybV0 = parcelRequire("1ybV0");
const $668a01cc7ea88012$export$992090b26f7c7f11 = (parentIssue, rank)=>{
    if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first')) {
        // sorting based on rank considers the parent rank first, then sorts based on item rank
        // concatenating (parentRank + rank) would do that for us!
        const parentRank = parentIssue?.rank ?? '';
        return parentRank.concat(rank);
    }
    return rank;
};

});



parcelRegister("gZpkQ", function(module, exports) {

$parcel$export(module.exports, "useHideDoneItems", () => $0e65969a09396197$export$c2cb7b17819b92d4);
$parcel$export(module.exports, "useInferHideDoneItemsWithFilters", () => $0e65969a09396197$export$a14bc8305f71e469);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $8Qd0L = parcelRequire("8Qd0L");

var $9GlEj = parcelRequire("9GlEj");
const $0e65969a09396197$export$c2cb7b17819b92d4 = ()=>{
    const [hideDoneItems, persistHideDoneItems] = (0, $7c3W1.useViewPreference)((0, $ji3xf.HIDE_DONE_ITEMS_PREFERENCE));
    const setHideDoneItems = (0, $eUqFw.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
        persistHideDoneItems
    ]);
    return [
        hideDoneItems === 'true',
        setHideDoneItems
    ];
};
const $0e65969a09396197$export$a14bc8305f71e469 = ({ filters: filters })=>{
    const [hideDoneItems, setHideDoneItems] = $0e65969a09396197$export$c2cb7b17819b92d4();
    const { quickFilters: quickFilters } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        if (hideDoneItems) {
            const isFilteringByDoneStatus = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE]);
            if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filters,
        quickFilters?.DONE
    ]);
};

});
parcelRegister("9GlEj", function(module, exports) {

$parcel$export(module.exports, "useQuickFilters", () => $20c7583d02c9250e$export$3dae1bb95b659fd4);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lO4Or = parcelRequire("lO4Or");

var $kMmsu = parcelRequire("kMmsu");
const $20c7583d02c9250e$var$quickFilterToJQLMapOld = {
    ASSIGNED_TO_ME: 'assignee = currentUser()',
    DONE: "StatusCategory = 'Complete'",
    DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
};
const $20c7583d02c9250e$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
    if (sprintJQLTerm == null) return $20c7583d02c9250e$var$quickFilterToJQLMapOld;
    return {
        ...$20c7583d02c9250e$var$quickFilterToJQLMapOld,
        ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
    };
};
const $20c7583d02c9250e$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const jqlClauses = Object.entries(quickFilters).map(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly ASSIGNED_TO_ME: "assignee = currentUser()"; readonly DONE: "StatusCategory = 'Complete'"; readonly DUE_THIS_WEEK: "duedate <= endOfWeek() and duedate > startOfWeek()"; }'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
    const enabledFilters = jqlClauses.filter((jql)=>jql);
    return enabledFilters.join(' AND ') || null;
};
const $20c7583d02c9250e$export$9294471da4d3c33f = {
    ASSIGNED_TO_ME: false,
    DONE: false,
    DUE_THIS_WEEK: false,
    ACTIVE_SPRINTS: false
};
const $20c7583d02c9250e$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $20c7583d02c9250e$var$quickFilterToJQLMapOld } = {})=>{
    const quickFilters = {
        ...$20c7583d02c9250e$export$9294471da4d3c33f
    };
    if (!jql) return quickFilters;
    if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
    if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
    if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
    if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
    return quickFilters;
};
const $20c7583d02c9250e$var$useSprintFieldJQLTerm = ()=>{
    const { data: fields } = (0, $kMmsu.useFieldsResource)();
    return (0, $eUqFw.useMemo)(()=>{
        if (fields == null) return undefined;
        const sprintField = fields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        return sprintField != null ? sprintField.jqlTerm : undefined;
    }, [
        fields
    ]);
};
const $20c7583d02c9250e$export$3dae1bb95b659fd4 = ()=>{
    const sprintFieldJQLTerm = $20c7583d02c9250e$var$useSprintFieldJQLTerm();
    const quickFilterToJQLMap = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$808f76242d61e1a5(sprintFieldJQLTerm), [
        sprintFieldJQLTerm
    ]);
    const [filters, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const setQuickFilters = (0, $eUqFw.useCallback)((newQuickFilters)=>{
        if (newQuickFilters) {
            const jql = $20c7583d02c9250e$var$buildJQLFromQuickFilters(newQuickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            });
            if (jql == null) setFilters(undefined);
            else setFilters(jql);
        } else setFilters(undefined);
    }, [
        quickFilterToJQLMap,
        setFilters
    ]);
    const quickFilters = (0, $eUqFw.useMemo)(()=>$20c7583d02c9250e$export$9692fc1a2fd983f5(filters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        }), [
        filters,
        quickFilterToJQLMap
    ]);
    return {
        quickFilters: quickFilters,
        persistQuickFilters: setQuickFilters,
        quickFiltersJql: $20c7583d02c9250e$var$buildJQLFromQuickFilters(quickFilters, {
            quickFilterToJQLMap: quickFilterToJQLMap
        })
    };
};

});


parcelRegister("lEWmB", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $2972841342234906$export$973ca22476b0e05f);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $1ybV0 = parcelRequire("1ybV0");

var $8aCHU = parcelRequire("8aCHU");
const $2972841342234906$export$973ca22476b0e05f = ()=>{
    const [jql, saveFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const serialiseJql = (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? (0, $8aCHU.serialiseJql) : (0, $8aCHU.serialiseJqlOld);
    const setFilter = (0, $eUqFw.useCallback)((filters)=>{
        const serialisedJql = serialiseJql(filters);
        saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
    }, [
        saveFilters,
        serialiseJql
    ]);
    return {
        setFilter: setFilter,
        jql: jql
    };
};

});
parcelRegister("8aCHU", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $0e700551905b00b3$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "serialiseJqlOld", () => $0e700551905b00b3$export$5bd6a523f48a18cd);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $0e700551905b00b3$export$9ee6085825c9cbfa);

var $8blac = parcelRequire("8blac");

var $27QuD = parcelRequire("27QuD");

var $6wqPF = parcelRequire("6wqPF");

var $6x1NF = parcelRequire("6x1NF");

var $ehDeP = parcelRequire("ehDeP");
var $k85ht = parcelRequire("k85ht");
var $lmIUR = parcelRequire("lmIUR");

var $dG4cR = parcelRequire("dG4cR");
const $0e700551905b00b3$var$START_DATE_JQL = 'Start date[Date]';
const $0e700551905b00b3$var$EMPTY = 'EMPTY';
const $0e700551905b00b3$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $0e700551905b00b3$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $0e700551905b00b3$var$START_DATE_JQL;
    return fieldName;
};
const $0e700551905b00b3$var$getFieldNameForJql = (fieldName)=>$0e700551905b00b3$var$getQuotedFieldName($0e700551905b00b3$var$getFieldNameForJqlRaw(fieldName));
const $0e700551905b00b3$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $0e700551905b00b3$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $0e700551905b00b3$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $0e700551905b00b3$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $0e700551905b00b3$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $ehDeP.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(toFieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_LT)), (0, $ehDeP.default).valueOperand(toDate)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_GT_EQUALS)), (0, $ehDeP.default).valueOperand(options.value.from)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $ehDeP.default).valueOperand((0, $807962b43ef03b56$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $ehDeP.default).byText.valueOperand(`"${$0e700551905b00b3$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_EQUALS)), operands[0]), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $ehDeP.default).terminalClause((0, $ehDeP.default).field(fieldName), (0, $ehDeP.default).operator((0, $k85ht.OPERATOR_IN)), (0, $ehDeP.default).listOperand(operands)), (0, $e5bc650799ce4838$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $ehDeP.default).jast(jqlQuery);
    return (0, $lmIUR.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $0e700551905b00b3$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $0e700551905b00b3$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $0e700551905b00b3$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $6x1NF.default)((0, $6wqPF.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $dG4cR.EMPTY_FILTER_VALUE) ? $0e700551905b00b3$var$EMPTY : `'${$0e700551905b00b3$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $0e700551905b00b3$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $0e700551905b00b3$var$getFieldIdFromJql(fieldId);
};
const $0e700551905b00b3$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($0e700551905b00b3$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("27QuD", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $2cjNq = parcelRequire("2cjNq");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $18c4f43cd593e3cf$var$trim(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return $2cjNq(string);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), chrSymbols = $aSldm(chars), start = $3Muqa(strSymbols, chrSymbols), end = $1qE1i(strSymbols, chrSymbols) + 1;
    return $8SGvQ(strSymbols, start, end).join('');
}
module.exports = $18c4f43cd593e3cf$var$trim;

});
parcelRegister("1qE1i", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $10a7434ada2e55c3$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $10a7434ada2e55c3$var$charsEndIndex;

});

parcelRegister("3Muqa", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $2c0d73c17288fd42$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $jkhuN(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $2c0d73c17288fd42$var$charsStartIndex;

});


const $e5bc650799ce4838$export$6d6d48d210d3ca97 = 'and';
const $e5bc650799ce4838$export$7b8f0a728d79a753 = 'or';

const $807962b43ef03b56$export$38accfc5a5d1c113 = 'value';
const $807962b43ef03b56$export$f6049126fd97001f = 'keyword';
const $807962b43ef03b56$export$19c7c729db381f9d = 'function';
const $807962b43ef03b56$export$fabec4aebba3f4df = 'list';
const $807962b43ef03b56$export$1c46dca02aac24dd = 'empty';

parcelRegister("lmIUR", function(module, exports) {

$parcel$export(module.exports, "print", () => $a9625f5ea61b2ada$export$c2d084dc44961371);

var $8dloj = parcelRequire("8dloj");

var $8VPLp = parcelRequire("8VPLp");

var $gGtGU = parcelRequire("gGtGU");
const $a9625f5ea61b2ada$export$c2d084dc44961371 = (jast, options = {})=>{
    return (0, $gGtGU.printDocToString)((0, $8VPLp.printAstToDoc)(jast, (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'operatorCase'
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(options, [
        'printWidth'
    ]));
};

});
parcelRegister("8VPLp", function(module, exports) {

$parcel$export(module.exports, "printAstToDoc", () => $d301c3605dc18477$export$f0ef38932978952);


var $6RWCB = parcelRequire("6RWCB");

var $6l51o = parcelRequire("6l51o");
const $d301c3605dc18477$var$formatOperator = (operator, operatorCase)=>{
    switch(operatorCase){
        case 'lower':
            return operator.toLowerCase();
        case 'upper':
            return operator.toUpperCase();
        case 'preserve':
            return operator;
    }
};
class $d301c3605dc18477$export$27a275559a5c8102 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor({ operatorCase: operatorCase } = {}){
        super();
        this.operatorCase = operatorCase || 'preserve';
    }
    visitArgument(argument) {
        return argument.text;
    }
    /**
	 * Visit each of the provided nodes and form a new array with each `Doc` joined by the provided separator.
	 */ joinNodes(nodes, separator) {
        const docs = [];
        nodes.forEach((node)=>{
            if (separator !== undefined && docs.length > 0) docs.push(separator);
            docs.push(node.accept(this));
        });
        return docs;
    }
    visitCompoundClause(compoundClause) {
        const operatorDoc = compoundClause.operator.accept(this);
        const clauseDocs = [];
        compoundClause.clauses.forEach((clause)=>{
            if (clauseDocs.length > 0) clauseDocs.push((0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '), operatorDoc, ' ');
            // Wrap nested compound clauses in parentheses
            if (clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
            else clauseDocs.push(clause.accept(this));
        });
        return (0, $6l51o.group)(clauseDocs);
    }
    visitCompoundOperator(compoundOperator) {
        return $d301c3605dc18477$var$formatOperator(compoundOperator.value, this.operatorCase);
    }
    visitField(field) {
        const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
        return (0, $6l51o.group)([
            field.text,
            ...propertyDocs
        ]);
    }
    visitFunction(functionString) {
        return functionString.text;
    }
    visitFunctionOperand(functionOperand) {
        const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
        return (0, $6l51o.group)([
            functionOperand.function.accept(this),
            '(',
            ...argumentDocs,
            ')'
        ]);
    }
    visitKeywordOperand(keywordOperand) {
        return keywordOperand.value;
    }
    visitListOperand(listOperand) {
        const operandDocs = this.joinNodes(listOperand.values, ', ');
        return (0, $6l51o.group)([
            '(',
            ...operandDocs,
            ')'
        ]);
    }
    visitOperator(operator) {
        return $d301c3605dc18477$var$formatOperator(operator.text, this.operatorCase);
    }
    visitOrderBy(orderBy) {
        const fieldDocs = this.joinNodes(orderBy.fields, ', ');
        return (0, $6l51o.group)([
            orderBy.operator.accept(this),
            ' ',
            ...fieldDocs
        ]);
    }
    visitOrderByDirection(orderByDirection) {
        return orderByDirection.value;
    }
    visitOrderByField(orderByField) {
        const docs = [
            orderByField.field.accept(this)
        ];
        if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitOrderByOperator(orderByOperator) {
        return $d301c3605dc18477$var$formatOperator(orderByOperator.value, this.operatorCase);
    }
    visitPredicate(predicate) {
        const docs = [
            predicate.operator.accept(this)
        ];
        if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
        return (0, $6l51o.group)(docs);
    }
    visitPredicateOperator(predicateOperator) {
        return $d301c3605dc18477$var$formatOperator(predicateOperator.text, this.operatorCase);
    }
    visitProperty(property) {
        const docs = [];
        if (property.key) docs.push('[', property.key.accept(this), ']');
        if (property.path) {
            const pathDocs = this.joinNodes(property.path, ' ');
            docs.push(...pathDocs);
        }
        return (0, $6l51o.group)(docs);
    }
    visitQuery(query) {
        if (query.where && query.orderBy) return (0, $6l51o.group)([
            query.where.accept(this),
            (0, $6l51o.ifBreak)((0, $6l51o.newLine)(), ' '),
            query.orderBy.accept(this)
        ]);
        else if (query.where) return query.where.accept(this);
        else if (query.orderBy) return query.orderBy.accept(this);
        return '';
    }
    visitTerminalClause(terminalClause) {
        const docs = [
            terminalClause.field.accept(this)
        ];
        if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
        if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
        terminalClause.predicates.forEach((predicate)=>{
            docs.push(' ', predicate.accept(this));
        });
        return (0, $6l51o.group)(docs);
    }
    visitValueOperand(valueOperand) {
        return valueOperand.text;
    }
    visitNotClause(notClause) {
        const clauseDocs = [];
        // Wrap nested compound clauses in parentheses
        if (notClause.clause.clauseType === (0, $35634e4e5a46f5ae$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
        else clauseDocs.push(notClause.clause.accept(this));
        return (0, $6l51o.group)([
            notClause.operator.accept(this),
            ' ',
            ...clauseDocs
        ]);
    }
    visitNotClauseOperator(notClauseOperator) {
        return notClauseOperator.value;
    }
    visitChildren() {
        throw new Error('Required visit method not implemented for node');
    }
    defaultResult() {
        return '';
    }
}
const $d301c3605dc18477$export$f0ef38932978952 = (jast, options)=>{
    const astToDocVisitor = new $d301c3605dc18477$export$27a275559a5c8102(options);
    return jast.query ? jast.query.accept(astToDocVisitor) : '';
};

});
const $35634e4e5a46f5ae$export$7a58b23488ea076b = 'compound';
const $35634e4e5a46f5ae$export$ae56b4ef248a2b6a = 'terminal';
const $35634e4e5a46f5ae$export$e356b89f8c8d2fcb = 'not';

parcelRegister("6RWCB", function(module, exports) {

$parcel$export(module.exports, "AbstractJastVisitor", () => $17ed1e3c7a9e2333$export$51be62b46ee668fd);
class $17ed1e3c7a9e2333$export$51be62b46ee668fd {
    /**
	 * The default implementation calls AstNode#accept on the specified node.
	 * @param node
	 */ visit(node) {
        return node.accept(this);
    }
    /**
	 * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
	 * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
	 * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
	 * aggregate result and the result of visiting the child.
	 */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
	 * Aggregates the results of visiting multiple children of a node.
	 *
	 * The default implementation returns `nextResult`, meaning
	 * {@link #visitChildren} will return the result of the last child visited
	 * (or return the initial value if the node has no children).
	 *
	 * @param aggregate The previous aggregate value. In the default
	 * implementation, the aggregate value is initialized to
	 * {@link #defaultResult}, which is passed as the `aggregate` argument
	 * to this method after the first child node is visited.
	 * @param nextResult The result of the immediately preceeding call to visit
	 * a child node.
	 *
	 * @returns The updated aggregate result.
	 */ aggregateResult(aggregate, nextResult) {
        return nextResult;
    }
    /**
	 * This method is called before visiting each child in
	 * {@link #visitChildren}. When the method is first called\ `currentResult`
	 * will be the initial value (in the default implementation, the initial value
	 * is returned by a call to {@link #defaultResult}).
	 *
	 * The default implementation always returns `true`, indicating that
	 * `visitChildren` should only return after all children are visited.
	 * One reason to override this method is to provide a "short circuit"
	 * evaluation option for situations where the result of visiting a single
	 * child has the potential to determine the result of the visit operation as
	 * a whole.
	 *
	 * @param node The {@link AstNode} whose children are currently being
	 * visited.
	 * @param currentResult The current aggregate result of the children visited
	 * to the current point.
	 *
	 * @returns `true` to continue visiting children. Otherwise return
	 * `false` to stop visiting children and immediately return the
	 * current aggregate result from {@link #visitChildren}.
	 */ shouldVisitNextChild(node, currentResult) {
        return true;
    }
}

});

parcelRegister("6l51o", function(module, exports) {

$parcel$export(module.exports, "group", () => $505bf572d8c2f20e$export$e5e25fbcc1f7affe);
$parcel$export(module.exports, "ifBreak", () => $505bf572d8c2f20e$export$1db8e61901dcb0fa);
$parcel$export(module.exports, "newLine", () => $505bf572d8c2f20e$export$dc84f6841f96b7da);
const $505bf572d8c2f20e$export$e5e25fbcc1f7affe = (contents)=>{
    return {
        type: 'group',
        contents: contents
    };
};
const $505bf572d8c2f20e$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
    return {
        type: 'if-break',
        breakContents: breakContents,
        flatContents: flatContents
    };
};
const $505bf572d8c2f20e$export$dc84f6841f96b7da = ()=>{
    return {
        type: 'new-line'
    };
};

});


parcelRegister("gGtGU", function(module, exports) {

$parcel$export(module.exports, "printDocToString", () => $1adbb8b7e9dc2aa6$export$316fc7e94b95b118);
const $1adbb8b7e9dc2aa6$var$computeFlatWidth = (doc)=>{
    if (typeof doc === 'string') return doc.length;
    if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1adbb8b7e9dc2aa6$var$computeFlatWidth(innerDoc), 0);
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.contents);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc.flatContents);
        case 'new-line':
            // TODO This probably represents a bug as we don't expect new lines in the flat path
            return 0;
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printDoc = (doc, context)=>{
    if (typeof doc === 'string') return {
        result: doc,
        endIndex: context.startIndex + doc.length
    };
    switch(doc.type){
        case 'group':
            return $1adbb8b7e9dc2aa6$var$printGroup(doc, context);
        case 'if-break':
            return $1adbb8b7e9dc2aa6$var$printIfBreak(doc, context);
        case 'new-line':
            return $1adbb8b7e9dc2aa6$var$printNewLine();
        default:
            throw new Error('Unrecognised doc type.');
    }
};
const $1adbb8b7e9dc2aa6$var$printGroup = (doc, context)=>{
    const docWidth = context.startIndex + $1adbb8b7e9dc2aa6$var$computeFlatWidth(doc);
    const breakContents = context.printWidth !== null && docWidth > context.printWidth;
    return doc.contents.reduce((agg, innerDoc)=>{
        const innerContext = {
            ...context,
            startIndex: agg.endIndex,
            breakContents: breakContents
        };
        const output = $1adbb8b7e9dc2aa6$var$printDoc(innerDoc, innerContext);
        return {
            result: agg.result + output.result,
            endIndex: output.endIndex
        };
    }, {
        result: '',
        endIndex: context.startIndex
    });
};
const $1adbb8b7e9dc2aa6$var$printIfBreak = (doc, context)=>{
    if (context.breakContents) return $1adbb8b7e9dc2aa6$var$printDoc(doc.breakContents, context);
    return $1adbb8b7e9dc2aa6$var$printDoc(doc.flatContents, context);
};
const $1adbb8b7e9dc2aa6$var$printNewLine = ()=>{
    return {
        result: '\n',
        // Reset our end index as a new line is being output.
        endIndex: 0
    };
};
// TODO Tweak this number with design
const $1adbb8b7e9dc2aa6$var$defaultPrintWidth = 100;
const $1adbb8b7e9dc2aa6$export$316fc7e94b95b118 = (doc, options = {})=>{
    const { printWidth: printWidth = $1adbb8b7e9dc2aa6$var$defaultPrintWidth } = options;
    const output = $1adbb8b7e9dc2aa6$var$printDoc(doc, {
        printWidth: printWidth,
        startIndex: 0,
        breakContents: false
    });
    return output.result;
};

});


parcelRegister("dG4cR", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $36a0671262b022c0$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $36a0671262b022c0$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $36a0671262b022c0$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $36a0671262b022c0$export$9b72011e2eb8d7d0);
const $36a0671262b022c0$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $36a0671262b022c0$export$6e40821019289c70 = 'optimistic-filter-id';
const $36a0671262b022c0$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $36a0671262b022c0$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $36a0671262b022c0$export$9ebaf9fe814731d3 = null;
const $36a0671262b022c0$export$9b72011e2eb8d7d0 = 'text';

});



parcelRegister("96etS", function(module, exports) {

$parcel$export(module.exports, "useSimpleSearch", () => $70f3d6a365372dbd$export$b549f44e7ca96280);
$parcel$export(module.exports, "useSimpleSearchHighlight", () => $70f3d6a365372dbd$export$fd04dfca01137d2);
$parcel$export(module.exports, "useSearchText", () => $70f3d6a365372dbd$export$119186efd4186c93);
$parcel$export(module.exports, "useSimpleSearchJQL", () => $70f3d6a365372dbd$export$42b8d8a5ec5bc873);

var $eUqFw = parcelRequire("eUqFw");

var $6GXx9 = parcelRequire("6GXx9");

var $kJlBc = parcelRequire("kJlBc");

var $dG4cR = parcelRequire("dG4cR");
const $70f3d6a365372dbd$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
const $70f3d6a365372dbd$var$issueKeyRegex = new RegExp(`^${(0, $6GXx9.ISSUEKEY_REGEX)}$`);
const $70f3d6a365372dbd$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
const $70f3d6a365372dbd$export$b549f44e7ca96280 = ()=>{
    const [simpleSearch, persistSimpleSearch] = (0, $kJlBc.useQueryParam)((0, $dG4cR.SIMPLE_SEARCH_PARAM));
    const setSimpleSearch = (0, $eUqFw.useCallback)((searchText)=>{
        searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
    }, [
        persistSimpleSearch
    ]);
    return [
        simpleSearch ?? '',
        setSimpleSearch
    ];
};
const $70f3d6a365372dbd$export$72839f749ccf76b2 = (text)=>{
    if (text == null) return [];
    return text.split(' ').filter((word)=>word !== '');
};
const $70f3d6a365372dbd$export$fd04dfca01137d2 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    return (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(simpleSearch), [
        simpleSearch
    ]);
};
const $70f3d6a365372dbd$export$abb78553baf1cfac = (text)=>{
    if (text == null || text.trim() === '') return '';
    let search = $70f3d6a365372dbd$var$sanitize(text);
    if ($70f3d6a365372dbd$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
    // if the text does not contain Chinese or Japanese characters (which are not tokenized),
    // and does not end with a space character
    // make it a wildcard search
    if (!$70f3d6a365372dbd$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
    return `(summary ~ '${search}' OR description ~ '${search}')`;
};
const $70f3d6a365372dbd$export$119186efd4186c93 = (text)=>{
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(text), [
        text
    ]);
    const highlight = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$72839f749ccf76b2(text), [
        text
    ]);
    return {
        jql: jql,
        highlight: highlight
    };
};
const $70f3d6a365372dbd$export$42b8d8a5ec5bc873 = ()=>{
    const [simpleSearch] = $70f3d6a365372dbd$export$b549f44e7ca96280();
    const jql = (0, $eUqFw.useMemo)(()=>$70f3d6a365372dbd$export$abb78553baf1cfac(simpleSearch), [
        simpleSearch
    ]);
    const addSimpleSearchToJQL = (0, $eUqFw.useCallback)((currentJQL)=>{
        if (jql === '') return currentJQL;
        if (currentJQL == null) return jql;
        return `${currentJQL} AND ${jql}`;
    }, [
        jql
    ]);
    return {
        jql: jql,
        isSearching: jql !== '',
        addSimpleSearchToJQL: addSimpleSearchToJQL
    };
};
var $70f3d6a365372dbd$export$2e2bcd8739ae039 = $70f3d6a365372dbd$export$b549f44e7ca96280;

});
parcelRegister("6GXx9", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $2bd12f0fe8e9dce1$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $2bd12f0fe8e9dce1$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");
const $2bd12f0fe8e9dce1$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bd12f0fe8e9dce1$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$2bd12f0fe8e9dce1$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});


parcelRegister("jQFcD", function(module, exports) {

$parcel$export(module.exports, "sanitiseJql", () => $fea50252d29e77ce$export$78c9a06ab18996fc);
$parcel$export(module.exports, "getJqlErrors", () => $fea50252d29e77ce$export$cc387523b0acb16d);

var $bXcc5 = parcelRequire("bXcc5");
var $lmIUR = parcelRequire("lmIUR");

var $1ybV0 = parcelRequire("1ybV0");
const $fea50252d29e77ce$export$78c9a06ab18996fc = (jql)=>{
    if (!jql) return jql;
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
    return (0, $lmIUR.print)(jast, (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? {
        operatorCase: 'upper',
        printWidth: null
    } : undefined);
};
const $fea50252d29e77ce$export$cc387523b0acb16d = (jql)=>{
    if (!jql) return [];
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    return jast.errors;
};

});



parcelRegister("5ujax", function(module, exports) {

$parcel$export(module.exports, "hasAllRequiredFields", () => $52d6130341d650ac$export$146976a1cbd99cd0);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $52d6130341d650ac$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
    if (!issueType) return false;
    return issueType.fields.every((field)=>{
        if (!field.fieldConfig?.isRequired) return true;
        if (!field.type && !field.aliasFieldId) return false;
        if (field.aliasFieldId && field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
        if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
        if (field.type) switch(field.type){
            case 0, $lO4Or.ISSUE_TYPE:
            case 0, $lO4Or.REPORTER_TYPE:
                return true;
            case 0, $lO4Or.SUMMARY_TYPE:
                return Boolean(createInput.summary);
            case 0, $lO4Or.PRIORITY_TYPE:
                return Boolean(createInput.priority);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return Boolean(createInput.assignee);
            case 0, $lO4Or.DUE_DATE_TYPE:
                return Boolean(createInput.dueDate);
            case 0, $lO4Or.CATEGORY_TYPE:
                return Boolean(createInput.category);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return createInput.storyPointEstimate != null;
            case 0, $lO4Or.SPRINT_TYPE:
                return Boolean(createInput.sprint);
            default:
                break;
        }
        return false;
    });
};

});

parcelRegister("auegK", function(module, exports) {

$parcel$export(module.exports, "CancelledError", () => $3e371496a660187a$export$a8430ed4188f35a9);
$parcel$export(module.exports, "useCreateIssueDialog", () => $3e371496a660187a$export$8254d39962ec7361);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $ctR9z = parcelRequire("ctR9z");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");


var $fD1Hq = parcelRequire("fD1Hq");

var $l1Cux = parcelRequire("l1Cux");
class $3e371496a660187a$export$a8430ed4188f35a9 extends Error {
}
const $3e371496a660187a$export$8d1d8a0d2a7917ac = ()=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    return (0, $eUqFw.useCallback)((issueType, predicate)=>{
        if (!issueType) return undefined;
        const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
        return issueTypeWithFields?.fields.find(predicate);
    }, [
        typesWithFields
    ]);
};
const $3e371496a660187a$export$8254d39962ec7361 = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const getField = $3e371496a660187a$export$8d1d8a0d2a7917ac();
    // rank field is handled separately as it's not returned by the available fields API
    const { data: rankField } = (0, $fD1Hq.useRankField)();
    return (0, $eUqFw.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
            const unsubscribe = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                // the user cancelled editing
                onClose(null);
            });
            // resolve the promise once the GIC has been closed or reject it if cancelled
            const onClose = (data)=>{
                const result = data?.[0];
                if (result) resolve(result);
                else // adding a delay upon user cancelling because of a bug in the GIC's state management logic ICO-303
                setTimeout(()=>{
                    reject(new $3e371496a660187a$export$a8430ed4188f35a9('User cancelled'));
                }, 100);
                unsubscribe();
            };
            const { payload: payload, submitApiData: submitApiData } = (0, $l1Cux.buildGICPayload)({
                createInput: createInput,
                extraPayload: extraPayload,
                rankField: rankField,
                getField: getField
            });
            const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
            openIssueCreateModal({
                id: 'jwm-create-issue-dialog',
                onClose: onClose,
                payload: payload,
                context: {
                    projectId: createInput.projectId,
                    submitApiData: submitApiData
                },
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                triggerPointKey: (0, $33ffe55cb7bcdadc$export$145eb8935a34e85e),
                disableProjectDropdown: true,
                disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                disableCreationSuccessFlag: true,
                displayCreateAnotherIssueToggle: false,
                minimizableModalView: 'mini'
            });
        }), [
        getField,
        openIssueCreateModal,
        rankField,
        subscribe
    ]);
};

});
parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");


var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$8d987f6e80b74000),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                ...(0, $1ybV0.ff)('jira-ai-work-breakdown-new-ui_z0inn') && {
                    callbackPayload: undefined
                },
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $ggKAj.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $ggKAj.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $dYfll.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");
var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $duQ8C = parcelRequire("duQ8C");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('global-issue.create-modal-subsequent');
    else (0, $duQ8C.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("l1Cux", function(module, exports) {

$parcel$export(module.exports, "buildGICPayload", () => $3b44adbb66991c12$export$eb18ffe6388f217a);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable complexity */ 
var $6x1NF = parcelRequire("6x1NF");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
const $3b44adbb66991c12$var$assigneeFieldPredicate = (field)=>field.type === (0, $lO4Or.ASSIGNEE_TYPE);
const $3b44adbb66991c12$var$categoryFieldPredicate = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $3b44adbb66991c12$var$dueDateFieldPredicate = (field)=>field.type === (0, $lO4Or.DUE_DATE_TYPE);
const $3b44adbb66991c12$var$priorityFieldPredicate = (field)=>field.type === (0, $lO4Or.PRIORITY_TYPE);
const $3b44adbb66991c12$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $3b44adbb66991c12$var$storyPointsFieldPredicate = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $3b44adbb66991c12$var$sprintFieldPredicate = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $3b44adbb66991c12$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
    const payload = {
        defaultValues: {
            singleLineTextFields: [],
            singleSelectUserPickerFields: [],
            numberFields: [],
            datePickerFields: []
        },
        project: {
            projectId: createInput.projectId
        }
    };
    const additionalFields = {};
    let transition;
    if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
        fieldId: (0, $lO4Or.SUMMARY_TYPE),
        text: createInput.summary
    });
    if (createInput.issueType) payload.issueType = {
        issueTypeId: createInput.issueType.id
    };
    if (createInput.dueDate && getField(createInput.issueType, $3b44adbb66991c12$var$dueDateFieldPredicate)) {
        const formattedDueDate = (0, $6x1NF.default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: (0, $lO4Or.DUE_DATE_TYPE),
            date: {
                formattedDate: formattedDueDate
            }
        });
        additionalFields.duedate = formattedDueDate;
    }
    const startDateField = getField(createInput.issueType, $3b44adbb66991c12$var$startDateFieldPredicate);
    if (createInput.startDate && startDateField) {
        const formattedStartDate = (0, $6x1NF.default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
        payload.defaultValues.datePickerFields.push({
            fieldId: startDateField.id,
            date: {
                formattedDate: formattedStartDate
            }
        });
        additionalFields[startDateField.id] = formattedStartDate;
    }
    if (createInput.assignee && getField(createInput.issueType, $3b44adbb66991c12$var$assigneeFieldPredicate)) {
        payload.defaultValues.singleSelectUserPickerFields.push({
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            user: {
                accountId: createInput.assignee.accountId
            }
        });
        additionalFields[0, $lO4Or.ASSIGNEE_TYPE] = {
            id: createInput.assignee.accountId
        };
    }
    if (createInput.priority && getField(createInput.issueType, $3b44adbb66991c12$var$priorityFieldPredicate)) {
        payload.defaultValues.priority = {
            priorityId: createInput.priority.priorityId
        };
        additionalFields[0, $lO4Or.PRIORITY_TYPE] = {
            id: createInput.priority.priorityId
        };
    }
    const categoryField = getField(createInput.issueType, $3b44adbb66991c12$var$categoryFieldPredicate);
    if (createInput.category && categoryField) {
        payload.defaultValues.singleSelectFields = [
            {
                fieldId: categoryField.id,
                option: {
                    id: createInput.category.optionId,
                    optionId: createInput.category.optionId
                }
            }
        ];
        additionalFields[categoryField.id] = {
            id: createInput.category.optionId,
            value: createInput.category.value
        };
    }
    const storyPointEstimateField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointEstimateFieldPredicate);
    if (createInput.storyPointEstimate && storyPointEstimateField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        });
        additionalFields[storyPointEstimateField.id] = {
            id: storyPointEstimateField.id,
            value: createInput.storyPointEstimate
        };
    }
    const storyPointsField = getField(createInput.issueType, $3b44adbb66991c12$var$storyPointsFieldPredicate);
    if (createInput.storyPoints && storyPointsField) {
        payload.defaultValues.numberFields.push({
            fieldId: storyPointsField.id,
            value: createInput.storyPoints
        });
        additionalFields[storyPointsField.id] = {
            id: storyPointsField.id,
            value: createInput.storyPoints
        };
    }
    const sprintField = getField(createInput.issueType, $3b44adbb66991c12$var$sprintFieldPredicate);
    if (createInput.sprint && sprintField) {
        payload.defaultValues.sprintsField = {
            fieldId: sprintField.id,
            sprints: [
                {
                    sprintId: createInput.sprint.id
                }
            ]
        };
        additionalFields[sprintField.id] = {
            id: sprintField.id,
            value: createInput.sprint.id
        };
    }
    if (createInput.parentIssueId) {
        payload.parentId = {
            parentId: createInput.parentIssueId
        };
        payload.defaultValues.parentField = {
            issueId: createInput.parentIssueId
        };
    }
    if (createInput.status && extraPayload?.transitionId) {
        payload.status = {
            statusId: createInput.status.statusId
        };
        transition = {
            id: extraPayload.transitionId
        };
    }
    if (rankField && (createInput.rankAfter || createInput.rankBefore)) // rank is always passed as additional field
    additionalFields[rankField.id] = {
        ...createInput.rankAfter ? {
            rankAfterIssue: createInput.rankAfter.issueId
        } : {},
        ...createInput.rankBefore ? {
            rankBeforeIssue: createInput.rankBefore.issueId
        } : {}
    };
    return {
        payload: payload,
        submitApiData: {
            additionalFields: additionalFields,
            transition: transition
        }
    };
};

});


parcelRegister("fOAem", function(module, exports) {

$parcel$export(module.exports, "useShowCreateSuccessFlag", () => $96a3689a6bc73ef9$export$dfe953d11a91d407);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $jb0p7 = parcelRequire("jb0p7");
const $96a3689a6bc73ef9$export$dfe953d11a91d407 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    return (0, $eUqFw.useCallback)((issueKey)=>{
        const flagId = `jwm-create-success-flag-${issueKey}`;
        showFlag({
            id: flagId,
            isAutoDismiss: true,
            type: 'success',
            title: formatMessage((0, $jb0p7.default).createSuccessFlagTitle, {
                issueKey: issueKey
            }),
            actions: [
                {
                    content: (0, $jb0p7.default).viewIssueLinkText,
                    href: `/browse/${issueKey}`,
                    onClick: (event)=>{
                        if (event && !(0, $hIxFu.isModifiedEvent)(event)) {
                            setSelectedIssueKey(issueKey);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        dismissFlag,
        formatMessage,
        setSelectedIssueKey,
        showFlag
    ]);
};

});
parcelRegister("hIxFu", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $b3eda05a90faeae0$export$642c6f14f6d4bbd5);
const $b3eda05a90faeae0$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

});

parcelRegister("jb0p7", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d4475055050609$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $82d4475055050609$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    viewIssueLinkText: {
        "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
        "defaultMessage": "View issue"
    }
});

});


parcelRegister("9Y2JR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd43750acdd7824c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd43750acdd7824c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "business-issue-create.controllers.create-issue.error-flag-title-non-final",
        "defaultMessage": "We weren't able to create an issue"
    },
    errorFlagDescriptionNonFinal: {
        "id": "business-issue-create.controllers.create-issue.error-flag-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    }
});

});


parcelRegister("frfm9", function(module, exports) {

$parcel$export(module.exports, "useCreateParamHandler", () => $6b54e991d48bd90a$export$294bf5b0ba86140);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $kJlBc = parcelRequire("kJlBc");

var $auegK = parcelRequire("auegK");
const $6b54e991d48bd90a$export$294bf5b0ba86140 = ()=>{
    const [inlineCreateParam, setInlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const showCreateIssueDialog = (0, $auegK.useCreateIssueDialog)();
    const project = (0, $kQAZu.useProject)();
    (0, $eUqFw.useEffect)(()=>{
        if (inlineCreateParam != null) {
            showCreateIssueDialog({
                projectId: String(project.id)
            }).catch(()=>{
            // we don't care about the error in this scenario
            });
            setInlineCreateParam(undefined);
        }
    }, [
        inlineCreateParam,
        project,
        setInlineCreateParam,
        showCreateIssueDialog
    ]);
};

});


parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    window.location.assign(url);
    return null;
};

});


parcelRegister("jasPp", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $f166a39fad510ca7$export$124b2dc1d1aab5e6);

var $eUqFw = parcelRequire("eUqFw");

var $4X5wI = parcelRequire("4X5wI");
class $f166a39fad510ca7$export$124b2dc1d1aab5e6 extends (0, $eUqFw.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $4X5wI.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args);
        this.state = {
            caughtError: null
        };
    }
}

});
parcelRegister("4X5wI", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5);
class $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


parcelRegister("gbsaq", function(module, exports) {

$parcel$export(module.exports, "LIST_PADDING_LEFT", () => $c42804ad4b83a228$export$a473358fe9122073);
$parcel$export(module.exports, "LIST_ROW", () => $c42804ad4b83a228$export$beca668e8640bfff);
$parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", () => $c42804ad4b83a228$export$258441c8a79bb589);
$parcel$export(module.exports, "ROW_KEY", () => $c42804ad4b83a228$export$1c6db1a0937ef0bd);
$parcel$export(module.exports, "SELECT_ROW_COLUMN_WIDTH", () => $c42804ad4b83a228$export$c9c106422318b1d6);
$parcel$export(module.exports, "TYPE_CELL_LEFT_PADDING", () => $c42804ad4b83a228$export$1911356e2f572e);
$parcel$export(module.exports, "EXPAND_ICON_INDENT_WIDTH", () => $c42804ad4b83a228$export$68438aed9d51940e);
$parcel$export(module.exports, "LIST_FIELD_POPUP_OFFSET", () => $c42804ad4b83a228$export$3e36baaa5cb0cfb5);
$parcel$export(module.exports, "DATE_LOZENGE_ID", () => $c42804ad4b83a228$export$9fcfab1f93d2a27a);
$parcel$export(module.exports, "CHILD_CREATE_BTN_WRAPPER", () => $c42804ad4b83a228$export$16bb76a118fce7b4);
$parcel$export(module.exports, "UP", () => $c42804ad4b83a228$export$b29f845fa4b57508);
$parcel$export(module.exports, "DOWN", () => $c42804ad4b83a228$export$c7c029a231f98d34);
$parcel$export(module.exports, "LEFT", () => $c42804ad4b83a228$export$f981f70d61d1405a);
$parcel$export(module.exports, "RIGHT", () => $c42804ad4b83a228$export$1cac5500365a4eb4);
$parcel$export(module.exports, "BULK_SELECT_CHECKBOX_ID", () => $c42804ad4b83a228$export$61ba93f63403a728);
$parcel$export(module.exports, "DRAG_AND_DROP_BUTTON_FOCUS_EVENT", () => $c42804ad4b83a228$export$2e64c33508f031cb);
$parcel$export(module.exports, "ACTION_DRAG_STARTED", () => $c42804ad4b83a228$export$5886ae675e1cc401);
$parcel$export(module.exports, "ACTION_DRAG_ENDED", () => $c42804ad4b83a228$export$736f74130173aad9);
$parcel$export(module.exports, "NO_ISSUE_TYPE", () => $c42804ad4b83a228$export$6a707112f448ba18);
$parcel$export(module.exports, "NO_PARENT_ISSUE_TYPE", () => $c42804ad4b83a228$export$aa7400fdf583255b);
$parcel$export(module.exports, "TOP_LEVEL_COLLECTION", () => $c42804ad4b83a228$export$e9f49e7d94ba81a7);
$parcel$export(module.exports, "BULK_DELETE_IN_PROGRESS_FLAG_ID", () => $c42804ad4b83a228$export$2537d1b6d47b8b99);
$parcel$export(module.exports, "BULK_DELETE_SUCCESS_FLAG_ID", () => $c42804ad4b83a228$export$50d12af09489a2d7);
$parcel$export(module.exports, "BULK_DELETE_FAILED_FLAG_ID", () => $c42804ad4b83a228$export$b4268ee17ddbdd7f);
$parcel$export(module.exports, "BULK_DELETE_FAILED_CLIENT_FLAG_ID", () => $c42804ad4b83a228$export$ebf578347a3066f4);
$parcel$export(module.exports, "VIEW_EXPERIENCE", () => $c42804ad4b83a228$export$4a2289be55388ee6);
$parcel$export(module.exports, "LOAD_CHILDREN_EXPERIENCE", () => $c42804ad4b83a228$export$16b872ae5b961241);
$parcel$export(module.exports, "LOAD_GROUP_ITEMS_EXPERIENCE", () => $c42804ad4b83a228$export$47da82a3abffaada);
$parcel$export(module.exports, "LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE", () => $c42804ad4b83a228$export$6c7be7d66ea2537f);
$parcel$export(module.exports, "BULK_DELETE_EXPERIENCE", () => $c42804ad4b83a228$export$435db386ec1c226);
$parcel$export(module.exports, "BULK_COPY_EXPERIENCE", () => $c42804ad4b83a228$export$dbecc95ea17b546e);
$parcel$export(module.exports, "CREATE_CATEGORY_EXPERIENCE", () => $c42804ad4b83a228$export$af494ffa4befd621);
$parcel$export(module.exports, "UPDATE_CATEGORY_EXPERIENCE", () => $c42804ad4b83a228$export$15d259507553cf76);
$parcel$export(module.exports, "DELETE_CATEGORY_EXPERIENCE", () => $c42804ad4b83a228$export$a433ff40336ab4a7);
$parcel$export(module.exports, "SUPPORTED_GROUPS_TYPES", () => $c42804ad4b83a228$export$220fd19c26dc2508);

var $lO4Or = parcelRequire("lO4Or");
const $c42804ad4b83a228$export$a473358fe9122073 = 20;
const $c42804ad4b83a228$export$beca668e8640bfff = 'listRow';
const $c42804ad4b83a228$export$258441c8a79bb589 = 40;
const $c42804ad4b83a228$export$727f6efd406ed55d = 50;
const $c42804ad4b83a228$export$1c6db1a0937ef0bd = 'rowKey';
const $c42804ad4b83a228$export$c9c106422318b1d6 = 65;
const $c42804ad4b83a228$export$1911356e2f572e = 35;
const $c42804ad4b83a228$export$68438aed9d51940e = 20;
const $c42804ad4b83a228$export$a2dd5f25b5a4e5d2 = 45;
const $c42804ad4b83a228$export$56446adcecbeec34 = {
    tableFooter: 1,
    tableShadow: 2,
    inlineFieldCreateControls: 3
};
const $c42804ad4b83a228$export$3e36baaa5cb0cfb5 = [
    0,
    -$c42804ad4b83a228$export$258441c8a79bb589
];
const $c42804ad4b83a228$export$eda9e94a9409652f = 'tag-wrapper-highlight-on-hover';
const $c42804ad4b83a228$export$9fcfab1f93d2a27a = 'list-date-lozenge';
const $c42804ad4b83a228$export$16bb76a118fce7b4 = 'child-create-btn-wrapper';
const $c42804ad4b83a228$export$b29f845fa4b57508 = 'up';
const $c42804ad4b83a228$export$c7c029a231f98d34 = 'down';
const $c42804ad4b83a228$export$f981f70d61d1405a = 'left';
const $c42804ad4b83a228$export$1cac5500365a4eb4 = 'right';
const $c42804ad4b83a228$export$61ba93f63403a728 = 'bulk-select-checkbox';
const $c42804ad4b83a228$export$2e64c33508f031cb = 'drag-and-drop-button-focus';
const $c42804ad4b83a228$export$ce523a2c42983704 = 45;
const $c42804ad4b83a228$export$5886ae675e1cc401 = 'dragStarted';
const $c42804ad4b83a228$export$736f74130173aad9 = 'dragEnded';
const $c42804ad4b83a228$export$6a707112f448ba18 = 'noIssueType';
const $c42804ad4b83a228$export$aa7400fdf583255b = 'noParentIssueType';
const $c42804ad4b83a228$export$e9f49e7d94ba81a7 = 'topLevelCollection';
const $c42804ad4b83a228$export$2537d1b6d47b8b99 = 'bulk-delete-in-progress-flag';
const $c42804ad4b83a228$export$50d12af09489a2d7 = 'bulk-delete-success-flag';
const $c42804ad4b83a228$export$b4268ee17ddbdd7f = 'bulk-delete-failed-flag';
const $c42804ad4b83a228$export$ebf578347a3066f4 = 'bulk-delete-failed-client-flag';
const $c42804ad4b83a228$export$4a2289be55388ee6 = {
    experience: 'listView',
    experienceId: 'main',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$16b872ae5b961241 = {
    experience: 'loadChildren',
    experienceId: 'children',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$47da82a3abffaada = {
    experience: 'loadGroup',
    experienceId: 'groupItems',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$6c7be7d66ea2537f = {
    experience: 'loadGroupChildren',
    experienceId: 'groupItemsChildren',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$435db386ec1c226 = {
    experience: 'bulkDelete',
    experienceId: 'bulkDelete',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$dbecc95ea17b546e = {
    experience: 'bulkCopy',
    experienceId: 'bulkCopy',
    packageName: 'jiraBusinessList',
    teamName: 'keystone'
};
const $c42804ad4b83a228$export$af494ffa4befd621 = {
    experience: 'createCategory',
    experienceId: 'createCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $c42804ad4b83a228$export$15d259507553cf76 = {
    experience: 'updateCategory',
    experienceId: 'updateCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $c42804ad4b83a228$export$a433ff40336ab4a7 = {
    experience: 'deleteCategory',
    experienceId: 'deleteCategory',
    packageName: 'jiraBusinessList',
    teamName: 'jira-warepil'
};
const $c42804ad4b83a228$export$220fd19c26dc2508 = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $lO4Or.NUMBER_CF_TYPE),
    (0, $lO4Or.SPRINT_TYPE)
];

});

parcelRegister("egJIx", function(module, exports) {

$parcel$export(module.exports, "useJWMListFeatures", () => $dd73846feb791cdd$export$1253737febad5ca9);
$parcel$export(module.exports, "ListFeaturesProvider", () => $dd73846feb791cdd$export$9b33d4a1cd64aa2c);

var $eUqFw = parcelRequire("eUqFw");
const $dd73846feb791cdd$var$defaultFeaturesContext = {
    isShareButtonEnabled: true,
    isPresenceEnabled: true,
    issueViewInteraction: 'default',
    isOnboardingEnabled: true,
    featureView: 'list',
    inviteButtonInteraction: 'default',
    typeSelectInteraction: 'default',
    hasFilterCustomFields: true,
    hasCreateSubtask: true,
    canCreateIssues: true,
    isSoftwareFieldsEnabled: false,
    isBusinessFieldsEnabled: true,
    isScrumProject: false
};
const $dd73846feb791cdd$var$ListFeaturesContext = /*#__PURE__*/ (0, $eUqFw.createContext)($dd73846feb791cdd$var$defaultFeaturesContext);
const $dd73846feb791cdd$export$1253737febad5ca9 = ()=>(0, $eUqFw.useContext)($dd73846feb791cdd$var$ListFeaturesContext);
const $dd73846feb791cdd$export$9b33d4a1cd64aa2c = ({ children: children, ...props })=>{
    const value = (0, $eUqFw.useMemo)(()=>({
            ...$dd73846feb791cdd$var$defaultFeaturesContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dd73846feb791cdd$var$ListFeaturesContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("dSE3z", function(module, exports) {

$parcel$export(module.exports, "useGroupBy", () => $2f464576ca82e79c$export$c4ec754551fa3ff4);

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");
const $2f464576ca82e79c$export$c4ec754551fa3ff4 = ()=>{
    const [groupByFieldId, setGroupBy] = (0, $7c3W1.useViewPreference)((0, $ji3xf.GROUPING_PREFERENCE));
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [
        groupByFieldId,
        setGroupBy
    ];
};

});

parcelRegister("k3EUD", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_MUTATION", () => $9c369d6aa3fa7766$export$f5c1cac020b22be4);
$parcel$export(module.exports, "ISSUE_REFETCH_QUERY", () => $9c369d6aa3fa7766$export$834c81726d4c51eb);

var $9ypom = parcelRequire("9ypom");

var $k9sa9 = parcelRequire("k9sa9");

var $jsfvR = parcelRequire("jsfvR");

var $7Pw84 = parcelRequire("7Pw84");

var $7XECd = parcelRequire("7XECd");
const $9c369d6aa3fa7766$var$CREATED_ITEM_FRAGMENT = (0, $9ypom.default)`
fragment CreatedListItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
        totalCount
    }
    commentSummary {
        totalCount
    }
    legacyConfluenceLinks(getFirstOnly: true) {
        ...ConfluenceLinksFragment
    }
    devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
        ...DevSummaryFieldFragment
    }
    ...ListViewIssueFieldsFragment
}
${(0, $7XECd.LIST_VIEW_FIELDS_FRAGMENT)}
${(0, $k9sa9.CONFLUENCE_LINKS_FRAGMENT)}
${(0, $jsfvR.JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
const $9c369d6aa3fa7766$export$f5c1cac020b22be4 = (0, $9ypom.default)`

mutation JWMListInlineCreateIssue ($input: JiraCreateIssueInput!, $fieldIds: [String]!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false,  $withParentIssueId: Boolean!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedListItemFragment
        }
        ...CreateIssueFragment
    }
}
${(0, $7Pw84.CREATE_ISSUE_FRAGMENT)}
${$9c369d6aa3fa7766$var$CREATED_ITEM_FRAGMENT}
`;
const $9c369d6aa3fa7766$export$834c81726d4c51eb = (0, $9ypom.default)`
query JWMListInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false, $withParentIssueId: Boolean!) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedListItemFragment
                    }
                }
            }
        }
    }
}
${$9c369d6aa3fa7766$var$CREATED_ITEM_FRAGMENT}
`;

});
parcelRegister("k9sa9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_LINKS_FRAGMENT", () => $560fee80a719f902$export$757a6323be066698);

var $9ypom = parcelRequire("9ypom");
const $560fee80a719f902$export$757a6323be066698 = (0, $9ypom.default)`
    fragment ConfluenceLinksFragment on ConfluenceLinks {    
            linkedConfluencePages {
                pageCount
                pages {
                    ... on ConfluencePage {
                        id
                        globalId
                        href
                        title
                        type
                        lastUpdatedContext {
                            user {
                                key
                                accountId
                                emailAddress
                                avatarUrl
                                displayName
                                active
                            }
                        }
                    }
                    ... on FailedRemoteLink {
                        id
                        error
                        link {
                            id
                            globalId
                            href
                        }
                        repairLink {
                            href
                        }
                    }
                }
            }
    }
`;

});

parcelRegister("jsfvR", function(module, exports) {

$parcel$export(module.exports, "JIRA_BUSINESS_FIELDS_FRAGMENT", () => $c67038b8aa4bb6f6$export$16a4e56fe7b29670);
$parcel$export(module.exports, "JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT", () => $c67038b8aa4bb6f6$export$8a6df2ce60bca6f1);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $knKYk = parcelRequire("knKYk");

var $12K5u = parcelRequire("12K5u");

var $619OD = parcelRequire("619OD");

var $7FAgb = parcelRequire("7FAgb");

var $eO5bL = parcelRequire("eO5bL");

var $6abst = parcelRequire("6abst");

var $7iWRP = parcelRequire("7iWRP");

var $8taGk = parcelRequire("8taGk");

var $jE8oD = parcelRequire("jE8oD");

var $dwTBA = parcelRequire("dwTBA");

var $dOZkn = parcelRequire("dOZkn");

var $cDFYl = parcelRequire("cDFYl");

var $edYOM = parcelRequire("edYOM");

var $l6gH4 = parcelRequire("l6gH4");

var $7Agtp = parcelRequire("7Agtp");

var $kpAWV = parcelRequire("kpAWV");

var $hNOMn = parcelRequire("hNOMn");

var $6YPjW = parcelRequire("6YPjW");

var $7V4Du = parcelRequire("7V4Du");

var $dfvNy = parcelRequire("dfvNy");

var $jy6Ks = parcelRequire("jy6Ks");
const $c67038b8aa4bb6f6$export$16a4e56fe7b29670 = (0, $9ypom.default)`
	${(0, $dwTBA.PARENT_FRAGMENT)}
	${(0, $jy6Ks.VERSION_FRAGMENT)}
	${(0, $hNOMn.TEAM_FRAGMENT)}
	${(0, $eO5bL.GOALS_FRAGMENT)}
	${(0, $l6gH4.RESOLUTION_FRAGMENT)}
	${(0, $6abst.GROUP_FRAGMENT)}
	${(0, $7iWRP.LABELS_FRAGMENT)}
	${(0, $12K5u.DATE_FRAGMENT)}
	${(0, $619OD.DATE_TIME_FRAGMENT)}
	${(0, $dfvNy.ATLASSIAN_ACCOUNT_FRAGMENT)}
	${(0, $dfvNy.USER_FRAGMENT)}
	${(0, $dfvNy.PEOPLE_FRAGMENT)}
	${(0, $dfvNy.MULTIPLE_USER_FRAGMENT)}
	${(0, $dOZkn.PRIORITY_FRAGMENT)}
	${(0, $8taGk.MULTIPLE_SELECT_FRAGMENT)}
	${(0, $jE8oD.NUMBER_FRAGMENT)}
	${(0, $edYOM.RADIO_SELECT_FRAGMENT)}
	${(0, $7Agtp.SINGLE_SELECT_FRAGMENT)}
	${(0, $7V4Du.URL_FRAGMENT)}
	${(0, $6YPjW.SINGLE_LINE_TEXT_FRAGMENT)}
	${(0, $kpAWV.STATUS_CATEGORY_FRAGMENT)}
	${(0, $knKYk.CASCADING_SELECT_FRAGMENT)}
	${(0, $cDFYl.PROJECT_FRAGMENT)}
`;
const $c67038b8aa4bb6f6$export$8a6df2ce60bca6f1 = (0, $9ypom.default)`
	${(0, $7FAgb.DEV_SUMMARY_FRAGMENT)}
`;

});
parcelRegister("knKYk", function(module, exports) {

$parcel$export(module.exports, "CASCADING_SELECT_FRAGMENT", () => $1dee1f780cc92072$export$88d11aac85f3a5f2);

var $9ypom = parcelRequire("9ypom");
const $1dee1f780cc92072$export$88d11aac85f3a5f2 = (0, $9ypom.default)`
    fragment jiraCascadingSelectFieldFragment on JiraCascadingSelectField {
        id
        fieldId
        fieldConfig {
            isEditable
        }
        cascadingOption {
            parentValue {
                id
                isDisabled
                value
            }
            childOptionValue {
                id
                optionId
                isDisabled
                value
            }
        }
    } 
`;

});

parcelRegister("12K5u", function(module, exports) {

$parcel$export(module.exports, "DATE_FRAGMENT", () => $e27c61cf85fc05d7$export$f8e1b8104aa9273f);

var $9ypom = parcelRequire("9ypom");
const $e27c61cf85fc05d7$export$f8e1b8104aa9273f = (0, $9ypom.default)`
    fragment jiraDateFieldFragment on JiraDatePickerField {
        date
    } 
`;

});

parcelRegister("619OD", function(module, exports) {

$parcel$export(module.exports, "DATE_TIME_FRAGMENT", () => $5bbad55334412b6a$export$f5c7c2e5cce27d00);

var $9ypom = parcelRequire("9ypom");
const $5bbad55334412b6a$export$f5c7c2e5cce27d00 = (0, $9ypom.default)`
    fragment jiraDateTimeFieldFragment on JiraDateTimePickerField {
        dateTime
    } 
`;

});

parcelRegister("7FAgb", function(module, exports) {

$parcel$export(module.exports, "DEV_SUMMARY_FRAGMENT", () => $1822f106238a6d70$export$a5751f0d2763fac3);

var $9ypom = parcelRequire("9ypom");
const $1822f106238a6d70$export$a5751f0d2763fac3 = (0, $9ypom.default)`
    fragment DevSummaryFieldFragment on JiraIssueDevSummaryResult {
        devSummary {
            commit {
                overall {
                    count
                }
            }
            pullrequest {
                overall {
                    state
                    count
                }
            }
        }
    } 
`;

});

parcelRegister("eO5bL", function(module, exports) {

$parcel$export(module.exports, "GOALS_FRAGMENT", () => $7c48f16fc92b4b75$export$14859f852d0eecb4);

var $9ypom = parcelRequire("9ypom");
const $7c48f16fc92b4b75$export$14859f852d0eecb4 = (0, $9ypom.default)`
    fragment JiraGoalsFieldFragment on JiraGoalsField {
        __typename
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedGoals(first: 1) {
            totalCount,
            edges {
                node {
                    id
                    name
                    status
                }
            }
        }
    }
`;

});

parcelRegister("6abst", function(module, exports) {

$parcel$export(module.exports, "GROUP_FRAGMENT", () => $dc896979b0c4b14e$export$91c2ad2e63414b50);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $9ypom = parcelRequire("9ypom");
const $dc896979b0c4b14e$export$99b0877e6d0a4712 = (0, $9ypom.default)`
    fragment jiraBusinessSingleGroupFieldFragment on JiraSingleGroupPickerField {
      __typename
      id
      fieldId
      name
      selectedGroup {
        groupId
        name
      }
    }
`;
const $dc896979b0c4b14e$export$27846949a41c873f = (0, $9ypom.default)`
    fragment jiraBusinessMultipleGroupFieldFragment on JiraMultipleGroupPickerField {
      __typename
      id
      fieldId
      name
      selectedGroupsConnection {
        edges {
          node {
            groupId
            name
          }
        }
      }
    }
`;
const $dc896979b0c4b14e$export$91c2ad2e63414b50 = (0, $9ypom.default)`
	${$dc896979b0c4b14e$export$27846949a41c873f}
	${$dc896979b0c4b14e$export$99b0877e6d0a4712}
`;

});

parcelRegister("7iWRP", function(module, exports) {

$parcel$export(module.exports, "LABELS_FRAGMENT", () => $da845276456d17d3$export$30f9416168d64de4);

var $9ypom = parcelRequire("9ypom");
const $da845276456d17d3$export$30f9416168d64de4 = (0, $9ypom.default)`
    fragment jiraLabelsFieldFragment on JiraLabelsField {
        selectedLabelsConnection {
            edges {
                node {
                    name
                }
            }
        }
    } 
`;

});

parcelRegister("8taGk", function(module, exports) {

$parcel$export(module.exports, "MULTIPLE_SELECT_FRAGMENT", () => $dbe24feb054829bd$export$ed658c6a0e11bdf9);

var $9ypom = parcelRequire("9ypom");
const $dbe24feb054829bd$export$ed658c6a0e11bdf9 = (0, $9ypom.default)`
    fragment jiraMultipleSelectFieldFragment on JiraMultipleSelectField {
        fieldConfig {
            isEditable
          }
        selectedOptions {
            edges {
                node {
                    optionId
                    value
                }
            }
        }
    }
`;

});

parcelRegister("jE8oD", function(module, exports) {

$parcel$export(module.exports, "NUMBER_FRAGMENT", () => $618c56cda47ac49c$export$c1b90ff48aa1e878);

var $9ypom = parcelRequire("9ypom");
const $618c56cda47ac49c$export$c1b90ff48aa1e878 = (0, $9ypom.default)`
    fragment jiraNumberFieldFragment on JiraNumberField {
        number
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("dwTBA", function(module, exports) {

$parcel$export(module.exports, "PARENT_FRAGMENT", () => $72420efef97913c5$export$1efcd2a93f28f76e);

var $9ypom = parcelRequire("9ypom");
const $72420efef97913c5$export$1efcd2a93f28f76e = (0, $9ypom.default)`
    fragment jiraBusinessParentFieldFragment on JiraParentIssueField {
        fieldId
        parentIssue {
            id @include(if: $withParentIssueId)
            issueId
            key
            rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") @include(if: $withParentRank) {
                aliasFieldId
                ... on JiraSingleLineTextField {
                    text
                }
            }
            fields: fieldsByIdOrAlias(idsOrAliases: ["summary", "issuetype", "issuecolor", "status"], ignoreMissingFields: true) @connection (key: "parentFields") @include(if: $isParentFieldVisible) {
                fieldId
                name
                aliasFieldId
                type
                ... on JiraColorField {
                    color {
                        colorKey
                    }
                }
                ... on JiraSingleLineTextField {
                    text
                }
                ... on JiraStatusField {
                    status {
                        name
                        statusCategory {
                            statusCategoryId
                        }
                    }
                }
                ... on JiraIssueTypeField {
                    issueType {
                        name
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
`;

});

parcelRegister("dOZkn", function(module, exports) {

$parcel$export(module.exports, "PRIORITY_FRAGMENT", () => $b70122d1523a6883$export$6d5f71aa3bbf9a14);

var $9ypom = parcelRequire("9ypom");
const $b70122d1523a6883$export$6d5f71aa3bbf9a14 = (0, $9ypom.default)`
    fragment jiraPriorityFieldFragment on JiraPriorityField {
        priority {
            id
            name
            priorityId
            iconUrl
        }
    }
`;

});

parcelRegister("cDFYl", function(module, exports) {

$parcel$export(module.exports, "PROJECT_FRAGMENT", () => $a4a2cba79cefd910$export$e365122194197244);

var $9ypom = parcelRequire("9ypom");
const $a4a2cba79cefd910$export$e365122194197244 = (0, $9ypom.default)`
    fragment jiraProjectFieldFragment on JiraProjectField {
        fieldId
        name
        project {
            id
            name
            key
            avatar {
                large
            }
        }
    }
`;

});

parcelRegister("edYOM", function(module, exports) {

$parcel$export(module.exports, "RADIO_SELECT_FRAGMENT", () => $9011f1a76bb1c7c7$export$55296ac87efdd2c2);

var $9ypom = parcelRequire("9ypom");
const $9011f1a76bb1c7c7$export$55296ac87efdd2c2 = (0, $9ypom.default)`
    fragment jiraRadioSelectFieldFragment on JiraRadioSelectField {
        fieldId
        name
        fieldConfig {
            isEditable
        }
        selectedOption {
            optionId
            value
        }
    }
`;

});

parcelRegister("l6gH4", function(module, exports) {

$parcel$export(module.exports, "RESOLUTION_FRAGMENT", () => $95c5771aabe2f2bb$export$e8f52599fbfc8f74);

var $9ypom = parcelRequire("9ypom");
const $95c5771aabe2f2bb$export$e8f52599fbfc8f74 = (0, $9ypom.default)`
    fragment jiraBusinessResolutionFieldFragment on JiraResolutionField {
        fieldId
        name
        resolution {
            id
            name
        }
    } 
`;

});

parcelRegister("7Agtp", function(module, exports) {

$parcel$export(module.exports, "SINGLE_SELECT_FRAGMENT", () => $60efd2c7e32ed4cb$export$f1c5cfc4b5de6700);

var $9ypom = parcelRequire("9ypom");
const $60efd2c7e32ed4cb$export$f1c5cfc4b5de6700 = (0, $9ypom.default)`
    fragment jiraSingleSelectFragment on JiraSingleSelectField {
        fieldConfig {
            isEditable
        }
        fieldOption {
            optionId
            value
            color {
                colorKey
            }
        }
    }
`;

});

parcelRegister("kpAWV", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_FRAGMENT", () => $3d33e6ad79841c36$export$a125a2d730e3d413);

var $9ypom = parcelRequire("9ypom");
const $3d33e6ad79841c36$export$a125a2d730e3d413 = (0, $9ypom.default)`
    fragment jiraStatusCategoryFragment on JiraStatusCategoryField {
        fieldId
        fieldConfig {
          isEditable
        }
        statusCategory {
          id
          statusCategoryId
          name
        }
    }
`;

});

parcelRegister("hNOMn", function(module, exports) {

$parcel$export(module.exports, "TEAM_FRAGMENT", () => $b3ffb5d31d5f4342$export$b8a1e15b67d0c801);

var $9ypom = parcelRequire("9ypom");
const $b3ffb5d31d5f4342$export$b8a1e15b67d0c801 = (0, $9ypom.default)`
    fragment jiraBusinessTeamFieldFragment on JiraTeamViewField {
        fieldId
        selectedTeam {
            jiraSuppliedName
            jiraSuppliedTeamId
        }
    } 
`;

});

parcelRegister("6YPjW", function(module, exports) {

$parcel$export(module.exports, "SINGLE_LINE_TEXT_FRAGMENT", () => $fe7b71abea61f99e$export$23113309bffe00ca);

var $9ypom = parcelRequire("9ypom");
const $fe7b71abea61f99e$export$23113309bffe00ca = (0, $9ypom.default)`
    fragment jiraSingleLineTextFragment on JiraSingleLineTextField {
        text
    }
`;

});

parcelRegister("7V4Du", function(module, exports) {

$parcel$export(module.exports, "URL_FRAGMENT", () => $f3ec340ded916e2c$export$7044ea8d89b6f59d);

var $9ypom = parcelRequire("9ypom");
const $f3ec340ded916e2c$export$7044ea8d89b6f59d = (0, $9ypom.default)`
    fragment jiraUrlFieldFragment on JiraUrlField {
        uri
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("dfvNy", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT_FRAGMENT", () => $42c19ca4b42d5a18$export$7620e2c63d440c49);
$parcel$export(module.exports, "USER_FRAGMENT", () => $42c19ca4b42d5a18$export$6496fa362c67d06e);
$parcel$export(module.exports, "PEOPLE_FRAGMENT", () => $42c19ca4b42d5a18$export$49438f3cf8087021);
$parcel$export(module.exports, "MULTIPLE_USER_FRAGMENT", () => $42c19ca4b42d5a18$export$5267cb871f0541c9);

var $9ypom = parcelRequire("9ypom");
const $42c19ca4b42d5a18$export$7620e2c63d440c49 = (0, $9ypom.default)`
  fragment AtlassianAccountFragment on AtlassianAccountUser {
    accountId
    accountStatus
    picture
    name
  }
`;
const $42c19ca4b42d5a18$export$6496fa362c67d06e = (0, $9ypom.default)`
    fragment jiraSingleUserFieldFragment on JiraSingleSelectUserPickerField {
        user {
            ...AtlassianAccountFragment
        }
        fieldConfig {
            isEditable
        }
    }
`;
const $42c19ca4b42d5a18$export$49438f3cf8087021 = (0, $9ypom.default)`
    fragment jiraPeopleFieldFragment on JiraPeopleField {
        fieldConfig {
          isEditable
        }
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
    }
`;
const $42c19ca4b42d5a18$export$5267cb871f0541c9 = (0, $9ypom.default)`
    fragment jiraMultipleUserFieldFragment on JiraMultipleSelectUserPickerField {
        selectedUsersConnection {
          edges {
            node {
              ...AtlassianAccountFragment
            }
          }
        }
        fieldConfig {
          isEditable
        }
    }
`;

});

parcelRegister("jy6Ks", function(module, exports) {

$parcel$export(module.exports, "VERSION_FRAGMENT", () => $1edd726b01aafa2b$export$6f6bf5d27acb96a6);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $9ypom = parcelRequire("9ypom");
const $1edd726b01aafa2b$export$4320515340a845c0 = (0, $9ypom.default)`
    fragment jiraBusinessSingleVersionFieldFragment on JiraSingleVersionPickerField {
      __typename
      id
      fieldId
      name
      version {
        versionId
        name
      }
    }
`;
const $1edd726b01aafa2b$export$b336fe1ccb7b1f67 = (0, $9ypom.default)`
    fragment jiraBusinessMultipleVersionFieldFragment on JiraMultipleVersionPickerField {
      __typename
      id
      fieldId
      name
      selectedVersionsConnection {
        edges {
          node {
            versionId
            name
          }
        }
      }
    }
`;
const $1edd726b01aafa2b$export$6f6bf5d27acb96a6 = (0, $9ypom.default)`
	${$1edd726b01aafa2b$export$b336fe1ccb7b1f67}
	${$1edd726b01aafa2b$export$4320515340a845c0}
`;

});


parcelRegister("7Pw84", function(module, exports) {

$parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", () => $33f8e9ac12479c3a$export$47232071d0e9dfb);

var $9ypom = parcelRequire("9ypom");
const $33f8e9ac12479c3a$export$47232071d0e9dfb = (0, $9ypom.default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;

});

parcelRegister("7XECd", function(module, exports) {

$parcel$export(module.exports, "LIST_VIEW_FIELDS_FRAGMENT", () => $fbac42598b9ed86c$export$878eea3ba159096b);
$parcel$export(module.exports, "LIST_VIEW_QUERY", () => $fbac42598b9ed86c$export$bf9c5668f03a036d);
$parcel$export(module.exports, "BACKGROUND_LIST_VIEW_QUERY", () => $fbac42598b9ed86c$export$b0ac16e8fe90de24);
$parcel$export(module.exports, "LIST_VIEW_ITEM_DETAILS_QUERY", () => $fbac42598b9ed86c$export$3f338783432a1617);
$parcel$export(module.exports, "LIST_VIEW_ITEMS_QUERY_BULK", () => $fbac42598b9ed86c$export$bad4ee6da81533c5);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $9ypom = parcelRequire("9ypom");

var $k9sa9 = parcelRequire("k9sa9");

var $jsfvR = parcelRequire("jsfvR");
const $fbac42598b9ed86c$export$878eea3ba159096b = (0, $9ypom.default)`
  fragment ListViewIssueFieldsFragment on JiraWorkManagementViewItem {
    fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
      fieldId
      name
      aliasFieldId
      type
      ... on JiraIssueTypeField {
        issueType {
          issueTypeId
          name
          avatar {
            medium
          }
          hierarchy {
            level
          }
        }
      }
      ... on JiraStatusField {
        status {
          name
          statusId
          statusCategory {
            statusCategoryId
          }
        }
      }
      ... on JiraRichTextField {
        richText {
          adfValue {
            json
            convertedPlainText {
              plainText
              isTruncated
            }
          }
        }
        renderer
      }
      ... on JiraOriginalTimeEstimateField {
        originalEstimate {
          timeInSeconds
        }
        fieldConfig {
          isEditable
        }
      }
      ... on JiraTimeTrackingField {
        originalEstimate {
          timeInSeconds
        }
        timeTrackingSettings {
          defaultUnit
          defaultFormat
          workingHoursPerDay
          workingDaysPerWeek
        }
      }
      ... on JiraComponentsField {
        fieldConfig {
          isEditable
        }
        selectedComponentsConnection {
          edges {
            node {
              name
              componentId
            }
          }
        }
      }
      ... on JiraParentIssueField {
        parentIssue {
          issueId
          key
        }
      }
     ... on JiraCheckboxesField {
        selectedOptions {
          edges {
            node {
              optionId
              value
            }
          }
        }
      }
      ... on JiraSprintField {
        fieldId
        aliasFieldId
        fieldConfig {
          isEditable
        }
        selectedSprintsConnection(first: 1) {
          edges {
            node {
              sprintId
              name
              state
            }
          }
        }
      }
      ...jiraBusinessSingleVersionFieldFragment
      ...jiraBusinessMultipleVersionFieldFragment
      ...jiraBusinessParentFieldFragment
      ...jiraBusinessTeamFieldFragment
      ...JiraGoalsFieldFragment
      ...jiraBusinessResolutionFieldFragment
      ...jiraBusinessSingleGroupFieldFragment
      ...jiraBusinessMultipleGroupFieldFragment
      ...jiraLabelsFieldFragment
      ...jiraDateFieldFragment
      ...jiraDateTimeFieldFragment
      ...jiraSingleUserFieldFragment
      ...jiraMultipleUserFieldFragment
      ...jiraPeopleFieldFragment
      ...jiraPriorityFieldFragment
      ...jiraMultipleSelectFieldFragment
      ...jiraNumberFieldFragment
      ...jiraRadioSelectFieldFragment
      ...jiraSingleSelectFragment
      ...jiraUrlFieldFragment
      ...jiraSingleLineTextFragment
      ...jiraStatusCategoryFragment
      ...jiraCascadingSelectFieldFragment
      ...jiraProjectFieldFragment
    }
  }

  ${(0, $jsfvR.JIRA_BUSINESS_FIELDS_FRAGMENT)}
`;
const $fbac42598b9ed86c$export$5f151982dc1bb93c = (0, $9ypom.default)`
  fragment ListViewItemEdges on JiraWorkManagementViewItemConnection {
    edges {
      node {
        id
        issueId
        childSummary(includeDone: $includeDoneItems) {
            hasChildren
            totalCount
        }
        commentSummary {
            totalCount
        }
        legacyConfluenceLinks(getFirstOnly: true) @include(if: $withConfluenceLinks) @connection(key: "legacyConfluenceLinks") {
            ...ConfluenceLinksFragment
        }
        devSummaryCache @include(if: $isDevSummaryFieldVisible)  {
          ...DevSummaryFieldFragment
        }
        ...ListViewIssueFieldsFragment
      }
    }
  }
  ${$fbac42598b9ed86c$export$878eea3ba159096b}
  ${(0, $k9sa9.CONFLUENCE_LINKS_FRAGMENT)}
  ${(0, $jsfvR.JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT)}
`;
const $fbac42598b9ed86c$export$bf9c5668f03a036d = (0, $9ypom.default)`
  query JWMListViewItems($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false,  $withParentIssueId: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "list", filter:["jql"]) {
        ...on QueryError {
          message
          extensions {
            statusCode
            errorType
          }
        }
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;
const $fbac42598b9ed86c$export$b0ac16e8fe90de24 = (0, $9ypom.default)`
  query JWMListViewItemsBackground($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false,  $withParentIssueId: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) @connection (key: "backgroundList", filter:["jql"]) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }

  ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;
const $fbac42598b9ed86c$export$3f338783432a1617 = (0, $9ypom.default)`
  query JWMListViewItemDetails($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false, $withParentIssueId: Boolean!) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        ... on JiraWorkManagementViewItemConnection {
          ...ListViewItemEdges
        }
      }
    }
  }

  ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;
const $fbac42598b9ed86c$var$getListQueryAlias = (issueId)=>`issue${issueId}: jwmViewItems(
  cloudId: $cloudId,
  jql: $jql${issueId},
  first: $first,
  after: $after
  ) @connection (key: "list", filter:["jql"]) {
      ... on JiraWorkManagementViewItemConnection {
        ...ListViewItemEdges
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `;
const $fbac42598b9ed86c$export$bad4ee6da81533c5 = (issueIds)=>(0, $9ypom.default)`
    query JWMListViewItemsBulk (${issueIds.map((issueId)=>`$jql${issueId}: String!, `).join('')}$includeDoneItems: Boolean!, $cloudId: ID!, $fieldIds: [String]!, $first: Int, $after: String, $withConfluenceLinks: Boolean!, $isParentFieldVisible: Boolean!, $isDevSummaryFieldVisible: Boolean!, $withParentRank: Boolean = false,  $withParentIssueId: Boolean!) {
        jira {
          ${issueIds.map($fbac42598b9ed86c$var$getListQueryAlias).join('\n')}
        }
    }

    ${$fbac42598b9ed86c$export$5f151982dc1bb93c}
`;

});


parcelRegister("aPQfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f397652852d3db1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hJYsP = parcelRequire("hJYsP");

var $4G5xU = parcelRequire("4G5xU");

var $41WOo = parcelRequire("41WOo");

var $lGxgz = parcelRequire("lGxgz");
var $96etS = parcelRequire("96etS");
var $iaCjO = parcelRequire("iaCjO");

var $d3C6e = parcelRequire("d3C6e");

var $kHnEs = parcelRequire("kHnEs");
var $9u6Jh = parcelRequire("9u6Jh");

var $5I9Im = parcelRequire("5I9Im");

var $e3dJ4 = parcelRequire("e3dJ4");

var $hIxFu = parcelRequire("hIxFu");

var $422sV = parcelRequire("422sV");

var $6HWvN = parcelRequire("6HWvN");


var $gVPP8 = parcelRequire("gVPP8");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");

var $jK1pm = parcelRequire("jK1pm");

var $84CBi = parcelRequire("84CBi");

var $fa2D3 = parcelRequire("fa2D3");

var $gbsaq = parcelRequire("gbsaq");

var $jwBHm = parcelRequire("jwBHm");

var $aDWue = parcelRequire("aDWue");

var $hotly = parcelRequire("hotly");

var $cGmOd = parcelRequire("cGmOd");

var $egJIx = parcelRequire("egJIx");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $6IRtV = parcelRequire("6IRtV");

var $h8g5T = parcelRequire("h8g5T");
var $5r9Wo = parcelRequire("5r9Wo");

var $aqGaJ = parcelRequire("aqGaJ");

var $lCzHy = parcelRequire("lCzHy");

var $5jA3I = parcelRequire("5jA3I");

var $eicDW = parcelRequire("eicDW");

var $e3maP = parcelRequire("e3maP");

var $8axyj = parcelRequire("8axyj");

var $aUash = parcelRequire("aUash");

var $bR4Tm = parcelRequire("bR4Tm");

var $56s5R = parcelRequire("56s5R");
var $bxcZe = parcelRequire("bxcZe");

var $5NSnR = parcelRequire("5NSnR");

var $1lhPF = parcelRequire("1lhPF");

var $fuaUK = parcelRequire("fuaUK");

var $aiXUL = parcelRequire("aiXUL");

var $4PNxf = parcelRequire("4PNxf");

var $6lgzJ = parcelRequire("6lgzJ");

var $1ukK3 = parcelRequire("1ukK3");

var $dSlaZ = parcelRequire("dSlaZ");

var $dcGUq = parcelRequire("dcGUq");
const $4f397652852d3db1$var$FOOTER_HEIGHT = 45;
const $4f397652852d3db1$var$ROW_HEIGHT = 40;
const $4f397652852d3db1$var$ON_END_REACHED_THRESHOLD = 300;
// passing in empty componentName so that we can define action name from analytics events
const $4f397652852d3db1$var$BaseTableWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('', {
    onResize: 'resized'
})((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56s5R.default), props));
const $4f397652852d3db1$var$ListContent = ({ projectId: projectId, projectKey: projectKey, projectName: projectName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const interactionMetrics = (0, $jwBHm.useInteractionMetrics)();
    const [columnWidths, { setColumnWidth: setColumnWidth }] = (0, $cGmOd.useColumnWidths)();
    const [{ issuesMap: issuesMap, hierarchyData: { loading: loading, error: error } }] = (0, $5r9Wo.useHierarchyStore)();
    const viewMode = (0, $hJ992.useViewMode)();
    const isViewModeSideBar = viewMode === (0, $935e771f19f8ea28$export$705305d6da432040);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isFiltering: isFiltering } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    // Remove after clean up of jsw_list_view_-_all_the_fields
    const [selectedIssueKey, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const showReparentModal = (0, $e3maP.useShouldShowReparentModal)();
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.VIEW_EXPERIENCE), {
        loading: loading,
        error: error
    });
    const [{ sortBy: sortBy }] = (0, $iaCjO.useSorting)();
    const isSorting = sortBy != null;
    const { isOnboardingEnabled: isOnboardingEnabled, featureView: featureView, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    (0, $8axyj.useTableAnalytics)();
    const ufoPressTracing = (0, $fa2D3.default)('jwm.list.issue-view-opened');
    // Remove after clean up of jsw_list_view_-_all_the_fields
    let openIssueModal = (issue)=>(event)=>{
            if (issue.id && !(0, $d3C6e.isOptimisticIssue)(Number(issue.id)) && issue.key) {
                if (!(0, $hIxFu.isModifiedEvent)(event)) {
                    ufoPressTracing(event.timeStamp);
                    setSelectedIssueKey(issue.key);
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        };
    if ((0, $1ybV0.ff)('jwm.list.rendering-improvements')) // Replace with inline function when cleaning up 'jwm.list.rendering-improvements'
    // eslint-disable-next-line react-hooks/rules-of-hooks
    openIssueModal = (0, $eUqFw.useCallback)(openIssueModal, [
        setSelectedIssueKey,
        ufoPressTracing
    ]);
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onBeforeOpened = (0, $eUqFw.useCallback)((event)=>{
            ufoPressTracing(event.timeStamp);
        }, [
            ufoPressTracing
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const filterIssue = (0, $eUqFw.useCallback)((issue)=>Boolean(issue.id && !(0, $d3C6e.isOptimisticIssue)(Number(issue.id)) && issue.key), []);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ createOpenIssueModalHandler: openIssueModal } = (0, $e3dJ4.useIssueModalActions)({
            onBeforeOpened: onBeforeOpened,
            filterIssue: filterIssue
        }));
    }
    const { toggleHighlightRow: toggleHighlightRow, getRowClassName: getRowClassName } = (0, $bxcZe.useHighlightDoneItems)();
    const highlightRow = (0, $eUqFw.useCallback)((issueKey)=>toggleHighlightRow(issueKey, true), [
        toggleHighlightRow
    ]);
    const { onIssueUpdated: onIssueUpdated } = (0, $bR4Tm.useIssueUpdated)();
    const columns = (0, $dcGUq.useGetColumns)({
        columnWidths: columnWidths,
        rowHeight: $4f397652852d3db1$var$ROW_HEIGHT,
        openIssueModal: openIssueModal,
        highlightRow: highlightRow,
        loading: loading,
        projectId: projectId,
        onIssueUpdated: onIssueUpdated
    });
    const onResize = (columnKey, width, analyticsEvent)=>{
        interactionMetrics[0, $jwBHm.COLUMN_RESIZED].start();
        setColumnWidth(columnKey, width);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'column resized', {
            columnKey: columnKey
        });
    };
    const onModalIssueClose = (0, $eUqFw.useCallback)(()=>{
        setSelectedIssueKey(undefined);
    }, [
        setSelectedIssueKey
    ]);
    const { onIssueChange: onIssueChange } = (0, $lCzHy.useIssueChangeUpdater)();
    // this needs to be memoised otherwise it rerenders when the table changes causing some elements to blink
    // a common reason for the table to change while this is open is the realtime implementation
    const bentoView = (0, $eUqFw.useMemo)(()=>selectedIssueKey != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHnEs.default), {
            issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
            onClose: onModalIssueClose,
            analyticsSource: (0, $0100842672acae20$export$7ca28938a07e0c33),
            onChange: onIssueChange,
            isSoftwareProject: (0, $eI5EY.fg)('jsw_list_view_-_change_issue_view_analytics_event') && isSoftwareFieldsEnabled
        }), [
        selectedIssueKey,
        onModalIssueClose,
        onIssueChange,
        isSoftwareFieldsEnabled
    ]);
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    const shouldShowEmbedOnboarding = selectedIssueKey == null && isOnboardingEnabled && !showFlatList && issuesMap?.size > 3;
    const shouldShowReparentModal = showReparentModal && (0, $1ybV0.ff)('jwm.visual-hierarchy-dnd');
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'list viewed', {
            isGrouping: isGrouping,
            isSorting: isSorting,
            isFiltering: isFiltering,
            isSearching: isSearching
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "list-view",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HWvN.RenderStartMark), {
        view: featureView,
        loading: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h8g5T.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f397652852d3db1$var$BaseTableWithAnalytics, {
        columns: columns,
        onResize: onResize,
        onEndReachedThreshold: $4f397652852d3db1$var$ON_END_REACHED_THRESHOLD,
        footerHeight: $4f397652852d3db1$var$FOOTER_HEIGHT,
        rowHeight: $4f397652852d3db1$var$ROW_HEIGHT,
        getRowClassName: getRowClassName,
        loadingMessage: formatMessage((0, $6lgzJ.default).loadingMoreItems),
        isSorting: isSorting,
        EmptyState: (0, $fuaUK.EmptyState),
        GroupItem: (0, $aiXUL.GroupItem),
        projectId: projectId,
        projectKey: projectKey,
        projectName: projectName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eicDW.default), (0, $1ybV0.ff)('jwm.list.background-refetch-for-groups-and-children') ? {} : {
        issuesMap: issuesMap,
        isBackgroundQueryDisabled: isGrouping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6IRtV.default), {
        isBackgroundQueryDisabled: !isGrouping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hHiDc.UpdateFieldsDetail), null), shouldShowEmbedOnboarding && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $422sV.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jira-list-issue-app"
    }, isViewModeSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9u6Jh.SidebarIssueView), {
        issueKey: selectedIssueKey,
        onClose: onModalIssueClose,
        analyticsSource: (0, $0100842672acae20$export$7ca28938a07e0c33),
        onChange: onIssueChange,
        isSoftwareProject: (0, $eI5EY.fg)('jsw_list_view_-_change_issue_view_analytics_event') && isSoftwareFieldsEnabled
    }) : bentoView), (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVPP8.DevDetailsDialogLoaderAsync), {
        scopeId: "software-list.list"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jA3I.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5NSnR.default), null), shouldShowReparentModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSlaZ.AsyncReparentModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1lhPF.default), null));
};
const $4f397652852d3db1$export$84d0dd190d551cd1 = ({ projectId: projectId, projectKey: projectKey, projectName: projectName, isTeamManaged: isTeamManaged })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ childrenItems: _childrenQueryData }] = (0, $5r9Wo.useHierarchyStore)();
    const pageHeading = formatMessage((0, $6lgzJ.default).listHeading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClear = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'groupBy cleared', {
            reason: 'stale'
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $aUash.useClearStaleGroupBy)({
        onClear: onClear
    });
    (0, $aDWue.useWatchBulkSelection)();
    (0, $eUqFw.useEffect)(()=>{
        // fire tracking for inline field create statsig experiment
        (0, $41WOo.isJwmInlineFieldCreateEnabled)();
    }, []);
    const listViewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJYsP.BusinessDocumentTitle), {
        pageHeading: pageHeading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "jira-list-header-actions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PNxf.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f397652852d3db1$var$ListContent, {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isTeamManaged: isTeamManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ukK3.InteractionMetrics), null), (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I9Im.PrefetchIssueDataController), null));
    return (0, $1ybV0.ff)('bulk-edit-in-jwm-list-view_bny2w') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hotly.BulkSelectionContainer), {
        scope: "JWMListBulkSelection"
    }, listViewContent) : listViewContent;
};
var $4f397652852d3db1$export$2e2bcd8739ae039 = $4f397652852d3db1$export$84d0dd190d551cd1;

});
parcelRegister("hJYsP", function(module, exports) {

$parcel$export(module.exports, "BusinessDocumentTitle", () => $08e74678968dfe67$export$416064ba09d98e69);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $fDLFb = parcelRequire("fDLFb");
const $08e74678968dfe67$export$416064ba09d98e69 = /*#__PURE__*/ (0, $eUqFw.memo)(({ pageHeading: pageHeading })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: documentTitle
    });
});

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});


parcelRegister("kHnEs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cc12293a50ce22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");


var $hJ992 = parcelRequire("hJ992");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $jK1pm = parcelRequire("jK1pm");

const $f3cc12293a50ce22$export$843a6e93936e3b60 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dQVrX")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $f3cc12293a50ce22$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $0100842672acae20$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
    const [, setSelectedIssue] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
        setSelectedIssue
    ]);
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setSidebarContent(null);
        setDetailViewAsSidebar();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const viewModeOptions = (0, $eUqFw.useMemo)(()=>!viewModeSwitchDisabled ? {
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        } : undefined, [
        onSwitchToModal,
        onSwitchToSidebar,
        viewModeSwitchDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-modal-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        packageName: isSoftwareProject ? 'software' : 'business',
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3cc12293a50ce22$export$843a6e93936e3b60, {
        analyticsSource: analyticsSource,
        issueKey: issueKey,
        onClose: onClose,
        onChange: onChange,
        onIssueDeleteSuccess: onDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        viewModeOptions: viewModeOptions
    })))));
};
var $f3cc12293a50ce22$export$2e2bcd8739ae039 = $f3cc12293a50ce22$var$ModalIssueAppWrapper;

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");


var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$98c0ebc22792f04));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$98c0ebc22792f04)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$705305d6da432040));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");

const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || (0, $935e771f19f8ea28$export$2d037fdba4f67558);

});




parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("dQVrX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('aTMMU')
        ]);
        const value = parcelRequire('kjWxV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("aTMMU")
    ]).then(()=>parcelRequire('kjWxV'));
}

});


parcelRegister("9u6Jh", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $134113658c67db96$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hSCS8 = parcelRequire("hSCS8");

var $1ybV0 = parcelRequire("1ybV0");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $bw53Y = parcelRequire("bw53Y");

var $4LhhW = parcelRequire("4LhhW");
const $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
const $134113658c67db96$var$callWhenIdle = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $134113658c67db96$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $4LhhW.useSetSidebarStyleVar)();
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // avoid re-rendering in case props aren't memoised
        if (issueKey === prevIssueKey && !!content) return;
        if (issueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($134113658c67db96$var$CSSAntiCorruptionLayer, {
                key: $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bw53Y.SidebarIssueApp), {
                issueKey: (0, $6vrw7.toIssueKey)(issueKey),
                onClose: onCloseSidebar,
                analyticsSource: analyticsSource,
                onChange: onChange,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                isSoftwareProject: isSoftwareProject
            }));
            setSidebarContent(newContent);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
        } else {
            if (!(0, $1ybV0.ff)('jwm.fix-issue-view-sidebar-close-on-unscheduled_click_ysro6.') || (0, $1ybV0.ff)('jwm.fix-issue-view-sidebar-close-on-unscheduled_click_ysro6.') && content?.key === $134113658c67db96$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
        }
    }, [
        analyticsSource,
        content,
        createAnalyticsEvent,
        isSoftwareProject,
        issueKey,
        onChange,
        onCloseSidebar,
        onIssueDeleteSuccess,
        prevIssueKey,
        setSidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $134113658c67db96$var$callWhenIdle(()=>{
            (0, $bw53Y.IssueApp).preload();
        });
    }, []);
    return null;
});
// put an extra div around issue view to "adopt" styles from `SidebarContent` (`> div`)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $134113658c67db96$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bw53Y", function(module, exports) {

$parcel$export(module.exports, "IssueApp", () => $1d0bd87d82d1f36e$export$35dd9ab573b87c3f);
$parcel$export(module.exports, "SidebarIssueApp", () => $1d0bd87d82d1f36e$export$e402f7c18d4d7f37);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $hSCS8 = parcelRequire("hSCS8");

var $hJ992 = parcelRequire("hJ992");

var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c4qEZ = parcelRequire("c4qEZ");

var $jK1pm = parcelRequire("jK1pm");

const $1d0bd87d82d1f36e$export$35dd9ab573b87c3f = (0, $7rh0R.lazy)(()=>(parcelRequire("f4xMV")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $1d0bd87d82d1f36e$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eUqFw.useState)(issueKey);
    const prevIssueKey = (0, $hzcvF.usePreviousWithInitial)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eUqFw.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $hJ992.useIssueContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    (0, $eUqFw.useEffect)(()=>{
        if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey
    ]);
    const onSwitchToModal = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsModal();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
    }, [
        createAnalyticsEvent,
        setDetailViewAsModal,
        setSidebarContent
    ]);
    const onSwitchToSidebar = (0, $eUqFw.useCallback)(()=>{
        setDetailViewAsSidebar();
        setSidebarContent(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
    }, [
        createAnalyticsEvent,
        setDetailViewAsSidebar,
        setSidebarContent
    ]);
    const PACKAGE_NAME = (0, $eUqFw.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
        isSoftwareProject
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-sidebar-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0bd87d82d1f36e$export$35dd9ab573b87c3f, {
        viewModeOptions: {
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040),
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal,
            onSwitchToSidebar: onSwitchToSidebar
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    })))));
};

});
parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});

parcelRegister("f4xMV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('kMAKK')
        ]);
        const value = parcelRequire('9zAkH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("kMAKK")
    ]).then(()=>parcelRequire('9zAkH'));
}

});


parcelRegister("4LhhW", function(module, exports) {

$parcel$export(module.exports, "useSetSidebarStyleVar", () => $94858a1aa5f6a192$export$70b20cd72362e39d);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");


var $53ucm = parcelRequire("53ucm");
const $94858a1aa5f6a192$var$MARGIN = 24;
const $94858a1aa5f6a192$export$70b20cd72362e39d = ()=>{
    const [{ content: content, sidebarWidth: sidebarWidth }] = (0, $hSCS8.useSidebar)();
    const { setWidth: setWidth } = (0, $53ucm.useDetailPanelActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (content !== null) {
            document.documentElement?.style.setProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8), `${sidebarWidth}px`);
            setWidth(sidebarWidth + $94858a1aa5f6a192$var$MARGIN);
        } else document.documentElement?.style.removeProperty((0, $29bf8722faf6f5bf$export$c83c5cba188418d8));
        return ()=>{
            setWidth(0);
        };
    }, [
        content,
        setWidth,
        sidebarWidth
    ]);
};

});
const $29bf8722faf6f5bf$export$c83c5cba188418d8 = '--detailPanelWidth';



parcelRegister("5I9Im", function(module, exports) {

$parcel$export(module.exports, "PrefetchIssueDataController", () => $1fd41398a8791bc6$export$1e95fb877713bf5e);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");

var $hYeSy = parcelRequire("hYeSy");

var $1SYbt = parcelRequire("1SYbt");
const $1fd41398a8791bc6$var$IssueDataLoader = /*#__PURE__*/ (0, $eUqFw.memo)(({ issues: issues })=>issues.map((issueKey)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SYbt.AsyncIssueViewCriticalDataLoader), {
            key: issueKey,
            issueKey: issueKey
        })));
const $1fd41398a8791bc6$export$1e95fb877713bf5e = ()=>{
    const { prefetchedIssues: prefetchedIssues } = (0, $hYeSy.usePrefetchIssueViewData)();
    const { clearCache: clearCache } = (0, $hYeSy.usePrefetchIssueViewDataActions)();
    const [selectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const prevSelectedIssueKey = (0, $hzcvF.usePreviousWithInitial)(selectedIssueKey);
    (0, $eUqFw.useEffect)(()=>{
        const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
        const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
        // clear cache when user closes Issue modal or opens another issue without closing it (ie via breadcrumbs)
        if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
    }, [
        clearCache,
        prevSelectedIssueKey,
        selectedIssueKey
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // clear cache on unmount
            clearCache();
        }, [
        clearCache
    ]);
    const issues = (0, $eUqFw.useMemo)(()=>Object.keys(prefetchedIssues), [
        prefetchedIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1fd41398a8791bc6$var$IssueDataLoader, {
        issues: issues
    });
};

});
parcelRegister("hYeSy", function(module, exports) {

$parcel$export(module.exports, "usePrefetchIssueViewData", () => $1367707b89dd09e1$export$519e056a921d9691);
$parcel$export(module.exports, "usePrefetchIssueViewDataActions", () => $1367707b89dd09e1$export$fee97ccc4dadacbb);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
/**
 * The minimum allowed time between two consecutive issue data prefetches.
 */ const $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
const $1367707b89dd09e1$var$MAX_DELAY = 300;
const $1367707b89dd09e1$var$MIN_DELAY = 0;
const $1367707b89dd09e1$export$a87749ac92873cf7 = ()=>100;
const $1367707b89dd09e1$var$actions = {
    // prefetches issue view data on hover
    prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
            const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
            const currentTimestamp = Date.now();
            const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $1367707b89dd09e1$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $1367707b89dd09e1$var$MAX_DELAY : $1367707b89dd09e1$var$MIN_DELAY;
            // clear cache if it exceeds the limit so that it doesn't grow indefinitely
            const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $1367707b89dd09e1$export$a87749ac92873cf7() ? {} : prefetchedIssues;
            setState({
                // prefetch the issue only if the time from the last prefetch is greater than ALLOWED_TIME_BETWEEN_PREFETCHES
                prefetchedIssues: delay === $1367707b89dd09e1$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                    ...nextPrefetchedIssues,
                    [issueKey]: true
                } : prefetchedIssues,
                timestampOfTheLastPrefetch: currentTimestamp
            });
        },
    // clears cached issues (ie on view unmount)
    clearCache: ()=>({ setState: setState })=>{
            setState({
                timestampOfTheLastPrefetch: null,
                prefetchedIssues: {}
            });
        }
};
const $1367707b89dd09e1$var$PrefetchIssueViewStore = (0, $a61MH.createStore)({
    initialState: {
        timestampOfTheLastPrefetch: null,
        prefetchedIssues: {}
    },
    actions: $1367707b89dd09e1$var$actions,
    name: 'JWMPrefetchIssueViewStore'
});
const $1367707b89dd09e1$export$519e056a921d9691 = (0, $ggKAj.createStateHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);
const $1367707b89dd09e1$export$fee97ccc4dadacbb = (0, $ggKAj.createActionsHook)($1367707b89dd09e1$var$PrefetchIssueViewStore);

});

parcelRegister("1SYbt", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", () => $b758d168c0275aa2$export$15a49d6c068f7356);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $72NCz = parcelRequire("72NCz");
const $b758d168c0275aa2$var$entryPointParams = {};
const $b758d168c0275aa2$export$15a49d6c068f7356 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $72NCz.asyncIssueViewCriticalDataLoaderEntrypoint), $b758d168c0275aa2$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm-issue-view-critical-data-loader",
        packageName: "jiraBusinessIssueViewCriticalDataLoader",
        runtimeProps: props
    });
});

});
parcelRegister("72NCz", function(module, exports) {

$parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", () => $80aa607d47f3d3ce$export$6254258f84be452a);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $80aa607d47f3d3ce$export$6254258f84be452a = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("B8xwO")), {
        moduleId: "1f53773a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("B8xwO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('apZDm');
        const value = parcelRequire('2rxqz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("apZDm").then(()=>parcelRequire('2rxqz'));
}

});




parcelRegister("e3dJ4", function(module, exports) {

$parcel$export(module.exports, "useIssueModalActions", () => $58c0bec98635e94c$export$6f3a65eba75c0ec1);

var $eUqFw = parcelRequire("eUqFw");

var $jGcn0 = parcelRequire("jGcn0");

var $hIxFu = parcelRequire("hIxFu");

var $kJlBc = parcelRequire("kJlBc");
const $58c0bec98635e94c$var$alwaysTrue = ()=>true;
const $58c0bec98635e94c$export$6f3a65eba75c0ec1 = ({ onBeforeOpened: onBeforeOpened, filterIssue: filterIssue = $58c0bec98635e94c$var$alwaysTrue } = {})=>{
    const [_, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const createOpenIssueModalHandler = (0, $eUqFw.useCallback)((issue)=>(event)=>{
            if (filterIssue(issue)) {
                if (!(0, $hIxFu.isModifiedEvent)(event)) {
                    onBeforeOpened && onBeforeOpened(event);
                    setSelectedIssueKey(issue.key);
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        }, [
        filterIssue,
        onBeforeOpened,
        setSelectedIssueKey
    ]);
    return {
        createOpenIssueModalHandler: createOpenIssueModalHandler
    };
};

});

parcelRegister("422sV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7abff022c89493f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7abff022c89493f7$var$ListEmbedOnboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9StkD")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/onboarding/list-embed/src/ui/main.tsx"
});
const $7abff022c89493f7$var$ListEmbedOnboardingAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.onboarding.list-embed",
        packageName: "jira-business.onboarding.list-embed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "list-embed-onboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7abff022c89493f7$var$ListEmbedOnboarding, null)));
var $7abff022c89493f7$export$2e2bcd8739ae039 = $7abff022c89493f7$var$ListEmbedOnboardingAsync;

});
parcelRegister("9StkD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('iSmP0')
        ]);
        const value = parcelRequire('g6Owk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("iSmP0")
    ]).then(()=>parcelRequire('g6Owk'));
}

});


parcelRegister("6HWvN", function(module, exports) {

$parcel$export(module.exports, "RenderStartMark", () => $ebb8060987b09135$export$2128f295d6adb861);
$parcel$export(module.exports, "PageLoadMetrics", () => $ebb8060987b09135$export$66b33c055cbb625e);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");


var $ZvXTS = parcelRequire("ZvXTS");
const $ebb8060987b09135$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
    if (loading === true) return null;
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$b78f0bbf209e5f4));
    return null;
};
const $ebb8060987b09135$export$66b33c055cbb625e = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
    // set UI_RENDER_END mark to indicate the end of UI render
    (0, $ZvXTS.markViewMetric)(view, (0, $78bb8734d7176028$export$88ea1e280513690f));
    const metric = (0, $ZvXTS.pageLoadMetrics)[view];
    return metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: `${product}.${view}`,
        metric: metric,
        extra: attributes
    });
});

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("gVPP8", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $d943de865dd0122f$export$f5ffc0f323543e16);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d943de865dd0122f$var$DevDetailDialogLoaderWithContainer = (0, $7rh0R.lazy)(()=>(parcelRequire("j1d3R")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index.tsx"
});
const $d943de865dd0122f$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d943de865dd0122f$var$DevDetailDialogLoaderWithContainer, props));
$d943de865dd0122f$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});
parcelRegister("j1d3R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('90cOZ')
        ]);
        const value = parcelRequire('g5FQE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("90cOZ")
    ]).then(()=>parcelRequire('g5FQE'));
}

});


parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("jwBHm", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RESIZED", () => $ad32839562116fec$export$8b3afcfe2043df19);
$parcel$export(module.exports, "COLUMN_VISIBILITY_CHANGED", () => $ad32839562116fec$export$8d5ff5bc3618f0bf);
$parcel$export(module.exports, "DND_ROW_DROPPED", () => $ad32839562116fec$export$fcf01bd231fb8f52);
$parcel$export(module.exports, "DND_ROW_LIFTED", () => $ad32839562116fec$export$96db5145b3b810a2);
$parcel$export(module.exports, "MORE_FIELDS_BUTTON_CLICKED", () => $ad32839562116fec$export$eee8b97030e3c397);
$parcel$export(module.exports, "useInteractionMetrics", () => $ad32839562116fec$export$6f239bf5d81555c8);

var $lNfG4 = parcelRequire("lNfG4");
const $ad32839562116fec$export$8b3afcfe2043df19 = 'column-resized';
const $ad32839562116fec$export$8d5ff5bc3618f0bf = 'column-visibility-changed';
const $ad32839562116fec$export$fcf01bd231fb8f52 = 'dnd-row-droppped';
const $ad32839562116fec$export$96db5145b3b810a2 = 'dnd-row-lifted';
const $ad32839562116fec$export$eee8b97030e3c397 = 'more-fields-button-clicked';
const $ad32839562116fec$var$interactionMetrics = {
    [$ad32839562116fec$export$8b3afcfe2043df19]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$8b3afcfe2043df19}`
    }),
    [$ad32839562116fec$export$8d5ff5bc3618f0bf]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$8d5ff5bc3618f0bf}`
    }),
    [$ad32839562116fec$export$eee8b97030e3c397]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$eee8b97030e3c397}`
    }),
    [$ad32839562116fec$export$96db5145b3b810a2]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$96db5145b3b810a2}`
    }),
    [$ad32839562116fec$export$fcf01bd231fb8f52]: (0, $lNfG4.metrics).interaction({
        key: `jwm.list.${$ad32839562116fec$export$fcf01bd231fb8f52}`
    })
};
const $ad32839562116fec$export$6f239bf5d81555c8 = ()=>$ad32839562116fec$var$interactionMetrics;

});

parcelRegister("aDWue", function(module, exports) {

$parcel$export(module.exports, "useWatchBulkSelection", () => $1dfbdfbec97ae97b$export$5cafb03426b5addb);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kQAZu = parcelRequire("kQAZu");

var $lEWmB = parcelRequire("lEWmB");
var $9GlEj = parcelRequire("9GlEj");

var $hzcvF = parcelRequire("hzcvF");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");

var $hotly = parcelRequire("hotly");

var $8COV0 = parcelRequire("8COV0");
const $1dfbdfbec97ae97b$export$5cafb03426b5addb = ()=>{
    const [{ selectedIssues: selectedIssues }, { clearSelection: clearSelection, unselectIssues: unselectIssues }] = (0, $hotly.useBulkSelectionStore)();
    const projectData = (0, $kQAZu.useProject)();
    const projectId = projectData.id;
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    const [{ hierarchyData: { data: issues }, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    /*
        Use state to check once the filters has been updated
        After this we should wait for the new issues to be fetched
        and unselect the issues that are no longer visible for this new query
    */ const [hasFiltersBeenUpdated, setHasFiltersBeenUpdated] = (0, $eUqFw.useState)(false);
    const prevIssues = (0, $hzcvF.usePreviousWithInitial)(issues);
    // clear all items when grouping & filters change as the groups reset and collapse
    (0, $eUqFw.useEffect)(()=>{
        if (selectedIssues.size && (jql || quickFiltersJql)) {
            if (isGrouping) clearSelection();
            else setHasFiltersBeenUpdated(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        jql,
        quickFiltersJql
    ]);
    // clear items which are no longer visible after filtering etc.
    (0, $eUqFw.useEffect)(()=>{
        if (hasFiltersBeenUpdated && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevIssues, issues) && !isGrouping) {
            const allIssueIds = (0, $8COV0.getAllIssuesIds)({
                data: issues,
                childrenItems: childrenItems
            });
            const issuesToUnselect = [
                ...selectedIssues
            ].filter((issueId)=>allIssueIds.indexOf(issueId) === -1);
            if (issuesToUnselect.length > 0) unselectIssues({
                issues: issuesToUnselect
            });
            setHasFiltersBeenUpdated(false);
        }
    }, [
        childrenItems,
        hasFiltersBeenUpdated,
        isGrouping,
        issues,
        prevIssues,
        selectedIssues,
        unselectIssues
    ]);
    // clear all items when changing project
    (0, $eUqFw.useEffect)(()=>{
        clearSelection();
    }, [
        projectId,
        clearSelection
    ]);
};

});
parcelRegister("5r9Wo", function(module, exports) {

$parcel$export(module.exports, "useHierarchyStore", () => $6f7d17a2863fe3d7$export$2fc259d06066fab6);

var $jG2Eu = parcelRequire("jG2Eu");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $4oWxH = parcelRequire("4oWxH");

var $lO4Or = parcelRequire("lO4Or");

var $aXbY8 = parcelRequire("aXbY8");
const $6f7d17a2863fe3d7$export$21726efd4013edfd = 1;
const $6f7d17a2863fe3d7$var$createLoadingItems = ()=>Array.from(Array((0, $jGcn0.DEFAULT_PAGE_SIZE)).keys()).map((i)=>(0, $aXbY8.createItemSkeleton)({
            issueId: String(i)
        }));
const $6f7d17a2863fe3d7$var$getInitialState = ()=>({
        hierarchyData: {
            data: $6f7d17a2863fe3d7$var$createLoadingItems(),
            loading: true,
            totalCount: 0,
            isLoadingNextPage: false,
            loadNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        },
        expandedItems: {},
        childrenItems: {},
        issuesMap: new Map(),
        issueParentMap: new Map()
    });
const $6f7d17a2863fe3d7$export$d4c72bab9d6cc13a = $6f7d17a2863fe3d7$var$getInitialState();
const $6f7d17a2863fe3d7$var$findAnchorIndex = (issues, anchorId)=>{
    if (anchorId == null) return undefined;
    const index = issues.findIndex((issue)=>String(issue.issueId) === anchorId);
    if (index === -1) return undefined;
    return index;
};
// Recursively creates hierarchy tree by iterating over the items and their children
const $6f7d17a2863fe3d7$var$createHierarchy = ({ item: item, childrenItems: childrenItems, issuesMap: issuesMap, extendItemsWithChildCreate: extendItemsWithChildCreate, hierarchyLevels: hierarchyLevels, showFlatList: showFlatList, issueParentMap: issueParentMap })=>{
    const childQueryData = childrenItems[item.issueId] || {};
    const childrenData = Array.isArray(childQueryData.data) ? childQueryData.data : [];
    const childrenCount = item.childSummary?.totalCount ?? 0;
    const epicLevelIssueTypeIds = hierarchyLevels.filter((hierarchyLevel)=>hierarchyLevel.level === $6f7d17a2863fe3d7$export$21726efd4013edfd).map((hierarchyLevel)=>hierarchyLevel.id);
    const hasChildren = item.issuetype?.id && epicLevelIssueTypeIds.includes(item.issuetype.id) ? true : childrenCount > 0;
    let children = [];
    if (((0, $4oWxH.isGroupItem)(item.issueId) || showFlatList !== true) && hasChildren) {
        const depth = (item.depth || 0) + 1;
        const skeletonItem = childQueryData.loading ? [
            (0, $aXbY8.createItemSkeleton)({
                issueId: item.issueId
            })
        ] : [];
        children = childrenData.length ? childrenData.map((childItem, index)=>{
            issueParentMap.set(`${childItem.issueId}`, `${item.issueId}`);
            return $6f7d17a2863fe3d7$var$createHierarchy({
                item: {
                    ...childItem,
                    rankIndex: index,
                    depth: depth,
                    rowKey: `${childItem.id}-${depth}`
                },
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                hierarchyLevels: hierarchyLevels,
                extendItemsWithChildCreate: extendItemsWithChildCreate,
                issueParentMap: issueParentMap
            });
        }) : skeletonItem;
        if (childQueryData.hasNextPage === true) children.push((0, $aXbY8.createRowForShowMore)(item.issueId));
    }
    const newItem = extendItemsWithChildCreate(item, children);
    issuesMap.set(`${item.issueId}`, newItem);
    return newItem;
};
const $6f7d17a2863fe3d7$var$extendItemsWithChildCreate = (rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels)=>(item, children)=>{
        const expandItem = (issueId)=>{
            const state = getState();
            if (!state.expandedItems[issueId]) setState({
                ...state,
                expandedItems: {
                    ...state.expandedItems,
                    [issueId]: true
                }
            });
        };
        const insertInlineCreate = (anchorIndex, type, issueId)=>{
            if (anchorIndex != null) children.splice(anchorIndex, 0, (0, $aXbY8.createRowForInlineCreate)(type, String(issueId)));
            else children.unshift((0, $aXbY8.createRowForInlineCreate)(type, String(issueId)));
        };
        const hierarchyLevel = hierarchyLevels.find((x)=>x.id === item.issuetype?.id)?.level;
        const anchorIndex = $6f7d17a2863fe3d7$var$findAnchorIndex(children, rowCreateState.anchorId);
        const { parentId: parentId } = rowCreateState;
        if (String(parentId) === String(item.issueId)) {
            if ((0, $4oWxH.isGroupItem)(item.issueId)) insertInlineCreate(anchorIndex, 'group', item.issueId);
            else if (hierarchyLevel === 0) insertInlineCreate(anchorIndex, 'subtask', item.issueId);
            else if (hierarchyLevel && hierarchyLevel >= 1) insertInlineCreate(anchorIndex, 'task', item.issueId);
        }
        return {
            ...item,
            children: children,
            onChildCreateButtonClicked: hierarchyLevel !== -1 ? ()=>{
                setRowCreatePosition({
                    parentId: item.issueId
                });
                expandItem(item.issueId);
            } : undefined
        };
    };
const $6f7d17a2863fe3d7$var$transformTopLevelIssues = (data, rowCreateState)=>{
    const { parentId: parentId, anchorId: anchorId } = rowCreateState;
    /**
	 * Due to race conditions, we cannot trust query data to be the source of truth for top level issues,
	 * so we need to make sure any inline create row has been removed before proceeding
	 */ const topLevelIssues = data.filter((item)=>!(0, $aXbY8.isItemAnInlineCreate)(String(item.issueId)));
    if (anchorId && !parentId) {
        const anchorIndex = $6f7d17a2863fe3d7$var$findAnchorIndex(topLevelIssues, rowCreateState.anchorId);
        if (anchorIndex != null) // Insert the sibling issue create row
        topLevelIssues.splice(anchorIndex, 0, (0, $aXbY8.createRowForInlineCreate)('sibling'));
    }
    return topLevelIssues;
};
// Takes top level items (or Groups) GraphQL response and stores it in here
const $6f7d17a2863fe3d7$var$setHierarchyData = (queryData, rowCreateState, setRowCreatePosition, hierarchyLevels, showFlatList)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { childrenItems: childrenItems, issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
        const childCreateCallback = $6f7d17a2863fe3d7$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
        if (queryData.loading) return;
        /**
		 * transformTopLevelIssues is used to transform both ListViewIssue[] and HierarchyItem[] array types, depending on what is passed as the 'data' argument,
		 *  hence the need to type cast it as ListViewIssue[] to avoid type errors
		 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const topLevelIssues = $6f7d17a2863fe3d7$var$transformTopLevelIssues(queryData.data, rowCreateState);
        const data = queryData.loading ? $6f7d17a2863fe3d7$var$createLoadingItems() : topLevelIssues.map((item, index)=>$6f7d17a2863fe3d7$var$createHierarchy({
                item: {
                    ...item,
                    rankIndex: index,
                    depth: 0,
                    rowKey: `${item.id}-0`
                },
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                extendItemsWithChildCreate: childCreateCallback,
                showFlatList: showFlatList,
                hierarchyLevels: hierarchyLevels,
                issueParentMap: issueParentMap
            }));
        setState({
            ...state,
            hierarchyData: {
                ...queryData,
                data: data
            }
        });
    };
// Updates expanded items
const $6f7d17a2863fe3d7$var$setExpandedItems = (issueId, isExpanded)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            expandedItems: {
                ...state.expandedItems,
                [issueId]: isExpanded
            }
        });
    };
// Stores GraphQL response of expanded child items
const $6f7d17a2863fe3d7$var$setChildrenItems = (parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const childrenItems = {
            ...state.childrenItems,
            [parentIssueId]: {
                ...queryData,
                ...queryData.data ? {
                    data: queryData.data.map((issue)=>({
                            ...issue,
                            parentIssueId: parentIssueId
                        }))
                } : {}
            }
        };
        const { issuesMap: issuesMap, issueParentMap: issueParentMap } = state;
        let targetFound = false;
        const updateHierarchy = ({ rootIssueId: rootIssueId })=>{
            const item = issuesMap.get(`${rootIssueId}`);
            // We can stop traversal once the parent node has been updated
            if (targetFound || !item) return null;
            const childCreateCallback = $6f7d17a2863fe3d7$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            if (String(item.issueId) === String(parentIssueId)) {
                // If we find the node we're appending children to, we need to create the new hierarchy below it and return to notify parents to update
                targetFound = true;
                return $6f7d17a2863fe3d7$var$createHierarchy({
                    item: item,
                    childrenItems: childrenItems,
                    issuesMap: issuesMap,
                    extendItemsWithChildCreate: childCreateCallback,
                    hierarchyLevels: hierarchyLevels,
                    issueParentMap: issueParentMap
                });
            }
            const { children: children } = item;
            const updatedChild = children?.reduce((acc, curr, index)=>{
                const newChild = updateHierarchy({
                    rootIssueId: curr.issueId
                });
                if (newChild) children[index] = newChild;
                return newChild ?? acc;
            }, undefined);
            if (updatedChild) {
                // if one of the children updated, then we need to update this node as well
                const newItem = {
                    ...item,
                    children: children
                };
                issuesMap.set(`${item.issueId}`, newItem);
                return newItem;
            }
            return null;
        };
        const topLevelItems = state.hierarchyData.data;
        for(let index = 0, count = topLevelItems.length; index < count; index += 1){
            const item = topLevelItems[index];
            const newItem = updateHierarchy({
                rootIssueId: item.issueId
            });
            if (newItem) topLevelItems[index] = newItem;
            if (targetFound) break;
        }
        setState({
            ...state,
            childrenItems: childrenItems,
            hierarchyData: {
                ...state.hierarchyData,
                data: [
                    ...topLevelItems
                ]
            }
        });
    };
// rebuilds the hierarchy, factoring in changes to row create position
const $6f7d17a2863fe3d7$var$refreshHierarchy = (rowCreateState, setRowCreatePosition, hierarchyLevels)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { issuesMap: issuesMap, childrenItems: childrenItems, issueParentMap: issueParentMap } = state;
        /**
		 * getTopLevelIssues is used to transform both ListViewIssue[] and HierarchyItem[], depending on what is passed as the 'data' argument,
		 *  hence the need to type cast it as HierarchyItem[] to avoid type errors
		 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const topLevelIssues = $6f7d17a2863fe3d7$var$transformTopLevelIssues(state.hierarchyData.data, rowCreateState);
        for(let index = 0, count = topLevelIssues.length; index < count; index += 1){
            const item = topLevelIssues[index];
            const childCreateCallback = $6f7d17a2863fe3d7$var$extendItemsWithChildCreate(rowCreateState, setRowCreatePosition, getState, setState, hierarchyLevels);
            const newItem = $6f7d17a2863fe3d7$var$createHierarchy({
                item: item,
                childrenItems: childrenItems,
                issuesMap: issuesMap,
                extendItemsWithChildCreate: childCreateCallback,
                hierarchyLevels: hierarchyLevels,
                issueParentMap: issueParentMap
            });
            if (newItem) topLevelIssues[index] = newItem;
        }
        setState({
            ...state,
            childrenItems: childrenItems,
            hierarchyData: {
                ...state.hierarchyData,
                data: [
                    ...topLevelIssues
                ]
            }
        });
    };
const $6f7d17a2863fe3d7$var$resetCache = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            childrenItems: {},
            expandedItems: {}
        });
    };
const $6f7d17a2863fe3d7$var$expandFirstItems = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const firstIssueId = state.hierarchyData.data[0]?.issueId;
        setState({
            ...state,
            expandedItems: firstIssueId != null ? {
                [firstIssueId]: true
            } : {}
        });
    };
const $6f7d17a2863fe3d7$var$clearExpandedItems = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            expandedItems: Object.fromEntries(Object.keys(state.expandedItems).map((key)=>[
                    key,
                    false
                ]))
        });
    };
const $6f7d17a2863fe3d7$var$getParentIssueKeysByChildId = (issueId)=>({ getState: getState })=>{
        const { issuesMap: issuesMap } = getState();
        let parents = [];
        let node = issuesMap.get(`${issueId}`);
        do {
            const parentIssue = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            node?.fields, (0, $lO4Or.PARENT_TYPE), 'issue', null);
            const cachedParentIssueId = !(0, $4oWxH.isGroupItem)(`${node?.parentIssueId}`) ? node?.parentIssueId : null;
            const parentIssueId = parentIssue?.issueId ? parentIssue?.issueId : cachedParentIssueId;
            if (parentIssueId) {
                node = issuesMap.get(`${parentIssueId}`);
                // When parent issue is cached in hierarchy store
                if (node) parents = [
                    {
                        id: `${parentIssueId}`,
                        key: `${node.key}`
                    },
                    ...parents
                ];
                else if (parentIssue?.issueKey) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const key = `${parentIssue?.issueKey || ''}`;
                    parents = [
                        {
                            id: `${parentIssueId}`,
                            key: key
                        },
                        ...parents
                    ];
                }
            } else node = undefined;
        }while (node);
        if (parents.length) return parents;
        return null;
    };
const $6f7d17a2863fe3d7$var$clearHierarchyData = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            hierarchyData: $6f7d17a2863fe3d7$var$getInitialState().hierarchyData
        });
    };
const $6f7d17a2863fe3d7$var$initState = ({ projectKey: projectKey })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            projectKey: projectKey
        });
    };
const $6f7d17a2863fe3d7$var$actions = {
    setHierarchyData: $6f7d17a2863fe3d7$var$setHierarchyData,
    setExpandedItems: $6f7d17a2863fe3d7$var$setExpandedItems,
    setChildrenItems: $6f7d17a2863fe3d7$var$setChildrenItems,
    refreshHierarchy: $6f7d17a2863fe3d7$var$refreshHierarchy,
    expandFirstItems: $6f7d17a2863fe3d7$var$expandFirstItems,
    clearExpandedItems: $6f7d17a2863fe3d7$var$clearExpandedItems,
    clearHierarchyData: $6f7d17a2863fe3d7$var$clearHierarchyData,
    resetCache: $6f7d17a2863fe3d7$var$resetCache,
    getParentIssueKeysByChildId: $6f7d17a2863fe3d7$var$getParentIssueKeysByChildId,
    initState: $6f7d17a2863fe3d7$var$initState
};
const $6f7d17a2863fe3d7$var$Store = (0, $a61MH.createStore)({
    initialState: $6f7d17a2863fe3d7$export$d4c72bab9d6cc13a,
    actions: $6f7d17a2863fe3d7$var$actions,
    name: 'JWMHierarchyStore'
});
const $6f7d17a2863fe3d7$export$2fc259d06066fab6 = (0, $ggKAj.createHook)($6f7d17a2863fe3d7$var$Store);

});
parcelRegister("4oWxH", function(module, exports) {

$parcel$export(module.exports, "getParentIssueId", () => $f8cd47f415fc2d3e$export$846a0afb93794223);
$parcel$export(module.exports, "isGroupItem", () => $f8cd47f415fc2d3e$export$dcc23ed179776a3b);
$parcel$export(module.exports, "getGroupItemId", () => $f8cd47f415fc2d3e$export$4f6368343f5d1a95);
$parcel$export(module.exports, "isRootLevel", () => $f8cd47f415fc2d3e$export$7044e84e19490c29);

var $3uSNh = parcelRequire("3uSNh");

var $1ybV0 = parcelRequire("1ybV0");

var $7Sz8O = parcelRequire("7Sz8O");
const $f8cd47f415fc2d3e$export$3ba5d152e044664d = (parentIssue, subtaskFieldIssue)=>{
    const parentIssueFields = parentIssue.fields || [];
    const subtasksFieldIndex = parentIssueFields.findIndex((field)=>field?.fieldKey === 'subtasks');
    const subtasksField = typeof subtasksFieldIndex === 'number' && subtasksFieldIndex !== -1 ? parentIssueFields[subtasksFieldIndex] : undefined;
    if (subtasksFieldIndex === -1 || subtasksField == null) // there should be a subtask field always in the code
    // since it's declared in the gql
    return parentIssue;
    const updatedFields = [
        ...parentIssueFields
    ];
    updatedFields[subtasksFieldIndex] = {
        ...updatedFields[subtasksFieldIndex],
        issues: [
            subtaskFieldIssue,
            ...subtasksField?.issues || []
        ].filter((issue, index, issueArray)=>issueArray.findIndex((current)=>current.issueId === issue.issueId) === index)
    };
    return {
        ...parentIssue,
        // we're updating just the subtasks field, but flow doesn't understand that because the union type of fields
        fields: updatedFields
    };
};
const $f8cd47f415fc2d3e$export$30019f8058090ccb = (isFiltering, id)=>{
    if (id === (0, $7Sz8O.OPTIMISTIC_ISSUE_ID)) return false;
    return !isFiltering;
};
const $f8cd47f415fc2d3e$export$d9893aac42f29b60 = (node)=>{
    const issueKey = (0, $3uSNh.safeGetValue)(node.fields, 'issuekey', 'text', undefined);
    const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    const projectKey1 = (issueKey ?? '').split('-')[0];
    const projectKey2 = (parentIssue?.key ?? '').split('-')[0];
    const sameProject = projectKey1 && projectKey2 ? projectKey1 === projectKey2 : false;
    return sameProject ? parentIssue?.issueId : undefined;
};
const $f8cd47f415fc2d3e$export$846a0afb93794223 = (node)=>{
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) return $f8cd47f415fc2d3e$export$d9893aac42f29b60(node);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parentIssue = (0, $3uSNh.safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
    if (parentIssue?.issueId) return parentIssue?.issueId;
    return undefined;
};
const $f8cd47f415fc2d3e$export$dcc23ed179776a3b = (issueId = '')=>typeof issueId === 'string' && issueId.startsWith((0, $7Sz8O.GROUP_ITEM_PREFIX));
const $f8cd47f415fc2d3e$export$4f6368343f5d1a95 = (issueId)=>{
    const [_, groupItemId] = issueId.split(`${(0, $7Sz8O.GROUP_ITEM_PREFIX)}_`);
    return groupItemId ?? issueId;
};
const $f8cd47f415fc2d3e$export$7044e84e19490c29 = (issueId)=>{
    if ((0, $1ybV0.ff)('jwm-list-view-update-group-count_36voh')) return issueId === (0, $7Sz8O.ROOT_LEVEL);
    if (!issueId) return false;
    return issueId === (0, $7Sz8O.ROOT_LEVEL) || $f8cd47f415fc2d3e$export$dcc23ed179776a3b(issueId);
};

});
parcelRegister("7Sz8O", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID_PREFIX", () => $f5561e29bb49c6a7$export$a76c6afcd77fffd8);
$parcel$export(module.exports, "OPTIMISTIC_ISSUE_ID", () => $f5561e29bb49c6a7$export$2bc461aaabcabfc9);
$parcel$export(module.exports, "ROOT_LEVEL", () => $f5561e29bb49c6a7$export$d24bbd23c8a5d65e);
$parcel$export(module.exports, "GROUP_ITEM_PREFIX", () => $f5561e29bb49c6a7$export$b29b9e70f9850100);
const $f5561e29bb49c6a7$export$a76c6afcd77fffd8 = '-optimistic';
const $f5561e29bb49c6a7$export$2bc461aaabcabfc9 = -1;
const $f5561e29bb49c6a7$export$d24bbd23c8a5d65e = 'rootLevel';
const $f5561e29bb49c6a7$export$b29b9e70f9850100 = 'GROUP_BY';

});


parcelRegister("aXbY8", function(module, exports) {

$parcel$export(module.exports, "isItemAnIssue", () => $dc3d38a485b6d99f$export$975d97cb9b482d9f);
$parcel$export(module.exports, "createItemSkeleton", () => $dc3d38a485b6d99f$export$ac4443ed642486ab);
$parcel$export(module.exports, "isItemSkeleton", () => $dc3d38a485b6d99f$export$121c11fd7ecbe3e1);
$parcel$export(module.exports, "INLINE_CREATE_ITEM_PREFIX", () => $dc3d38a485b6d99f$export$cdc74f7556cd3fa2);
$parcel$export(module.exports, "createRowForInlineCreate", () => $dc3d38a485b6d99f$export$eb550cfe09336f0d);
$parcel$export(module.exports, "isItemAnInlineCreate", () => $dc3d38a485b6d99f$export$f785dc554f71ae43);
$parcel$export(module.exports, "isItemAnInlineCreateTask", () => $dc3d38a485b6d99f$export$76703e048af589f9);
$parcel$export(module.exports, "isItemAnInlineCreateSubTask", () => $dc3d38a485b6d99f$export$7bcd44296e4ddac3);
$parcel$export(module.exports, "isItemAnInlineCreateGroup", () => $dc3d38a485b6d99f$export$a18c1da7342b1b86);
$parcel$export(module.exports, "isItemASiblingTopLevelHierarchyInlineCreate", () => $dc3d38a485b6d99f$export$6341a221cf48c3e1);
$parcel$export(module.exports, "isItemShowMore", () => $dc3d38a485b6d99f$export$20c8aeca27cd0961);
$parcel$export(module.exports, "createRowForShowMore", () => $dc3d38a485b6d99f$export$4a6167a75be5ff06);

var $8Qd0L = parcelRequire("8Qd0L");

var $lqO9q = parcelRequire("lqO9q");
const $dc3d38a485b6d99f$export$975d97cb9b482d9f = (issueId)=>Number(issueId) > 0;
const $dc3d38a485b6d99f$export$8764542593218704 = 'SKELETON-ITEM-';
const $dc3d38a485b6d99f$export$ac4443ed642486ab = ({ issueId: issueId })=>({
        id: `${$dc3d38a485b6d99f$export$8764542593218704}${issueId}-id`,
        issueId: `${$dc3d38a485b6d99f$export$8764542593218704}${issueId}`,
        typeId: 'loading',
        issuetype: {},
        key: 'loading',
        rank: '',
        status: {
            name: 'To do',
            categoryId: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.TODO)).toString()
        },
        totalSubtasks: 0,
        rankIndex: 0,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    });
const $dc3d38a485b6d99f$export$121c11fd7ecbe3e1 = (issueId = '')=>String(issueId).startsWith($dc3d38a485b6d99f$export$8764542593218704);
const $dc3d38a485b6d99f$export$cdc74f7556cd3fa2 = 'INLINE-CREATE-';
const $dc3d38a485b6d99f$export$eb550cfe09336f0d = (type = 'subtask', issueId = 'InlineCreate')=>({
        id: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}${type}-id`,
        issueId: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}${type}-issueId`,
        parentIssueId: issueId,
        typeId: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}-typeId--${issueId}`,
        issuetype: {},
        key: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}-key-${issueId}`,
        rank: '',
        rankIndex: -1,
        status: {
            name: 'To do',
            categoryId: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.TODO)).toString()
        },
        totalSubtasks: 0,
        rowKey: `${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}-${issueId}`,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    });
const $dc3d38a485b6d99f$export$f785dc554f71ae43 = (issueId = '')=>issueId.startsWith($dc3d38a485b6d99f$export$cdc74f7556cd3fa2);
const $dc3d38a485b6d99f$export$76703e048af589f9 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}task`);
const $dc3d38a485b6d99f$export$7bcd44296e4ddac3 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}subtask`);
const $dc3d38a485b6d99f$export$a18c1da7342b1b86 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}group`);
const $dc3d38a485b6d99f$export$6341a221cf48c3e1 = (issueId = '')=>issueId.startsWith(`${$dc3d38a485b6d99f$export$cdc74f7556cd3fa2}sibling`);
const $dc3d38a485b6d99f$export$8fca45ac4bf48d8a = 'SHOW_MORE-';
const $dc3d38a485b6d99f$export$20c8aeca27cd0961 = (issueId = '')=>issueId.startsWith($dc3d38a485b6d99f$export$8fca45ac4bf48d8a);
const $dc3d38a485b6d99f$export$4a6167a75be5ff06 = (issueId)=>({
        id: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-id`,
        issueId: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-issueId`,
        parentIssueId: issueId,
        typeId: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-typeId--${issueId}`,
        issuetype: {},
        key: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-key-${issueId}`,
        rank: '',
        rankIndex: -1,
        status: {
            name: 'To do',
            categoryId: (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.TODO)).toString()
        },
        totalSubtasks: 0,
        rowKey: `${$dc3d38a485b6d99f$export$8fca45ac4bf48d8a}-${issueId}`,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    });

});
parcelRegister("lqO9q", function(module, exports) {

$parcel$export(module.exports, "SELECT_ROW_COLUMN_ID", () => $f82872dc389830b4$export$2862da21a9b5c4c7);
$parcel$export(module.exports, "COLUMNS_WITH_DISABLED_REORDERING", () => $f82872dc389830b4$export$d4e2ef02d58b3b19);
$parcel$export(module.exports, "DEFAULT_CACHE_VARIABLES", () => $f82872dc389830b4$export$fc14c7f3b5089b5d);
$parcel$export(module.exports, "PLACEHOLDER_COLUMN", () => $f82872dc389830b4$export$b74e0ecca7ce25fe);

var $lO4Or = parcelRequire("lO4Or");
const $f82872dc389830b4$export$2862da21a9b5c4c7 = 'selectRow';
const $f82872dc389830b4$export$394fb015dc5fe3a6 = 'summary';
const $f82872dc389830b4$export$b76d46aaf0fea4b4 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $f82872dc389830b4$export$e7d0f09e45be184e = 'column-draggable-helper-class';
const $f82872dc389830b4$export$d4e2ef02d58b3b19 = [
    $f82872dc389830b4$export$2862da21a9b5c4c7,
    (0, $lO4Or.ISSUE_TYPE),
    'key'
];
const $f82872dc389830b4$export$7b293683c3b210c9 = 'JWMCategoryCustomField';
const $f82872dc389830b4$export$fc14c7f3b5089b5d = {
    jql: ''
};
const $f82872dc389830b4$export$b74e0ecca7ce25fe = 'PLACEHOLDER';

});



parcelRegister("hotly", function(module, exports) {

$parcel$export(module.exports, "BulkSelectionContainer", () => $6c9f50fcdf5be0d5$export$ba7d4447e46b479e);
$parcel$export(module.exports, "useBulkSelectionStore", () => $6c9f50fcdf5be0d5$export$2addfe65a8c51586);
$parcel$export(module.exports, "useIsIssueSelected", () => $6c9f50fcdf5be0d5$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useIsGroupSelected", () => $6c9f50fcdf5be0d5$export$5810b0d7bc5c531d);
$parcel$export(module.exports, "useDiffIssuesSelected", () => $6c9f50fcdf5be0d5$export$84ca3a6195e96ba);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $gB6aI = parcelRequire("gB6aI");
const $6c9f50fcdf5be0d5$var$actions = {
    selectIssues: ({ issues: issues, issuesData: issuesData, selectGroup: selectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const selectedIssuesDataMap = new Map(state.selectedIssuesData);
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd')) issuesData?.forEach((issue)=>{
                selectedIssuesDataMap.set(issue.issueId, issue);
            });
            const newState = {
                ...state,
                selectedIssues: new Set([
                    ...state.selectedIssues,
                    ...issues
                ]),
                ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && issuesData && {
                    selectedIssuesData: selectedIssuesDataMap
                },
                ...selectGroup ? {
                    selectedGroups: new Set([
                        ...state.selectedGroups,
                        selectGroup
                    ])
                } : {},
                ...rowIndex !== undefined ? {
                    lastSelectedRowIndex: rowIndex
                } : {}
            };
            setState(newState);
        },
    selectAllIssues: ({ issues: issues, issuesData: // TODO: make issuesData required when removing use of issues https://jbusiness.atlassian.net/browse/HRZ-589
    issuesData = [] })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const selectedIssuesDataMap = new Map();
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd')) issuesData?.forEach((issue)=>{
                selectedIssuesDataMap.set(issue.issueId, issue);
            });
            const newState = {
                ...state,
                areAllIssuesSelected: true,
                selectedIssues: new Set(issues),
                ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && {
                    selectedIssuesData: selectedIssuesDataMap
                },
                lastSelectedRowIndex: undefined
            };
            setState(newState);
        },
    selectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                selectedGroups: new Set([
                    ...state.selectedGroups,
                    groupId
                ])
            });
        },
    selectAll: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: true
            });
        },
    unselectAll: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: false,
                lastSelectedRowIndex: undefined
            });
        },
    unselectGroup: (groupId)=>({ setState: setState, getState: getState })=>{
            const { selectedGroups: selectedGroups, ...state } = getState();
            selectedGroups.delete(groupId);
            setState({
                ...state,
                areAllIssuesSelected: false,
                selectedGroups: new Set(selectedGroups)
            });
        },
    unselectIssues: ({ issues: issues, unselectGroup: unselectGroup, rowIndex: rowIndex })=>({ setState: setState, getState: getState })=>{
            const { selectedIssues: selectedIssues, selectedIssuesData: selectedIssuesData, ...state } = getState();
            if (unselectGroup) state.selectedGroups.delete(unselectGroup);
            issues.forEach((issueId)=>{
                selectedIssues.delete(issueId);
                if ((0, $1ybV0.ff)('jwm.visual-hierarchy-dnd')) selectedIssuesData.delete(issueId);
            });
            const newState = {
                ...state,
                areAllIssuesSelected: false,
                selectedIssues: new Set(selectedIssues),
                selectedIssuesData: selectedIssuesData,
                ...unselectGroup ? {
                    selectedGroups: new Set(state.selectedGroups)
                } : {},
                ...rowIndex !== undefined ? {
                    lastSelectedRowIndex: rowIndex
                } : {}
            };
            setState(newState);
        },
    clearSelection: ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                areAllIssuesSelected: false,
                selectedGroups: new Set(),
                selectedIssues: new Set(),
                ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && {
                    selectedIssuesData: new Map()
                }
            });
        },
    toggleShowDeleteModal: ({ showDeleteModal: showDeleteModal })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                showDeleteModal: showDeleteModal
            });
        },
    toggleBulkEditSidebar: ({ showBulkEditSidebar: showBulkEditSidebar })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { selectedIssues: selectedIssues } = state;
            if (showBulkEditSidebar) setState({
                ...state,
                showBulkEditSidebar: showBulkEditSidebar,
                bulkEditableIssues: new Set(selectedIssues)
            });
            else setState({
                ...state,
                showBulkEditSidebar: showBulkEditSidebar,
                bulkEditableIssues: new Set()
            });
        },
    setBulkChangePermission: ({ bulkChangePermission: bulkChangePermission })=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                bulkChangePermission: bulkChangePermission
            });
        },
    setFetchingGroups: (groups)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                fetchingGroups: groups
            });
        },
    setLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        }
};
const $6c9f50fcdf5be0d5$var$initialState = {
    areAllIssuesSelected: false,
    selectedIssues: new Set(),
    selectedIssuesData: new Map(),
    selectedGroups: new Set(),
    showDeleteModal: false,
    showBulkEditSidebar: false,
    // groups that were collapsed and we are fetching the children to select them
    fetchingGroups: [],
    bulkEditableIssues: new Set()
};
const $6c9f50fcdf5be0d5$var$Store = (0, $a61MH.createStore)({
    initialState: $6c9f50fcdf5be0d5$var$initialState,
    actions: $6c9f50fcdf5be0d5$var$actions,
    name: 'JWMListBulkSelection'
});
const $6c9f50fcdf5be0d5$export$ba7d4447e46b479e = (0, $heB5U.createContainer)($6c9f50fcdf5be0d5$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                ...$6c9f50fcdf5be0d5$var$initialState
            });
        }
});
const $6c9f50fcdf5be0d5$export$2addfe65a8c51586 = (0, $ggKAj.createHook)($6c9f50fcdf5be0d5$var$Store);
const $6c9f50fcdf5be0d5$export$cfefd69fc8a5ac52 = (0, $ggKAj.createHook)($6c9f50fcdf5be0d5$var$Store, {
    selector: (0, $gB6aI.isIssueSelected)
});
const $6c9f50fcdf5be0d5$export$5810b0d7bc5c531d = (0, $ggKAj.createHook)($6c9f50fcdf5be0d5$var$Store, {
    selector: (0, $gB6aI.isGroupSelected)
});
const $6c9f50fcdf5be0d5$export$84ca3a6195e96ba = (0, $ggKAj.createHook)($6c9f50fcdf5be0d5$var$Store, {
    selector: (0, $gB6aI.diffIssuesSelected)
});

});
parcelRegister("gB6aI", function(module, exports) {

$parcel$export(module.exports, "isIssueSelected", () => $27092b3cbe1590f2$export$32568110248dd20a);
$parcel$export(module.exports, "isGroupSelected", () => $27092b3cbe1590f2$export$9a23656adbf96f8a);
$parcel$export(module.exports, "diffIssuesSelected", () => $27092b3cbe1590f2$export$bb31aa8fa8f2c5e0);

var $bj4JM = parcelRequire("bj4JM");
const $27092b3cbe1590f2$export$32568110248dd20a = (0, $bj4JM.createSelector)((state)=>({
        selectedIssues: state.selectedIssues,
        fetchingGroups: state.fetchingGroups
    }), (__, { issueId: issueId, parentIssueId: parentIssueId })=>({
        issueId: issueId,
        parentIssueId: parentIssueId
    }), ({ selectedIssues: selectedIssues, fetchingGroups: fetchingGroups }, issue)=>{
    if (selectedIssues.has(String(issue.issueId))) return true;
    if (issue.parentIssueId) // Optimistic selection
    return fetchingGroups.includes(String(issue.parentIssueId));
    return false;
});
const $27092b3cbe1590f2$export$9a23656adbf96f8a = (0, $bj4JM.createSelector)((state)=>state.selectedGroups, (__, groupId)=>groupId, (selectedGroups, groupId)=>{
    if (!groupId) return false;
    return selectedGroups.has(groupId);
});
const $27092b3cbe1590f2$export$bb31aa8fa8f2c5e0 = (0, $bj4JM.createSelector)((state)=>state.selectedIssues, (__, issues)=>issues, (selectedIssues, issues)=>{
    if (!issues) return undefined;
    const diff = [];
    issues.forEach((issueId)=>{
        if (!selectedIssues.has(issueId)) diff.push(issueId);
    });
    return diff;
});

});


parcelRegister("8COV0", function(module, exports) {

$parcel$export(module.exports, "getFlattenIssuesList", () => $7ba7c1f031f18026$export$f47d7c5b44a813c0);
$parcel$export(module.exports, "getAllIssueChildren", () => $7ba7c1f031f18026$export$1945e9d463a28215);
$parcel$export(module.exports, "getAllIssuesIds", () => $7ba7c1f031f18026$export$1b9aa9aa607a46fc);

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");

var $4oWxH = parcelRequire("4oWxH");
var $7Sz8O = parcelRequire("7Sz8O");

var $6vrw7 = parcelRequire("6vrw7");

var $aXbY8 = parcelRequire("aXbY8");
const $7ba7c1f031f18026$export$f47d7c5b44a813c0 = ({ issues: issues, expandedItems: expandedItems })=>{
    if (!issues || issues.length === 0) return [];
    const flattenedIssues = issues.flatMap((issue)=>{
        const isExpanded = expandedItems[(0, $6vrw7.toIssueId)(issue.issueId)];
        const children = isExpanded ? $7ba7c1f031f18026$export$f47d7c5b44a813c0({
            issues: issue.children,
            expandedItems: expandedItems
        }) : [];
        return [
            issue,
            ...children
        ];
    });
    return flattenedIssues;
};
const $7ba7c1f031f18026$export$1945e9d463a28215 = (0, $5iWql.default)(({ issue: issue, childrenItems: childrenItems })=>{
    if (!issue) return [];
    const issueChildren = childrenItems[issue.issueId];
    if (!issueChildren) return [];
    let issuesIds = [];
    issueChildren.data?.forEach((child)=>{
        issuesIds = [
            ...issuesIds,
            String(child.issueId),
            ...$7ba7c1f031f18026$export$1945e9d463a28215({
                issue: child,
                childrenItems: childrenItems
            })
        ];
    });
    return issuesIds;
}, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $7ba7c1f031f18026$export$1b9aa9aa607a46fc = ({ data: data, childrenItems: childrenItems })=>{
    let issuesIds = [];
    data.forEach((issue)=>{
        const { issueId: issueId, id: id } = issue;
        if (!(0, $4oWxH.isGroupItem)(issueId) && !(0, $aXbY8.isItemSkeleton)(issueId) && !id.startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX))) issuesIds.push(String(issueId));
        if (childrenItems[issueId]) issuesIds = [
            ...issuesIds,
            ...$7ba7c1f031f18026$export$1945e9d463a28215({
                issue: issue,
                childrenItems: childrenItems
            })
        ];
    });
    return issuesIds;
};

});


parcelRegister("cGmOd", function(module, exports) {

$parcel$export(module.exports, "useColumnWidths", () => $d7c1e1f9391c5df0$export$d598237875812773);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $kQAZu = parcelRequire("kQAZu");

var $iGdkQ = parcelRequire("iGdkQ");
const $d7c1e1f9391c5df0$export$86880b4b2e1a2384 = 'column.widths';
const $d7c1e1f9391c5df0$var$actions = {
    setColumnWidth: (columnKey, width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const { columnsWidths: columnsWidths, storageKey: storageKey } = state;
            if (storageKey == null) return;
            const newState = {
                ...state,
                columnsWidths: {
                    ...columnsWidths,
                    [columnKey]: width
                }
            };
            (0, $iGdkQ.localStorage).set(storageKey, newState.columnsWidths);
            setState(newState);
        },
    initState: (projectKey)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.storageKey != null) return;
            const storageKey = `${projectKey}-${$d7c1e1f9391c5df0$export$86880b4b2e1a2384}`;
            setState({
                ...state,
                storageKey: storageKey,
                columnsWidths: (0, $iGdkQ.localStorage).get(storageKey) || {}
            });
        }
};
const $d7c1e1f9391c5df0$var$Store = (0, $a61MH.createStore)({
    initialState: {
        storageKey: null,
        columnsWidths: {}
    },
    actions: $d7c1e1f9391c5df0$var$actions,
    name: 'JBusListViewColumnWidthStore'
});
const $d7c1e1f9391c5df0$var$useHook = (0, $ggKAj.createHook)($d7c1e1f9391c5df0$var$Store);
const $d7c1e1f9391c5df0$export$d598237875812773 = ()=>{
    const [{ columnsWidths: columnsWidths }, { setColumnWidth: setColumnWidth, initState: initState }] = $d7c1e1f9391c5df0$var$useHook();
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null) initState(projectKey);
    }, [
        initState,
        projectKey
    ]);
    return [
        columnsWidths,
        {
            setColumnWidth: setColumnWidth
        }
    ];
};

});
parcelRegister("iGdkQ", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $14f1b0b4f914bbd7$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $14f1b0b4f914bbd7$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_business_list-view');

});


parcelRegister("hHiDc", function(module, exports) {

$parcel$export(module.exports, "useIssueFields", () => $2c6f147c9fec0ebf$export$3dd4dc75e8b8fc8a);
$parcel$export(module.exports, "UpdateFieldsDetail", () => $2c6f147c9fec0ebf$export$fc1188611b218081);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $MdoH4 = parcelRequire("MdoH4");

var $5iWql = parcelRequire("5iWql");

var $gEmpR = parcelRequire("gEmpR");

var $hPXdk = parcelRequire("hPXdk");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $1Te3F = parcelRequire("1Te3F");

var $6hN2s = parcelRequire("6hN2s");

var $6HSAr = parcelRequire("6HSAr");
const $2c6f147c9fec0ebf$var$fieldIdsToQuery = [
    'rank',
    'parent'
];
const $2c6f147c9fec0ebf$var$buildListOfAvailableFields = (0, $5iWql.default)((fields, constants)=>fields// add fields missing in the service response
    .concat(constants.MISSING_FIELDS)// filter out fields that we can't render yet
    .filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field.type ?? ''))// sort in order of SUPPORTED_FIELDS
    .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '')), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
const $2c6f147c9fec0ebf$var$getSortedAvailableFields = (0, $5iWql.default)((availableFields, fieldsOrder, constants)=>availableFields.sort((a, b)=>{
        // fieldsOrder are initially set to SUPPORTED_FIELD_TYPES which are typed base
        // Category field is a custom field and it's id (e.g, customfield_X) is not equal to the type
        // so finding by id will return -1
        const aFieldsOrderIdx = a?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(a?.type) ? fieldsOrder.indexOf(a.type) : fieldsOrder.indexOf(a.id);
        const bFieldsOrderIdx = b?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(b?.type) ? fieldsOrder.indexOf(b.type) : fieldsOrder.indexOf(b.id);
        // if field is missing from fieldsOrder add to the end sorted based on field type
        if (aFieldsOrderIdx === -1 || bFieldsOrderIdx === -1) {
            if (aFieldsOrderIdx !== -1) return -1;
            if (bFieldsOrderIdx !== -1) return 1;
            return constants.SUPPORTED_FIELD_TYPES.indexOf(a.type ?? '') - constants.SUPPORTED_FIELD_TYPES.indexOf(b.type ?? '');
        }
        return aFieldsOrderIdx - bFieldsOrderIdx;
    }));
const $2c6f147c9fec0ebf$export$3dd4dc75e8b8fc8a = ()=>{
    const constants = (0, $1Te3F.useConstants)();
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const availableFields = $2c6f147c9fec0ebf$var$buildListOfAvailableFields(data.fields, constants);
    let order;
    let details;
    let toggleField;
    let reorderFields;
    let resetCache = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    if ((0, $eI5EY.fg)('jsw_list_view_-_cache_extra_fields_data')) {
        ({ fields: { order: order, details: details }, toggleField: toggleField, reorderFields: reorderFields, resetCache: resetCache } = (0, $6hN2s.useFieldsActions)(!loading && error == null ? availableFields : null));
        if (!(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && !(0, $1ybV0.ff)('jwm.list.rendering-improvements')) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6hN2s.useUpdateFieldsDetail)(!loading && error == null ? availableFields : null);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ fields: order, toggleField: toggleField, reorderFields: reorderFields } = (0, $6hN2s.useFieldsActionsOld)());
        details = null;
    }
    const getAvailableFields = (0, $eUqFw.useCallback)(()=>{
        try {
            return $2c6f147c9fec0ebf$var$getSortedAvailableFields(availableFields, order, constants);
        } catch (err) {
            if ((0, $eI5EY.fg)('jsw_list_view_-_cache_extra_fields_data')) {
                resetCache && resetCache();
                (0, $guiFP.default)({
                    meta: {
                        id: 'getAvailableFields',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Error trying to get available fields from cache'
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                return $2c6f147c9fec0ebf$var$getSortedAvailableFields(availableFields, [], constants);
            }
            throw err;
        }
    }, [
        availableFields,
        constants,
        order,
        resetCache
    ]);
    const shouldGetVisibleFieldsFromCache = (0, $eUqFw.useMemo)(()=>(loading || error != null) && details != null, [
        details,
        error,
        loading
    ]);
    const getVisibleFields = (0, $eUqFw.useCallback)(()=>{
        if (shouldGetVisibleFieldsFromCache) try {
            return order// Remove the ? once jsw_list_view_-_cache_extra_fields_data gets clean up
            .map((id)=>details?.[id]).filter((field)=>constants.SUPPORTED_FIELD_TYPES.includes(field?.type ?? ''));
        } catch (err) {
            resetCache && resetCache();
            (0, $guiFP.default)({
                meta: {
                    id: 'getVisibleFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to get visible fields from cache'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            return [];
        }
        return getAvailableFields().filter((field)=>constants.ALWAYS_VISIBLE_FIELDS.includes(field.id) || field.id != null && order.includes(field.id) || field.type !== undefined && order.includes(field.type));
    }, [
        shouldGetVisibleFieldsFromCache,
        getAvailableFields,
        order,
        details,
        constants.SUPPORTED_FIELD_TYPES,
        constants.ALWAYS_VISIBLE_FIELDS,
        resetCache
    ]);
    const getQueryFieldIds = (0, $eUqFw.useCallback)(()=>{
        if (loading) return [];
        let visibleFieldIds;
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // return queryFieldIds based on columns visibility
        // note that changing columns visibility triggers another items query
        visibleFieldIds = getVisibleFields()// the top level dev summary is the only thing that we should be using
        // we need to remove it from fieldIds because could fetch the field twice and is a complex field
        .filter((field)=>field.type !== (0, $lO4Or.DEV_SUMMARY_CF_TYPE)).map((field)=>field.id === 'key' ? 'issuekey' : field.id)// avoid querying items on columns re-ordering
        .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($2c6f147c9fec0ebf$var$fieldIdsToQuery);
        else // return queryFieldIds based on columns visibility
        // note that changing columns visibility triggers another items query
        visibleFieldIds = getVisibleFields().map((field)=>field.id === 'key' ? 'issuekey' : field.id)// avoid querying items on columns re-ordering
        .sort((a, b)=>constants.SUPPORTED_FIELD_TYPES.indexOf(a) - constants.SUPPORTED_FIELD_TYPES.indexOf(b)).concat($2c6f147c9fec0ebf$var$fieldIdsToQuery);
        if (visibleFieldIds.includes('timeoriginalestimate') && !visibleFieldIds.includes('timetracking')) // In JIS2, replace timeoriginalestimate with timetracking, which will have the information we
        // need to determine timeAsString in the JIS2 transformer in
        // src/packages/business/list/src/services/get-list-view-issues/field-transformer-jis2/index.tsx
        visibleFieldIds.splice(visibleFieldIds.indexOf('timeoriginalestimate'), 1, 'timetracking');
        const queryFieldIds = visibleFieldIds.filter((field)=>field !== 'commentsummary');
        return (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(queryFieldIds);
    }, [
        constants.SUPPORTED_FIELD_TYPES,
        getVisibleFields,
        loading
    ]);
    const { getQueryFieldIdsWithCache: getQueryFieldIdsWithCache } = (0, $6HSAr.useFieldsCache)({
        loading: loading,
        error: error,
        getQueryFieldIds: getQueryFieldIds
    });
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hPXdk.useHierarchyCache)({
        view: 'list'
    });
    const isParentFieldVisible = (0, $eUqFw.useCallback)(()=>(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? getVisibleFields().some((field)=>field.id === 'parent') : false, [
        getVisibleFields
    ]);
    const isDevSummaryFieldVisible = (0, $eUqFw.useCallback)(()=>(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? getVisibleFields().some((field)=>field.type === (0, $lO4Or.DEV_SUMMARY_CF_TYPE)) : false, [
        getVisibleFields
    ]);
    return {
        constants: constants,
        toggleField: toggleField,
        getVisibleFields: getVisibleFields,
        getAvailableFields: getAvailableFields,
        getQueryFieldIds: getQueryFieldIdsWithCache,
        isParentFieldVisible: isParentFieldVisible,
        isDevSummaryFieldVisible: isDevSummaryFieldVisible,
        hierarchyLevelsWithCache: hierarchyLevelsWithCache,
        reorderFields: reorderFields,
        fieldsOrder: order,
        isVisibleFieldsCached: shouldGetVisibleFieldsFromCache,
        loading: loading,
        error: error
    };
};
const $2c6f147c9fec0ebf$export$fc1188611b218081 = ()=>{
    /* eslint-disable react-hooks/rules-of-hooks */ if (!(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && (!(0, $eI5EY.fg)('jsw_list_view_-_cache_extra_fields_data') || !(0, $1ybV0.ff)('jwm.list.rendering-improvements'))) return null;
    const constants = (0, $1Te3F.useConstants)();
    const { data: data, loading: loading, error: error } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const availableFields = $2c6f147c9fec0ebf$var$buildListOfAvailableFields(data.fields, constants);
    (0, $6hN2s.useUpdateFieldsDetail)(!loading && error == null ? availableFields : null);
    return null;
/* eslint-enable react-hooks/rules-of-hooks */ };

});
parcelRegister("hPXdk", function(module, exports) {

$parcel$export(module.exports, "useHierarchyCache", () => $3299fbc32eb7c5ca$export$c2cd1510e81d00ce);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $gEmpR = parcelRequire("gEmpR");


var $9kyGZ = parcelRequire("9kyGZ");
const $3299fbc32eb7c5ca$export$c2cd1510e81d00ce = ({ view: view })=>{
    const { loading: loading, error: error, hierarchyLevels: newHierarchyLevels } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const localStorage = (0, $9kyGZ.getLocalStorage)(view);
    const hierarchyStorageKey = `${entity.id}_${(0, $ed82405237805b60$export$2cab30374aa79c41)}`;
    const [hierarchyLevels, setHierarchyLevels] = (0, $eUqFw.useState)(localStorage.get(hierarchyStorageKey));
    // save hierarchyLevels in localStorage
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !error) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(hierarchyLevels, newHierarchyLevels)) {
                setHierarchyLevels(newHierarchyLevels);
                localStorage.set(hierarchyStorageKey, newHierarchyLevels);
            }
        }
    }, [
        loading,
        error,
        hierarchyLevels,
        hierarchyStorageKey,
        setHierarchyLevels,
        localStorage,
        newHierarchyLevels
    ]);
    const hierarchyLevelsWithCache = (0, $eUqFw.useMemo)(()=>{
        // return from cache (localStorage)
        if (hierarchyLevels && Array.isArray(hierarchyLevels)) return hierarchyLevels;
        // returns nothing if available fields query is in progress. But if cache is empty, it returns newHierarchyLevels
        if (loading) return [];
        return newHierarchyLevels;
    }, [
        hierarchyLevels,
        loading,
        newHierarchyLevels
    ]);
    return {
        hierarchyLevelsWithCache: hierarchyLevelsWithCache
    };
};

});
const $ed82405237805b60$export$2cab30374aa79c41 = 'hierarchy_levels';

parcelRegister("9kyGZ", function(module, exports) {

$parcel$export(module.exports, "getLocalStorage", () => $f21eb66b21e85710$export$d3720feff416e85b);

var $aZaPn = parcelRequire("aZaPn");
const $f21eb66b21e85710$export$d3720feff416e85b = (view)=>(0, $aZaPn.createLocalStorageProvider)(`jira_business_${view}-view`);

});


parcelRegister("1Te3F", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CUSTOM_FIELDS_BY_TYPE", () => $16df7b8e3a965f2e$export$5150e2d13825462d);
$parcel$export(module.exports, "getInitVisibleFields", () => $16df7b8e3a965f2e$export$86172108eb1873dd);
$parcel$export(module.exports, "getAlwaysVisibleFields", () => $16df7b8e3a965f2e$export$de476ed52b559d9);
$parcel$export(module.exports, "useConstants", () => $16df7b8e3a965f2e$export$eedf91b09a0fe0d1);

var $eUqFw = parcelRequire("eUqFw");

var $3555e = parcelRequire("3555e");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $8lNor = parcelRequire("8lNor");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $egJIx = parcelRequire("egJIx");

var $kT5zt = parcelRequire("kT5zt");
const $16df7b8e3a965f2e$export$5150e2d13825462d = [
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.SPRINT_TYPE)
];
const $16df7b8e3a965f2e$export$86172108eb1873dd = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>[
        (0, $lO4Or.ISSUE_TYPE),
        'key',
        (0, $lO4Or.SUMMARY_TYPE),
        (0, $lO4Or.STATUS_TYPE),
        isCategoryEnabled ? (0, $lO4Or.CATEGORY_TYPE) : undefined,
        isScrumProject ? (0, $lO4Or.SPRINT_TYPE) : undefined,
        (0, $lO4Or.ASSIGNEE_TYPE),
        (0, $lO4Or.DUE_DATE_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.CREATED),
        (0, $lO4Or.UPDATED),
        (0, $lO4Or.REPORTER_TYPE)
    ].filter(Boolean);
const $16df7b8e3a965f2e$export$db265ae985088fd7 = ({ isCategoryEnabled: isCategoryEnabled = true, isScrumProject: isScrumProject = false })=>({
        [(0, $lO4Or.ISSUE_TYPE)]: true,
        key: true,
        [(0, $lO4Or.SUMMARY_TYPE)]: true,
        [(0, $lO4Or.STATUS_TYPE)]: true,
        ...isCategoryEnabled ? {
            [(0, $lO4Or.CATEGORY_TYPE)]: true
        } : {},
        ...isScrumProject ? {
            [(0, $lO4Or.SPRINT_TYPE)]: true
        } : {},
        [(0, $lO4Or.ASSIGNEE_TYPE)]: true,
        [(0, $lO4Or.DUE_DATE_TYPE)]: true,
        [(0, $lO4Or.PRIORITY_TYPE)]: true,
        [(0, $lO4Or.LABELS_TYPE)]: true,
        [(0, $lO4Or.CREATED)]: true,
        [(0, $lO4Or.UPDATED)]: true,
        [(0, $lO4Or.REPORTER_TYPE)]: true
    });
const $16df7b8e3a965f2e$export$de476ed52b559d9 = ()=>[
        (0, $lO4Or.ISSUE_TYPE),
        'key',
        (0, $lO4Or.SUMMARY_TYPE)
    ];
const $16df7b8e3a965f2e$export$e4330d77fd93d1de = ({ defaultVisibleFields: defaultVisibleFields, hasConfluence: hasConfluence = false, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled = false, isBusinessFieldsEnabled: isBusinessFieldsEnabled = true, isTeamManaged: isTeamManaged = true, isScrumProject: isScrumProject = false } = {})=>Object.keys(defaultVisibleFields ?? $16df7b8e3a965f2e$export$db265ae985088fd7({
        isCategoryEnabled: isBusinessFieldsEnabled,
        isScrumProject: isScrumProject
    })).concat([
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.TIME_ESTIMATE_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $jGcn0.COMMENT_SUMMARY_TYPE)
    ]).concat(isSoftwareFieldsEnabled && isTeamManaged ? [
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)
    ] : []).concat(isSoftwareFieldsEnabled && !isTeamManaged ? [
        (0, $lO4Or.STORY_POINTS_TYPE)
    ] : []).concat(isSoftwareFieldsEnabled && !isScrumProject ? [
        (0, $lO4Or.SPRINT_TYPE)
    ] : []).concat(hasConfluence ? [
        (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)
    ] : []).concat((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $8lNor.getSupportedFieldTypes)(isSoftwareFieldsEnabled) : []);
const $16df7b8e3a965f2e$export$c7b8f0505fa10763 = (hasConfluence)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useMemo)(()=>[
            {
                id: 'key',
                type: 'key',
                name: formatMessage((0, $kT5zt.default).key),
                issueTypes: [],
                fieldConfig: {
                    isRequired: true,
                    isEditable: false
                }
            },
            {
                id: (0, $jGcn0.COMMENT_SUMMARY_TYPE),
                type: (0, $jGcn0.COMMENT_SUMMARY_TYPE),
                name: formatMessage((0, $kT5zt.default).comments),
                issueTypes: [],
                fieldConfig: {
                    isRequired: true,
                    isEditable: false
                }
            },
            ...hasConfluence ? [
                {
                    id: (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
                    type: (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
                    name: formatMessage((0, $kT5zt.default).confluencePages),
                    issueTypes: [],
                    fieldConfig: (0, $eI5EY.fg)('jira_list_keyboard_nav') ? {
                        isRequired: false,
                        isEditable: true
                    } : {
                        isRequired: true,
                        isEditable: false
                    }
                }
            ] : []
        ], [
        formatMessage,
        hasConfluence
    ]);
};
const $16df7b8e3a965f2e$export$eedf91b09a0fe0d1 = ()=>{
    const hasConfluence = (0, $3555e.useTenantHasConfluence)();
    const projectData = (0, $kQAZu.useProject)();
    const isTeamManaged = projectData.isSimplified;
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled, isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const missingFields = $16df7b8e3a965f2e$export$c7b8f0505fa10763(hasConfluence);
    return (0, $eUqFw.useMemo)(()=>{
        const defaultVisibleFields = $16df7b8e3a965f2e$export$db265ae985088fd7({
            isCategoryEnabled: isBusinessFieldsEnabled,
            isScrumProject: isScrumProject
        });
        const alwaysVisibleFields = $16df7b8e3a965f2e$export$de476ed52b559d9();
        const supportedFieldTypes = $16df7b8e3a965f2e$export$e4330d77fd93d1de({
            defaultVisibleFields: defaultVisibleFields,
            hasConfluence: hasConfluence,
            isSoftwareFieldsEnabled: isSoftwareFieldsEnabled,
            isBusinessFieldsEnabled: isBusinessFieldsEnabled,
            isTeamManaged: isTeamManaged,
            isScrumProject: isScrumProject
        });
        return {
            DEFAULT_VISIBLE_FIELDS: defaultVisibleFields,
            ALWAYS_VISIBLE_FIELDS: alwaysVisibleFields,
            SUPPORTED_FIELD_TYPES: supportedFieldTypes,
            MISSING_FIELDS: missingFields
        };
    }, [
        isBusinessFieldsEnabled,
        hasConfluence,
        isSoftwareFieldsEnabled,
        isTeamManaged,
        isScrumProject,
        missingFields
    ]);
};

});
parcelRegister("8lNor", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldTypes", () => $e1580c6b5fbd09d7$export$e4330d77fd93d1de);
$parcel$export(module.exports, "newInitVisibleFields", () => $e1580c6b5fbd09d7$export$e8fa0cca823ce465);
$parcel$export(module.exports, "isSupportedTypePredicated", () => $e1580c6b5fbd09d7$export$6868d04e3954dca5);
$parcel$export(module.exports, "getTopLevelFieldKey", () => $e1580c6b5fbd09d7$export$5a7b6a57d325d92);
$parcel$export(module.exports, "isTopLevelField", () => $e1580c6b5fbd09d7$export$9ce71a7c226d8918);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $aqWRZ = parcelRequire("aqWRZ");

var $ajiYT = parcelRequire("ajiYT");

var $cQ6i7 = parcelRequire("cQ6i7");

var $9wDFL = parcelRequire("9wDFL");

var $8q0ZE = parcelRequire("8q0ZE");

var $fVV9q = parcelRequire("fVV9q");

var $6FuLp = parcelRequire("6FuLp");

var $843w3 = parcelRequire("843w3");

var $2yqHU = parcelRequire("2yqHU");

var $csNv4 = parcelRequire("csNv4");

var $iAXnP = parcelRequire("iAXnP");
const $e1580c6b5fbd09d7$export$e4330d77fd93d1de = (0, $5iWql.default)((isSoftwareFieldsEnabled)=>[
        ...(0, $8q0ZE.parentSupportedTypes),
        ...(0, $csNv4.teamSupportedTypes),
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? [
            ...(0, $843w3.resolutionSupportedTypes),
            ...(0, $9wDFL.groupSupportedTypes),
            ...(0, $2yqHU.statusCategorySupportedTypes),
            ...(0, $fVV9q.projectSupportedTypes),
            ...(0, $aqWRZ.cascadingSelectSupportedTypes),
            ...(0, $6FuLp.radioSelectSupportedTypes)
        ] : [],
        ...(0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? (0, $cQ6i7.goalsSupportedTypes) : [],
        ...isSoftwareFieldsEnabled ? [
            ...(0, $ajiYT.devSummarySupportedTypes),
            ...(0, $iAXnP.versionSupportedTypes)
        ] : []
    ]);
const $e1580c6b5fbd09d7$export$e8fa0cca823ce465 = (0, $5iWql.default)((isSoftwareFieldsEnabled)=>[
        ...(0, $8q0ZE.parentSupportedTypes),
        ...(0, $csNv4.teamSupportedTypes),
        ...isSoftwareFieldsEnabled ? [
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            ...(0, $ajiYT.devSummarySupportedTypes)
        ] : []
    ]);
const $e1580c6b5fbd09d7$export$6868d04e3954dca5 = (fieldType, isSoftwareFieldsEnabled = true)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e1580c6b5fbd09d7$export$e4330d77fd93d1de(isSoftwareFieldsEnabled).includes(fieldType);
// top level field
const $e1580c6b5fbd09d7$var$TOP_LEVEL_FIELD = [
    ...(0, $ajiYT.devSummarySupportedTypes)
];
const $e1580c6b5fbd09d7$var$isValidTopFieldType = (typename)=>true;
const $e1580c6b5fbd09d7$export$5a7b6a57d325d92 = (fieldType)=>{
    if (!fieldType || !$e1580c6b5fbd09d7$var$isValidTopFieldType(fieldType)) return null;
    if ((0, $ajiYT.devSummarySupportedTypes).includes(fieldType)) return 0, $c12b99091b418650$export$72b5bd2391f1e7c0;
    return null;
};
const $e1580c6b5fbd09d7$export$9ce71a7c226d8918 = (fieldType)=>{
    if (!fieldType || !$e1580c6b5fbd09d7$var$isValidTopFieldType(fieldType)) return false;
    return $e1580c6b5fbd09d7$var$TOP_LEVEL_FIELD.includes(fieldType);
};

});
parcelRegister("aqWRZ", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectSupportedTypes", () => $e102388129376b5f$export$caf76d0a4f04f1d);

var $lO4Or = parcelRequire("lO4Or");
const $e102388129376b5f$export$caf76d0a4f04f1d = [
    (0, $lO4Or.CASCADING_SELECT_CF_TYPE)
];

});

const $c12b99091b418650$export$72b5bd2391f1e7c0 = 'devSummary';

parcelRegister("ajiYT", function(module, exports) {

$parcel$export(module.exports, "devSummarySupportedTypes", () => $4a9102c9a6a79121$export$22d58d85f8d7faea);

var $lO4Or = parcelRequire("lO4Or");
const $4a9102c9a6a79121$export$22d58d85f8d7faea = [
    (0, $lO4Or.DEV_SUMMARY_CF_TYPE)
];

});

parcelRegister("cQ6i7", function(module, exports) {

$parcel$export(module.exports, "goalsSupportedTypes", () => $1c027395f8e7b4db$export$bc170bcdefb8333f);

var $lO4Or = parcelRequire("lO4Or");
const $1c027395f8e7b4db$export$bc170bcdefb8333f = [
    (0, $lO4Or.GOALS_CF_TYPE)
];

});

parcelRegister("9wDFL", function(module, exports) {

$parcel$export(module.exports, "groupSupportedTypes", () => $fe1c565660b1662c$export$f3ef0b84bd022156);

var $lO4Or = parcelRequire("lO4Or");
const $fe1c565660b1662c$export$f3ef0b84bd022156 = [
    (0, $lO4Or.GROUP_CF_TYPE),
    (0, $lO4Or.MULTI_GROUP_CF_TYPE)
];

});

parcelRegister("8q0ZE", function(module, exports) {

$parcel$export(module.exports, "parentSupportedTypes", () => $52aa9997ad392f5e$export$cc8590a96c2280c);

var $lO4Or = parcelRequire("lO4Or");
const $52aa9997ad392f5e$export$cc8590a96c2280c = [
    (0, $lO4Or.PARENT_TYPE)
];

});

parcelRegister("fVV9q", function(module, exports) {

$parcel$export(module.exports, "projectSupportedTypes", () => $26131322fb8e449c$export$ecab9c2d3c8390e9);

var $lO4Or = parcelRequire("lO4Or");
const $26131322fb8e449c$export$ecab9c2d3c8390e9 = [
    (0, $lO4Or.PROJECT_PICKER_CF_TYPE)
];

});

parcelRegister("6FuLp", function(module, exports) {

$parcel$export(module.exports, "radioSelectSupportedTypes", () => $aa04aa8aa7506338$export$a92ad538b45df386);

var $lO4Or = parcelRequire("lO4Or");
const $aa04aa8aa7506338$export$a92ad538b45df386 = [
    (0, $lO4Or.RADIO_BUTTONS_CF_TYPE)
];

});

parcelRegister("843w3", function(module, exports) {

$parcel$export(module.exports, "resolutionSupportedTypes", () => $2fdff68ebbb5c1de$export$89876769ad40213e);

var $lO4Or = parcelRequire("lO4Or");
const $2fdff68ebbb5c1de$export$89876769ad40213e = [
    (0, $lO4Or.RESOLUTION_TYPE)
];

});

parcelRegister("2yqHU", function(module, exports) {

$parcel$export(module.exports, "statusCategorySupportedTypes", () => $04bd63d71e65897e$export$ce1a6f07ee0c2fd4);

var $lO4Or = parcelRequire("lO4Or");
const $04bd63d71e65897e$export$ce1a6f07ee0c2fd4 = [
    (0, $lO4Or.STATUS_CATEGORY_TYPE)
];

});

parcelRegister("csNv4", function(module, exports) {

$parcel$export(module.exports, "teamSupportedTypes", () => $ae82114964792b44$export$7fe9ceb0183f4a3e);

var $lO4Or = parcelRequire("lO4Or");
const $ae82114964792b44$export$7fe9ceb0183f4a3e = [
    (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)
];

});

parcelRegister("iAXnP", function(module, exports) {

$parcel$export(module.exports, "versionSupportedTypes", () => $c8c09a423c8a5fac$export$c35776c44a9e8a18);

var $lO4Or = parcelRequire("lO4Or");
const $c8c09a423c8a5fac$export$c35776c44a9e8a18 = [
    (0, $lO4Or.VERSION_CF_TYPE),
    (0, $lO4Or.MULTI_VERSION_CF_TYPE),
    (0, $lO4Or.FIX_VERSIONS_TYPE),
    (0, $lO4Or.AFFECTS_VERSIONS_TYPE)
];

});


parcelRegister("kT5zt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a59112d86e42fafe$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a59112d86e42fafe$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    key: {
        "id": "business-list.controllers.get-issue-fields.constants.key",
        "defaultMessage": "Key"
    },
    comments: {
        "id": "business-list.controllers.get-issue-fields.constants.comments",
        "defaultMessage": "Comments"
    },
    confluencePages: {
        "id": "business-list.controllers.get-issue-fields.constants.confluence-pages",
        "defaultMessage": "Confluence pages"
    }
});

});


parcelRegister("6hN2s", function(module, exports) {

$parcel$export(module.exports, "useUpdateFieldsDetail", () => $bbcd9cbd736a28e7$export$33428c970fa4bad3);
$parcel$export(module.exports, "useFieldsActions", () => $bbcd9cbd736a28e7$export$4027818e87c46ba5);
$parcel$export(module.exports, "useFieldsActionsOld", () => $bbcd9cbd736a28e7$export$b2e53e8897fe7ef8);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $41WOo = parcelRequire("41WOo");

var $8lNor = parcelRequire("8lNor");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $iGdkQ = parcelRequire("iGdkQ");

var $egJIx = parcelRequire("egJIx");

var $lAcL9 = parcelRequire("lAcL9");

var $1Te3F = parcelRequire("1Te3F");

var $9aDlc = parcelRequire("9aDlc");
const $bbcd9cbd736a28e7$var$getFieldsCache = ({ availableFields: availableFields, fields: fields, order: order })=>{
    if (availableFields == null) return fields.details;
    const newDetails = {};
    availableFields.forEach(({ id: id, name: name, type: type })=>{
        if (order.includes(id)) newDetails[id] = {
            id: id,
            name: name,
            type: type
        };
        else if (type != null && order.includes(type)) newDetails[type] = {
            id: id,
            name: name,
            type: type
        };
    });
    return newDetails;
};
const $bbcd9cbd736a28e7$var$NEW_FIELDS_ONBOARDING_LOCAL_STORAGE_KEY = 'list_new_fields_onboarding';
const $bbcd9cbd736a28e7$export$33428c970fa4bad3 = (availableFields)=>{
    const [fields, setFields] = (0, $9aDlc.useFieldsPreference)();
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const { isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const newFieldsOnboardingStorageKey = `${entity.id}_${$bbcd9cbd736a28e7$var$NEW_FIELDS_ONBOARDING_LOCAL_STORAGE_KEY}`;
    (0, $eUqFw.useEffect)(()=>{
        if (availableFields != null) {
            /*
                ---- START ----
                This part of the code is just for the onboarding of the new fields
                should be removed when we do the clean up of: jsw_list_view_-_all_the_fields
            */ const isOnboardingDone = (0, $iGdkQ.localStorage).get(newFieldsOnboardingStorageKey);
            if (!isOnboardingDone && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
                const newFields = availableFields.filter((field)=>field.type && (0, $8lNor.isSupportedTypePredicated)(field.type, isScrumProject) ? (0, $8lNor.newInitVisibleFields)(isScrumProject).includes(field.type) : false).map((field)=>field.id);
                const newFieldsOrder = [
                    ...fields.order,
                    ...newFields
                ];
                setFields({
                    order: newFieldsOrder,
                    details: $bbcd9cbd736a28e7$var$getFieldsCache({
                        availableFields: availableFields,
                        fields: fields,
                        order: newFieldsOrder
                    })
                });
                (0, $iGdkQ.localStorage).set(newFieldsOnboardingStorageKey, true);
            /* ---- END ---- */ } else setFields({
                order: fields.order,
                details: $bbcd9cbd736a28e7$var$getFieldsCache({
                    order: fields.order,
                    fields: fields,
                    availableFields: availableFields
                })
            });
        }
    // We only want to update cache when available fields change the first time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        availableFields,
        newFieldsOnboardingStorageKey
    ]);
};
const $bbcd9cbd736a28e7$export$4027818e87c46ba5 = (availableFields)=>{
    const [fields, setFields, setFieldsOld] = (0, $9aDlc.useFieldsPreference)();
    let createFields;
    let createIndex;
    if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    [{ createIndex: createIndex, createFields: createFields }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const resetCache = (0, $eUqFw.useCallback)(()=>{
        setFields(undefined);
        setFieldsOld(undefined);
    }, [
        setFields,
        setFieldsOld
    ]);
    const reorderFields = (0, $eUqFw.useCallback)(({ visibleFields: visibleFields, oldIndex: oldIndex, newIndex: newIndex })=>{
        try {
            if (oldIndex === newIndex) return;
            let oldFieldIndex = oldIndex;
            let newFieldIndex = newIndex;
            if (newFieldIndex < 3) /*
                    moving column to:
                    - the first position it's not possible due to the bulk selection
                    - the second position it's not possible because the type issue should not be repositioned
                    - the third position it's not possible because the key issue should not be repositioned
                */ return;
            // We have an extra column at the beginning for bulk selection
            // that should be considered to reorder fields
            oldFieldIndex -= 1;
            newFieldIndex -= 1;
            const reorderedFields = [
                ...visibleFields
            ];
            const [reorderedField] = reorderedFields.splice(oldFieldIndex, 1);
            reorderedFields.splice(newFieldIndex, 0, reorderedField);
            // visibleFields is initially set by DEFAULT_VISIBLE_FIELDS which are type based
            // we need to keep it consistent for those fields as getAvailableFields finds this field by type
            const fieldsOrder = reorderedFields.map((field)=>field?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(field.type) ? field.type : field.id);
            setFields({
                ...fields,
                order: fieldsOrder
            });
        } catch (error) {
            resetCache();
            (0, $guiFP.default)({
                meta: {
                    id: 'reorderFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to reorder the fields'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        fields,
        resetCache,
        setFields
    ]);
    const toggleField = (0, $eUqFw.useCallback)((fieldId)=>{
        try {
            const isVisible = fields.order.includes(fieldId);
            const newFieldsOrder = [
                ...fields.order
            ];
            let createColumnIndex = createIndex;
            if (createFields) {
                const createField = createFields.find((f)=>f.fieldId === fieldId);
                createColumnIndex = createField?.createIndex ?? createColumnIndex;
            }
            if (!isVisible) {
                if ((0, $41WOo.isJwmInlineFieldCreateEnabled)() && typeof createColumnIndex !== 'undefined') newFieldsOrder.splice(createColumnIndex, 0, fieldId);
                else newFieldsOrder.push(fieldId);
            } else {
                const fieldIndex = newFieldsOrder.findIndex((fId)=>fId === fieldId);
                if (fieldIndex >= 0) newFieldsOrder.splice(fieldIndex, 1);
            }
            setFields({
                order: newFieldsOrder,
                details: $bbcd9cbd736a28e7$var$getFieldsCache({
                    availableFields: availableFields,
                    fields: fields,
                    order: newFieldsOrder
                })
            });
        } catch (error) {
            resetCache();
            (0, $guiFP.default)({
                meta: {
                    id: 'toggleFields',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Error trying to toogle a field'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        fields,
        createIndex,
        createFields,
        setFields,
        availableFields,
        resetCache
    ]);
    return {
        fields: fields,
        toggleField: toggleField,
        reorderFields: reorderFields,
        resetCache: resetCache
    };
};
const $bbcd9cbd736a28e7$export$b2e53e8897fe7ef8 = ()=>{
    const [fields, setFields] = (0, $9aDlc.useFieldsPreferenceOld)();
    let createFields;
    let createIndex;
    if ((0, $41WOo.isJwmInlineFieldCreateEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    [{ createIndex: createIndex, createFields: createFields }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const reorderFields = (0, $eUqFw.useCallback)(({ visibleFields: visibleFields, oldIndex: oldIndex, newIndex: newIndex })=>{
        if (oldIndex === newIndex) return;
        let oldFieldIndex = oldIndex;
        let newFieldIndex = newIndex;
        if (newFieldIndex < 3) /*
                moving column to:
                - the first position it's not possible due to the bulk selection
                - the second position it's not possible because the type issue should not be repositioned
                - the third position it's not possible because the key issue should not be repositioned
            */ return;
        // We have an extra column at the beginning for bulk selection
        // that should be considered to reorder fields
        oldFieldIndex -= 1;
        newFieldIndex -= 1;
        const reorderedFields = [
            ...visibleFields
        ];
        const [reorderedField] = reorderedFields.splice(oldFieldIndex, 1);
        reorderedFields.splice(newFieldIndex, 0, reorderedField);
        // visibleFields is initially set by DEFAULT_VISIBLE_FIELDS which are type based
        // we need to keep it consistent for those fields as getAvailableFields finds this field by type
        const fieldsOrder = reorderedFields.map((field)=>field?.type && (0, $1Te3F.DEFAULT_CUSTOM_FIELDS_BY_TYPE).includes(field.type) ? field.type : field.id);
        setFields(fieldsOrder);
    }, [
        setFields
    ]);
    const toggleField = (0, $eUqFw.useCallback)((fieldId)=>{
        const isVisible = fields.includes(fieldId);
        const newFields = [
            ...fields
        ];
        let createColumnIndex = createIndex;
        if (createFields) {
            const createField = createFields.find((field)=>field.fieldId === fieldId);
            createColumnIndex = createField?.createIndex ?? createColumnIndex;
        }
        if (!isVisible) {
            if ((0, $41WOo.isJwmInlineFieldCreateEnabled)() && typeof createColumnIndex !== 'undefined') newFields.splice(createColumnIndex, 0, fieldId);
            else newFields.push(fieldId);
        } else {
            const fieldIndex = newFields.findIndex((field)=>field === fieldId);
            if (fieldIndex >= 0) newFields.splice(fieldIndex, 1);
        }
        setFields(newFields);
    }, [
        fields,
        createFields,
        createIndex,
        setFields
    ]);
    return {
        fields: fields,
        toggleField: toggleField,
        reorderFields: reorderFields
    };
};

});
parcelRegister("lAcL9", function(module, exports) {

$parcel$export(module.exports, "useInlineFieldCreateControls", () => $3647fb1ffdff85af$export$d98d27d7d9c6b61f);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $3647fb1ffdff85af$var$actions = {
    setIsSelected: (isSelected)=>({ setState: setState })=>{
            setState({
                isSelected: isSelected
            });
        },
    setCreateIndex: (columnIndex)=>({ setState: setState })=>{
            setState({
                createIndex: columnIndex !== undefined ? columnIndex + 1 : undefined
            });
        },
    clearCreateIndex: ()=>({ setState: setState })=>{
            setState({
                createIndex: undefined
            });
        },
    addCreateField: ({ fieldId: fieldId, name: name, type: type })=>({ setState: setState, getState: getState })=>{
            setState({
                createFields: [
                    ...getState().createFields,
                    {
                        fieldId: fieldId,
                        name: name,
                        type: type,
                        createIndex: getState().createIndex
                    }
                ]
            });
        },
    removeCreateField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                createFields: [
                    ...getState().createFields.filter((field)=>field.fieldId !== fieldId)
                ]
            });
        }
};
const $3647fb1ffdff85af$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isSelected: false,
        createIndex: undefined,
        createFields: []
    },
    actions: $3647fb1ffdff85af$var$actions,
    name: 'JwmListInlineFieldCreate'
});
const $3647fb1ffdff85af$export$d98d27d7d9c6b61f = (0, $ggKAj.createHook)($3647fb1ffdff85af$var$Store);

});

parcelRegister("9aDlc", function(module, exports) {

$parcel$export(module.exports, "useFieldsPreference", () => $5966853789054e24$export$46ce869a6df40a8b);
$parcel$export(module.exports, "useFieldsPreferenceOld", () => $5966853789054e24$export$4a17407108f98215);

var $eUqFw = parcelRequire("eUqFw");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $egJIx = parcelRequire("egJIx");

var $1Te3F = parcelRequire("1Te3F");
const $5966853789054e24$export$46ce869a6df40a8b = ()=>{
    const [fields, setFieldsOld] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_PREFERENCE));
    const [fieldsDetail, setFields] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_DETAIL_PREFERENCE));
    const { isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const fieldsPreferences = (0, $eUqFw.useMemo)(()=>{
        if (fieldsDetail == null && fields != null) return {
            order: fields,
            details: null
        };
        if (fieldsDetail == null || !Array.isArray(fieldsDetail.order)) return {
            order: (0, $1Te3F.getInitVisibleFields)({
                isCategoryEnabled: isBusinessFieldsEnabled,
                isScrumProject: isScrumProject
            }),
            details: null
        };
        return fieldsDetail;
    }, [
        fieldsDetail,
        fields,
        isBusinessFieldsEnabled,
        isScrumProject
    ]);
    return [
        fieldsPreferences,
        setFields,
        setFieldsOld
    ];
};
const $5966853789054e24$export$4a17407108f98215 = ()=>{
    const [fields, setFields] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FIELDS_PREFERENCE));
    const { isBusinessFieldsEnabled: isBusinessFieldsEnabled, isScrumProject: isScrumProject } = (0, $egJIx.useJWMListFeatures)();
    const fieldsPreferences = (0, $eUqFw.useMemo)(()=>{
        if (fields == null || !Array.isArray(fields)) return (0, $1Te3F.getInitVisibleFields)({
            isCategoryEnabled: isBusinessFieldsEnabled,
            isScrumProject: isScrumProject
        });
        return fields;
    }, [
        fields,
        isBusinessFieldsEnabled,
        isScrumProject
    ]);
    return [
        fieldsPreferences,
        setFields
    ];
};

});


parcelRegister("6HSAr", function(module, exports) {

$parcel$export(module.exports, "useFieldsCache", () => $1a91a98110c84b08$export$2fa1686d7312ac20);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $fDLFb = parcelRequire("fDLFb");

var $iGdkQ = parcelRequire("iGdkQ");
const $1a91a98110c84b08$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY = 'query_fields_id';
const $1a91a98110c84b08$export$2fa1686d7312ac20 = ({ loading: loading, error: error, getQueryFieldIds: getQueryFieldIds })=>{
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const queryFieldsStorageKey = `${entity.id}_${$1a91a98110c84b08$var$QUERY_FIELDS_ID_LOCAL_STORAGE_KEY}`;
    const [queryFieldIds, setQueryFieldsIds] = (0, $eUqFw.useState)((0, $iGdkQ.localStorage).get(queryFieldsStorageKey));
    // save queryFieldIds in localStorage on initial page load when queryFieldIds are empty in localStorage
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && !error) {
            const newQueryFieldIds = getQueryFieldIds();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryFieldIds, newQueryFieldIds)) {
                setQueryFieldsIds(newQueryFieldIds);
                (0, $iGdkQ.localStorage).set(queryFieldsStorageKey, newQueryFieldIds);
            }
        }
    }, [
        loading,
        error,
        getQueryFieldIds,
        queryFieldsStorageKey,
        queryFieldIds,
        setQueryFieldsIds
    ]);
    const getQueryFieldIdsWithCache = (0, $eUqFw.useCallback)(()=>{
        // return from cache (localStorage)
        if (queryFieldIds && Array.isArray(queryFieldIds)) return queryFieldIds;
        // returns nothing if available fields query is in progress. But if cache is empty, it calls getQueryFieldIds
        if (loading) return [];
        return getQueryFieldIds();
    }, [
        getQueryFieldIds,
        loading,
        queryFieldIds
    ]);
    return {
        getQueryFieldIdsWithCache: getQueryFieldIdsWithCache
    };
};

});


parcelRegister("6IRtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d52b6cf42a4f59$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e3d52b6cf42a4f59$var$GroupUpdater = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9YfbS")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/group-updater/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3d52b6cf42a4f59$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-group-updater",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3d52b6cf42a4f59$var$GroupUpdater, props));

});
parcelRegister("9YfbS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('Dnl01');
        const value = parcelRequire('c4reD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("Dnl01").then(()=>parcelRequire('c4reD'));
}

});


parcelRegister("h8g5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0388c01def4135b6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dSE3z = parcelRequire("dSE3z");

var $2fYxG = parcelRequire("2fYxG");

var $xqSqx = parcelRequire("xqSqx");

var $kBwul = parcelRequire("kBwul");
const $0388c01def4135b6$var$Hierarchy = ()=>{
    const { childrenLoader: childrenLoader } = (0, $2fYxG.useChildrenLoader)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    // avoid re-fetching children when Hierarchy component re-renders
    const childItemsLoader = (0, $eUqFw.useMemo)(()=>childrenLoader, [
        childrenLoader
    ]);
    const shouldGroupItems = groupByFieldId != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldGroupItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xqSqx.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kBwul.default), null), childItemsLoader);
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$0388c01def4135b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0388c01def4135b6$var$Hierarchy);

});
parcelRegister("2fYxG", function(module, exports) {

$parcel$export(module.exports, "useChildrenLoader", () => $fe41b4f14de4bba7$export$10e8857fe2182cb4);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");

var $nxBOY = parcelRequire("nxBOY");
var $4oWxH = parcelRequire("4oWxH");
var $7Sz8O = parcelRequire("7Sz8O");

var $1ybV0 = parcelRequire("1ybV0");

var $dYkSU = parcelRequire("dYkSU");

var $5r9Wo = parcelRequire("5r9Wo");

var $iGWrT = parcelRequire("iGWrT");
const $fe41b4f14de4bba7$export$10e8857fe2182cb4 = ()=>{
    const [{ expandedItems: expandedItems, childrenItems: childrenItems, issuesMap: issuesMap }] = (0, $5r9Wo.useHierarchyStore)();
    const { data: data } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const { setChildrenItems: setChildrenItems } = (0, $iGWrT.useSetChildrenItems)();
    const getHierarchyLevel = (0, $eUqFw.useCallback)((issueId)=>{
        const maybeIssue = issuesMap.get(issueId);
        if (!maybeIssue) return undefined;
        const maybeIssueTypeData = data.issueTypes.find((issueType)=>issueType.id === maybeIssue.issuetype.id);
        if (!maybeIssueTypeData) return undefined;
        return maybeIssueTypeData.hierarchyLevel;
    }, [
        data.issueTypes,
        issuesMap
    ]);
    const childrenLoader = (0, $eUqFw.useMemo)(()=>{
        const expandedItemIssueIds = Object.keys(expandedItems).filter((issueId)=>!(0, $4oWxH.isGroupItem)(issueId) && // exclude optimistically created items that'd immediately be expanded when "Expand All" is on
            String(issueId) !== String((0, $7Sz8O.OPTIMISTIC_ISSUE_ID)));
        const featureFlaggedProps = (0, $1ybV0.ff)('jwm.remove-list-view-bulk-query') ? {
            ChildQueryController: (0, $dYkSU.ListViewChildQueryController)
        } : {
            ChildQueryControllerBulk: (0, $dYkSU.ListViewChildQueryBulkController)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nxBOY.ChildrenController), {
            ...featureFlaggedProps,
            expandedItemIssueIds: expandedItemIssueIds,
            loadingIssueIds: expandedItemIssueIds.filter((expandedItemId)=>!childrenItems[expandedItemId] || childrenItems[expandedItemId].loading),
            setChildrenQueryData: setChildrenItems,
            getHierarchyLevel: getHierarchyLevel
        });
    }, [
        expandedItems,
        setChildrenItems,
        getHierarchyLevel,
        childrenItems
    ]);
    return {
        childrenLoader: childrenLoader
    };
};

});
parcelRegister("nxBOY", function(module, exports) {

$parcel$export(module.exports, "ChildrenController", () => $f44a906179e22f72$export$8c3512dd18e9e8f);

var $eUqFw = parcelRequire("eUqFw");

const $f44a906179e22f72$export$8c3512dd18e9e8f = /*#__PURE__*/ (0, $eUqFw.memo)(({ expandedItemIssueIds: expandedItemIssueIds, loadingIssueIds: loadingIssueIds, setChildrenQueryData: setChildrenQueryData, ChildQueryController: ChildQueryController, ChildQueryControllerBulk: ChildQueryControllerBulk, getHierarchyLevel: getHierarchyLevel })=>{
    const onDataChange = (0, $eUqFw.useCallback)((parentIssueIds, { data: data, ...rest })=>{
        parentIssueIds.forEach((parentIssueId)=>{
            if (loadingIssueIds?.includes(parentIssueId) || data[parentIssueId]) setChildrenQueryData(parentIssueId, {
                ...rest,
                ...data[parentIssueId] ? {
                    data: data[parentIssueId]
                } : {}
            });
        });
    }, [
        setChildrenQueryData,
        loadingIssueIds
    ]);
    if (ChildQueryControllerBulk) {
        const hasLoadingChildren = !!loadingIssueIds?.length;
        const parentIssueIds = hasLoadingChildren ? loadingIssueIds : expandedItemIssueIds;
        const hierarchyLevels = parentIssueIds.map((issueId)=>getHierarchyLevel?.(issueId));
        const uniqueHierarchyLevels = [
            ...new Set(hierarchyLevels)
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildQueryControllerBulk, {
            hasLoadingChildren: hasLoadingChildren,
            parentIssueIds: parentIssueIds,
            parentHierarchyType: (0, $2a7b21c0842403e6$export$9355e489ad16f98e),
            onDataChange: onDataChange,
            parentHierarchyLevels: uniqueHierarchyLevels
        });
    }
    if (ChildQueryController) return expandedItemIssueIds.map((expandedItemIssueId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChildQueryController, {
            parentIssueId: expandedItemIssueId,
            parentHierarchyType: (0, $2a7b21c0842403e6$export$9355e489ad16f98e),
            parentHierarchyLevel: getHierarchyLevel ? getHierarchyLevel(expandedItemIssueId) : undefined,
            onDataChange: setChildrenQueryData,
            key: expandedItemIssueId
        }));
}, (prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedItemIssueIds.sort();
    const prevLoadingIssueIds = prevProps.loadingIssueIds?.sort();
    const nextLoadingIssueIds = nextProps.loadingIssueIds?.sort();
    let loadingIssuesMatch = true;
    if (prevLoadingIssueIds === undefined || nextLoadingIssueIds === undefined) loadingIssuesMatch = prevLoadingIssueIds === nextLoadingIssueIds;
    else loadingIssuesMatch = prevLoadingIssueIds?.length === nextLoadingIssueIds?.length && prevLoadingIssueIds.every((_, id)=>prevLoadingIssueIds[id] === nextLoadingIssueIds[id]);
    return prevProps.setChildrenQueryData === nextProps.setChildrenQueryData && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]) && loadingIssuesMatch;
});

});

parcelRegister("dYkSU", function(module, exports) {

$parcel$export(module.exports, "ListViewChildQueryController", () => $a375fdd86ab2d782$export$fffae14cb4664bb4);
$parcel$export(module.exports, "ListViewChildQueryBulkController", () => $a375fdd86ab2d782$export$89ce1cfdc4eecbef);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $aVwtE = parcelRequire("aVwtE");

var $1ybV0 = parcelRequire("1ybV0");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $f8ADw = parcelRequire("f8ADw");

var $hHiDc = parcelRequire("hHiDc");

var $fXrll = parcelRequire("fXrll");
const $a375fdd86ab2d782$export$fffae14cb4664bb4 = /*#__PURE__*/ (0, $eUqFw.memo)(({ parentHierarchyType: parentHierarchyType, parentIssueId: parentIssueId, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    // Memoise the parent issue to avoid `useListViewIssuesService` creating
    // a new data object on every render
    const parentIssue = (0, $eUqFw.useMemo)(()=>({
            hierarchyType: parentHierarchyType,
            hierarchyLevel: parentHierarchyLevel,
            issueId: parentIssueId
        }), [
        parentHierarchyType,
        parentHierarchyLevel,
        parentIssueId
    ]);
    const onComplete = (0, $eUqFw.useCallback)((responseData)=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'listChildrenData fetched', {
            totalChildren: (0, $aVwtE.getAGGCompliantData)(responseData, 'list')?.edges?.length,
            parentIssueId: parentIssueId,
            hierarchyLevel: parentHierarchyLevel
        });
    }, [
        createAnalyticsEvent,
        parentHierarchyLevel,
        parentIssueId
    ]);
    const { data: data, error: error, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage, loading: loading, loadNextPage: loadNextPage } = (0, $f8ADw.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            parentIssue: (0, $1ybV0.ff)('jwm.list.remove-unnecessary-parent-issue-dependency') ? {
                hierarchyType: parentHierarchyType,
                hierarchyLevel: parentHierarchyLevel,
                issueId: parentIssueId
            } : parentIssue,
            sorting: sorting,
            isHidingDoneItems: isHidingDoneItems,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: !isLoadingFields,
        onComplete: onComplete
    });
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $eUqFw.useEffect)(()=>{
        onDataChange(parentIssueId, {
            data: data,
            error: error,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loading: loading,
            loadNextPage: loadNextPage
        });
    }, [
        data,
        error,
        hasNextPage,
        isLoadingNextPage,
        loading,
        loadNextPage,
        onDataChange,
        parentIssueId
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $fXrll.default).errorTitle,
        description: (0, $fXrll.default).errorMessage
    }) : null;
});
const $a375fdd86ab2d782$export$89ce1cfdc4eecbef = /*#__PURE__*/ (0, $eUqFw.memo)(({ hasLoadingChildren: hasLoadingChildren, parentHierarchyType: parentHierarchyType, parentIssueIds: parentIssueIds, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel, parentHierarchyLevels: parentHierarchyLevels })=>{
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const { data: data, loading: isLoadingItems, error: error, isLoadingNextPage: isLoadingNextPage } = (0, $f8ADw.useListViewIssuesBulk)({
        input: {
            hasLoadingChildren: hasLoadingChildren,
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            parentIssues: parentIssueIds.map((issueId)=>({
                    hierarchyType: parentHierarchyType,
                    hierarchyLevel: parentHierarchyLevel,
                    issueId: issueId
                })),
            sorting: sorting,
            isHidingDoneItems: isHidingDoneItems,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: isLoadingFields === false && parentIssueIds.length > 0
    });
    const loading = isLoadingFields || isLoadingItems;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const totalIssues = Object.values(data).reduce((acc, curr)=>acc + curr.length, 0);
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $eUqFw.useEffect)(()=>{
        /* This is a workaround from avoiding the analytics event fired twice on every fetch:
            First when items are loaded (loading: true -> false)
            Second when parentIssueIds are updated after items are updated(parentISsueIds: loadingparentIds -> expandedParentIds)
            Below !hasLoadingChildren check skips firing the event in second case 
           */ if (loading || !hasLoadingChildren) return;
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'listChildrenDataBulk fetched', {
            totalChildren: totalIssues,
            parentIssueIds: parentIssueIds,
            hierarchyLevels: parentHierarchyLevels
        });
    }, [
        loading,
        createAnalyticsEvent,
        totalIssues,
        parentIssueIds,
        parentHierarchyLevels,
        hasLoadingChildren
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onDataChange(parentIssueIds, {
            data: data,
            loading: loading,
            error: error,
            isLoadingNextPage: isLoadingNextPage
        });
    }, [
        data,
        error,
        loading,
        isLoadingNextPage,
        onDataChange,
        parentIssueIds
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $fXrll.default).errorTitle,
        description: (0, $fXrll.default).errorMessage
    }) : null;
});

});
parcelRegister("aVwtE", function(module, exports) {

$parcel$export(module.exports, "useFetchMore", () => $4a89f8875e643360$export$d84f34af2f3f5d9f);
$parcel$export(module.exports, "getAGGCompliantData", () => $4a89f8875e643360$export$5a178cf599565b50);

var $iZuDo = parcelRequire("iZuDo");

var $jlBDe = parcelRequire("jlBDe");

var $90pMD = parcelRequire("90pMD");

var $6gPph = parcelRequire("6gPph");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $4X5wI = parcelRequire("4X5wI");
function $4a89f8875e643360$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
    const variablesWithAfter = {
        ...variables,
        after: after
    };
    return client.query({
        query: query,
        variables: variablesWithAfter,
        fetchPolicy: 'no-cache',
        errorPolicy: errorPolicy
    }).then((response)=>{
        if (!response) return;
        if (response.errors) {
            onError && onError(new (0, $jlBDe.ApolloError)({
                graphQLErrors: response.errors
            }));
            if (errorPolicy === 'none') return;
        }
        if (response.data == null) return;
        // Update cache based on updateQuery method
        const prevData = client.readQuery({
            query: query,
            variables: variables
        });
        if (prevData == null) // It should not happened, adding the check just to make flow happpy
        return;
        const newData = updateQuery(prevData, {
            fetchMoreResult: response.data,
            variables: variablesWithAfter
        });
        client.writeQuery({
            query: query,
            variables: variables,
            // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: TVariables; notifyOnNetworkStatusChange: boolean; data: TData; }' is not assignable to parameter of type 'WriteQueryOptions<TData, TVariables>'.
            notifyOnNetworkStatusChange: true,
            data: newData
        });
    }).catch((err)=>{
        onError && onError(err);
    });
}
function $4a89f8875e643360$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const client = (0, $iZuDo.useApolloClient)();
    // We're using `useDeepMemo` instead of `useCallback`/`useMemo` as it's very
    // likely that the `variables` dependency will change with each render even
    // though its contents will remain the same. Doing this stops us from
    // unnecessarily returning a new callback, as this could trigger unnecessary
    // rerenders or side-effects.
    return (0, $90pMD.useDeepMemo)(()=>(options)=>$4a89f8875e643360$export$2b602b4ab6fde7b6({
                ...options,
                variables: variables,
                query: query,
                client: client
            }), [
        client,
        variables,
        query
    ]);
}
function $4a89f8875e643360$export$5a178cf599565b50(data, listName, onError) {
    if (listName && data?.jira?.[listName]) {
        const _data = data.jira[listName];
        if (_data?.__typename === 'QueryError') {
            const queryError = new (0, $6gPph.QueryError)(_data);
            if (queryError.extensions?.find((ex)=>ex.statusCode === 401) && (0, $eI5EY.fg)('jira_list_add_401_error_handling')) throw new (0, $4X5wI.AuthenticationError)(_data.message);
            if ((0, $1ybV0.ff)('fix-sentry-unhandled-error-for-list-handler')) {
                onError && onError(_data);
                return undefined;
            }
            throw new (0, $6gPph.QueryError)(_data);
        }
        return _data;
    }
    return undefined;
}

});
parcelRegister("90pMD", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $aa834e9231a22e71$export$722debc0e56fea39);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $aa834e9231a22e71$export$722debc0e56fea39 = (memoFn, deps)=>{
    const ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(ref.current.deps, deps)) ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
};

});

parcelRegister("6gPph", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $cba33ea5171f294f$export$83dcbdfe8cbc1e17);
const $cba33ea5171f294f$export$f215947b3d76a6b7 = 'QueryError';
class $cba33ea5171f294f$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});


parcelRegister("dWGNJ", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $1e474dd65cc72606$export$518ba8e0e60f145f);

var $eUqFw = parcelRequire("eUqFw");

var $7byHA = parcelRequire("7byHA");

var $izafr = parcelRequire("izafr");
const $1e474dd65cc72606$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $7byHA.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
            // @ts-expect-error - TS2322 - Type '{ flag: { type: string; title: MessageDescriptorV2; description: any; }; }' is not assignable to type 'IntrinsicAttributes'.
            flag: {
                type: 'warning',
                title: title,
                description: errorMessage
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        // @ts-expect-error - TS2322 - Type '{ flag: { type: string; title: MessageDescriptorV2; description: MessageDescriptorV2; }; }' is not assignable to type 'IntrinsicAttributes'.
        flag: {
            type: 'error',
            title: title,
            description: description
        }
    });
};

});
parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("f8ADw", function(module, exports) {

$parcel$export(module.exports, "useListViewRecovery", () => $21ae3ba4f3dc3632$export$cedf3319fef1d036);
$parcel$export(module.exports, "useListViewIssues", () => $21ae3ba4f3dc3632$export$3c9c5774f09af6c0);
$parcel$export(module.exports, "useListViewIssuesBulk", () => $21ae3ba4f3dc3632$export$3b99bc6027f7bb74);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $i3K0B = parcelRequire("i3K0B");

var $iaCjO = parcelRequire("iaCjO");

var $aVwtE = parcelRequire("aVwtE");
var $12sJv = parcelRequire("12sJv");
var $4ZWyd = parcelRequire("4ZWyd");

var $ZvXTS = parcelRequire("ZvXTS");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");
const $21ae3ba4f3dc3632$export$cedf3319fef1d036 = (input, settings)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const variables = {
        ...(0, $i3K0B.getVariables)(input),
        cloudId: cloudId
    };
    return (0, $4ZWyd.useListRecovery)({
        settings: settings,
        queryList: (0, $7XECd.LIST_VIEW_QUERY),
        queryBackgroundList: (0, $7XECd.BACKGROUND_LIST_VIEW_QUERY),
        variables: variables,
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listRecoveryQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in background in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onBackgroundListError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listRecoveryBackgroundQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch more issues in background in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $21ae3ba4f3dc3632$var$emptyArray = [];
const $21ae3ba4f3dc3632$export$3c9c5774f09af6c0 = ({ input: input, condition: condition = true, onComplete: onComplete })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [hasLoadingStarted, setHasLoadingStarted] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    const onNextPageLoaded = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
    }, [
        createAnalyticsEvent
    ]);
    const queryVariables = (0, $i3K0B.getVariables)(input);
    const { data: data, loadFirstPage: loadFirstPage, hasNextPage: hasNextPage, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $12sJv.useJqlPagination)({
        variables: {
            cloudId: cloudId,
            ...queryVariables
        },
        query: (0, $7XECd.LIST_VIEW_QUERY),
        onCompleted: (responseData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemsQuery succeeded', {
                issuesCount: (0, $aVwtE.getAGGCompliantData)(responseData, 'list')?.edges?.length
            });
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
            if (onComplete) onComplete(responseData);
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
        },
        onPaginationError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewPaginationQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch more issues in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onNextPageLoaded: onNextPageLoaded
    });
    (0, $eUqFw.useEffect)(()=>{
        // only call once when condition === true
        if (!data && condition) {
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$23e322eb7c526958));
            loadFirstPage();
            setHasLoadingStarted(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        condition,
        data
    ]);
    const { sort: sort } = (0, $iaCjO.useSorter)();
    const _data = (0, $aVwtE.getAGGCompliantData)(data, 'list');
    const edges = _data?.edges || $21ae3ba4f3dc3632$var$emptyArray;
    const intl = (0, $5JgJ2.default)();
    const parentIssue = (0, $1ybV0.ff)('jwm.list.remove-unnecessary-parent-issue-dependency') ? undefined : input.parentIssue;
    const result = (0, $eUqFw.useMemo)(()=>{
        if (Array.isArray(edges) && edges.length === 0) return edges;
        const cacheVariables = {
            jql: queryVariables.jql,
            withConfluenceLinks: queryVariables.withConfluenceLinks,
            includeDoneItems: queryVariables.includeDoneItems,
            isParentFieldVisible: queryVariables.isParentFieldVisible,
            isDevSummaryFieldVisible: queryVariables.isDevSummaryFieldVisible,
            withParentRank: (0, $1ybV0.ff)('jwm.list_sort_parent_rank_first')
        };
        return sort(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $fjqly.transformResult)(edges, {
            parentIssue: parentIssue,
            cacheVariables: cacheVariables,
            intl: intl
        }));
    }, [
        edges,
        parentIssue,
        sort,
        queryVariables.jql,
        queryVariables.withConfluenceLinks,
        queryVariables.includeDoneItems,
        queryVariables.isParentFieldVisible,
        queryVariables.isDevSummaryFieldVisible,
        intl
    ]);
    return {
        data: result,
        // Make sure to return loading=true until items are loaded.
        loading: hasLoadingStarted ? loading : true,
        error: error,
        loadNextPage: loadNextPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage
    };
};
const $21ae3ba4f3dc3632$var$useBulkQueryFetchPolicy = (input)=>{
    const fetchPolicyRef = (0, $eUqFw.useRef)('network-only');
    const prevInputRef = (0, $eUqFw.useRef)(input);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(input, prevInputRef.current)) {
        fetchPolicyRef.current = prevInputRef.current.hasLoadingChildren && !input.hasLoadingChildren ? 'cache-first' : 'network-only';
        prevInputRef.current = input;
    }
    return fetchPolicyRef.current;
};
const $21ae3ba4f3dc3632$export$3b99bc6027f7bb74 = ({ input: input, condition: condition = true, onComplete: onComplete })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [hasLoadingStarted, setHasLoadingStarted] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    // Workaround to avoid additional network requests and/or silent failures -
    // see https://jbusiness.atlassian.net/browse/HRZ-67
    const fetchPolicy = $21ae3ba4f3dc3632$var$useBulkQueryFetchPolicy(input);
    const onNextPageLoaded = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
    }, [
        createAnalyticsEvent
    ]);
    const queryVariables = (0, $i3K0B.getVariables)(input);
    // This concatenated query shouldn't go through useJqlPagination as the response differs from the expectation.
    // I've created https://jbusiness.atlassian.net/browse/JER-280 so we can explore better ways of doing this.
    const { data: data, loadFirstPage: loadFirstPage, hasNextPage: hasNextPage, loading: loading, error: error, isLoadingNextPage: isLoadingNextPage } = (0, $12sJv.useJqlPagination)({
        fetchPolicy: fetchPolicy,
        variables: {
            cloudId: cloudId,
            ...queryVariables
        },
        query: input.parentIssues?.length ? (0, $7XECd.LIST_VIEW_ITEMS_QUERY_BULK)(input.parentIssues?.map((parentIssue)=>parentIssue.issueId) ?? []) : (0, $7XECd.LIST_VIEW_QUERY),
        onCompleted: (responseData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemsQueryBulk succeeded', {
                issuesCount: Object.values(responseData?.jira ?? {}).reduce((acc, curr)=>{
                    if (typeof curr !== 'string' && curr?.__typename === 'JiraWorkManagementViewItemConnection') return acc + (curr?.edges?.length ?? 0);
                    return acc;
                }, 0)
            });
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
            if (onComplete) onComplete();
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewItemsQueryBulk',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$83ca21a50372ea3b));
        },
        onPaginationError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewPaginationQueryBulk',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch more issues in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onNextPageLoaded: onNextPageLoaded
    });
    (0, $eUqFw.useEffect)(()=>{
        // only call once when condition === true
        if (!data && condition) {
            (0, $ZvXTS.markViewMetric)('list', (0, $78bb8734d7176028$export$23e322eb7c526958));
            loadFirstPage();
            setHasLoadingStarted(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        condition,
        data
    ]);
    const { sort: sort } = (0, $iaCjO.useSorter)();
    const intl = (0, $5JgJ2.default)();
    const parentIssues = (0, $1ybV0.ff)('jwm.list.remove-unnecessary-parent-issue-dependency') ? undefined : input.parentIssues;
    const result = (0, $eUqFw.useMemo)(()=>{
        if (!data) return {};
        return Object.fromEntries(Object.keys(data.jira || {}).map((entry)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const subList = data.jira && data.jira[entry];
            const edges = typeof subList !== 'string' && subList?.__typename === 'JiraWorkManagementViewItemConnection' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            subList.edges || $21ae3ba4f3dc3632$var$emptyArray;
            // to guarantee issue ids are strings, the jql aliases are `issue{issueId}`, we just need the issueId
            const issueId = entry.substring(5);
            if (Array.isArray(edges) && edges.length === 0 || !edges) return [
                issueId,
                []
            ];
            return [
                issueId,
                sort(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $fjqly.transformResult)(edges, {
                    parentIssue: parentIssues?.find((parentIssue)=>parentIssue.issueId === issueId),
                    cacheVariables: {
                        jql: queryVariables.jql,
                        withConfluenceLinks: queryVariables.withConfluenceLinks,
                        includeDoneItems: queryVariables.includeDoneItems
                    },
                    intl: intl
                }))
            ];
        }));
    }, [
        data,
        sort,
        parentIssues,
        queryVariables.jql,
        queryVariables.withConfluenceLinks,
        queryVariables.includeDoneItems,
        intl
    ]);
    return {
        data: result,
        // Make sure to return loading=true until items are loaded.
        loading: hasLoadingStarted ? loading : true,
        error: error,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage
    };
};

});
parcelRegister("12sJv", function(module, exports) {

$parcel$export(module.exports, "useIssuePagination", () => $f9609ccfe0ed4e32$export$b49565a42289e6b);
$parcel$export(module.exports, "useJqlPagination", () => $f9609ccfe0ed4e32$export$9408824d9baedabc);
$parcel$export(module.exports, "useRefreshInterval", () => $f9609ccfe0ed4e32$export$7cfdc4e3bbeb1790);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $iZuDo = parcelRequire("iZuDo");

var $1ybV0 = parcelRequire("1ybV0");

var $aVwtE = parcelRequire("aVwtE");
const $f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql = {
    uniqueId: 'issueId',
    filter: 'jql'
};
function $f9609ccfe0ed4e32$export$80b3cb77c2f932d9({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $eUqFw.useState)(false);
    const _data = data && (0, $aVwtE.getAGGCompliantData)(data, listName, onError);
    const hasNextPage = _data?.pageInfo?.hasNextPage || false;
    const endCursor = _data?.pageInfo?.endCursor || '';
    const fetchMore = (0, $aVwtE.useFetchMore)({
        query: query,
        variables: variables
    });
    /**
	 * creating a useRef for onError so that we don't regenerate the `next` function every time `onError` changes.
	 * - This will make the `next` reference to be more resistant to reference changes in case consumer inline the `onError` function
	 * - Moreover, `onError` is not affecting the data that we fetch, since it will be only called in in-need basis
	 * - Additionally in apollo repository, `onError` is also excluded from memoization list  (check the useQuery)
	 */ const onErrorRef = (0, $eUqFw.useRef)();
    onErrorRef.current = onError;
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $eUqFw.useEffect)(()=>{
        // reset next page state
        setIsLoadingNextPage(false);
    }, [
        resetWhenChanged
    ]);
    const updateQueryAGGCompliant = (0, $eUqFw.useCallback)(// @ts-expect-error TS2345 - Argument of type '(prev: TData, { fetchMoreResult }: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData | { jira: { [x: string]: any; }; }' is not assignable to parameter of type '(prev: TData, options: { fetchMoreResult?: TData | undefined; variables: TVariables; }) => TData'.
    (prev, { fetchMoreResult: fetchMoreResult })=>{
        setIsLoadingNextPage(false);
        if (!fetchMoreResult) return prev;
        const edges = [
            ...(0, $aVwtE.getAGGCompliantData)(prev, listName)?.edges || [],
            ...(0, $aVwtE.getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
        ];
        return {
            jira: {
                ...fetchMoreResult.jira,
                [listName]: {
                    ...(0, $aVwtE.getAGGCompliantData)(fetchMoreResult, listName),
                    edges: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(edges, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    (edge)=>edge?.node && edge.node[uniqueId])
                }
            }
        };
    }, [
        setIsLoadingNextPage,
        listName,
        uniqueId
    ]);
    const next = (0, $eUqFw.useCallback)((after)=>{
        setIsLoadingNextPage(true);
        fetchMore({
            after: after,
            onError: onErrorRef.current,
            errorPolicy: errorPolicy,
            updateQuery: updateQueryAGGCompliant
        });
    }, [
        fetchMore,
        updateQueryAGGCompliant,
        errorPolicy
    ]);
    return {
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        isLoadingNextPage: isLoadingNextPage,
        next: next
    };
}
const $f9609ccfe0ed4e32$export$b49565a42289e6b = (options)=>$f9609ccfe0ed4e32$export$80b3cb77c2f932d9({
        ...options,
        ...$f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql
    });
const $f9609ccfe0ed4e32$export$9cc6d2e5a4c2e67e = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
    const [inFlightPage, setInFlightPage] = (0, $eUqFw.useState)();
    const resetWhenChanged = filter ? variables[filter] : variables;
    (0, $eUqFw.useEffect)(()=>{
        // reset inflight track
        setInFlightPage(null);
    }, [
        resetWhenChanged
    ]);
    const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, $iZuDo.useLazyQuery)(query, {
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy || 'network-only',
        onCompleted: onCompleted,
        onError: onError
    });
    if ((0, $1ybV0.ff)('jwm.fix-list-view-jql-query-errors_5jp7y') && data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
    const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $f9609ccfe0ed4e32$export$80b3cb77c2f932d9({
        data: data,
        variables: variables,
        listName: 'list',
        onError: onPaginationError,
        errorPolicy: errorPolicy,
        query: query,
        uniqueId: uniqueId,
        filter: filter
    });
    const loadNextPage = (0, $eUqFw.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || endCursor === inFlightPage || loading) return;
        setInFlightPage(endCursor);
        next(endCursor);
        onNextPageLoaded && onNextPageLoaded();
    }, [
        endCursor,
        hasNextPage,
        inFlightPage,
        next,
        onNextPageLoaded,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        loadFirstPage: loadFirstPage,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage,
        refetch: refetch
    };
};
const $f9609ccfe0ed4e32$export$9408824d9baedabc = (options)=>$f9609ccfe0ed4e32$export$9cc6d2e5a4c2e67e({
        ...options,
        ...$f9609ccfe0ed4e32$var$paginationOptionsForIssuesByJql
    });
const $f9609ccfe0ed4e32$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (interval == null) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const timer = setTimeout(()=>{
            if (condition) callback();
        }, interval * 1000);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        interval,
        callback,
        condition
    ]);
};

});

parcelRegister("4ZWyd", function(module, exports) {

$parcel$export(module.exports, "useListRecovery", () => $e3f0f57f06398edd$export$c23bdcd09893983b);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $c4MRZ = parcelRequire("c4MRZ");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $12sJv = parcelRequire("12sJv");

var $aVwtE = parcelRequire("aVwtE");
const $e3f0f57f06398edd$var$getOperationName = (query)=>{
    const operation = (0, $c4MRZ.getOperationAST)(query, undefined);
    return operation && operation.name && operation.name.value || '';
};
const $e3f0f57f06398edd$export$c23bdcd09893983b = ({ settings: settings, queryList: queryList, queryBackgroundList: queryBackgroundList, variables: variables, onComplete: onComplete, onError: onError, onBackgroundListError: onBackgroundListError })=>{
    const analyticsTaskId = $e3f0f57f06398edd$var$getOperationName(queryBackgroundList);
    const analyticsTaskName = 'backgroundRefetch';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const [fetchListInBackground, { loading: loading, data: data }] = (0, $iZuDo.useLazyQuery)(queryBackgroundList, {
        fetchPolicy: 'network-only',
        onError: onError
    });
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(false);
    const [hasFinished, setHasFinished] = (0, $eUqFw.useState)(false);
    const [refreshCount, setRefreshCount] = (0, $eUqFw.useState)(0);
    const [currentQuery, setCurrentQuery] = (0, $eUqFw.useState)();
    const listEndCursor = (0, $eUqFw.useRef)(undefined);
    const { next: next, hasNextPage: hasNextPage, endCursor: endCursor } = (0, $12sJv.useIssuePagination)({
        data: data,
        variables: variables,
        listName: 'list',
        onError: onBackgroundListError,
        query: queryBackgroundList
    });
    const prevEndCursor = (0, $hzcvF.usePreviousWithInitial)(endCursor);
    // abort background operations if a new query is provided
    (0, $eUqFw.useEffect)(()=>{
        if (!hasStarted || variables.jql === currentQuery) return;
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskAbort', {
            task: analyticsTaskName,
            taskId: analyticsTaskId,
            reason: 'query has changed'
        });
        setHasFinished(true);
        setHasStarted(false);
        setCurrentQuery(undefined);
    }, [
        analyticsTaskId,
        createAnalyticsEvent,
        currentQuery,
        hasStarted,
        variables.jql
    ]);
    // refetch all pages until the current endCursor: if we have 5 pages in total, list endCursor is on page 2,
    // then background refresh will pull first 2 pages only
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && hasNextPage && // query pages one-by-one until we reach the current page
        endCursor !== listEndCursor.current && // query pages only when endCursor changes,
        // otherwise it might query the same page multiple times due to re-renders of useListRecovery
        endCursor !== prevEndCursor) next(endCursor);
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        next,
        prevEndCursor
    ]);
    // replace list items with backgroundList items so the main view will update
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && !hasFinished && !loading && listEndCursor.current === endCursor) try {
            const getCachedData = (query, metaId)=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, $guiFP.default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: metaId,
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const backgroundListData = getCachedData(queryBackgroundList, 'getCachedBackgroundListData');
            const listData = getCachedData(queryList, 'getCachedListData');
            const backgroundList = (0, $aVwtE.getAGGCompliantData)(backgroundListData, 'list');
            const list = (0, $aVwtE.getAGGCompliantData)(listData, 'list');
            setRefreshCount(refreshCount + 1);
            setHasFinished(true);
            setHasStarted(false);
            setCurrentQuery(undefined);
            if (!backgroundList || !list || !listData || !Array.isArray(backgroundList.edges) || !Array.isArray(list.edges)) throw new Error('Conditions not met');
            client.writeQuery({
                query: queryList,
                variables: variables,
                data: {
                    ...listData,
                    jira: {
                        ...listData.jira,
                        list: {
                            ...backgroundList,
                            edges: backgroundList.edges
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                details: `${backgroundList.edges.length} items updated`
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            if ((0, $1ybV0.ff)('jwm.list.background-refetch-for-groups-and-children')) onComplete?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                error: `Failed to refresh data in the background (${e.name || 'error'})`
            });
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'useIssueTypesAndFieldsCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(queryList),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        next,
        client,
        loading,
        hasFinished,
        refreshCount,
        queryList,
        queryBackgroundList,
        variables,
        createAnalyticsEvent,
        analyticsTaskId,
        listEndCursor,
        onComplete
    ]);
    const refreshList = (0, $eUqFw.useCallback)(()=>{
        if (hasStarted && !hasFinished || settings.isDisabled) return;
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: queryList,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'refreshList',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(queryList),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const listData = getCachedListData();
        const list = (0, $aVwtE.getAGGCompliantData)(listData ?? undefined, 'list');
        // store current list endCursor so that we know at what page to stop backgroundList fetching
        listEndCursor.current = list?.pageInfo?.endCursor;
        fetchListInBackground({
            variables: variables
        });
        setCurrentQuery(variables.jql);
        setHasStarted(true);
        setHasFinished(false);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskStart', {
            task: analyticsTaskName,
            taskId: analyticsTaskId
        });
    }, [
        analyticsTaskId,
        client,
        createAnalyticsEvent,
        fetchListInBackground,
        hasFinished,
        hasStarted,
        queryList,
        settings.isDisabled,
        variables
    ]);
    const isRefreshing = hasStarted && !hasFinished;
    if (!(0, $1ybV0.ff)('jwm.list.background-refetch-for-groups-and-children')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $12sJv.useRefreshInterval)(refreshList, // it won't trigger a refresh if another has been triggered
    // it won't trigger refresh if the tab is invisible
    settings.isVisible && !isRefreshing, settings.updateInterval);
    return {
        isRefreshing: isRefreshing,
        refreshCount: refreshCount,
        refreshList: refreshList
    };
};

});
parcelRegister("c4MRZ", function(module, exports) {

$parcel$export(module.exports, "getOperationAST", () => $11510882f4ca1049$export$1f718485f6b6643f);

var $1c4hI = parcelRequire("1c4hI");
function $11510882f4ca1049$export$1f718485f6b6643f(documentAST, operationName) {
    var operation = null;
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var definition = _documentAST$definiti2[_i2];
        if (definition.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION) {
            var _definition$name;
            if (operationName == null) {
                // If no operation name was provided, only return an Operation if there
                // is one defined in the document. Upon encountering the second, return
                // null.
                if (operation) return null;
                operation = definition;
            } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
        }
    }
    return operation;
}

});


parcelRegister("fjqly", function(module, exports) {

$parcel$export(module.exports, "addChildToParentListView", () => $65b6ea7ab198376d$export$a79dcdc594f4a8c4);
$parcel$export(module.exports, "removeChildFromParentListView", () => $65b6ea7ab198376d$export$1ea2ddc4aab7921f);
$parcel$export(module.exports, "transformResult", () => $65b6ea7ab198376d$export$f13b29f9ed0c5a03);

var $jGcn0 = parcelRequire("jGcn0");

var $dHtvo = parcelRequire("dHtvo");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $6BYzZ = parcelRequire("6BYzZ");

var $f5yXM = parcelRequire("f5yXM");
const $65b6ea7ab198376d$export$a79dcdc594f4a8c4 = (parentIssue)=>({
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: true,
            totalCount: parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount + 1 : 1
        }
    });
const $65b6ea7ab198376d$export$1ea2ddc4aab7921f = (parentIssue, childrenToRemove = 1)=>{
    const newCount = parentIssue.childSummary?.totalCount ? parentIssue.childSummary?.totalCount - childrenToRemove : 0;
    return {
        ...parentIssue,
        childSummary: {
            __typename: 'JiraWorkManagementChildSummary',
            hasChildren: newCount > 0,
            totalCount: newCount
        }
    };
};
const $65b6ea7ab198376d$var$createDateTimeFieldTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: (field.dateTime && (0, $6BYzZ.DateOnly).fromDateAccordingToLocalTime(new Date(field.dateTime))) ?? null
        });
const $65b6ea7ab198376d$var$createDateFieldTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: (field.date && (0, $6BYzZ.toDateOnly)(field.date)) ?? null
        });
const $65b6ea7ab198376d$var$atlassianAccountUserTransformer = (user)=>({
        accountId: user.accountId,
        avatarUrl: user.picture,
        displayName: user.name
    });
const $65b6ea7ab198376d$var$createJiraSingleSelectUserPickeTransformer = ()=>(field)=>field.user && {
            [field.aliasFieldId || field.fieldId]: $65b6ea7ab198376d$var$atlassianAccountUserTransformer(field.user)
        } || null;
const $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer = (fieldId)=>(field)=>({
            [fieldId || field.aliasFieldId || field.fieldId]: field.text
        });
const $65b6ea7ab198376d$var$createJiraLabelsTransformer = ()=>(field)=>({
            [field.aliasFieldId || field.fieldId]: field.selectedLabelsConnection?.edges?.map((edge)=>edge?.node?.name) || []
        });
const $65b6ea7ab198376d$var$topLevelFieldTransformers = {
    [(0, $lO4Or.ISSUE_KEY_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer('key'),
    [(0, $lO4Or.ISSUE_TYPE)]: (field)=>({
            issuetype: {
                iconUrl: field.issueType?.avatar?.medium,
                id: field.issueType?.issueTypeId,
                name: field.issueType?.name,
                ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && {
                    level: field.issueType?.hierarchy?.level
                }
            }
        }),
    [(0, $lO4Or.SUMMARY_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer(),
    [(0, $lO4Or.STATUS_TYPE)]: (field)=>({
            status: {
                id: field.status.statusId,
                name: field.status.name,
                categoryId: field.status.statusCategory?.statusCategoryId
            }
        }),
    [(0, $jGcn0.START_DATE_ALIAS_FIELD_ID)]: $65b6ea7ab198376d$var$createDateFieldTransformer(),
    [(0, $lO4Or.DUE_DATE_TYPE)]: $65b6ea7ab198376d$var$createDateFieldTransformer(),
    [(0, $lO4Or.UPDATED)]: $65b6ea7ab198376d$var$createDateTimeFieldTransformer(),
    [(0, $lO4Or.CREATED)]: $65b6ea7ab198376d$var$createDateTimeFieldTransformer(),
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleSelectUserPickeTransformer(),
    [(0, $lO4Or.PRIORITY_TYPE)]: (field)=>({
            priority: (field.priority && {
                id: field.priority.id,
                name: field.priority.name,
                iconUrl: field.priority.iconUrl
            }) ?? null
        }),
    [(0, $lO4Or.LABELS_TYPE)]: $65b6ea7ab198376d$var$createJiraLabelsTransformer(),
    [(0, $lO4Or.RANK_CF_TYPE)]: $65b6ea7ab198376d$var$createJiraSingleLineTextTransformer(),
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: (field)=>({
            timeoriginalestimate: field.originalEstimate?.timeInSeconds ?? null
        })
};
const $65b6ea7ab198376d$var$getTopLevelField = (field)=>{
    const transformer = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $65b6ea7ab198376d$var$topLevelFieldTransformers[field.type];
    if (transformer) // @ts-expect-error - TS2345 - Type &#39;JWMListViewItems_jira_list_JiraWorkManagementViewItemConnection_edges_node_fields_JiraColorField&#39; is not assignable to type &#39;never&#39;
    return transformer(field);
    return null;
};
const $65b6ea7ab198376d$export$f13b29f9ed0c5a03 = (edges, options)=>{
    if (edges) return edges.filter((edge)=>edge?.node).map((edge)=>{
        const { id: id, fields: fields, issueId: issueId, childSummary: childSummary, legacyConfluenceLinks: legacyConfluenceLinks, commentSummary: commentSummary } = edge.node;
        const listViewIssue = {
            id: id,
            issueId: issueId,
            childSummary: {
                totalCount: childSummary?.totalCount,
                hasChildren: childSummary?.hasChildren ?? false
            },
            cacheVariables: options.cacheVariables,
            fields: (0, $f5yXM.listViewTransformFields)(fields, options.intl),
            confluenceLinks: legacyConfluenceLinks ?? undefined,
            commentSummary: {
                totalCount: commentSummary?.totalCount
            },
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $dHtvo.transformTopLevelFields)(edge?.node) : {}
        };
        fields?.forEach((field)=>{
            if (field != null) {
                const fieldValues = $65b6ea7ab198376d$var$getTopLevelField(field);
                Object.assign(listViewIssue, fieldValues);
            }
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return listViewIssue;
    });
    return [];
};

});
parcelRegister("dHtvo", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $437837b35cd3faec$export$fbce423ada1f57a0);
$parcel$export(module.exports, "isTransformFieldSupported", () => $437837b35cd3faec$export$d3f2873cf2713a58);
$parcel$export(module.exports, "transformTopLevelFields", () => $437837b35cd3faec$export$82a9f94774eb7857);

var $5iWql = parcelRequire("5iWql");

var $6Vgvs = parcelRequire("6Vgvs");

var $kDvxN = parcelRequire("kDvxN");

var $1MCx2 = parcelRequire("1MCx2");

var $60igd = parcelRequire("60igd");

var $jH0qI = parcelRequire("jH0qI");

var $aCOZQ = parcelRequire("aCOZQ");

var $l7QbV = parcelRequire("l7QbV");

var $965Lk = parcelRequire("965Lk");

var $7BmGU = parcelRequire("7BmGU");

var $ehKZQ = parcelRequire("ehKZQ");

var $1eTr0 = parcelRequire("1eTr0");

var $edHli = parcelRequire("edHli");
// Used for list view controller when transforming Gira response
const $437837b35cd3faec$var$createSupportedTransformations = (0, $5iWql.default)(()=>({
        ...(0, $1eTr0.transformVersionField)(),
        ...(0, $jH0qI.transformParentField)(),
        ...(0, $ehKZQ.transformTeamField)(),
        ...(0, $1MCx2.transformGoalsField)(),
        ...(0, $965Lk.transformResolutionField)(),
        ...(0, $60igd.transformGroupField)(),
        ...(0, $l7QbV.transformRadioSelectField)(),
        ...(0, $7BmGU.transformStatusCategoryField)(),
        ...(0, $aCOZQ.transformProjectField)(),
        ...(0, $6Vgvs.transformCascadingSelectField)()
    }));
const $437837b35cd3faec$var$isValidTypename = (typename)=>true;
const $437837b35cd3faec$export$66480ae6e701514d = (field)=>true;
const $437837b35cd3faec$export$fbce423ada1f57a0 = (field, intl)=>{
    const supportedTransformations = $437837b35cd3faec$var$createSupportedTransformations();
    if (field == null) return null;
    const typename = field.__typename;
    if (!$437837b35cd3faec$var$isValidTypename(typename)) return null;
    const transform = supportedTransformations[typename];
    if (transform == null) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return transform(field, intl);
};
const $437837b35cd3faec$export$d3f2873cf2713a58 = (field)=>{
    const supportedTransformations = $437837b35cd3faec$var$createSupportedTransformations();
    if (!(0, $edHli.isJiraBusinessFields)(field)) return false;
    if (!$437837b35cd3faec$var$isValidTypename(field.__typename)) return false;
    return supportedTransformations[field.__typename] != null;
};
const $437837b35cd3faec$export$82a9f94774eb7857 = (issueNode)=>issueNode ? {
        [(0, $c12b99091b418650$export$72b5bd2391f1e7c0)]: (0, $kDvxN.transformDevSummaryField)(issueNode.devSummaryCache)
    } : {};

});
parcelRegister("6Vgvs", function(module, exports) {

$parcel$export(module.exports, "transformCascadingSelectField", () => $37f6a251e511afcf$export$b5257861e8de13fa);

var $2rn3r = parcelRequire("2rn3r");

var $lO4Or = parcelRequire("lO4Or");

const $37f6a251e511afcf$export$b5257861e8de13fa = ()=>({
        [(0, $125a7921ac42bc2d$export$c5c9bcd04d3610df)]: (field)=>{
            if (field.__typename !== (0, $125a7921ac42bc2d$export$c5c9bcd04d3610df)) return null;
            return {
                type: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
                id: field.id,
                fieldId: field.fieldId,
                value: field.cascadingOption && field.cascadingOption.parentValue ? {
                    parentOptionValue: {
                        id: field.cascadingOption.parentValue.id,
                        optionId: (0, $2rn3r.JiraIssueFieldOptionAri).parse(field.cascadingOption.parentValue.id).optionId,
                        value: field.cascadingOption.parentValue.value,
                        isDisabled: field.cascadingOption.parentValue.isDisabled
                    },
                    ...field.cascadingOption.childOptionValue ? {
                        childOptionValue: {
                            id: field.cascadingOption.childOptionValue.id,
                            optionId: field.cascadingOption.childOptionValue.optionId,
                            value: field.cascadingOption.childOptionValue.value,
                            isDisabled: field.cascadingOption.childOptionValue.isDisabled
                        }
                    } : {}
                } : null
            };
        }
    });

});
parcelRegister("2rn3r", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $396674cae5287926$export$e3bc1ec22f941fbe);

var $7HlAi = parcelRequire("7HlAi");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue-field-option/manifest.ts
var $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $7HlAi.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $7HlAi.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $396674cae5287926$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("7HlAi", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $5632bebec8ddd527$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $5632bebec8ddd527$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $5632bebec8ddd527$export$eb4f4cf0880fe5a8 = "jira", $5632bebec8ddd527$export$4bec333360908e78 = "issue-field-option";

});


const $125a7921ac42bc2d$export$c5c9bcd04d3610df = 'JiraCascadingSelectField';


parcelRegister("kDvxN", function(module, exports) {

$parcel$export(module.exports, "transformDevSummaryField", () => $92fef3395c7adfcf$export$2093d68e8a6114b5);
const $92fef3395c7adfcf$var$hasPullRequest = (field)=>Number(field?.devSummary?.pullrequest?.overall?.count) > 0;
const $92fef3395c7adfcf$var$isUnderReview = (field)=>$92fef3395c7adfcf$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'OPEN';
const $92fef3395c7adfcf$var$isMerged = (field)=>$92fef3395c7adfcf$var$hasPullRequest(field) && field?.devSummary?.pullrequest?.overall?.state === 'MERGED';
const $92fef3395c7adfcf$export$2093d68e8a6114b5 = (field)=>field ? {
        pullRequestsCount: Number(field?.devSummary?.pullrequest?.overall?.count),
        isUnderReview: $92fef3395c7adfcf$var$isUnderReview(field),
        isMerged: $92fef3395c7adfcf$var$isMerged(field),
        commitCount: Number(field?.devSummary?.commit?.overall?.count)
    } : null;

});

parcelRegister("1MCx2", function(module, exports) {

$parcel$export(module.exports, "transformGoalsField", () => $53a4fecceff51526$export$c34241865478278);

var $lO4Or = parcelRequire("lO4Or");

const $53a4fecceff51526$export$c34241865478278 = ()=>({
        [(0, $72b28c0dfc5355e0$export$aac6761ddd37ded5)]: (field)=>{
            if (field.__typename !== (0, $72b28c0dfc5355e0$export$aac6761ddd37ded5)) return null;
            return {
                type: (0, $lO4Or.GOALS_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                isEditable: !!field.fieldConfig?.isEditable,
                value: {
                    goals: field.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                            id: edge?.node?.id || '',
                            name: edge?.node?.name || '',
                            status: edge?.node?.status || null
                        })) || [],
                    totalCount: field.selectedGoals?.totalCount || 0
                }
            };
        }
    });

});
const $72b28c0dfc5355e0$export$aac6761ddd37ded5 = 'JiraGoalsField';


parcelRegister("60igd", function(module, exports) {

$parcel$export(module.exports, "transformGroupField", () => $5e6be5474ec79100$export$5090c8e3ce3e3e36);

var $lO4Or = parcelRequire("lO4Or");

const $5e6be5474ec79100$export$5090c8e3ce3e3e36 = ()=>({
        [(0, $2aba7ed23bc6b18c$export$e67f77aeba6db6c8)]: (field)=>{
            if (field.__typename !== (0, $2aba7ed23bc6b18c$export$e67f77aeba6db6c8)) return null;
            return {
                type: (0, $lO4Or.GROUP_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedGroup ? {
                    groupId: field.selectedGroup.groupId,
                    name: field.selectedGroup.name ?? ''
                } : null
            };
        },
        [(0, $2aba7ed23bc6b18c$export$bf73c80438672453)]: (field)=>{
            if (field.__typename !== (0, $2aba7ed23bc6b18c$export$bf73c80438672453)) return null;
            return {
                type: (0, $lO4Or.MULTI_GROUP_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedGroupsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                        groupId: edge?.node.groupId,
                        name: edge?.node.name ?? ''
                    } : null).filter((group)=>group != null) ?? null
            };
        }
    });

});
const $2aba7ed23bc6b18c$export$e67f77aeba6db6c8 = 'JiraSingleGroupPickerField';
const $2aba7ed23bc6b18c$export$bf73c80438672453 = 'JiraMultipleGroupPickerField';


parcelRegister("jH0qI", function(module, exports) {

$parcel$export(module.exports, "transformParentField", () => $b9a24253f43185e7$export$9154eb05be84db49);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $3uSNh = parcelRequire("3uSNh");

const $b9a24253f43185e7$export$9154eb05be84db49 = ()=>({
        [(0, $715a232380f49eb2$export$89cbdbc2fa7a3b27)]: (field)=>{
            if (field.__typename !== (0, $715a232380f49eb2$export$89cbdbc2fa7a3b27)) return null;
            let fields = {};
            if (Array.isArray(field.parentIssue?.fields)) {
                const issueType = (0, $3uSNh.safeGetValue)(field.parentIssue.fields, 'issuetype', 'issueType', null);
                const color = (0, $3uSNh.safeGetValue)(field.parentIssue.fields, 'issuecolor', 'color.colorKey', null);
                fields = {
                    summary: (0, $3uSNh.safeGetValue)(field.parentIssue.fields, 'summary', 'text', null),
                    statusCategoryId: (0, $3uSNh.safeGetValue)(field.parentIssue?.fields, 'status', 'status.statusCategory.statusCategoryId', null),
                    issueType: issueType ? {
                        name: issueType.name,
                        iconUrl: issueType.avatar?.medium
                    } : null,
                    color: color != null ? color.toUpperCase() : null
                };
            }
            if ((0, $1ybV0.ff)('jwm.list_sort_parent_rank_first') && Array.isArray(field.parentIssue?.rankField)) {
                const rank = (0, $3uSNh.safeGetValue)(field.parentIssue?.rankField, 'rank', 'text', null);
                fields = {
                    ...fields,
                    rank: rank ?? null
                };
            }
            return {
                type: (0, $lO4Or.PARENT_TYPE),
                fieldId: field.fieldId,
                value: field.parentIssue ? {
                    id: field.parentIssue?.id,
                    issueId: field.parentIssue?.issueId,
                    issueKey: field.parentIssue?.key,
                    ...fields
                } : null
            };
        }
    });

});
const $715a232380f49eb2$export$89cbdbc2fa7a3b27 = 'JiraParentIssueField';


parcelRegister("aCOZQ", function(module, exports) {

$parcel$export(module.exports, "transformProjectField", () => $5dbde54d59224ed6$export$1fd74e5690ffdae3);

var $lO4Or = parcelRequire("lO4Or");

const $5dbde54d59224ed6$export$1fd74e5690ffdae3 = ()=>({
        [(0, $286c7e8b25ae1c0d$export$32cecd77017de859)]: (field)=>{
            if (field.__typename !== (0, $286c7e8b25ae1c0d$export$32cecd77017de859)) return null;
            return {
                type: (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.project ? {
                    id: field.project.id,
                    name: field.project.name ?? '',
                    key: field.project.key ?? '',
                    avatarUrls: {
                        '48x48': field.project.avatar?.large ?? ''
                    }
                } : null
            };
        }
    });

});
const $286c7e8b25ae1c0d$export$32cecd77017de859 = 'JiraProjectField';


parcelRegister("l7QbV", function(module, exports) {

$parcel$export(module.exports, "transformRadioSelectField", () => $83f5b0b9b02fe828$export$ee3d5244f5f85b47);

var $lO4Or = parcelRequire("lO4Or");

const $83f5b0b9b02fe828$export$ee3d5244f5f85b47 = ()=>({
        [(0, $f96a5fe14aa86356$export$561e8c47e4fa1c1b)]: (field)=>{
            if (field.__typename !== (0, $f96a5fe14aa86356$export$561e8c47e4fa1c1b)) return null;
            return {
                type: (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                isEditable: !!field.fieldConfig?.isEditable,
                value: field.selectedOption ? {
                    value: field.selectedOption.optionId,
                    label: field.selectedOption.value ?? ''
                } : null
            };
        }
    });

});
const $f96a5fe14aa86356$export$561e8c47e4fa1c1b = 'JiraRadioSelectField';


parcelRegister("965Lk", function(module, exports) {

$parcel$export(module.exports, "transformResolutionField", () => $39b8d4431c014535$export$3441c85b045ddb32);

var $lO4Or = parcelRequire("lO4Or");

const $39b8d4431c014535$export$3441c85b045ddb32 = ()=>({
        [(0, $1db008f6a8fd416a$export$a7bcc074cfedc376)]: (field)=>{
            if (field.__typename !== (0, $1db008f6a8fd416a$export$a7bcc074cfedc376)) return null;
            return {
                type: (0, $lO4Or.RESOLUTION_TYPE),
                fieldId: field.fieldId,
                value: field.resolution ? {
                    id: field.resolution.id,
                    name: field.resolution.name ?? ''
                } : null
            };
        }
    });

});
const $1db008f6a8fd416a$export$a7bcc074cfedc376 = 'JiraResolutionField';


parcelRegister("7BmGU", function(module, exports) {

$parcel$export(module.exports, "transformStatusCategoryField", () => $517adf1afdcfab8e$export$daffdd43f256def6);

var $lO4Or = parcelRequire("lO4Or");

const $517adf1afdcfab8e$export$daffdd43f256def6 = ()=>({
        [(0, $00385361dcdfb8da$export$aa464b56f1076111)]: (field)=>{
            if (field.__typename !== (0, $00385361dcdfb8da$export$aa464b56f1076111)) return null;
            return {
                type: (0, $lO4Or.STATUS_CATEGORY_TYPE),
                fieldId: field.fieldId,
                value: field.statusCategory ? {
                    statusCategoryId: field.statusCategory.statusCategoryId,
                    name: field.statusCategory.name ?? ''
                } : null
            };
        }
    });

});
const $00385361dcdfb8da$export$aa464b56f1076111 = 'JiraStatusCategoryField';


parcelRegister("ehKZQ", function(module, exports) {

$parcel$export(module.exports, "transformTeamField", () => $7a263e99d93ab108$export$c924eaa42d1ef062);

var $lO4Or = parcelRequire("lO4Or");

const $7a263e99d93ab108$export$c924eaa42d1ef062 = ()=>({
        [(0, $51d4762401af983e$export$4b2dddaf094af935)]: (field)=>{
            if (field.__typename !== (0, $51d4762401af983e$export$4b2dddaf094af935)) return null;
            return {
                type: (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
                fieldId: field.fieldId,
                value: field.selectedTeam ? {
                    id: field.selectedTeam.jiraSuppliedTeamId,
                    name: field.selectedTeam.jiraSuppliedName ?? ''
                } : null
            };
        }
    });

});
const $51d4762401af983e$export$4b2dddaf094af935 = 'JiraTeamViewField';


parcelRegister("1eTr0", function(module, exports) {

$parcel$export(module.exports, "transformVersionField", () => $8a6c7a131969f81d$export$7beb4bd99d0c30b);

var $lO4Or = parcelRequire("lO4Or");

const $8a6c7a131969f81d$export$7beb4bd99d0c30b = ()=>({
        [(0, $fba37de157c6d93d$export$7d00c90aa4f1f657)]: (field)=>{
            if (field.__typename !== (0, $fba37de157c6d93d$export$7d00c90aa4f1f657)) return null;
            return {
                type: (0, $lO4Or.VERSION_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.version ? {
                    id: field.version.versionId,
                    name: field.version.name ?? ''
                } : null
            };
        },
        [(0, $fba37de157c6d93d$export$f240ecd334700f48)]: (field)=>{
            if (field.__typename !== (0, $fba37de157c6d93d$export$f240ecd334700f48)) return null;
            return {
                type: (0, $lO4Or.MULTI_VERSION_CF_TYPE),
                fieldId: field.fieldId,
                name: field.name,
                value: field.selectedVersionsConnection?.edges?.map?.((edge)=>edge?.node != null ? {
                        id: edge?.node.versionId,
                        name: edge?.node.name ?? ''
                    } : null).filter((version)=>version != null) ?? null
            };
        }
    });

});
const $fba37de157c6d93d$export$7d00c90aa4f1f657 = 'JiraSingleVersionPickerField';
const $fba37de157c6d93d$export$f240ecd334700f48 = 'JiraMultipleVersionPickerField';



parcelRegister("6BYzZ", function(module, exports) {

$parcel$export(module.exports, "DateOnly", () => $5d1ef987232e205a$export$988b361b394263b6);
$parcel$export(module.exports, "toDateOnly", () => $5d1ef987232e205a$export$b0961ad8aee63b8b);
const $5d1ef987232e205a$export$9cda9b56d134780f = 'Invalid date or date format';
const $5d1ef987232e205a$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
const $5d1ef987232e205a$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const $5d1ef987232e205a$var$daysInMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
/**
 Returns a boolean to indicate that the date specified is valid.

 Note: Dates before Year zero are treated to be invalid.
 */ const $5d1ef987232e205a$var$isDateValid = (year, month, day)=>{
    if ([
        year,
        month,
        day
    ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
    if (year < 0) return false;
    if (month < 1 || month > 12) return false;
    if (day < 1) return false;
    if (day > (month === 2 && $5d1ef987232e205a$var$isLeapYear(year) ? 29 : $5d1ef987232e205a$var$daysInMonth[month - 1])) return false;
    return true;
};
const $5d1ef987232e205a$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
class $5d1ef987232e205a$export$988b361b394263b6 {
    /**
	 * Return true if the string is a valid ISO date string in the format 'YYYY-MM-DD'.
	 * @param dateString
	 * @returns {boolean}
	 */ static isISODateString(dateString) {
        try {
            $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(dateString);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e?.message === $5d1ef987232e205a$export$9cda9b56d134780f) return false;
            throw e;
        }
        return true;
    }
    /**
	 * Create a DateOnly object from a string in the format 'YYYY-MM-DD'.
	 */ // go/jfe-eslint
    static fromISODateString(dateString) {
        const matches = $5d1ef987232e205a$var$dateFormatRegExp.exec(dateString);
        if (matches === null) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        const [, year, month, day] = matches;
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        return new $5d1ef987232e205a$export$988b361b394263b6(...[
            year,
            month,
            day
        ].map((s)=>Number.parseInt(s, 10)));
    }
    /**
	 * DISCLAIMER:
	 * Date() does NOT store timezone information.
	 *
	 * Date.prototype.toString() leverages the system's timezone to serialize it into a string according to local time.
	 * Methods getDate(), getMonth(), getFullYear() behave the same and also return values according to local time.
	 *
	 * Methods toUTCString(), getUTCDate(), getUTCMonth(), getUTCFullYear() return values according to universal time.
	 *
	 * Reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
	 */ /**
	 * Create a DateOnly object that reflects the local year, month & day for the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToLocalTime(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
	 * Create a DateOnly object that reflects the UTC year, month & day of the specified Date.
	 *
	 * See the disclaimer above for further details.
	 */ // go/jfe-eslint
    static fromDateAccordingToUTC(date) {
        return new $5d1ef987232e205a$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
    }
    /**
	 * Compare 2 DateOnly objects.
	 *
	 * (Similar to the TC39 proposal Temporal.PlainDate.compare).
	 *
	 * If a comes before b, return -1.
	 * If a is equal to b, return 0.
	 * If a is greater than b, return 1.
	 */ static compare(a, b) {
        if (a.year === b.year) {
            if (a.month === b.month) {
                if (a.day === b.day) return 0;
                return a.day < b.day ? -1 : 1;
            }
            return a.month < b.month ? -1 : 1;
        }
        return a.year < b.year ? -1 : 1;
    }
    /**
	 * Create a DateOnly object which represents a day. It does not have a time component.
	 * @param year - A year, ranging between 0 and 9999 inclusive.
	 * @param month - A month, ranging between 1 and 12 inclusive.
	 * @param day - A day of the month, ranging between 1 and 31 inclusive.
	 */ constructor(year, month, day){
        if (!$5d1ef987232e205a$var$isDateValid(year, month, day)) throw new Error($5d1ef987232e205a$export$9cda9b56d134780f);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    getYear() {
        return this.year;
    }
    getMonth() {
        return this.month;
    }
    getDay() {
        return this.day;
    }
    toISOString() {
        return $5d1ef987232e205a$var$toISOString(this.year, this.month, this.day);
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 which corresponds to the UTC timezone.
	 */ toUTCDate() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    }
    /**
	 * Returns a Date object with the same date, with the time component set to 00:00:00 for the local timezone.
	 */ toLocalDate() {
        // take the current date (e.g. 1.06.2020)
        const localDate = new Date();
        // store current month in a const to compare below
        const currentMonth = localDate.getMonth();
        // set the year
        localDate.setFullYear(this.year);
        localDate.setHours(0);
        localDate.setMinutes(0);
        localDate.setSeconds(0);
        localDate.setMilliseconds(0);
        localDate.setDate(this.day);
        // if this.day doesn't exist in the current month (e.g. 31 doesn't exist in June ),
        // it will set the month to July instead. We need to make sure setDate doesn't change the month
        if (localDate.getMonth() !== currentMonth) {
            localDate.setMonth(this.month - 1);
            // reset the date after updating the month
            localDate.setDate(this.day);
        } else localDate.setMonth(this.month - 1);
        return localDate;
    }
    equals(dateOnly) {
        return $5d1ef987232e205a$export$988b361b394263b6.compare(this, dateOnly) === 0;
    }
}
const $5d1ef987232e205a$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $5d1ef987232e205a$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;

});

parcelRegister("f5yXM", function(module, exports) {

$parcel$export(module.exports, "listViewTransformFields", () => $2e7db4abed8c4eed$export$34af57b660300007);

var $dHtvo = parcelRequire("dHtvo");

var $h9cCP = parcelRequire("h9cCP");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $7v0hO = parcelRequire("7v0hO");

var $gDg11 = parcelRequire("gDg11");
const $2e7db4abed8c4eed$var$transformTimeTracking = (originalEstimate, timeTrackingOptions, intl)=>{
    if (originalEstimate) return {
        timeInSeconds: Number(originalEstimate.timeInSeconds) || undefined,
        timeAsString: (0, $7v0hO.timeTrackingFormatter)(Number(originalEstimate.timeInSeconds), {
            ...timeTrackingOptions,
            timeFormat: (0, $gDg11.timeFormatMap).get(timeTrackingOptions.timeFormat) || (0, $h9cCP.PRETTY)
        }, intl)
    };
    return null;
};
const $2e7db4abed8c4eed$var$transformUser = (user)=>{
    if (user) return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        accountId: user.accountId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        name: user.name,
        picture: user.picture ?? ''
    };
    return null;
};
const $2e7db4abed8c4eed$var$transformUsers = (users)=>{
    if (users) return users.map((user)=>$2e7db4abed8c4eed$var$transformUser(user?.node));
    return null;
};
const $2e7db4abed8c4eed$var$transformSelectField = (selectedOption)=>{
    if (selectedOption) return {
        optionId: String(selectedOption.optionId),
        value: selectedOption.value,
        ...selectedOption.color ? {
            color: selectedOption.color?.colorKey
        } : {}
    };
    return null;
};
const $2e7db4abed8c4eed$export$d4a0295c1cbaac03 = (selectedOptions)=>{
    if (selectedOptions) return selectedOptions.map((option)=>option?.node?.optionId && option?.node?.value ? $2e7db4abed8c4eed$var$transformSelectField(option.node) : null).filter((option)=>option !== null);
    return null;
};
const $2e7db4abed8c4eed$export$c072126708d93f04 = (labels)=>{
    if (labels) return labels.map((label)=>label?.node?.name ?? null).filter((label)=>label !== null);
    return null;
};
const $2e7db4abed8c4eed$var$transformSprint = (sprints)=>{
    if (sprints) return sprints.map((sprint)=>sprint?.node ?? null).filter((sprint)=>sprint !== null);
    return null;
};
const $2e7db4abed8c4eed$export$b5df62b8f5dea4f9 = (componentValues)=>{
    if (componentValues?.length) return componentValues.map((componentValue)=>componentValue?.node?.componentId ? {
            componentId: componentValue.node?.componentId ?? '',
            name: componentValue.node?.name ?? null
        } : null).filter((componentValue)=>componentValue !== null);
    return null;
};
const $2e7db4abed8c4eed$var$transformParent = (parentIssue)=>{
    if (parentIssue) return {
        issueId: parentIssue.issueId,
        issueKey: parentIssue.key
    };
    return null;
};
const $2e7db4abed8c4eed$var$listFieldTransformers = {
    JiraIssueTypeField: (field)=>{
        if (field.__typename !== 'JiraIssueTypeField') return null;
        return {
            type: (0, $lO4Or.ISSUE_TYPE),
            fieldId: field.fieldId,
            value: field.issueType?.name ?? null,
            ...(0, $1ybV0.ff)('jwm.visual-hierarchy-dnd') && {
                level: field.issueType?.hierarchy?.level
            }
        };
    },
    JiraSingleLineTextField: (field)=>{
        if (field.__typename !== 'JiraSingleLineTextField') return null;
        return {
            type: field.type === 'issuekey' ? 'key' : field.type,
            fieldId: field.fieldId,
            value: field.text
        };
    },
    JiraUrlField: (field)=>{
        if (field.__typename !== 'JiraUrlField') return null;
        return {
            type: (0, $lO4Or.URL_CF_TYPE),
            fieldId: field.fieldId,
            value: field.uri
        };
    },
    JiraRichTextField: (field)=>{
        if (field.__typename !== 'JiraRichTextField') return null;
        const value = field.richText?.adfValue?.json;
        return {
            type: (0, $lO4Or.TEXT_AREA_CF_TYPE),
            fieldId: field.fieldId,
            value: value ? JSON.stringify(value) : ''
        };
    },
    JiraStatusField: (field)=>{
        if (field.__typename !== 'JiraStatusField') return null;
        return {
            type: (0, $lO4Or.STATUS_TYPE),
            fieldId: field.fieldId,
            name: field.status?.name,
            value: Number(field.status?.statusCategory?.statusCategoryId) ? Number(field.status?.statusCategory?.statusCategoryId) : null
        };
    },
    JiraSingleSelectUserPickerField: (field)=>{
        if (field.__typename !== 'JiraSingleSelectUserPickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformUser(field.user)
        };
    },
    JiraLabelsField: (field)=>{
        if (field.__typename !== 'JiraLabelsField') return null;
        return {
            type: field.fieldId === 'labels' ? (0, $lO4Or.LABELS_TYPE) : (0, $lO4Or.LABELS_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$c072126708d93f04(field.selectedLabelsConnection?.edges ?? null)
        };
    },
    JiraPriorityField: (field)=>{
        if (field.__typename !== 'JiraPriorityField') return null;
        if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return {
            type: (0, $lO4Or.PRIORITY_TYPE),
            fieldId: field.fieldId,
            value: field.priority ? {
                name: field.priority.name,
                priorityId: field.priority.priorityId,
                iconUrl: field.priority.iconUrl
            } : null
        };
        return {
            type: (0, $lO4Or.PRIORITY_TYPE),
            fieldId: field.fieldId,
            value: field.priority?.name ?? null,
            priorityId: field.priority?.priorityId ?? null
        };
    },
    JiraDateTimePickerField: (field)=>{
        if (field.__typename !== 'JiraDateTimePickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: field.dateTime
        };
    },
    JiraMultipleSelectField: (field)=>{
        if (field.__typename !== 'JiraMultipleSelectField') return null;
        return {
            type: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
        };
    },
    JiraSingleSelectField: (field)=>{
        if (field.__typename !== 'JiraSingleSelectField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformSelectField(field.fieldOption) ?? null
        };
    },
    // Use the timetracking field to map to the timeoriginalestimate field rather than directly using
    // timeoriginalestimate because timetracking returns data needed to determine the timeAsString.
    // Logic to request for the timetracking field data if timeoriginalestimate is in list view is in
    // `getQueryFieldIds` in src/packages/business/list/src/controllers/get-issue-fields/index.tsx
    JiraTimeTrackingField: (field, intl)=>{
        if (field.__typename !== 'JiraTimeTrackingField' || field.originalEstimate?.timeInSeconds == null || field.timeTrackingSettings?.workingHoursPerDay == null || field.timeTrackingSettings?.workingDaysPerWeek == null || field.timeTrackingSettings?.defaultUnit == null || intl == null) {
            if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return {
                type: (0, $lO4Or.TIME_ESTIMATE_TYPE),
                fieldId: 'timeoriginalestimate',
                value: null
            };
            return null;
        }
        const { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultFormat: timeFormat, defaultUnit: defaultUnit } = field.timeTrackingSettings;
        return {
            type: (0, $lO4Or.TIME_ESTIMATE_TYPE),
            fieldId: 'timeoriginalestimate',
            value: $2e7db4abed8c4eed$var$transformTimeTracking(field.originalEstimate, {
                workingHoursPerDay: workingHoursPerDay,
                workingDaysPerWeek: workingDaysPerWeek,
                timeFormat: timeFormat || (0, $h9cCP.PRETTY),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                defaultUnit: defaultUnit
            }, intl)
        };
    },
    JiraDatePickerField: (field)=>{
        if (field.__typename !== 'JiraDatePickerField') return null;
        return {
            type: field.type,
            fieldId: field.fieldId,
            value: field.date
        };
    },
    JiraNumberField: (field)=>{
        if (field.__typename !== 'JiraNumberField') return null;
        return {
            type: field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE) || field.type === (0, $lO4Or.STORY_POINTS_TYPE) ? field.type : (0, $lO4Or.NUMBER_CF_TYPE),
            fieldId: field.fieldId,
            value: field.number
        };
    },
    JiraMultipleSelectUserPickerField: (field)=>{
        if (field.__typename !== 'JiraMultipleSelectUserPickerField') return null;
        return {
            type: (0, $lO4Or.MULTI_USER_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
        };
    },
    JiraPeopleField: (field)=>{
        if (field.__typename !== 'JiraPeopleField') return null;
        return {
            type: (0, $lO4Or.PEOPLE_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformUsers(field.selectedUsersConnection?.edges ?? null)
        };
    },
    JiraComponentsField: (field)=>{
        if (field.__typename !== 'JiraComponentsField') return null;
        return {
            type: (0, $lO4Or.COMPONENTS_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$b5df62b8f5dea4f9(field.selectedComponentsConnection?.edges ?? null)
        };
    },
    JiraParentIssueField: (field)=>{
        if (field.__typename !== 'JiraParentIssueField') return null;
        return {
            type: (0, $lO4Or.PARENT_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformParent(field.parentIssue)
        };
    },
    JiraCheckboxesField: (field)=>{
        if (field.__typename !== 'JiraCheckboxesField') return null;
        return {
            type: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$export$d4a0295c1cbaac03(field.selectedOptions?.edges ?? null)
        };
    },
    JiraSprintField: (field)=>{
        if (field.__typename !== 'JiraSprintField') return null;
        return {
            type: (0, $lO4Or.SPRINT_TYPE),
            fieldId: field.fieldId,
            value: $2e7db4abed8c4eed$var$transformSprint(field.selectedSprintsConnection?.edges ?? null)
        };
    }
};
const $2e7db4abed8c4eed$var$listViewTransformField = (field, intl)=>{
    if (field == null) return null;
    if ((0, $dHtvo.isTransformFieldSupported)(field) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $dHtvo.transformField)(field, intl);
    if (field.__typename in $2e7db4abed8c4eed$var$listFieldTransformers) return $2e7db4abed8c4eed$var$listFieldTransformers[field.__typename](field, intl);
    return null;
};
const $2e7db4abed8c4eed$export$34af57b660300007 = (fields, intl)=>{
    const toReturn = [];
    fields?.forEach((field)=>{
        const transformedField = $2e7db4abed8c4eed$var$listViewTransformField(field, intl);
        if (transformedField != null) toReturn.push(transformedField);
    });
    return toReturn;
};

});
parcelRegister("h9cCP", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $335f9886067ef898$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $335f9886067ef898$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $335f9886067ef898$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $335f9886067ef898$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $335f9886067ef898$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $335f9886067ef898$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $335f9886067ef898$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $335f9886067ef898$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $335f9886067ef898$export$83f9ac2d887bd06a);
const $335f9886067ef898$export$f4aba04677f37907 = 'minute';
const $335f9886067ef898$export$1bf939ebcf31ef0e = 'hour';
const $335f9886067ef898$export$1a58b8d7f494dd72 = 'day';
const $335f9886067ef898$export$3241045aa1844a20 = 'week';
const $335f9886067ef898$export$b387b66963374517 = 'days';
const $335f9886067ef898$export$f25ebc73c10ad2c = 'hours';
const $335f9886067ef898$export$d39e6ebabedff673 = 'pretty';
const $335f9886067ef898$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $335f9886067ef898$export$f4aba04677f37907,
    format: $335f9886067ef898$export$d39e6ebabedff673
};
const $335f9886067ef898$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatter = (timeInSeconds, units)=>{
    const timeForZero = `0${units[3].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongForm = (timeInSeconds, units)=>{
    const timeForZero = `0${units[7].suffix}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (unit?.isSingular) {
            if (currentTimeValue === 1) return {
                secondsRemaining: timeObj.secondsRemaining % unit.seconds,
                time: `${timeObj.time} ${currentTimeValue}${unit.suffix}`
            };
            return timeObj;
        }
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue}${unit.suffix}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitWeek),
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitDay),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitHour),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: formatMessage((0, $eyAhE.default).timeUnitMinute),
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[1].seconds : 0, units[1].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatter(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const units = [
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekSingular)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongWeekPlural)}`,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDaySingular)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongDayPlural)}`,
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongHourPlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinuteSingular)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE),
            isSingular: true
        },
        {
            suffix: ` ${formatMessage((0, $eyAhE.default).timeUnitLongMinutePlural)}`,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        }
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR) * workingHoursPerDay) return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[2].seconds : 0, units[2].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeInDaysValid ? timeInSeconds / units[3].seconds : 0, units[3].suffix);
        case (0, $4m36T.TimeFormats).HOURS:
            if (timeInSeconds === (0, $4m36T.SECONDS_PER_HOUR)) return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[4].seconds : 0, units[4].suffix);
            return $84936c9163886c98$var$timeFormatter(isTimeValid ? timeInSeconds / units[5].seconds : 0, units[5].suffix);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatterLongForm(timeInSeconds, units);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeekPlural: {
        "id": "time-tracking-formatter.time-unit-long-week-plural",
        "defaultMessage": "weeks"
    },
    timeUnitLongDayPlural: {
        "id": "time-tracking-formatter.time-unit-long-day-plural",
        "defaultMessage": "days"
    },
    timeUnitLongHourPlural: {
        "id": "time-tracking-formatter.time-unit-long-hour-plural",
        "defaultMessage": "hours"
    },
    timeUnitLongMinutePlural: {
        "id": "time-tracking-formatter.time-unit-long-minute-plural",
        "defaultMessage": "minutes"
    },
    timeUnitLongWeekSingular: {
        "id": "time-tracking-formatter.time-unit-long-week-singular",
        "defaultMessage": "week"
    },
    timeUnitLongDaySingular: {
        "id": "time-tracking-formatter.time-unit-long-day-singular",
        "defaultMessage": "day"
    },
    timeUnitLongHourSingular: {
        "id": "time-tracking-formatter.time-unit-long-hour-singular",
        "defaultMessage": "hour"
    },
    timeUnitLongMinuteSingular: {
        "id": "time-tracking-formatter.time-unit-long-minute-singular",
        "defaultMessage": "minute"
    }
});

});


parcelRegister("gDg11", function(module, exports) {

$parcel$export(module.exports, "timeFormatMap", () => $b8cb5c2f048086dd$export$17f3cee8c0df1);

var $h9cCP = parcelRequire("h9cCP");
const $b8cb5c2f048086dd$export$17f3cee8c0df1 = new Map([
    [
        'HOURS',
        (0, $h9cCP.HOURS)
    ],
    [
        'hours',
        (0, $h9cCP.HOURS)
    ],
    [
        'DAYS',
        (0, $h9cCP.DAYS)
    ],
    [
        'days',
        (0, $h9cCP.DAYS)
    ],
    [
        'PRETTY',
        (0, $h9cCP.PRETTY)
    ],
    [
        'pretty',
        (0, $h9cCP.PRETTY)
    ]
]);

});




parcelRegister("fXrll", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcdf474eb5d3060$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $abcdf474eb5d3060$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.children-query.error-title",
        "defaultMessage": "We couldn't load items."
    },
    errorMessage: {
        "id": "business-list.controllers.children-query.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("iGWrT", function(module, exports) {

$parcel$export(module.exports, "useSetChildrenItems", () => $45e960eb5c7066b0$export$1d27e69d8e0f02db);

var $eUqFw = parcelRequire("eUqFw");

var $hHiDc = parcelRequire("hHiDc");

var $8gkkx = parcelRequire("8gkkx");

var $5r9Wo = parcelRequire("5r9Wo");
const $45e960eb5c7066b0$export$1d27e69d8e0f02db = ()=>{
    const [, { setChildrenItems: setChildrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, $8gkkx.useRowCreateStore)();
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hHiDc.useIssueFields)();
    const setChildrenItemsWithDependencies = (0, $eUqFw.useCallback)((parentIssueId, queryData)=>setChildrenItems(parentIssueId, queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache), [
        setChildrenItems,
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache
    ]);
    return {
        setChildrenItems: setChildrenItemsWithDependencies
    };
};

});
parcelRegister("8gkkx", function(module, exports) {

$parcel$export(module.exports, "useRowCreateStore", () => $ab7138b15ee48bfe$export$b9c0fc956229dde8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $ab7138b15ee48bfe$var$initialState = {
    parentId: undefined,
    anchorId: undefined
};
const $ab7138b15ee48bfe$var$actions = {
    setRowCreatePosition: (rowCreatePosition)=>({ setState: setState })=>{
            if (rowCreatePosition) setState(rowCreatePosition);
        },
    resetRowCreatePosition: ()=>({ setState: setState })=>setState($ab7138b15ee48bfe$var$initialState)
};
const $ab7138b15ee48bfe$var$ListViewRowCreateStore = (0, $a61MH.createStore)({
    initialState: $ab7138b15ee48bfe$var$initialState,
    actions: $ab7138b15ee48bfe$var$actions,
    name: 'JWMListViewRowInlineCreate'
});
const $ab7138b15ee48bfe$export$b9c0fc956229dde8 = (0, $ggKAj.createHook)($ab7138b15ee48bfe$var$ListViewRowCreateStore);

});



parcelRegister("xqSqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfae6c6d38ca00fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4G5xU = parcelRequire("4G5xU");

var $dWGNJ = parcelRequire("dWGNJ");

var $hzcvF = parcelRequire("hzcvF");

var $gbsaq = parcelRequire("gbsaq");

var $dSE3z = parcelRequire("dSE3z");

var $6xvBl = parcelRequire("6xvBl");

var $94mYl = parcelRequire("94mYl");

var $iaqLb = parcelRequire("iaqLb");

var $5r9Wo = parcelRequire("5r9Wo");

var $2zwYz = parcelRequire("2zwYz");

var $fTRcw = parcelRequire("fTRcw");
const $bfae6c6d38ca00fc$var$GroupsLoader = ()=>{
    const items = (0, $6xvBl.useListItemGroups)();
    const { childrenLoader: childrenLoader } = (0, $iaqLb.useGroupChildrenLoader)({
        groups: items.data
    });
    const prevItems = (0, $hzcvF.usePreviousWithInitial)(items);
    const [, { expandFirstItems: expandFirstItems }] = (0, $5r9Wo.useHierarchyStore)();
    const { setHierarchyData: setHierarchyData } = (0, $fTRcw.useSetHierarchyData)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_GROUP_ITEMS_EXPERIENCE), {
        loading: items.loading,
        error: items.error,
        shouldStartExperience: true
    });
    // resets expanded items and queryData cache when filtering/sorting/groupBy is updated
    (0, $2zwYz.useResetItems)();
    // initialize items when switching between grouping -> hierarchy
    (0, $eUqFw.useEffect)(()=>{
        if (items.loading) return;
        setHierarchyData(items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.loading
    ]);
    // updates groups only when "data", "loading", "isLoadingNextPage" or "totalCount" changes
    (0, $eUqFw.useEffect)(()=>{
        if (prevItems.totalCount !== items.totalCount || prevItems.loading !== items.loading || prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
    }, [
        items,
        prevItems,
        setHierarchyData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!items.loading && groupByFieldId != null) expandFirstItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        items.loading,
        groupByFieldId
    ]);
    // avoid re-fetching children when GroupsLoader re-renders
    const groupChildrenLoader = (0, $eUqFw.useMemo)(()=>childrenLoader, [
        childrenLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, groupChildrenLoader, items.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: items.error,
        title: (0, $94mYl.default).errorTitle,
        description: (0, $94mYl.default).errorMessage
    }));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$bfae6c6d38ca00fc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($bfae6c6d38ca00fc$var$GroupsLoader);

});
parcelRegister("6xvBl", function(module, exports) {

$parcel$export(module.exports, "useListItemGroups", () => $445faaf6b4924d57$export$cc19d2aa74250242);

var $eZbpk = parcelRequire("eZbpk");

var $7O3Xq = parcelRequire("7O3Xq");

var $dSE3z = parcelRequire("dSE3z");
const $445faaf6b4924d57$export$cc19d2aa74250242 = ()=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    return (0, $7O3Xq.useListItemGroups)({
        input: {
            jqlContext: jqlContext,
            groupByFieldId: groupByFieldId
        }
    });
};

});
parcelRegister("7O3Xq", function(module, exports) {

$parcel$export(module.exports, "getGroupVariables", () => $d09cc729aa650ea5$export$5c591b26f9c07c51);
$parcel$export(module.exports, "useListViewGroupRecovery", () => $d09cc729aa650ea5$export$30e59d989a124a32);
$parcel$export(module.exports, "useListItemGroups", () => $d09cc729aa650ea5$export$cc19d2aa74250242);
/* eslint-disable camelcase */ 
var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $hYxMC = parcelRequire("hYxMC");

var $guiFP = parcelRequire("guiFP");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hzwAr = parcelRequire("hzwAr");

var $26iUh = parcelRequire("26iUh");
const $d09cc729aa650ea5$var$DEFAULT_ITEMS_PER_PAGE = 50;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d09cc729aa650ea5$var$emptyArray = [];
const $d09cc729aa650ea5$var$fieldIds = [
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID),
    (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
];
const $d09cc729aa650ea5$export$5c591b26f9c07c51 = ({ groupByFieldId: groupByFieldId, jqlContext: jqlContext })=>{
    const jql = jqlContext || '';
    return {
        jql: jql,
        first: $d09cc729aa650ea5$var$DEFAULT_ITEMS_PER_PAGE,
        groupByFieldId: groupByFieldId != null ? groupByFieldId : '',
        fieldIds: $d09cc729aa650ea5$var$fieldIds
    };
};
const $d09cc729aa650ea5$export$30e59d989a124a32 = (input, settings)=>{
    const variables = $d09cc729aa650ea5$export$5c591b26f9c07c51(input);
    return (0, $hYxMC.useGroupRecovery)({
        settings: settings,
        queryList: (0, $hzwAr.LIST_VIEW_ITEM_GROUPS_QUERY),
        queryBackgroundList: (0, $hzwAr.BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY),
        variables: variables,
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listRecoveryGroupQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in background in list view while grouping'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};
const $d09cc729aa650ea5$export$cc19d2aa74250242 = ({ input: input })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isLoadingNextPage, setIsLoadingNextPage] = (0, $eUqFw.useState)(false);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $iZuDo.useQuery)((0, $hzwAr.LIST_VIEW_ITEM_GROUPS_QUERY), {
        variables: $d09cc729aa650ea5$export$5c591b26f9c07c51(input),
        onCompleted: (responseData)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listViewItemGroupsQuery succeeded', {
                groupsCount: responseData.groups?.nodes?.length
            });
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewItemGroupsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch item groups in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const totalCount = data?.groups?.totalCount || 0;
    const nodes = data?.groups?.nodes || $d09cc729aa650ea5$var$emptyArray;
    const hasNextPage = data?.groups?.pageInfo?.hasNextPage || false;
    const endCursor = data?.groups?.pageInfo?.endCursor || '';
    const result = (0, $eUqFw.useMemo)(()=>{
        if (!Array.isArray(nodes) || nodes.length === 0) return [];
        return (0, $26iUh.transformResult)(nodes);
    }, [
        nodes
    ]);
    const loadNextPage = (0, $eUqFw.useCallback)(()=>{
        /*
		 * Do not load the same page twice and do not load the next page if
		 * a request is already in progress.
		 */ if (!hasNextPage || loading) return;
        setIsLoadingNextPage(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'table endReached');
        fetchMore({
            variables: {
                ...$d09cc729aa650ea5$export$5c591b26f9c07c51(input),
                after: endCursor
            },
            // @ts-expect-error - The expected type comes from property 'updateQuery' which is declared here on type 'FetchMoreQueryOptions<JWMListViewItemGroupsWithPaginationVariables, keyof
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                setIsLoadingNextPage(false);
                if (!fetchMoreResult) return prev;
                const updatedNodes = [
                    ...prev?.groups?.nodes || [],
                    ...fetchMoreResult?.groups?.nodes || []
                ];
                return {
                    groups: {
                        ...fetchMoreResult.groups,
                        nodes: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(updatedNodes, 'id')
                    }
                };
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onError: (apolloError)=>{
                (0, $guiFP.default)({
                    meta: {
                        id: 'listViewItemGroupsQuery',
                        packageName: 'jiraBusinessList',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: 'Failed to fetch more item groups in list view'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        createAnalyticsEvent,
        endCursor,
        fetchMore,
        hasNextPage,
        input,
        loading
    ]);
    return {
        data: result,
        loading: loading,
        error: error,
        totalCount: totalCount,
        hasNextPage: hasNextPage,
        isLoadingNextPage: isLoadingNextPage,
        loadNextPage: loadNextPage
    };
};

});
parcelRegister("hYxMC", function(module, exports) {

$parcel$export(module.exports, "useGroupRecovery", () => $945eecde7a3a52d2$export$b5990c6f00139390);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $c4MRZ = parcelRequire("c4MRZ");

var $guiFP = parcelRequire("guiFP");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $12sJv = parcelRequire("12sJv");
const $945eecde7a3a52d2$var$MAX_ITEMS_PER_PAGE = 50;
const $945eecde7a3a52d2$var$getOperationName = (query)=>{
    const operation = (0, $c4MRZ.getOperationAST)(query, undefined);
    return operation && operation.name && operation.name.value || '';
};
const $945eecde7a3a52d2$export$b5990c6f00139390 = ({ settings: settings, queryList: queryList, queryBackgroundList: queryBackgroundList, variables: variables, onError: onError })=>{
    const analyticsTaskId = $945eecde7a3a52d2$var$getOperationName(queryBackgroundList);
    const analyticsTaskName = 'groupsBackgroundRefetch';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const backgroundQueryVariables = (0, $eUqFw.useMemo)(()=>({
            ...variables,
            first: $945eecde7a3a52d2$var$MAX_ITEMS_PER_PAGE
        }), [
        variables
    ]);
    const client = (0, $iZuDo.useApolloClient)();
    const [fetchListInBackground, { loading: loading, data: data, fetchMore: fetchMore }] = (0, $iZuDo.useLazyQuery)(queryBackgroundList, {
        fetchPolicy: 'network-only',
        onError: onError
    });
    const [hasStarted, setHasStarted] = (0, $eUqFw.useState)(false);
    const [hasFinished, setHasFinished] = (0, $eUqFw.useState)(false);
    const [refreshCount, setRefreshCount] = (0, $eUqFw.useState)(0);
    const [currentQuery, setCurrentQuery] = (0, $eUqFw.useState)();
    const [currentGroup, setCurrentGroup] = (0, $eUqFw.useState)();
    const listEndCursor = (0, $eUqFw.useRef)(undefined);
    const { hasNextPage: hasNextPage, endCursor: endCursor } = data?.backgroundGroups?.pageInfo || {};
    const prevEndCursor = (0, $hzcvF.usePreviousWithInitial)(endCursor);
    // refetch all pages until the current endCursor: if we have 5 pages in total, list endCursor is on page 2,
    // then background refresh will pull first 2 pages only
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && hasNextPage && // query pages one-by-one until we reach the current page
        endCursor !== listEndCursor.current && // query pages only when endCursor changes,
        // otherwise it might query the same page multiple times due to re-renders of useListRecovery
        endCursor !== prevEndCursor) fetchMore({
            variables: {
                ...backgroundQueryVariables,
                after: endCursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult) return prev;
                const updatedNodes = [
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...prev?.backgroundGroups?.nodes || [],
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...fetchMoreResult?.backgroundGroups?.nodes || []
                ];
                return {
                    backgroundGroups: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...fetchMoreResult.backgroundGroups,
                        nodes: updatedNodes
                    }
                };
            }
        });
    }, [
        hasStarted,
        hasNextPage,
        endCursor,
        prevEndCursor,
        fetchListInBackground,
        backgroundQueryVariables,
        fetchMore
    ]);
    // abort background operations if a new query is provided
    (0, $eUqFw.useEffect)(()=>{
        if (!hasStarted || variables.jql === currentQuery && variables.groupByFieldId === currentGroup) return;
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskAbort', {
            task: analyticsTaskName,
            taskId: analyticsTaskId,
            reason: 'query has changed'
        });
        setHasFinished(true);
        setHasStarted(false);
        setCurrentQuery(undefined);
        setCurrentGroup(undefined);
    }, [
        analyticsTaskId,
        createAnalyticsEvent,
        currentGroup,
        currentQuery,
        hasStarted,
        variables,
        variables.groupByFieldId,
        variables.jql
    ]);
    // replace list items with backgroundList items so the main view will update
    (0, $eUqFw.useEffect)(()=>{
        if (hasStarted && !hasFinished && !loading && listEndCursor.current === endCursor) try {
            const backgroundListData = client.readQuery({
                query: queryBackgroundList,
                variables: backgroundQueryVariables
            });
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: queryList,
                        variables: variables
                    });
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName,
                        taskId: analyticsTaskId
                    });
                    return read;
                } catch (e) {
                    (0, $guiFP.default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'useGroupRecovery',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            taskId: analyticsTaskId,
                            query: JSON.stringify(queryList),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const listData = getCachedListData();
            setRefreshCount(refreshCount + 1);
            setHasFinished(true);
            setHasStarted(false);
            setCurrentQuery(undefined);
            setCurrentGroup(undefined);
            if (!backgroundListData || backgroundListData.backgroundGroups == null || !listData || listData.groups == null || !Array.isArray(backgroundListData.backgroundGroups.nodes) || !Array.isArray(listData.groups.nodes)) throw new Error('Conditions not met');
            const { backgroundGroups: backgroundGroups } = backgroundListData;
            if (backgroundGroups.nodes == null) return;
            client.writeQuery({
                query: queryList,
                variables: variables,
                data: {
                    groups: {
                        ...backgroundGroups,
                        nodes: backgroundGroups.nodes
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskSuccess', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                details: `${backgroundGroups.nodes.length} items updated`
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
                task: analyticsTaskName,
                taskId: analyticsTaskId,
                error: `Failed to refresh data in the background (${e.name || 'error'})`
            });
        }
    }, [
        hasStarted,
        client,
        loading,
        hasFinished,
        refreshCount,
        backgroundQueryVariables,
        queryList,
        queryBackgroundList,
        variables,
        createAnalyticsEvent,
        analyticsTaskId,
        endCursor
    ]);
    const refreshList = (0, $eUqFw.useCallback)(()=>{
        if (hasStarted && !hasFinished || settings.isDisabled) return;
        const listData = client.readQuery({
            query: queryList,
            variables: variables
        });
        // store current list endCursor so that we know at what page to stop backgroundList fetching
        listEndCursor.current = listData?.groups?.pageInfo?.endCursor;
        fetchListInBackground({
            variables: backgroundQueryVariables
        });
        setCurrentQuery(variables.jql);
        setCurrentGroup(variables.groupByFieldId);
        setHasStarted(true);
        setHasFinished(false);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskStart', {
            task: analyticsTaskName,
            taskId: analyticsTaskId
        });
    }, [
        analyticsTaskId,
        backgroundQueryVariables,
        client,
        createAnalyticsEvent,
        fetchListInBackground,
        hasFinished,
        hasStarted,
        queryList,
        settings.isDisabled,
        variables
    ]);
    const isRefreshing = hasStarted && !hasFinished;
    (0, $12sJv.useRefreshInterval)(refreshList, // it won't trigger a refresh if another has been triggered
    // it won't trigger refresh if the tab is invisible
    settings.isVisible && !isRefreshing, settings.updateInterval);
    return {
        isRefreshing: isRefreshing,
        refreshCount: refreshCount,
        refreshList: refreshList
    };
};

});

parcelRegister("hzwAr", function(module, exports) {

$parcel$export(module.exports, "LIST_VIEW_ITEM_GROUPS_QUERY", () => $b9b4939e9b1787b5$export$ee6c63a9d588e5da);
$parcel$export(module.exports, "BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY", () => $b9b4939e9b1787b5$export$1531880e8d0ec6bc);

var $9ypom = parcelRequire("9ypom");

var $k2u2Z = parcelRequire("k2u2Z");
const $b9b4939e9b1787b5$export$ee6c63a9d588e5da = (0, $9ypom.default)`
    query JWMListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        groups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "groups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, $k2u2Z.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;
const $b9b4939e9b1787b5$export$1531880e8d0ec6bc = (0, $9ypom.default)`
    query JiraBusinessBackgroundListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        backgroundGroups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "backgroundGroups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${(0, $k2u2Z.JWM_CATEGORY_OPTIONS_FRAGMENT)}
`;

});
parcelRegister("k2u2Z", function(module, exports) {

$parcel$export(module.exports, "JWM_CATEGORY_OPTIONS_FRAGMENT", () => $c539c000b5100098$export$61519670a3514192);

var $9ypom = parcelRequire("9ypom");
const $c539c000b5100098$export$61519670a3514192 = (0, $9ypom.default)`
    fragment JwmCategoryOptionsFragment on JiraWorkManagementCategoryOption {
        id
        color
        option {
            id
            optionId
            value
            isDisabled
        }
    }
`;

});


parcelRegister("26iUh", function(module, exports) {

$parcel$export(module.exports, "createGroupIssueId", () => $119f79f94d421d34$export$4ac2cce4af64b535);
$parcel$export(module.exports, "transformResult", () => $119f79f94d421d34$export$f13b29f9ed0c5a03);
$parcel$export(module.exports, "getGroupQuery", () => $119f79f94d421d34$export$399b257fbf191156);
$parcel$export(module.exports, "findItemGroup", () => $119f79f94d421d34$export$326ed4587250ed11);
$parcel$export(module.exports, "createItemGroup", () => $119f79f94d421d34$export$c8d5f559d504cbde);
/* eslint-disable camelcase */ 
var $hompL = parcelRequire("hompL");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $7Sz8O = parcelRequire("7Sz8O");
var $4oWxH = parcelRequire("4oWxH");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");
const $119f79f94d421d34$export$4ac2cce4af64b535 = (nodeId)=>`${0, $7Sz8O.GROUP_ITEM_PREFIX}_${nodeId}`;
const $119f79f94d421d34$export$eb0e89edd4882353 = (statusIdPath = '')=>{
    if (statusIdPath == null) return '';
    const splitStatusIdPath = statusIdPath.split('/');
    return splitStatusIdPath[splitStatusIdPath.length - 1];
};
const $119f79f94d421d34$var$getFieldNameForJql = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    return fieldName;
};
const $119f79f94d421d34$var$getCategory = (field)=>{
    if (field && 'category' in field && field.category != null && field.category.option != null) return {
        fieldKey: field.fieldKey,
        name: field.category.option.value,
        optionId: field.category.option.optionId,
        color: field.category.color ?? null
    };
    return {};
};
const $119f79f94d421d34$var$getStoryPoints = (field)=>field?.__typename === 'FloatCustomField' && 'floatValue' in field ? field.floatValue : null;
const $119f79f94d421d34$var$getSprint = (field)=>{
    if (field && field.__typename === 'SprintCustomField' && field.values && field.values[0]) return {
        fieldKey: field.fieldKey,
        title: field.title,
        id: field.values[0].id,
        name: field.values[0].name,
        state: field.values[0].state
    };
    return null;
};
const $119f79f94d421d34$export$f13b29f9ed0c5a03 = (nodes)=>{
    if (!nodes) return [];
    return nodes.map((node)=>{
        const { id: id, field: field } = node || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = {};
        if (field && 'fieldKey' in field && field.fieldKey != null) values[field.fieldKey] = field;
        const totalCount = node?.totalCount;
        const groupItem = {
            id: id,
            issueId: $119f79f94d421d34$export$4ac2cce4af64b535(id || ''),
            key: '',
            typeId: '',
            issuetype: {},
            rank: '',
            status: values.status ? {
                id: values.status.statusId,
                name: values.status.name,
                categoryId: values.status.statusCategoryId
            } : {},
            ...values.assignee ? values.assignee.userValue && {
                assignee: {
                    accountId: values.assignee.userValue.accountId,
                    displayName: values.assignee.userValue.displayName,
                    avatarUrl: values.assignee.userValue.avatarUrl
                }
            } : {},
            labels: values.labels && values.labels.labels || [],
            priority: values.priority ? {
                id: values.priority.id,
                name: values.priority.name,
                iconUrl: values.priority.iconUrl
            } : {},
            category: $119f79f94d421d34$var$getCategory(field),
            childSummary: {
                totalCount: totalCount,
                hasChildren: (totalCount ?? 0) > 0
            },
            storypoints: $119f79f94d421d34$var$getStoryPoints(field),
            storypointestimate: $119f79f94d421d34$var$getStoryPoints(field),
            sprint: $119f79f94d421d34$var$getSprint(field)
        };
        return groupItem;
    });
};
const $119f79f94d421d34$export$399b257fbf191156 = ({ groupIssueId: groupIssueId, groupByFieldId: groupByFieldId, groups: groups })=>{
    if (!groups || !groupByFieldId) return undefined;
    const groupItem = groups.find((group)=>group.issueId === groupIssueId);
    if (!groupItem) return undefined;
    if (groupByFieldId === (0, $lO4Or.ASSIGNEE_TYPE)) return {
        jqlTerm: (0, $lO4Or.ASSIGNEE_TYPE),
        value: groupItem.assignee?.accountId
    };
    if (groupByFieldId === (0, $lO4Or.PRIORITY_TYPE)) {
        const priorityId = groupItem?.priority?.id;
        return {
            jqlTerm: (0, $lO4Or.PRIORITY_TYPE),
            value: priorityId ? (0, $huI7r.getAriConfig)(priorityId).resourceId : undefined
        };
    }
    if (groupByFieldId === (0, $lO4Or.STATUS_TYPE)) {
        const statusAri = (0, $huI7r.getAriConfig)(groupItem?.status?.id ?? '');
        return {
            jqlTerm: (0, $lO4Or.STATUS_TYPE),
            value: statusAri?.resourceId
        };
    }
    if (groupByFieldId.startsWith('customfield_')) {
        const getValue = ()=>{
            if (groupItem.category) {
                const categoryName = groupItem.category?.name ?? undefined;
                if (categoryName) // wrap with quotes and escape quotes
                return `"${categoryName.replace(/"/g, '\\"')}"`;
            }
            if (typeof groupItem.storypoints === 'number') return groupItem.storypoints;
            if (typeof groupItem.storypointestimate === 'number') return groupItem.storypointestimate;
            if (groupItem.sprint) return groupItem.sprint && String(groupItem.sprint?.id) || undefined;
            return undefined;
        };
        return {
            jqlTerm: $119f79f94d421d34$var$getFieldNameForJql(groupByFieldId),
            value: getValue()
        };
    }
    return undefined;
};
const $119f79f94d421d34$export$326ed4587250ed11 = ({ item: item, groups: groups, groupByFieldId: groupByFieldId, isGroupingByCategory: isGroupingByCategory = false })=>{
    if (!groups || !groupByFieldId) return undefined;
    const field = (0, $3uSNh.getFieldValue)(item.fields, groupByFieldId);
    // if item doesn't support category field but list is grouped by category, return the uncategorized group
    if (!field && isGroupingByCategory) return groups.find((group)=>!group.category?.name);
    return groups.find((group)=>{
        switch(field?.type){
            case 0, $lO4Or.CATEGORY_TYPE:
                return String(group?.category?.optionId) === String((0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'fieldOption', undefined)?.optionId);
            case 0, $lO4Or.ASSIGNEE_TYPE:
                return groupByFieldId && group.assignee?.accountId === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'user', undefined)?.accountId;
            case 0, $lO4Or.STATUS_TYPE:
                return groupByFieldId && $119f79f94d421d34$export$eb0e89edd4882353(group.status?.id) === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'status.statusId', undefined);
            case 0, $lO4Or.PRIORITY_TYPE:
                return groupByFieldId && group.priority?.name === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'priority.name', undefined);
            case 0, $lO4Or.SPRINT_TYPE:
                return $119f79f94d421d34$var$getSprintGroup(item, group);
            case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                return groupByFieldId && group.storypointestimate === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
            case 0, $lO4Or.NUMBER_CF_TYPE:
                if (field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return groupByFieldId && group.storypoints === (0, $3uSNh.safeGetValue)(item.fields, groupByFieldId, 'number', undefined);
                return false;
            default:
                return false;
        }
    });
};
const $119f79f94d421d34$var$getSprintGroup = (item, group)=>{
    const sprintId = (0, $3uSNh.safeGetValue)(item.fields, 'sprint', 'selectedSprintsConnection.edges[0].node.sprintId', undefined);
    if (!sprintId) return group.sprint === null;
    return group.sprint?.id === Number(sprintId);
};
const $119f79f94d421d34$export$c86575e2d4de1020 = ({ item: item, groupItemsQueryData: groupItemsQueryData })=>{
    if (!groupItemsQueryData) return undefined;
    const keys = Object.keys(groupItemsQueryData);
    // an issue can be in multiple groups due to hierarchy items appearing at all levels
    const matchingGroups = keys.filter((groupIssueId)=>// data could be undefined if is loading
        groupItemsQueryData[groupIssueId].data?.find((node)=>node.issueId === item.issueId));
    return matchingGroups.find((groupName)=>(0, $4oWxH.isGroupItem)(groupName)) ?? matchingGroups[0];
};
const $119f79f94d421d34$var$convertFieldToGroupItemField = (groupByFieldId, field)=>{
    if (groupByFieldId === (0, $lO4Or.ASSIGNEE_TYPE) && field) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const userField = field;
        const convertedField = {
            fieldKey: groupByFieldId,
            userValue: {
                accountId: userField.user?.accountId ?? null,
                displayName: userField.user?.name ?? null,
                avatarUrl: userField.user?.picture,
                __typename: 'UserValue'
            },
            __typename: 'UserField'
        };
        return convertedField;
    }
    if (groupByFieldId === (0, $lO4Or.PRIORITY_TYPE) && field) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const priorityField = field;
        const convertedField = {
            fieldKey: groupByFieldId,
            name: priorityField.priority?.name ?? null,
            id: priorityField.priority?.id ?? null,
            iconUrl: priorityField.priority?.iconUrl,
            __typename: 'PriorityField'
        };
        return convertedField;
    }
    if (groupByFieldId?.startsWith('customfield_') && field) {
        if (field.__typename === 'JiraSingleSelectField' && field.type === (0, $lO4Or.CATEGORY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const categoryField = field;
            if (categoryField.fieldOption) {
                const convertedField = {
                    category: {
                        color: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        categoryField.fieldOption?.color?.colorKey ?? null,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                        option: {
                            id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                            isDisabled: false,
                            optionId: categoryField.fieldOption.optionId,
                            value: categoryField.fieldOption.value,
                            __typename: 'JiraOption'
                        },
                        __typename: 'JiraWorkManagementCategoryOption'
                    },
                    selectedValue: {
                        optionId: categoryField.fieldOption.optionId,
                        value: categoryField.fieldOption.value ?? '',
                        __typename: 'Option'
                    },
                    fieldKey: field.fieldId,
                    __typename: 'JWMCategoryCustomField'
                };
                return convertedField;
            }
        }
        if (field.__typename === 'JiraNumberField') {
            const convertedField = {
                fieldKey: field.fieldId,
                floatValue: field.number,
                __typename: 'FloatCustomField'
            };
            return convertedField;
        }
    }
    return field;
};
const $119f79f94d421d34$export$c8d5f559d504cbde = ({ item: item, groupByFieldId: groupByFieldId })=>{
    if (!item || !groupByFieldId) return undefined;
    let field = (0, $3uSNh.getFieldValue)(item.fields, groupByFieldId);
    if (!field) return;
    if (field && groupByFieldId) // TODO: Remove this part once JER-321 is done.
    field = $119f79f94d421d34$var$convertFieldToGroupItemField(groupByFieldId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    field);
    return {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        field: field,
        totalCount: 1,
        __typename: 'JWMItemGroup'
    };
};

});



parcelRegister("94mYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f283e4cd7d178c16$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f283e4cd7d178c16$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.with-grouping.error-title",
        "defaultMessage": "We couldn't load item groups."
    },
    errorMessage: {
        "id": "business-list.controllers.with-grouping.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});

parcelRegister("iaqLb", function(module, exports) {

$parcel$export(module.exports, "useGroupChildrenLoader", () => $99df389ad462343b$export$2f8ce4dc0f882a8a);

var $eUqFw = parcelRequire("eUqFw");

var $4oWxH = parcelRequire("4oWxH");

var $dSE3z = parcelRequire("dSE3z");

var $fLPR5 = parcelRequire("fLPR5");

var $5r9Wo = parcelRequire("5r9Wo");

var $iGWrT = parcelRequire("iGWrT");
const $99df389ad462343b$export$2f8ce4dc0f882a8a = ({ groups: groups })=>{
    const [{ expandedItems: expandedItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { setChildrenItems: setChildrenItems } = (0, $iGWrT.useSetChildrenItems)();
    const childrenLoader = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLPR5.GroupItemsController), {
            expandedGroupItemIssueIds: Object.keys(expandedItems).filter((0, $4oWxH.isGroupItem)),
            groupByFieldId: groupByFieldId,
            onDataChange: setChildrenItems,
            groups: groups
        }), [
        expandedItems,
        groupByFieldId,
        groups,
        setChildrenItems
    ]);
    return {
        childrenLoader: childrenLoader
    };
};

});
parcelRegister("fLPR5", function(module, exports) {

$parcel$export(module.exports, "GroupItemsController", () => $c6476a52a7960413$export$bf0c6c1ff455a90f);

var $eUqFw = parcelRequire("eUqFw");

var $26iUh = parcelRequire("26iUh");

var $bDdX6 = parcelRequire("bDdX6");
const $c6476a52a7960413$export$bf0c6c1ff455a90f = /*#__PURE__*/ (0, $eUqFw.memo)(({ expandedGroupItemIssueIds: expandedGroupItemIssueIds, groupByFieldId: groupByFieldId, groups: groups, onDataChange: onDataChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, expandedGroupItemIssueIds.map((expandedGroupItemIssueId)=>{
        const groupQuery = (0, $26iUh.getGroupQuery)({
            groups: groups,
            groupIssueId: expandedGroupItemIssueId,
            groupByFieldId: groupByFieldId
        });
        if (!groupQuery) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDdX6.GroupItemsQueryController), {
            groupIssueId: expandedGroupItemIssueId,
            onDataChange: onDataChange,
            key: expandedGroupItemIssueId,
            groupQuery: groupQuery
        });
    })), // Only re-render when expandedGroupItemIssueIds or onDataChange changes
(prevProps, nextProps)=>{
    const prevIssueIds = prevProps.expandedGroupItemIssueIds.sort();
    const nextIssueIds = nextProps.expandedGroupItemIssueIds.sort();
    return prevProps.onDataChange === nextProps.onDataChange && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]);
});

});
parcelRegister("bDdX6", function(module, exports) {

$parcel$export(module.exports, "GroupItemsQueryController", () => $c3396a80970f7e98$export$e689a28b990fb20b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $f8ADw = parcelRequire("f8ADw");

var $hHiDc = parcelRequire("hHiDc");

var $aqGaJ = parcelRequire("aqGaJ");

var $kntjE = parcelRequire("kntjE");
const $c3396a80970f7e98$export$e689a28b990fb20b = /*#__PURE__*/ (0, $eUqFw.memo)(({ groupIssueId: groupIssueId, groupQuery: groupQuery, onDataChange: onDataChange })=>{
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const isValidFiltersJql = !jqlErrors.length;
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    const { getQueryFieldIds: getQueryFieldIds, loading: isLoadingFields, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const { data: data, loading: isLoadingItems, error: error, loadNextPage: loadNextPage, hasNextPage: hasNextPage, isLoadingNextPage: isLoadingNextPage } = (0, $f8ADw.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            fieldIds: getQueryFieldIds(),
            quickFiltersJql: quickFiltersJql,
            sorting: sorting,
            groupQuery: groupQuery,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: isLoadingFields === false && isValidFiltersJql
    });
    const loading = !isValidFiltersJql ? false : isLoadingFields || isLoadingItems;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const totalIssues = data?.length;
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE), {
        loading: loading,
        error: error,
        shouldStartExperience: true
    });
    (0, $eUqFw.useEffect)(()=>{
        if (loading || typeof totalIssues !== 'number') return;
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'listGroupItemsQuery succeeded', {
            totalIssues: totalIssues
        });
    }, [
        loading,
        createAnalyticsEvent,
        totalIssues
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'listGroupItemsQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to query group items in list view'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (jqlErrors.length) (0, $guiFP.default)({
            meta: {
                id: 'listGroupItemsQuery',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Error in the JQL query'
            },
            error: jqlErrors[0],
            skipSentry: true
        });
    }, [
        jqlErrors
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onDataChange(groupIssueId, {
            data: data,
            loading: loading,
            error: error,
            loadNextPage: loadNextPage,
            isLoadingNextPage: isLoadingNextPage,
            hasNextPage: hasNextPage
        });
    }, [
        data,
        error,
        loading,
        loadNextPage,
        isLoadingNextPage,
        onDataChange,
        groupIssueId,
        hasNextPage
    ]);
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $kntjE.default).errorTitle,
        description: (0, $kntjE.default).errorMessage
    }) : null;
});

});
parcelRegister("aqGaJ", function(module, exports) {

$parcel$export(module.exports, "useHierarchyConfig", () => $d73448afed1a6ac7$export$4691cc2dea373ff0);


var $lGxgz = parcelRequire("lGxgz");

var $eI5EY = parcelRequire("eI5EY");

var $dSE3z = parcelRequire("dSE3z");
const $d73448afed1a6ac7$export$4691cc2dea373ff0 = ()=>{
    const { isFiltering: isFiltering } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const hierarchyParent = !isFiltering ? (0, $2a7b21c0842403e6$export$9355e489ad16f98e) : undefined;
    if ((0, $eI5EY.fg)('jwm_flat_list_when_grouping')) {
        const showFlatList = isFiltering || groupByFieldId != null;
        return {
            showFlatList: showFlatList,
            hierarchyParent: showFlatList ? undefined : hierarchyParent
        };
    }
    return {
        showFlatList: isFiltering,
        hierarchyParent: hierarchyParent
    };
};

});

parcelRegister("kntjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9581159a48b09b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5c9581159a48b09b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.group-items-query.error-title",
        "defaultMessage": "We couldn't load group items."
    },
    errorMessage: {
        "id": "business-list.controllers.group-items-query.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});




parcelRegister("2zwYz", function(module, exports) {

$parcel$export(module.exports, "useResetItems", () => $2e5307c4489ed688$export$266465ecb6779ef7);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");
var $lEWmB = parcelRequire("lEWmB");
var $9GlEj = parcelRequire("9GlEj");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");
const $2e5307c4489ed688$export$266465ecb6779ef7 = ()=>{
    const { sorting: sorting } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { jql: jql } = (0, $lEWmB.useFilters)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const [{ hierarchyData: { loading: loading } }, { resetCache: resetCache, clearHierarchyData: clearHierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    const projectData = (0, $kQAZu.useProject)();
    const projectKey = projectData.key;
    const lastSorting = (0, $eUqFw.useRef)({
        ...sorting
    });
    const lastJqlFiltering = (0, $eUqFw.useRef)(jql);
    const lastQuickFilterJql = (0, $eUqFw.useRef)(quickFiltersJql);
    const lastGroupByFieldId = (0, $eUqFw.useRef)(groupByFieldId);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) return;
        const hasSortingChanged = lastSorting.current.sortBy !== sorting.sortBy || lastSorting.current.direction !== sorting.direction;
        const hasFilteringChanged = lastJqlFiltering.current !== jql || lastQuickFilterJql.current !== quickFiltersJql;
        const hasGroupByFieldIdChanged = lastGroupByFieldId.current !== groupByFieldId;
        if (hasGroupByFieldIdChanged || hasSortingChanged || hasFilteringChanged) {
            resetCache();
            // update last reference
            lastSorting.current = sorting;
            lastJqlFiltering.current = jql;
            lastQuickFilterJql.current = quickFiltersJql;
            lastGroupByFieldId.current = groupByFieldId;
        }
    }, [
        groupByFieldId,
        loading,
        sorting,
        resetCache,
        jql,
        quickFiltersJql
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Reset hierarchy data when navigate across projects
        clearHierarchyData();
    }, [
        projectKey,
        clearHierarchyData
    ]);
};

});

parcelRegister("fTRcw", function(module, exports) {

$parcel$export(module.exports, "useSetHierarchyData", () => $3c05167fde49e43c$export$b96814cd86fd4960);

var $eUqFw = parcelRequire("eUqFw");

var $hHiDc = parcelRequire("hHiDc");

var $8gkkx = parcelRequire("8gkkx");

var $aqGaJ = parcelRequire("aqGaJ");

var $5r9Wo = parcelRequire("5r9Wo");
const $3c05167fde49e43c$export$b96814cd86fd4960 = ()=>{
    const [, { setHierarchyData: setHierarchyData, refreshHierarchy: refreshHierarchy }] = (0, $5r9Wo.useHierarchyStore)();
    const [rowCreateState, { setRowCreatePosition: setRowCreatePosition }] = (0, $8gkkx.useRowCreateStore)();
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, $hHiDc.useIssueFields)();
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    (0, $eUqFw.useEffect)(()=>{
        refreshHierarchy(rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache);
    }, [
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache,
        refreshHierarchy
    ]);
    const setHierarchyDataWithDependencies = (0, $eUqFw.useCallback)((queryData)=>setHierarchyData(queryData, rowCreateState, setRowCreatePosition, hierarchyLevelsWithCache, showFlatList), [
        setHierarchyData,
        rowCreateState,
        setRowCreatePosition,
        hierarchyLevelsWithCache,
        showFlatList
    ]);
    return {
        setHierarchyData: setHierarchyDataWithDependencies
    };
};

});


parcelRegister("kBwul", function(module, exports) {

$parcel$export(module.exports, "default", () => $96ede29ffd923480$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $4G5xU = parcelRequire("4G5xU");

var $lGxgz = parcelRequire("lGxgz");

var $guiFP = parcelRequire("guiFP");

var $bKxX9 = parcelRequire("bKxX9");

var $dWGNJ = parcelRequire("dWGNJ");

var $hzcvF = parcelRequire("hzcvF");

var $gbsaq = parcelRequire("gbsaq");

var $f8ADw = parcelRequire("f8ADw");

var $gfhub = parcelRequire("gfhub");

var $hHiDc = parcelRequire("hHiDc");

var $aqGaJ = parcelRequire("aqGaJ");

var $5r9Wo = parcelRequire("5r9Wo");

var $2zwYz = parcelRequire("2zwYz");

var $fTRcw = parcelRequire("fTRcw");

var $afRND = parcelRequire("afRND");
const $96ede29ffd923480$export$9e1fb4c88b271603 = ()=>{
    const [{ hierarchyLevel: hierarchyLevel }, { resetHierarchyLevel: resetHierarchyLevel, setHierarchyLevel: setHierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems, jqlErrors: jqlErrors } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { showFlatList: showFlatList, hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const prevShowFlatList = (0, $hzcvF.usePreviousWithInitial)(showFlatList);
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    const isValidFiltersJql = !jqlErrors.length;
    let projectKey;
    if ((0, $bKxX9.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    // fetch issues based on `hierarchyLevel` - regardless of issue types
    const items = (0, $f8ADw.useListViewIssues)({
        input: {
            jqlContext: jqlContext,
            quickFiltersJql: quickFiltersJql,
            fieldIds: queryFieldIds,
            sorting: sorting,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey,
            isParentFieldVisible: isParentFieldVisible(),
            isDevSummaryFieldVisible: isDevSummaryFieldVisible()
        },
        condition: typeof hierarchyLevel === 'number' && queryFieldIds.length > 0 && isValidFiltersJql
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hierarchyLevel == null && hierarchyLevelsWithCache.length) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
    }, [
        hierarchyLevel,
        hierarchyLevelsWithCache,
        setHierarchyLevel
    ]);
    // reset hierarchyLevel to the top level when filtering change
    (0, $eUqFw.useEffect)(()=>{
        if (hierarchyLevelsWithCache.length && prevShowFlatList && !showFlatList) setHierarchyLevel(hierarchyLevelsWithCache[0].level);
    }, [
        showFlatList,
        prevShowFlatList,
        setHierarchyLevel,
        hierarchyLevelsWithCache
    ]);
    // reset hierarchyLevel on unmount
    (0, $eUqFw.useEffect)(()=>()=>resetHierarchyLevel(), []); // eslint-disable-line react-hooks/exhaustive-deps
    const levels = (0, $eUqFw.useMemo)(()=>[
            ...new Set(hierarchyLevelsWithCache.map((x)=>x.level))
        ], [
        hierarchyLevelsWithCache
    ]);
    // When BE service returns empty response from top level items query
    // We take next hierarchy level and re-fetch items... until BE returs some data, or we reach the bottom hierarchy level
    (0, $eUqFw.useEffect)(()=>{
        if (!items.loading && !items.data.length && hierarchyLevel != null) {
            const nextIndex = levels.indexOf(hierarchyLevel) + 1;
            if (typeof levels[nextIndex] === 'number') setHierarchyLevel(levels[nextIndex]);
        }
    }, [
        hierarchyLevel,
        levels,
        items.data.length,
        items.loading,
        setHierarchyLevel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (jqlErrors.length) (0, $guiFP.default)({
            meta: {
                id: 'listHierarchyLoader',
                packageName: 'jiraBusinessList',
                teamName: 'keystone'
            },
            attributes: {
                message: 'Error in the JQL query'
            },
            error: jqlErrors[0],
            skipSentry: true
        });
    }, [
        jqlErrors
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ...items,
            loading: isValidFiltersJql ? items.loading : false
        }), [
        items,
        isValidFiltersJql
    ]);
};
const $96ede29ffd923480$var$HierarchyLoader = ()=>{
    const items = $96ede29ffd923480$export$9e1fb4c88b271603();
    const prevItems = (0, $hzcvF.usePreviousWithInitial)(items);
    const [, { resetCache: resetCache }] = (0, $5r9Wo.useHierarchyStore)();
    const { setHierarchyData: setHierarchyData } = (0, $fTRcw.useSetHierarchyData)();
    (0, $4G5xU.useQueryBasedViewAutomaticTracking)((0, $gbsaq.VIEW_EXPERIENCE), {
        loading: items.loading,
        error: items.error
    });
    // resets expanded items and queryData cache when filtering/sorting/groupBy is updated
    (0, $2zwYz.useResetItems)();
    // initialize items when switching between grouping -> hierarchy
    (0, $eUqFw.useEffect)(()=>{
        setHierarchyData(items);
        resetCache();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // updates hierarchy items in store only when "data", "isLoadingNextPage" or "totalCount" changes
    (0, $eUqFw.useEffect)(()=>{
        if (prevItems.data !== items.data || prevItems.isLoadingNextPage !== items.isLoadingNextPage) setHierarchyData(items);
    }, [
        items,
        prevItems,
        setHierarchyData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, items.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: items.error,
        title: (0, $afRND.default).errorTitle,
        description: (0, $afRND.default).errorMessage
    }));
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$96ede29ffd923480$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($96ede29ffd923480$var$HierarchyLoader);

});
parcelRegister("gfhub", function(module, exports) {

$parcel$export(module.exports, "useHierarchyLevel", () => $7e94e6d9ca58ea66$export$62fdc6b7b35d2861);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $7e94e6d9ca58ea66$var$initialState = {
    hierarchyLevel: undefined
};
const $7e94e6d9ca58ea66$var$resetHierarchyLevel = ()=>({ setState: setState })=>setState({
            ...$7e94e6d9ca58ea66$var$initialState
        });
const $7e94e6d9ca58ea66$var$setHierarchyLevel = (hierarchyLevel)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            hierarchyLevel: hierarchyLevel
        });
    };
const $7e94e6d9ca58ea66$var$actions = {
    resetHierarchyLevel: $7e94e6d9ca58ea66$var$resetHierarchyLevel,
    setHierarchyLevel: $7e94e6d9ca58ea66$var$setHierarchyLevel
};
const $7e94e6d9ca58ea66$var$Store = (0, $a61MH.createStore)({
    initialState: $7e94e6d9ca58ea66$var$initialState,
    actions: $7e94e6d9ca58ea66$var$actions,
    name: 'JWMHierarchyLevelStore'
});
const $7e94e6d9ca58ea66$export$62fdc6b7b35d2861 = (0, $ggKAj.createHook)($7e94e6d9ca58ea66$var$Store);

});

parcelRegister("afRND", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2eddeffee33e10$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $eb2eddeffee33e10$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.hierarchy.hierarchy-loader.error-title",
        "defaultMessage": "We couldn't load items."
    },
    errorMessage: {
        "id": "business-list.controllers.hierarchy.hierarchy-loader.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});



parcelRegister("lCzHy", function(module, exports) {

$parcel$export(module.exports, "useIssueChangeUpdater", () => $479bbe2446616aac$export$55b903604085ad27);

var $eUqFw = parcelRequire("eUqFw");

var $fE3Ua = parcelRequire("fE3Ua");

var $99RVt = parcelRequire("99RVt");
const $479bbe2446616aac$export$55b903604085ad27 = ()=>{
    const { onIssueRemoved: onIssueRemoved } = (0, $99RVt.useListViewUpdaterService)();
    const onIssueChange = (0, $eUqFw.useCallback)((event)=>{
        if (event.type === (0, $fE3Ua.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) {
            const { issueId: issueId, meta: { oldParentIssueId: oldParentIssueId } } = event;
            onIssueRemoved({
                issueId: Number(issueId),
                parentId: oldParentIssueId || undefined
            });
        }
    }, [
        onIssueRemoved
    ]);
    return {
        onIssueChange: onIssueChange
    };
};

});
parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("99RVt", function(module, exports) {

$parcel$export(module.exports, "useListViewUpdaterService", () => $31de61f84209b9b7$export$8fe666044644d3c0);

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $9j3OJ = parcelRequire("9j3OJ");
var $aVwtE = parcelRequire("aVwtE");
var $4oWxH = parcelRequire("4oWxH");
var $hTnQu = parcelRequire("hTnQu");
var $2rYp2 = parcelRequire("2rYp2");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $26iUh = parcelRequire("26iUh");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");

var $gfhub = parcelRequire("gfhub");

var $hotly = parcelRequire("hotly");

var $dSE3z = parcelRequire("dSE3z");

var $fGcrx = parcelRequire("fGcrx");

var $5r9Wo = parcelRequire("5r9Wo");

var $aqGaJ = parcelRequire("aqGaJ");

var $9DopW = parcelRequire("9DopW");
const $31de61f84209b9b7$export$8fe666044644d3c0 = ()=>{
    const [{ selectedIssues: selectedIssues, showDeleteModal: showDeleteModal }, { toggleShowDeleteModal: toggleShowDeleteModal, unselectIssues: unselectIssues }] = (0, $hotly.useBulkSelectionStore)();
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const fieldIds = (0, $9DopW.useSupportedFieldIds)();
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenQueryData, hierarchyData: hierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    const groups = hierarchyData.data;
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGroupingByStatus = groupByFieldId === (0, $lO4Or.STATUS_TYPE);
    const cloudId = (0, $dWLk9.useCloudId)();
    const topLevelVariables = {
        ...(0, $i3K0B.getVariables)({
            jqlContext: jqlContext,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            sorting: sorting,
            hierarchyLevel: hierarchyLevel,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            projectIdOrKey: projectKey
        }),
        cloudId: cloudId
    };
    const { addToCacheCallback: addToCacheCallback, removeFromCacheCallback: removeFromCacheCallback } = (0, $9j3OJ.createViewUpdaterCallbacksWithCacheActions)({
        query: (0, $7XECd.LIST_VIEW_QUERY),
        addToCache: addToCache,
        updateItemsInCache: updateItemsInCache,
        removeFromCache: removeFromCache,
        isHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        isInfiniteHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
        createVariablesForItemWithoutParent: ()=>topLevelVariables,
        createVariablesForGroupItem: (groupIssueId)=>({
                cloudId: cloudId,
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    groupQuery: (0, $26iUh.getGroupQuery)({
                        groups: groups,
                        groupIssueId: groupIssueId,
                        groupByFieldId: groupByFieldId
                    }),
                    hierarchyParent: hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems
                })
            }),
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) // this scenario should be impossible because there is isHierarchyEnabled parameter above
            return topLevelVariables;
            return {
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    projectIdOrKey: projectKey,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // We only want to add or remove item if the existing query for children-of-this-parent exists
        // this is to prevent apollo error where the cache key is missing
        shouldChildItemBeAddedToOrRemovedFromCache: (parentIssueId)=>Boolean(childrenQueryData && childrenQueryData[(0, $6vrw7.toIssueId)(parentIssueId)] !== undefined),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(issueId);
            if (!maybeIssue) return undefined;
            return maybeIssue.parentIssueId ?? (0, $4oWxH.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        onUpdateParentWithNewChild: (0, $fjqly.addChildToParentListView),
        // note that prevParent will be undefined if the prevParent is not expanded or does not exist
        updateIssueParentMap: (issueId, newParentId)=>{
            if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
            else issueParentMap.delete(String(issueId));
        },
        removeChildFromParent: (0, $fjqly.removeChildFromParentListView),
        isGroupingByStatus: isGroupingByStatus,
        isGrouping: !!groupByFieldId
    });
    const isGrouping = groupByFieldId != null;
    const { addToGroupCache: addToGroupCache, removeFromGroupCache: removeFromGroupCache } = (0, $fGcrx.useGroupCacheActions)({
        fieldIds: fieldIds
    });
    // When we detect an item has been updated that is currently filtered out of view, we still want to update group totals
    // so we do another request with no filters and update group cache's total count only
    const [getUpdatedIssue] = (0, $iZuDo.useLazyQuery)((0, $7XECd.LIST_VIEW_ITEM_DETAILS_QUERY), {
        fetchPolicy: 'network-only',
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewUpdaterQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch updated issue by id in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onCompleted: (result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) addToGroupCache(validNodes, {
                updateCountOnly: true
            });
        }
    });
    const handleFilteredUpdate = (issueIds)=>{
        getUpdatedIssue({
            variables: {
                ...(0, $i3K0B.getVariables)({
                    issueIds: issueIds,
                    fieldIds: fieldIds
                }),
                cloudId: cloudId
            }
        });
    };
    const getGroupChildItems = (items)=>{
        const groupChildItems = [];
        const nestedItems = [];
        items.forEach((item)=>{
            const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
            // we only want to move items between groups via realtime update if the item is a direct child of a group item
            // that is when it doesn't have a parent field, or its parent is a group item,
            if (parentIssueId != null && !(0, $4oWxH.isGroupItem)(parentIssueId) && childrenQueryData && childrenQueryData[parentIssueId]) nestedItems.push(item);
            else groupChildItems.push(item);
        });
        return {
            groupChildItems: groupChildItems,
            nestedItems: nestedItems
        };
    };
    return (0, $2rYp2.useViewUpdater)({
        input: {
            projectKey: projectKey,
            fieldIds: fieldIds,
            quickFiltersJql: quickFiltersJql,
            isHidingDoneItems: isHidingDoneItems
        },
        query: (0, $7XECd.LIST_VIEW_ITEM_DETAILS_QUERY),
        actions: [
            {
                addToCache: (items)=>{
                    if (isGrouping) {
                        const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                        if (groupChildItems.length) return addToGroupCache(groupChildItems);
                        if (nestedItems.length) return addToCacheCallback(items);
                    }
                    return addToCacheCallback(items);
                },
                removeFromCache: (items)=>{
                    if (selectedIssues?.size) {
                        let issuesToUnselect = [];
                        items.forEach(({ issueId: issueId })=>{
                            if (selectedIssues.has(String(issueId))) issuesToUnselect = [
                                ...issuesToUnselect,
                                String(issueId)
                            ];
                        });
                        if (issuesToUnselect.length) {
                            unselectIssues({
                                issues: issuesToUnselect
                            });
                            if (issuesToUnselect.length === selectedIssues.size && showDeleteModal) toggleShowDeleteModal({
                                showDeleteModal: false
                            });
                        }
                    }
                    if (isGrouping) {
                        const { groupChildItems: groupChildItems, nestedItems: nestedItems } = getGroupChildItems(items);
                        if (groupChildItems.length) return removeFromGroupCache(groupChildItems);
                        if (nestedItems.length) return removeFromCacheCallback(items);
                    }
                    return removeFromCacheCallback(items);
                },
                handleFilteredUpdate: (issueIds)=>isGrouping ? handleFilteredUpdate(issueIds) : undefined
            }
        ],
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewUpdaterQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch issues in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        onAppendItemsError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'listViewAppendItemsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to append issues by id in list view updater'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
};

});
parcelRegister("9j3OJ", function(module, exports) {

$parcel$export(module.exports, "createViewUpdaterCallbacksWithCacheActions", () => $8ac2f00f49bb3cf6$export$cc1c02509eec9edb);
$parcel$export(module.exports, "createGroupingViewUpdaterCacheActions", () => $8ac2f00f49bb3cf6$export$c410d2a23de7830a);

var $1ybV0 = parcelRequire("1ybV0");

var $4oWxH = parcelRequire("4oWxH");
const $8ac2f00f49bb3cf6$export$cc1c02509eec9edb = ({ isHierarchyEnabled: isHierarchyEnabled, isInfiniteHierarchyEnabled: isInfiniteHierarchyEnabled, query: query, addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache, createVariablesForItemWithParent: createVariablesForItemWithParent, createVariablesForItemWithoutParent: createVariablesForItemWithoutParent, shouldChildItemBeAddedToOrRemovedFromCache: shouldChildItemBeAddedToOrRemovedFromCache, onUpdateParentWithNewChild: onUpdateParentWithNewChild, getParentOfIssueIfExist: getParentOfIssueIfExist, isItemHierarchySupported: isItemHierarchySupported, removeChildFromParent: removeChildFromParent, updateIssueParentMap: updateIssueParentMap, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, createVariablesForGroupItem: createVariablesForGroupItem, isGroupingByStatus: isGroupingByStatus = false, isGrouping: isGrouping = false })=>{
    const getParentVariables = (parentId)=>{
        const variables = createVariablesForItemWithoutParent();
        if (!parentId) return variables;
        if (createVariablesForGroupItem && (0, $4oWxH.isGroupItem)(parentId)) return createVariablesForGroupItem(parentId);
        return createVariablesForItemWithParent(parentId);
    };
    const updateIssueParent = ({ prevParentIssueId: prevParentIssueId, parentIssueId: parentIssueId, item: item })=>{
        updateIssueParentMap && updateIssueParentMap(item.issueId, parentIssueId);
        if (!prevParentIssueId && !isGrouping || isGrouping && prevParentIssueId || prevParentIssueId && shouldChildItemBeAddedToOrRemovedFromCache(prevParentIssueId)) removeFromCache({
            query: query,
            variables: getParentVariables(prevParentIssueId),
            issueId: Number(item.issueId)
        });
        if (isGroupingByStatus) return;
        const hasParentToRemove = getParentOfIssueIfExist && !!getParentOfIssueIfExist(item.issueId);
        if (removeChildFromParent && prevParentIssueId && hasParentToRemove) {
            const grandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(String(prevParentIssueId)) : undefined;
            if ((0, $4oWxH.isGroupItem)(grandParentId) || (0, $4oWxH.isGroupItem)(prevParentIssueId)) return;
            updateItemsInCache({
                query: query,
                variables: getParentVariables(grandParentId),
                issueIds: [
                    String(prevParentIssueId)
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
        }
        if (!parentIssueId) return;
        // updateChildCount of new parent
        // so user will have an indicator that shows the parent has subtask now
        const newGrandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(parentIssueId.toString()) : undefined;
        if ((0, $4oWxH.isGroupItem)(newGrandParentId) || (0, $4oWxH.isGroupItem)(parentIssueId)) return;
        updateItemsInCache({
            query: query,
            variables: getParentVariables(newGrandParentId),
            issueIds: [
                parentIssueId
            ],
            updateItem: (existingIssue)=>{
                const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                return updatedIssueWithNewChild;
            }
        });
    };
    const addToCacheCallback = (items)=>{
        if (isHierarchyEnabled()) {
            const itemsWithoutParent = items.filter((i)=>(0, $4oWxH.getParentIssueId)(i) === undefined);
            const itemsWithParent = items.filter((i)=>(0, $4oWxH.getParentIssueId)(i) !== undefined);
            // add items WITHOUT parent first
            if (itemsWithoutParent.length > 0) {
                addToCache({
                    newNodes: itemsWithoutParent,
                    query: query,
                    variables: createVariablesForItemWithoutParent()
                });
                (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && items.forEach((item)=>{
                    // when parent is unlinked from issue
                    const parentIssueId = undefined;
                    const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                    if (isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId) updateIssueParent({
                        prevParentIssueId: prevParentIssueId,
                        parentIssueId: parentIssueId,
                        item: item
                    });
                });
            }
            // then add items WITH parent
            itemsWithParent.forEach((item)=>{
                const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                if (parentIssueId === undefined) // this scenario should be impossible because we already filtered the item
                // but doing this just to remove the Flow error
                return;
                // CLEAN UP THE FOLLOWING CONDITION WITH 'jwm.visual-hierarchy-milestone-1' as it's only used by timeline view
                if (isItemHierarchySupported && !isItemHierarchySupported(item)) {
                    // this is a specific scenario for the TIMELINE
                    // in that view we don't support epic hierarchy (we don't show the epic children, those are displayed on the same level)
                    // in that case we should not use the parent variables because that query doesn't exist
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForItemWithoutParent()
                    });
                    return;
                }
                const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                const shouldUpdateIssueParent = (0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1') && isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId;
                const shouldChildItemBeAddedOrRemovedFromCache = shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId);
                if (shouldUpdateIssueParent) updateIssueParent({
                    prevParentIssueId: prevParentIssueId,
                    parentIssueId: parentIssueId,
                    item: item
                });
                // We only want to add item if the existing query for children-of-this-parent exists
                // this is to prevent apollo error where the cache key is missing
                if (shouldChildItemBeAddedOrRemovedFromCache) addToCache({
                    newNodes: [
                        item
                    ],
                    query: query,
                    variables: createVariablesForItemWithParent(parentIssueId)
                });
                else if (!shouldChildItemBeAddedOrRemovedFromCache && !shouldUpdateIssueParent) {
                    let variables = createVariablesForItemWithoutParent();
                    if (isInfiniteHierarchyEnabled() && // Grandparent only exists in infinite hierarchy
                    getParentOfIssueIfExist) {
                        const grandParentId = getParentOfIssueIfExist(parentIssueId.toString());
                        if (grandParentId != null) variables = createVariablesForItemWithParent(grandParentId);
                    }
                    // if the parent is not listed to have child yet
                    // we will update the parent to show children
                    // so user will have an indicator that shows the parent has subtask now
                    updateItemsInCache({
                        query: query,
                        variables: variables,
                        issueIds: [
                            parentIssueId
                        ],
                        updateItem: (existingIssue)=>{
                            const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                            return updatedIssueWithNewChild;
                        }
                    });
                }
            });
            return;
        }
        addToCache({
            newNodes: items,
            query: query,
            variables: createVariablesForItemWithoutParent()
        });
    };
    const removeFromCacheCallback = (items)=>{
        items.forEach((item)=>{
            if (isHierarchyEnabled()) {
                const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                if (parentIssueId !== undefined) {
                    if (shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId)) removeFromCache({
                        issueId: item.issueId,
                        query: query,
                        variables: createVariablesForItemWithParent(parentIssueId)
                    });
                    // TODO remove the subtask from parent 'Subtask' field https://jbusiness.atlassian.net/browse/JET-1883
                    return;
                }
            }
            removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForItemWithoutParent()
            });
        });
    };
    return {
        addToCacheCallback: addToCacheCallback,
        removeFromCacheCallback: removeFromCacheCallback
    };
};
const $8ac2f00f49bb3cf6$export$c410d2a23de7830a = ({ query: query, groupsQuery: groupsQuery, addToCache: addToCache, removeFromCache: removeFromCache, addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache, updateItemsInCache: updateItemsInCache, createVariablesForGroups: createVariablesForGroups, createVariablesForGroupItem: createVariablesForGroupItem, createItemGroup: createItemGroup, findItemGroup: findItemGroup, findGroupById: findGroupById, canUpdateGroupCache: canUpdateGroupCache, getParentOfIssueIfExist: getParentOfIssueIfExist, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, onUpdateParentWithNewChild: onUpdateParentWithNewChild, removeChildFromParent: removeChildFromParent, createVariablesForItemWithParent: createVariablesForItemWithParent, updateIssueParentMap: updateIssueParentMap })=>{
    const getReparentingInfo = (item)=>{
        const currentParent = (0, $4oWxH.getParentIssueId)(item);
        const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
        // note that currentParent can be undefined or a groupitem if parent is unlinked
        const isUnlinkParent = (!currentParent || (0, $4oWxH.isGroupItem)(currentParent)) && prevParent && currentParent !== prevParent;
        const isReparenting = currentParent && currentParent !== prevParent;
        return {
            isReparenting: isReparenting,
            isUnlinkParent: isUnlinkParent,
            currentParent: currentParent,
            prevParent: prevParent
        };
    };
    const removeItemFromCache = (item, currentGroupIssueId)=>{
        const { isReparenting: isReparenting, prevParent: prevParent, isUnlinkParent: isUnlinkParent } = getReparentingInfo(item);
        // check if items data exists in apollo cache, so that updating it won't blow up apollo
        if (canUpdateGroupCache(currentGroupIssueId) && (!isReparenting && !isUnlinkParent || prevParent && (0, $4oWxH.isGroupItem)(prevParent))) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForGroupItem(currentGroupIssueId)
        });
        else if (prevParent && (isReparenting || isUnlinkParent) && !(0, $4oWxH.isGroupItem)(prevParent)) removeFromCache({
            issueId: item.issueId,
            query: query,
            variables: createVariablesForItemWithParent(prevParent)
        });
        const groupItem = findGroupById(currentGroupIssueId);
        const prevGrandParent = prevParent ? getParentOfIssueIfExist(prevParent) : undefined;
        if (groupItem) {
            if (prevParent && (isReparenting || isUnlinkParent) && prevGrandParent && removeChildFromParent) // update count of prevParent
            updateItemsInCache({
                query: query,
                variables: (0, $4oWxH.isGroupItem)(prevGrandParent) ? createVariablesForGroupItem(prevGrandParent) : createVariablesForItemWithParent(prevGrandParent),
                issueIds: [
                    prevParent
                ],
                updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
            });
            else if (!(0, $1ybV0.ff)('jwm-list-view-update-group-count_36voh') || isChildIssueInGroup(groupItem, item.issueId)) // update totalGroupItems in itemGroups cache.
            updateGroupItemInCache({
                query: groupsQuery,
                variables: createVariablesForGroups(),
                id: groupItem.id,
                updateItem: (group)=>({
                        ...group,
                        totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount - 1) : undefined
                    })
            });
        }
    };
    const getGroupIssueId = (issueId)=>{
        if ((0, $4oWxH.isGroupItem)(issueId)) return issueId;
        const parentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(issueId) : undefined;
        if (!parentId) return null;
        if ((0, $4oWxH.isGroupItem)(parentId)) return parentId;
        return getGroupIssueId(parentId);
    };
    const isChildIssueInGroup = (group, childIssueId)=>group.children?.some((issue)=>issue.issueId === childIssueId);
    const addToGroupCache = (items, { updateCountOnly: updateCountOnly = false } = {
        updateCountOnly: false
    })=>{
        items.forEach((item)=>{
            const { isReparenting: isReparenting, currentParent: currentParent, prevParent: prevParent } = getReparentingInfo(item);
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            const nextGroup = findItemGroup(item);
            if (currentGroupIssueId != null && !updateCountOnly) removeItemFromCache(item, currentGroupIssueId);
            if (nextGroup != null) {
                // check if items data exists in apollo cache, so that updating it won't blow up apollo
                if (canUpdateGroupCache(nextGroup.issueId) && !updateCountOnly && !isReparenting) {
                    // add the item to the next group
                    addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForGroupItem(nextGroup.issueId)
                    });
                    // this should not be necessary once background refetch when grouping is working correctly
                    updateIssueParentMap(item.issueId);
                }
                const newGrandParentId = currentParent ? getParentOfIssueIfExist(currentParent) : undefined;
                if (currentParent && isReparenting && newGrandParentId) updateItemsInCache({
                    query: query,
                    variables: (0, $4oWxH.isGroupItem)(newGrandParentId) ? createVariablesForGroupItem(newGrandParentId) : createVariablesForItemWithParent(newGrandParentId),
                    issueIds: [
                        currentParent
                    ],
                    updateItem: (existingIssue)=>{
                        const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                        return updatedIssueWithNewChild;
                    }
                });
                else // update totalGroupItems in itemGroups cache.
                updateGroupItemInCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    id: nextGroup.id,
                    updateItem: (group)=>({
                            ...group,
                            totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount + 1) : undefined
                        })
                });
            } else {
                const newGroup = createItemGroup(item);
                if (newGroup != null) addGroupItemToCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    newNodes: [
                        newGroup
                    ]
                });
            }
        });
    };
    const removeFromGroupCache = (items)=>{
        items.forEach((item)=>{
            const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
            const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
            // happens when updating parent but new parent is not expanded
            if (currentGroupIssueId != null) removeItemFromCache(item, currentGroupIssueId);
        });
    };
    return {
        addToCache: addToGroupCache,
        removeFromCache: removeFromGroupCache
    };
};

});

parcelRegister("hTnQu", function(module, exports) {

$parcel$export(module.exports, "useCacheActions", () => $018dc286559ccf2c$export$f79bd85e41a6298f);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $iZuDo = parcelRequire("iZuDo");

var $jGcn0 = parcelRequire("jGcn0");

var $3uSNh = parcelRequire("3uSNh");

var $guiFP = parcelRequire("guiFP");

var $kmr29 = parcelRequire("kmr29");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $6vrw7 = parcelRequire("6vrw7");

var $7Sz8O = parcelRequire("7Sz8O");

var $4oWxH = parcelRequire("4oWxH");

var $aVwtE = parcelRequire("aVwtE");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $018dc286559ccf2c$var$getIssueKey = (fields)=>(0, $3uSNh.safeGetValue)(fields, 'issuekey', 'text', '');
const $018dc286559ccf2c$var$getIndexById = (listData, issueId)=>{
    if (listData == null || listData.edges == null) return -1;
    const { edges: edges } = listData;
    return edges.findIndex((edge)=>edge != null && edge.node != null && edge.node.issueId != null && edge.node.issueId === issueId);
};
const $018dc286559ccf2c$export$f79bd85e41a6298f = ()=>{
    const analyticsTaskName = 'useCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const [, extractedFieldValueActions] = (0, $kmr29.useFieldsValuesActions)();
    const [currentIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_ISSUE_PARAM));
    const removeIssueFromExtractedFieldsCache = (0, $eUqFw.useCallback)(({ currentIssueId: currentIssueId, issueKey: issueKey, parentIssueId: parentIssueId })=>{
        issueKey != null && // do not clean the cache if the issue is currently visible in bento (that would show blank fields)
        issueKey !== currentIssueKey && `${parentIssueId}` !== `${currentIssueId}` && extractedFieldValueActions.setIssue((0, $6vrw7.toIssueKey)(issueKey), {});
    }, [
        currentIssueKey,
        extractedFieldValueActions
    ]);
    const addToCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        if (listData == null || listData.edges == null || !Array.isArray(newNodes) || newNodes.length === 0) return;
        try {
            const newIssueIds = new Set(newNodes.map((item)=>{
                if (item != null && item.issueId != null) return item.issueId;
                return undefined;
            }).filter(Boolean));
            newNodes.forEach((item)=>{
                if (item == null || item.fields == null) return;
                const issueKey = $018dc286559ccf2c$var$getIssueKey(item.fields);
                if (issueKey != null && issueKey !== '') {
                    const parentIssueId = (0, $4oWxH.getParentIssueId)(item);
                    const currentIssueId = item.issueId;
                    removeIssueFromExtractedFieldsCache({
                        currentIssueId: currentIssueId,
                        issueKey: issueKey,
                        parentIssueId: parentIssueId
                    });
                }
            });
            const isOptimisticIssueWithRealIssueInNewNodes = (issue)=>{
                // check whether an issue is an optimisticIssue that has the real data coming in
                // summary should give us a second check to replace the right optimistic issue with the new one
                // we are using summary instead of issueKey or issueId
                // since it's the only field that will contain the same value to identify
                // the correlation between real issue and optimistic issue
                const issueSummary = issue.fields?.find((field)=>field.fieldId === 'summary');
                const newNodeWithSameSummary = newNodes.find((newNode)=>newNode.fields?.find((field)=>field.fieldId === 'summary' && issueSummary != null && field.text === issueSummary.text));
                return issue.id.toString().startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX)) && newNodeWithSameSummary != null;
            };
            const newIssues = listData.edges.filter((edge)=>edge != null && edge.node != null && edge.node.issueId != null && !newIssueIds.has(edge.node.issueId) && !isOptimisticIssueWithRealIssueInNewNodes(edge.node)).concat(newNodes.map((node)=>({
                    node: node,
                    __typename: 'JiraWorkManagementViewItemEdge'
                }))) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newIssues,
                            totalCount: newIssues.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloAddToCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const removeFromCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const issueIds = Array.isArray(issueId) ? issueId : [
            issueId
        ];
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'removeFromCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        if (!listData?.edges || !Array.isArray(listData.edges)) return;
        try {
            const updatedEdges = listData.edges?.filter((edge)=>edge?.node && !issueIds.includes(edge.node.issueId));
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: updatedEdges,
                            totalCount: updatedEdges.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            issueIds.forEach((issue)=>{
                const index = $018dc286559ccf2c$var$getIndexById(listData ?? undefined, issue);
                const item = updatedEdges[index];
                const issueKey = $018dc286559ccf2c$var$getIssueKey(item?.node?.fields ?? []);
                const currentIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(item, 'issueId', 0);
                if (issueKey !== '') removeIssueFromExtractedFieldsCache({
                    currentIssueId: currentIssueId,
                    issueKey: issueKey
                });
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloRemoveFromCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache Write error'),
                meta: {
                    id: 'removeFromCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent,
        removeIssueFromExtractedFieldsCache
    ]);
    const getCachedIssueById = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'getCachedIssueById',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloGetCachedIssueById taskSuccess', {
            task: analyticsTaskName
        });
        return listData?.edges?.find((issue)=>issue?.node?.issueId === Number(issueId))?.node ?? null;
    }, [
        client,
        createAnalyticsEvent
    ]);
    const updateItemsInCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, issueIds: issueIds, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateItemsInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const listData = (0, $aVwtE.getAGGCompliantData)(data ?? undefined, 'list');
        const existingEdges = listData?.edges;
        if (existingEdges == null) return;
        try {
            const newEdges = [
                ...existingEdges
            ];
            let hasItemOverride = false;
            issueIds.forEach((issueId)=>{
                const issueToUpdateIndex = existingEdges.findIndex((issue)=>issue?.node?.issueId === Number(issueId)) ?? undefined;
                const existingIssue = existingEdges[issueToUpdateIndex];
                if (existingIssue?.node == null || issueToUpdateIndex === undefined || issueToUpdateIndex === -1 || existingIssue == null) return;
                const itemOverride = updateItem(existingIssue.node);
                if (itemOverride === undefined) return;
                hasItemOverride = true;
                newEdges[issueToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraWorkManagementViewItemEdge'
                };
            });
            if (!hasItemOverride) return;
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    jira: {
                        ...data?.jira ?? {},
                        list: {
                            ...listData,
                            edges: newEdges,
                            totalCount: newEdges.length
                        }
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloUpdateItemsInCache taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateItemsInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        getCachedIssueById: getCachedIssueById,
        updateItemsInCache: updateItemsInCache
    };
};

});
parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $a61MH.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $dYfll.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});


parcelRegister("2rYp2", function(module, exports) {

$parcel$export(module.exports, "useViewUpdater", () => $7b05e60be9d51978$export$a7d7c9fa51f6f9e6);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $i3K0B = parcelRequire("i3K0B");

var $eZbpk = parcelRequire("eZbpk");

var $lT4mK = parcelRequire("lT4mK");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $aVwtE = parcelRequire("aVwtE");

var $2hnDK = parcelRequire("2hnDK");

var $6HSzd = parcelRequire("6HSzd");
const $7b05e60be9d51978$export$a7d7c9fa51f6f9e6 = ({ input: input, query: query, actions: actions, onError: onError, onAppendItemsError: onAppendItemsError })=>{
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const cloudId = (0, $dWLk9.useCloudId)();
    // Keep track of updates in flight so we can validate them against the current list of issues.
    // Useful when filters are enabled and items are changed in a way that do not match the filter anymore.
    const [updateInFlightList, setUpdateInFlightList] = (0, $eUqFw.useState)([]);
    const [cacheActionIssues, dispatch] = (0, $6HSzd.useCacheActionsReducer)();
    // move this up here to stop eslint complaining
    let handleFilterMismatch;
    // Separate query to handle issue removal
    const [fetchIssueToRemove, { loading: fetchIssueToRemoveLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'REMOVE_FROM_CACHE',
                issues: validNodes
            });
        },
        onError: onAppendItemsError
    });
    // Separated query to update individual items so the other query can deal with pagination in the right sequence
    const [getIssuesById, { variables: getIssuesByIdVariables, loading: getIssuesByIdLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
        onError: (error)=>{
            if ((0, $lT4mK.isAbortError)(error.networkError)) return;
            onError(error);
        },
        onCompleted: (result)=>{
            handleFilterMismatch(getIssuesByIdVariables, result);
        }
    });
    // Separated query to append newly created items so we know it needs to be added to the top of the list.
    // Adding to the top to mimic backend behaviour but this might need to change when we introduce sorting.
    const [appendIssuesById, { loading: appendIssuesByIdLoading }] = (0, $iZuDo.useLazyQuery)(query, {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
        onCompleted: (result)=>{
            const items = (0, $aVwtE.getAGGCompliantData)(result, 'list', onError);
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'ADD_TO_CACHE',
                issues: validNodes
            });
        },
        onError: onAppendItemsError
    });
    const { addRequestToQueue: addRequestToQueue, addRequestToAbortableQueue: addRequestToAbortableQueue } = (0, $2hnDK.useRequestQueue)({
        isRequestLoading: fetchIssueToRemoveLoading || getIssuesByIdLoading || appendIssuesByIdLoading
    });
    const removeIssueById = (0, $eUqFw.useCallback)((issueIdsToRemove)=>{
        addRequestToQueue(()=>fetchIssueToRemove({
                variables: {
                    ...(0, $i3K0B.getVariables)({
                        jqlContext: jqlContext,
                        issueIds: issueIdsToRemove,
                        fieldIds: input.fieldIds,
                        isHidingDoneItems: input.isHidingDoneItems,
                        isParentFieldVisible: input.isParentFieldVisible,
                        isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                        projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined,
                        // we don't want to include any quickFiltersJql on purpose
                        // because we actually want to get the data of the issue that is not suppose to match the current quickFiltersJql
                        // e.g. consider this scenario
                        // - if the current quickFiltersJql is filtering DONE item
                        // - and the issueId that we need to remove is because user moving it to DONE
                        // - if we include the quickFiltersJql in here, the BE will NOT return the issue data because it's already DONE -> so we can't filter it in FE
                        // - so in this case we just want the data of the issue
                        quickFiltersJql: null
                    }),
                    cloudId: cloudId
                }
            }));
    }, [
        addRequestToQueue,
        fetchIssueToRemove,
        jqlContext,
        input.fieldIds,
        input.isHidingDoneItems,
        input.isParentFieldVisible,
        input.isDevSummaryFieldVisible,
        input.projectKey,
        cloudId
    ]);
    const removeIssue = (0, $eUqFw.useCallback)(({ issueId: issueId, parentId: parentId })=>{
        // @ts-expect-error ts(2322) - we can't instantiate an issue of the generic type, as we can't know the whole issue
        // However, the removeFromCache function called with this issue only needs this part of the interface
        const issueNode = {
            issueId: issueId,
            fields: parentId != null ? [
                {
                    fieldId: 'parent',
                    type: (0, $lO4Or.PARENT_TYPE),
                    parentIssue: {
                        issueId: parentId
                    }
                }
            ] : []
        };
        dispatch({
            type: 'REMOVE_FROM_CACHE',
            issues: [
                issueNode
            ]
        });
    }, [
        dispatch
    ]);
    // Filters are handled by JQL (not client side). The update function respects the filters so a BLANK update
    // means the item findIssueById didn't match the JQL filter and SHOULD be removed.
    handleFilterMismatch = (0, $eUqFw.useCallback)((variables, result)=>{
        if (!variables.jql) return;
        if ((0, $1ybV0.ff)('jira-list-view-realtime-discard-empty-response') && (!result || !result.jira)) // this is a case where the request failed, we don't want to remove the issue from the list in this case
        return;
        const updateIndex = updateInFlightList.findIndex((updateInput)=>(0, $i3K0B.getVariables)(updateInput).jql === variables.jql);
        if (updateIndex === -1) return;
        const currentUpdate = updateInFlightList[updateIndex];
        // In slow connections, users might change filters after an update was requested but before it can be applied.
        // We should not process those!
        const isUsingSameFilter = currentUpdate.quickFiltersJql === input.quickFiltersJql;
        const issueIds = [
            ...currentUpdate.issueIds || []
        ];
        const items = (0, $aVwtE.getAGGCompliantData)(result, 'list');
        const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
        if (isUsingSameFilter) {
            const issueIdsToRemove = [];
            issueIds.forEach((issueId, idIndex)=>{
                // item exists in the list but not in the filtered results - remove it!
                const item = validNodes?.find((node)=>node?.issueId === issueId);
                if (item == null) issueIdsToRemove.push(issueId);
                issueIds.splice(idIndex, 0);
                updateInFlightList[updateIndex] = {
                    ...currentUpdate,
                    issueIds: issueIds
                };
            });
            if (issueIdsToRemove.length > 0) removeIssueById(issueIdsToRemove);
        }
        setUpdateInFlightList((prevUpdateInFlightList)=>{
            prevUpdateInFlightList.splice(updateIndex, 1);
            return prevUpdateInFlightList;
        });
        // if item returns in filtered results it should be added to the cache. The method will dedup and sort by rank.
        if (validNodes && validNodes.length > 0) dispatch({
            type: 'ADD_TO_CACHE',
            issues: validNodes
        });
        // if item has been filtered out we may still want to do something with it
        const filteredIssueIds = issueIds.filter((issueId)=>!(validNodes ?? []).find((node)=>node?.issueId === issueId));
        if (filteredIssueIds.length > 0) dispatch({
            type: 'HANDLE_FILTERED_UPDATE',
            issues: filteredIssueIds
        });
    }, [
        updateInFlightList,
        input,
        removeIssueById,
        dispatch
    ]);
    // Interact with the cache in a useEffect to avoid doing it faster than the group items query data is updated
    (0, $eUqFw.useEffect)(()=>{
        if (cacheActionIssues.addToCache.length === 0 && cacheActionIssues.removeFromCache.length === 0 && cacheActionIssues.handleFilteredUpdate.length === 0) return;
        /* eslint-disable @typescript-eslint/consistent-type-assertions */ Object.entries(cacheActionIssues)/* eslint-enable @typescript-eslint/consistent-type-assertions */ .forEach(([actionName, issues])=>{
            if (Array.isArray(issues) && issues.length > 0) actions.forEach((actionEntry)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                actionEntry?.[actionName]?.(issues);
            });
        });
        dispatch({
            type: 'CLEAR'
        });
    }, [
        cacheActionIssues,
        actions,
        dispatch
    ]);
    return {
        onIssueUpdated: (issueIds)=>{
            // we want to fetch this issueIds
            // but at the same time we pass the `quickFiltersJql`
            // so if in the end result, we don't get back the `issueIds`, we know that the updated issue is not valid anymore in the current `quickFiltersJql`
            // e.g.
            // - current quickFiltersJql is NOT showing DONE item
            // - then there is an update to an ISSUE-X that changes the status
            // - we then fetch updated data of ISSUE_X based on current quickFiltersJql
            // - if the ISSUE-X is returned in the result -> it means ISSUE-X still matches current quickFiltersJql
            // - otherwise it is not, so it will be handled in handleFilterMismatch to be removed from view
            const updateInput = {
                jqlContext: jqlContext,
                issueIds: issueIds,
                fieldIds: input.fieldIds,
                quickFiltersJql: input.quickFiltersJql,
                isHidingDoneItems: input.isHidingDoneItems,
                isParentFieldVisible: input.isParentFieldVisible,
                isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined
            };
            setUpdateInFlightList((prevUpdateInFlightList)=>[
                    ...prevUpdateInFlightList,
                    updateInput
                ]);
            if ((0, $1ybV0.ff)('jwm.visual-hierarchy-milestone-1')) addRequestToAbortableQueue(issueIds, getIssuesById, {
                variables: {
                    ...(0, $i3K0B.getVariables)(updateInput),
                    cloudId: cloudId
                }
            });
            else addRequestToQueue(()=>{
                getIssuesById({
                    variables: {
                        ...(0, $i3K0B.getVariables)(updateInput),
                        cloudId: cloudId
                    }
                });
            });
        },
        onIssueCreated: (issueIds)=>{
            addRequestToQueue(()=>appendIssuesById({
                    variables: {
                        ...(0, $i3K0B.getVariables)({
                            jqlContext: jqlContext,
                            issueIds: issueIds,
                            fieldIds: input.fieldIds,
                            quickFiltersJql: input.quickFiltersJql,
                            isHidingDoneItems: input.isHidingDoneItems,
                            isParentFieldVisible: input.isParentFieldVisible,
                            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                            projectIdOrKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? input.projectKey ?? undefined : undefined
                        }),
                        cloudId: cloudId
                    }
                }));
        },
        onIssueRemoved: (params)=>removeIssue(params)
    };
};

});
parcelRegister("lT4mK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ABORT_ERROR_MESSAGE", () => $804e6ae63bab13aa$export$6131a8d209a21250);
$parcel$export(module.exports, "AbortError", () => $804e6ae63bab13aa$export$18b052ffd8c84d7);
$parcel$export(module.exports, "isAbortError", () => $804e6ae63bab13aa$export$d2c30ea522b3259e);
const $804e6ae63bab13aa$export$6131a8d209a21250 = 'The operation was aborted.';
class $804e6ae63bab13aa$export$18b052ffd8c84d7 extends Error {
    constructor(message, statusCode = 499){
        super(message);
        this.name = 'AbortError';
        this.statusCode = statusCode;
    }
}
const $804e6ae63bab13aa$export$d2c30ea522b3259e = (error)=>error instanceof $804e6ae63bab13aa$export$18b052ffd8c84d7;

});

parcelRegister("2hnDK", function(module, exports) {

$parcel$export(module.exports, "useRequestQueue", () => $dfad9e82c2bb88f7$export$a90df70eeafb262f);

var $eUqFw = parcelRequire("eUqFw");

var $lT4mK = parcelRequire("lT4mK");
const $dfad9e82c2bb88f7$export$a90df70eeafb262f = ({ isRequestLoading: isRequestLoading })=>{
    const [abortableQueueMap, setAbortableQueueMap] = (0, $eUqFw.useState)(new Map());
    const abortControllerMap = (0, $eUqFw.useRef)(new Map());
    const inProgressRequestId = (0, $eUqFw.useRef)(null);
    const addRequestToAbortableQueue = (0, $eUqFw.useCallback)((issueIds, queryFunction, queryOptions)=>{
        const id = issueIds.join('-');
        const existingAbortController = abortControllerMap.current.get(id);
        existingAbortController?.abort(new (0, $lT4mK.AbortError)((0, $lT4mK.DEFAULT_ABORT_ERROR_MESSAGE)));
        const abortController = new AbortController();
        abortControllerMap.current.set(id, abortController);
        const request = ()=>{
            queryFunction({
                ...queryOptions,
                context: {
                    ...queryOptions.context,
                    fetchOptions: {
                        ...queryOptions.context?.fetchOptions,
                        signal: abortController.signal
                    }
                }
            });
        };
        setAbortableQueueMap((prevQueueMap)=>new Map([
                ...prevQueueMap,
                [
                    id,
                    request
                ]
            ]));
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (!isRequestLoading && abortableQueueMap.size) {
            const iterator = abortableQueueMap.entries();
            const nextResult = iterator.next();
            if (!nextResult.done) {
                const [id, request] = nextResult.value;
                inProgressRequestId.current = id;
                request();
            }
            setAbortableQueueMap(new Map(iterator));
        }
    }, [
        abortableQueueMap,
        isRequestLoading
    ]);
    const [queue, setQueue] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isRequestLoading && queue.length > 0) setQueue((prevQueue)=>{
            const [nextItem, ...restOfQueue] = prevQueue;
            nextItem();
            return restOfQueue;
        });
    }, [
        queue,
        isRequestLoading
    ]);
    const addRequestToQueue = (request)=>setQueue((prevQueue)=>[
                ...prevQueue,
                request
            ]);
    return {
        addRequestToQueue: addRequestToQueue,
        addRequestToAbortableQueue: addRequestToAbortableQueue
    };
};

});

parcelRegister("6HSzd", function(module, exports) {

$parcel$export(module.exports, "useCacheActionsReducer", () => $fe64e59249b7515f$export$83303d410e8412eb);

var $eUqFw = parcelRequire("eUqFw");
const $fe64e59249b7515f$var$cacheActionsReducer = (state, action)=>{
    switch(action.type){
        case 'ADD_TO_CACHE':
            return {
                ...state,
                addToCache: [
                    ...state.addToCache,
                    ...action.issues
                ]
            };
        case 'REMOVE_FROM_CACHE':
            return {
                ...state,
                removeFromCache: [
                    ...state.removeFromCache,
                    ...action.issues
                ]
            };
        case 'HANDLE_FILTERED_UPDATE':
            return {
                ...state,
                handleFilteredUpdate: [
                    ...state.handleFilteredUpdate,
                    ...action.issues
                ]
            };
        case 'CLEAR':
            return {
                addToCache: [],
                removeFromCache: [],
                handleFilteredUpdate: []
            };
        default:
            return state;
    }
};
const $fe64e59249b7515f$export$83303d410e8412eb = ()=>// @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
    (0, $eUqFw.useReducer)($fe64e59249b7515f$var$cacheActionsReducer, {
        addToCache: [],
        removeFromCache: [],
        handleFilteredUpdate: []
    });

});


parcelRegister("fGcrx", function(module, exports) {

$parcel$export(module.exports, "useGroupCacheActions", () => $d008973264df6542$export$3083f2cce6510ba2);

var $i3K0B = parcelRequire("i3K0B");

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $9j3OJ = parcelRequire("9j3OJ");
var $4oWxH = parcelRequire("4oWxH");
var $hTnQu = parcelRequire("hTnQu");
var $gtnVv = parcelRequire("gtnVv");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $7O3Xq = parcelRequire("7O3Xq");

var $hzwAr = parcelRequire("hzwAr");

var $26iUh = parcelRequire("26iUh");

var $7XECd = parcelRequire("7XECd");

var $fjqly = parcelRequire("fjqly");

var $gfhub = parcelRequire("gfhub");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");

var $aqGaJ = parcelRequire("aqGaJ");

var $g74gP = parcelRequire("g74gP");

var $k37U2 = parcelRequire("k37U2");
const $d008973264df6542$export$3083f2cce6510ba2 = ({ fieldIds: fieldIds } = {})=>{
    const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const { addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache } = (0, $gtnVv.useItemGroupsCacheActions)();
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $g74gP.useRankParent)();
    const input = (0, $k37U2.useIssuesInput)({
        groupIssueId: (0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    const [{ issueParentMap: issueParentMap, issuesMap: issuesMap, childrenItems: childrenItems, hierarchyData: hierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, sorting: sorting, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const groupItemsQueryData = childrenItems;
    const groups = hierarchyData.data;
    const cloudId = (0, $dWLk9.useCloudId)();
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    const categoryField = availableFields.find((field)=>field?.type === (0, $lO4Or.CATEGORY_TYPE));
    const isGroupingByCategory = groupByFieldId === categoryField?.id;
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const { addToCache: addToGroupCache, removeFromCache: removeFromGroupCache } = (0, $9j3OJ.createGroupingViewUpdaterCacheActions)({
        query: (0, $7XECd.LIST_VIEW_QUERY),
        groupsQuery: (0, $hzwAr.LIST_VIEW_ITEM_GROUPS_QUERY),
        addToCache: addToCache,
        removeFromCache: removeFromCache,
        updateItemsInCache: updateItemsInCache,
        addGroupItemToCache: addGroupItemToCache,
        updateGroupItemInCache: updateGroupItemInCache,
        // make sure group items data exists in apollo cache
        canUpdateGroupCache: (groupIssueId)=>groupItemsQueryData ? !!groupItemsQueryData[(0, $6vrw7.toIssueId)(groupIssueId)] : false,
        findItemGroup: (item)=>(0, $26iUh.findItemGroup)({
                groups: groups,
                groupByFieldId: groupByFieldId,
                item: item,
                isGroupingByCategory: isGroupingByCategory
            }),
        createItemGroup: (item)=>(0, $26iUh.createItemGroup)({
                groupByFieldId: groupByFieldId,
                item: item
            }),
        findGroupById: (groupIssueId)=>groups?.find((group)=>groupIssueId === (0, $26iUh.createGroupIssueId)(group.id)),
        createVariablesForGroupItem: (groupIssueId)=>({
                cloudId: cloudId,
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    groupQuery: (0, $26iUh.getGroupQuery)({
                        groups: groups,
                        groupIssueId: groupIssueId,
                        groupByFieldId: groupByFieldId
                    }),
                    hierarchyParent: input.hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems,
                    projectIdOrKey: projectKey
                })
            }),
        createVariablesForGroups: ()=>(0, $7O3Xq.getGroupVariables)({
                groupByFieldId: groupByFieldId,
                jqlContext: jqlContext
            }),
        getParentOfIssueIfExist: (issueId)=>{
            const maybeIssue = issuesMap.get(String(issueId));
            if (!maybeIssue) return undefined;
            return maybeIssue.parentIssueId ?? (0, $4oWxH.getParentIssueId)(maybeIssue);
        },
        getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onUpdateParentWithNewChild: (0, $fjqly.addChildToParentListView),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        removeChildFromParent: (0, $fjqly.removeChildFromParentListView),
        createVariablesForItemWithParent: (parentIssueId)=>{
            if (!hierarchyParent) return {
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    hierarchyLevel: hierarchyLevel,
                    hierarchyParent: hierarchyParent,
                    isHidingDoneItems: isHidingDoneItems
                }),
                cloudId: cloudId
            };
            return {
                ...(0, $i3K0B.getVariables)({
                    jqlContext: jqlContext,
                    fieldIds: fieldIds || input.fieldIds,
                    quickFiltersJql: quickFiltersJql,
                    sorting: sorting,
                    isHidingDoneItems: isHidingDoneItems,
                    hierarchyParent: undefined,
                    parentIssue: {
                        hierarchyType: hierarchyParent,
                        issueId: parentIssueId
                    }
                }),
                cloudId: cloudId
            };
        },
        // note that prevParent will be undefined if the prevParent is not expanded or does not exist
        updateIssueParentMap: (issueId, newParentId)=>{
            if (newParentId) issueParentMap.set(String(issueId), String(newParentId));
            else issueParentMap.delete(String(issueId));
        }
    });
    return {
        addToGroupCache: addToGroupCache,
        removeFromGroupCache: removeFromGroupCache
    };
};

});
parcelRegister("gtnVv", function(module, exports) {

$parcel$export(module.exports, "useItemGroupsCacheActions", () => $b62511f8ae570da7$export$a49f2fc3773a6a0f);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $b62511f8ae570da7$export$a49f2fc3773a6a0f = ()=>{
    const analyticsTaskName = 'useItemGroupsCacheActionsApolloCacheActions';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const client = (0, $iZuDo.useApolloClient)();
    const updateGroupItemInCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, id: id, updateItem: updateItem })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'updateGroupItemInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        const existingNodes = data?.groups.nodes;
        if (existingNodes == null) return;
        const itemToUpdateIndex = existingNodes.findIndex((issue)=>issue?.id === id) ?? undefined;
        const existingItem = existingNodes[itemToUpdateIndex];
        if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingItem == null) return;
        const itemOverride = updateItem(existingItem);
        if (itemOverride === undefined) return;
        const newNodes = [
            ...existingNodes
        ];
        newNodes[itemToUpdateIndex] = itemOverride;
        try {
            client.writeQuery({
                query: query,
                variables: variables,
                // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: GenericGroupVariables; notifyOnNetworkStatusChange: boolean; data: { groups: { nodes: (TIssueNode | null | undefined)[]; }; }; }' is not assignable to parameter of type 'WriteQueryOptions<{ groups: { nodes: (TIssueNode | null | undefined)[]; }; }, GenericGroupVariables>'.
                notifyOnNetworkStatusChange: true,
                data: {
                    ...data,
                    groups: {
                        ...data?.groups || {},
                        nodes: newNodes
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'updateGroupItemInCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    const addGroupItemToCache = (0, $eUqFw.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
        const getCachedListData = ()=>{
            try {
                const read = client.readQuery({
                    query: query,
                    variables: variables
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                    task: analyticsTaskName
                });
                return read;
            } catch (e) {
                (0, $guiFP.default)({
                    error: e instanceof Error ? e : new Error('Unknown cache read error'),
                    meta: {
                        id: 'addGroupItemToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheRead taskFail',
                        error: JSON.stringify(e)
                    }
                });
                return null;
            }
        };
        const data = getCachedListData();
        if (data == null || data.groups == null || !Array.isArray(newNodes) || newNodes.length === 0 || !Array.isArray(newNodes)) return;
        const newGroupsIds = new Set(newNodes.map((item)=>item != null && item.id != null ? item.id : undefined).filter(Boolean));
        if (data == null || data.groups == null || !Array.isArray(data.groups.nodes)) return;
        try {
            const newGroups = data.groups.nodes.filter((node)=>node != null && node.id != null && !newGroupsIds.has(node.id)).concat(newNodes) ?? [];
            client.writeQuery({
                query: query,
                variables: variables,
                data: {
                    ...data,
                    groups: {
                        ...data.groups,
                        nodes: newGroups
                    }
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                task: analyticsTaskName
            });
        } catch (e) {
            (0, $guiFP.default)({
                error: e instanceof Error ? e : new Error('Unknown cache write error'),
                meta: {
                    id: 'addGroupItemToCache',
                    packageName: 'jiraBusinessListHandlers',
                    teamName: 'keystone'
                },
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true,
                attributes: {
                    task: analyticsTaskName,
                    query: JSON.stringify(query),
                    variables: JSON.stringify(variables),
                    eventName: 'apolloCacheWrite taskFail',
                    error: JSON.stringify(e)
                }
            });
        }
    }, [
        client,
        createAnalyticsEvent
    ]);
    return {
        updateGroupItemInCache: updateGroupItemInCache,
        addGroupItemToCache: addGroupItemToCache
    };
};

});

parcelRegister("g74gP", function(module, exports) {

$parcel$export(module.exports, "useRankParent", () => $c13b72b900996970$export$70ab091cfa570abd);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $c13b72b900996970$var$actions = {
    setRankParentIssueId: (rankParentIssueId)=>({ setState: setState })=>setState({
                rankParentIssueId: rankParentIssueId
            })
};
const $c13b72b900996970$var$Store = (0, $a61MH.createStore)({
    initialState: {
        rankParentIssueId: null
    },
    actions: $c13b72b900996970$var$actions,
    name: 'JBusListViewRankParentIssueIdStore'
});
const $c13b72b900996970$export$70ab091cfa570abd = (0, $ggKAj.createHook)($c13b72b900996970$var$Store);

});

parcelRegister("k37U2", function(module, exports) {

$parcel$export(module.exports, "useIssuesInput", () => $f493ab16cd54b286$export$242d22b97c239de6);

var $kQAZu = parcelRequire("kQAZu");

var $lGxgz = parcelRequire("lGxgz");

var $1ybV0 = parcelRequire("1ybV0");

var $26iUh = parcelRequire("26iUh");

var $gfhub = parcelRequire("gfhub");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");

var $aqGaJ = parcelRequire("aqGaJ");
const $f493ab16cd54b286$export$242d22b97c239de6 = (options)=>{
    const { groupIssueId: groupIssueId, parentIssueId: parentIssueId } = options || {};
    const [{ hierarchyLevel: hierarchyLevel }] = (0, $gfhub.useHierarchyLevel)();
    const [{ hierarchyData: hierarchyData }] = (0, $5r9Wo.useHierarchyStore)();
    const { jqlContext: jqlContext, quickFiltersJql: quickFiltersJql, isHidingDoneItems: isHidingDoneItems } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { hierarchyParent: hierarchyParent } = (0, $aqGaJ.useHierarchyConfig)();
    const { getQueryFieldIds: getQueryFieldIds, isParentFieldVisible: isParentFieldVisible, isDevSummaryFieldVisible: isDevSummaryFieldVisible } = (0, $hHiDc.useIssueFields)();
    const groups = hierarchyData.data;
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    let projectKey;
    if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const projectData = (0, $kQAZu.useProject)();
        projectKey = projectData.key;
    }
    let input = {
        jqlContext: jqlContext,
        quickFiltersJql: quickFiltersJql,
        projectIdOrKey: projectKey,
        fieldIds: getQueryFieldIds(),
        isHidingDoneItems: isHidingDoneItems,
        isParentFieldVisible: isParentFieldVisible(),
        isDevSummaryFieldVisible: isDevSummaryFieldVisible()
    };
    if (groupIssueId != null) input = {
        ...input,
        hierarchyParent: hierarchyParent,
        groupQuery: (0, $26iUh.getGroupQuery)({
            groupIssueId: groupIssueId,
            groupByFieldId: groupByFieldId,
            groups: groups
        })
    };
    else if (parentIssueId != null && hierarchyParent != null) input = {
        ...input,
        hierarchyParent: undefined,
        parentIssue: {
            hierarchyType: hierarchyParent,
            issueId: parentIssueId
        }
    };
    else {
        input.hierarchyLevel = hierarchyLevel;
        input.hierarchyParent = hierarchyParent;
    }
    return input;
};

});


parcelRegister("9DopW", function(module, exports) {

$parcel$export(module.exports, "useSupportedFieldIds", () => $a95fc05aeef016aa$export$ec520f6de95e7778);

var $eUqFw = parcelRequire("eUqFw");

var $gbsaq = parcelRequire("gbsaq");

var $hHiDc = parcelRequire("hHiDc");
const $a95fc05aeef016aa$export$ec520f6de95e7778 = ()=>{
    const { getQueryFieldIds: getQueryFieldIds, getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const queryFieldIds = getQueryFieldIds();
    return (0, $eUqFw.useMemo)(()=>[
            ...queryFieldIds,
            ...getAvailableFields().filter((field)=>field.type ? !queryFieldIds.includes(field.id) && (0, $gbsaq.SUPPORTED_GROUPS_TYPES).includes(field.type) : false).map((field)=>field.id)
        ], [
        getAvailableFields,
        queryFieldIds
    ]);
};

});



parcelRegister("5jA3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cec6992b21fffdf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9cec6992b21fffdf$var$ListActionsBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("bmBUJ")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/list-actions-banner/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cec6992b21fffdf$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "list-actions-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9cec6992b21fffdf$var$ListActionsBanner, null));

});
parcelRegister("bmBUJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hSQOc');
        const value = parcelRequire('5MvXJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hSQOc").then(()=>parcelRequire('5MvXJ'));
}

});


parcelRegister("eicDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5640d89dae7af19f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5640d89dae7af19f$var$ListViewUpdater = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("97FId")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/controllers/list-updater/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5640d89dae7af19f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "list-view-updater",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5640d89dae7af19f$var$ListViewUpdater, props));

});
parcelRegister("97FId", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('caoaB');
        const value = parcelRequire('e60XG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("caoaB").then(()=>parcelRequire('e60XG'));
}

});


parcelRegister("e3maP", function(module, exports) {

$parcel$export(module.exports, "useReparentModalStore", () => $9c67d8ad9d47df4a$export$2e755c9651c94d7f);
$parcel$export(module.exports, "useShouldShowReparentModal", () => $9c67d8ad9d47df4a$export$bb435bd62aedac9f);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $9c67d8ad9d47df4a$var$actions = {
    openReparentModal: (issueIdToReparent)=>({ setState: setState })=>{
            setState({
                issueIdToReparent: issueIdToReparent
            });
        },
    closeReparentModal: ()=>({ setState: setState })=>{
            setState({
                issueIdToReparent: null
            });
        }
};
const $9c67d8ad9d47df4a$var$ReparentModalStore = (0, $a61MH.createStore)({
    initialState: {
        issueIdToReparent: null
    },
    actions: $9c67d8ad9d47df4a$var$actions,
    name: 'JWMReparentModal'
});
const $9c67d8ad9d47df4a$export$2e755c9651c94d7f = (0, $ggKAj.createHook)($9c67d8ad9d47df4a$var$ReparentModalStore);
const $9c67d8ad9d47df4a$export$e88c9698e4ec8c24 = (state)=>state.issueIdToReparent != null;
const $9c67d8ad9d47df4a$export$bb435bd62aedac9f = (0, $ggKAj.createHook)($9c67d8ad9d47df4a$var$ReparentModalStore, {
    selector: $9c67d8ad9d47df4a$export$e88c9698e4ec8c24
});

});

parcelRegister("8axyj", function(module, exports) {

$parcel$export(module.exports, "useTableAnalytics", () => $d11291d162364e4c$export$d0703a75f31864f4);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1eMsI = parcelRequire("1eMsI");
const $d11291d162364e4c$export$d0703a75f31864f4 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ tableRef: tableRef }] = (0, $1eMsI.useTableRefStore)();
    const tableInitialised = (0, $eUqFw.useRef)(false);
    const _columns = tableRef.current?.getColumnManager()?._columns;
    const columns = (0, $eUqFw.useMemo)(()=>_columns ?? [], [
        _columns
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!tableInitialised.current && columns.length > 0) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'table init', {
                numberOfColumns: columns.length
            });
            tableInitialised.current = true;
        }
    }, [
        columns.length,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("1eMsI", function(module, exports) {

$parcel$export(module.exports, "useTableRefStore", () => $1f6827eabc323acd$export$18c478ca7c21c86a);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $1f6827eabc323acd$var$actions = {
    setTableRef: (tableRef)=>({ setState: setState })=>{
            setState({
                tableRef: tableRef
            });
        }
};
const $1f6827eabc323acd$var$TableRefStore = (0, $a61MH.createStore)({
    initialState: {
        tableRef: {
            current: null
        }
    },
    actions: $1f6827eabc323acd$var$actions,
    name: 'JWMTableRef'
});
const $1f6827eabc323acd$export$18c478ca7c21c86a = (0, $ggKAj.createHook)($1f6827eabc323acd$var$TableRefStore);

});


parcelRegister("aUash", function(module, exports) {

$parcel$export(module.exports, "useClearStaleGroupBy", () => $b0512a5241132dc8$export$33497e7241a3f128);

var $eUqFw = parcelRequire("eUqFw");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");
const $b0512a5241132dc8$export$33497e7241a3f128 = ({ onClear: onClear })=>{
    const [groupByFieldId, setGroupBy] = (0, $dSE3z.useGroupBy)();
    const { getAvailableFields: getAvailableFields, loading: loading } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    (0, $eUqFw.useEffect)(()=>{
        if (!groupByFieldId || loading) return;
        const isGroupedFieldAvailable = availableFields.some((field)=>field.id === groupByFieldId);
        if (!isGroupedFieldAvailable) {
            setGroupBy(undefined);
            onClear();
        }
    }, [
        groupByFieldId,
        setGroupBy,
        availableFields,
        loading,
        onClear
    ]);
    return null;
};

});

parcelRegister("bR4Tm", function(module, exports) {

$parcel$export(module.exports, "useIssueUpdated", () => $6499fbcc568e0c51$export$5ed6d188c4dd5d1d);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $99RVt = parcelRequire("99RVt");
const $6499fbcc568e0c51$var$canRemoveIssue = ({ fieldType: fieldType, issueKey: issueKey, newValue: newValue, oldValue: oldValue })=>{
    switch(fieldType){
        case 0, $lO4Or.PARENT_TYPE:
            if ((0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs')) {
                const currentProject = (issueKey ?? '').split('-')[0];
                const oldValueProjectKey = (oldValue?.key ?? '').split('-')[0];
                const newValueProjectKey = (newValue?.key ?? '').split('-')[0];
                if (// parent from foreign project is assigned
                !oldValue?.value && newValueProjectKey !== currentProject || // parent from foreign project is unlinked
                !newValue?.value && oldValueProjectKey !== currentProject) return false;
            }
            return newValue?.value !== oldValue?.value;
        default:
            return false;
    }
};
const $6499fbcc568e0c51$export$5ed6d188c4dd5d1d = ()=>{
    const { onIssueRemoved: onIssueRemoved } = (0, $99RVt.useListViewUpdaterService)();
    const onIssueUpdated = (0, $eUqFw.useCallback)(({ issueKey: issueKey, issueId: issueId, fieldType: fieldType, newValue: newValue, oldValue: oldValue })=>{
        if ($6499fbcc568e0c51$var$canRemoveIssue({
            issueKey: issueKey,
            fieldType: fieldType,
            newValue: newValue,
            oldValue: oldValue
        })) onIssueRemoved({
            issueId: Number(issueId),
            parentId: oldValue?.value ?? undefined
        });
    }, [
        onIssueRemoved
    ]);
    return {
        onIssueUpdated: onIssueUpdated
    };
};

});

parcelRegister("56s5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1ae6fe29740d0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iEjRn = parcelRequire("iEjRn");



var $bxcZe = parcelRequire("bxcZe");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a1ae6fe29740d0a$export$2e2bcd8739ae039 = (props)=>{
    (0, $eUqFw.useEffect)(()=>{
        // preload components required for initial render
        (0, $iEjRn.Table).preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iEjRn.default), props);
};

});
parcelRegister("iEjRn", function(module, exports) {

$parcel$export(module.exports, "Table", () => $52e903affc483eca$export$54ec01a60f47d33d);
$parcel$export(module.exports, "default", () => $52e903affc483eca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $al6r8 = parcelRequire("al6r8");

const $52e903affc483eca$export$54ec01a60f47d33d = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("41cdA")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/base-table/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52e903affc483eca$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "base-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $al6r8.LoadingTable), props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52e903affc483eca$export$54ec01a60f47d33d, props));

});
parcelRegister("al6r8", function(module, exports) {

$parcel$export(module.exports, "LoadingTable", () => $611d347caa94c445$export$b353ee8dbb8fb09e);

var $eUqFw = parcelRequire("eUqFw");

var $90G8g = parcelRequire("90G8g");

var $7P3DW = parcelRequire("7P3DW");
const $611d347caa94c445$var$getRowSkeleton = (columns, rowHeight, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonRow, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonField, key = 0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonRow, {
        key: key
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonField, {
            key: column.key,
            height: rowHeight,
            width: column.width
        })));
const $611d347caa94c445$var$getLoadingSkeleton = (columns, rowHeight, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonRow, // eslint-disable-next-line @typescript-eslint/no-explicit-any
SkeletonField)=>Array.from({
        length: 20
    }, (_, i)=>$611d347caa94c445$var$getRowSkeleton(columns, rowHeight, SkeletonRow, SkeletonField, i));
const $611d347caa94c445$export$b353ee8dbb8fb09e = /*#__PURE__*/ (0, $eUqFw.memo)(({ columns: columns, rowHeight: rowHeight })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.Wrapper), null, columns.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.TableWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingRow), {
        key: "loading-header-row"
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingWrapper), {
            key: column.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.LoadingField), {
            // @ts-expect-error - Type 'number | undefined' is not assignable to type 'number'.
            height: rowHeight,
            width: column.width - (0, $7P3DW.ICON_OFFSET)
        })))), $611d347caa94c445$var$getLoadingSkeleton(columns, rowHeight, (0, $7P3DW.LoadingRow), (0, $7P3DW.LoadingField))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P3DW.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90G8g.ThemedSpinner), null))), (prevProps, nextProps)=>prevProps.columns.length === nextProps.columns.length);

});
parcelRegister("7P3DW", function(module, exports) {

$parcel$export(module.exports, "LoadingRow", () => $20a0eba714969846$export$d1e723d3001badba);
$parcel$export(module.exports, "LoadingField", () => $20a0eba714969846$export$2304bbb03949f4f1);
$parcel$export(module.exports, "ICON_OFFSET", () => $20a0eba714969846$export$382610e783aa2ae8);
$parcel$export(module.exports, "LoadingWrapper", () => $20a0eba714969846$export$43a792a870d28db2);
$parcel$export(module.exports, "LoadingIcon", () => $20a0eba714969846$export$b936c55164dcf1db);
$parcel$export(module.exports, "Wrapper", () => $20a0eba714969846$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "SpinnerWrapper", () => $20a0eba714969846$export$52b4dfd89a6b3a1b);
$parcel$export(module.exports, "TableWrapper", () => $20a0eba714969846$export$4267411171632d35);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $20a0eba714969846$var$LOADING_VIEW_HEIGHT = '76vh';
const $20a0eba714969846$export$d1e723d3001badba = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$2304bbb03949f4f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1rjw0ur": (0, $9t7rW.default)(`${__cmplp.width - (0, $c9TLT.gridSize) * 2}px`),
            "--_mkz9at": (0, $9t7rW.default)(`${__cmplp.height - (0, $c9TLT.gridSize) * 2}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbra4q _4t3i2wna _bfhk15j7 _18s8u2gc _19bvv77o _2rko1sit",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$var$ICON_SIZE = 24;
const $20a0eba714969846$export$382610e783aa2ae8 = $20a0eba714969846$var$ICON_SIZE + (0, $c9TLT.gridSize) * 2;
const $20a0eba714969846$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$b936c55164dcf1db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _4t3i1tcg _bfhk1aqf _18s8u2gc _2rko1sit",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoftgi _1e0c1txw _2lx21bp4 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1h6o _4cvr1h6o _1tkeo1og",
            __cmplp.className
        ])
    });
});
const $20a0eba714969846$export$4267411171632d35 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _1e0c1ule _4t3io1og _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("41cdA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('50qxY')
        ]);
        const value = parcelRequire('iaq7Q');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("50qxY")
    ]).then(()=>parcelRequire('iaq7Q'));
}

});


parcelRegister("bxcZe", function(module, exports) {

$parcel$export(module.exports, "getColumnVisibilityIndexes", () => $a6ed118b467cb247$export$2b4b1825d849585e);
$parcel$export(module.exports, "useHighlightDoneItems", () => $a6ed118b467cb247$export$10dde765bae17fce);
$parcel$export(module.exports, "calculateIssuesHeight", () => $a6ed118b467cb247$export$e12173811eb87ac);
$parcel$export(module.exports, "getIssueCreateRankBefore", () => $a6ed118b467cb247$export$963872cb9359ad45);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $d3C6e = parcelRequire("d3C6e");

var $1ybV0 = parcelRequire("1ybV0");

var $6vrw7 = parcelRequire("6vrw7");

var $aXbY8 = parcelRequire("aXbY8");

var $fP6gY = parcelRequire("fP6gY");
const $a6ed118b467cb247$export$2b4b1825d849585e = (0, $5iWql.default)((scrollLeft, tableWidth, columns)=>{
    const leftEdge = scrollLeft;
    const rightEdge = scrollLeft + tableWidth;
    const visibleColumnsIdx = [];
    const invisibleColumnsIdx = [];
    let totalOffset = 0;
    const columnsOffset = columns.reduce((acc, column)=>{
        acc.push(totalOffset);
        totalOffset += column.width;
        return acc;
    }, []);
    columnsOffset.forEach((columnOffset, colIdx)=>{
        const isNotVisible = columnOffset + columns[colIdx].width < leftEdge || columnOffset > rightEdge;
        isNotVisible ? invisibleColumnsIdx.push(colIdx) : visibleColumnsIdx.push(colIdx);
    });
    return {
        visibleColumns: visibleColumnsIdx,
        invisibleColumns: invisibleColumnsIdx
    };
});
const $a6ed118b467cb247$var$useHighlightDoneItemsNew = ()=>{
    const [highlightedIssues, setHightlightedIssues] = (0, $eUqFw.useState)({});
    const toggleHighlightRow = (0, $eUqFw.useCallback)((issueKey, value, timeout = 5000)=>{
        setHightlightedIssues((prev)=>({
                ...prev,
                [issueKey]: value
            }));
        if (value) // using a timer here to clean up the object instead of tiying it to the unmount of the row because base-table unmounts rows due to virtualisation.
        setTimeout(()=>{
            setHightlightedIssues((prevState)=>{
                const newState = {
                    ...prevState
                };
                delete newState[issueKey];
                return newState;
            });
        }, timeout);
    }, []);
    const getRowClassName = (0, $eUqFw.useCallback)(({ rowData: rowData })=>highlightedIssues[rowData.key] && 'highlight', [
        highlightedIssues
    ]);
    return {
        toggleHighlightRow: toggleHighlightRow,
        getRowClassName: getRowClassName
    };
};
const $a6ed118b467cb247$var$useHighlightDoneItemsOld = ()=>{
    const [highlightedIssues, setHightlightedIssues] = (0, $eUqFw.useState)({});
    const toggleHighlightRow = (issueKey, value, timeout = 5000)=>{
        setHightlightedIssues({
            ...highlightedIssues,
            [issueKey]: value
        });
        if (value) // using a timer here to clean up the object instead of tiying it to the unmount of the row because base-table unmounts rows due to virtualisation.
        setTimeout(()=>{
            setHightlightedIssues((prevState)=>{
                const newState = {
                    ...prevState
                };
                delete newState[issueKey];
                return newState;
            });
        }, timeout);
    };
    const getRowClassName = ({ rowData: rowData })=>highlightedIssues[rowData.key] && 'highlight';
    return {
        toggleHighlightRow: toggleHighlightRow,
        getRowClassName: getRowClassName
    };
};
const $a6ed118b467cb247$export$10dde765bae17fce = ()=>// eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1ybV0.ff)('jwm.list.rendering-improvements') ? $a6ed118b467cb247$var$useHighlightDoneItemsNew() : $a6ed118b467cb247$var$useHighlightDoneItemsOld();
const $a6ed118b467cb247$export$e12173811eb87ac = (issues, rowHeight, expandedItems, expandedGroups)=>issues.reduce((totalHeight, issue)=>{
        let accumulatedHeight = totalHeight;
        accumulatedHeight += rowHeight;
        // add the total heights of all expanded children
        if (issue.children && issue.children.length > 0 && (expandedItems && expandedItems[(0, $6vrw7.toIssueId)(issue.issueId)] === true || expandedGroups && expandedGroups[(0, $6vrw7.toIssueId)(issue.issueId)] === true)) accumulatedHeight += $a6ed118b467cb247$export$e12173811eb87ac(issue.children, rowHeight, expandedItems, expandedGroups);
        return accumulatedHeight;
    }, 0);
const $a6ed118b467cb247$export$963872cb9359ad45 = ({ items: items, startIndex: startIndex })=>{
    let rankBefore;
    const itemsCount = items?.length ?? 0;
    if (itemsCount > 0) for(let i = startIndex; i < itemsCount; i++){
        const { issueId: issueId, rank: rank } = items[i];
        const isItemAnIssue = !(0, $d3C6e.isOptimisticIssue)(issueId) && !(0, $fP6gY.isEmptyRow)(String(issueId)) && !(0, $aXbY8.isItemAnInlineCreate)(String(issueId)) && !(0, $aXbY8.isItemShowMore)(String(issueId));
        if (isItemAnIssue) {
            rankBefore = {
                issueId: String(issueId),
                rank: rank
            };
            break;
        }
    }
    return rankBefore;
};

});
parcelRegister("fP6gY", function(module, exports) {

$parcel$export(module.exports, "isEmptyRow", () => $b4b94bbd67441d39$export$ee1d59c3151f153d);

var $4oWxH = parcelRequire("4oWxH");

var $6vrw7 = parcelRequire("6vrw7");

var $aXbY8 = parcelRequire("aXbY8");

var $lqO9q = parcelRequire("lqO9q");
const $b4b94bbd67441d39$export$36f6900d705f61ab = ({ data: data, childrenQueryData: childrenQueryData, rowCreateState: rowCreateState, setRowCreatePosition: setRowCreatePosition, setIssueExpanded: setIssueExpanded, groups: groups, groupItemsQueryData: groupItemsQueryData })=>{
    const issuesMap = new Map();
    const addAndReturnIssue = (issue)=>{
        issuesMap.set(String(issue.issueId), issue);
        return issue;
    };
    const convertListViewIssueToListViewControllerData = ({ issue: issue, children: children, issueHasChildCreateOpen: issueHasChildCreateOpen, canCreateChild: canCreateChild, rankIndex: rankIndex, parentIssueId: parentIssueId })=>{
        if ((0, $4oWxH.isGroupItem)(issue.issueId) && groupItemsQueryData) return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex,
            children: issueHasChildCreateOpen ? [
                (0, $aXbY8.createRowForInlineCreate)('group'),
                ...children || []
            ] : children
        });
        if (childrenQueryData) return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex,
            parentIssueId: parentIssueId,
            children: issueHasChildCreateOpen ? [
                ...children || [],
                (0, $aXbY8.createRowForInlineCreate)('subtask')
            ] : children,
            onChildCreateButtonClicked: canCreateChild ? ()=>{
                setRowCreatePosition({
                    parentId: issue.issueId
                });
                if (setIssueExpanded) setIssueExpanded((0, $6vrw7.toIssueId)(issue.issueId), true);
            } : undefined
        });
        return addAndReturnIssue({
            ...issue,
            rankIndex: rankIndex
        });
    };
    const isGrouping = typeof groups !== 'undefined' ? groups.length > 0 : false;
    if (isGrouping && !groupItemsQueryData || !childrenQueryData) return {
        convertedData: data.map((issue, index)=>convertListViewIssueToListViewControllerData({
                issue: issue,
                children: undefined,
                issueHasChildCreateOpen: false,
                canCreateChild: false,
                rankIndex: index,
                parentIssueId: undefined
            })),
        issuesMap: issuesMap
    };
    const items = isGrouping ? groups : data;
    const convertedData = (items || []).map((issue, index)=>{
        // TODO https://jbusiness.atlassian.net/browse/JET-1723 need to convert to string
        const { issueId: issueIdNumber, childSummary: childSummary } = issue;
        const issueId = String(issueIdNumber);
        const { parentId: parentId } = rowCreateState;
        const issueHasChildCreateOpen = parentId === issue.issueId;
        const hasNoChildren = !childSummary?.hasChildren;
        if (hasNoChildren) return convertListViewIssueToListViewControllerData({
            issue: issue,
            children: undefined,
            issueHasChildCreateOpen: issueHasChildCreateOpen,
            canCreateChild: true,
            parentIssueId: undefined,
            rankIndex: index
        });
        // Getting children from either GroupQueryData or ChildrenQueryData and merging them with items
        let children;
        const childIssuesData = childrenQueryData ? childrenQueryData[issue.issueId] : undefined;
        const groupItemsData = groupItemsQueryData ? groupItemsQueryData[issue.issueId] : undefined;
        const childItemsData = isGrouping ? groupItemsData : childIssuesData;
        const loading = isGrouping ? !groupItemsData || groupItemsData?.loading : !childIssuesData || childIssuesData?.loading;
        if (loading === true) children = [
            (0, $aXbY8.createItemSkeleton)({
                issueId: issueId
            })
        ];
        else children = childItemsData ? childItemsData.data.map((childIssue, childIndex)=>{
            const convertedChildIssue = convertListViewIssueToListViewControllerData({
                issue: childIssue,
                // TODO remove undefined children for recursive call once we introduce multiple hierarchy levels
                children: undefined,
                issueHasChildCreateOpen: false,
                // children items cannot create child anymore, TODO when multiple hierarchy introduced, this logic will need to change
                canCreateChild: false,
                parentIssueId: issueId,
                rankIndex: childIndex
            });
            return convertedChildIssue;
        }) : [];
        const convertedIssue = convertListViewIssueToListViewControllerData({
            issue: issue,
            children: children,
            issueHasChildCreateOpen: issueHasChildCreateOpen,
            canCreateChild: true,
            parentIssueId: undefined,
            rankIndex: index
        });
        return convertedIssue;
    });
    return {
        convertedData: convertedData,
        issuesMap: issuesMap
    };
};
const $b4b94bbd67441d39$var$EMTPY_ROW_PREFIX = 'EMPTY_ROW';
const $b4b94bbd67441d39$export$ee1d59c3151f153d = (issueId = '')=>issueId.toString().startsWith($b4b94bbd67441d39$var$EMTPY_ROW_PREFIX);
const $b4b94bbd67441d39$export$4293a35894588c6e = [
    {
        id: '',
        issueId: $b4b94bbd67441d39$var$EMTPY_ROW_PREFIX,
        typeId: '',
        issuetype: {},
        key: '',
        rank: '',
        rankIndex: -1,
        status: {
            categoryId: '',
            name: ''
        },
        totalSubtasks: 0,
        cacheVariables: (0, $lqO9q.DEFAULT_CACHE_VARIABLES)
    }
];

});



parcelRegister("5NSnR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4548836f1135cd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b4548836f1135cd$var$LazyBulkDeleteModal = (0, $7rh0R.lazy)(()=>(parcelRequire("i4YGn")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/bulk-delete-modal/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b4548836f1135cd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "bulk-delete-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b4548836f1135cd$var$LazyBulkDeleteModal, null));

});
parcelRegister("i4YGn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9pDXu');
        const value = parcelRequire('2DsrU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9pDXu").then(()=>parcelRequire('2DsrU'));
}

});


parcelRegister("1lhPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b3d960aa428cb2$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/rules-of-hooks */ 
var $eUqFw = parcelRequire("eUqFw");

var $4E9Xv = parcelRequire("4E9Xv");

var $5SC3o = parcelRequire("5SC3o");

var $1ybV0 = parcelRequire("1ybV0");

var $hotly = parcelRequire("hotly");

var $9UXmP = parcelRequire("9UXmP");

var $blMI4 = parcelRequire("blMI4");

var $7x2p7 = parcelRequire("7x2p7");
const $12b3d960aa428cb2$var$BulkEdit = ()=>{
    const isBulkEditEnabled = (0, $1ybV0.ff)('bulk-edit-in-jwm-list-view_bny2w');
    if (!isBulkEditEnabled) return null;
    const bulkChangePermission = (0, $9UXmP.useBulkChangePermission)();
    const bulkOperationsForm = (0, $5SC3o.useReferenceLoader)();
    const [, { toggleBulkEditSidebar: toggleBulkEditSidebar }] = (0, $hotly.useBulkSelectionStore)();
    const onOpenSidebar = (0, $eUqFw.useCallback)(()=>{
        toggleBulkEditSidebar({
            showBulkEditSidebar: true
        });
    }, [
        toggleBulkEditSidebar
    ]);
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        toggleBulkEditSidebar({
            showBulkEditSidebar: false
        });
    }, [
        toggleBulkEditSidebar
    ]);
    if (!isBulkEditEnabled || !bulkChangePermission) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4E9Xv.BulkOpsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7x2p7.BulkEditSidebar), {
        bulkOperationsForm: bulkOperationsForm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $blMI4.BulkOperationsLoader), {
        bulkOperationsForm: bulkOperationsForm,
        onCloseSidebar: onCloseSidebar,
        onOpenSidebar: onOpenSidebar
    }));
};
var $12b3d960aa428cb2$export$2e2bcd8739ae039 = $12b3d960aa428cb2$var$BulkEdit;

});
parcelRegister("4E9Xv", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $3d2709472df65d95$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $3d2709472df65d95$export$95271787b6ae4d3c);

var $eUqFw = parcelRequire("eUqFw");

var $bAQOb = parcelRequire("bAQOb");

var $8WuJm = parcelRequire("8WuJm");

var $jeI7w = parcelRequire("jeI7w");
const $3d2709472df65d95$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3d2709472df65d95$var$BulkOpsAnalyticsProviderOld = (props)=>{
    const [bulkOpsFlow] = (0, $eUqFw.useState)(new (0, $jeI7w.DefaultBulkOpsFlow)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d2709472df65d95$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, props.children);
};
const $3d2709472df65d95$var$BulkOpsAnalyticsProviderNew = (props)=>{
    const [bulkOpsFlow] = (0, $eUqFw.useState)(new (0, $jeI7w.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $eUqFw.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d2709472df65d95$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $3d2709472df65d95$export$8ab440f197429d1e = (0, $bAQOb.componentWithFF)('bulk-operations-additions-may08-sprint_rvdeo', $3d2709472df65d95$var$BulkOpsAnalyticsProviderNew, $3d2709472df65d95$var$BulkOpsAnalyticsProviderOld);
const $3d2709472df65d95$export$95271787b6ae4d3c = ()=>(0, $eUqFw.useContext)($3d2709472df65d95$var$BulkOpsAnalyticsContext);

});
parcelRegister("jeI7w", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $d9ae6884fa818966$export$74bf75c57acfbb74);

var $hompL = parcelRequire("hompL");
class $d9ae6884fa818966$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("5SC3o", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $1500fcd781a55507$export$727d936bc4a88f4e);

var $eUqFw = parcelRequire("eUqFw");
const $1500fcd781a55507$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $eUqFw.useState)(null);
    return (0, $eUqFw.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("9UXmP", function(module, exports) {

$parcel$export(module.exports, "useBulkChangePermission", () => $8991899306b94587$export$9a67849ec94d7b59);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $fTkNj = parcelRequire("fTkNj");

var $hotly = parcelRequire("hotly");
const $8991899306b94587$export$9a67849ec94d7b59 = ()=>{
    if (!(0, $1ybV0.ff)('bulk-edit-in-jwm-list-view_bny2w')) return false;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [, { setBulkChangePermission: setBulkChangePermission }] = (0, $hotly.useBulkSelectionStore)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const bulkChangePermission = (0, $fTkNj.useBulkChangePermissionService)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        bulkChangePermission !== null && bulkChangePermission !== undefined && setBulkChangePermission({
            bulkChangePermission: bulkChangePermission
        });
    }, [
        bulkChangePermission,
        setBulkChangePermission
    ]);
    return bulkChangePermission;
};

});
parcelRegister("fTkNj", function(module, exports) {

$parcel$export(module.exports, "useBulkChangePermissionService", () => $8131c5fbbb51b610$export$cd2838b9aad6b912);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gd0Sp = parcelRequire("gd0Sp");

const $8131c5fbbb51b610$export$cd2838b9aad6b912 = ()=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const [bulkChangePermission, setPermission] = (0, $eUqFw.useState)();
    const getBulkChangePermission = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const gqlResponse = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $366c055cc947f138$export$f9d7f5d9663f3e0c),
                    variables: {
                        cloudId: cloudId
                    }
                })
            });
            setPermission(gqlResponse?.data?.jira?.permission?.hasPermission ?? false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchBulkChangePermission',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to get bulk change permission.'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setPermission(false);
        }
    }, [
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        getBulkChangePermission();
    }, [
        getBulkChangePermission,
        cloudId
    ]);
    return bulkChangePermission;
};

});
const $366c055cc947f138$export$f9d7f5d9663f3e0c = `
query GetBulkEditPermission ($cloudId: ID!) {
    jira {
      permission(cloudId: $cloudId, type: BULK_CHANGE)
        @optIn(to: "JiraPermission")
        {
            hasPermission
        }
    }
  }
`;



parcelRegister("blMI4", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsLoader", () => $f0823ea538c98d65$export$3af81192d3c2a190);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eZoe4 = parcelRequire("eZoe4");

var $hotly = parcelRequire("hotly");

var $epZpb = parcelRequire("epZpb");

var $dSE3z = parcelRequire("dSE3z");

var $1ji6g = parcelRequire("1ji6g");
const $f0823ea538c98d65$export$3af81192d3c2a190 = ({ bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { bulkOptimisticUpdate: bulkOptimisticUpdate } = (0, $1ji6g.useUpdateGroupIssue)();
    const { updateSelectedItemsInCache: updateSelectedItemsInCache } = (0, $epZpb.useBulkEditCacheActions)();
    const [{ bulkEditableIssues: selectedIssues }] = (0, $hotly.useBulkSelectionStore)();
    const onUpdateStart = (0, $eUqFw.useCallback)((res)=>{
        const { data: data, issueIds: issueIds } = res[0];
        if (data) {
            if (groupByFieldId) // TODO: Transform data to ListItemField type for bulkOptimisticUpdate
            bulkOptimisticUpdate(issueIds, []);
            else updateSelectedItemsInCache({
                data: data,
                issueIds: issueIds
            });
        }
    }, [
        groupByFieldId,
        bulkOptimisticUpdate,
        updateSelectedItemsInCache
    ]);
    // TODO remove this action on bulk-transition-multiple-workflows_wtnvv cleanup
    const onUpdateStartOld = (0, $eUqFw.useCallback)(({ data: data, issueIds: issueIds })=>{
        if (data) {
            if (groupByFieldId) // TODO: Transform data to ListItemField type for bulkOptimisticUpdate
            bulkOptimisticUpdate(issueIds, []);
            else updateSelectedItemsInCache({
                data: data,
                issueIds: issueIds
            });
        }
    }, [
        groupByFieldId,
        bulkOptimisticUpdate,
        updateSelectedItemsInCache
    ]);
    const onUpdateError = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), []);
    const onUpdateSuccess = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), []);
    const onOpenForm = (0, $eUqFw.useCallback)(()=>{
        onOpenSidebar();
    }, [
        onOpenSidebar
    ]);
    const onCloseForm = (0, $eUqFw.useCallback)(()=>{
        onCloseSidebar();
    }, [
        onCloseSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZoe4.AsyncBulkOpsCore), {
        bulkOperationsForm: bulkOperationsForm,
        onOpenForm: onOpenForm,
        onCloseForm: onCloseForm,
        onUpdateStart: onUpdateStart,
        onUpdateStartOld: onUpdateStartOld,
        onUpdateError: onUpdateError,
        onUpdateSuccess: onUpdateSuccess,
        onLegacyBulkEditRequest: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onSelectAll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        selectableIssueIds: [],
        selectedIssueIds: Array.from(selectedIssues).map(Number) ?? [],
        extraAnalyticsAttributes: {},
        onClearAll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        // configure when resolving the ticket https://jplat.jira.atlassian.cloud/browse/THOR-3771. leaving this switched on by default for now.
        hasBulkEditPermission: true
    });
};

});
parcelRegister("eZoe4", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $d719578b48c9f60c$export$ac7b39f8b8a9f5cd);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $jt2jz = parcelRequire("jt2jz");
const $d719578b48c9f60c$var$entryPointParams = {};
const $d719578b48c9f60c$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jt2jz.asyncBulkopsCoreEntryPoint), $d719578b48c9f60c$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("jt2jz", function(module, exports) {

$parcel$export(module.exports, "asyncBulkopsCoreEntryPoint", () => $a24e50e796ac10e7$export$3e78ba4b165ed95e);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $a24e50e796ac10e7$export$3e78ba4b165ed95e = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8XEa1")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8XEa1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ZR3gR')
        ]);
        const value = parcelRequire('hAaG7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ZR3gR")
    ]).then(()=>parcelRequire('hAaG7'));
}

});



parcelRegister("epZpb", function(module, exports) {

$parcel$export(module.exports, "useBulkEditCacheActions", () => $3e05e02cb955498f$export$cbb9dab75d903148);

var $eUqFw = parcelRequire("eUqFw");

var $fcWBJ = parcelRequire("fcWBJ");

var $7Sz8O = parcelRequire("7Sz8O");
var $hTnQu = parcelRequire("hTnQu");

var $eI5EY = parcelRequire("eI5EY");

var $7XECd = parcelRequire("7XECd");

var $5r9Wo = parcelRequire("5r9Wo");

var $hotly = parcelRequire("hotly");

var $1cjzL = parcelRequire("1cjzL");
const $3e05e02cb955498f$export$cbb9dab75d903148 = ()=>{
    const { updateItemsInCache: updateItemsInCache } = (0, $hTnQu.useCacheActions)();
    const [{ selectedIssues: selectedIssues }] = (0, $hotly.useBulkSelectionStore)();
    const [{ issuesMap: issuesMap }] = (0, $5r9Wo.useHierarchyStore)();
    const updateSelectedItemsInCache = (0, $eUqFw.useCallback)(({ data: data })=>{
        const selectedIssuesByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))([
            ...selectedIssues
        ], (issueId)=>issuesMap.get(issueId)?.parentIssueId || (0, $7Sz8O.ROOT_LEVEL));
        const parents = Object.entries(selectedIssuesByParent);
        const optimisticUpdateIssue = (existingIssue)=>{
            const updatedIssue = {
                ...existingIssue,
                fields: [
                    ...existingIssue.fields?.filter((field)=>!Object.keys(data).includes(field?.fieldId)) ?? [],
                    ...(0, $1cjzL.transformData)(existingIssue, data)
                ]
            };
            return updatedIssue;
        };
        parents.forEach(([, issues])=>{
            const variables = issuesMap.get(issues[0])?.cacheVariables;
            if (variables !== undefined) updateItemsInCache({
                query: (0, $7XECd.LIST_VIEW_QUERY),
                variables: {
                    ...variables,
                    withParentIssueId: (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')
                },
                issueIds: issues,
                updateItem: optimisticUpdateIssue
            });
        });
    }, [
        selectedIssues,
        issuesMap,
        updateItemsInCache
    ]);
    return {
        updateSelectedItemsInCache: updateSelectedItemsInCache
    };
};

});
parcelRegister("1cjzL", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $614a70d4040c7750$export$3ceb62baab058c6b);

var $dXOIB = parcelRequire("dXOIB");
const $614a70d4040c7750$export$3ceb62baab058c6b = (existingIssue, data)=>{
    const optimisticUpdateFields = [];
    return Object.keys(data).reduce((acc, fieldId)=>{
        const accumulator = acc;
        const existingField = existingIssue.fields?.find((field)=>field.fieldId === fieldId);
        if (existingField && (0, $dXOIB.isOptimisticUpdateSupported)(existingField.type)) {
            const fieldFormValue = data[existingField.fieldId];
            if (fieldFormValue === undefined) return accumulator;
            const transformedField = (0, $dXOIB.transformFieldForOptimisticUpdates)(existingField.type, existingField, fieldFormValue);
            if (transformedField !== undefined) accumulator.push(transformedField);
        }
        return accumulator;
    }, optimisticUpdateFields);
};

});
parcelRegister("dXOIB", function(module, exports) {

$parcel$export(module.exports, "transformFieldForOptimisticUpdates", () => $8b00d316a1e5e75e$export$efcd89b84c6a3e91);
$parcel$export(module.exports, "isOptimisticUpdateSupported", () => $8b00d316a1e5e75e$export$d96ec240de147154);

var $5iWql = parcelRequire("5iWql");

var $gEWNG = parcelRequire("gEWNG");

var $2OcmD = parcelRequire("2OcmD");

var $gfc8V = parcelRequire("gfc8V");

var $6SSdp = parcelRequire("6SSdp");

var $dduzv = parcelRequire("dduzv");

var $KUkV1 = parcelRequire("KUkV1");

var $2eBI0 = parcelRequire("2eBI0");

var $5DlXh = parcelRequire("5DlXh");

var $cINNs = parcelRequire("cINNs");

var $lOzLM = parcelRequire("lOzLM");

var $cTnEj = parcelRequire("cTnEj");

var $1Oh2J = parcelRequire("1Oh2J");
const $8b00d316a1e5e75e$var$createSupportedBulkEditTransformations = (0, $5iWql.default)(()=>({
        ...(0, $2eBI0.priorityOptimisticUpdatesHandler),
        ...(0, $cTnEj.userOptimisticUpdatesHandler),
        ...(0, $gfc8V.labelsOptimisticUpdatesHandler),
        ...(0, $gEWNG.dateOptimisticUpdatesHandler),
        ...(0, $2OcmD.dateTimeOptimisticUpdatesHandler),
        ...(0, $6SSdp.multiSelectOptimisticUpdatesHandler),
        ...(0, $dduzv.numberOptimisticUpdatesHandler),
        ...(0, $KUkV1.parentOptimisticUpdatesHandler),
        ...(0, $1Oh2J.versionOptimisticUpdatesHandler),
        ...(0, $5DlXh.singleSelectOptimisticUpdatesHandler),
        ...(0, $lOzLM.urlOptimisticUpdatesHandler),
        ...(0, $cINNs.textOptimisticUpdatesHandler)
    }));
const $8b00d316a1e5e75e$export$efcd89b84c6a3e91 = (fieldType, ...args)=>{
    const handlers = $8b00d316a1e5e75e$var$createSupportedBulkEditTransformations();
    if (!handlers[fieldType]) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType](...args);
};
const $8b00d316a1e5e75e$export$d96ec240de147154 = (fieldType)=>{
    const handlers = $8b00d316a1e5e75e$var$createSupportedBulkEditTransformations();
    return handlers[fieldType] !== null;
};

});
parcelRegister("gEWNG", function(module, exports) {

$parcel$export(module.exports, "dateOptimisticUpdatesHandler", () => $56c7d5c89815bc37$export$f6ab9c7ce755192);

var $lO4Or = parcelRequire("lO4Or");
const $56c7d5c89815bc37$export$fb826df18639e2fa = (existingField, fieldData)=>({
        ...existingField,
        date: fieldData ?? null
    });
const $56c7d5c89815bc37$export$f6ab9c7ce755192 = {
    [(0, $lO4Or.DATE_CF_TYPE)]: $56c7d5c89815bc37$export$fb826df18639e2fa,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $56c7d5c89815bc37$export$fb826df18639e2fa,
    [(0, $lO4Or.START_DATE_TYPE)]: $56c7d5c89815bc37$export$fb826df18639e2fa
};

});

parcelRegister("2OcmD", function(module, exports) {

$parcel$export(module.exports, "dateTimeOptimisticUpdatesHandler", () => $fec393f1144feeae$export$a24474a096daecea);

var $lO4Or = parcelRequire("lO4Or");
const $fec393f1144feeae$export$3863479bf706ee55 = (existingField, fieldData)=>({
        ...existingField,
        dateTime: fieldData ?? null
    });
const $fec393f1144feeae$export$a24474a096daecea = {
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $fec393f1144feeae$export$3863479bf706ee55
};

});

parcelRegister("gfc8V", function(module, exports) {

$parcel$export(module.exports, "labelsOptimisticUpdatesHandler", () => $866cd623680d6186$export$ae3a6c05d0376219);

var $lO4Or = parcelRequire("lO4Or");

var $bdPbp = parcelRequire("bdPbp");
const $866cd623680d6186$export$24889be11660a2f9 = (existingField, fieldData)=>{
    const action = fieldData.action;
    const existingLabels = existingField.selectedLabelsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    const labelNodes = (0, $bdPbp.transformOptionsUsingMultiAction)({
        existingOptions: existingLabels,
        options: fieldData.value.map((value)=>({
                __typename: 'JiraLabel',
                labelId: null,
                name: value.value
            })),
        action: action,
        isEqual: (option, existingOption)=>option.name === existingOption.name
    });
    return {
        ...existingField,
        selectedLabelsConnection: {
            __typename: 'JiraLabelConnection',
            edges: labelNodes?.map((node)=>({
                    __typename: 'JiraLabelEdge',
                    node: node
                })) ?? null
        }
    };
};
const $866cd623680d6186$export$ae3a6c05d0376219 = {
    [(0, $lO4Or.LABELS_TYPE)]: $866cd623680d6186$export$24889be11660a2f9
};

});
parcelRegister("bdPbp", function(module, exports) {

$parcel$export(module.exports, "transformOptionsUsingMultiAction", () => $e9be823968055534$export$de5a9a8aa203227b);
const $e9be823968055534$export$de5a9a8aa203227b = ({ existingOptions: existingOptions, options: options, action: action, isEqual: isEqual })=>{
    if (action === 'set') return options;
    if (action === 'add') return [
        ...existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption))),
        ...options
    ];
    if (action === 'remove') return existingOptions.filter((existingOption)=>options.some((option)=>!isEqual(option, existingOption)));
    return null;
};

});


parcelRegister("6SSdp", function(module, exports) {

$parcel$export(module.exports, "multiSelectOptimisticUpdatesHandler", () => $0290c012aba98b26$export$451576b5e993a4c6);

var $lO4Or = parcelRequire("lO4Or");
const $0290c012aba98b26$export$6308785fb410c4b7 = (existingField, fieldData)=>({
        ...existingField,
        selectedOptions: {
            __typename: 'JiraOptionConnection',
            edges: fieldData.map((field)=>({
                    __typename: 'JiraOptionEdge',
                    node: {
                        __typename: 'JiraOption',
                        optionId: '',
                        value: field.value
                    }
                }))
        }
    });
const $0290c012aba98b26$export$451576b5e993a4c6 = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $0290c012aba98b26$export$6308785fb410c4b7
};

});

parcelRegister("dduzv", function(module, exports) {

$parcel$export(module.exports, "numberOptimisticUpdatesHandler", () => $79bb4b501f624220$export$b507b41c3a04d8b2);

var $lO4Or = parcelRequire("lO4Or");
const $79bb4b501f624220$export$db1d3572e95020a7 = (existingField, fieldData)=>({
        ...existingField,
        number: fieldData
    });
const $79bb4b501f624220$export$b507b41c3a04d8b2 = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $79bb4b501f624220$export$db1d3572e95020a7,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $79bb4b501f624220$export$db1d3572e95020a7,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $79bb4b501f624220$export$db1d3572e95020a7
};

});

parcelRegister("KUkV1", function(module, exports) {

$parcel$export(module.exports, "parentOptimisticUpdatesHandler", () => $e570ee2a2827b1e2$export$beaef88a0d44b30c);

var $lO4Or = parcelRequire("lO4Or");
const $e570ee2a2827b1e2$export$b807f08dd17c9fef = (existingField, fieldData)=>({
        ...existingField,
        parentIssue: {
            __typename: 'JiraIssue',
            id: fieldData.id?.toString() || '',
            issueId: fieldData.value.toString(),
            key: fieldData.key,
            rankField: [],
            fields: [
                {
                    fieldId: 'summary',
                    aliasFieldId: null,
                    name: 'Summary',
                    type: 'summary',
                    text: fieldData.fields.summary,
                    __typename: 'JiraSingleLineTextField'
                },
                {
                    fieldId: 'issuetype',
                    aliasFieldId: null,
                    name: 'Issue Type',
                    type: 'issuetype',
                    __typename: 'JiraIssueTypeField',
                    issueType: {
                        __typename: 'JiraIssueType',
                        name: fieldData?.fields?.issuetype?.name || '',
                        avatar: {
                            medium: fieldData?.fields?.issuetype?.iconUrl?.replace('xsmall', 'medium'),
                            __typename: 'JiraAvatar'
                        }
                    }
                }
            ]
        }
    });
const $e570ee2a2827b1e2$export$beaef88a0d44b30c = {
    [(0, $lO4Or.PARENT_TYPE)]: $e570ee2a2827b1e2$export$b807f08dd17c9fef
};

});

parcelRegister("2eBI0", function(module, exports) {

$parcel$export(module.exports, "priorityOptimisticUpdatesHandler", () => $eada8a0041e1baae$export$1722f398d0e70c01);

var $XGPnQ = parcelRequire("XGPnQ");

var $lO4Or = parcelRequire("lO4Or");
const $eada8a0041e1baae$export$5096de161ee14da = (existingField, fieldData)=>{
    const priorityId = fieldData.value && (0, $XGPnQ.JiraPriorityAri).check(fieldData.value) ? (0, $XGPnQ.JiraPriorityAri).parse(fieldData.value).resourceId : fieldData?.value ?? '';
    return {
        ...existingField,
        priority: {
            id: fieldData.value ?? '',
            name: fieldData.label,
            priorityId: priorityId,
            iconUrl: fieldData.iconUrl,
            __typename: 'JiraPriority'
        }
    };
};
const $eada8a0041e1baae$export$1722f398d0e70c01 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $eada8a0041e1baae$export$5096de161ee14da
};

});
parcelRegister("XGPnQ", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAri", () => $2eb998dfbb67cb97$export$5f41709ebd395cb1);

var $kVIiT = parcelRequire("kVIiT");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/priority/manifest.ts
var $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $kVIiT.JiraPriorityAriResourceOwner),
    resourceType: (0, $kVIiT.JiraPriorityAriResourceType),
    resourceIdSlug: "activation/{activationId}/{priorityId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        priorityId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/priority/index.ts
var $2eb998dfbb67cb97$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get priorityId() {
        return this._priorityId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.qualifier,
            platformQualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceOwner,
            resourceType: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                priorityId: opts.priorityId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            priorityId: this.priorityId
        };
    }
};

});
parcelRegister("kVIiT", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAriResourceOwner", () => $87edd756771a8842$export$a154bdc743e3d7f4);
$parcel$export(module.exports, "JiraPriorityAriResourceType", () => $87edd756771a8842$export$f5f5f4d1fc71ee3e);
// src/jira/priority/types.ts
var $87edd756771a8842$export$a154bdc743e3d7f4 = "jira", $87edd756771a8842$export$f5f5f4d1fc71ee3e = "priority";

});



parcelRegister("5DlXh", function(module, exports) {

$parcel$export(module.exports, "singleSelectOptimisticUpdatesHandler", () => $9403be3430c48d89$export$3bfe96bec4aaa3d1);

var $lO4Or = parcelRequire("lO4Or");
const $9403be3430c48d89$export$1c2a2f3ef1a9bb3 = (existingField, fieldData)=>{
    if (fieldData === null) return {
        ...existingField,
        fieldOption: null
    };
    return {
        ...existingField,
        fieldOption: {
            __typename: 'JiraOption',
            optionId: fieldData.value,
            value: fieldData.label,
            color: null
        }
    };
};
const $9403be3430c48d89$export$3bfe96bec4aaa3d1 = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $9403be3430c48d89$export$1c2a2f3ef1a9bb3
};

});

parcelRegister("cINNs", function(module, exports) {

$parcel$export(module.exports, "textOptimisticUpdatesHandler", () => $99d0ef486f298ff5$export$6d32d6f2341892ca);

var $lO4Or = parcelRequire("lO4Or");
const $99d0ef486f298ff5$export$dff85ea10550e176 = (existingField, fieldData)=>({
        ...existingField,
        text: !fieldData ? ' ' : fieldData
    });
const $99d0ef486f298ff5$export$6d32d6f2341892ca = {
    [(0, $lO4Or.TEXT_CF_TYPE)]: $99d0ef486f298ff5$export$dff85ea10550e176
};

});

parcelRegister("lOzLM", function(module, exports) {

$parcel$export(module.exports, "urlOptimisticUpdatesHandler", () => $dada0ccdd3c33047$export$5275c3199d66bb55);

var $lO4Or = parcelRequire("lO4Or");
const $dada0ccdd3c33047$export$2fdc0fb9ea4e0c38 = (existingField, fieldData)=>({
        ...existingField,
        uri: !fieldData ? null : fieldData
    });
const $dada0ccdd3c33047$export$5275c3199d66bb55 = {
    [(0, $lO4Or.URL_CF_TYPE)]: $dada0ccdd3c33047$export$2fdc0fb9ea4e0c38
};

});

parcelRegister("cTnEj", function(module, exports) {

$parcel$export(module.exports, "userOptimisticUpdatesHandler", () => $af3752e2e37a93a1$export$2205d16240a6327f);

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $af3752e2e37a93a1$var$activeAccountStatus = 'active';
const $af3752e2e37a93a1$export$ae35491859a54223 = (existingField, fieldData)=>({
        ...existingField,
        user: fieldData != null ? {
            accountId: fieldData.accountId ?? '',
            accountStatus: $af3752e2e37a93a1$var$activeAccountStatus,
            picture: fieldData.avatarUrls[0, $jGcn0.DEFAULT_AVATAR_RES],
            name: fieldData.displayName,
            __typename: 'AtlassianAccountUser'
        } : null
    });
const $af3752e2e37a93a1$export$741c2fd1d5e759e7 = (existingField, fieldData)=>({
        ...existingField,
        user: fieldData != null ? {
            accountId: fieldData.id ?? '',
            accountStatus: $af3752e2e37a93a1$var$activeAccountStatus,
            picture: fieldData.avatarUrl,
            name: fieldData.name,
            __typename: 'AtlassianAccountUser'
        } : null
    });
const $af3752e2e37a93a1$export$2205d16240a6327f = {
    [(0, $lO4Or.REPORTER_TYPE)]: $af3752e2e37a93a1$export$741c2fd1d5e759e7,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $af3752e2e37a93a1$export$ae35491859a54223
};

});

parcelRegister("1Oh2J", function(module, exports) {

$parcel$export(module.exports, "versionOptimisticUpdatesHandler", () => $a43f30c32845e2f3$export$ded24c5df4d4a072);

var $lO4Or = parcelRequire("lO4Or");

var $bdPbp = parcelRequire("bdPbp");
const $a43f30c32845e2f3$export$23dfa4890df81d45 = (existingField, fieldData)=>({
        ...existingField,
        version: fieldData ? {
            __typename: 'JiraVersion',
            versionId: fieldData.value,
            name: fieldData.label
        } : null
    });
const $a43f30c32845e2f3$export$ab0e3c9aa41c8369 = (existingField, fieldData)=>{
    const action = fieldData.action;
    const existingVersions = existingField.selectedVersionsConnection?.edges?.map((edge)=>edge?.node).filter(Boolean) ?? [];
    const versionNodes = (0, $bdPbp.transformOptionsUsingMultiAction)({
        existingOptions: existingVersions,
        options: fieldData.value.map((value)=>({
                __typename: 'JiraVersion',
                versionId: value.value,
                name: value.label
            })),
        action: action,
        isEqual: (option, existingOption)=>option.versionId === existingOption.versionId
    });
    return {
        ...existingField,
        selectedVersionsConnection: {
            __typename: 'JiraVersionConnection',
            edges: versionNodes?.map((node)=>({
                    __typename: 'JiraVersionEdge',
                    node: node
                })) ?? null
        }
    };
};
const $a43f30c32845e2f3$export$ded24c5df4d4a072 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $a43f30c32845e2f3$export$23dfa4890df81d45,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $a43f30c32845e2f3$export$ab0e3c9aa41c8369,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $a43f30c32845e2f3$export$ab0e3c9aa41c8369,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $a43f30c32845e2f3$export$ab0e3c9aa41c8369
};

});




parcelRegister("1ji6g", function(module, exports) {

$parcel$export(module.exports, "useUpdateGroupIssue", () => $6b83525a7e08b896$export$43b9ca95cc220db0);

var $eUqFw = parcelRequire("eUqFw");

var $i3K0B = parcelRequire("i3K0B");

var $4oWxH = parcelRequire("4oWxH");
var $hTnQu = parcelRequire("hTnQu");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $fecbI = parcelRequire("fecbI");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $csTm8 = parcelRequire("csTm8");

var $7XECd = parcelRequire("7XECd");

var $9QCRO = parcelRequire("9QCRO");

var $fGcrx = parcelRequire("fGcrx");

var $5r9Wo = parcelRequire("5r9Wo");

var $g74gP = parcelRequire("g74gP");

var $k37U2 = parcelRequire("k37U2");


var $jcy5X = parcelRequire("jcy5X");
const $6b83525a7e08b896$export$43b9ca95cc220db0 = ()=>{
    const { getCachedIssueById: getCachedIssueById } = (0, $hTnQu.useCacheActions)();
    const { addToGroupCache: addToGroupCache } = (0, $fGcrx.useGroupCacheActions)();
    const [{ rankParentIssueId: rankParentIssueId }] = (0, $g74gP.useRankParent)();
    const input = (0, $k37U2.useIssuesInput)({
        groupIssueId: (0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined,
        parentIssueId: !(0, $4oWxH.isGroupItem)(rankParentIssueId) ? rankParentIssueId : undefined
    });
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [originalIssue, setOriginalIssue] = (0, $eUqFw.useState)();
    const [{ issuesMap: issuesMap }] = (0, $5r9Wo.useHierarchyStore)();
    const [updateError, setUpdateError] = (0, $eUqFw.useState)(null);
    const cloudId = (0, $dWLk9.useCloudId)();
    (0, $eUqFw.useEffect)(()=>{
        if (updateError) {
            setUpdateError(null);
            // revert optimistic update
            if (originalIssue) {
                addToGroupCache([
                    originalIssue
                ]);
                setOriginalIssue(null);
            }
            showFlag({
                type: 'error',
                title: [
                    (0, $jcy5X.default).errorTitle,
                    {
                        field: updateError.field
                    }
                ],
                description: [
                    (0, $jcy5X.default).errorMessage,
                    {
                        field: updateError.field
                    }
                ]
            });
            (0, $guiFP.default)({
                meta: {
                    id: updateError.query,
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                error: updateError.error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        originalIssue,
        updateError,
        addToGroupCache,
        showFlag
    ]);
    const optimisticUpdate = (0, $eUqFw.useCallback)((issue, fieldType, field)=>{
        const cachedIssue = getCachedIssueById({
            issueId: issue.issueId,
            query: (0, $7XECd.LIST_VIEW_QUERY),
            variables: {
                ...(0, $i3K0B.getVariables)(input),
                cloudId: cloudId
            }
        });
        setOriginalIssue(cachedIssue);
        if (cachedIssue) {
            const updatedIssue = {
                ...cachedIssue,
                fields: [
                    ...cachedIssue.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (cachedField)=>cachedField.fieldId !== fieldType) ?? [],
                    field
                ]
            };
            addToGroupCache([
                updatedIssue
            ]);
        }
    }, [
        getCachedIssueById,
        input,
        cloudId,
        addToGroupCache
    ]);
    const bulkOptimisticUpdate = (0, $eUqFw.useCallback)((issueIds, fields)=>{
        const cachedIssues = issueIds.map((issueId)=>getCachedIssueById({
                issueId: issueId.toString(),
                query: (0, $7XECd.LIST_VIEW_QUERY),
                variables: {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    ...issuesMap.get(issueId.toString())?.cacheVariables,
                    cloudId: cloudId
                }
            })).filter(Boolean);
        const fieldIds = fields.map((field)=>field.fieldId);
        if (cachedIssues.length) {
            const updatedIssues = cachedIssues.map((cachedIssue)=>({
                    ...cachedIssue,
                    fields: [
                        ...cachedIssue.fields?.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (cachedField)=>!fieldIds.includes(cachedField.fieldId)) ?? [],
                        ...fields
                    ]
                }));
            addToGroupCache(updatedIssues);
        }
    }, [
        getCachedIssueById,
        issuesMap,
        cloudId,
        addToGroupCache
    ]);
    const updateField = (0, $eUqFw.useCallback)((issue, fieldType, fieldValue, analyticsAlias)=>{
        (0, $fecbI.defaultSaveField)((0, $6vrw7.toIssueKey)(issue.key), fieldType, fieldValue, '').then(()=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $4243c9d89786171f$export$406cbd2164fd0d71)} succeeded`, {
                field: (0, $csTm8.getFieldForAnalytics)(fieldType, analyticsAlias)
            });
        }).catch((error)=>{
            setUpdateError({
                error: error,
                field: (0, $csTm8.getFieldForAnalytics)(fieldType, analyticsAlias),
                query: (0, $4243c9d89786171f$export$406cbd2164fd0d71)
            });
        });
    }, [
        setUpdateError,
        createAnalyticsEvent
    ]);
    const updateAssignee = (0, $eUqFw.useCallback)((issue, fieldValue)=>{
        const newField = {
            aliasFieldId: null,
            fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
            name: 'assignee',
            type: 'assignee',
            fieldConfig: {
                isEditable: true,
                __typename: 'JiraFieldConfig'
            },
            __typename: 'JiraSingleSelectUserPickerField',
            user: fieldValue != null ? {
                accountId: fieldValue.accountId,
                accountStatus: (0, $9QCRO.AccountStatus).active,
                picture: fieldValue.avatarUrl,
                name: fieldValue.displayName,
                __typename: 'AtlassianAccountUser'
            } : null
        };
        optimisticUpdate(issue, (0, $lO4Or.ASSIGNEE_TYPE), newField);
        if (fieldValue === null || fieldValue === undefined) // unassigned user
        updateField(issue, (0, $lO4Or.ASSIGNEE_TYPE), null);
        else (0, $lRmyA.performGetRequest)(`/rest/api/2/user/assignable/search?issueKey=${issue.key}&accountId=${fieldValue.accountId}`).then((response)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $4243c9d89786171f$export$3e3161555559eda3)} succeeded`);
            if (Array.isArray(response) && response[0]) updateField(issue, (0, $lO4Or.ASSIGNEE_TYPE), response[0]);
            else setUpdateError({
                error: new Error('User does not exist or is not allowed to be assigned to the issue'),
                field: (0, $lO4Or.ASSIGNEE_TYPE),
                query: (0, $4243c9d89786171f$export$3e3161555559eda3)
            });
        }).catch((error)=>{
            setUpdateError({
                error: error,
                field: (0, $lO4Or.ASSIGNEE_TYPE),
                query: (0, $4243c9d89786171f$export$3e3161555559eda3)
            });
        });
    }, [
        optimisticUpdate,
        updateField,
        setUpdateError,
        createAnalyticsEvent
    ]);
    const updatePriority = (0, $eUqFw.useCallback)((issue, fieldValue)=>{
        if (fieldValue) {
            const priorityId = fieldValue.id && (0, $huI7r.isAri)(fieldValue.id) ? (0, $huI7r.getAriConfig)(fieldValue.id).resourceId : fieldValue?.id ?? null;
            const newField = {
                aliasFieldId: null,
                fieldId: (0, $lO4Or.PRIORITY_TYPE),
                type: (0, $lO4Or.PRIORITY_TYPE),
                name: 'Priority',
                priority: {
                    id: fieldValue.id ?? '',
                    name: fieldValue.name,
                    priorityId: priorityId ?? '',
                    iconUrl: fieldValue.iconUrl,
                    __typename: 'JiraPriority'
                },
                __typename: 'JiraPriorityField'
            };
            optimisticUpdate(issue, (0, $lO4Or.PRIORITY_TYPE), newField);
            updateField(issue, (0, $lO4Or.PRIORITY_TYPE), {
                ...fieldValue,
                id: priorityId
            });
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateCategory = (0, $eUqFw.useCallback)((issue, fieldKey, fieldValue)=>{
        const category = fieldValue ? {
            value: fieldValue.name,
            label: fieldValue.name
        } : null;
        const newField = {
            aliasFieldId: null,
            fieldId: fieldKey,
            fieldConfig: {
                isEditable: true,
                __typename: 'JiraFieldConfig'
            },
            __typename: 'JiraSingleSelectField',
            name: 'Category',
            type: (0, $lO4Or.CATEGORY_TYPE),
            fieldOption: fieldValue ? {
                optionId: fieldValue.optionId,
                value: fieldValue.name,
                color: fieldValue.color ? {
                    colorKey: fieldValue.color,
                    __typename: 'JiraColor'
                } : null,
                __typename: 'JiraOption'
            } : null
        };
        optimisticUpdate(issue, fieldKey, newField);
        updateField(issue, fieldKey, category, 'category');
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateJiraNumber = (0, $eUqFw.useCallback)((issue, field, number)=>{
        if (typeof number !== 'undefined') {
            const newField = {
                fieldId: field.id,
                aliasFieldId: field.aliasFieldId || null,
                name: field.name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                type: field.type,
                number: number,
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                __typename: 'JiraNumberField'
            };
            optimisticUpdate(issue, field.id, newField);
            updateField(issue, field.id, number, newField.aliasFieldId || newField.type);
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    const updateSprint = (0, $eUqFw.useCallback)((issue, field, sprint)=>{
        if (typeof sprint !== 'undefined') {
            const newField = {
                fieldId: field.id,
                name: field.name,
                aliasFieldId: 'sprint',
                type: (0, $lO4Or.SPRINT_TYPE),
                fieldConfig: {
                    isEditable: true,
                    __typename: 'JiraFieldConfig'
                },
                selectedSprintsConnection: {
                    edges: sprint === null ? [] : [
                        {
                            node: {
                                sprintId: String(sprint.id),
                                name: sprint.name,
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                state: sprint.state,
                                __typename: 'JiraSprint'
                            },
                            __typename: 'JiraSprintEdge'
                        }
                    ],
                    __typename: 'JiraSprintConnection'
                },
                __typename: 'JiraSprintField'
            };
            optimisticUpdate(issue, field.id, newField);
            updateField(issue, field.id, sprint === null ? null : Number(sprint.id), 'sprint');
        }
    }, [
        optimisticUpdate,
        updateField
    ]);
    return {
        updateAssignee: updateAssignee,
        updatePriority: updatePriority,
        updateCategory: updateCategory,
        updateJiraNumber: updateJiraNumber,
        updateSprint: updateSprint,
        bulkOptimisticUpdate: bulkOptimisticUpdate
    };
};

});
parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});

parcelRegister("csTm8", function(module, exports) {

$parcel$export(module.exports, "getFieldForAnalytics", () => $53d1fcbf7bde8af4$export$af1963dc1f827ac2);

var $lO4Or = parcelRequire("lO4Or");
const $53d1fcbf7bde8af4$export$af1963dc1f827ac2 = (fieldType, analyticsAlias)=>{
    if (analyticsAlias) {
        // keep backwards compatibility
        if (analyticsAlias === (0, $lO4Or.CATEGORY_TYPE)) return 'category';
        return analyticsAlias;
    }
    return fieldType;
};

});

parcelRegister("9QCRO", function(module, exports) {

$parcel$export(module.exports, "AccountStatus", () => $a8333aabe82fb202$export$3693f74db10d5f88);
/* eslint-disable camelcase */ var $a8333aabe82fb202$export$3693f74db10d5f88;
(function(AccountStatus) {
    AccountStatus["active"] = "active";
    AccountStatus["closed"] = "closed";
    AccountStatus["inactive"] = "inactive";
})($a8333aabe82fb202$export$3693f74db10d5f88 || ($a8333aabe82fb202$export$3693f74db10d5f88 = {}));

});

const $4243c9d89786171f$export$3e3161555559eda3 = 'updateGroupIssueAssigneeSearch';
const $4243c9d89786171f$export$406cbd2164fd0d71 = 'updateGroupIssueUpdateField';

parcelRegister("jcy5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d8b34908106b6b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8d8b34908106b6b2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.controllers.update-group-issue.error-title",
        "defaultMessage": "Failed to update {field}"
    },
    errorMessage: {
        "id": "business-list.controllers.update-group-issue.error-message",
        "defaultMessage": "Something went wrong updating the issue's {field} field. Please try again or contact your administrator if the problem persists."
    }
});

});



parcelRegister("7x2p7", function(module, exports) {

$parcel$export(module.exports, "BulkEditSidebar", () => $fad5dc21f02178b6$export$43008afc76943d65);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hSCS8 = parcelRequire("hSCS8");

var $hotly = parcelRequire("hotly");
const $fad5dc21f02178b6$var$useOnUnmount = (fn)=>{
    const currentFn = (0, $eUqFw.useRef)(fn);
    currentFn.current = fn;
    (0, $eUqFw.useEffect)(()=>()=>currentFn.current(), []);
};
const $fad5dc21f02178b6$export$43008afc76943d65 = ({ bulkOperationsForm: bulkOperationsForm })=>{
    const [{ content: content }, { resetSidebarQueryParams: resetSidebarQueryParams, setSidebarContent: _setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const [{ showBulkEditSidebar: showBulkEditSidebar }] = (0, $hotly.useBulkSelectionStore)();
    const lastSetSidebarContent = (0, $eUqFw.useRef)(null);
    const setSidebarContent = (0, $eUqFw.useCallback)((newContent)=>{
        _setSidebarContent(newContent);
        lastSetSidebarContent.current = newContent;
    }, [
        _setSidebarContent
    ]);
    const resetSidebarContent = (0, $eUqFw.useCallback)(()=>{
        if (lastSetSidebarContent.current) setSidebarContent(null);
    }, [
        setSidebarContent
    ]);
    $fad5dc21f02178b6$var$useOnUnmount(resetSidebarContent);
    const sidebarContent = (0, $eUqFw.useMemo)(()=>showBulkEditSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.wrapper",
            xcss: $fad5dc21f02178b6$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            "data-testId": "business-list.ui.list-view.bulk-edit-sidebar.bulkops-sidebar",
            ref: bulkOperationsForm.setRef,
            xcss: $fad5dc21f02178b6$var$containerStyles
        })) : null, [
        bulkOperationsForm.setRef,
        showBulkEditSidebar
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!sidebarContent) return;
        if (!lastSetSidebarContent.current) resetSidebarQueryParams();
        if (content !== sidebarContent) setSidebarContent(sidebarContent);
    }, [
        content,
        resetSidebarQueryParams,
        setSidebarContent,
        sidebarContent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (sidebarContent) return;
        if (content && content === lastSetSidebarContent.current) resetSidebarContent();
    }, [
        content,
        resetSidebarContent,
        sidebarContent
    ]);
    return null;
};
const $fad5dc21f02178b6$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    inset: 'space.0',
    justifyContent: 'stretch'
});
const $fad5dc21f02178b6$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    flexGrow: 1,
    // Adjust for the unwanted vertical padding from 'SidebarLayout'
    marginBottom: 'space.negative.100',
    marginTop: 'space.negative.100'
});

});


parcelRegister("fuaUK", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $0302372f09956a0e$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $jGcn0 = parcelRequire("jGcn0");

var $kiBzn = parcelRequire("kiBzn");
var $lGxgz = parcelRequire("lGxgz");
var $96etS = parcelRequire("96etS");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $egJIx = parcelRequire("egJIx");

var $kny42 = parcelRequire("kny42");

var $j1jCa = parcelRequire("j1jCa");
const $0302372f09956a0e$export$ea3803e2a45d21c4 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, setInlineCreateParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.INLINE_CREATE_PARAM));
    const handleClick = (0, $eUqFw.useCallback)(()=>setInlineCreateParam('true'), [
        setInlineCreateParam
    ]);
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0302372f09956a0e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kny42.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0302372f09956a0e$var$HeadingWrapper, null, formatMessage((0, $j1jCa.default).emptyStateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0302372f09956a0e$var$contentWrapperStyles
    }, formatMessage((0, $j1jCa.default).emptyStateDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        onClick: handleClick
    }, formatMessage(isSoftwareFieldsEnabled ? (0, $j1jCa.default).createIssueButton : (0, $j1jCa.default).createItemButton)));
};
const $0302372f09956a0e$export$fddf379e22a74b00 = ()=>{
    const { isFiltering: isFiltering, jqlErrors: jqlErrors } = (0, $lGxgz.useFilteredViewContextInput)({
        view: 'list'
    });
    const { isSearching: isSearching } = (0, $96etS.useSimpleSearchJQL)();
    const emptyStateMessage = isSearching || isFiltering ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kiBzn.ThemedFilterEmptyState), {
        reason: jqlErrors.length ? 'INVALID_JQL' : 'NO_RESULTS'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0302372f09956a0e$export$ea3803e2a45d21c4, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $0302372f09956a0e$var$wrapperStyles
    }, emptyStateMessage);
};
const $0302372f09956a0e$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0302372f09956a0e$var$emptyWrapperStyles
    }, children);
const $0302372f09956a0e$var$emptyWrapperStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '400px',
    padding: 'space.300',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER,
    borderRadius: 'border.radius.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0302372f09956a0e$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _19pku2gc",
            __cmplp.className
        ])
    });
});
const $0302372f09956a0e$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0302372f09956a0e$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.1000',
    paddingTop: 'space.800',
    width: '100%'
});

});
parcelRegister("kiBzn", function(module, exports) {

$parcel$export(module.exports, "ThemedFilterEmptyState", () => $a505eae840e121fb$export$e911425bb76dd69e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $ji3xf = parcelRequire("ji3xf");
var $7c3W1 = parcelRequire("7c3W1");

var $lGiWG = parcelRequire("lGiWG");

var $kar7l = parcelRequire("kar7l");
parcelRequire("hgbp4");
var $e9Rfo = parcelRequire("e9Rfo");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $dG4cR = parcelRequire("dG4cR");

var $9rrf5 = parcelRequire("9rrf5");
const $a505eae840e121fb$export$e911425bb76dd69e = ({ reason: reason })=>{
    // @ts-expect-error - TS2339 - Property 'updateQueryParam' does not exist on type 'BoundActions<EntireRouterState, PublicRouterActions>'.
    const { updateQueryParam: updateQueryParam } = (0, $kJlBc.useRouterActions)();
    const [, setFilters] = (0, $7c3W1.useViewPreference)((0, $ji3xf.FILTER_PREFERENCE));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        // persist that the user has cleared filters in view preferences
        // but do not push the change to the URL as we're already pushing a history state
        // to clear both filters and simple search below
        setFilters(undefined, 'none');
        updateQueryParam({
            filter: undefined,
            quickFilters: undefined,
            [(0, $dG4cR.SIMPLE_SEARCH_PARAM)]: undefined
        }, 'push');
    }, [
        updateQueryParam,
        setFilters
    ]);
    const message = reason === 'INVALID_JQL' ? formatMessage((0, $9rrf5.default).invalidStateHeading) : formatMessage((0, $9rrf5.default).emptyStateHeading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a505eae840e121fb$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e9Rfo))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a505eae840e121fb$var$HeadingWrapper, null, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        appearance: "primary",
        onClick: handleOnClear
    }, formatMessage((0, $9rrf5.default).clearFiltersButton)));
};
const $a505eae840e121fb$var$wrapperStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center',
    margin: 'auto',
    width: '450px',
    padding: 'space.300',
    borderRadius: 'border.radius.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $kar7l.Tokens).ELEVATION_SURFACE_CONTRAST_BOLDER
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a505eae840e121fb$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1c2q _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $a505eae840e121fb$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1yk2 _4t3i13i4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lGiWG", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $3bf493f9be098b31$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");
const $3bf493f9be098b31$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, ...props }, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3bf493f9be098b31$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf493f9be098b31$var$CustomButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7opLA.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e9Rfo")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $i647H = parcelRequire("i647H");

var $e9Rfo = parcelRequire("e9Rfo");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e9Rfo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($i647H))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("i647H", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("e9Rfo", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("9rrf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8fd0b56fda09200$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d8fd0b56fda09200$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "business-filters.themed-filter-empty-state.empty-state-heading",
        "defaultMessage": "It looks like we can't find any results that match."
    },
    invalidStateHeading: {
        "id": "business-filters.themed-filter-empty-state.invalid-state-heading",
        "defaultMessage": "We can't handle the current filters, please clear to continue."
    },
    clearFiltersButton: {
        "id": "business-filters.themed-filter-empty-state.clear-filters-button",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("kny42", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e7b4247c210c8f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7e7b4247c210c8f4$var$Illustration = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("bkiHG")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/empty-state/illustration/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7e7b4247c210c8f4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-list-empty-state",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e7b4247c210c8f4$var$Illustration, null));

});
parcelRegister("bkiHG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dlpQn');
        const value = parcelRequire('3Grbf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dlpQn").then(()=>parcelRequire('3Grbf'));
}

});


parcelRegister("j1jCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e2299a4687208f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $88e2299a4687208f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateHeading: {
        "id": "business-list.list-view.empty-state.empty-state-heading",
        "defaultMessage": "View your work in a list"
    },
    emptyStateDescription: {
        "id": "business-list.list-view.empty-state.empty-state-description",
        "defaultMessage": "Manage and sort all your project\u2019s work into a single list that can be easily scanned and sorted by category."
    },
    createItemButton: {
        "id": "business-list.list-view.empty-state.create-item-button",
        "defaultMessage": "Create an item"
    },
    createIssueButton: {
        "id": "business-list.list-view.empty-state.create-issue-button",
        "defaultMessage": "Create issue"
    }
});

});


parcelRegister("aiXUL", function(module, exports) {

$parcel$export(module.exports, "GroupItem", () => $f1c34fcc4c23ae95$export$3142cb2f1b79aeb9);

var $eUqFw = parcelRequire("eUqFw");

var $gZpkQ = parcelRequire("gZpkQ");

var $ef5z4 = parcelRequire("ef5z4");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $2jrDX = parcelRequire("2jrDX");

var $9yV1c = parcelRequire("9yV1c");

var $9w3zf = parcelRequire("9w3zf");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");

var $8gkkx = parcelRequire("8gkkx");

var $l7wqg = parcelRequire("l7wqg");

var $dTdQF = parcelRequire("dTdQF");

var $kavY4 = parcelRequire("kavY4");

var $1CxqB = parcelRequire("1CxqB");

var $6dZjh = parcelRequire("6dZjh");

var $6SYWA = parcelRequire("6SYWA");

var $fOYLV = parcelRequire("fOYLV");

var $ex5gB = parcelRequire("ex5gB");

var $5m7NF = parcelRequire("5m7NF");

var $60YYZ = parcelRequire("60YYZ");
const $f1c34fcc4c23ae95$var$GroupItemRenderer = ({ field: field, data: data })=>{
    switch(field.__typename){
        case 'JiraSingleSelectUserPickerField':
            if (field.type === (0, $lO4Or.ASSIGNEE_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7wqg.AssigneeItem), {
                data: data
            });
            return null;
        case 'GenericIssueField':
            if (field.type === (0, $lO4Or.STATUS_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ex5gB.StatusItem), {
                data: data
            });
            return null;
        case 'JiraPriorityField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dZjh.PriorityItem), {
                data: data
            });
        case 'JWMCategoryField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTdQF.CategoryItem), {
                data: data
            });
        case 'JiraNumberField':
            if (field.aliasFieldId === 'storypoints') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5m7NF.StoryPointsItem), {
                value: data.storypoints
            });
            if (field.aliasFieldId === 'storypointestimate') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5m7NF.StoryPointsItem), {
                value: data.storypointestimate
            });
            return null;
        case 'JiraSprintField':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fOYLV.SprintItem), {
                data: data
            });
        default:
            return null;
    }
};
const $f1c34fcc4c23ae95$export$3142cb2f1b79aeb9 = /*#__PURE__*/ (0, $eUqFw.memo)(({ data: data, rowIndex: rowIndex, canCreateIssues: canCreateIssues })=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const [, setHideDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const issueId = (0, $6vrw7.toIssueId)(data.issueId);
    const totalGroupItems = data.childSummary?.totalCount ?? 0;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ expandedItems: expandedGroups, hierarchyData: { loading: loading } }, { setExpandedItems: setGroupExpanded }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ shouldExpandAllItems: shouldExpandAllItems }, { disableExpandCollapseAllItems: disableExpandCollapseAllItems }] = (0, $9yV1c.useExpandCollapseAllItems)({
        view: 'list'
    });
    const [, { setRowCreatePosition: setRowCreatePosition }] = (0, $8gkkx.useRowCreateStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    const categoryFieldId = availableFields.find((fieldItem)=>fieldItem.type === (0, $lO4Or.CATEGORY_TYPE))?.id;
    const field = (0, $9w3zf.useGetGroupByField)();
    const onExpand = (0, $eUqFw.useCallback)(()=>{
        const isExpanded = Boolean(expandedGroups[issueId]);
        const isStatusGroup = groupByFieldId === (0, $lO4Or.STATUS_TYPE);
        const isDoneStatus = // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string' and 'number' have no overlap.
        data.status?.categoryId === (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).DONE];
        // show done items when expanding the done status group
        if (isStatusGroup && isDoneStatus && !isExpanded) setHideDoneItems(false);
        if (isExpanded && shouldExpandAllItems) disableExpandCollapseAllItems();
        setGroupExpanded(issueId, !isExpanded);
    }, [
        data,
        disableExpandCollapseAllItems,
        expandedGroups,
        groupByFieldId,
        issueId,
        setGroupExpanded,
        setHideDoneItems,
        shouldExpandAllItems
    ]);
    const handleAddInlineCreateRow = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        setRowCreatePosition({
            parentId: String(issueId)
        });
        if (setGroupExpanded) setGroupExpanded(issueId, true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowCreateGroupItemIcon', {
            groupByFieldId: groupByFieldId
        });
    }, [
        setRowCreatePosition,
        issueId,
        setGroupExpanded,
        createAnalyticsEvent,
        groupByFieldId
    ]);
    const checkIfHasIssueCreation = (0, $ef5z4.useCanCreateIssueInStatus)();
    const canInlineCreate = (0, $eUqFw.useMemo)(()=>{
        if (!canCreateIssues) return false;
        if (groupByFieldId !== (0, $lO4Or.STATUS_TYPE)) return true;
        const statusId = data.status?.id && (0, $huI7r.getAriConfig)(data.status.id).resourceId;
        if (!statusId) return false;
        return checkIfHasIssueCreation(statusId);
    }, [
        canCreateIssues,
        checkIfHasIssueCreation,
        data.status,
        groupByFieldId
    ]);
    const CreateIssueComponent = (0, $eUqFw.useMemo)(()=>canInlineCreate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.CreateIssuePlusButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jrDX.default), {
            tooltip: formatMessage((0, $1CxqB.default).createIssue),
            label: formatMessage((0, $1CxqB.default).addGroupItem),
            onClick: handleAddInlineCreateRow,
            shouldDisplayBtn: true
        })), [
        canInlineCreate,
        formatMessage,
        handleAddInlineCreateRow
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingRow), {
        key: "loading-grouping-header-row",
        "data-testid": "business-list.ui.list-view.group-item.loading-row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingWrapper), {
        key: data.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.LoadingField), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SYWA.SelectGroupCheckbox), {
        group: data,
        rowIndex: rowIndex
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60YYZ.GroupContainer), null, totalGroupItems > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kavY4.ExpandIcon), {
        onClick: onExpand,
        totalGroupItems: totalGroupItems,
        rowIndex: rowIndex,
        expanded: expandedGroups[issueId] === true
    }), field ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f1c34fcc4c23ae95$var$GroupItemRenderer, {
        field: field,
        data: data
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, groupByFieldId === (0, $lO4Or.ASSIGNEE_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7wqg.AssigneeItem), {
        data: data
    }), groupByFieldId === (0, $lO4Or.STATUS_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ex5gB.StatusItem), {
        data: data
    }), groupByFieldId === (0, $lO4Or.PRIORITY_TYPE) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dZjh.PriorityItem), {
        data: data
    }), groupByFieldId === categoryFieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTdQF.CategoryItem), {
        data: data
    })), CreateIssueComponent));
});

});
parcelRegister("ef5z4", function(module, exports) {

$parcel$export(module.exports, "useCanCreateIssueInStatus", () => $24564dd80699b178$export$efe8838d1712139f);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $c7wtc = parcelRequire("c7wtc");
const $24564dd80699b178$export$efe8838d1712139f = ()=>{
    const workflows = (0, $c7wtc.useWorkflows)();
    const project = (0, $kQAZu.useProject)();
    return (0, $eUqFw.useCallback)((statusId, workflow = null)=>{
        if (!workflows) return false;
        const eligibleWorkflows = workflow != null ? [
            workflow
        ] : workflows.filter((w)=>w.issueTypes.some((it)=>it.hierarchyLevel >= 0));
        // we want to show the create button on the group if it can:
        // - be created from the initial transition,
        // - OR if it has a global transition leading to it
        //      AND the transition isn't conditional
        //      AND the user is allowed to transition issues
        return eligibleWorkflows.some((w)=>w.transitions.some((transition)=>transition.to.statusId === statusId && (transition.isInitial || transition.isGlobal && !transition.isConditional && project.permissions.transitionIssues)));
    }, [
        project,
        workflows
    ]);
};

});

parcelRegister("2jrDX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5945efd4865c984a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gO9Xw = parcelRequire("gO9Xw");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $gbsaq = parcelRequire("gbsaq");
var $5945efd4865c984a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5945efd4865c984a$var$ChildCreateButtonWrapper, {
        id: (0, $gbsaq.CHILD_CREATE_BTN_WRAPPER),
        shouldDisplayBtn: props.shouldDisplayBtn,
        "data-testid": "business-list.common.ui.create-issue-plus-button.child-create-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5945efd4865c984a$var$ChildCreateButton, {
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: props.label,
        size: "small"
    })))));
const $5945efd4865c984a$var$BUTTON_SIZE = 2 * (0, $c9TLT.gridSize);
const $5945efd4865c984a$var$ICON_SIZE = 12;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5945efd4865c984a$var$ChildCreateButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb7vkz _4t3i7vkz _2rko1sit _s7n4jp4b _bfhkiw92 _syaz10s3 _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _11r712vo _e2oo1crf _1xjx1crf _z2391qo1 _19y510s3 _16uvt94y _jomr74gs _irr374gs _1di6uh8s _9h8h705v",
            __cmplp.className
        ])
    });
});
const $5945efd4865c984a$var$ChildCreateButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldDisplayBtn: shouldDisplayBtn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldDisplayBtn ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9yV1c", function(module, exports) {

$parcel$export(module.exports, "useExpandCollapseAllItems", () => $b732dae86109b3aa$export$38cfcb71ce0d3b89);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $b732dae86109b3aa$var$actions = {
    toggleExpanding: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: !state[view].shouldExpandAllItems,
                    shouldCollapseAllItems: false
                }
            });
        },
    setCollapsing: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: false,
                    shouldCollapseAllItems: true
                }
            });
        },
    disableExpandCollapse: (view)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    shouldExpandAllItems: false,
                    shouldCollapseAllItems: false
                }
            });
        },
    setHasExpandedAllItems: (view, hasExpanded)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    hasExpandedAllItems: hasExpanded
                }
            });
        },
    setHasCollapsedAllItems: (view, hasCollapsed)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                [view]: {
                    ...state[view],
                    hasCollapsedAllItems: hasCollapsed
                }
            });
        }
};
const $b732dae86109b3aa$var$Store = (0, $a61MH.createStore)({
    initialState: {
        list: {
            shouldExpandAllItems: false,
            shouldCollapseAllItems: false,
            hasExpandedAllItems: false,
            hasCollapsedAllItems: false
        },
        timeline: {
            shouldExpandAllItems: false,
            shouldCollapseAllItems: false,
            hasExpandedAllItems: false,
            hasCollapsedAllItems: false
        }
    },
    actions: $b732dae86109b3aa$var$actions,
    name: 'JWMExpandCollapseStore'
});
const $b732dae86109b3aa$var$useHook = (0, $ggKAj.createHook)($b732dae86109b3aa$var$Store);
const $b732dae86109b3aa$export$38cfcb71ce0d3b89 = ({ view: view, onCollapse: onCollapse })=>{
    const [state, { toggleExpanding: toggleExpanding, setCollapsing: setCollapsing, disableExpandCollapse: disableExpandCollapse, setHasExpandedAllItems: setHasExpandedAllItems, setHasCollapsedAllItems: setHasCollapsedAllItems }] = $b732dae86109b3aa$var$useHook();
    const { shouldExpandAllItems: shouldExpandAllItems, shouldCollapseAllItems: shouldCollapseAllItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems } = state[view];
    const toggleExpandingForView = (0, $eUqFw.useCallback)(()=>toggleExpanding(view), [
        toggleExpanding,
        view
    ]);
    const setCollapsingForView = (0, $eUqFw.useCallback)(()=>setCollapsing(view), [
        setCollapsing,
        view
    ]);
    const setHasCollapsedAllItemsForView = (0, $eUqFw.useCallback)((hasCollapsed)=>setHasCollapsedAllItems(view, hasCollapsed), [
        setHasCollapsedAllItems,
        view
    ]);
    const setHasExpandedAllItemsForView = (0, $eUqFw.useCallback)((hasExpanded)=>setHasExpandedAllItems(view, hasExpanded), [
        setHasExpandedAllItems,
        view
    ]);
    const disableExpandCollapseForView = (0, $eUqFw.useCallback)(()=>disableExpandCollapse(view), [
        disableExpandCollapse,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onCollapse && shouldCollapseAllItems) {
            onCollapse();
            disableExpandCollapseForView();
        }
    }, [
        disableExpandCollapseForView,
        onCollapse,
        shouldCollapseAllItems
    ]);
    return [
        {
            shouldExpandAllItems: shouldExpandAllItems,
            shouldCollapseAllItems: shouldCollapseAllItems,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems
        },
        {
            toggleExpandAllItems: toggleExpandingForView,
            collapseAllItems: setCollapsingForView,
            disableExpandCollapseAllItems: disableExpandCollapseForView,
            setHasExpandedAllItems: setHasExpandedAllItemsForView,
            setHasCollapsedAllItems: setHasCollapsedAllItemsForView
        }
    ];
};

});

parcelRegister("9w3zf", function(module, exports) {

$parcel$export(module.exports, "useGetGroupByField", () => $281c588fb60f53d7$export$7a0354af7d69ba55);

var $jGcn0 = parcelRequire("jGcn0");

var $4S5hf = parcelRequire("4S5hf");

var $lO4Or = parcelRequire("lO4Or");

var $hHiDc = parcelRequire("hHiDc");

var $dSE3z = parcelRequire("dSE3z");
const $281c588fb60f53d7$export$1aef70471c979441 = (field)=>field.type === (0, $lO4Or.CATEGORY_TYPE);
const $281c588fb60f53d7$export$48f560f91a048a7f = (field)=>field.type === (0, $lO4Or.NUMBER_CF_TYPE) && field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID);
const $281c588fb60f53d7$export$8b6cfed4387d2f77 = (field)=>field.type === (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE);
const $281c588fb60f53d7$export$ea68dd9055d500e2 = (field)=>field.type === (0, $lO4Or.SPRINT_TYPE);
const $281c588fb60f53d7$export$7a0354af7d69ba55 = ()=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const availableFields = getAvailableFields();
    const { data: categoryField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$1aef70471c979441);
    const { data: storyPointsField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$48f560f91a048a7f);
    const { data: storyPointEstimateField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$8b6cfed4387d2f77);
    const { data: sprintField } = (0, $4S5hf.useFindField)($281c588fb60f53d7$export$ea68dd9055d500e2);
    switch(groupByFieldId){
        case categoryField?.id:
            return categoryField;
        case storyPointsField?.id:
            return storyPointsField;
        case storyPointEstimateField?.id:
            return storyPointEstimateField;
        case sprintField?.id:
            return sprintField;
        default:
            return availableFields.find((availableField)=>availableField.type === groupByFieldId);
    }
};

});

parcelRegister("l7wqg", function(module, exports) {

$parcel$export(module.exports, "AssigneeItem", () => $c9646e4c044d1fd0$export$be57e3a2d4264803);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $gjzML = parcelRequire("gjzML");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8UbeN = parcelRequire("8UbeN");

var $b6Z7z = parcelRequire("b6Z7z");
const $c9646e4c044d1fd0$export$be57e3a2d4264803 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isUnassigned = !data.assignee;
    const unassignedDisplayName = formatMessage((0, $b6Z7z.default).unassignedDisplayName);
    const displayName = isUnassigned ? unassignedDisplayName : data.assignee?.displayName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isUnassigned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        src: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjzML.AvatarLite), {
        avatarUrl: data.assignee?.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.DisplayName), null, displayName));
};

});
parcelRegister("gjzML", function(module, exports) {

$parcel$export(module.exports, "AvatarLite", () => $1d0a2d9cba4728c5$export$8b9560cc4e12c651);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1d0a2d9cba4728c5$var$AVATAR_SIZE = 24;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d0a2d9cba4728c5$var$Avatar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { avatarUrl: avatarUrl, isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fzlxay": (0, $9t7rW.default)(`url(${__cmplp.avatarUrl})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itk1v7f _ouxl1ssb _12vemgnk _1lrw1dfr _bfhk18uv _2rko1ssb _vchh18uv _4t3i1tcg _1bsb1tcg _1ul91tcg _1tke1tcg _1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _80om1kw7 _18s8v77o",
            __cmplp.isHighlighted ? "_16qs7aa6" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $1d0a2d9cba4728c5$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $1d0a2d9cba4728c5$export$8b9560cc4e12c651 = /*#__PURE__*/ (0, $eUqFw.memo)(({ avatarUrl: avatarUrl, name: name = '', highlight: highlight, testId: testId })=>{
    const isHighlighted = highlight && highlight.some($1d0a2d9cba4728c5$var$hasKeywords(name));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d0a2d9cba4728c5$var$Avatar, {
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        avatarUrl: avatarUrl,
        title: name,
        // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
        isHighlighted: isHighlighted,
        "data-testid": testId
    });
});

});

parcelRegister("8UbeN", function(module, exports) {

$parcel$export(module.exports, "WrapperCommon", () => $ee6ba19431b45a72$export$2cd335d97b9054d6);
$parcel$export(module.exports, "CellWrapper", () => $ee6ba19431b45a72$export$4812fadef83edffe);
$parcel$export(module.exports, "CellContentContainer", () => $ee6ba19431b45a72$export$bd476b087602e432);
$parcel$export(module.exports, "CellContainer", () => $ee6ba19431b45a72$export$287da707e3318210);
$parcel$export(module.exports, "CellContentWrapper", () => $ee6ba19431b45a72$export$f76c50a859269a04);
$parcel$export(module.exports, "TextFieldWrapper", () => $ee6ba19431b45a72$export$e6dcd4f050b24d88);
$parcel$export(module.exports, "AvatarItem", () => $ee6ba19431b45a72$export$15f08c141eda7939);
$parcel$export(module.exports, "DisplayName", () => $ee6ba19431b45a72$export$101fbca3a406e1fd);
$parcel$export(module.exports, "EmptyCellContent", () => $ee6ba19431b45a72$export$78bba2733575aa77);
$parcel$export(module.exports, "Container", () => $ee6ba19431b45a72$export$42a852a2b6b56249);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $ee6ba19431b45a72$export$95bfdfec8f6b837d = 2;
const $ee6ba19431b45a72$export$e643c5fb607dbcc5 = `0 0 0 ${$ee6ba19431b45a72$export$95bfdfec8f6b837d}px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`} inset`;
const $ee6ba19431b45a72$export$85e848b114283663 = 160;
const $ee6ba19431b45a72$export$df441c04a8cf98f7 = 40;
const $ee6ba19431b45a72$export$2cd335d97b9054d6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$4812fadef83edffe = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $ee6ba19431b45a72$export$2cd335d97b9054d6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _2rko1sit _19bvu2gc",
            __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$bd476b087602e432 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_g3ey1q": (0, $9t7rW.default)(__cmplp.width - ((0, $c9TLT.gridSize) * 3 + $ee6ba19431b45a72$export$95bfdfec8f6b837d * 2), "px"),
            "--_1nq8131": (0, $9t7rW.default)(__cmplp.height - $ee6ba19431b45a72$export$95bfdfec8f6b837d * 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _1bsb6uc2 _4t3i4226",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$287da707e3318210 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _p7r11txw _dzc21h6o _bhl9upfu _k8em1osq _bd9w1r31 _ezapglyw _1qzf1o36 _zbayglpi",
            __cmplp.isFocused ? "_bp7o179s" : "_bp7oglyw",
            __cmplp.isFocused ? "_1gzevuon" : "_1gze18uv",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$f76c50a859269a04 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { preferredWidth: preferredWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfanob": (0, $9t7rW.default)(__cmplp.preferredWidth, "px"),
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1rw8 _1ul91178 _1p3lidpf _13ce179s",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$e6dcd4f050b24d88 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, isEditable: isEditable, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)($ee6ba19431b45a72$export$e643c5fb607dbcc5)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _2rkoglpi _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _cj13v77o _1v5nidpf _qbsg179s _1yds1osq _kgm11cy0 _17kn15vq _1hrp15vq _x3fa1l2s",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.isEditable ?? true ? "_80om1kdv" : "_80om73ad",
            __cmplp.isSelected || __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$15f08c141eda7939 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isUnassigned: isUnassigned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1reo15vq _18m915vq _o5721q9c _1bsb1osq _4t3imslj _16l4kb7n",
            __cmplp.isUnassigned ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.isUnassigned ? "_syaz1e9r" : "_syaz1kw7",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$export$78bba2733575aa77 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1e9r _lcxvglyw _12qeu2gc",
            __cmplp.className
        ])
    });
});
const $ee6ba19431b45a72$var$containerBaseStyles = null;
const $ee6ba19431b45a72$var$containerMenuOpenStyles = null;
const $ee6ba19431b45a72$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, isMenuOpen: isMenuOpen, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: width ? `${width}px` : '100%'
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq _2rko1hkb _80omtlke _bfhk18uv _19bvu2gc _16qsglyw",
            isMenuOpen && "_bfhkvuon _19bvze3t _16qs1f5q"
        ])
    }, children));

});

parcelRegister("b6Z7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $724195363e48e1cb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $724195363e48e1cb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedDisplayName: {
        "id": "business-list.list-view.group-item.assignee-item.unassigned-display-name",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("dTdQF", function(module, exports) {

$parcel$export(module.exports, "CategoryItem", () => $dec77a362bbe0ee4$export$41d1d7fbacf843);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $MxsGB = parcelRequire("MxsGB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3SBWf = parcelRequire("3SBWf");
const $dec77a362bbe0ee4$export$41d1d7fbacf843 = /*#__PURE__*/ (0, $eUqFw.memo)(({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return data.category?.name != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $MxsGB.default), {
        categoryColor: data.category.color,
        categoryName: data.category.name,
        isInteractive: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dec77a362bbe0ee4$var$UncategorizedLabel, null, formatMessage((0, $3SBWf.default).noCategory));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dec77a362bbe0ee4$var$UncategorizedLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz14xw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("MxsGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $575c3f5934e57f5b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $k7FjW = parcelRequire("k7FjW");
const $575c3f5934e57f5b$var$CategoryTag = ({ categoryName: categoryName, categoryColor: categoryColor, isInteractive: isInteractive = true })=>{
    const { textColor: textColor, backgroundColor: backgroundColor } = (0, $k7FjW.getColorMetadata)(categoryColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$CategoryTagWrapper, {
        isInteractive: isInteractive,
        textColor: textColor,
        "aria-label": categoryName,
        "data-testid": "business-categories.ui.category-form.category-tag.category-tag-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($575c3f5934e57f5b$var$StyledTag, {
        color: backgroundColor
    }, categoryName));
};
var $575c3f5934e57f5b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($575c3f5934e57f5b$var$CategoryTag);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $575c3f5934e57f5b$var$CategoryTagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textColor: textColor, isInteractive: isInteractive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlcdp": (0, $9t7rW.default)(__cmplp.textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bah1e5h _4cvr1h6o _v564188d _p12f1osq _1ul9idpf _1tkeidpf _syazijt0",
            __cmplp.isInteractive ? "_d0altlke" : "_d0al73ad",
            __cmplp.className
        ])
    });
});
const $575c3f5934e57f5b$var$StyledTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoiti9 _bfhk1cj8 _1yt41b66 _1wybdlk8 _k48p1nn1 _vwz4dlk8 _1bto1l2s _o5721q9c _1reo15vq _18m915vq _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k7FjW", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $0ce9d8c1415fa16c$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $0ce9d8c1415fa16c$export$49fce7fdcf55f26d);

var $fwFhq = parcelRequire("fwFhq");
const $0ce9d8c1415fa16c$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $fwFhq.CATEGORY_THEMES).length);
    return (0, $fwFhq.CATEGORY_THEMES)[randomIndex].name;
};
const $0ce9d8c1415fa16c$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $0ce9d8c1415fa16c$export$9eff62e8ee2aaa2c = (colorName)=>(0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName)?.backgroundColor ?? '';
const $0ce9d8c1415fa16c$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $fwFhq.GREY_LIGHTEST_META;
    return (0, $fwFhq.CATEGORY_THEMES).find((item)=>item.name === colorName) ?? (0, $fwFhq.GREY_LIGHTEST_META);
};
const $0ce9d8c1415fa16c$export$4ef6b7574883e63d = ()=>(0, $fwFhq.CATEGORY_THEMES).map((item)=>item.name);

});
parcelRegister("fwFhq", function(module, exports) {

$parcel$export(module.exports, "GREY_LIGHTEST_META", () => $592872c1ad972acf$export$cb19a604bb399a88);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $592872c1ad972acf$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $592872c1ad972acf$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "CATEGORY_THEMES", () => $592872c1ad972acf$export$845e69f3af4133a6);

var $PdmhA = parcelRequire("PdmhA");

var $jwyl8 = parcelRequire("jwyl8");

var $kzlGv = parcelRequire("kzlGv");
const $592872c1ad972acf$export$cb19a604bb399a88 = {
    name: 'GREY_LIGHTEST',
    backgroundColor: `var(--ds-background-neutral, ${$jwyl8.N100})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $PdmhA).N900})`,
    messageLabel: (0, $kzlGv.default).greyLightest
};
const $592872c1ad972acf$export$7c3ad8ed1eaec359 = {
    name: 'GREY_LIGHTER',
    backgroundColor: `var(--ds-background-neutral-hovered, ${$jwyl8.N200})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $PdmhA).N900})`,
    messageLabel: (0, $kzlGv.default).greyLighter
};
const $592872c1ad972acf$export$11b75436f568ab00 = {
    name: 'GREY',
    backgroundColor: `var(--ds-background-neutral-pressed, ${$jwyl8.N300})`,
    textColor: `var(--ds-text-accent-gray-bolder, ${(0, $PdmhA).N900})`,
    messageLabel: (0, $kzlGv.default).grey
};
const $592872c1ad972acf$export$680a025ac49fcedd = {
    name: 'GREY_DARKER',
    backgroundColor: `var(--ds-background-neutral-bold, ${$jwyl8.N400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarker
};
const $592872c1ad972acf$export$c63acd769779da32 = {
    name: 'GREY_DARKEST',
    backgroundColor: `var(--ds-background-neutral-bold-pressed, ${$jwyl8.N500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greyDarkest
};
const $592872c1ad972acf$export$d6bc0064d6a00b4b = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-purple-subtlest, ${$jwyl8.P100})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLightest
};
const $592872c1ad972acf$export$7a53a04457b57cc7 = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-purple-subtler, ${$jwyl8.P200})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purpleLighter
};
const $592872c1ad972acf$export$d6f3928d12bf329c = {
    name: 'PURPLE',
    backgroundColor: `var(--ds-background-accent-purple-subtle, ${$jwyl8.P300})`,
    textColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    messageLabel: (0, $kzlGv.default).purple
};
const $592872c1ad972acf$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: `var(--ds-text-accent-purple, ${$jwyl8.P400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarker
};
const $592872c1ad972acf$export$5e3ecd219265b1d5 = {
    name: 'PURPLE_DARKEST',
    backgroundColor: `var(--ds-text-accent-purple-bolder, ${$jwyl8.P500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).purpleDarkest
};
const $592872c1ad972acf$export$4b98b31eae42f719 = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-blue-subtlest, ${$jwyl8.B100})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLightest
};
const $592872c1ad972acf$export$e92a5b8219b97745 = {
    name: 'BLUE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-blue-subtler, ${$jwyl8.B200})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blueLighter
};
const $592872c1ad972acf$export$b761714c24fd7f1c = {
    name: 'BLUE',
    backgroundColor: `var(--ds-background-accent-blue-subtle, ${$jwyl8.B300})`,
    textColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    messageLabel: (0, $kzlGv.default).blue
};
const $592872c1ad972acf$export$50b37b24459ab9d9 = {
    name: 'BLUE_DARKER',
    backgroundColor: `var(--ds-text-accent-blue, ${$jwyl8.B400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarker
};
const $592872c1ad972acf$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: `var(--ds-text-accent-blue-bolder, ${$jwyl8.B500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).blueDarkest
};
const $592872c1ad972acf$export$1fe5b156c0ba3acb = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-teal-subtlest, ${$jwyl8.T100})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLightest
};
const $592872c1ad972acf$export$fb40f4c2f659b9bb = {
    name: 'TEAL_LIGHTER',
    backgroundColor: `var(--ds-background-accent-teal-subtler, ${$jwyl8.T200})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).tealLighter
};
const $592872c1ad972acf$export$d177e878b5837287 = {
    name: 'TEAL',
    backgroundColor: `var(--ds-background-accent-teal-subtle, ${$jwyl8.T300})`,
    textColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    messageLabel: (0, $kzlGv.default).teal
};
const $592872c1ad972acf$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: `var(--ds-text-accent-teal, ${$jwyl8.T400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarker
};
const $592872c1ad972acf$export$fc1c501cf599d75a = {
    name: 'TEAL_DARKEST',
    backgroundColor: `var(--ds-text-accent-teal-bolder, ${$jwyl8.T500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).tealDarkest
};
const $592872c1ad972acf$export$d977521f30fbcdeb = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-green-subtlest, ${$jwyl8.G100})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLightest
};
const $592872c1ad972acf$export$911ea8fce963369 = {
    name: 'GREEN_LIGHTER',
    backgroundColor: `var(--ds-background-accent-green-subtler, ${$jwyl8.G200})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).greenLighter
};
const $592872c1ad972acf$export$814f677491d6ea0d = {
    name: 'GREEN',
    backgroundColor: `var(--ds-background-accent-green-subtle, ${$jwyl8.G300})`,
    textColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    messageLabel: (0, $kzlGv.default).green
};
const $592872c1ad972acf$export$376a849da12d546d = {
    name: 'GREEN_DARKER',
    backgroundColor: `var(--ds-background-accent-green-bolder, ${$jwyl8.G400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarker
};
const $592872c1ad972acf$export$808ba7d394e8f2c4 = {
    name: 'GREEN_DARKEST',
    backgroundColor: `var(--ds-text-accent-green-bolder, ${$jwyl8.G500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).greenDarkest
};
const $592872c1ad972acf$export$46ad9119b0fbf094 = {
    name: 'LIME_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-lime-subtlest, ${$jwyl8.L100})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLightest
};
const $592872c1ad972acf$export$e5e5e485aa3ce630 = {
    name: 'LIME_LIGHTER',
    backgroundColor: `var(--ds-background-accent-lime-subtler, ${$jwyl8.L200})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).limeLighter
};
const $592872c1ad972acf$export$166a57cda148857c = {
    name: 'LIME',
    backgroundColor: `var(--ds-background-accent-lime-subtle, ${$jwyl8.L300})`,
    textColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    messageLabel: (0, $kzlGv.default).lime
};
const $592872c1ad972acf$export$40663533c0b649cc = {
    name: 'LIME_DARKER',
    backgroundColor: `var(--ds-text-accent-lime, ${$jwyl8.L400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarker
};
const $592872c1ad972acf$export$78557ba4a4ffc502 = {
    name: 'LIME_DARKEST',
    backgroundColor: `var(--ds-text-accent-lime-bolder, ${$jwyl8.L500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).limeDarkest
};
const $592872c1ad972acf$export$12021cfc394e311e = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${$jwyl8.Y100})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLightest
};
const $592872c1ad972acf$export$eab7ec7309efe3db = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: `var(--ds-background-accent-yellow-subtler, ${$jwyl8.Y200})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellowLighter
};
const $592872c1ad972acf$export$8d5b340327da7fa3 = {
    name: 'YELLOW',
    backgroundColor: `var(--ds-background-accent-yellow-subtle, ${$jwyl8.Y300})`,
    textColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    messageLabel: (0, $kzlGv.default).yellow
};
const $592872c1ad972acf$export$b0a7a0813708318e = {
    name: 'YELLOW_DARKER',
    backgroundColor: `var(--ds-text-accent-yellow, ${$jwyl8.Y400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarker
};
const $592872c1ad972acf$export$dde9759b2d3b0e02 = {
    name: 'YELLOW_DARKEST',
    backgroundColor: `var(--ds-text-accent-yellow-bolder, ${$jwyl8.Y500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).yellowDarkest
};
const $592872c1ad972acf$export$4718b8cf3799954b = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-orange-subtlest, ${$jwyl8.O100})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLightest
};
const $592872c1ad972acf$export$8fac1fdda0aa4e41 = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: `var(--ds-background-accent-orange-subtler, ${$jwyl8.O200})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orangeLighter
};
const $592872c1ad972acf$export$2efe350451bcec02 = {
    name: 'ORANGE',
    backgroundColor: `var(--ds-background-accent-orange-subtle, ${$jwyl8.O300})`,
    textColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    messageLabel: (0, $kzlGv.default).orange
};
const $592872c1ad972acf$export$5ba9bd795da8d7d5 = {
    name: 'ORANGE_DARKER',
    backgroundColor: `var(--ds-background-accent-orange-bolder, ${$jwyl8.O400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarker
};
const $592872c1ad972acf$export$93a7b89503a97d81 = {
    name: 'ORANGE_DARKEST',
    backgroundColor: `var(--ds-text-accent-orange-bolder, ${$jwyl8.O500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).orangeDarkest
};
const $592872c1ad972acf$export$56873b0b30501dbe = {
    name: 'RED_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-red-subtlest, ${$jwyl8.R100})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLightest
};
const $592872c1ad972acf$export$344aa49a80760380 = {
    name: 'RED_LIGHTER',
    backgroundColor: `var(--ds-background-accent-red-subtler, ${$jwyl8.R200})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).redLighter
};
const $592872c1ad972acf$export$c760bedaf9085f90 = {
    name: 'RED',
    backgroundColor: `var(--ds-background-accent-red-subtle, ${$jwyl8.R300})`,
    textColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).red
};
const $592872c1ad972acf$export$38493b731be63d77 = {
    name: 'RED_DARKER',
    backgroundColor: `var(--ds-background-accent-red-bolder, ${$jwyl8.R400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).redDarker
};
const $592872c1ad972acf$export$dda419d8311f8d4a = {
    name: 'RED_DARKEST',
    backgroundColor: `var(--ds-text-accent-red-bolder, ${$jwyl8.R500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).redDarkest
};
const $592872c1ad972acf$export$e0957dc0d569e65f = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: `var(--ds-background-accent-magenta-subtlest, ${$jwyl8.M100})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLightest
};
const $592872c1ad972acf$export$299af16a857bf4ca = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: `var(--ds-background-accent-magenta-subtler, ${$jwyl8.M200})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magentaLighter
};
const $592872c1ad972acf$export$d7208e47aa15bafe = {
    name: 'MAGENTA',
    backgroundColor: `var(--ds-background-accent-magenta-subtle-hovered, ${$jwyl8.M300})`,
    textColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.R500})`,
    messageLabel: (0, $kzlGv.default).magenta
};
const $592872c1ad972acf$export$b3aea5a31105d4e3 = {
    name: 'MAGENTA_DARKER',
    backgroundColor: `var(--ds-text-accent-magenta, ${$jwyl8.M400})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarker
};
const $592872c1ad972acf$export$faf43e54615bce6b = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: `var(--ds-text-accent-magenta-bolder, ${$jwyl8.M500})`,
    textColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
    messageLabel: (0, $kzlGv.default).magentaDarkest
};
const $592872c1ad972acf$export$270aee965367aeb3 = `var(--ds-text-inverse, ${(0, $PdmhA).N0})`;
const $592872c1ad972acf$export$941ef40ef5fdd2b1 = `var(--ds-text, ${(0, $PdmhA).N500})`;
const $592872c1ad972acf$export$845e69f3af4133a6 = [
    $592872c1ad972acf$export$cb19a604bb399a88,
    $592872c1ad972acf$export$d6bc0064d6a00b4b,
    $592872c1ad972acf$export$4b98b31eae42f719,
    $592872c1ad972acf$export$1fe5b156c0ba3acb,
    $592872c1ad972acf$export$d977521f30fbcdeb,
    $592872c1ad972acf$export$46ad9119b0fbf094,
    $592872c1ad972acf$export$12021cfc394e311e,
    $592872c1ad972acf$export$4718b8cf3799954b,
    $592872c1ad972acf$export$56873b0b30501dbe,
    $592872c1ad972acf$export$e0957dc0d569e65f,
    $592872c1ad972acf$export$7c3ad8ed1eaec359,
    $592872c1ad972acf$export$7a53a04457b57cc7,
    $592872c1ad972acf$export$e92a5b8219b97745,
    $592872c1ad972acf$export$fb40f4c2f659b9bb,
    $592872c1ad972acf$export$911ea8fce963369,
    $592872c1ad972acf$export$e5e5e485aa3ce630,
    $592872c1ad972acf$export$eab7ec7309efe3db,
    $592872c1ad972acf$export$8fac1fdda0aa4e41,
    $592872c1ad972acf$export$344aa49a80760380,
    $592872c1ad972acf$export$299af16a857bf4ca,
    $592872c1ad972acf$export$11b75436f568ab00,
    $592872c1ad972acf$export$d6f3928d12bf329c,
    $592872c1ad972acf$export$b761714c24fd7f1c,
    $592872c1ad972acf$export$d177e878b5837287,
    $592872c1ad972acf$export$814f677491d6ea0d,
    $592872c1ad972acf$export$166a57cda148857c,
    $592872c1ad972acf$export$8d5b340327da7fa3,
    $592872c1ad972acf$export$2efe350451bcec02,
    $592872c1ad972acf$export$c760bedaf9085f90,
    $592872c1ad972acf$export$d7208e47aa15bafe,
    $592872c1ad972acf$export$680a025ac49fcedd,
    $592872c1ad972acf$export$7c314e2461a7241b,
    $592872c1ad972acf$export$50b37b24459ab9d9,
    $592872c1ad972acf$export$6daaa1cc3f46f41,
    $592872c1ad972acf$export$376a849da12d546d,
    $592872c1ad972acf$export$40663533c0b649cc,
    $592872c1ad972acf$export$b0a7a0813708318e,
    $592872c1ad972acf$export$5ba9bd795da8d7d5,
    $592872c1ad972acf$export$38493b731be63d77,
    $592872c1ad972acf$export$b3aea5a31105d4e3,
    $592872c1ad972acf$export$c63acd769779da32,
    $592872c1ad972acf$export$5e3ecd219265b1d5,
    $592872c1ad972acf$export$69c4eac71b813fba,
    $592872c1ad972acf$export$fc1c501cf599d75a,
    $592872c1ad972acf$export$808ba7d394e8f2c4,
    $592872c1ad972acf$export$78557ba4a4ffc502,
    $592872c1ad972acf$export$dde9759b2d3b0e02,
    $592872c1ad972acf$export$93a7b89503a97d81,
    $592872c1ad972acf$export$dda419d8311f8d4a,
    $592872c1ad972acf$export$faf43e54615bce6b
];

});
parcelRegister("jwyl8", function(module, exports) {

$parcel$export(module.exports, "N100", () => $cccad9dbca818926$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $cccad9dbca818926$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $cccad9dbca818926$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $cccad9dbca818926$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $cccad9dbca818926$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "P100", () => $cccad9dbca818926$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $cccad9dbca818926$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $cccad9dbca818926$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $cccad9dbca818926$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $cccad9dbca818926$export$147899de772240ec);
$parcel$export(module.exports, "B100", () => $cccad9dbca818926$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $cccad9dbca818926$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $cccad9dbca818926$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $cccad9dbca818926$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $cccad9dbca818926$export$a6ee3d71bc067634);
$parcel$export(module.exports, "T100", () => $cccad9dbca818926$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $cccad9dbca818926$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $cccad9dbca818926$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $cccad9dbca818926$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $cccad9dbca818926$export$6036577f95c3877e);
$parcel$export(module.exports, "G100", () => $cccad9dbca818926$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $cccad9dbca818926$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $cccad9dbca818926$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $cccad9dbca818926$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $cccad9dbca818926$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "L100", () => $cccad9dbca818926$export$fbb30b762ae4fcda);
$parcel$export(module.exports, "L200", () => $cccad9dbca818926$export$f72948ef771f6f15);
$parcel$export(module.exports, "L300", () => $cccad9dbca818926$export$59d89537e7d73aa4);
$parcel$export(module.exports, "L400", () => $cccad9dbca818926$export$4b0a7cabffffd4f5);
$parcel$export(module.exports, "L500", () => $cccad9dbca818926$export$58808b1c527bd1b0);
$parcel$export(module.exports, "Y100", () => $cccad9dbca818926$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $cccad9dbca818926$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $cccad9dbca818926$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $cccad9dbca818926$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $cccad9dbca818926$export$874739ea9e379ab6);
$parcel$export(module.exports, "O100", () => $cccad9dbca818926$export$4d0048026652f54a);
$parcel$export(module.exports, "O200", () => $cccad9dbca818926$export$51716a84e62e022c);
$parcel$export(module.exports, "O300", () => $cccad9dbca818926$export$59e5b1f9a23fd718);
$parcel$export(module.exports, "O400", () => $cccad9dbca818926$export$e30ed75d70748b1);
$parcel$export(module.exports, "O500", () => $cccad9dbca818926$export$d93a44e5c84e8256);
$parcel$export(module.exports, "R100", () => $cccad9dbca818926$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $cccad9dbca818926$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $cccad9dbca818926$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $cccad9dbca818926$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $cccad9dbca818926$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "M100", () => $cccad9dbca818926$export$6755153cd35f90b1);
$parcel$export(module.exports, "M200", () => $cccad9dbca818926$export$a19f0c33186f7767);
$parcel$export(module.exports, "M300", () => $cccad9dbca818926$export$a46884cf0037b203);
$parcel$export(module.exports, "M400", () => $cccad9dbca818926$export$a1d4686c17e1cdef);
$parcel$export(module.exports, "M500", () => $cccad9dbca818926$export$16814b01d9742bf7);

var $PdmhA = parcelRequire("PdmhA");
const $cccad9dbca818926$export$d6447c357493214f = '#F0F1F4';
const $cccad9dbca818926$export$f563ee71e9ee74cd = 'rgba(9, 30, 66, 0.14)';
const $cccad9dbca818926$export$e2ef2124cf4024b1 = (0, $PdmhA).N60A;
const $cccad9dbca818926$export$eece5f492e429f08 = '#44546F';
const $cccad9dbca818926$export$c39c0fe0f26207ae = (0, $PdmhA).N800;
const $cccad9dbca818926$export$6011520a64d9a187 = '#F3F0FF';
const $cccad9dbca818926$export$a7175d4e9206bc80 = '#DFD8FD';
const $cccad9dbca818926$export$b48405b95304b5a1 = '#9F8FEF';
const $cccad9dbca818926$export$c71e4279dd54a18d = '#5E4DB2';
const $cccad9dbca818926$export$147899de772240ec = '#352C63';
const $cccad9dbca818926$export$ecfc1dff386a3e7a = '#E9F2FF';
const $cccad9dbca818926$export$215b7063051591f1 = '#CCE0FF';
const $cccad9dbca818926$export$e62e8919cca44969 = '#579DFF';
const $cccad9dbca818926$export$b3de0ae08da2ce64 = '#0055CC';
const $cccad9dbca818926$export$a6ee3d71bc067634 = '#09326C';
const $cccad9dbca818926$export$776c9c497ef08533 = '#E3FAFC';
const $cccad9dbca818926$export$69cb3ca10c1e330e = '#C1F0F5';
const $cccad9dbca818926$export$9dc1ef0f3f48059b = '#60C6D2';
const $cccad9dbca818926$export$7c835c78b6fcdef8 = '#206B74';
const $cccad9dbca818926$export$6036577f95c3877e = '#1D474C';
const $cccad9dbca818926$export$afbce1382ec95f73 = '#DFFCF0';
const $cccad9dbca818926$export$747d86715d4175de = '#BAF3DB';
const $cccad9dbca818926$export$940e1f69e873f202 = '#4BCE97';
const $cccad9dbca818926$export$a49394138f7b8e85 = '#216E4E';
const $cccad9dbca818926$export$6fa04827ac68a4fb = '#164B35';
const $cccad9dbca818926$export$fbb30b762ae4fcda = '#EEFBDA';
const $cccad9dbca818926$export$f72948ef771f6f15 = '#D3F1A7';
const $cccad9dbca818926$export$59d89537e7d73aa4 = '#94C748';
const $cccad9dbca818926$export$4b0a7cabffffd4f5 = '#4C6B1F';
const $cccad9dbca818926$export$58808b1c527bd1b0 = '#37471F';
const $cccad9dbca818926$export$1cc05bbbf340e559 = '#FFF7D6';
const $cccad9dbca818926$export$5aae31392d72caaa = (0, $PdmhA).Y75;
const $cccad9dbca818926$export$c6930421db9fa514 = '#E2B203';
const $cccad9dbca818926$export$59619663aa6500fb = '#7F5F01';
const $cccad9dbca818926$export$874739ea9e379ab6 = '#533F04';
const $cccad9dbca818926$export$4d0048026652f54a = '#FFF4E5';
const $cccad9dbca818926$export$51716a84e62e022c = '#FFE2BD';
const $cccad9dbca818926$export$59e5b1f9a23fd718 = '#FAA53D';
const $cccad9dbca818926$export$e30ed75d70748b1 = '#974F0C';
const $cccad9dbca818926$export$d93a44e5c84e8256 = '#5F3811';
const $cccad9dbca818926$export$be802dd0d8b57f35 = '#FFEDEB';
const $cccad9dbca818926$export$60847d42f9da92a6 = '#FFD2CC';
const $cccad9dbca818926$export$4a7404f376229999 = '#F87462';
const $cccad9dbca818926$export$2010d0fb4295b346 = '#AE2A19';
const $cccad9dbca818926$export$2837b5a1a71d5c02 = '#601E16';
const $cccad9dbca818926$export$6755153cd35f90b1 = '#FFECF8';
const $cccad9dbca818926$export$a19f0c33186f7767 = '#FDD0EC';
const $cccad9dbca818926$export$a46884cf0037b203 = '#F797D2';
const $cccad9dbca818926$export$a1d4686c17e1cdef = '#943D73';
const $cccad9dbca818926$export$16814b01d9742bf7 = '#50253F';

});

parcelRegister("kzlGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c77e6e90b19c039$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c77e6e90b19c039$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    greyLightest: {
        "id": "business-categories.category-form.category-color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "business-categories.category-form.category-color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "business-categories.category-form.category-color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "business-categories.category-form.category-color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "business-categories.category-form.category-color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "business-categories.category-form.category-color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "business-categories.category-form.category-color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "business-categories.category-form.category-color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "business-categories.category-form.category-color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "business-categories.category-form.category-color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "business-categories.category-form.category-color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "business-categories.category-form.category-color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "business-categories.category-form.category-color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "business-categories.category-form.category-color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "business-categories.category-form.category-color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "business-categories.category-form.category-color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "business-categories.category-form.category-color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "business-categories.category-form.category-color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "business-categories.category-form.category-color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "business-categories.category-form.category-color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "business-categories.category-form.category-color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "business-categories.category-form.category-color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "business-categories.category-form.category-color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "business-categories.category-form.category-color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "business-categories.category-form.category-color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "business-categories.category-form.category-color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "business-categories.category-form.category-color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "business-categories.category-form.category-color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "business-categories.category-form.category-color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "business-categories.category-form.category-color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "business-categories.category-form.category-color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "business-categories.category-form.category-color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "business-categories.category-form.category-color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "business-categories.category-form.category-color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "business-categories.category-form.category-color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "business-categories.category-form.category-color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "business-categories.category-form.category-color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "business-categories.category-form.category-color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "business-categories.category-form.category-color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "business-categories.category-form.category-color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "business-categories.category-form.category-color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "business-categories.category-form.category-color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "business-categories.category-form.category-color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "business-categories.category-form.category-color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "business-categories.category-form.category-color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "business-categories.category-form.category-color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "business-categories.category-form.category-color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "business-categories.category-form.category-color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "business-categories.category-form.category-color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "business-categories.category-form.category-color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});




parcelRegister("3SBWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a53a1a378752df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $74a53a1a378752df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noCategory: {
        "id": "business-list.list-view.group-item.category-item.no-category",
        "defaultMessage": "Uncategorized"
    }
});

});


parcelRegister("kavY4", function(module, exports) {

$parcel$export(module.exports, "ExpandIcon", () => $a0f5f277ad8bbe17$export$fcdb0af0473ee9e4);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $48IC4 = parcelRequire("48IC4");

var $1wnOS = parcelRequire("1wnOS");
const $a0f5f277ad8bbe17$export$fcdb0af0473ee9e4 = ({ expanded: expanded, onClick: onClick, rowIndex: rowIndex, totalGroupItems: totalGroupItems })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const Icon = expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))) : (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9)));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onClick();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'listRowGroupExpandIcon', {
            direction: expanded ? 'collapse' : 'expand',
            totalGroupItems: totalGroupItems
        });
    }, [
        createAnalyticsEvent,
        expanded,
        onClick,
        totalGroupItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage(expanded ? (0, $48IC4.default).collapse : (0, $48IC4.default).expand)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1wnOS.ExpandIconWrapper), {
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: formatMessage(expanded ? (0, $48IC4.default).collapseLabel : (0, $48IC4.default).open),
            primaryColor: `var(--ds-text-subtle, ${(0, $PdmhA).N200})`
        }),
        appearance: "subtle",
        testId: `business-list.ui.list-view.group-item.expand-icon.expand-icon-wrapper-${rowIndex}`
    }));
};

});
parcelRegister("48IC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d423199d67e0b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c0d423199d67e0b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    expand: {
        "id": "business-list.list-view.group-item.expand-icon.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "business-list.list-view.group-item.expand-icon.collapse",
        "defaultMessage": "Collapse"
    },
    collapseLabel: {
        "id": "business-list.list-view.group-item.expand-icon.collapse-label",
        "defaultMessage": "collapse"
    },
    open: {
        "id": "business-list.list-view.group-item.expand-icon.open",
        "defaultMessage": "open"
    }
});

});

parcelRegister("1wnOS", function(module, exports) {

$parcel$export(module.exports, "ExpandIconWrapper", () => $ad9c59484beb743d$export$4eeef63d68e77552);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $ad9c59484beb743d$var$CONTENT_OFFSET = "var(--ds-space-100, 8px)";
const $ad9c59484beb743d$var$WRAPPER_TRANSFORM = `translate(calc(-100% - ${$ad9c59484beb743d$var$CONTENT_OFFSET}), -50%)`;
const $ad9c59484beb743d$export$4eeef63d68e77552 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t9ec1mu3 _14n4stnw _w1ap1tcg _btpd1tcg",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1CxqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da9484b0f88f75d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2da9484b0f88f75d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    visibleItemsCount: {
        "id": "business-list.list-view.group-item.visible-items-count",
        "defaultMessage": "{ visibleItems } of { totalGroupItems }"
    },
    addGroupItem: {
        "id": "business-list.list-view.group-item.add-group-item",
        "defaultMessage": "Add group item"
    },
    createIssue: {
        "id": "business-list.list-view.group-item.create-issue",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("6dZjh", function(module, exports) {

$parcel$export(module.exports, "PriorityItem", () => $734284504fe6d226$export$2ea27b6e6a4479a7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aCS15 = parcelRequire("aCS15");

var $eyAMn = parcelRequire("eyAMn");
const $734284504fe6d226$export$2ea27b6e6a4479a7 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const priorityName = data.priority?.name != null ? data.priority.name : formatMessage((0, $eyAMn.default).noPriority);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aCS15.default), {
        iconUrl: data.priority?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($734284504fe6d226$var$PriorityLabel, null, priorityName));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $734284504fe6d226$var$PriorityLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aCS15", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebdc6113df78754e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ebdc6113df78754e$var$PRIORITY_ICON_SIZE = 20;
const $ebdc6113df78754e$var$PriorityIcon = ({ iconUrl: iconUrl })=>iconUrl == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ebdc6113df78754e$var$ImageIcon, {
        src: iconUrl
    });
var $ebdc6113df78754e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ebdc6113df78754e$var$PriorityIcon);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebdc6113df78754e$var$ImageIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eyAMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65e095278376fc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d65e095278376fc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPriority: {
        "id": "business-list.list-view.group-item.priority-item.no-priority",
        "defaultMessage": "No priority"
    }
});

});


parcelRegister("6SYWA", function(module, exports) {

$parcel$export(module.exports, "SelectGroupCheckbox", () => $f898f65ca00fefcb$export$5740ccbed0a2bd61);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hRFuG = parcelRequire("hRFuG");

var $8COV0 = parcelRequire("8COV0");
var $hotly = parcelRequire("hotly");
var $lEcA7 = parcelRequire("lEcA7");
var $hMWPo = parcelRequire("hMWPo");

var $5r9Wo = parcelRequire("5r9Wo");

var $4SJmy = parcelRequire("4SJmy");
const $f898f65ca00fefcb$var$getFirstParent = ({ issuesMap: issuesMap, issueId: issueId })=>{
    const parentIssueId = issuesMap.get(issueId)?.parentIssueId;
    if (parentIssueId) return $f898f65ca00fefcb$var$getFirstParent({
        issuesMap: issuesMap,
        issueId: parentIssueId
    });
    return issueId;
};
const $f898f65ca00fefcb$export$5740ccbed0a2bd61 = /*#__PURE__*/ (0, $eUqFw.memo)(({ group: group, rowIndex: rowIndex, onKeyDown: onKeyDown })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ issuesMap: issuesMap, expandedItems: expandedItems, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectIssues: selectIssues, unselectIssues: unselectIssues, selectGroup: selectGroup, unselectGroup: unselectGroup }] = (0, $hotly.useBulkSelectionStore)();
    const [isGroupSelected] = (0, $hotly.useIsGroupSelected)(group.issueId);
    const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, $hMWPo.useShiftKeySelection)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, $lEcA7.useSelectCollapsedGroups)();
    const isLoadingGroupIssues = childrenItems[group.issueId]?.loading;
    const groupIssues = (0, $eUqFw.useMemo)(()=>!isLoadingGroupIssues ? (0, $8COV0.getAllIssueChildren)({
            issue: group,
            childrenItems: childrenItems
        }) : undefined, [
        childrenItems,
        group,
        isLoadingGroupIssues
    ]);
    const [diffGroupIssuesSelected] = (0, $hotly.useDiffIssuesSelected)(groupIssues);
    // fetchingGroups - prevent unselecting the group while fetching issues
    (0, $eUqFw.useEffect)(()=>{
        if (!areAllIssuesSelected && !fetchingGroups && !isLoadingGroupIssues && diffGroupIssuesSelected && groupIssues?.length) {
            if (diffGroupIssuesSelected.length === 0 && !isGroupSelected) // if all the issues of the group are selected we should select the group
            selectGroup(group.issueId);
            else if (diffGroupIssuesSelected.length && isGroupSelected) // if some issue is not selected we should unselect the group
            unselectGroup(group.issueId);
        }
    }, [
        areAllIssuesSelected,
        diffGroupIssuesSelected,
        fetchingGroups,
        group.issueId,
        groupIssues?.length,
        isGroupSelected,
        isLoadingGroupIssues,
        selectGroup,
        unselectGroup
    ]);
    const hasChildren = group.childSummary?.hasChildren;
    const hasFirstIssuesToFetch = (0, $eUqFw.useMemo)(()=>expandedItems[group.issueId] === undefined && hasChildren && groupIssues?.length === 0, [
        expandedItems,
        group.issueId,
        groupIssues?.length,
        hasChildren
    ]);
    const onClickCheckbox = (0, $eUqFw.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectGroup', {
            isChecked: isChecked,
            rowIndex: rowIndex,
            shiftKeyPressed: shiftKeyPressed
        });
        if (isChecked) {
            // if the group is selected and we have not fetched children of the group
            // we should expand the group and fetch them
            selectCollapsedGroups([
                group
            ]);
            selectIssues({
                issues: groupIssues || [],
                selectGroup: group.issueId,
                rowIndex: rowIndex
            });
        } else {
            let issuesToUnselect = groupIssues || [];
            if (!groupIssues?.length) /* Edge case - Sorting - line 170 */ issuesToUnselect = [
                ...selectedIssues
            ].filter((issueId)=>$f898f65ca00fefcb$var$getFirstParent({
                    issuesMap: issuesMap,
                    issueId: issueId
                }) === group.issueId);
            unselectIssues({
                issues: issuesToUnselect,
                unselectGroup: group.issueId,
                rowIndex: rowIndex
            });
        }
        if (shiftKeyPressed) onShiftKeyBulkSelection({
            isChecked: isChecked,
            rowIndex: rowIndex
        });
    }, [
        createAnalyticsEvent,
        group,
        groupIssues,
        issuesMap,
        onShiftKeyBulkSelection,
        rowIndex,
        selectCollapsedGroups,
        selectIssues,
        selectedIssues,
        unselectIssues
    ]);
    //  if there is some issue of the group selected
    let hasSomeGroupIssueSelected = !!(Number(diffGroupIssuesSelected?.length) > 0 && Number(diffGroupIssuesSelected?.length) < Number(groupIssues?.length));
    // shouldBeSelected is to check the group immediately when all the issues are selected (diffGroupIssuesSelected is 0)
    //  instead of waiting for the useEffect (line 73) to update the store to calling selectGroup once all the issues are selected
    const shouldBeSelected = Number(diffGroupIssuesSelected?.length) === 0 && hasChildren && Number(groupIssues?.length) > 0 && !hasFirstIssuesToFetch;
    let isChecked = isGroupSelected || hasSomeGroupIssueSelected || !!shouldBeSelected;
    if (!isChecked && selectedIssues.size) {
        /*
                 Edge case - Sorting
                  When the sorting of the columns or the filters changes all the groups change to collapsed and all the children's data it's null.
                 If there is data selected we are not able to match it with the group data.
                 If the change it's due to a filter change we clear the selection because we don't know if it's going to match with the new group data.
                 If the change it's due to sorting we know that will still be part of that group
             */ hasSomeGroupIssueSelected = [
            ...selectedIssues
        ].some((issueId)=>$f898f65ca00fefcb$var$getFirstParent({
                issuesMap: issuesMap,
                issueId: issueId
            }) === group.issueId);
        isChecked = hasSomeGroupIssueSelected;
    }
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') {
            onClickCheckbox({
                isChecked: !isChecked,
                shiftKeyPressed: e.shiftKey
            });
            return;
        }
        onKeyDown?.(e);
    }, [
        isChecked,
        onClickCheckbox,
        onKeyDown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRFuG.BulkSelectCheckbox), {
        onClick: onClickCheckbox,
        onKeyDown: handleKeyDown,
        isChecked: isChecked,
        isIndeterminate: hasSomeGroupIssueSelected,
        label: formatMessage((0, $4SJmy.default).selectGroup)
    });
});

});
parcelRegister("hRFuG", function(module, exports) {

$parcel$export(module.exports, "BulkSelectCheckbox", () => $b471a708ec0a3ec6$export$9d26591b0d1643b6);

var $eUqFw = parcelRequire("eUqFw");

var $dFBS3 = parcelRequire("dFBS3");

var $bT7k5 = parcelRequire("bT7k5");

var $lkPEe = parcelRequire("lkPEe");

var $gbsaq = parcelRequire("gbsaq");
const $b471a708ec0a3ec6$export$9d26591b0d1643b6 = /*#__PURE__*/ (0, $eUqFw.memo)(({ id: id, onClick: onClick, isChecked: isChecked, isIndeterminate: isIndeterminate, isSelected: isSelected, wrapperRef: wrapperRef, onKeyDown: onKeyDown, isDisabled: isDisabled, label: label, ...props })=>{
    const bulkSelectId = id ?? `${0, $gbsaq.BULK_SELECT_CHECKBOX_ID}_${(0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()}`;
    const handleOnClick = (0, $eUqFw.useCallback)((event)=>{
        onClick({
            isChecked: event?.currentTarget?.checked,
            shiftKeyPressed: !!event?.shiftKey
        });
    }, [
        onClick
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isSelected && wrapperRef?.current) wrapperRef.current.focus();
    }, [
        isSelected,
        wrapperRef
    ]);
    const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: bulkSelectId
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        id: bulkSelectId,
        onClick: handleOnClick,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        testId: "business-list.common.ui.bulk-select-checkbox",
        onKeyDown: onKeyDown,
        ...wrapperRef ? {
            ref: onWrapperRef
        } : {},
        ...props
    }));
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});



parcelRegister("lEcA7", function(module, exports) {

$parcel$export(module.exports, "useSelectCollapsedGroups", () => $e928696ce77fb5c0$export$fb1b9a2145b5780d);

var $eUqFw = parcelRequire("eUqFw");

var $5r9Wo = parcelRequire("5r9Wo");

var $hotly = parcelRequire("hotly");
const $e928696ce77fb5c0$export$fb1b9a2145b5780d = ()=>{
    const [{ expandedItems: expandedItems, childrenItems: childrenItems }, { setExpandedItems: setExpandedItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ fetchingGroups: fetchingGroups, selectedGroups: selectedGroups }, { selectIssues: selectIssues, selectGroup: selectGroup, setFetchingGroups: setFetchingGroups }] = (0, $hotly.useBulkSelectionStore)();
    (0, $eUqFw.useEffect)(()=>{
        // if the fetch of the group issues is done and the group is selected
        // we should select the group issues
        if (fetchingGroups.length) {
            let groupFetchDone = [];
            fetchingGroups.forEach((groupId)=>{
                const group = childrenItems[groupId];
                if (group?.loading === false && selectedGroups.has(groupId)) {
                    selectIssues({
                        issues: group.data.map((i)=>String(i.issueId))
                    });
                    groupFetchDone = [
                        ...groupFetchDone,
                        groupId
                    ];
                }
            });
            if (groupFetchDone.length) setFetchingGroups(fetchingGroups.filter((g)=>!groupFetchDone.includes(g)));
        }
    }, [
        childrenItems,
        fetchingGroups,
        selectIssues,
        selectedGroups,
        setFetchingGroups
    ]);
    const selectCollapsedGroups = (0, $eUqFw.useCallback)((groups)=>{
        let groupToFetch = [];
        groups.forEach((group)=>{
            const { issueId: issueId, childSummary: childSummary } = group;
            const hasChildren = childSummary?.hasChildren;
            selectGroup(issueId);
            const hasIssuesToFetch = expandedItems[issueId] === undefined && childrenItems[issueId] === undefined && hasChildren;
            setExpandedItems(issueId, true);
            // if the group is selected and we have not fetched children of the group
            // we should expand the group and fetch them
            if (hasIssuesToFetch) groupToFetch = [
                ...groupToFetch,
                issueId
            ];
        });
        setFetchingGroups(groupToFetch);
    }, [
        childrenItems,
        expandedItems,
        selectGroup,
        setExpandedItems,
        setFetchingGroups
    ]);
    return {
        selectCollapsedGroups: selectCollapsedGroups,
        fetchingGroups: fetchingGroups.length > 0
    };
};

});

parcelRegister("hMWPo", function(module, exports) {

$parcel$export(module.exports, "useShiftKeySelection", () => $ba8313d70bc53bc1$export$e105f3cb55da1b14);

var $eUqFw = parcelRequire("eUqFw");

var $fcWBJ = parcelRequire("fcWBJ");

var $4oWxH = parcelRequire("4oWxH");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");

var $hotly = parcelRequire("hotly");

var $lEcA7 = parcelRequire("lEcA7");

var $8COV0 = parcelRequire("8COV0");
const $ba8313d70bc53bc1$export$e105f3cb55da1b14 = ()=>{
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const [{ issuesMap: issuesMap, expandedItems: expandedItems, hierarchyData: hierarchyData, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ selectedIssues: selectedIssuesStore, fetchingGroups: fetchingGroups, lastSelectedRowIndex: lastSelectedRowIndex }, { selectIssues: selectIssues, unselectIssues: unselectIssues, setLastSelectedRowIndex: setLastSelectedRowIndex }] = (0, $hotly.useBulkSelectionStore)();
    const { selectCollapsedGroups: selectCollapsedGroups } = (0, $lEcA7.useSelectCollapsedGroups)();
    /*
        If grouping, the last lastSelectedRowIndex could change  due to expanding and fetching a group
        Once we finish with the fetching of the groups we should update lastSelectedRowIndex with the new index
    */ const [lastIssueIdSelected, setLastIssueIdSelected] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const isGrouping = groupByFieldId != null;
        if (isGrouping && !fetchingGroups.length && lastSelectedRowIndex !== undefined && lastIssueIdSelected) {
            const issues = (0, $8COV0.getFlattenIssuesList)({
                issues: hierarchyData.data,
                expandedItems: expandedItems
            });
            const newIndex = issues.findIndex((i)=>String(i.issueId) === lastIssueIdSelected);
            if (newIndex >= 0) {
                setLastSelectedRowIndex(newIndex);
                setLastIssueIdSelected(undefined);
            }
        }
    // Should only update the last selected row index once
    // the expanded items are updated and the groups are finally fetched
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandedItems,
        fetchingGroups
    ]);
    const onShiftKeyBulkSelection = (0, $eUqFw.useCallback)(({ isChecked: isChecked, rowIndex: selectedRowIndex })=>{
        let rowIndex = selectedRowIndex;
        if (lastSelectedRowIndex !== undefined && rowIndex !== undefined) {
            const lastIssueSelected = issuesMap.get([
                ...selectedIssuesStore
            ].pop() || '');
            const parentLastIssueSelected = lastIssueSelected?.parentIssueId;
            let expandedItemsToGetFlattenList = expandedItems;
            if (parentLastIssueSelected && !(0, $4oWxH.isGroupItem)(parentLastIssueSelected) && !expandedItems[parentLastIssueSelected]) {
                /*
                    Edge case
                        If the last issue selected it's a child of a collapsed task/epic
                        We should simulate the parent as expanded because we need to select the hidden children
                        */ expandedItemsToGetFlattenList = {
                    ...expandedItemsToGetFlattenList,
                    [parentLastIssueSelected]: true
                };
                rowIndex += issuesMap.get(parentLastIssueSelected)?.children?.length || 0;
            }
            const issues = expandedItems ? (0, $8COV0.getFlattenIssuesList)({
                issues: hierarchyData.data,
                expandedItems: expandedItemsToGetFlattenList
            }) : hierarchyData.data;
            let selectedIssues = [];
            if (lastSelectedRowIndex < rowIndex) selectedIssues = issues.slice(lastSelectedRowIndex, rowIndex + 1);
            else selectedIssues = issues.slice(rowIndex, !isChecked ? lastSelectedRowIndex + 1 : lastSelectedRowIndex);
            let issueIds = [];
            const isGrouping = groupByFieldId != null;
            if (isGrouping) {
                const groups = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(selectedIssues, (issue)=>(0, $4oWxH.isGroupItem)(issue.issueId));
                // select/unselect issues that are in the middle and are not groups
                issueIds = groups.false.map((issue)=>String(issue.issueId));
                // Should select and expand the groups in the middle but not the parent of the selected issue
                const pressedIssue = issues[rowIndex];
                const groupsToSelect = groups.true?.filter((group)=>group.issueId !== pressedIssue.parentIssueId) || [];
                if (groupsToSelect.length) {
                    /*
                            if there are groups in the middle of the selection we should keep
                            the last issue selected to update the row index because could change
                            depending on the groups that are going to be expanded
                        */ setLastIssueIdSelected(pressedIssue.issueId);
                    if (isChecked) selectCollapsedGroups(groupsToSelect);
                    else groupsToSelect.forEach((group)=>{
                        const groupIssues = (0, $8COV0.getAllIssueChildren)({
                            issue: group,
                            childrenItems: childrenItems
                        });
                        unselectIssues({
                            issues: groupIssues || [],
                            unselectGroup: group.issueId,
                            rowIndex: rowIndex
                        });
                    });
                }
            } else issueIds = selectedIssues.map((issue)=>String(issue.issueId));
            if (!isChecked) unselectIssues({
                issues: issueIds
            });
            else selectIssues({
                issues: issueIds
            });
        }
    }, [
        childrenItems,
        expandedItems,
        groupByFieldId,
        hierarchyData.data,
        issuesMap,
        lastSelectedRowIndex,
        selectCollapsedGroups,
        selectIssues,
        selectedIssuesStore,
        unselectIssues
    ]);
    return {
        onShiftKeyBulkSelection: onShiftKeyBulkSelection
    };
};

});

parcelRegister("4SJmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c146a483af553973$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c146a483af553973$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectGroup: {
        "id": "business-list.list-view.group-item.select-group-checkbox.select-group",
        "defaultMessage": "Select group"
    }
});

});


parcelRegister("fOYLV", function(module, exports) {

$parcel$export(module.exports, "SprintItem", () => $99e98ba6399b9789$export$c40eb2da058b4e36);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7qb3w = parcelRequire("7qb3w");
const $99e98ba6399b9789$export$c40eb2da058b4e36 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { sprint: sprint } = data;
    let text;
    if (!sprint) text = formatMessage((0, $7qb3w.default).backlog);
    else if (sprint.state === 'CLOSED') text = formatMessage((0, $7qb3w.default).completedSprint);
    else text = sprint.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: text,
        testId: "business-list.ui.list-view.group-item.sprint-item.simple-tag"
    });
};

});
parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTag);

});
parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            $98c5a9f7a5ded4f8$var$baseStyles,
            (isRemovable || isLink) && $98c5a9f7a5ded4f8$var$focusRingStyles,
            isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            isInteractive && $98c5a9f7a5ded4f8$var$interactiveStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});
parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$PdmhA.N700})`,
    standardLink: `var(--ds-link, ${$PdmhA.B400})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$PdmhA.N20})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$PdmhA.B100})`,
    red: `var(--ds-background-accent-red-subtle, ${$PdmhA.R100})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$PdmhA.Y200})`,
    green: `var(--ds-background-accent-green-subtle, ${$PdmhA.G200})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$PdmhA.T200})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$PdmhA.P100})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$PdmhA.N500})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$PdmhA.B75})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$PdmhA.R75})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$PdmhA.Y100})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$PdmhA.G100})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$PdmhA.T100})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$PdmhA.P75})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$PdmhA.N30})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$PdmhA.B75})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$PdmhA.R75})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$PdmhA.Y100})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$PdmhA.G100})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$PdmhA.T100})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$PdmhA.P75})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$PdmhA.N400})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$PdmhA.B50})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$PdmhA.R50})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$PdmhA.Y75})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$PdmhA.G75})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$PdmhA.T75})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$PdmhA.P50})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$PdmhA.N40})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$PdmhA.B50})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$PdmhA.R50})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$PdmhA.Y75})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$PdmhA.G75})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$PdmhA.T75})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$PdmhA.P50})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$PdmhA.N300})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$PdmhA.B100})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$PdmhA.R100})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$PdmhA.Y200})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$PdmhA.G200})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$PdmhA.T200})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$PdmhA.P100})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$PdmhA.N50})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$PdmhA.B100})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$PdmhA.R500})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$PdmhA.N500})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N500})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N500})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N500})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$PdmhA.N500})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$PdmhA.N500})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$PdmhA.N500})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.N500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.N500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.N500})`,
    limeLight: `var(--ds-text-accent-lime, ${$PdmhA.N500})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$PdmhA.N500})`,
    orangeLight: `var(--ds-text-accent-orange, ${$PdmhA.N500})`,
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$PdmhA.N700})`,
    standardLink: `var(--ds-text-danger, ${$PdmhA.B400})`,
    blue: `var(--ds-text-danger, ${$PdmhA.N800})`,
    red: `var(--ds-text-danger, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-danger, ${$PdmhA.N800})`,
    green: `var(--ds-text-danger, ${$PdmhA.N800})`,
    teal: `var(--ds-text-danger, ${$PdmhA.N800})`,
    purple: `var(--ds-text-danger, ${$PdmhA.N800})`,
    lime: `var(--ds-text-danger, ${$PdmhA.N800})`,
    magenta: `var(--ds-text-danger, ${$PdmhA.N800})`,
    orange: `var(--ds-text-danger, ${$PdmhA.N800})`,
    grey: `var(--ds-text-danger, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-danger, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-danger, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    limeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    magentaLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    orangeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    greyLight: `var(--ds-text-danger, ${$PdmhA.N500})`
};

});


parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $70eddb948b5989f5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $70eddb948b5989f5$var$beforeElementStyles
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$linkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            $154b7edc63fec879$var$baseStyles,
            $154b7edc63fec879$var$linkStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $154b7edc63fec879$var$baseStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});


parcelRegister("7qb3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9d061e3c74ed12$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b9d061e3c74ed12$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    completedSprint: {
        "id": "business-list.list-view.group-item.sprint-item.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    backlog: {
        "id": "business-list.list-view.group-item.sprint-item.backlog",
        "defaultMessage": "Backlog"
    }
});

});


parcelRegister("ex5gB", function(module, exports) {

$parcel$export(module.exports, "StatusItem", () => $0ef50df9ba2f2652$export$a687524c95d42e5);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $0ef50df9ba2f2652$var$appearanceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
const $0ef50df9ba2f2652$export$cbc76b787f60c037 = (categoryId)=>categoryId != null ? $0ef50df9ba2f2652$var$appearanceMap[(0, $8Qd0L.statusCategoryForId)(categoryId)] : $0ef50df9ba2f2652$var$appearanceMap[0, $8Qd0L.UNDEFINED];
const $0ef50df9ba2f2652$export$a687524c95d42e5 = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: $0ef50df9ba2f2652$export$cbc76b787f60c037(data.status?.categoryId)
    }, data.status?.name);

});

parcelRegister("5m7NF", function(module, exports) {

$parcel$export(module.exports, "StoryPointsItem", () => $6a58910c9cb7dc06$export$93b96298887b28d0);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6FafE = parcelRequire("6FafE");
const $6a58910c9cb7dc06$export$93b96298887b28d0 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        testId: "business-list.ui.list-view.group-item.storypoints-item.storypoints",
        text: typeof value === 'number' ? formatMessage((0, $6FafE.default).storyPoints, {
            points: value
        }) : formatMessage((0, $6FafE.default).noStoryPoints)
    });
};

});
parcelRegister("6FafE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3e95fc722b69aa4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d3e95fc722b69aa4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    storyPoints: {
        "id": "business-list.list-view.group-item.storypoints-item.story-points",
        "defaultMessage": "{points, plural, one {# point} other {# points}}"
    },
    noStoryPoints: {
        "id": "business-list.list-view.group-item.storypoints-item.no-story-points",
        "defaultMessage": "No points"
    }
});

});


parcelRegister("60YYZ", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $985fcedc010f80cf$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "GroupContainer", () => $985fcedc010f80cf$export$dd05ea0be7e7193a);
$parcel$export(module.exports, "CreateIssuePlusButtonWrapper", () => $985fcedc010f80cf$export$caa7a2fe02de419c);
$parcel$export(module.exports, "LoadingIcon", () => $985fcedc010f80cf$export$b936c55164dcf1db);
$parcel$export(module.exports, "LoadingRow", () => $985fcedc010f80cf$export$d1e723d3001badba);
$parcel$export(module.exports, "LoadingField", () => $985fcedc010f80cf$export$2304bbb03949f4f1);
$parcel$export(module.exports, "LoadingWrapper", () => $985fcedc010f80cf$export$43a792a870d28db2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");
const $985fcedc010f80cf$var$ICON_SIZE = 24;
const $985fcedc010f80cf$var$wrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.250'
});
const $985fcedc010f80cf$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: $985fcedc010f80cf$var$wrapperStyles
    }, children);
const $985fcedc010f80cf$var$groupContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.500'
});
const $985fcedc010f80cf$export$dd05ea0be7e7193a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: $985fcedc010f80cf$var$groupContainerStyles
    }, children);
const $985fcedc010f80cf$export$caa7a2fe02de419c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$b936c55164dcf1db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsbu2gc _4t3i1tcg _bfhk1aqf _18s81l84 _2rko1sit",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$d1e723d3001badba = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$2304bbb03949f4f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb68cl _bfhk1aqf _18s8u2gc _2rko1l7b",
            __cmplp.className
        ])
    });
});
const $985fcedc010f80cf$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4PNxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac497dc7be8ffdce$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $lkPEe = parcelRequire("lkPEe");

var $RZgA1 = parcelRequire("RZgA1");

var $5Wwns = parcelRequire("5Wwns");
var $7fw7y = parcelRequire("7fw7y");

var $9TEHc = parcelRequire("9TEHc");
var $8rPxE = parcelRequire("8rPxE");
var $d9gm1 = parcelRequire("d9gm1");
var $gZpkQ = parcelRequire("gZpkQ");

var $bSsl1 = parcelRequire("bSsl1");
var $iSNkS = parcelRequire("iSNkS");
var $eCCst = parcelRequire("eCCst");

var $91Lr1 = parcelRequire("91Lr1");

var $7h3LT = parcelRequire("7h3LT");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3007p = parcelRequire("3007p");
var $6MsoD = parcelRequire("6MsoD");

var $9yV1c = parcelRequire("9yV1c");

var $egJIx = parcelRequire("egJIx");

var $dSE3z = parcelRequire("dSE3z");

var $aqGaJ = parcelRequire("aqGaJ");

var $3Cjpz = parcelRequire("3Cjpz");

var $eXDkt = parcelRequire("eXDkt");

var $1X186 = parcelRequire("1X186");
const $ac497dc7be8ffdce$export$223875819fd7cf93 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { inviteButtonInteraction: inviteButtonInteraction, isShareButtonEnabled: isShareButtonEnabled, isPresenceEnabled: isPresenceEnabled, hasFilterCustomFields: hasFilterCustomFields, isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const [hideDoneItems, setHideDoneItems] = (0, $gZpkQ.useHideDoneItems)();
    const [{ nudgeStep: nudgeStep, shouldOpenModal: shouldOpenModal }, { setShouldOpenModal: setShouldOpenModal }] = (0, $7h3LT.useNudgeStep)();
    const handleDialogClose = (0, $eUqFw.useCallback)(()=>{
        if (shouldOpenModal) setShouldOpenModal(false);
    }, [
        setShouldOpenModal,
        shouldOpenModal
    ]);
    const [{ hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems }, { toggleExpandAllItems: toggleExpandAllItems, collapseAllItems: collapseAllItems }] = (0, $9yV1c.useExpandCollapseAllItems)({
        view: 'list'
    });
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const isGrouping = groupByFieldId != null;
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hiddenQuickFilters: hiddenQuickFilters, allowedAliasFieldId: allowedAliasFieldId } = (0, $1X186.useFilterProps)();
    const showShareButtonSpotlight = nudgeStep === (0, $dd8a6385bf5dfbc6$export$7b88fd4d1ff6218e);
    const shareButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eCCst.JWMShareButton), {
        shareTitle: (0, $eXDkt.default).shareTitle,
        integrationType: (0, $iSNkS.integrationTypes).LIST,
        shareContentType: "list",
        isAutoOpenDialog: shouldOpenModal,
        onDialogClose: handleDialogClose
    });
    const handleExpandCollapseAllItems = (0, $eUqFw.useCallback)((operation)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandCollapseAll', {
            operation: operation
        });
        if (operation === 'collapse') collapseAllItems();
        else if (operation === 'expand') toggleExpandAllItems();
    }, [
        collapseAllItems,
        createAnalyticsEvent,
        toggleExpandAllItems
    ]);
    const wrappedShareButton = showShareButtonSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: (0, $dd8a6385bf5dfbc6$export$7b88fd4d1ff6218e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, shareButton)) : shareButton;
    const searchBarLabelId = 'header-actions-search-field-label';
    const searchBar = (0, $eI5EY.fg)('jwm_header_filters_a11y_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), {
        id: searchBarLabelId
    }, formatMessage((0, $eXDkt.default).searchLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9gm1.SimpleSearchField), {
        placeholder: (0, $eXDkt.default).simpleSearch,
        view: "list",
        describedbyId: searchBarLabelId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9gm1.SimpleSearchField), {
        placeholder: (0, $eXDkt.default).simpleSearch,
        view: "list",
        describedbyId: ""
    });
    const addPeopleWithPresence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSsl1.default), {
        view: "list",
        isPresenceEnabledInContext: isPresenceEnabled,
        isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab'
    });
    const shareActionButton = isShareButtonEnabled && wrappedShareButton;
    const allowedFieldTypes = (0, $eUqFw.useMemo)(()=>isSoftwareFieldsEnabled ? new Set([
            ...(0, $9TEHc.BUSINESS_FIELD_TYPES),
            ...(0, $9TEHc.SOFTWARE_FIELD_TYPES)
        ]) : undefined, [
        isSoftwareFieldsEnabled
    ]);
    const filters = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3007p.FilterDropdownListNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8rPxE.Filters), {
        view: "list",
        allowedFieldTypes: allowedFieldTypes,
        allowCustomFields: hasFilterCustomFields,
        allowedAliasFieldId: allowedAliasFieldId,
        hiddenQuickFilters: hiddenQuickFilters
    }));
    const groupByDropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Cjpz.default), null);
    let onClickConditionalFormattingButton;
    if ((0, $79xbN.expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) ({ onClickConditionalFormattingButton: onClickConditionalFormattingButton } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7fw7y.useConditionalFormattingSidebar)({
        SidebarComponent: (0, $5Wwns.ConditionalFormatting)
    }));
    const moreMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6MsoD.MoreDropdownListNudgeAsync), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91Lr1.default), {
        hideDoneItems: Boolean(hideDoneItems),
        onChangeHideDoneItems: setHideDoneItems,
        onExpandCollapseAllItems: handleExpandCollapseAllItems,
        onConditionalFormatting: onClickConditionalFormattingButton,
        isExpandCollapseButtonEnabled: !showFlatList || isGrouping,
        hasExpandedAllItems: hasExpandedAllItems,
        hasCollapsedAllItems: hasCollapsedAllItems
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.ActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.LeftActionsWrapper), null, searchBar, addPeopleWithPresence), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RZgA1.RightActionsWrapper), null, shareActionButton, filters, groupByDropdown, moreMenu));
};
var $ac497dc7be8ffdce$export$2e2bcd8739ae039 = $ac497dc7be8ffdce$export$223875819fd7cf93;

});
parcelRegister("RZgA1", function(module, exports) {

$parcel$export(module.exports, "ActionsWrapper", () => $2a4eb501d360abec$export$c8223871eecc8f3a);
$parcel$export(module.exports, "LeftActionsWrapper", () => $2a4eb501d360abec$export$42cb1c7ab389bf4d);
$parcel$export(module.exports, "RightActionsWrapper", () => $2a4eb501d360abec$export$4aa2cd250ec24dcc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hSCS8 = parcelRequire("hSCS8");
const $2a4eb501d360abec$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
    const [{ content: content }] = (0, $hSCS8.useSidebar)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a4eb501d360abec$var$ActionsWrapperStyled, {
        sidebarOpen: !!content,
        "data-testid": testId
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4eb501d360abec$var$CenterAlignedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$var$ActionsWrapperStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_10qff79": (0, $9t7rW.default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke1ylp _18s8l1uc _1yt46hdp _1n261g80 _bfhk1ml8 _18k9kjed",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$42cb1c7ab389bf4d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $2a4eb501d360abec$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $2a4eb501d360abec$export$4aa2cd250ec24dcc = $2a4eb501d360abec$var$CenterAlignedWrapper;

});

parcelRegister("5Wwns", function(module, exports) {

$parcel$export(module.exports, "ConditionalFormatting", () => $0dee0e4c14e4b3bf$export$6d44d4a22d5bca7a);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $jR9Og = parcelRequire("jR9Og");
const $0dee0e4c14e4b3bf$var$entryPointParams = {};
const $0dee0e4c14e4b3bf$export$6d44d4a22d5bca7a = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jR9Og.conditionalFormattingEntryPoint), $0dee0e4c14e4b3bf$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.parent.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        // TODO: add fallback
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    });
};

});
parcelRegister("jR9Og", function(module, exports) {

$parcel$export(module.exports, "conditionalFormattingEntryPoint", () => $520e8c0265750cc6$export$cd67196f8dec2ab9);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $520e8c0265750cc6$export$cd67196f8dec2ab9 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("dim6M")), {
        moduleId: "8b7c2bc3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dim6M", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5sNAx');
        const value = parcelRequire('a2U20');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5sNAx").then(()=>parcelRequire('a2U20'));
}

});



parcelRegister("7fw7y", function(module, exports) {

$parcel$export(module.exports, "useConditionalFormattingSidebar", () => $271101c7e3b4af16$export$c77be4b5de2c89e5);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $271101c7e3b4af16$var$CONDITIONAL_FORMATTING_SIDEBAR_CONTENT_KEY = 'conditionalFormattingSidebar';
const $271101c7e3b4af16$export$c77be4b5de2c89e5 = ({ SidebarComponent: SidebarComponent })=>{
    const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isConditionalFormattingSidebarOpen = (0, $eUqFw.useMemo)(()=>content?.key === $271101c7e3b4af16$var$CONDITIONAL_FORMATTING_SIDEBAR_CONTENT_KEY, [
        content
    ]);
    const onCloseSidebar = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'conditionalFormattingSidebarButton', {
            open: false
        });
        setSidebarContent(null);
    }, [
        createAnalyticsEvent,
        setSidebarContent
    ]);
    const onClickConditionalFormattingButton = (0, $eUqFw.useCallback)(()=>{
        if (isConditionalFormattingSidebarOpen) onCloseSidebar();
        else {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'conditionalFormattingSidebarButton', {
                open: true
            });
            setSidebarContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SidebarComponent, {
                key: $271101c7e3b4af16$var$CONDITIONAL_FORMATTING_SIDEBAR_CONTENT_KEY,
                onCloseSidebar: onCloseSidebar
            }));
        }
    }, [
        SidebarComponent,
        createAnalyticsEvent,
        isConditionalFormattingSidebarOpen,
        onCloseSidebar,
        setSidebarContent
    ]);
    return {
        onClickConditionalFormattingButton: onClickConditionalFormattingButton
    };
};

});

parcelRegister("8rPxE", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $4a948cec7cd2ee06$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jK1pm = parcelRequire("jK1pm");

var $jpXBE = parcelRequire("jpXBE");

var $fvzkg = parcelRequire("fvzkg");

var $jWIW7 = parcelRequire("jWIW7");

var $9GlEj = parcelRequire("9GlEj");

var $27zPy = parcelRequire("27zPy");

var $6M6Pf = parcelRequire("6M6Pf");
const $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault = [
    'ACTIVE_SPRINTS'
];
const $4a948cec7cd2ee06$export$92a576f896a9bf72 = /*#__PURE__*/ (0, $eUqFw.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $4a948cec7cd2ee06$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const allowedFieldTypes = (0, $jWIW7.useAllowedFieldTypes)(inputAllowedFieldTypes);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const close = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const toggle = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((prevIsOpen)=>!prevIsOpen);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
    }, [
        createAnalyticsEvent
    ]);
    const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, $9GlEj.useQuickFilters)();
    const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, $fvzkg.useDeserialiseJqlFilters)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
    if ((0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jpXBE.useGoalsFilterAnalyticsEvent)({
        filters: filters,
        view: view
    });
    const hasFiltersApplied = count > 0 || hasFilterError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27zPy.MenuContent), {
                "data-testid": "business-filters.ui.filters.menu-content",
                count: count,
                fieldConfig: fieldConfig,
                filters: filters,
                quickFilters: quickFilters,
                setQuickFilters: setQuickFilters,
                setFilters: setFilters,
                hiddenQuickFilters: hiddenQuickFilters,
                view: view,
                allowCustomFields: allowCustomFields,
                allowSavedFilters: allowSavedFilters,
                hasFilterError: hasFilterError
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M6Pf.Trigger), {
                ...triggerProps,
                count: count,
                hasFiltersApplied: hasFiltersApplied,
                isSelected: isOpen,
                onClick: toggle
            }),
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }), customFieldsLoader));
});

});
parcelRegister("jpXBE", function(module, exports) {

$parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", () => $bf0eb06c2610c94c$export$c9b2aef46b42c898);

var $eUqFw = parcelRequire("eUqFw");

var $hLW3I = parcelRequire("hLW3I");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $bf0eb06c2610c94c$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { data: filterFields } = (0, $hLW3I.useFilterFields)();
    const goalField = (0, $eUqFw.useMemo)(()=>filterFields.find((field)=>field.type === (0, $lO4Or.GOALS_CF_TYPE)), [
        filterFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (goalField && filters[goalField.id]) {
            const goalsFilter = filters[goalField.id];
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                source: view,
                goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
            });
        }
    }, [
        createAnalyticsEvent,
        filters,
        goalField,
        view
    ]);
};

});
parcelRegister("hLW3I", function(module, exports) {

$parcel$export(module.exports, "useFilterFields", () => $b966faf4b3b8c8a2$export$b2d30fa5478b571a);

var $eUqFw = parcelRequire("eUqFw");

var $kMmsu = parcelRequire("kMmsu");
const $b966faf4b3b8c8a2$export$b2d30fa5478b571a = ()=>{
    const { data: fields, loading: loading } = (0, $kMmsu.useFieldsResource)();
    const data = (0, $eUqFw.useMemo)(()=>fields?.map((field)=>({
                id: field.jqlTerm,
                name: field.displayName,
                type: field.type
            })) ?? [], [
        fields
    ]);
    return {
        data: data,
        loading: loading,
        error: undefined
    };
};

});


parcelRegister("fvzkg", function(module, exports) {

$parcel$export(module.exports, "DeserialisedFiltersProvider", () => $df8b3ad8c9e75684$export$c5640c1fbeb250b6);
$parcel$export(module.exports, "useDeserialisedFilters", () => $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7);
$parcel$export(module.exports, "useDeserialiseJqlFilters", () => $df8b3ad8c9e75684$export$eaa578dc219a620a);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $9TEHc = parcelRequire("9TEHc");

var $jhNgz = parcelRequire("jhNgz");

var $hLW3I = parcelRequire("hLW3I");

var $gZpkQ = parcelRequire("gZpkQ");

var $lEWmB = parcelRequire("lEWmB");

var $9GlEj = parcelRequire("9GlEj");

var $coMWQ = parcelRequire("coMWQ");
const $df8b3ad8c9e75684$var$DEFAULT_VALUE = {
    filters: {}
};
/* Context used by the board view until the filters get implemented in the backend */ const $df8b3ad8c9e75684$var$DeserialisedFiltersContext = /*#__PURE__*/ (0, $eUqFw.createContext)($df8b3ad8c9e75684$var$DEFAULT_VALUE);
const $df8b3ad8c9e75684$export$c5640c1fbeb250b6 = ({ children: children })=>{
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const value = (0, $eUqFw.useMemo)(()=>({
            filters: filters,
            setFilters: setFilters,
            isLoading: isLoading,
            setIsLoading: setIsLoading
        }), [
        filters,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df8b3ad8c9e75684$var$DeserialisedFiltersContext.Provider, {
        value: value
    }, children);
};
const $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7 = ()=>(0, $eUqFw.useContext)($df8b3ad8c9e75684$var$DeserialisedFiltersContext);
/**
 * There are known limitations with deserialising JQL that the backend supports but the UI filter
 * dialog does not. This is mainly seen from links on the Summary page that contain filters like relative
 * dates (i.e. `statusCategoryChangedDate >= -1w`) and `statusCategory`. For these types of filters
 * we don't want to send errors to our analytics service as they create too much noise
 * and make it harder to identify errors we care about.
 *
 * Software projects do not have a Summary page so we are using `allowedFilterTypes` as a way of
 * approximating what type of project we are, this allows us to then prevent/allow sending
 * errors to the analytics service.
 *
 * @see https://jbusiness.atlassian.net/browse/FLINGO-370
 */ const $df8b3ad8c9e75684$var$useErrorDeserializeAnalytics = ({ allowedFieldTypes: allowedFieldTypes, error: error })=>{
    const isSoftwareProject = (0, $9TEHc.SOFTWARE_FIELD_TYPES).some(Set.prototype.has, allowedFieldTypes);
    const shouldSuppressErrors = !isSoftwareProject;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldSuppressErrors) return;
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'deserializeJQL',
                packageName: 'jiraBusinessFilters',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'keystone'
            },
            attributes: {
                message: 'Failed to deserialize filters'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        shouldSuppressErrors
    ]);
};
const $df8b3ad8c9e75684$var$EMPTY_FILTER = {};
const $df8b3ad8c9e75684$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
    const { jql: jql, setFilter: setFilter } = (0, $lEWmB.useFilters)();
    const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $df8b3ad8c9e75684$export$ac7ff3aa0620d1a7();
    const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, $jhNgz.useFieldConfigWithCustomFields)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allowCustomFields: allowCustomFields
    });
    const [filters, setFilters] = (0, $eUqFw.useState)({});
    const [error, setError] = (0, $eUqFw.useState)(null);
    const hasFilterError = error != null;
    const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $eUqFw.useState)(false);
    const [filtersCache, setFiltersCache] = (0, $eUqFw.useState)({});
    const { data: filterFields, loading: isLoadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const { quickFiltersJql: quickFiltersJql } = (0, $9GlEj.useQuickFilters)();
    (0, $eUqFw.useEffect)(()=>{
        // Skip if loading
        if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
        // Skip if no fields supported
        if (!Object.keys(fieldConfig).length) return;
        // Skip if deserialised this jql before
        if (jql != null && filters === filtersCache[jql]) return;
        // Skip if has error and jql not empty
        if (hasFilterError && jql != null) return;
        if (jql == null) {
            if (hasFilterError) setError(null);
            if (filters !== $df8b3ad8c9e75684$var$EMPTY_FILTER) setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (quickFiltersJql !== null) {
            setFilters($df8b3ad8c9e75684$var$EMPTY_FILTER);
            return;
        }
        if (filtersCache[jql]) {
            setFilters(filtersCache[jql]);
            return;
        }
        setIsDeserialisingFilters(true);
        (0, $coMWQ.deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
            setFilters(result);
            setFiltersCache({
                ...filtersCache,
                [jql]: result
            });
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setIsDeserialisingFilters(false);
        });
    }, [
        hasFilterError,
        quickFiltersJql,
        error,
        filters,
        isLoadingFieldConfig,
        isLoadingFilterFields,
        fieldConfig,
        jql,
        filtersCache,
        filterFields,
        resolvers,
        isDeserialisingFilters
    ]);
    $df8b3ad8c9e75684$var$useErrorDeserializeAnalytics({
        allowedFieldTypes: allowedFieldTypes,
        error: error
    });
    (0, $gZpkQ.useInferHideDoneItemsWithFilters)({
        filters: filters
    });
    (0, $eUqFw.useEffect)(()=>{
        if (setContextFilters) setContextFilters(filters);
    }, [
        filters,
        setContextFilters
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (setIsLoadingFilters) setIsLoadingFilters(isLoadingFieldConfig || isDeserialisingFilters);
    }, [
        isDeserialisingFilters,
        isLoadingFieldConfig,
        setIsLoadingFilters
    ]);
    return {
        fieldConfig: fieldConfig,
        filters: filters,
        hasFilterError: hasFilterError,
        customFieldsLoader: customFieldsLoader,
        setFilters: setFilter
    };
};

});
parcelRegister("jhNgz", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigWithCustomFields", () => $d017338cf4a59425$export$9f6dc7e3584916fa);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $ejYlo = parcelRequire("ejYlo");

var $bPRqC = parcelRequire("bPRqC");

var $aWjLM = parcelRequire("aWjLM");
const $d017338cf4a59425$var$emptySet = new Set();
const $d017338cf4a59425$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
    const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, $bPRqC.useFieldConfig)({
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId
    });
    (0, $eUqFw.useEffect)(()=>{
        setFieldConfig({
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loading
        });
    }, [
        fieldConfig,
        resolvers,
        loading,
        setFieldConfig
    ]);
    return null;
};
const $d017338cf4a59425$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
    const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $eUqFw.useMemo)(()=>{
        // split allowedFieldTypes into new and old input for useFieldConfigV2 and useFieldConfigOld
        const newTypes = new Set(allowedFieldTypes);
        const oldTypes = new Set();
        (0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
            if (allowedFieldTypes.has(type)) {
                newTypes.delete(type);
                oldTypes.add(type);
            }
        });
        return [
            newTypes,
            oldTypes
        ];
    }, [
        allowedFieldTypes
    ]);
    const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
    const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
    const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
    const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, $aWjLM.useFieldConfigV2)({
        view: view,
        allowedFieldTypes: newAllowedFieldTypes
    });
    const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $eUqFw.useState)({
        fieldConfig: {},
        resolvers: {},
        loading: shouldLoadOldFieldConfig
    });
    const customFieldsLoader = (0, $eUqFw.useMemo)(()=>{
        if (!shouldLoadOldFieldConfig) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d017338cf4a59425$var$CustomFieldsLoader, {
            allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $d017338cf4a59425$var$emptySet,
            allowedAliasFieldId: allowedAliasFieldId,
            setFieldConfig: setFieldConfig
        });
    }, [
        allowCustomFields,
        allowedAliasFieldId,
        oldAllowedFieldTypes,
        shouldLoadOldFieldConfig
    ]);
    const { fetchUsers: fetchUsers } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes
    });
    const fieldConfig = (0, $eUqFw.useMemo)(()=>{
        const aliasFields = {};
        const otherFields = {};
        Object.keys(fieldConfigOld).forEach((id)=>{
            if (fieldConfigOld[id].systemType === (0, $lO4Or.PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, $lO4Or.USER_CF_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fieldConfigOld[id] = {
                ...fieldConfigOld[id],
                loadOptions: fetchUsers
            };
            // We want to assure that alias fields are always at the end of the filter
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
            else otherFields[id] = fieldConfigOld[id];
        });
        return {
            ...otherFields,
            ...fieldConfigNew,
            ...aliasFields
        };
    }, [
        fieldConfigOld,
        fieldConfigNew,
        fetchUsers
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: {
            ...resolversOld,
            ...resolversNew
        },
        customFieldsLoader: customFieldsLoader,
        loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
    };
};

});
parcelRegister("ejYlo", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $a250a9d5a7d089ab$export$6cb851ed13e3949e);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

var $4Zgod = parcelRequire("4Zgod");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");


var $bRzz9 = parcelRequire("bRzz9");
const $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows of the priority filter
const $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50; // Increased initial number of options fetched
const $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
// TODO: remove shouldFetchSprints and keep shouldFetchSoftwareFields after clean up  jsw_list_view_-_all_the_fields
const $a250a9d5a7d089ab$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$a48313dd44fc9855),
                variables: {
                    cloudId: cloudId,
                    first: $a250a9d5a7d089ab$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                    jql: jqlContext,
                    shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE))),
                    shouldFetchSoftwareFields: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, $lO4Or.FIX_VERSIONS_TYPE))),
                    shouldFetchParentField: Boolean((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')),
                    shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, $lO4Or.GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va')),
                    goalsJqlTerm: goalsJqlTerm && (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? goalsJqlTerm : '',
                    sprintsJqlContext: allowedFieldTypes?.has((0, $lO4Or.SPRINT_TYPE)) ? `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}` : undefined
                }
            })
        });
        if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        const hydratedValues = jqlURLParam ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParam) : null;
        const transformedInitialData = (0, $bRzz9.transformInitialData)(response.data);
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            return (0, $5IIOI.mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
        }
        return transformedInitialData;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $bRzz9.fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
    }
    return null;
};
const $a250a9d5a7d089ab$var$memoizedFetchInitialData = (0, $5iWql.default)($a250a9d5a7d089ab$var$fetchInitialDataInternal);
const $a250a9d5a7d089ab$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, $4Zgod.EMPTY_TEAMS));
const $a250a9d5a7d089ab$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const [jqlURLParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const goalsJqlTerm = (0, $bRzz9.useGoalsJqlTerm)(filterFields);
    let fetchTeamsService = $a250a9d5a7d089ab$var$fetchTeamsServiceFnc;
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) // eslint-disable-next-line react-hooks/rules-of-hooks
    fetchTeamsService = (0, $4Zgod.useFetchTeams)();
    const fetchInitialData = (0, $eUqFw.useCallback)(async ()=>{
        if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
            $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
            fetchTeamsService({
                first: $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS
            })
        ]).then((values)=>{
            let result = (0, $kIODn.EMPTY_TRANSFORMED_DATA);
            values.forEach((value)=>{
                result = {
                    ...result,
                    ...value
                };
            });
            return result;
        });
        return $a250a9d5a7d089ab$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
    }, [
        allowedFieldTypes,
        cloudId,
        fetchTeamsService,
        goalsJqlTerm,
        jqlContext
    ]);
    const fetchData = (0, $eUqFw.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
            body: JSON.stringify({
                query: (0, $8d92abf0af87bfd8$export$f8e8a5f34f6ea725),
                variables: {
                    cloudId: cloudId,
                    first: first,
                    jqlTerm: fieldName,
                    jql: jqlContextProp ?? jqlContext,
                    searchString: query,
                    after: afterCursor
                }
            })
        });
        if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        return response.data.jira.jqlBuilder.fieldValues;
    }, [
        cloudId,
        jqlContext
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'labels',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchComponents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'component',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchPriorities = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'priority',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformPriorities)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'assignee',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformUsers)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchIssueTypes = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'issuetype',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            let options = (0, $kIODn.transformIssueTypes)(fieldValuesData);
            if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
            return {
                totalCount: fieldValuesData.totalCount,
                options: options
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        view
    ]);
    const fetchStatuses = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'status',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformStatuses)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchCategories = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $a250a9d5a7d089ab$var$MAX_NUMBER_OF_OPTIONS })=>{
        try {
            const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                body: JSON.stringify({
                    query: (0, $8d92abf0af87bfd8$export$562e34ec948f373d),
                    variables: {
                        first: first,
                        jql: jqlContext,
                        searchQuery: query,
                        after: afterCursor
                    }
                })
            });
            if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
            return {
                totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                options: (0, $kIODn.transformCategories)(response.data.jira.jwmCategoryOptions)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        jqlContext
    ]);
    const fetchSprints = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'sprint',
                query: query,
                first: first,
                afterCursor: afterCursor,
                jqlContext: `${jqlContext} AND ${$a250a9d5a7d089ab$var$ACTIVE_SPRINTS_JQL}`
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformSprints)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        jqlContext
    ]);
    const fetchFixVersions = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'fixVersion',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformDefaultField)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchParents = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: 'parent',
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformParent)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData
    ]);
    const fetchGoals = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        if (!goalsJqlTerm) return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const fieldValuesData = await fetchData({
                fieldName: goalsJqlTerm,
                query: query,
                first: first,
                afterCursor: afterCursor
            });
            return {
                totalCount: fieldValuesData.totalCount,
                options: (0, $kIODn.transformGoals)(fieldValuesData)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchData,
        goalsJqlTerm
    ]);
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
        try {
            const fieldValuesData = await fetchTeamsService({
                query: query,
                first: first,
                after: afterCursor
            });
            return fieldValuesData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $bRzz9.fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
        }
        return $a250a9d5a7d089ab$var$EMPTY_FIELD_DATA;
    }, [
        fetchTeamsService
    ]);
    return {
        fetchInitialData: fetchInitialData,
        fetchLabels: fetchLabels,
        fetchComponents: fetchComponents,
        fetchPriorities: fetchPriorities,
        fetchUsers: fetchUsers,
        fetchIssueTypes: fetchIssueTypes,
        fetchStatuses: fetchStatuses,
        fetchCategories: fetchCategories,
        fetchSprints: fetchSprints,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            fetchFixVersions: fetchFixVersions,
            fetchParents: fetchParents,
            fetchTeams: fetchTeams
        } : {},
        fetchGoals: fetchGoals
    };
};

});
parcelRegister("kIODn", function(module, exports) {

$parcel$export(module.exports, "transformPriorities", () => $661a0fc6907b6ea1$export$86ca92dec35c4797);
$parcel$export(module.exports, "transformUsers", () => $661a0fc6907b6ea1$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformIssueTypes", () => $661a0fc6907b6ea1$export$4c05e2584b34e4d8);
$parcel$export(module.exports, "transformStatuses", () => $661a0fc6907b6ea1$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformCategories", () => $661a0fc6907b6ea1$export$1b389c47cf1df04e);
$parcel$export(module.exports, "transformDefaultField", () => $661a0fc6907b6ea1$export$6133e08eeff30d5f);
$parcel$export(module.exports, "transformSprints", () => $661a0fc6907b6ea1$export$6a33be7fc7f04943);
$parcel$export(module.exports, "transformGoals", () => $661a0fc6907b6ea1$export$673d4fceed3e8383);
$parcel$export(module.exports, "transformParent", () => $661a0fc6907b6ea1$export$87e9766fb5100314);
$parcel$export(module.exports, "transformTeams", () => $661a0fc6907b6ea1$export$fd398a52d6f57b46);
$parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", () => $661a0fc6907b6ea1$export$ca9df9cab9cc134f);
$parcel$export(module.exports, "transformValuesData", () => $661a0fc6907b6ea1$export$8e327b5f9ebc175d);
/* eslint-disable complexity */ 
var $lyOYo = parcelRequire("lyOYo");

var $lO4Or = parcelRequire("lO4Or");
const $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
const $661a0fc6907b6ea1$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
const $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
const $661a0fc6907b6ea1$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node.priority.iconUrl || ''
        }));
const $661a0fc6907b6ea1$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: node?.user?.picture || ''
        }));
const $661a0fc6907b6ea1$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            id: $661a0fc6907b6ea1$var$getFirstIssueTypeId(node),
            avatar: $661a0fc6907b6ea1$var$getFirstIssueTypeAvatar(node) || '',
            square: true,
            hierarchyLevel: $661a0fc6907b6ea1$var$getFirstIssueTypeHierarchyLevel(node) || 0
        }));
const $661a0fc6907b6ea1$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            categoryId: node.statusCategory.statusCategoryId
        }));
const $661a0fc6907b6ea1$export$1b389c47cf1df04e = (data)=>{
    const transformedCategories = data.edges.map((edge)=>({
            cursor: edge?.cursor,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            value: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            label: edge.node.option.value,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            color: edge.node.color
        }));
    // Remove any categories that have the same name across multiple projects
    return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(transformedCategories, ({ value: value })=>value);
};
const $661a0fc6907b6ea1$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName
        }));
const $661a0fc6907b6ea1$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.displayName,
            label: node.sprint?.name || ''
        }));
const $661a0fc6907b6ea1$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
            cursor: cursor,
            value: node.jqlTerm,
            label: node.goal.name || '',
            status: node.goal.status || ''
        }));
const $661a0fc6907b6ea1$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
        let avatar = '';
        if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
        return {
            cursor: cursor,
            value: node.jqlTerm,
            label: node.displayName,
            avatar: avatar
        };
    });
const $661a0fc6907b6ea1$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
            cursor: data.pageInfo?.endCursor,
            value: node.team.id.replace('ari:cloud:identity::team/', ''),
            label: node.team.displayName || '',
            avatar: node.team.smallAvatarImageUrl || ''
        }));
// Type predicted
const $661a0fc6907b6ea1$var$isIssueType = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issueTypes' in node);
};
const $661a0fc6907b6ea1$var$isPriority = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'priority' in node);
};
const $661a0fc6907b6ea1$var$isStatus = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'statusCategory' in node);
};
const $661a0fc6907b6ea1$var$isSprint = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'sprint' in node);
};
const $661a0fc6907b6ea1$var$isGoal = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'goal' in node);
};
const $661a0fc6907b6ea1$var$isParent = (fieldValue)=>{
    const { node: node } = fieldValue.edges[0];
    return Boolean(node && 'issue' in node);
};
// any fieldValue could be a UserFieldValues because the edges could have some node with "user" undefined
// for example : { node: { displayName: "administrators", jqlTerm: "membersOf(administrators)" }}
const $661a0fc6907b6ea1$var$isUser = (fieldValue)=>true;
const $661a0fc6907b6ea1$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
const $661a0fc6907b6ea1$export$ca9df9cab9cc134f = {
    labels: {
        totalCount: 0,
        options: []
    },
    components: {
        totalCount: 0,
        options: []
    },
    priority: {
        totalCount: 0,
        options: []
    },
    users: {
        totalCount: 0,
        options: []
    },
    issuetype: {
        totalCount: 0,
        options: []
    },
    status: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.CATEGORY_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.SPRINT_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.GOALS_CF_TYPE)]: {
        totalCount: 0,
        options: []
    },
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $661a0fc6907b6ea1$export$8e327b5f9ebc175d = (data)=>{
    const transformedData = {
        ...$661a0fc6907b6ea1$export$ca9df9cab9cc134f
    };
    Object.entries(data).forEach(([key, fieldValue])=>{
        if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
            case 'issuetype':
                if ($661a0fc6907b6ea1$var$isIssueType(fieldValue)) transformedData.issuetype = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$4c05e2584b34e4d8(fieldValue)
                };
                break;
            case 'priority':
                if ($661a0fc6907b6ea1$var$isPriority(fieldValue)) transformedData.priority = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$86ca92dec35c4797(fieldValue)
                };
                break;
            case 'status':
                if ($661a0fc6907b6ea1$var$isStatus(fieldValue)) transformedData.status = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$20a57a5ec025f2d(fieldValue)
                };
                break;
            case 'component':
            case 'components':
            case 'fixVersions':
            case 'labels':
                if ($661a0fc6907b6ea1$var$isDefaultField(fieldValue)) {
                    const transformedKey = key === 'component' ? (0, $lO4Or.COMPONENTS_TYPE) : key;
                    transformedData[transformedKey] = {
                        totalCount: fieldValue.totalCount,
                        options: $661a0fc6907b6ea1$export$6133e08eeff30d5f(fieldValue)
                    };
                }
                break;
            case 'parent':
                if ($661a0fc6907b6ea1$var$isParent(fieldValue)) transformedData[key] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$87e9766fb5100314(fieldValue)
                };
                break;
            default:
                if ($661a0fc6907b6ea1$var$isSprint(fieldValue)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$6a33be7fc7f04943(fieldValue)
                };
                else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $661a0fc6907b6ea1$var$isUser(fieldValue)) {
                    const usersData = $661a0fc6907b6ea1$export$fb8c90bfc4beaa59(fieldValue);
                    const userOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        ...usersData,
                        ...transformedData.users?.options ?? []
                    ], ({ value: value })=>value);
                    transformedData.users = {
                        totalCount: userOptions.length,
                        options: userOptions
                    };
                } else if ($661a0fc6907b6ea1$var$isGoal(fieldValue)) transformedData[0, $lO4Or.GOALS_CF_TYPE] = {
                    totalCount: fieldValue.totalCount,
                    options: $661a0fc6907b6ea1$export$673d4fceed3e8383(fieldValue)
                };
        }
    });
    return transformedData;
};

});

parcelRegister("4Zgod", function(module, exports) {

$parcel$export(module.exports, "EMPTY_TEAMS", () => $f012c42657d68d46$export$37430da53242c305);
$parcel$export(module.exports, "useFetchTeams", () => $f012c42657d68d46$export$da1ab223b3f1410c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $lO4Or = parcelRequire("lO4Or");

var $jD3pk = parcelRequire("jD3pk");

var $dWLk9 = parcelRequire("dWLk9");

var $kIODn = parcelRequire("kIODn");

// use ari functions from @atlassian/ari whenever it is ready for import
const $f012c42657d68d46$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
const $f012c42657d68d46$export$37430da53242c305 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
        totalCount: 0,
        options: []
    }
};
const $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS = 20;
const $f012c42657d68d46$export$da1ab223b3f1410c = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const fetchTeams = (0, $eUqFw.useCallback)(async ({ query: query, first: first = $f012c42657d68d46$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
        if (orgId) try {
            const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $1a073e75df73c791$export$cbe5a6af25588495),
                    variables: {
                        orgId: $f012c42657d68d46$var$prependOrgIdAri(orgId),
                        cloudId: cloudId,
                        queryString: query,
                        first: first,
                        after: after
                    }
                })
            });
            const options = (0, $kIODn.transformTeams)(response.data.team.teamSearchV2) || [];
            // Teams query doesn't return the total count
            const totalCount = options.length >= first ? first : options.length;
            return {
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
                    totalCount: totalCount,
                    options: options
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchTeams',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch team filter data'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return $f012c42657d68d46$export$37430da53242c305;
    }, [
        cloudId,
        orgId
    ]);
    return fetchTeams;
};

});
const $1a073e75df73c791$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;


parcelRegister("gF4D9", function(module, exports) {

$parcel$export(module.exports, "hydrateFilterValues", () => $12ce55db15189323$export$b18eef22aaa99c21);

var $5iWql = parcelRequire("5iWql");

var $6gPph = parcelRequire("6gPph");

var $dlVOn = parcelRequire("dlVOn");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

const $12ce55db15189323$export$3361e9be8093ddcc = (fields)=>{
    const hydratedValues = {};
    fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        hydratedValues[field.jqlTerm] = {
            edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                    node: item
                })),
            totalCount: 0
        };
    });
    return hydratedValues;
};
const $12ce55db15189323$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
            body: JSON.stringify({
                query: (0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? (0, $a02b4224be9155fa$export$2bd792833522f1f1) : (0, $a02b4224be9155fa$export$e8b5e80812d4a604),
                variables: {
                    cloudId: cloudId,
                    jql: jqlContext
                }
            })
        });
        if (response.errors != null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
        if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, $6gPph.QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
            throw new Error('Failed to fetch on hydrateFilterValuesService');
        }
        return $12ce55db15189323$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'JWMHydrateFilterValues',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $12ce55db15189323$export$b18eef22aaa99c21 = (0, $5iWql.default)($12ce55db15189323$export$7a89edfb546e2344);

});
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $a02b4224be9155fa$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$a02b4224be9155fa$var$FIELD_VALUE_NODE_FRAGMENT}
`;


parcelRegister("5IIOI", function(module, exports) {

$parcel$export(module.exports, "transformHydratedValues", () => $3cf74c17db7589d0$export$56282b201a60959e);
$parcel$export(module.exports, "mergeHydratedValues", () => $3cf74c17db7589d0$export$8f60413c08081990);

var $lyOYo = parcelRequire("lyOYo");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $3cf74c17db7589d0$var$transformHydratedValuesOld = (data)=>{
    const transformedHydratedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    Object.keys(data).forEach((key)=>{
        if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
            case 'issuetype':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformIssueTypes)(data[key])
                };
                return;
            case 'priority':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformPriorities)(data[key])
                };
                return;
            case 'status':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformStatuses)(data[key])
                };
                return;
            case 'labels':
                transformedHydratedData[key] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            case 'component':
                transformedHydratedData.components = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformDefaultField)(data[key])
                };
                return;
            default:
                if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                    totalCount: 0,
                    options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ...(0, $kIODn.transformUsers)(data[key]),
                        ...transformedHydratedData.users?.options ?? []
                    ], ({ value: value })=>value)
                };
                else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, $lO4Or.SPRINT_TYPE] = {
                    totalCount: 0,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    options: (0, $kIODn.transformSprints)(data[key])
                };
        }
    });
    return transformedHydratedData;
};
const $3cf74c17db7589d0$export$56282b201a60959e = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) return (0, $kIODn.transformValuesData)(data);
    return $3cf74c17db7589d0$var$transformHydratedValuesOld(data);
};
const $3cf74c17db7589d0$export$8f60413c08081990 = (initialData, hydratedValues)=>({
        labels: {
            totalCount: initialData.labels.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.labels.options,
                ...initialData.labels.options
            ], ({ value: value })=>value)
        },
        components: {
            totalCount: initialData.components.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.components.options,
                ...initialData.components.options
            ], ({ value: value })=>value)
        },
        priority: {
            totalCount: initialData.priority.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.priority.options,
                ...initialData.priority.options
            ], ({ value: value })=>value)
        },
        users: {
            totalCount: initialData.users.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.users.options,
                ...initialData.users.options
            ], ({ value: value })=>value)
        },
        issuetype: {
            totalCount: initialData.issuetype.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.issuetype.options,
                ...initialData.issuetype.options
            ], ({ value: value })=>value)
        },
        status: {
            totalCount: initialData.status.totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues.status.options,
                ...initialData.status.options
            ], ({ value: value })=>value)
        },
        // hydrate values endpoint doesn't support categories
        [(0, $lO4Or.CATEGORY_TYPE)]: initialData[0, $lO4Or.CATEGORY_TYPE],
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: initialData[0, $lO4Or.SPRINT_TYPE].totalCount,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.SPRINT_TYPE].options,
                ...initialData[0, $lO4Or.SPRINT_TYPE].options
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
            totalCount: initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || [],
                ...initialData[0, $lO4Or.FIX_VERSIONS_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.PARENT_FIELD_TYPE)]: {
            totalCount: initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.PARENT_FIELD_TYPE]?.options || [],
                ...initialData[0, $lO4Or.PARENT_FIELD_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.GOALS_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.GOALS_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.GOALS_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.GOALS_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        },
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
            options: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...hydratedValues[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || [],
                ...initialData[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE]?.options || []
            ], ({ value: value })=>value)
        }
    });

});

const $8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $8d92abf0af87bfd8$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$8d92abf0af87bfd8$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $8d92abf0af87bfd8$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$8d92abf0af87bfd8$var$CATEGORY_CONNECTION_FRAGMENT}
`;

parcelRegister("bRzz9", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $26047d310e78058e$export$93219b8691fe49a0);
$parcel$export(module.exports, "fireFieldValuesErrorAnalytics", () => $26047d310e78058e$export$c3c62a63250fc6f8);
$parcel$export(module.exports, "useGoalsJqlTerm", () => $26047d310e78058e$export$674eff5ec8403101);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $kIODn = parcelRequire("kIODn");
const $26047d310e78058e$var$transformInitialCategories = (data)=>{
    if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
        totalCount: data.jira.jwmCategoryOptions.totalCount,
        options: (0, $kIODn.transformCategories)(data.jira.jwmCategoryOptions)
    };
    return undefined;
};
const $26047d310e78058e$var$transformInitialDataOld = (data)=>{
    const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
    const transformedData = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, $lO4Or.SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
        totalCount: components.totalCount,
        options: (0, $kIODn.transformDefaultField)(components)
    };
    if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
        totalCount: issuetype.totalCount,
        options: (0, $kIODn.transformIssueTypes)(issuetype)
    };
    if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
        totalCount: priority.totalCount,
        options: (0, $kIODn.transformPriorities)(priority)
    };
    if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
        totalCount: labels.totalCount,
        options: (0, $kIODn.transformDefaultField)(labels)
    };
    if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
        totalCount: status.totalCount,
        options: (0, $kIODn.transformStatuses)(status)
    };
    if (users?.edges != null && Array.isArray(users.edges)) {
        const usersData = (0, $kIODn.transformUsers)(users);
        const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, $kIODn.transformUsers)(recentlyUsedUsers) : null;
        transformedData.users = {
            totalCount: users.totalCount,
            options: // combine `recentlyUsedUsers` and `users` options to improve relevancy of the users field
            recentlyUsedUsersData != null ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
                ...recentlyUsedUsersData,
                ...usersData
            ], ({ value: value })=>value) : usersData
        };
    }
    const categories = $26047d310e78058e$var$transformInitialCategories(data);
    if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
    if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, $lO4Or.SPRINT_TYPE] = {
        options: (0, $kIODn.transformSprints)(sprints),
        totalCount: sprints.totalCount
    };
    return transformedData;
};
const $26047d310e78058e$export$93219b8691fe49a0 = (data)=>{
    if ((0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
        const transformedData = (0, $kIODn.transformValuesData)(data.jira.jqlBuilder);
        const categories = $26047d310e78058e$var$transformInitialCategories(data);
        if (categories) transformedData[0, $lO4Or.CATEGORY_TYPE] = categories;
        return transformedData;
    }
    return $26047d310e78058e$var$transformInitialDataOld(data);
};
const $26047d310e78058e$export$c3c62a63250fc6f8 = (errorId, errorMessage, // eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>{
    (0, $guiFP.default)({
        meta: {
            id: errorId,
            packageName: 'jiraBusinessFilters',
            teamName: 'wanjel'
        },
        attributes: {
            message: errorMessage
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $26047d310e78058e$export$674eff5ec8403101 = (filterFields)=>{
    const goalsJqlTerm = (0, $eUqFw.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, $lO4Or.GOALS_CF_TYPE))?.id, [
        filterFields
    ]);
    return goalsJqlTerm;
};

});


parcelRegister("bPRqC", function(module, exports) {

$parcel$export(module.exports, "useFieldConfig", () => $527c6b4310270d47$export$70da50df1be2dbe1);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $jGcn0 = parcelRequire("jGcn0");

var $35jYz = parcelRequire("35jYz");
var $gEmpR = parcelRequire("gEmpR");

var $ihkPC = parcelRequire("ihkPC");

var $fP7qq = parcelRequire("fP7qq");

var $e20I1 = parcelRequire("e20I1");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $kJlBc = parcelRequire("kJlBc");

var $dWLk9 = parcelRequire("dWLk9");

var $gF4D9 = parcelRequire("gF4D9");

var $5IIOI = parcelRequire("5IIOI");

var $a75Ge = parcelRequire("a75Ge");

var $7G14t = parcelRequire("7G14t");

var $ijEQD = parcelRequire("ijEQD");
const $527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS = 10;
const $527c6b4310270d47$var$useFilterMapper = true;
const $527c6b4310270d47$var$EMPTY_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_USER_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY = [];
const $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY = [];
const $527c6b4310270d47$export$1fe8227c57fa0d68 = ()=>({
        initialUsers: {
            data: $527c6b4310270d47$var$EMPTY_USER_ARRAY,
            isLoading: false
        },
        initialLabels: {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        },
        initialComponents: {
            data: $527c6b4310270d47$var$EMPTY_COMPONENT_ARRAY,
            isLoading: false
        },
        initialCategories: {
            data: $527c6b4310270d47$var$EMPTY_CATEGORY_ARRAY,
            isLoading: false
        },
        projectKey: null
    });
const $527c6b4310270d47$export$74cea4b24a6bc9fa = $527c6b4310270d47$export$1fe8227c57fa0d68();
const $527c6b4310270d47$var$useForceUpdate = ()=>{
    const [, setValue] = (0, $eUqFw.useState)(0);
    return (0, $eUqFw.useCallback)(()=>setValue((value)=>value + 1), []);
};
const $527c6b4310270d47$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [userResolver] = (0, $eUqFw.useState)(new (0, $e20I1.UserResolver)());
    const forceUpdate = $527c6b4310270d47$var$useForceUpdate();
    // this is used to check whether the hook is still mounted by the time we call fireErrorAnalytics
    // see JET-2324
    const mounted = (0, $eUqFw.useRef)(true);
    const [priorityFieldConfig] = (0, $35jYz.useIssueTypeFieldConfig)({
        screen: 'VIEW',
        issueTypeId: 'default',
        fieldId: 'priority'
    });
    const { data: issueTypeData } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const formattedCategoryOptions = (0, $eUqFw.useMemo)(()=>{
        const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, $lO4Or.CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
        return categoryOptions.map(({ value: value })=>({
                label: value,
                value: value
            }));
    }, [
        issueTypeData
    ]);
    const { statuses: statuses, loading: loadingStatuses } = (0, $a75Ge.useProjectStatuses)();
    const [{ match: { params: { projectKey: projectKey } } }] = (0, $kJlBc.useRouter)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const [jqlURLParam] = (0, $kJlBc.useQueryParam)((0, $jGcn0.FILTER_PARAM));
    const jqlURLParamRef = (0, $eUqFw.useRef)(jqlURLParam);
    const hydratedUsers = (0, $eUqFw.useRef)(null);
    const fetchInitialUsers = (0, $eUqFw.useCallback)(async ()=>{
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
        let users = [];
        const hydratedValues = jqlURLParamRef.current ? await (0, $gF4D9.hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
        if (hydratedValues !== null) {
            const transformedHydratedValues = (0, $5IIOI.transformHydratedValues)(hydratedValues);
            hydratedUsers.current = transformedHydratedValues.users.options;
        }
        const url = `/rest/api/3/user/search?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=`;
        users = await (0, $2OdyW.default)(url);
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers = {
            data: users,
            isLoading: false
        };
        forceUpdate();
        return users;
    }, [
        cloudId,
        forceUpdate
    ]);
    const fetchInitialLabels = (0, $eUqFw.useCallback)(async ()=>{
        const url = `/rest/api/3/label?maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}`;
        try {
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
            const response = await (0, $2OdyW.default)(url);
            const labels = response.values;
            $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
                data: labels,
                isLoading: false
            };
            forceUpdate();
            return labels;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterInitialLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch initial labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels = {
            data: $527c6b4310270d47$var$EMPTY_ARRAY,
            isLoading: false
        };
        forceUpdate();
        return $527c6b4310270d47$var$EMPTY_ARRAY;
    }, [
        forceUpdate
    ]);
    const fetchUsers = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) {
            const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$527c6b4310270d47$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
            try {
                const response = await (0, $2OdyW.default)(url);
                return response;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'searchFilterUsers',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search users',
                        errorType: (0, $ihkPC.getErrorType)(err),
                        online: window.navigator.onLine,
                        mounted: mounted.current
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
        return $527c6b4310270d47$var$EMPTY_USER_ARRAY;
    }, [
        projectKey
    ]);
    const fetchProjectComponents = (0, $eUqFw.useCallback)(async (query = '')=>{
        if (projectKey != null) try {
            const response = await (0, $fP7qq.fetchComponents)({
                inputValue: query,
                autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                useFilterMapper: $527c6b4310270d47$var$useFilterMapper,
                mounted: mounted.current
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $guiFP.default)({
                meta: {
                    id: 'fetchFilterComponents',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch components',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return [];
    }, [
        projectKey
    ]);
    const fetchLabels = (0, $eUqFw.useCallback)((query = '')=>(0, $2OdyW.default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'searchFilterLabels',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to search labels',
                    errorType: (0, $ihkPC.getErrorType)(err),
                    online: window.navigator.onLine,
                    mounted: mounted.current
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
        }), []);
    const fetchProjectCategories = (0, $eUqFw.useCallback)((query = '')=>{
        // TODO Replace with back end fetch API
        const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
        return Promise.resolve(filteredCategoriesQuery ?? []);
    }, [
        formattedCategoryOptions
    ]);
    const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)
    });
    const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, $7G14t.useGroupItemValues)({
        groupFieldId: (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
    }, [
        allowedAliasFieldId,
        fetchInitialStoryPointsEstimateData
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKey != null && // Initially fetch for everything if projectKey is updated or users is empty
        ($527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey !== projectKey || $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.data === $527c6b4310270d47$var$EMPTY_USER_ARRAY)) {
            if ($527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                $527c6b4310270d47$export$74cea4b24a6bc9fa.projectKey = projectKey;
                fetchInitialUsers();
            }
        }
    }, [
        fetchInitialUsers,
        fetchProjectComponents,
        projectKey,
        fetchInitialLabels,
        fetchProjectCategories,
        forceUpdate
    ]);
    const { data: initialUsers, isLoading: isLoadingUsers } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialUsers;
    const { data: initialLabels, isLoading: isLoadingLabels } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialLabels;
    const { data: initialComponents, isLoading: isLoadingComponents } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialComponents;
    const { data: initialCategories, isLoading: isLoadingCategories } = $527c6b4310270d47$export$74cea4b24a6bc9fa.initialCategories;
    const fieldOptionsData = (0, $eUqFw.useMemo)(()=>({
            priority: (0, $ijEQD.transformPriority)(priorityFieldConfig),
            issuetype: (0, $ijEQD.transformIssueType)(issueTypeData),
            status: (0, $ijEQD.transformStatuses)(statuses),
            users: (0, $ijEQD.transformUsers)(initialUsers),
            labels: (0, $ijEQD.transformLabels)(initialLabels),
            components: initialComponents,
            [(0, $lO4Or.CATEGORY_TYPE)]: initialCategories,
            [(0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
            [(0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
        }), [
        priorityFieldConfig,
        issueTypeData,
        statuses,
        initialUsers,
        initialLabels,
        initialComponents,
        initialCategories,
        initialStoryPoints?.options,
        initialStoryPointsEstimate?.options
    ]);
    fieldOptionsData.users = (0, $eUqFw.useMemo)(()=>{
        if (hydratedUsers.current === null) return fieldOptionsData.users;
        return (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
            ...hydratedUsers.current ?? [],
            ...fieldOptionsData.users ?? []
        ], ({ value: value })=>value);
    }, [
        fieldOptionsData
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $ijEQD.getFilterFieldConfigAndResolvers)({
        formatMessage: formatMessage,
        allowedFieldTypes: allowedFieldTypes,
        allowedAliasFieldId: allowedAliasFieldId,
        allFields: issueTypeData.fields,
        fieldOptionsData: fieldOptionsData,
        fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, $ijEQD.transformUsers)(users || [])),
        fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, $ijEQD.transformLabelSuggestions)(labels) : []),
        fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
        fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
        userResolver: userResolver
    });
    const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingStatuses || fetching
    };
};

});
parcelRegister("ihkPC", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $348eddd0ac284a22$export$e19f9f08a6d79fd2);

var $7byHA = parcelRequire("7byHA");
const $348eddd0ac284a22$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
const $348eddd0ac284a22$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
const $348eddd0ac284a22$export$d46a05f8561f868a = 'OTHER';
const $348eddd0ac284a22$export$c748438cec453c9f = {
    FAILED_TO_FETCH: 'Failed to fetch',
    NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
    NETWORK_REQUEST_FAILED: 'Network request failed',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    ABORTED: 'operation was aborted.',
    CANCELLED: 'cancelled',
    TIMEOUT: 'The request timed out.'
};
const $348eddd0ac284a22$var$isApolloClientNetworkError = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>error.networkError !== undefined && error.networkError !== null;
const $348eddd0ac284a22$export$e19f9f08a6d79fd2 = (error)=>{
    if (error == null) return $348eddd0ac284a22$export$9705762bba4e9e25;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode) return `FETCH_ERROR_${statusCode}`;
    }
    if ($348eddd0ac284a22$var$isApolloClientNetworkError(error)) return $348eddd0ac284a22$export$7453182ebe5973d4;
    const entry = Object.entries($348eddd0ac284a22$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    return entry ? entry[0] : $348eddd0ac284a22$export$d46a05f8561f868a;
};

});

parcelRegister("fP7qq", function(module, exports) {

$parcel$export(module.exports, "fetchComponents", () => $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3);
$parcel$export(module.exports, "mapComponentsToOptions", () => (parcelRequire("a9hW2")).mapComponentsToOptions);

var $53ciZ = parcelRequire("53ciZ");

var $ihkPC = parcelRequire("ihkPC");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $a9hW2 = parcelRequire("a9hW2");
const $9fb5f20e4a6bfa39$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, mounted: mounted, queryParameters: queryParameters })=>{
    const mapperFunction = useFilterMapper === true ? (0, $a9hW2.mapComponentsToFilterOptions) : (0, $a9hW2.mapComponentsToOptions);
    const query = (0, $1ybV0.ff)('jira.list.field-support-part1') ? (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue,
        ...queryParameters
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue
    });
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectComponents',
                packageName: 'jiraBusinessFetchComponents',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to fetch jwm project components',
                errorType: (0, $ihkPC.getErrorType)(error),
                online: window.navigator.onLine,
                mounted: mounted
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});
parcelRegister("a9hW2", function(module, exports) {

$parcel$export(module.exports, "mapComponentsToOptions", () => $c0b17925cb48a958$export$85e44418187c2c1e);
$parcel$export(module.exports, "mapComponentsToFilterOptions", () => $c0b17925cb48a958$export$b4ef58d3e943e4d5);
const $c0b17925cb48a958$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
            label: name,
            value: componentId !== undefined ? String(componentId) : String(id)
        }));
const $c0b17925cb48a958$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
            label: name,
            value: name
        }));

});


parcelRegister("e20I1", function(module, exports) {

$parcel$export(module.exports, "UserResolver", () => $2f3c56b3440530f6$export$723df28d03868f02);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
class $2f3c56b3440530f6$export$723df28d03868f02 {
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        this.getUsersFromAccountId = (accountIds)=>{
            const recoveredFromCache = [];
            const missingFromCache = [];
            accountIds.forEach((accountId)=>{
                const user = this.cache.get(accountId);
                if (user) recoveredFromCache.push(user);
                else missingFromCache.push(accountId);
            });
            if (missingFromCache.length === 0) // @ts-expect-error - User is not assignable to type 'string'
            return Promise.resolve(recoveredFromCache);
            return (0, $2OdyW.default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && // @ts-expect-error - TS2339 - Property 'forEach' does not exist on type '() => IterableIterator<Readonly<Partial<Diff<ResponseSuccess, Record<any, any>>> & { accountId: string | null; displayName: string; avatarUrls: { readonly "48x48"?: string | undefined; readonly "32x32"?: string | undefined; readonly "24x24"?: string | undefined; readonly "16x16"?: string | undefined; }; }>>'. | TS7006 - Parameter 'user' implicitly has an 'any' type.
                response.values.forEach((user)=>{
                    if (user) this.cache.set(user.accountId, user);
                })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                (0, $gUUjF.default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
            });
        };
        this.cache = new Map();
    }
}

});

parcelRegister("7G14t", function(module, exports) {

$parcel$export(module.exports, "useGroupItemValues", () => $f05aa0c8a487bc66$export$f05af123f98299b0);

var $eUqFw = parcelRequire("eUqFw");

var $NFHn0 = parcelRequire("NFHn0");

var $eZbpk = parcelRequire("eZbpk");

var $dlVOn = parcelRequire("dlVOn");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lKPnc = parcelRequire("lKPnc");

var $fOoev = parcelRequire("fOoev");
const $f05aa0c8a487bc66$var$reducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                loading: true
            };
        case 'success':
            return {
                loading: false,
                data: action.payload
            };
        case 'error':
            return {
                loading: false,
                data: null
            };
        default:
            return state;
    }
};
const $f05aa0c8a487bc66$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($f05aa0c8a487bc66$var$reducer, {
        loading: false
    });
    const jqlContext = (0, $eZbpk.useJqlContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchDataAbortable = (0, $NFHn0.useAbortable)((0, $lKPnc.fetchGroupItemValues));
    const fetch = (0, $eUqFw.useCallback)(async ()=>{
        try {
            dispatch({
                type: 'loading'
            });
            const response = await fetchDataAbortable(groupFieldId, jqlContext);
            if (response.data?.items == null) throw new (0, $dlVOn.GraphQLErrors)(response.errors);
            dispatch({
                type: 'success',
                payload: (0, $fOoev.transformInitialData)({
                    data: response.data,
                    formatMessage: formatMessage
                })
            });
        } catch (error) {
            if (error === (0, $NFHn0.ABORTED)) return;
            dispatch({
                type: 'error'
            });
        }
    }, [
        fetchDataAbortable,
        formatMessage,
        groupFieldId,
        jqlContext
    ]);
    return {
        fetch: fetch,
        data: state.data,
        loading: state.loading
    };
};

});
parcelRegister("NFHn0", function(module, exports) {

$parcel$export(module.exports, "ABORTED", () => $f9f77c4f962e82bc$export$23e29024ea698a35);
$parcel$export(module.exports, "useAbortable", () => $f9f77c4f962e82bc$export$a487c7eb4387f959);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eUqFw = parcelRequire("eUqFw");
const $f9f77c4f962e82bc$export$23e29024ea698a35 = Symbol('ABORTED');
const $f9f77c4f962e82bc$export$a487c7eb4387f959 = (fetch)=>{
    const prevControllerRef = (0, $eUqFw.useRef)(null);
    return (0, $eUqFw.useCallback)((...args)=>{
        if (prevControllerRef.current) prevControllerRef.current.abort();
        const controller = new AbortController();
        prevControllerRef.current = controller;
        return fetch(controller.signal, ...args).catch((error)=>{
            if (controller.signal.aborted) throw $f9f77c4f962e82bc$export$23e29024ea698a35;
            else throw error;
        });
    }, [
        fetch
    ]);
};

});

parcelRegister("lKPnc", function(module, exports) {

$parcel$export(module.exports, "fetchGroupItemValues", () => $8489c6f37b087f09$export$7e6e0c3f4468ce45);

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");
var $lRmyA = parcelRequire("lRmyA");

const $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS = 20; // min number to render two rows
const $8489c6f37b087f09$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
    try {
        const variables = {
            fieldId: groupFieldId,
            first: $8489c6f37b087f09$var$MAX_NUMBER_OF_OPTIONS,
            jql: jqlContext
        };
        const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
            body: JSON.stringify({
                query: (0, $622211c2999f2f37$export$a48313dd44fc9855),
                variables: variables
            })
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!(0, $JRB5w.isHttpClientErrorResponse)(error) && !signal.aborted) (0, $guiFP.default)({
            meta: {
                id: 'initializeFilterGroupItemsData',
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: 'Failed to initialize filter data using the group query'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
const $622211c2999f2f37$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;


parcelRegister("fOoev", function(module, exports) {

$parcel$export(module.exports, "transformInitialData", () => $2b76e62e743cb9ff$export$93219b8691fe49a0);

var $ivaRx = parcelRequire("ivaRx");
const $2b76e62e743cb9ff$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
        totalCount: data.items.totalCount,
        options: data.items.edges.map((edge)=>{
            if (edge.node.field.floatValue == null) return {
                value: null,
                label: formatMessage((0, $ivaRx.default).noneOption)
            };
            const stringFloatValue = String(edge.node.field.floatValue);
            return {
                value: stringFloatValue,
                label: stringFloatValue
            };
        })
    });

});
parcelRegister("ivaRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd2394f0a911447$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd2394f0a911447$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noneOption: {
        "id": "business-filters.controllers.group-item-values.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("ijEQD", function(module, exports) {

$parcel$export(module.exports, "transformPriority", () => $c6e67604bea772f5$export$1b9f55a39456e911);
$parcel$export(module.exports, "transformIssueType", () => $c6e67604bea772f5$export$96520244689f81c1);
$parcel$export(module.exports, "transformStatuses", () => $c6e67604bea772f5$export$20a57a5ec025f2d);
$parcel$export(module.exports, "transformUsers", () => $c6e67604bea772f5$export$fb8c90bfc4beaa59);
$parcel$export(module.exports, "transformLabels", () => $c6e67604bea772f5$export$c072126708d93f04);
$parcel$export(module.exports, "transformLabelSuggestions", () => $c6e67604bea772f5$export$cdfcc40760c1a4f8);
$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $c6e67604bea772f5$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $h1vWF = parcelRequire("h1vWF");
const $c6e67604bea772f5$export$1b9f55a39456e911 = (0, $5iWql.default)((priorityFieldConfig)=>[
        ...priorityFieldConfig?.options || []
    ].reduce((acc, next)=>{
        acc.push({
            value: next.name,
            label: next.name,
            avatar: next.iconUrl || ''
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$96520244689f81c1 = (0, $5iWql.default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
        acc.push({
            value: next.id,
            label: next.name,
            id: next.id,
            avatar: next.avatarUrl,
            square: true
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$20a57a5ec025f2d = (0, $5iWql.default)((statuses)=>statuses.reduce((acc, next)=>{
        acc.push({
            value: next.untranslatedName,
            label: next.name,
            categoryId: next.statusCategory.id,
            // Board needs the status id as number for client side filtering
            id: Number(next.id)
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$c072126708d93f04 = (0, $5iWql.default)((labels)=>labels.reduce((acc, next)=>{
        acc.push({
            value: next || '',
            label: next
        });
        return acc;
    }, []));
const $c6e67604bea772f5$export$cdfcc40760c1a4f8 = (0, $5iWql.default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
        acc.push({
            value: next.label || '',
            label: next.label
        });
        return acc;
    }, []));
const $c6e67604bea772f5$var$getType = ({ type: type })=>{
    switch(type){
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
        case 0, $lO4Or.DATE_CF_TYPE:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.NUMBER_CF_TYPE:
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $c6e67604bea772f5$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
            label: value,
            value: value
        }));
const $c6e67604bea772f5$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return fieldOptionsData.users;
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return $c6e67604bea772f5$var$getSelectCustomFieldValues(field);
        case 0, $lO4Or.NUMBER_CF_TYPE:
            if (aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
        case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
            return fieldOptionsData[0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return fieldOptionsData[type];
    }
};
const $c6e67604bea772f5$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
            return true;
        default:
            return false;
    }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
const $c6e67604bea772f5$var$isCustomField = (type)=>(0, $9TEHc.EXTRA_CUSTOM_FIELD_TYPES).has(type);
const $c6e67604bea772f5$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>// @ts-expect-error - TS7006 - Parameter 'response' implicitly has an 'any' type.
        userResolver.getUsersFromAccountId(accountIds).then((response)=>$c6e67604bea772f5$export$fb8c90bfc4beaa59(response)));
const $c6e67604bea772f5$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $h1vWF.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
    fields.forEach((field)=>{
        const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
        // if the type is unsupported
        // or it's the start date field (which is handled separately as 'date range')
        // then skip
        if (type == null || aliasFieldId === (0, $jGcn0.START_DATE_ALIAS_FIELD_ID)) return;
        const selectType = $c6e67604bea772f5$var$getType({
            type: type
        });
        fieldConfig[id] = {
            systemType: type,
            label: name,
            type: selectType,
            placeholder: formatMessage((0, $h1vWF.default).filterPlaceholder),
            options: $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData,
                field: field,
                aliasFieldId: aliasFieldId
            }),
            isCustomField: $c6e67604bea772f5$var$isCustomField(type),
            fieldConfigVersion: 1
        };
        if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
        if (type === (0, $lO4Or.ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, $h1vWF.default).typeLabel);
        if ($c6e67604bea772f5$var$isUserField(type)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
            resolvers[id] = $c6e67604bea772f5$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: 'EMPTY',
                    label: formatMessage((0, $h1vWF.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
        }
        if (type === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = $c6e67604bea772f5$var$getValues({
                type: type,
                fieldOptionsData: fieldOptionsData
            });
        }
        if (type === (0, $lO4Or.SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_SELECT_CF_TYPE) || type === (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
            ...fieldConfig[id].options,
            {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: formatMessage((0, $h1vWF.default).noneOption),
                isEmptyOption: true
            }
        ];
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("1run3", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $0804b64445570a47$export$ed12481c953b8653);
$parcel$export(module.exports, "isDateField", () => $0804b64445570a47$export$7d34c8548269835d);
const $0804b64445570a47$export$ed12481c953b8653 = {
    AsyncSelectFilter: 'AsyncSelectFilter',
    AvatarSelectFilter: 'AvatarSelectFilter',
    AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
    PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
    LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
    PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
    LozengeSelectFilter: 'LozengeSelectFilter',
    PrioritySelectFilter: 'PrioritySelectFilter',
    CategorySelectFilter: 'CategorySelectFilter',
    GoalsSelectFilter: 'GoalsSelectFilter',
    PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
    NumberFilter: 'NumberFilter',
    SelectFilter: 'SelectFilter',
    SearchFilter: 'SearchFilter',
    TextFilter: 'TextFilter',
    DateFilter: 'DateFilter',
    ProjectFilter: 'ProjectFilter'
};
const $0804b64445570a47$export$7d34c8548269835d = (field)=>field.type === $0804b64445570a47$export$ed12481c953b8653.DateFilter;

});

parcelRegister("h1vWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a86e8a54f0713c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2a86e8a54f0713c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config.date-range-label",
        "defaultMessage": "Date range"
    },
    typeLabel: {
        "id": "business-filters.controllers.field-config.type-label",
        "defaultMessage": "Type"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noneOption: {
        "id": "business-filters.controllers.field-config.none-option",
        "defaultMessage": "None"
    }
});

});



parcelRegister("aWjLM", function(module, exports) {

$parcel$export(module.exports, "useFieldConfigV2", () => $f0c719cf639dcc71$export$c041141a7ef797c1);

var $eUqFw = parcelRequire("eUqFw");

var $fDLFb = parcelRequire("fDLFb");

var $e20I1 = parcelRequire("e20I1");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $ejYlo = parcelRequire("ejYlo");

var $hLW3I = parcelRequire("hLW3I");

var $jWIW7 = parcelRequire("jWIW7");

var $7goEv = parcelRequire("7goEv");
const $f0c719cf639dcc71$var$EMPTY_FIELD_DATA = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$var$EMPTY_FILTER_DATA = {
    initialUsers: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialLabels: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialComponents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialPriorities: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialIssueTypes: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialStatuses: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialCategories: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialSprints: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialFixVersions: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialParents: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialGoals: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA,
    initialTeams: $f0c719cf639dcc71$var$EMPTY_FIELD_DATA
};
const $f0c719cf639dcc71$var$initialState = {
    data: undefined,
    loadingData: true
};
const $f0c719cf639dcc71$var$reducer = (state, action)=>{
    switch(action.type){
        case 'init':
            return $f0c719cf639dcc71$var$initialState;
        case 'fetch-data-success':
            return {
                ...state,
                data: action.value,
                loadingData: false
            };
        case 'fetch-data-error':
            return {
                ...state,
                data: $f0c719cf639dcc71$var$EMPTY_FILTER_DATA,
                loadingData: false
            };
        default:
            return state;
    }
};
/**
 * useFieldConfig hook that is used to populate the field and field values for JWM Filters.
 * It can be used for JWM Overviews which includes multiple Jira Projects.
 */ const $f0c719cf639dcc71$var$emptyFieldValue = {
    totalCount: 0,
    options: []
};
const $f0c719cf639dcc71$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectFieldData = (0, $jWIW7.useProjectFilter)();
    const { data: filterFields, loading: loadingFilterFields } = (0, $hLW3I.useFilterFields)();
    const [{ data: data, loadingData: loadingData }, dispatch] = (0, $eUqFw.useReducer)($f0c719cf639dcc71$var$reducer, $f0c719cf639dcc71$var$initialState);
    const userResolver = (0, $eUqFw.useRef)(new (0, $e20I1.UserResolver)());
    const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, $ejYlo.useFetchFieldValues)({
        view: view,
        allowedFieldTypes: allowedFieldTypes,
        filterFields: filterFields
    });
    const { data: entity } = (0, $fDLFb.useBusinessEntity)();
    const businessEntityId = entity.id;
    const initialiseDefaultData = (0, $eUqFw.useCallback)(()=>{
        fetchInitialData().then((initialData)=>{
            dispatch({
                type: 'fetch-data-success',
                value: {
                    initialUsers: initialData?.users ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialLabels: initialData?.labels ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialComponents: initialData?.components ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialPriorities: initialData?.priority ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialIssueTypes: initialData?.issuetype ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialStatuses: initialData?.status ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialCategories: initialData?.[0, $lO4Or.CATEGORY_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    initialSprints: initialData?.[0, $lO4Or.SPRINT_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                    ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                        initialFixVersions: initialData?.[0, $lO4Or.FIX_VERSIONS_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialParents: initialData?.[0, $lO4Or.PARENT_FIELD_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue,
                        initialTeams: initialData?.[0, $lO4Or.TEAMS_PLATFORM_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                    } : {},
                    initialGoals: initialData?.[0, $lO4Or.GOALS_CF_TYPE] ?? $f0c719cf639dcc71$var$emptyFieldValue
                }
            });
        }).catch(()=>{
            dispatch({
                type: 'fetch-data-error'
            });
        });
    }, [
        fetchInitialData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loadingFilterFields) {
            dispatch({
                type: 'init'
            });
            initialiseDefaultData();
        }
    }, [
        initialiseDefaultData,
        loadingFilterFields,
        businessEntityId
    ]);
    const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $eUqFw.useMemo)(()=>{
        const fieldOptionsData = {
            priority: data?.initialPriorities ?? $f0c719cf639dcc71$var$emptyFieldValue,
            issuetype: data?.initialIssueTypes ?? $f0c719cf639dcc71$var$emptyFieldValue,
            status: data?.initialStatuses ?? $f0c719cf639dcc71$var$emptyFieldValue,
            users: data?.initialUsers ?? $f0c719cf639dcc71$var$emptyFieldValue,
            labels: data?.initialLabels ?? $f0c719cf639dcc71$var$emptyFieldValue,
            components: data?.initialComponents ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.CATEGORY_TYPE)]: data?.initialCategories ?? $f0c719cf639dcc71$var$emptyFieldValue,
            [(0, $lO4Or.SPRINT_TYPE)]: data?.initialSprints ?? $f0c719cf639dcc71$var$emptyFieldValue,
            project: projectFieldData,
            ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
                [(0, $lO4Or.FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.PARENT_FIELD_TYPE)]: data?.initialParents ?? $f0c719cf639dcc71$var$emptyFieldValue,
                [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $f0c719cf639dcc71$var$emptyFieldValue
            } : {},
            [(0, $lO4Or.GOALS_CF_TYPE)]: data?.initialGoals ?? $f0c719cf639dcc71$var$emptyFieldValue
        };
        return (0, $7goEv.getFilterFieldConfigAndResolvers)({
            view: view,
            formatMessage: formatMessage,
            allFields: filterFields,
            allowedFieldTypes: allowedFieldTypes,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: fetchUsers,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchCategories: fetchCategories,
            ...fetchOptions,
            userResolver: userResolver.current
        });
    }, [
        data?.initialPriorities,
        data?.initialIssueTypes,
        data?.initialStatuses,
        data?.initialUsers,
        data?.initialLabels,
        data?.initialComponents,
        data?.initialCategories,
        data?.initialSprints,
        data?.initialFixVersions,
        data?.initialParents,
        data?.initialGoals,
        data?.initialTeams,
        projectFieldData,
        view,
        formatMessage,
        filterFields,
        allowedFieldTypes,
        fetchUsers,
        fetchLabels,
        fetchComponents,
        fetchCategories,
        fetchOptions
    ]);
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers,
        loading: loadingData || loadingFilterFields || data == null
    };
};

});
parcelRegister("7goEv", function(module, exports) {

$parcel$export(module.exports, "getFilterFieldConfigAndResolvers", () => $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b);

var $illlw = parcelRequire("illlw");

var $5iWql = parcelRequire("5iWql");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $9TEHc = parcelRequire("9TEHc");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");

var $9Jtgc = parcelRequire("9Jtgc");
const $1ffbd75d284f79d7$export$fb8c90bfc4beaa59 = (0, $5iWql.default)((users)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    users.reduce((acc, next)=>{
        acc.push({
            value: next.accountId || '',
            label: next.displayName,
            avatar: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(next, [
                'avatarUrls',
                '24x24'
            ], '')
        });
        return acc;
    }, []));
const $1ffbd75d284f79d7$var$getType = (type)=>{
    switch(type){
        case 0, $lO4Or.CATEGORY_TYPE:
            return (0, $1run3.FieldType).CategorySelectFilter;
        case 0, $lO4Or.PRIORITY_TYPE:
            return (0, $1run3.FieldType).PrioritySelectFilter;
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return (0, $1run3.FieldType).AvatarAsyncSelectFilter;
        case 0, $lO4Or.ISSUE_TYPE:
        case 0, $lO4Or.PARENT_FIELD_TYPE:
        case 0, $lO4Or.TEAMS_PLATFORM_CF_TYPE:
            return (0, $1run3.FieldType).AvatarSelectFilter;
        case 0, $lO4Or.STATUS_TYPE:
            return (0, $1run3.FieldType).LozengeSelectFilter;
        case 0, $lO4Or.LABELS_TYPE:
        case 0, $lO4Or.COMPONENTS_TYPE:
        case 0, $lO4Or.FIX_VERSIONS_TYPE:
        case 0, $lO4Or.SPRINT_TYPE:
            return (0, $1run3.FieldType).AsyncSelectFilter;
        case 0, $lO4Or.CREATED:
        case 0, $lO4Or.UPDATED:
            return (0, $1run3.FieldType).DateFilter;
        case 0, $lO4Or.PROJECT_TYPE:
            return (0, $1run3.FieldType).ProjectFilter;
        case 0, $lO4Or.GOALS_CF_TYPE:
            return (0, $1run3.FieldType).GoalsSelectFilter;
        default:
            return (0, $1run3.FieldType).SelectFilter;
    }
};
const $1ffbd75d284f79d7$var$getValues = (type, fieldOptionsData)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return fieldOptionsData.users;
        default:
            return fieldOptionsData[type];
    }
};
const $1ffbd75d284f79d7$var$isUserField = (type)=>{
    switch(type){
        case 0, $lO4Or.ASSIGNEE_TYPE:
        case 0, $lO4Or.REPORTER_TYPE:
        case 0, $lO4Or.USER_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$isCustomField = (type)=>{
    switch(type){
        case 0, $lO4Or.USER_CF_TYPE:
        case 0, $lO4Or.PEOPLE_CF_TYPE:
        case 0, $lO4Or.SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
        case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
            return true;
        default:
            return false;
    }
};
const $1ffbd75d284f79d7$var$createUserValueGetter = (userResolver)=>(0, $5iWql.default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response)=>$1ffbd75d284f79d7$export$fb8c90bfc4beaa59(response)));
const $1ffbd75d284f79d7$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfig = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resolvers = {};
    if (allowedFieldTypes.has((0, $9TEHc.DATE_RANGE_TYPE))) // manually add dateRange to fieldConfig
    fieldConfig.dateRange = {
        label: formatMessage((0, $9Jtgc.default).dateRangeLabel),
        type: (0, $1run3.FieldType).DateFilter,
        fromLabel: formatMessage((0, $9Jtgc.default).startDateLabel),
        toLabel: formatMessage((0, $9Jtgc.default).dueDateLabel)
    };
    const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
    // eslint-disable-next-line complexity
    fields.forEach((field)=>{
        const { name: name, type: type, id: id } = field;
        const fieldType = type ?? '';
        const fieldValues = $1ffbd75d284f79d7$var$getValues(fieldType, fieldOptionsData);
        fieldConfig[id] = {
            label: name,
            type: $1ffbd75d284f79d7$var$getType(fieldType),
            placeholder: formatMessage((0, $9Jtgc.default).filterPlaceholder),
            options: fieldValues?.options || [],
            totalCount: fieldValues?.totalCount || 0,
            isCustomField: $1ffbd75d284f79d7$var$isCustomField(fieldType),
            fieldConfigVersion: 2
        };
        // issue type
        if (type === (0, $lO4Or.ISSUE_TYPE)) {
            let options = fieldValues?.options || [];
            if (view === 'board') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                fieldConfig[id].options = options;
            }
            if (fetchIssueTypes) {
                fieldConfig[id].loadOptions = fetchIssueTypes;
                fieldConfig[id].defaultOptions = options;
            }
        } else if ($1ffbd75d284f79d7$var$isUserField(fieldType)) {
            fieldConfig[id].loadOptions = fetchUsers;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            resolvers[id] = $1ffbd75d284f79d7$var$createUserValueGetter(userResolver);
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).unassignedLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.LABELS_TYPE)) {
            fieldConfig[id].loadOptions = fetchLabels;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noLabelsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.COMPONENTS_TYPE)) {
            fieldConfig[id].loadOptions = fetchComponents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noComponentsLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.CATEGORY_TYPE)) {
            fieldConfig[id].loadOptions = fetchCategories;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noCategoriesLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.STATUS_TYPE) && fetchStatuses) {
            fieldConfig[id].loadOptions = fetchStatuses;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.PRIORITY_TYPE) && fetchPriorities) {
            fieldConfig[id].loadOptions = fetchPriorities;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
        } else if (fieldType === (0, $lO4Or.SPRINT_TYPE) && fetchSprints) {
            fieldConfig[id].loadOptions = fetchSprints;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noSprintLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.FIX_VERSIONS_TYPE) && fetchFixVersions && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchFixVersions;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noVersionLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.PARENT_FIELD_TYPE) && fetchParents && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchParents;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noParentLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fieldType === (0, $lO4Or.GOALS_CF_TYPE) && fetchGoals) {
            fieldConfig[id].loadOptions = fetchGoals;
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noGoalLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        } else if (fetchTeams && fieldType === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields')) {
            fieldConfig[id].loadOptions = fetchTeams;
            fieldConfig[id].defaultOptions = fieldValues?.options || [];
            fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: formatMessage((0, $9Jtgc.default).noTeamLabel),
                    isEmptyOption: true
                }
            ];
            fieldConfig[id].totalCount += 1;
        }
    });
    return {
        fieldConfig: fieldConfig,
        resolvers: resolvers
    };
};

});
parcelRegister("9Jtgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $510082940a52668b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $510082940a52668b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterPlaceholder: {
        "id": "business-filters.controllers.field-config-v2.filter-placeholder",
        "defaultMessage": "Search"
    },
    dateRangeLabel: {
        "id": "business-filters.controllers.field-config-v2.date-range-label",
        "defaultMessage": "Date range"
    },
    startDateLabel: {
        "id": "business-filters.controllers.field-config-v2.start-date-label",
        "defaultMessage": "Start date"
    },
    dueDateLabel: {
        "id": "business-filters.controllers.field-config-v2.due-date-label",
        "defaultMessage": "Due date"
    },
    unassignedLabel: {
        "id": "business-filters.controllers.field-config-v2.unassigned-label",
        "defaultMessage": "Unassigned"
    },
    noLabelsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-labels-label",
        "defaultMessage": "No label"
    },
    noCategoriesLabel: {
        "id": "business-filters.controllers.field-config-v2.no-categories-label",
        "defaultMessage": "No category"
    },
    noComponentsLabel: {
        "id": "business-filters.controllers.field-config-v2.no-components-label",
        "defaultMessage": "No component"
    },
    noSprintLabel: {
        "id": "business-filters.controllers.field-config-v2.no-sprint-label",
        "defaultMessage": "Backlog"
    },
    noVersionLabel: {
        "id": "business-filters.controllers.field-config-v2.no-version-label",
        "defaultMessage": "No version"
    },
    noParentLabel: {
        "id": "business-filters.controllers.field-config-v2.no-parent-label",
        "defaultMessage": "No parent"
    },
    noGoalLabel: {
        "id": "business-filters.controllers.field-config-v2.no-goal-label",
        "defaultMessage": "No goal"
    },
    noTeamLabel: {
        "id": "business-filters.controllers.field-config-v2.no-team-label",
        "defaultMessage": "No team"
    }
});

});




parcelRegister("coMWQ", function(module, exports) {

$parcel$export(module.exports, "deserialiseJql", () => $67199c690c914c16$export$214464255b766962);

var $hir2i = parcelRequire("hir2i");

var $27QuD = parcelRequire("27QuD");

var $9FEvp = parcelRequire("9FEvp");

var $6x1NF = parcelRequire("6x1NF");

var $6RWCB = parcelRequire("6RWCB");
var $bXcc5 = parcelRequire("bXcc5");
var $k85ht = parcelRequire("k85ht");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $1run3 = parcelRequire("1run3");

var $dG4cR = parcelRequire("dG4cR");
const $67199c690c914c16$var$START_DATE_JQL = 'Start date[Date]';
const $67199c690c914c16$var$EMPTY = 'EMPTY';
// remove any extra space first
// then replace any escaped apostrophe,
// lastly replace any quotation marks in the beginning and end of word but not the apostrophes in the middle of the word
const $67199c690c914c16$var$cleanString = (value)=>(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? value.trim() : value.trim().replace(/\\'/g, "'").replace(/^'|'$/g, '');
// some filters should display options retrieved from the URL parameters even when they are not returned amongst the useFieldConfig field values
const $67199c690c914c16$var$shouldIncludeUnknownOption = (filterField)=>{
    const allowedFieldTypes = new Set([
        (0, $lO4Or.COMPONENTS_TYPE),
        (0, $lO4Or.LABELS_TYPE),
        (0, $lO4Or.PRIORITY_TYPE),
        (0, $lO4Or.CATEGORY_TYPE)
    ]);
    return allowedFieldTypes.has(filterField?.type ?? '');
};
const $67199c690c914c16$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($27QuD)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $67199c690c914c16$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $67199c690c914c16$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
    if (resolver && typeof resolver === 'function') {
        const cleanIds = list.map((value)=>$67199c690c914c16$var$cleanString(value));
        const ids = cleanIds.filter((value)=>(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') || value !== $67199c690c914c16$var$EMPTY);
        return resolver(ids).then((options)=>{
            // keep empty option in the response
            if (!(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') && list.find((value)=>value === $67199c690c914c16$var$EMPTY)) return [
                ...options,
                {
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ];
            return options;
        });
    }
    const allowUnknownOption = $67199c690c914c16$var$shouldIncludeUnknownOption(filterField);
    return list.map((value)=>{
        const cleanValue = $67199c690c914c16$var$cleanString(value);
        if (field && !(0, $1run3.isDateField)(field) && Array.isArray(field.options)) {
            const optionInField = field.options.find((option)=>{
                if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                if (option.isEmptyOption) return value === $67199c690c914c16$var$EMPTY;
                return option.value === cleanValue;
            });
            if (!optionInField && allowUnknownOption) return {
                value: cleanValue,
                label: cleanValue
            };
            if (!(0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') && value === $67199c690c914c16$var$EMPTY) return {
                value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                label: ''
            };
            return optionInField;
        }
        return undefined;
    }).filter((item)=>item != null && 'value' in item);
};
class $67199c690c914c16$export$5299115fe71e8b39 extends (0, $6RWCB.AbstractJastVisitor) {
    constructor(fieldConfig, filterFields, resolvers){
        super();
        this.getOption = (fieldName, items)=>$67199c690c914c16$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
        this.visitCompoundClause = (compoundClause)=>{
            const clauseMap = Promise.resolve({});
            const operator = compoundClause.operator.value;
            if (operator === (0, $e5bc650799ce4838$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), clauseMap);
            throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
        };
        this.parseDateOperand = (operator, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) {
                let date = (0, $6x1NF.default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                if (operator.value === (0, $k85ht.OPERATOR_LT)) date = (0, $6x1NF.default)((0, $9FEvp.default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                const dateType = operator.value === (0, $k85ht.OPERATOR_LT) ? 'to' : 'from';
                return {
                    value: {
                        [dateType]: date
                    }
                };
            }
            throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
        };
        this.parseSelectOperand = async (fieldName, operand)=>{
            if (operand?.operandType === (0, $807962b43ef03b56$export$fabec4aebba3f4df)) {
                const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                return (await Promise.all(optionPromises)).flatMap((option)=>option);
            }
            if (operand?.operandType === (0, $807962b43ef03b56$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                operand.value
            ]);
            if (operand?.operandType === (0, $807962b43ef03b56$export$f6049126fd97001f)) return (0, $1ybV0.ff)('migrate-business-filters-serialising-to-jql-ast_j6qj6') ? [
                {
                    isEmptyOption: true,
                    value: (0, $dG4cR.EMPTY_FILTER_VALUE),
                    label: ''
                }
            ] : this.getOption(fieldName, [
                $67199c690c914c16$var$EMPTY
            ]);
            throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
        };
        this.visitTerminalClause = async (terminalClause)=>{
            const { field: field, operand: operand, operator: operator } = terminalClause;
            if (!operand || !operator) return Promise.resolve({});
            const getShouldConvertCustomField = (fieldName)=>// should convert cf[] -> customfield_ if it's not a field from version 2
                !(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
            const fieldName = $67199c690c914c16$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
            if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
            let value = [];
            if (operator.value === (0, $k85ht.OPERATOR_GT_EQUALS) || operator.value === (0, $k85ht.OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
            else if (operator.value === (0, $k85ht.OPERATOR_EQUALS) || operator.value === (0, $k85ht.OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
            else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
            return {
                [fieldName]: value
            };
        };
        this.fieldConfig = fieldConfig;
        this.filterFields = filterFields;
        this.resolvers = resolvers;
    }
    visitNotClause() {
        throw new Error('JQL contains invalid clause: NOT');
    }
    defaultResult() {
        return Promise.resolve({});
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ async aggregateResult(aggregate, nextResult) {
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($hir2i)))(await nextResult, await aggregate, (destValue, srcValue)=>{
            if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
            return undefined;
        });
    }
}
const $67199c690c914c16$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
    // Create the syntax tree for the filters JQL
    const builder = new (0, $bXcc5.JastBuilder)();
    const jast = builder.build(jql);
    if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
    // Parse the JQL AST into a FilterType object
    const parser = new $67199c690c914c16$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
    const parsedJql = await jast.query?.accept(parser);
    return parsedJql ?? {};
};

});
parcelRegister("hir2i", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $3Bqj8 = parcelRequire("3Bqj8");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $c97916e8180d3b9a$var$mergeWith = $3Bqj8(function(object, source, srcIndex, customizer) {
    $eljWd(object, source, srcIndex, customizer);
});
module.exports = $c97916e8180d3b9a$var$mergeWith;

});



parcelRegister("27zPy", function(module, exports) {

$parcel$export(module.exports, "MenuContent", () => $d758afbde8c38bbf$export$479f0f2f71193efe);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $cqv89 = parcelRequire("cqv89");

var $hEiVl = parcelRequire("hEiVl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d758afbde8c38bbf$var$LazyMenuContent = (0, $7rh0R.lazy)(()=>(parcelRequire("gk2kI")), {
    moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
});
const $d758afbde8c38bbf$export$479f0f2f71193efe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hEiVl.DropdownWrapper), {
        "data-testid": "business-filters.ui.filters.menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cqv89.MenuFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d758afbde8c38bbf$var$LazyMenuContent, props)));

});
parcelRegister("cqv89", function(module, exports) {

$parcel$export(module.exports, "MenuFallback", () => $d72c10a0e4505968$export$1198e585d599d03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $d72c10a0e4505968$export$1198e585d599d03 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d72c10a0e4505968$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium",
        testId: "business-filters.common.ui.menu-fallback.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d72c10a0e4505968$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hEiVl", function(module, exports) {

$parcel$export(module.exports, "DropdownWrapper", () => $5348b95debef5641$export$5f7211d21bfdae05);
$parcel$export(module.exports, "ScrollableContent", () => $5348b95debef5641$export$6c560fdadeb11d78);
$parcel$export(module.exports, "DropdownHeaderWrapper", () => $5348b95debef5641$export$e23294aded7a8a49);
$parcel$export(module.exports, "DropdownHeaderButtons", () => $5348b95debef5641$export$53ca7a3701b98335);
$parcel$export(module.exports, "FiltersListSeparator", () => $5348b95debef5641$export$1a67069896d998b9);
$parcel$export(module.exports, "FiltersListWrapper", () => $5348b95debef5641$export$a5a9080bd2c85987);
$parcel$export(module.exports, "Section", () => $5348b95debef5641$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "LastSection", () => $5348b95debef5641$export$1faf3c7558df435);
$parcel$export(module.exports, "SectionMessageWrapper", () => $5348b95debef5641$export$c5e20d5e200edfe2);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9TEHc = parcelRequire("9TEHc");
const $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT = 52;
const $5348b95debef5641$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
const $5348b95debef5641$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6c560fdadeb11d78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uik9ob": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, $9TEHc.POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${// dynamically calculating offsetTop on popup mount
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.offsetTop ?? (0, $9TEHc.POPUP_OFFSET_TOP)) + $5348b95debef5641$var$DROPDOWN_HEADER_HEIGHT}px)`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$e23294aded7a8a49 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
            __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$53ca7a3701b98335 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1a67069896d998b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x3do13y8 _18s81alc",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$a5a9080bd2c85987 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1gwv",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$1faf3c7558df435 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $5348b95debef5641$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdidpf _zulpidpf",
            __cmplp.className
        ])
    });
});
const $5348b95debef5641$export$c5e20d5e200edfe2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gk2kI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8LeNQ')
        ]);
        const value = parcelRequire('fTzDz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8LeNQ")
    ]).then(()=>parcelRequire('fTzDz'));
}

});


parcelRegister("6M6Pf", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $70b788e25198d514$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $4ki2H = parcelRequire("4ki2H");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lwKJI = parcelRequire("lwKJI");
const $70b788e25198d514$var$FILTER_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
    label: "",
    size: "small"
});
const $70b788e25198d514$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterMessage = (0, $eUqFw.useMemo)(()=>{
        if (count > 0) return formatMessage((0, $lwKJI.default).filtersCount, {
            filters: count
        });
        if (hasFiltersApplied) return formatMessage((0, $lwKJI.default).buttonWithFilters);
        return formatMessage((0, $lwKJI.default).filterButton);
    }, [
        count,
        formatMessage,
        hasFiltersApplied
    ]);
    const TriggerButton = withThemedButton ? (0, $lGiWG.ThemedButton) : (0, $7u4fN.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerButton, {
        ...otherProps,
        ref: ref,
        testId: "business-filters.ui.filters.trigger.button-wrapper",
        iconBefore: $70b788e25198d514$var$FILTER_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70b788e25198d514$var$ButtonContents, null, filterMessage));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70b788e25198d514$var$ButtonContents = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _zulp1b66 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwKJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $142e1a2d3eb527a7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $142e1a2d3eb527a7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filtersCount: {
        "id": "business-filters.filters.trigger.filters-count",
        "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
    },
    filterButton: {
        "id": "business-filters.filters.trigger.filter-button",
        "defaultMessage": "Filter"
    },
    buttonWithFilters: {
        "id": "business-filters.filters.trigger.button-with-filters",
        "defaultMessage": "Filters applied"
    },
    newLozenge: {
        "id": "business-filters.filters.trigger.new-lozenge",
        "defaultMessage": "New"
    },
    newLozengeTooltip: {
        "id": "business-filters.filters.trigger.new-lozenge-tooltip",
        "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
    }
});

});



parcelRegister("d9gm1", function(module, exports) {

$parcel$export(module.exports, "SimpleSearchTextField", () => $2ba7b21880f0a587$export$63f96dda4bd4f7dc);
$parcel$export(module.exports, "SimpleSearchField", () => $2ba7b21880f0a587$export$44e8ccf3428dc1d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6zOB7 = parcelRequire("6zOB7");

var $jWuk1 = parcelRequire("jWuk1");

var $dsroq = parcelRequire("dsroq");

var $cf2Y4 = parcelRequire("cf2Y4");

var $kar7l = parcelRequire("kar7l");

var $c1K7Q = parcelRequire("c1K7Q");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9JEYY = parcelRequire("9JEYY");

var $96etS = parcelRequire("96etS");

var $j33Mg = parcelRequire("j33Mg");
const $2ba7b21880f0a587$export$63f96dda4bd4f7dc = /*#__PURE__*/ (0, $eUqFw.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId, isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [searchValue, setSearchValue] = (0, $eUqFw.useState)(externalValue);
    const handleSearchChange = (0, $eUqFw.useCallback)((newValue)=>{
        let eventAttributes = {};
        if ((0, $1ybV0.ff)('jwm-attachments-m2')) eventAttributes = (0, $9JEYY.getTextFieldAttributes)(newValue);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
            view: view,
            ...eventAttributes
        });
        onChange(newValue);
    }, [
        createAnalyticsEvent,
        onChange,
        view
    ]);
    const [handleSearchChangeDebounced] = (0, $2jdHI.default)(handleSearchChange, 500);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchValue(e.target.value);
        handleSearchChangeDebounced(e.target.value);
    }, [
        handleSearchChangeDebounced
    ]);
    const handleClear = (0, $eUqFw.useCallback)(()=>{
        setSearchValue('');
        handleSearchChangeDebounced('');
    }, [
        setSearchValue,
        handleSearchChangeDebounced
    ]);
    const themedIconPrimaryColor = isDisabled ? (0, $kar7l.Tokens).COLOR_TEXT_DISABLED : (0, $kar7l.Tokens).COLOR_TEXT_SUBTLEST;
    const Container = themedField ? $2ba7b21880f0a587$var$ThemedContainer : (0, $eUqFw.Fragment);
    (0, $eUqFw.useEffect)(()=>{
        setSearchValue(externalValue);
    }, [
        externalValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ref: inputRef,
        ...(0, $c1K7Q.generateDataTestId)('searchfield'),
        "aria-describedby": describedbyId,
        testId: testId,
        value: searchValue,
        isCompact: true,
        placeholder: formatMessage(placeholder),
        "aria-label": label || formatMessage(placeholder),
        onChange: handleChange,
        onFocus: onFocus,
        isDisabled: isDisabled,
        elemAfterInput: searchValue !== '' ? // We used Button with no children instead of IconButton because
        // of different sizing between an icon alone and IconButton
        // Using Button allows us to access to spacing="none" to mimic the
        // same spacing to the icon alone
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
                    ...iconProps,
                    size: "small",
                    primaryColor: themedField ? themedIconPrimaryColor : undefined
                }),
            appearance: "subtle",
            spacing: "none",
            "aria-label": formatMessage((0, $j33Mg.default).clear),
            testId: "business-filters.ui.simple-search-field.clear-button",
            onClick: handleClear
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            label: "",
            size: "small",
            primaryColor: themedField ? themedIconPrimaryColor : undefined
        }),
        className: (0, $7JEyt.default)([
            "_dzcou2gc"
        ])
    }));
});
const $2ba7b21880f0a587$export$44e8ccf3428dc1d5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId })=>{
    const [simpleSearch, setSimpleSearch] = (0, $96etS.useSimpleSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
            view: view
        });
    }, [
        createAnalyticsEvent,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ba7b21880f0a587$export$63f96dda4bd4f7dc, {
        view: view,
        onFocus: handleFocus,
        describedbyId: describedbyId,
        onChange: setSimpleSearch,
        value: simpleSearch,
        placeholder: placeholder
    }));
});
const $2ba7b21880f0a587$var$textFieldStyles = null; /* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ba7b21880f0a587$var$ThemedContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_6l8r1oay _x2xk1oay _sg3v1oay _w15a1oay _n8yf1v8d _jeiekwex _7n831c2q _1o8hu22k _n2ulgr9p",
            __cmplp.className
        ])
    });
}); /* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage */ 
const $2ba7b21880f0a587$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $ecaf8c9a10cf48c9$var$TextfieldComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
$ecaf8c9a10cf48c9$var$TextfieldComponent.displayName = 'Textfield';
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.memo)($ecaf8c9a10cf48c9$var$TextfieldComponent);
var // The above generic is used to let ERTC know what props to extract.
// See: https://github.com/atlassian/extract-react-types/issues/201
$ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("c1K7Q", function(module, exports) {

$parcel$export(module.exports, "generateDataTestId", () => $9d0a034fe3d4cf2e$export$7de5661ad251801);

var $1ybV0 = parcelRequire("1ybV0");
const $9d0a034fe3d4cf2e$var$DISABLED = 'disabled';
const $9d0a034fe3d4cf2e$var$DUPLICATED = 'duplicated';
const $9d0a034fe3d4cf2e$var$REPLACED = 'replaced';
const $9d0a034fe3d4cf2e$var$DEFAULT_FF = 'replace-data-test-id-with-data-testid-in-bento-m2';
const $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue = (featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $1ybV0.getMultivariateFeatureFlag)(featureFlag, $9d0a034fe3d4cf2e$var$DISABLED, [
        $9d0a034fe3d4cf2e$var$DISABLED,
        $9d0a034fe3d4cf2e$var$DUPLICATED,
        $9d0a034fe3d4cf2e$var$REPLACED
    ]);
const $9d0a034fe3d4cf2e$export$7de5661ad251801 = (testId, featureFlag = $9d0a034fe3d4cf2e$var$DEFAULT_FF)=>{
    const flagValue = $9d0a034fe3d4cf2e$var$getDataTestIdFlagValue(featureFlag);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let testIdProps = {};
    switch(flagValue){
        case 'duplicated':
            testIdProps = {
                'data-test-id': testId,
                'data-testid': testId
            };
            break;
        case 'replaced':
            testIdProps = {
                'data-testid': testId
            };
            break;
        case 'disabled':
        default:
            testIdProps = {
                'data-test-id': testId
            };
            break;
    }
    return testIdProps;
};

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("9JEYY", function(module, exports) {

$parcel$export(module.exports, "getTextFieldAttributes", () => $98a728a18d600acd$export$dfd7972bcd113afb);
const $98a728a18d600acd$export$dfd7972bcd113afb = (value = '')=>{
    const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
    return {
        queryLength: value.length,
        wordCount: wordCount
    };
};

});

parcelRegister("j33Mg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6d42843abbf146$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a6d42843abbf146$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "business-filters.simple-search-field.clear",
        "defaultMessage": "Clear"
    }
});

});


parcelRegister("bSsl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf2ff9f75b0cc835$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $3f7Cz = parcelRequire("3f7Cz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("cAOjv")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
});
const $cf2ff9f75b0cc835$var$AddPeopleWithAvatar = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.invite-people.add-people-with-avatars",
        packageName: "jiraBusinessInvitePeople",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "invite-button-with-avatars",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$AvatarFallback, null)
    }, props?.hasInviteButton === false ? // not including the Add People provider if the invite button is not needed
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf2ff9f75b0cc835$var$LazyAddPeopleWithAvatars, props))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf2ff9f75b0cc835$var$AvatarFallback = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $cf2ff9f75b0cc835$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($cf2ff9f75b0cc835$var$AddPeopleWithAvatar);

});
parcelRegister("3f7Cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5829e6ed86dc42e3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $bvGWz = parcelRequire("bvGWz");

var $3MjJX = parcelRequire("3MjJX");
const $5829e6ed86dc42e3$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
    const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, $bvGWz.useAddPeople)();
    if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MjJX.ProjectInvitePeopleModal), {
        onModalClose: closeAddPeopleModal,
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    });
    return null;
};
const $5829e6ed86dc42e3$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvGWz.AddPeopleProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "jira-business.invite-people.ui.add-people",
        packageName: "jira-business.invite-people.ui.add-people",
        teamName: "jira-warepil"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$InviteWrapper, {
        "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5829e6ed86dc42e3$var$AddPeopleModal, {
        shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
        source: source
    }))));
var $5829e6ed86dc42e3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($5829e6ed86dc42e3$var$AddPeople);
// this wrapper prevents the modal component to inherit any css logic from its parent, which could cause interferences in the consumer's UI
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5829e6ed86dc42e3$var$InviteWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bvGWz", function(module, exports) {

$parcel$export(module.exports, "AddPeopleProvider", () => $f3a4a647f29aa9d7$export$6d41c2327e862d9d);
$parcel$export(module.exports, "useAddPeople", () => $f3a4a647f29aa9d7$export$93ea361ec674cff6);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f3a4a647f29aa9d7$var$AddPeopleContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    triggerBtnRef: {
        current: null
    },
    isModalOpen: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openAddPeopleModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    closeAddPeopleModal: ()=>{}
});
const $f3a4a647f29aa9d7$export$6d41c2327e862d9d = ({ children: children })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const triggerBtnRef = (0, $eUqFw.useRef)(null);
    const onCloseCallbackRef = (0, $eUqFw.useRef)();
    const openAddPeopleModal = (0, $eUqFw.useCallback)((onClose, source)=>{
        setIsModalOpen(true);
        const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
            source: source
        });
        if (onClose) onCloseCallbackRef.current = onClose;
    }, [
        createAnalyticsEvent,
        projectData.isSimplified
    ]);
    const closeAddPeopleModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
        if (typeof onCloseCallbackRef.current === 'function') {
            onCloseCallbackRef.current();
            onCloseCallbackRef.current = null;
        }
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            triggerBtnRef: triggerBtnRef,
            isModalOpen: isModalOpen,
            openAddPeopleModal: openAddPeopleModal,
            closeAddPeopleModal: closeAddPeopleModal
        }), [
        triggerBtnRef,
        isModalOpen,
        openAddPeopleModal,
        closeAddPeopleModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3a4a647f29aa9d7$var$AddPeopleContext.Provider, {
        value: context
    }, children);
};
const $f3a4a647f29aa9d7$export$93ea361ec674cff6 = ()=>(0, $eUqFw.useContext)($f3a4a647f29aa9d7$var$AddPeopleContext);

});

parcelRegister("3MjJX", function(module, exports) {

$parcel$export(module.exports, "ProjectInvitePeopleModal", () => $1368af08b2bd60b0$export$6dfea89767cb5ac1);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $hlZx3 = parcelRequire("hlZx3");

var $66rnh = parcelRequire("66rnh");

var $d1I0W = parcelRequire("d1I0W");
const $1368af08b2bd60b0$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
    const projectData = (0, $kQAZu.useProject)();
    const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, $hlZx3.useInviteModalHandlers)();
    if (!shouldUseInvitePeopleModal && projectData.isSimplified) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $66rnh.AddPeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d1I0W.InvitePeopleModal), {
        onModalClose: onModalClose,
        onInviteSuccess: handleAddSuccess,
        onInviteError: handleError,
        source: source
    });
};

});
parcelRegister("hlZx3", function(module, exports) {

$parcel$export(module.exports, "useInviteModalHandlers", () => $72fe370f230f9c2c$export$f696e14fc423d0b);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");


var $f90H0 = parcelRequire("f90H0");

var $bLjrh = parcelRequire("bLjrh");
const $72fe370f230f9c2c$export$f696e14fc423d0b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectData = (0, $kQAZu.useProject)();
    const handleAddSuccess = (0, $eUqFw.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
        const hasSentInvitation = inviteStatus === (0, $f90H0.InvitationStatusEnum).INVITED;
        const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
        showFlag(hasSuccessfullyAddedPeople ? (0, $bLjrh.createAddSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            projectKey: projectData.key
        }) : (0, $bLjrh.createInviteSuccessFlagConfig)({
            totalPeopleAdded: totalPeopleAdded,
            email: email,
            hasSentInvitation: hasSentInvitation
        }));
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
            inviteStatus: inviteStatus
        });
    }, [
        createAnalyticsEvent,
        showFlag,
        projectData
    ]);
    const handleError = (0, $eUqFw.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$4e427f77b64bbbed)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$20ef020abfaa9ec))) {
            showFlag((0, $bLjrh.createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
            return;
        }
        if ((0, $1ybV0.ff)('user-invite-include-status-code-on-error_isxoj')) {
            if (errorMessage.includes((0, $aa13349e4e2d4a46$export$a1d765adf759361e))) showFlag((0, $bLjrh.inviteFailBadRequestFlagConfig));
            else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c7f012c6e67c4217))) showFlag((0, $bLjrh.inviteFailNetworkErrorFlagConfig));
            else if (errorMessage.includes((0, $aa13349e4e2d4a46$export$c8a538cf4ae41623)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$9bbcbc11675c1278)) || errorMessage.includes((0, $aa13349e4e2d4a46$export$a51af3c30283d234))) showFlag((0, $bLjrh.inviteFailGenericFlagConfig));
            else showFlag((0, $bLjrh.inviteFailFlagConfig));
        } else showFlag((0, $bLjrh.inviteFailFlagConfig));
        const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
        if (errorMessage.includes((0, $aa13349e4e2d4a46$export$14fb68f74ccc8b23)) || (0, $1ybV0.ff)('user-invite-include-status-code-on-error_isxoj') && isClientError) return;
        (0, $guiFP.default)({
            meta: {
                id: `jwm${modalType}Invite`,
                packageName: (0, $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b),
                teamName: 'jira-warepil'
            },
            attributes: {
                message: errorMessage
            },
            error: new Error(errorMessage),
            sendToPrivacyUnsafeSplunk: true
        });
        // The event tracked by the Invite People SLOs
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showFlag
    ]);
    return {
        handleAddSuccess: handleAddSuccess,
        handleError: handleError
    };
};

});
const $aa13349e4e2d4a46$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $aa13349e4e2d4a46$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $aa13349e4e2d4a46$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $aa13349e4e2d4a46$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $aa13349e4e2d4a46$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $aa13349e4e2d4a46$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $aa13349e4e2d4a46$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $aa13349e4e2d4a46$export$20ef020abfaa9ec = 'Licence Exceeded';
const $aa13349e4e2d4a46$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';

parcelRegister("f90H0", function(module, exports) {

$parcel$export(module.exports, "InvitationStatusEnum", () => $2279512461e31f50$export$2e0a7d2dc28c9a18);
const $2279512461e31f50$export$2e0a7d2dc28c9a18 = {
    ACCESS_REQUESTED: 'ACCESS_REQUESTED',
    INVITED: 'INVITED'
};

});

parcelRegister("bLjrh", function(module, exports) {

$parcel$export(module.exports, "inviteFailFlagConfig", () => $493a4fc4ed3495fe$export$95c6157ced8b3439);
$parcel$export(module.exports, "inviteFailGenericFlagConfig", () => $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d);
$parcel$export(module.exports, "inviteFailBadRequestFlagConfig", () => $493a4fc4ed3495fe$export$7f2d6442eed4d708);
$parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", () => $493a4fc4ed3495fe$export$c3bdacfc2255a9ed);
$parcel$export(module.exports, "createInviteSuccessFlagConfig", () => $493a4fc4ed3495fe$export$d456881895c2a0b2);
$parcel$export(module.exports, "createAddSuccessFlagConfig", () => $493a4fc4ed3495fe$export$cca35dec2a083169);
$parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", () => $493a4fc4ed3495fe$export$251dc06b3962c565);

var $jMP2a = parcelRequire("jMP2a");

var $7Ya7f = parcelRequire("7Ya7f");
const $493a4fc4ed3495fe$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
    if (totalPeopleAdded <= 0) return [
        agnosticDescription,
        {}
    ];
    return [
        specificDescription,
        {
            totalPeopleAddedMinusOne: totalPeopleAdded - 1,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }
    ];
};
const $493a4fc4ed3495fe$export$95c6157ced8b3439 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedMessageDescription,
    actions: [
        {
            content: (0, $7Ya7f.default).inviteFailedMessageCta,
            onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
        }
    ]
};
const $493a4fc4ed3495fe$export$1108ab4b8a5d8a7d = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedGenericMessageDescription
};
const $493a4fc4ed3495fe$export$7f2d6442eed4d708 = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedBadRequestMessageDescription
};
const $493a4fc4ed3495fe$export$c3bdacfc2255a9ed = {
    type: 'error',
    title: (0, $7Ya7f.default).inviteFailedMessageTitle,
    description: (0, $7Ya7f.default).inviteFailedNetworkErrorMessageDescription
};
const $493a4fc4ed3495fe$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
    if (!hasSentInvitation) return {
        type: 'success',
        title: (0, $7Ya7f.default).requestInviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).requestInviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
    return {
        type: 'success',
        title: (0, $7Ya7f.default).inviteSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).inviteSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).inviteSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        })
    };
};
const $493a4fc4ed3495fe$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
        type: 'success',
        title: (0, $7Ya7f.default).peopleAddedSuccessMessageTitle,
        description: $493a4fc4ed3495fe$export$8c9a09c293b933fb({
            agnosticDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescriptionAgnostic,
            specificDescription: (0, $7Ya7f.default).peopleAddedSuccessMessageDescription,
            totalPeopleAdded: totalPeopleAdded,
            email: email
        }),
        actions: [
            {
                content: (0, $7Ya7f.default).peopleAddedManageAccess,
                onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
            }
        ]
    });
const $493a4fc4ed3495fe$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
        type: 'warning',
        title: (0, $7Ya7f.default).userLimitInviteErrorTitle,
        description: isSiteAdmin ? (0, $7Ya7f.default).userLimitInviteErrorDescriptionAdmin : (0, $7Ya7f.default).userLimitInviteErrorDescription,
        actions: isSiteAdmin ? [
            {
                content: (0, $7Ya7f.default).upgradePlan,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                    window.open('/admin/billing/applications', '_blank');
                }
            },
            {
                content: (0, $7Ya7f.default).viewUsers,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                    window.open('/admin/users', '_blank');
                }
            }
        ] : [
            {
                content: (0, $7Ya7f.default).inviteFailedMessageCta,
                onClick: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                    window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                }
            }
        ]
    });

});
parcelRegister("7Ya7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $97084d0fb7d00df5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97084d0fb7d00df5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
        "defaultMessage": "Invitation sent"
    },
    inviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
        "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
    },
    inviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
        "defaultMessage": "You've successfully invited people to your business project."
    },
    inviteFailedMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
        "defaultMessage": "Something went wrong"
    },
    inviteFailedMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
    },
    inviteFailedMessageCta: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
        "defaultMessage": "Contact your admin"
    },
    inviteFailedGenericMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users, please try again."
    },
    inviteFailedBadRequestMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
    },
    inviteFailedNetworkErrorMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
        "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
    },
    requestInviteSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
        "defaultMessage": "Access request sent to your admin"
    },
    requestInviteSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
        "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
    },
    requestInviteSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
        "defaultMessage": "Your admin needs to approve access for people to your business project."
    },
    peopleAddedSuccessMessageTitle: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
        "defaultMessage": "New people added"
    },
    peopleAddedSuccessMessageDescription: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
        "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedSuccessMessageDescriptionAgnostic: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
        "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
    },
    peopleAddedManageAccess: {
        "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
        "defaultMessage": "Manage access"
    },
    userLimitInviteErrorTitle: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
        "defaultMessage": "Can't add more people"
    },
    userLimitInviteErrorDescriptionAdmin: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
        "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
    },
    userLimitInviteErrorDescription: {
        "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
        "defaultMessage": "You've reached your user limit. Contact your admin for help."
    },
    viewUsers: {
        "id": "business-invite-people.controllers.modal-handlers.view-users",
        "defaultMessage": "View users"
    },
    upgradePlan: {
        "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
        "defaultMessage": "Upgrade plan"
    }
});

});



parcelRegister("66rnh", function(module, exports) {

$parcel$export(module.exports, "AddPeopleModal", () => $0d2c4bae7dd02578$export$b28f48897cdf7241);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $kQAZu = parcelRequire("kQAZu");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $gGtKh = parcelRequire("gGtKh");

var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $bvGWz = parcelRequire("bvGWz");


const $0d2c4bae7dd02578$export$a4917c848b5c6ce8 = (0, $7rh0R.lazy)(()=>(parcelRequire("5zF4d")), {
    ssr: false,
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $0d2c4bae7dd02578$var$userInviteErrorCodes = {
    BAD_REQUEST_ERROR_CODE: $aa13349e4e2d4a46$export$a1d765adf759361e,
    NETWORK_ERROR_CODE: $aa13349e4e2d4a46$export$c7f012c6e67c4217,
    AUTH_FAILED_ERROR_CODE: $aa13349e4e2d4a46$export$c8a538cf4ae41623,
    SERVER_ERROR_ERROR_CODE: $aa13349e4e2d4a46$export$9bbcbc11675c1278,
    USER_NOT_FOUND_ERROR_CODE: $aa13349e4e2d4a46$export$a51af3c30283d234
};
const $0d2c4bae7dd02578$export$b28f48897cdf7241 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
    const { triggerBtnRef: triggerBtnRef } = (0, $bvGWz.useAddPeople)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const handleInviteSuccess = (0, $eUqFw.useCallback)((addedParties, _role)=>{
        onInviteSuccess({
            totalPeopleAdded: addedParties.length,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            email: addedParties[0]?.email || addedParties[0]?.displayName,
            modalType: 'Project'
        });
    }, [
        onInviteSuccess
    ]);
    // From the given error message, we want to search for a known error code defined under the user invite endpoint
    // Otherwise, we return the whole message and use that as error code for mapping later on
    const extractErrorCode = (message)=>{
        // Typescript assumes Object.keys is of type string[] so need to type cast
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const errorCode of Object.keys($0d2c4bae7dd02578$var$userInviteErrorCodes)){
            const errorMessage = $0d2c4bae7dd02578$var$userInviteErrorCodes[errorCode];
            if (message.includes(errorMessage)) return errorCode;
        }
        return message; // Return original message if no error code found
    };
    const handleInviteFailure = (0, $eUqFw.useCallback)((errors)=>{
        if ((0, $1ybV0.ff)('user-invite-include-status-code-on-error_isxoj')) {
            const userInviteErrorsWithCode = {};
            const oldUserInviteError = [];
            errors.forEach((error)=>{
                // After we cleanup user-invite-include-status-code-on-error_isxoj we shouldn't need
                // this string check as the type will always be UserInviteError
                if (typeof error === 'string') oldUserInviteError.push(error);
                else {
                    // Group all errors by known user invite error codes
                    const errorCode = extractErrorCode(error.message);
                    if (errorCode) {
                        if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                        userInviteErrorsWithCode[errorCode].push(error);
                    }
                }
            });
            // Join messages with the same error code
            const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
                const statusCode = group[0]?.statusCode; // Assuming all errors with same error code have the same status code
                const messages = group.map((obj)=>obj.message).join('\n');
                return {
                    message: messages,
                    statusCode: statusCode
                };
            });
            groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
                onInviteError({
                    modalType: 'Project',
                    errorMessage: groupedUserInviteError.message,
                    statusCode: groupedUserInviteError.statusCode
                });
            });
            return;
        }
        const errorMessage = errors?.join(', ') ?? '';
        onInviteError({
            modalType: 'Project',
            errorMessage: errorMessage
        });
    }, [
        onInviteError
    ]);
    const { id: id, key: key } = projectData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.project-invite-people-modal.add-people",
        packageName: "jira-business.project-invite-people-modal.add-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmProjectInviteComponent viewed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "add-people-modal-lazy",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d2c4bae7dd02578$export$a4917c848b5c6ce8, {
        isOpen: true,
        triggerBtnRef: triggerBtnRef,
        onClose: onModalClose,
        onAddSuccess: handleInviteSuccess,
        onError: handleInviteFailure,
        projectId: id,
        projectKey: key,
        projectType: "business",
        isAdmin: isAdmin,
        baseUrl: ""
    })));
});

});
parcelRegister("5zF4d", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('6HI0g')
        ]);
        const value = parcelRequire('4urEy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("6HI0g")
    ]).then(()=>parcelRequire('4urEy'));
}

});


parcelRegister("d1I0W", function(module, exports) {

$parcel$export(module.exports, "InvitePeopleModal", () => $c68f3c6d5279f8a1$export$e3ec81c4d0451f63);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aOw1G = parcelRequire("aOw1G");

var $kQAZu = parcelRequire("kQAZu");

var $kGQen = parcelRequire("kGQen");

var $exb0h = parcelRequire("exb0h");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $10fdS = parcelRequire("10fdS");

var $d6f6c = parcelRequire("d6f6c");

var $6Ua7e = parcelRequire("6Ua7e");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $c7H0g = parcelRequire("c7H0g");

var $f90H0 = parcelRequire("f90H0");

const $c68f3c6d5279f8a1$export$cbfde4f653ce234 = (0, $7rh0R.lazy)(()=>(parcelRequire("9Bx8m")), {
    ssr: false,
    moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
});
const $c68f3c6d5279f8a1$export$4d2a63c83bbce998 = (res)=>{
    if (res.accessRequested?.length) return (0, $f90H0.InvitationStatusEnum).ACCESS_REQUESTED;
    return (0, $f90H0.InvitationStatusEnum).INVITED;
};
const $c68f3c6d5279f8a1$var$LIST_ROUTES = [
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST_CLASSIC,
    (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST
];
const $c68f3c6d5279f8a1$var$isFailureResponse = (res)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    res.failure !== undefined;
const $c68f3c6d5279f8a1$export$e3ec81c4d0451f63 = /*#__PURE__*/ (0, $eUqFw.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const projectData = (0, $kQAZu.useProject)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onInviteCompleteHandler = (0, $eUqFw.useCallback)((response)=>{
        if ($c68f3c6d5279f8a1$var$isFailureResponse(response)) {
            const { message: message } = response.failure;
            onInviteError({
                modalType: 'Instance',
                errorMessage: message
            });
            return;
        }
        const inviteStatus = $c68f3c6d5279f8a1$export$4d2a63c83bbce998(response);
        const { invited: invited, accessRequested: accessRequested } = response;
        onInviteSuccess({
            totalPeopleAdded: invited.length || accessRequested.length,
            email: invited[0]?.email || accessRequested[0]?.email || '',
            modalType: 'Instance',
            inviteStatus: inviteStatus
        });
    }, [
        onInviteError,
        onInviteSuccess
    ]);
    const isSoftwareRoute = (0, $eUqFw.useMemo)(()=>$c68f3c6d5279f8a1$var$LIST_ROUTES.includes(route.name), [
        route
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-business.project-invite-people-modal.invite-people",
        packageName: "jira-business.project-invite-people-modal.invite-people",
        teamName: "jira-warepil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal.invite-people",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onModalClose,
        width: "small",
        shouldScrollInViewport: true,
        testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "jwmInstanceInviteComponent viewed"
    }), isSoftwareRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        isOpen: true,
        cloudId: cloudId,
        projectId: projectData.id,
        jiraProjectKey: projectData.key,
        isSiteAdmin: isAdmin,
        onClose: onModalClose,
        appEdition: (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions),
        jiraProjectName: projectData.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c68f3c6d5279f8a1$export$cbfde4f653ce234, {
        onSendHandler: onModalClose,
        onInviteCompletedHandler: onInviteCompleteHandler,
        onCancelHandler: onModalClose,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        continueUrl: window.location.href,
        enableThirdParty: true,
        source: source,
        orgId: orgId
    })))));
});

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});




parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1iV50")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("1iV50", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('e1vXm')
        ]);
        const value = parcelRequire('bagiu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("e1vXm")
    ]).then(()=>parcelRequire('bagiu'));
}

});


parcelRegister("9Bx8m", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('evBHV')
        ]);
        const value = parcelRequire('6SUBw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("evBHV")
    ]).then(()=>parcelRequire('6SUBw'));
}

});




parcelRegister("cAOjv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('j6IJU')
        ]);
        const value = parcelRequire('dNnOv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("j6IJU")
    ]).then(()=>parcelRequire('dNnOv'));
}

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("eCCst", function(module, exports) {

$parcel$export(module.exports, "JWMShareButton", () => $7c9cba86062e6e6f$export$b326da26415fdf10);

var $eUqFw = parcelRequire("eUqFw");

var $dFWNP = parcelRequire("dFWNP");

var $bDUCT = parcelRequire("bDUCT");

var $lGiWG = parcelRequire("lGiWG");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $hfslX = parcelRequire("hfslX");

var $lxV3x = parcelRequire("lxV3x");

var $bPBzW = parcelRequire("bPBzW");

var $iSNkS = parcelRequire("iSNkS");
const $7c9cba86062e6e6f$var$SHARE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
    label: "",
    size: "small"
});
const $7c9cba86062e6e6f$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareIntegrations: shareIntegrations } = (0, $hfslX.useShareIntegrations)(shareContentType);
    const entityAri = (0, $bDUCT.useEntityAri)();
    const shareButtonRef = (0, $eUqFw.useRef)(null);
    const renderCustomTriggerButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'onClick' implicitly has an 'any' type. | TS7031 - Binding element 'isSelected' implicitly has an 'any' type. | TS7031 - Binding element 'ref' implicitly has an 'any' type.
    ({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
            ...triggerProps,
            ref: shareButtonRef,
            onClick: onClick,
            isSelected: isSelected,
            iconBefore: $7c9cba86062e6e6f$var$SHARE_ICON,
            appearance: "subtle"
        }, formatMessage((0, $bPBzW.default).share))), [
        formatMessage
    ]);
    const handleDialogClose = ()=>{
        onDialogClose?.();
        if ((0, $1ybV0.ff)('jwm-a11y-round2_guwbb')) shareButtonRef?.current?.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxV3x.AsyncShareProjectNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        isAutoOpenDialog: isAutoOpenDialog,
        integrationType: integrationType,
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: "jira-core",
        shareLink: false ? '' : window.location.href,
        shareTitle: formatMessage(shareTitle),
        shareContentType: shareContentType,
        // @ts-expect-error - TS2322 - Type '({ onClick, isSelected }: { onClick: any; isSelected: any; }, { ref, ...triggerProps }: { [x: string]: any; ref: any; }) => Element' is not assignable to type 'RenderCustomTriggerButton'.
        renderCustomTriggerButton: renderCustomTriggerButton,
        objectAri: entityAri,
        onDialogClose: handleDialogClose,
        copyTooltipText: formatMessage((0, $bPBzW.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        integrationMode: "tabs",
        shareFormHelperMessage: formatMessage((0, $bPBzW.default).shareJwmHelperMessage)
    }));
};

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f4cb7ac67043f68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 15a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm12-4a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2zm0 14a3 3 0 100-6 3 3 0 000 6zm0-2a1 1 0 110-2 1 1 0 010 2z" fill-rule="nonzero"/><path d="M7 13.562l8.66 5 1-1.732-8.66-5z"/><path d="M7 10.83l1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = $9f4cb7ac67043f68$var$ShareIcon;
module.exports.default = $9f4cb7ac67043f68$var$_default;

});

parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");

var $PdmhA = parcelRequire("PdmhA");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");

const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $PdmhA).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("9XSbA")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("9XSbA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('dsiAd'),
            load('h2MrD'),
            load('bYT2S'),
            load('2xQrm')
        ]);
        const value = parcelRequire('iHQJU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("dsiAd"),
        load("h2MrD"),
        load("bYT2S"),
        load("2xQrm")
    ]).then(()=>parcelRequire('iHQJU'));
}

});


parcelRegister("hfslX", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $b36423e50cabd739$export$58a9f7a7ab3466f4);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $8q0kG = parcelRequire("8q0kG");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $dWLk9 = parcelRequire("dWLk9");

var $gWV0M = parcelRequire("gWV0M");
var $ljgr5 = parcelRequire("ljgr5");
const $b36423e50cabd739$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const ineligibilityReasons = (0, $eUqFw.useMemo)(()=>{
        const reasons = [];
        if ((0, $8q0kG.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $1ybV0.ff)('confluence.frontend.growth.fedramp-check-isolation') && (0, $dfBCt.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $eUqFw.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $ljgr5.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWV0M.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("gWV0M", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $acb191acb45641f8$export$2cc56764fd9edb21);

var $eUqFw = parcelRequire("eUqFw");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $335P8 = parcelRequire("335P8");

var $ljgr5 = parcelRequire("ljgr5");
const $acb191acb45641f8$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlackLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $335P8.StyledShareToSlack), props)));

});
parcelRegister("335P8", function(module, exports) {

$parcel$export(module.exports, "StyledShareToSlack", () => $7cc4332b79a68bdd$export$9aeb6210c91511b9);
$parcel$export(module.exports, "StyledShareToSlackLoader", () => $7cc4332b79a68bdd$export$d3f97cc63e3ee02);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $d3qIv = parcelRequire("d3qIv");
const $7cc4332b79a68bdd$export$9aeb6210c91511b9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $d3qIv.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8ax2b",
            __cmplp.className
        ])
    });
});
const $7cc4332b79a68bdd$export$d3f97cc63e3ee02 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $4Bees.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3qIv", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $3114157f9b395570$export$24281652e6b89b3b);

var $7rh0R = parcelRequire("7rh0R");

const $3114157f9b395570$export$24281652e6b89b3b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("971uQ")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("971uQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('dPtit')
        ]);
        const value = parcelRequire('dZKRj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("dPtit")
    ]).then(()=>parcelRequire('dZKRj'));
}

});



parcelRegister("ljgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f66b2d378eff6fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f66b2d378eff6fc$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});



parcelRegister("lxV3x", function(module, exports) {

$parcel$export(module.exports, "AsyncShareProjectNudge", () => $906cb1053f659eb0$export$d95995d6ca76620b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $906cb1053f659eb0$var$LazyShareProjectNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hB1df")), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
});
const $906cb1053f659eb0$export$d95995d6ca76620b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $99a775c02d636a41$export$a1be34032ee24f78),
        fallback: children,
        attributes: {
            nudgeId: (0, $99a775c02d636a41$export$a1be34032ee24f78)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-share-project-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($906cb1053f659eb0$var$LazyShareProjectNudge, null, children)));

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("hB1df", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('afZr6');
        const value = parcelRequire('16oN0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("afZr6").then(()=>parcelRequire('16oN0'));
}

});


parcelRegister("bPBzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6735bf02b619f7cd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6735bf02b619f7cd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    share: {
        "id": "business-invite-people.jwm-share-button.share",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "business-invite-people.jwm-share-button.share-tooltip-text",
        "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
    },
    shareJwmHelperMessage: {
        "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("91Lr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $aff05ea3c914239b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $l1jnn = parcelRequire("l1jnn");

var $cRKsH = parcelRequire("cRKsH");

const $aff05ea3c914239b$export$7174b56226171cc3 = (0, $7rh0R.lazy)(()=>(parcelRequire("euual")), {
    ssr: false,
    moduleId: "./src/packages/business/shared/components/more-menu/src/ui/more-menu/menu-content/index.tsx"
});
const $aff05ea3c914239b$var$MoreMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems, onConditionalFormatting: onConditionalFormatting })=>{
    const renderContent = (0, $eUqFw.useCallback)((onCloseMenu)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "menu-content",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aff05ea3c914239b$export$7174b56226171cc3, {
            hideDoneItems: hideDoneItems,
            onChangeHideDoneItems: onChangeHideDoneItems,
            onExpandCollapseAllItems: onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            onCloseMenu: onCloseMenu,
            onConditionalFormatting: onConditionalFormatting
        })), [
        hideDoneItems,
        onChangeHideDoneItems,
        onExpandCollapseAllItems,
        onConditionalFormatting,
        isExpandCollapseButtonEnabled,
        hasExpandedAllItems,
        hasCollapsedAllItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cRKsH.default), {
        renderContent: renderContent
    });
};
var $aff05ea3c914239b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($aff05ea3c914239b$var$MoreMenu);

});
parcelRegister("l1jnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91aceacdc3d4a91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");

var $3Y9u8 = parcelRequire("3Y9u8");
const $a91aceacdc3d4a91$var$MenuFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y9u8.SpinnerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
var $a91aceacdc3d4a91$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($a91aceacdc3d4a91$var$MenuFallback);

});
parcelRegister("3Y9u8", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $4a1a450a9393c394$export$52b4dfd89a6b3a1b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $4a1a450a9393c394$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cRKsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ab88bbf4e192a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jK1pm = parcelRequire("jK1pm");


var $fG0qd = parcelRequire("fG0qd");
const $b0ab88bbf4e192a9$var$MoreMenuCore = /*#__PURE__*/ (0, $eUqFw.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f81b038ef83e0f85$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(forceVisibility);
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(forceVisibility);
    }, [
        forceVisibility
    ]);
    const closeMenu = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggleMenu = (0, $eUqFw.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0ab88bbf4e192a9$export$5f7211d21bfdae05, {
            width: minWidth
        }, renderContent(closeMenu)), [
        closeMenu,
        renderContent,
        minWidth
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG0qd.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenu
        }), [
        isOpen,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "business-more-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    }));
});
var $b0ab88bbf4e192a9$export$2e2bcd8739ae039 = $b0ab88bbf4e192a9$var$MoreMenuCore;
const $b0ab88bbf4e192a9$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});

});
const $f81b038ef83e0f85$export$8c68b096b2d5e9f6 = 320;

parcelRegister("fG0qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4453e9a08a331d11$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG1wZ = parcelRequire("jG1wZ");

var $lGiWG = parcelRequire("lGiWG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k1mhY = parcelRequire("k1mhY");
const $4453e9a08a331d11$var$MORE_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
    label: "",
    size: "small"
});
const $4453e9a08a331d11$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        ...otherProps,
        ref: ref,
        testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
        iconBefore: $4453e9a08a331d11$var$MORE_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle",
        "aria-label": formatMessage((0, $k1mhY.default).moreButtonLabel)
    }, formatMessage((0, $k1mhY.default).moreButton));
});
var $4453e9a08a331d11$export$2e2bcd8739ae039 = $4453e9a08a331d11$var$Trigger;

});
parcelRegister("k1mhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $255e4847f5c60031$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $255e4847f5c60031$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreButton: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
        "defaultMessage": "More"
    },
    moreButtonLabel: {
        "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
        "defaultMessage": "More actions on the view options"
    }
});

});



parcelRegister("euual", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('17KHX');
        const value = parcelRequire('dBYRZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("17KHX").then(()=>parcelRequire('dBYRZ'));
}

});


const $dd8a6385bf5dfbc6$export$7b88fd4d1ff6218e = 'LIST_EMBED_NUDGE_STEP';

parcelRegister("7h3LT", function(module, exports) {

$parcel$export(module.exports, "useNudgeStep", () => $d7dc45dde0393f37$export$c5e63e44ad178ae8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

const $d7dc45dde0393f37$var$actions = {
    setNudgeStep: (nudgeStep)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                nudgeStep: nudgeStep
            }),
    setShouldOpenModal: (shouldOpenModal)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                shouldOpenModal: shouldOpenModal
            })
};
// @ts-expect-error - TS2344 - Type '{ readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; readonly setShouldOpenModal: (shouldOpenModal: boolean) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setNudgeStep: (nudgeStep: NUDGE_STEP) => ({ setState, getState }: StoreState<State>) => void; readonly setShouldOpenModal: (shouldOpenModal: boolean) => ({ setState, getState }: StoreState<...>) => void; }>>'.
const $d7dc45dde0393f37$var$Store = (0, $a61MH.createStore)({
    initialState: {
        nudgeStep: (0, $dd8a6385bf5dfbc6$export$7b88fd4d1ff6218e),
        shouldOpenModal: false
    },
    actions: $d7dc45dde0393f37$var$actions,
    name: 'JWMListEmbedNudgeStepStore'
});
const $d7dc45dde0393f37$export$c5e63e44ad178ae8 = (0, $ggKAj.createHook)($d7dc45dde0393f37$var$Store);

});

parcelRegister("3007p", function(module, exports) {

$parcel$export(module.exports, "FilterDropdownListNudgeAsync", () => $492e91749dd4ef09$export$7d038d6ad1823996);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $105cx = parcelRequire("105cx");

var $jAS31 = parcelRequire("jAS31");
const $492e91749dd4ef09$var$runtimeProps = {};
const $492e91749dd4ef09$var$entryPointParams = {};
const $492e91749dd4ef09$export$7d038d6ad1823996 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jAS31.filterDropdownNudgeEntrypoint), $492e91749dd4ef09$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: filterDropdownNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$5908fa8acd2c0739), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: filterDropdownNudgeRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $492e91749dd4ef09$var$runtimeProps
    }));
};

});
parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9WJJx = parcelRequire("9WJJx");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("jAS31", function(module, exports) {

$parcel$export(module.exports, "filterDropdownNudgeEntrypoint", () => $7633c2afcd7fab51$export$5cbb00667240a7df);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $7633c2afcd7fab51$export$5cbb00667240a7df = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("2471P")), {
        moduleId: "202abeae"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2471P", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1ZHXu');
        const value = parcelRequire('cMrYY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1ZHXu").then(()=>parcelRequire('cMrYY'));
}

});



parcelRegister("6MsoD", function(module, exports) {

$parcel$export(module.exports, "MoreDropdownListNudgeAsync", () => $a450ab744330ff92$export$49ce8a5fd7f1f225);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $105cx = parcelRequire("105cx");

var $hbeEy = parcelRequire("hbeEy");
const $a450ab744330ff92$var$runtimeProps = {};
const $a450ab744330ff92$var$entryPointParams = {};
const $a450ab744330ff92$export$49ce8a5fd7f1f225 = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $hbeEy.moreDropdownNudgeEntrypoint), $a450ab744330ff92$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: filterDropdownNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$50192b0fdc9bdacf), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: filterDropdownNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $a450ab744330ff92$var$runtimeProps
    }));
};

});
parcelRegister("hbeEy", function(module, exports) {

$parcel$export(module.exports, "moreDropdownNudgeEntrypoint", () => $6f385665b812fa99$export$32cd09a154d643d4);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $6f385665b812fa99$export$32cd09a154d643d4 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("8uRVj")), {
        moduleId: "2bbbd889"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8uRVj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f2QdF');
        const value = parcelRequire('iBIsO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f2QdF").then(()=>parcelRequire('iBIsO'));
}

});



parcelRegister("3Cjpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $569cf272949ec321$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $afdwN = parcelRequire("afdwN");

var $c2AuN = parcelRequire("c2AuN");
const $569cf272949ec321$var$GroupByDropdown = ()=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const close = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const toggle = (0, $eUqFw.useCallback)(()=>setIsOpen((wasOpen)=>!wasOpen), []);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($569cf272949ec321$export$5f7211d21bfdae05, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afdwN.default), {
            popupWidth: (0, $fe06322403b52911$export$8c68b096b2d5e9f6),
            onToggle: toggle
        })), [
        toggle
    ]);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2AuN.default), {
            ...triggerProps,
            isSelected: isOpen,
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'groupByDropdown');
                toggle();
            }
        }), [
        createAnalyticsEvent,
        isOpen,
        toggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: close,
        placement: "bottom-end",
        content: content,
        trigger: trigger,
        shouldRenderToParent: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds'),
        strategy: (0, $1ybV0.ff)('fix-should-render-to-parent-with-custom-backgrounds') ? 'absolute' : undefined
    });
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any
$569cf272949ec321$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($569cf272949ec321$var$GroupByDropdown);
const $569cf272949ec321$export$5f7211d21bfdae05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
const $fe06322403b52911$export$8c68b096b2d5e9f6 = 200;

parcelRegister("afdwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8080940516b2fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $l1jnn = parcelRequire("l1jnn");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc8080940516b2fb$var$GroupByDropdownOptions = (0, $7rh0R.lazy)(()=>(parcelRequire("1wEIv")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/header-actions/group-by-dropdown/dropdown-options/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fc8080940516b2fb$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "group-by-dropdown-options",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1jnn.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc8080940516b2fb$var$GroupByDropdownOptions, props));

});
parcelRegister("1wEIv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('53kwy');
        const value = parcelRequire('8FbGg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("53kwy").then(()=>parcelRequire('8FbGg'));
}

});


parcelRegister("c2AuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7608faa10733e46e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b8123 = parcelRequire("b8123");

var $lGiWG = parcelRequire("lGiWG");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $9w3zf = parcelRequire("9w3zf");

var $dSE3z = parcelRequire("dSE3z");

var $FRXWS = parcelRequire("FRXWS");
const $7608faa10733e46e$var$GROUP_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
    label: "",
    size: "small"
});
const $7608faa10733e46e$var$Trigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const groupByField = (0, $9w3zf.useGetGroupByField)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGiWG.ThemedButton), {
        testId: "business-list.ui.list-view.header-actions.group-by-dropdown.trigger.button-wrapper",
        iconBefore: $7608faa10733e46e$var$GROUP_ICON,
        isSelected: isSelected,
        onClick: onClick,
        appearance: "subtle"
    }, groupByFieldId == null ? formatMessage((0, $FRXWS.default).groupByButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $FRXWS.default).groupByActiveButton,
        values: {
            groupByFieldId: groupByField?.name
        }
    })));
});
var $7608faa10733e46e$export$2e2bcd8739ae039 = $7608faa10733e46e$var$Trigger;

});
parcelRegister("FRXWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9136e89df49d7d1e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9136e89df49d7d1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupByButton: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-button",
        "defaultMessage": "Group"
    },
    groupByActiveButton: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button",
        "defaultMessage": "Group by: {groupByFieldId}"
    },
    groupByAssignee: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-assignee",
        "defaultMessage": "Assignee"
    },
    groupByStatus: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-status",
        "defaultMessage": "Status"
    },
    groupByPriority: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-priority",
        "defaultMessage": "Priority"
    },
    groupByCategory: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-category",
        "defaultMessage": "Category"
    },
    groupByStoryPoints: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-points",
        "defaultMessage": "Story points"
    },
    groupByStoryPointEstimate: {
        "id": "business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-point-estimate",
        "defaultMessage": "Story point estimate"
    }
});

});



parcelRegister("eXDkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e912dc4da90dc873$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e912dc4da90dc873$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "business-list.list-view.header-actions.share-title",
        "defaultMessage": "List"
    },
    simpleSearch: {
        "id": "business-list.list-view.header-actions.simple-search",
        "defaultMessage": "Search list"
    },
    searchLabel: {
        "id": "business-list.list-view.header-actions.search-label",
        "defaultMessage": "Typing letters in the search input applies filters"
    }
});

});

parcelRegister("1X186", function(module, exports) {

$parcel$export(module.exports, "useFilterProps", () => $4a2983d9b3a9c1b9$export$5e00405c50f0041a);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $lO4Or = parcelRequire("lO4Or");

var $egJIx = parcelRequire("egJIx");

var $hHiDc = parcelRequire("hHiDc");
const $4a2983d9b3a9c1b9$var$createStringSet = (0, $5iWql.default)((...args)=>new Set([
        ...args
    ]));
const $4a2983d9b3a9c1b9$export$5e00405c50f0041a = ()=>{
    const { getAvailableFields: getAvailableFields } = (0, $hHiDc.useIssueFields)();
    const { isSoftwareFieldsEnabled: isSoftwareFieldsEnabled } = (0, $egJIx.useJWMListFeatures)();
    const availableFields = (0, $eUqFw.useMemo)(()=>getAvailableFields(), [
        getAvailableFields
    ]);
    // Only hides active sprints if the field is not available or is not software or FF is off
    const hiddenQuickFilters = (0, $eUqFw.useMemo)(()=>{
        if (!isSoftwareFieldsEnabled) return [
            'ACTIVE_SPRINTS'
        ];
        const sprintField = availableFields.find((field)=>field.type === (0, $lO4Or.SPRINT_TYPE));
        if (sprintField == null) return [
            'ACTIVE_SPRINTS'
        ];
        return [];
    }, [
        availableFields,
        isSoftwareFieldsEnabled
    ]);
    const allowedAliasFieldId = (0, $eUqFw.useMemo)(()=>{
        if (!isSoftwareFieldsEnabled) return;
        const fieldsAliases = availableFields.filter((field)=>field.aliasFieldId === (0, $jGcn0.STORY_POINTS_ALIAS_FIELD_ID) || field.aliasFieldId === (0, $jGcn0.STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)).map((field)=>field.aliasFieldId);
        if (fieldsAliases.length === 0) return;
        return $4a2983d9b3a9c1b9$var$createStringSet(...fieldsAliases);
    }, [
        availableFields,
        isSoftwareFieldsEnabled
    ]);
    return {
        allowedAliasFieldId: allowedAliasFieldId,
        hiddenQuickFilters: hiddenQuickFilters
    };
};

});


parcelRegister("6lgzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c94c5e4d797761$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0c94c5e4d797761$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    listHeading: {
        "id": "business-list.list-view.list-heading",
        "defaultMessage": "List"
    },
    unassignedOption: {
        "id": "business-list.list-view.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    assignToMe: {
        "id": "business-list.list-view.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    loadingMoreItems: {
        "id": "business-list.list-view.loading-more-items",
        "defaultMessage": "Loading more items..."
    }
});

});

parcelRegister("1ukK3", function(module, exports) {

$parcel$export(module.exports, "InteractionMetrics", () => $25b02abb4e2117cd$export$341b330828bd3906);

var $jwBHm = parcelRequire("jwBHm");
const $25b02abb4e2117cd$export$341b330828bd3906 = ()=>{
    const interactionMetrics = (0, $jwBHm.useInteractionMetrics)();
    if (interactionMetrics[0, $jwBHm.COLUMN_RESIZED].state === 'started') interactionMetrics[0, $jwBHm.COLUMN_RESIZED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $jwBHm.COLUMN_VISIBILITY_CHANGED].state === 'started') interactionMetrics[0, $jwBHm.COLUMN_VISIBILITY_CHANGED].stop({
        stopTime: Math.floor(performance.now())
    });
    if (interactionMetrics[0, $jwBHm.DND_ROW_DROPPED].state === 'started') interactionMetrics[0, $jwBHm.DND_ROW_DROPPED].stop({
        stopTime: Math.floor(performance.now())
    });
    return null;
};

});

parcelRegister("dSlaZ", function(module, exports) {

$parcel$export(module.exports, "AsyncReparentModal", () => $2451cd1567bac57e$export$2afac3ca0625436);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $85xFO = parcelRequire("85xFO");

var $abSTX = parcelRequire("abSTX");
const $2451cd1567bac57e$var$runtimeProps = {};
const $2451cd1567bac57e$var$entryPointParams = {};
const $2451cd1567bac57e$export$2afac3ca0625436 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $85xFO.reparentModalEntryPoint), $2451cd1567bac57e$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jwm.list.reparent-modal",
        packageName: (0, $abSTX.PACKAGE_NAME),
        teamName: "keystone",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $2451cd1567bac57e$var$runtimeProps,
        errorFallback: "unmount"
    });
};

});
parcelRegister("85xFO", function(module, exports) {

$parcel$export(module.exports, "reparentModalEntryPoint", () => $666b43736db1313a$export$e5e5cbbac06953a1);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $666b43736db1313a$export$e5e5cbbac06953a1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("3zfgc")), {
        moduleId: "aa8d69b8"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3zfgc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('cPKRD')
        ]);
        const value = parcelRequire('AlhnY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("cPKRD")
    ]).then(()=>parcelRequire('AlhnY'));
}

});


parcelRegister("abSTX", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e7c7478c8b87e1a2$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $e7c7478c8b87e1a2$export$5b388ccfa29be01);
const $e7c7478c8b87e1a2$export$b8b9d90f9e5bd72b = 'jiraBusinessList';
const $e7c7478c8b87e1a2$export$5b388ccfa29be01 = -1;

});


parcelRegister("dcGUq", function(module, exports) {

$parcel$export(module.exports, "useGetColumns", () => $8a794b760b661474$export$5cedf9467e164d21);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $kQAZu = parcelRequire("kQAZu");

var $41WOo = parcelRequire("41WOo");

var $lYoXb = parcelRequire("lYoXb");
var $6imc4 = parcelRequire("6imc4");

var $kBh2b = parcelRequire("kBh2b");

var $3uSNh = parcelRequire("3uSNh");

var $8Qd0L = parcelRequire("8Qd0L");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $gbsaq = parcelRequire("gbsaq");

var $Kei82 = parcelRequire("Kei82");

var $aXbY8 = parcelRequire("aXbY8");

var $lqO9q = parcelRequire("lqO9q");

var $b7r1l = parcelRequire("b7r1l");

var $hHiDc = parcelRequire("hHiDc");

var $1Te3F = parcelRequire("1Te3F");

var $5r9Wo = parcelRequire("5r9Wo");

var $lAcL9 = parcelRequire("lAcL9");

var $eMPoQ = parcelRequire("eMPoQ");

var $lhlwL = parcelRequire("lhlwL");

var $d3tIX = parcelRequire("d3tIX");

var $jxvjJ = parcelRequire("jxvjJ");

var $fG10K = parcelRequire("fG10K");

var $2Mt92 = parcelRequire("2Mt92");

var $62F3R = parcelRequire("62F3R");

var $2tEhM = parcelRequire("2tEhM");

var $atvEr = parcelRequire("atvEr");

var $dNtbZ = parcelRequire("dNtbZ");

var $5c3sP = parcelRequire("5c3sP");

var $g3fEZ = parcelRequire("g3fEZ");

var $5kwBu = parcelRequire("5kwBu");

var $6lgzJ = parcelRequire("6lgzJ");

var $IIbrH = parcelRequire("IIbrH");

var $jmKEB = parcelRequire("jmKEB");

var $cMZur = parcelRequire("cMZur");

var $fk8YW = parcelRequire("fk8YW");

var $hgKBS = parcelRequire("hgKBS");

var $iWW7F = parcelRequire("iWW7F");

var $7v11U = parcelRequire("7v11U");

var $67zRT = parcelRequire("67zRT");

var $a0Bmj = parcelRequire("a0Bmj");

var $7lf5Y = parcelRequire("7lf5Y");

var $kmNgr = parcelRequire("kmNgr");

var $9dQoH = parcelRequire("9dQoH");

var $eggEB = parcelRequire("eggEB");

var $1NqHF = parcelRequire("1NqHF");

var $261bh = parcelRequire("261bh");
const $8a794b760b661474$var$dateFieldWidth = 120;
const $8a794b760b661474$var$getAlwaysVisibleFieldsMemoized = (0, $5iWql.default)((0, $1Te3F.getAlwaysVisibleFields));
const $8a794b760b661474$export$23779177436374fa = ()=>({
        [(0, $lO4Or.ISSUE_TYPE)]: 110,
        key: 120,
        [(0, $lO4Or.SUMMARY_TYPE)]: 400,
        [(0, $lO4Or.STATUS_TYPE)]: 120,
        [(0, $lO4Or.ASSIGNEE_TYPE)]: 180,
        [(0, $lO4Or.REPORTER_TYPE)]: 180,
        [(0, $lO4Or.USER_CF_TYPE)]: 180,
        [(0, $lO4Or.DUE_DATE_TYPE)]: $8a794b760b661474$var$dateFieldWidth,
        [(0, $lO4Or.CREATED)]: $8a794b760b661474$var$dateFieldWidth,
        [(0, $lO4Or.UPDATED)]: $8a794b760b661474$var$dateFieldWidth,
        [(0, $lO4Or.PRIORITY_TYPE)]: 120,
        [(0, $lO4Or.LABELS_TYPE)]: 170,
        [(0, $lO4Or.SELECT_CF_TYPE)]: 120,
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: 170,
        [(0, $lO4Or.URL_CF_TYPE)]: 180,
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: 200,
        moreFields: 50,
        [(0, $lO4Or.DATETIME_CF_TYPE)]: 200,
        [(0, $lO4Or.COMPONENTS_TYPE)]: 170,
        [(0, $lO4Or.CATEGORY_TYPE)]: 170,
        [(0, $lO4Or.COMMENT_TYPE)]: 145,
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: 145,
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: 200,
        [(0, $lO4Or.SPRINT_TYPE)]: 145,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $lYoXb.getColumnWidths)() : {}
    });
const $8a794b760b661474$export$f2dfe9615519b1 = ()=>({
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: false,
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: false,
        [(0, $lO4Or.PEOPLE_CF_TYPE)]: false,
        [(0, $lO4Or.COMMENT_TYPE)]: false,
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: false,
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: false,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (0, $6imc4.getSortingDisabledFields)() : {}
    });
const $8a794b760b661474$var$COMMON_COLUMN_ATTRIBUTES = {
    frozen: false,
    maxWidth: 640,
    minWidth: 120,
    resizable: true
};
const $8a794b760b661474$var$COLUMN_ATTRIBUTE_OVERRIDES = {
    [(0, $lO4Or.PRIORITY_TYPE)]: {
        minWidth: 52
    },
    [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: {
        minWidth: 200
    },
    key: {
        minWidth: 72
    }
};
const $8a794b760b661474$var$SELECT_ROW_COLUMN = {
    key: (0, $lqO9q.SELECT_ROW_COLUMN_ID),
    dataKey: (0, $lqO9q.SELECT_ROW_COLUMN_ID),
    width: (0, $gbsaq.SELECT_ROW_COLUMN_WIDTH),
    headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7v11U.SelectAllColumnCheckbox), null),
    cellRenderer: (props)=>{
        if ((0, $aXbY8.isItemSkeleton)(props.rowData.issueId)) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: (0, $Kei82.loadingCellStyles)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxvjJ.CellNavigation), {
            columnIndex: 0,
            rowIndex: props.rowIndex || 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7v11U.SelectRowCheckbox), props));
    }
};
const $8a794b760b661474$var$iconSize = 'medium';
const $8a794b760b661474$var$EMPTY_ARRAY = [];
const $8a794b760b661474$var$EMPTY_PAGES_ARRAY = [];
// temporarily stored in an array until the endpoint is ready
const $8a794b760b661474$var$GLOBAL_SYSTEM_FIELDS_LIST = [
    'key',
    'issuetype',
    'summary',
    'status',
    'assignee',
    'duedate',
    'priority',
    'labels',
    'created',
    'updated',
    'reporter',
    'timeoriginalestimate',
    (0, $jGcn0.COMMENT_SUMMARY_TYPE),
    (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
    'parent',
    'resolution'
];
const $8a794b760b661474$var$isTimeTrackingConfigNeeded = (field)=>field.type === (0, $lO4Or.TIME_ESTIMATE_TYPE);
const $8a794b760b661474$export$5cedf9467e164d21 = ({ columnWidths: columnWidths, rowHeight: rowHeight, openIssueModal: openIssueModal, highlightRow: highlightRow, loading: pageLoading, projectId: projectId, onIssueUpdated: onIssueUpdated })=>{
    const { hierarchyLevelsWithCache: hierarchyLevelsWithCache, getVisibleFields: getVisibleFields, loading: loading, isVisibleFieldsCached: isVisibleFieldsCached } = (0, $hHiDc.useIssueFields)();
    const visibleFields = getVisibleFields();
    const iconMap = (0, $kBh2b.getFieldIcons)($8a794b760b661474$var$iconSize);
    const { data: projectData, getProjectData: getProjectData, loading: projectDataLoading } = (0, $eMPoQ.useJiraSettings)();
    const [, { getParentIssueKeysByChildId: getParentIssueKeysByChildId }] = (0, $5r9Wo.useHierarchyStore)();
    const { onOpenCommentsSidebar: onOpenCommentsSidebar, selectedIssueKey: selectedIssueKey } = (0, $b7r1l.useCommentsSidebar)({
        CommentsSidebar: $2tEhM.CommentsSidebar
    });
    const [{ createFields: createFields }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const [hierarchyStore] = (0, $5r9Wo.useHierarchyStore)();
    const currentFirstRowKey = (0, $eUqFw.useRef)();
    const project = (0, $kQAZu.useProject)();
    const defaultColumnWidths = (0, $eUqFw.useMemo)(()=>$8a794b760b661474$export$23779177436374fa(), []);
    const sortingActions = (0, $eUqFw.useMemo)(()=>$8a794b760b661474$export$f2dfe9615519b1(), []);
    const columnFields = (0, $eUqFw.useMemo)(()=>{
        const _columnFields = [
            ...visibleFields
        ];
        if ((0, $41WOo.isJwmInlineFieldCreateEnabled)() && createFields.length > 0) createFields.forEach(({ fieldId: fieldId, name: name, type: type, createIndex: createIndex })=>{
            const placeholderField = {
                id: `${(0, $lqO9q.PLACEHOLDER_COLUMN)}-${fieldId}`,
                name: name,
                type: type
            };
            if (createIndex != null) _columnFields.splice(createIndex, 0, placeholderField);
            else _columnFields.push(placeholderField);
        });
        return _columnFields;
    }, [
        visibleFields,
        createFields
    ]);
    // This function finds the first issue row from the top within the first group item
    const getFirstGroupChildRowKey = (0, $eUqFw.useCallback)(()=>{
        const groups = hierarchyStore.hierarchyData.data;
        const firstGroupChild = groups[0]?.children;
        if (!Array.isArray(groups) || !firstGroupChild) return null;
        const firstGroupRow = firstGroupChild.length > 0 && firstGroupChild[0].key.startsWith((0, $aXbY8.INLINE_CREATE_ITEM_PREFIX)) ? firstGroupChild[1] : firstGroupChild[0];
        const firstGroupChildRowKey = firstGroupRow?.key ?? null;
        return firstGroupChildRowKey;
    }, [
        hierarchyStore.hierarchyData.data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstGroupChildRowKey = getFirstGroupChildRowKey();
        currentFirstRowKey.current = firstGroupChildRowKey;
    }, [
        getFirstGroupChildRowKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // defer loading project data until estimate column is visible
        if (!projectData && visibleFields.find((field)=>field.type === (0, $lO4Or.TIME_ESTIMATE_TYPE)) && !projectDataLoading && pageLoading === false) getProjectData();
    }, [
        projectData,
        pageLoading,
        getProjectData,
        visibleFields,
        projectDataLoading
    ]);
    const hierarchyLevelsByName = (0, $eUqFw.useMemo)(()=>Object.fromEntries(hierarchyLevelsWithCache.map((hierarchyLevel)=>[
                hierarchyLevel.name,
                hierarchyLevel.level,
                hierarchyLevel.id
            ])), [
        hierarchyLevelsWithCache
    ]);
    const cellRenderers = (0, $eUqFw.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const toReturn = {};
        columnFields// eslint-disable-next-line complexity
        .map((field)=>{
            switch(field.type){
                case 0, $lO4Or.ISSUE_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eggEB.TypeCell), {
                                id: rowData.issueId,
                                iconUrl: cellData.iconUrl,
                                name: cellData.name,
                                avatarId: field.fieldConfig?.avatarId,
                                onChildCreateButtonClicked: rowData.onChildCreateButtonClicked,
                                hierarchyLevel: hierarchyLevelsByName[rowData.issuetype.name ?? '']
                            })
                    };
                case 'key':
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>{
                            const parentIssues = getParentIssueKeysByChildId(rowData.issueId);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3fEZ.KeyCell), {
                                issueId: rowData.id,
                                issueKey: cellData,
                                parentIssues: parentIssues,
                                onOpenIssueModal: openIssueModal
                            });
                        }
                    };
                case 0, $lO4Or.SUMMARY_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, rowIndex: rowIndex })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dQoH.TextCell), {
                                isNudgeCell: rowIndex === 0 || rowData?.key === currentFirstRowKey.current,
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldType: (0, $lO4Or.SUMMARY_TYPE),
                                fieldValue: cellData,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                testId: "business-list.ui.list-view.summary-cell"
                            })
                    };
                case 0, $lO4Or.URL_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const url = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'url', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1NqHF.UrlCell), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldType: (0, $lO4Or.URL_CF_TYPE),
                                fieldValue: url,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.TEXT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const wiki = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'wiki', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dQoH.TextCell), {
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldType: (0, $lO4Or.TEXT_CF_TYPE),
                                fieldValue: wiki,
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                testId: "business-list.ui.list-view.text-cf-cell"
                            });
                        }
                    };
                case 0, $lO4Or.TEXT_AREA_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const adf = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'adf', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kmNgr.TextAreaCell), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.TEXT_AREA_CF_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                onClick: openIssueModal(rowData),
                                fieldValue: adf
                            });
                        }
                    };
                case 0, $lO4Or.STATUS_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7lf5Y.default), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                width: column.width,
                                height: rowHeight,
                                rowData: rowData,
                                onHighlightRow: highlightRow,
                                ...cellData
                            })
                    };
                case 0, $lO4Or.ASSIGNEE_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'userValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $261bh.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.ASSIGNEE_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $6lgzJ.default).unassignedOption,
                                loggedInUserActionNameText: (0, $6lgzJ.default).assignToMe,
                                testId: "business-list.ui.list-view.assignee-cell",
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.COMMENT_TYPE:
                case 0, $jGcn0.COMMENT_SUMMARY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const totalCount = rowData?.commentSummary?.totalCount;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $62F3R.CommentsCell), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                isSelected: selectedIssueKey === rowData.key,
                                onClick: onOpenCommentsSidebar,
                                totalCount: totalCount
                            });
                        }
                    };
                case 0, $lO4Or.REPORTER_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'userValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $261bh.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.REPORTER_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $6lgzJ.default).unassignedOption,
                                loggedInUserActionNameText: (0, $6lgzJ.default).assignToMe,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.USER_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const userField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedUser', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $261bh.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.USER_CF_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: userField,
                                width: column.width,
                                emptyUserNameText: (0, $6lgzJ.default).unassignedOption,
                                loggedInUserActionNameText: (0, $6lgzJ.default).assignToMe,
                                // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'never'.
                                isEditable: userField?.isEditable,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.LABELS_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const labels = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'labels', []);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kwBu.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.LABELS_CF_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                issueLabels: labels,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.LABELS_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kwBu.default), {
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.LABELS_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                issueLabels: cellData,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $lO4Or.PRIORITY_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData, column: column })=>{
                            if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
                                const priorityValue = (0, $3uSNh.safeGetTransformedFieldValue)(rowData.fields, field.id, 'priority', {});
                                const { name: name, id: id } = rowData.issuetype;
                                if (typeof name !== 'string' || typeof id !== 'string') return;
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgKBS.default), {
                                    ...priorityValue,
                                    fieldType: (0, $lO4Or.PRIORITY_TYPE),
                                    issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                    width: column.width,
                                    height: rowHeight,
                                    fieldName: field.name,
                                    issueType: name,
                                    issueTypeId: id,
                                    testId: "business-list.ui.list-view.priority-cell",
                                    isEditable: field.fieldConfig?.isEditable ?? false,
                                    selectOptions: field.fieldConfig?.options ?? []
                                });
                            }
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgKBS.default), {
                                ...cellData,
                                fieldType: (0, $lO4Or.PRIORITY_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                width: column.width,
                                height: rowHeight,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                testId: "business-list.ui.list-view.priority-cell",
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                selectOptions: field.fieldConfig?.options ?? []
                            });
                        }
                    };
                case 0, $lO4Or.DUE_DATE_TYPE:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNtbZ.default), {
                                issueId: rowData.issueId,
                                fieldKey: field.id,
                                dateOnly: cellData,
                                fieldType: (0, $lO4Or.DUE_DATE_TYPE),
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                isDue: String(rowData.status?.categoryId) !== String((0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.DONE))),
                                testId: "business-list.ui.list-view.date-cell",
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $lO4Or.CREATED:
                case 0, $lO4Or.UPDATED:
                    return {
                        [field.id]: ({ cellData: cellData, rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNtbZ.default), {
                                issueId: rowData.issueId,
                                fieldKey: field.id,
                                readOnly: true,
                                dateOnly: cellData,
                                onOpenIssueModal: openIssueModal,
                                rowData: rowData,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            })
                    };
                case 0, $lO4Or.SELECT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValue = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $67zRT.default), {
                                fieldType: (0, $lO4Or.SELECT_CF_TYPE),
                                fieldName: field.name,
                                selectOptions: field.fieldConfig?.selectOptions,
                                width: column.width,
                                fieldKey: field.id,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: selectedValue,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.MULTI_SELECT_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValues', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $IIbrH.default), {
                                fieldType: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
                                fieldName: field.name,
                                selectOptions: field.fieldConfig?.selectOptions,
                                width: column.width,
                                fieldKey: field.id,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.CATEGORY_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const getFieldValue = ()=>(0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                rowData.fields, field.id, 'value', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lhlwL.default), {
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                width: column.width,
                                fieldKey: field.id,
                                fieldType: (0, $lO4Or.CATEGORY_TYPE),
                                issueTypeId: rowData.issuetype.id != null ? Number.parseInt(rowData.issuetype.id, 10) : -1,
                                isEditable: true,
                                fieldValue: getFieldValue(),
                                fieldName: field.name,
                                issueType: rowData.issuetype?.name
                            });
                        }
                    };
                case 0, $lO4Or.TIME_ESTIMATE_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const originalEstimate = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'originalEstimate', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fk8YW.default), {
                                config: projectData?.jiraSettings?.timeTracking ?? undefined,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldId: field.id,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                fieldValue: originalEstimate
                            });
                        }
                    };
                case 0, $lO4Or.DATE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const stringValue = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'stringValue', null);
                            return rowData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNtbZ.default), {
                                issueId: rowData.issueId,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                readOnly: !field.fieldConfig?.isEditable,
                                fieldType: (0, $lO4Or.DATE_CF_TYPE),
                                fieldValue: stringValue,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.NUMBER_CF_TYPE:
                case 0, $lO4Or.STORY_POINTS_TYPE:
                case 0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>{
                            const numberField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'floatValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMZur.default), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldType: field.type,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number | null'.
                                fieldValue: numberField,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.DATETIME_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const dateTimeField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'dateTimeValue', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c3sP.default), {
                                height: rowHeight,
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldValue: dateTimeField,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.MULTI_USER_CF_TYPE:
                case 0, $lO4Or.PEOPLE_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const multiUserField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, field.type === (0, $lO4Or.MULTI_USER_CF_TYPE) ? 'selectedUsers' : 'users', undefined);
                            const fieldType = field.type;
                            if (fieldType == null) return null;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jmKEB.default), {
                                height: rowHeight,
                                fieldKey: field.id,
                                fieldType: fieldType,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                initialValue: multiUserField,
                                width: column.width,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                fieldName: field.name,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.COMPONENTS_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const componentsField = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'componentValues', undefined);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atvEr.default), {
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldValue: componentsField,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId
                            });
                        }
                    };
                case 0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWW7F.default), {
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                issueId: rowData.issueId,
                                pages: rowData.confluenceLinks?.linkedConfluencePages?.pages || $8a794b760b661474$var$EMPTY_PAGES_ARRAY,
                                pageCount: rowData.confluenceLinks?.linkedConfluencePages?.pageCount || 0
                            })
                    };
                case 0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'selectedValues', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fG10K.default), {
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldName: field.name,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId,
                                selectOptions: field.fieldConfig?.selectOptions,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id
                            });
                        }
                    };
                case 0, $lO4Or.SPRINT_TYPE:
                    return {
                        [field.id]: ({ rowData: rowData, column: column })=>{
                            const selectedValues = (0, $3uSNh.safeGetTransformedFieldValue)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            rowData.fields, field.id, 'sprint', null);
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0Bmj.default), {
                                width: column.width,
                                issueKey: (0, $6vrw7.toIssueKey)(rowData.key),
                                fieldKey: field.id,
                                fieldName: field.name,
                                fieldValue: selectedValues,
                                isEditable: field.fieldConfig?.isEditable ?? false,
                                issueId: rowData.issueId,
                                issueType: rowData.issuetype.name,
                                issueTypeId: rowData.issuetype.id,
                                issueTypeLevel: rowData.issuetype.level
                            });
                        }
                    };
                default:
                    return {
                        [field.id]: undefined
                    };
            }
        }).forEach((fieldEntry)=>fieldEntry && Object.keys(fieldEntry).forEach((fieldKey)=>{
                toReturn[fieldKey] = fieldEntry[fieldKey];
            }));
        return toReturn;
    }, [
        getParentIssueKeysByChildId,
        hierarchyLevelsByName,
        highlightRow,
        onOpenCommentsSidebar,
        openIssueModal,
        projectData?.jiraSettings?.timeTracking,
        rowHeight,
        selectedIssueKey,
        columnFields
    ]);
    const iconMapWithCategoriesEnabled = (0, $eUqFw.useCallback)((field)=>{
        if (field.type === (0, $lO4Or.ISSUE_TYPE)) return null;
        if (field.type === (0, $lO4Or.CATEGORY_TYPE)) return field.type != null && iconMap[field.type];
        // This should come after the check for category type
        // Since category has a customfield_X id which is different across projects we should not check for id
        return iconMap[field.id] ?? (field.type !== undefined && iconMap[field.type]);
    }, [
        iconMap
    ]);
    const canEditField = (0, $41WOo.isJwmInlineFieldCreateEnabled)() && project.isSimplified && project.permissions?.administerProject;
    return (0, $eUqFw.useMemo)(()=>loading && !isVisibleFieldsCached ? $8a794b760b661474$var$EMPTY_ARRAY : [
            $8a794b760b661474$var$SELECT_ROW_COLUMN,
            ...columnFields.map((field, index)=>{
                const width = columnWidths[field.id] ?? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly issuetype: 120 | 90; readonly key: 120; readonly summary: 400; readonly status: 120; readonly assignee: 180; readonly reporter: 180; readonly "com.atlassian.jira.plugin.system.customfieldtypes:userpicker": 180; ... 12 more ...; readonly "com.atlassian.jira.plugin.system.customfieldtypes:jwm-category": 170...'.
                (field.type !== undefined && defaultColumnWidths[field.type]) ?? 120;
                return {
                    key: field.id,
                    dataKey: field.id,
                    width: width,
                    /*
       * https://autodesk.github.io/react-base-table/docs/get-started
       * To avoid "unnecessary" re-renders, BaseTable ignores functions when comparing column definition by default.
       * Hence, external values not passed as inputs to the renderer function need to be specified as props here. This was causing
       * the time original estimate cell to display stale data since the config data is fetched async after initial render.
       */ timeTrackingConfig: $8a794b760b661474$var$isTimeTrackingConfigNeeded(field) ? projectData?.jiraSettings?.timeTracking : undefined,
                    headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Mt92.ColumnHeader), {
                        icon: // TODO: JET-3805-Replace mocked data with real BE data
                        iconMapWithCategoriesEnabled(field),
                        label: field.name,
                        fieldId: field.id,
                        fieldType: field.type,
                        canSortField: field.type !== undefined && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "com.atlassian.jira.plugin.system.customfieldtypes:textarea": false; readonly "com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker": false; readonly "com.atlassian.jira.plugin.system.customfieldtypes:people": false; }'.
                        (sortingActions[field.type] ?? true) && !field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN)),
                        canHideField: !$8a794b760b661474$var$getAlwaysVisibleFieldsMemoized().includes(field.id) && !field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN)),
                        canEditField: !!(canEditField && !$8a794b760b661474$var$GLOBAL_SYSTEM_FIELDS_LIST.includes(field.id) && !field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN))),
                        disableDrag: (0, $lqO9q.COLUMNS_WITH_DISABLED_REORDERING).includes(field.id) || field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN)),
                        index: index
                    }),
                    cellRenderer: (0, $1ybV0.ff)('jwm.list.rendering-improvements') ? (params)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3tIX.CellWithHorizontalVirtualization), {
                            ...params,
                            cellRenderers: cellRenderers,
                            field: field,
                            key: params.column.key,
                            onIssueUpdated: onIssueUpdated,
                            projectId: projectId,
                            width: width
                        }) : (0, $d3tIX.getCellRenderer)({
                        cellRenderers: cellRenderers,
                        field: field,
                        onIssueUpdated: onIssueUpdated,
                        projectId: projectId,
                        width: width
                    }),
                    ...$8a794b760b661474$var$COMMON_COLUMN_ATTRIBUTES,
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly priority: { readonly minWidth: 52; }; readonly key: { readonly minWidth: 72; }; readonly issuetype?: { resizable: boolean; minWidth: number; } | undefined; }'.
                    ...$8a794b760b661474$var$COLUMN_ATTRIBUTE_OVERRIDES[field.id]
                };
            })
        ], [
        loading,
        isVisibleFieldsCached,
        columnFields,
        columnWidths,
        defaultColumnWidths,
        projectData?.jiraSettings?.timeTracking,
        iconMapWithCategoriesEnabled,
        sortingActions,
        canEditField,
        projectId,
        onIssueUpdated,
        cellRenderers
    ]);
};

});
parcelRegister("lYoXb", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $570957181c06a49c$export$e54c9225ca52acc);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $lLq8m = parcelRequire("lLq8m");

var $9ah4D = parcelRequire("9ah4D");

var $kYbuU = parcelRequire("kYbuU");

var $g9OCl = parcelRequire("g9OCl");

var $KBS3r = parcelRequire("KBS3r");

var $65msE = parcelRequire("65msE");

var $7GRZv = parcelRequire("7GRZv");

var $2WtZQ = parcelRequire("2WtZQ");
const $570957181c06a49c$export$e54c9225ca52acc = (0, $5iWql.default)(()=>({
        ...(0, $2WtZQ.versionColumnWidth),
        ...(0, $lLq8m.devSummaryColumnWidth),
        ...(0, $7GRZv.teamColumnWidth),
        ...(0, $9ah4D.goalsColumnWidth),
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $65msE.resolutionColumnWidth),
            ...(0, $kYbuU.groupColumnWidth),
            ...(0, $KBS3r.radioSelectColumnWidth),
            ...(0, $g9OCl.projectColumnWidth)
        } : {}
    }));

});
parcelRegister("lLq8m", function(module, exports) {

$parcel$export(module.exports, "devSummaryColumnWidth", () => $7249c712c321bbb3$export$358a1d02595241e8);

var $lO4Or = parcelRequire("lO4Or");
const $7249c712c321bbb3$export$358a1d02595241e8 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: 160
};

});

parcelRegister("9ah4D", function(module, exports) {

$parcel$export(module.exports, "goalsColumnWidth", () => $83fd100814c93d61$export$775dc358f0002ea0);

var $lO4Or = parcelRequire("lO4Or");
const $83fd100814c93d61$export$775dc358f0002ea0 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: 160
};

});

parcelRegister("kYbuU", function(module, exports) {

$parcel$export(module.exports, "groupColumnWidth", () => $3914ced4b2b85479$export$67a3cc86fcd4231);

var $lO4Or = parcelRequire("lO4Or");
const $3914ced4b2b85479$export$67a3cc86fcd4231 = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: 160,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: 160
};

});

parcelRegister("g9OCl", function(module, exports) {

$parcel$export(module.exports, "projectColumnWidth", () => $daa26ed8576b2469$export$8f9363e2d2217d2a);

var $lO4Or = parcelRequire("lO4Or");
const $daa26ed8576b2469$export$8f9363e2d2217d2a = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: 160
};

});

parcelRegister("KBS3r", function(module, exports) {

$parcel$export(module.exports, "radioSelectColumnWidth", () => $9cded55b2e9d6eab$export$c34ad8e09b312cd3);

var $lO4Or = parcelRequire("lO4Or");
const $9cded55b2e9d6eab$export$c34ad8e09b312cd3 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: 160
};

});

parcelRegister("65msE", function(module, exports) {

$parcel$export(module.exports, "resolutionColumnWidth", () => $d7c374527c66e4e2$export$a759c5e7f31f10ca);

var $lO4Or = parcelRequire("lO4Or");
const $d7c374527c66e4e2$export$a759c5e7f31f10ca = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: 160
};

});

parcelRegister("7GRZv", function(module, exports) {

$parcel$export(module.exports, "teamColumnWidth", () => $530b1426493edee7$export$1f7dab61cbeaeb04);

var $lO4Or = parcelRequire("lO4Or");
const $530b1426493edee7$export$1f7dab61cbeaeb04 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: 160
};

});

parcelRegister("2WtZQ", function(module, exports) {

$parcel$export(module.exports, "versionColumnWidth", () => $614587f4ad662c09$export$99cf8efcc69bcfe1);

var $lO4Or = parcelRequire("lO4Or");
const $614587f4ad662c09$export$99cf8efcc69bcfe1 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: 160,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: 160,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: 160,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: 160
};

});


parcelRegister("kBh2b", function(module, exports) {

$parcel$export(module.exports, "getFieldIcons", () => $e54f455c6b41e11e$export$df250ca2240f6516);

var $jqvCZ = parcelRequire("jqvCZ");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $bsrAN = parcelRequire("bsrAN");

var $6g0DE = parcelRequire("6g0DE");

var $975Me = parcelRequire("975Me");

var $4QCVn = parcelRequire("4QCVn");

var $fCSoc = parcelRequire("fCSoc");

var $7nIOX = parcelRequire("7nIOX");

var $is7XO = parcelRequire("is7XO");

var $851U9 = parcelRequire("851U9");

var $cLwpi = parcelRequire("cLwpi");

var $6wPXB = parcelRequire("6wPXB");

var $46tzp = parcelRequire("46tzp");

var $4wZzs = parcelRequire("4wZzs");
const $e54f455c6b41e11e$export$df250ca2240f6516 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((size)=>{
    const legacyFieldIcons = (0, $4wZzs.getLegacyFieldIcons)({
        size: size
    });
    return {
        ...legacyFieldIcons,
        ...(0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? {
            ...(0, $46tzp.getVersionIcons)(size),
            ...(0, $fCSoc.getParentIcon)(size),
            ...(0, $6g0DE.getDevSummaryIcons)(size),
            ...(0, $6wPXB.getTeamIcons)(size),
            ...(0, $975Me.getGoalsIcons)(size)
        } : {},
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $851U9.getResolutionIcons)(size),
            ...(0, $4QCVn.getGroupIcons)(size),
            ...(0, $cLwpi.getStatusCategoryIcons)(size),
            ...(0, $is7XO.getRadioSelectIcon)(size),
            ...(0, $7nIOX.getProjectIcons)(size),
            ...(0, $bsrAN.getCascadingSelectIcons)(size)
        } : {}
    };
});

});
parcelRegister("bsrAN", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectIcons", () => $4ec1409121357127$export$a1c73b689cfdba0d);

var $eUqFw = parcelRequire("eUqFw");

var $7Mesx = parcelRequire("7Mesx");

var $lO4Or = parcelRequire("lO4Or");
const $4ec1409121357127$export$a1c73b689cfdba0d = (size)=>({
        [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mesx))), {
            label: "",
            size: size
        })
    });

});
parcelRegister("7Mesx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a983b68a1ef33a3$var$_react = $5a983b68a1ef33a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5a983b68a1ef33a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5a983b68a1ef33a3$var$EditorBulletListIcon = (props)=>/*#__PURE__*/ $5a983b68a1ef33a3$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 8c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 010 2h-6a1 1 0 010-2zm-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 010 2h-6a1 1 0 010-2zm-5 5c0-.552.444-1 1-1 .552 0 1 .444 1 1 0 .552-.444 1-1 1-.552 0-1-.444-1-1zm5-1h6a1 1 0 010 2h-6a1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5a983b68a1ef33a3$var$EditorBulletListIcon.displayName = 'EditorBulletListIcon';
var $5a983b68a1ef33a3$var$_default = $5a983b68a1ef33a3$var$EditorBulletListIcon;
module.exports.default = $5a983b68a1ef33a3$var$_default;

});


parcelRegister("6g0DE", function(module, exports) {

$parcel$export(module.exports, "getDevSummaryIcons", () => $c249a2a5b82bb4bc$export$af7756d867a4596f);

var $eUqFw = parcelRequire("eUqFw");

var $gojax = parcelRequire("gojax");

var $lO4Or = parcelRequire("lO4Or");
const $c249a2a5b82bb4bc$export$af7756d867a4596f = (size)=>({
        [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gojax))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("gojax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beedc1cceb482b08$var$_react = $beedc1cceb482b08$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $beedc1cceb482b08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $beedc1cceb482b08$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $beedc1cceb482b08$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$beedc1cceb482b08$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $beedc1cceb482b08$var$_default = $beedc1cceb482b08$var$BitbucketBranchesIcon;
module.exports.default = $beedc1cceb482b08$var$_default;

});


parcelRegister("975Me", function(module, exports) {

$parcel$export(module.exports, "getGoalsIcons", () => $860af03e515ae7da$export$191c71adb6287036);

var $eUqFw = parcelRequire("eUqFw");

var $iY7zv = parcelRequire("iY7zv");

var $lO4Or = parcelRequire("lO4Or");
const $860af03e515ae7da$export$191c71adb6287036 = ()=>({
        [(0, $lO4Or.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
            label: "",
            spacing: "spacious"
        })
    });

});
parcelRegister("iY7zv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcf3b42887852980$var$_react = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dcf3b42887852980$var$_UNSAFE_baseNew = $dcf3b42887852980$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $dcf3b42887852980$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Goal".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcf3b42887852980$var$GoalIcon = (props)=>/*#__PURE__*/ $dcf3b42887852980$var$_react.default.createElement($dcf3b42887852980$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentColor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
    }, props));
$dcf3b42887852980$var$GoalIcon.displayName = 'GoalIcon';
var $dcf3b42887852980$var$_default = module.exports.default = $dcf3b42887852980$var$GoalIcon;

});


parcelRegister("4QCVn", function(module, exports) {

$parcel$export(module.exports, "getGroupIcons", () => $f5e22dbf818fedac$export$4b39ade85c5051f7);

var $eUqFw = parcelRequire("eUqFw");

var $iwsIy = parcelRequire("iwsIy");

var $lO4Or = parcelRequire("lO4Or");
const $f5e22dbf818fedac$export$4b39ade85c5051f7 = (size)=>({
        [(0, $lO4Or.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("fCSoc", function(module, exports) {

$parcel$export(module.exports, "getParentIcon", () => $c4211625266bf1b6$export$744c82990563f55a);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $aa7ce = parcelRequire("aa7ce");
const $c4211625266bf1b6$export$744c82990563f55a = ()=>({
        [(0, $lO4Or.PARENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa7ce.HierarchyIcon), null)
    });

});
parcelRegister("aa7ce", function(module, exports) {

$parcel$export(module.exports, "HierarchyIcon", () => $a7933f94a217c249$export$8c3a8f220bd0db42);

var $eUqFw = parcelRequire("eUqFw");
const $a7933f94a217c249$export$8c3a8f220bd0db42 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "4.33333",
        cy: "4.66732",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "10.9998",
        cy: "11.3333",
        r: "1.33333",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.3335 6V8.66667C4.3335 10.1394 5.5274 11.3333 7.00016 11.3333H9.66683",
        stroke: "#9FADBC",
        "stroke-width": "1.33333"
    }));

});


parcelRegister("7nIOX", function(module, exports) {

$parcel$export(module.exports, "getProjectIcons", () => $288778ae0a7a6d12$export$6db5abb9a6c7aec2);

var $eUqFw = parcelRequire("eUqFw");

var $e5T2d = parcelRequire("e5T2d");

var $lO4Or = parcelRequire("lO4Or");
const $288778ae0a7a6d12$export$6db5abb9a6c7aec2 = (size)=>({
        [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("is7XO", function(module, exports) {

$parcel$export(module.exports, "getRadioSelectIcon", () => $17a174c113288beb$export$c36fadaa74abd39e);

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $lO4Or = parcelRequire("lO4Or");
const $17a174c113288beb$export$c36fadaa74abd39e = (size)=>({
        [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))), {
            label: "",
            size: size
        })
    });

});
parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = $02468a1d390d1515$var$RadioIcon;
module.exports.default = $02468a1d390d1515$var$_default;

});


parcelRegister("851U9", function(module, exports) {

$parcel$export(module.exports, "getResolutionIcons", () => $b63068b3f418e7aa$export$e9550187a88e57a5);

var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $lO4Or = parcelRequire("lO4Or");
const $b63068b3f418e7aa$export$e9550187a88e57a5 = (size)=>({
        [(0, $lO4Or.RESOLUTION_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});


parcelRegister("cLwpi", function(module, exports) {

$parcel$export(module.exports, "getStatusCategoryIcons", () => $77e71eb554926895$export$f263f5d2ca3dcccb);

var $eUqFw = parcelRequire("eUqFw");

var $gniEB = parcelRequire("gniEB");

var $lO4Or = parcelRequire("lO4Or");
const $77e71eb554926895$export$f263f5d2ca3dcccb = (size)=>({
        [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gniEB))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("gniEB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bebd43992fe8e822$var$_react = $bebd43992fe8e822$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $bebd43992fe8e822$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bebd43992fe8e822$var$StatusIcon = (props)=>/*#__PURE__*/ $bebd43992fe8e822$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5zm3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98l.426 1.343zM6.02 10.423h.07l.7 2.21H5.313l.707-2.21zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.219 1.219 0 001.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636h2.53zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887v-1.434zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812h-1.05zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926 0-1.187.55-1.922 1.437-1.922.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965z" fill="currentColor"/></svg>`
    }, props));
$bebd43992fe8e822$var$StatusIcon.displayName = 'StatusIcon';
var $bebd43992fe8e822$var$_default = $bebd43992fe8e822$var$StatusIcon;
module.exports.default = $bebd43992fe8e822$var$_default;

});


parcelRegister("6wPXB", function(module, exports) {

$parcel$export(module.exports, "getTeamIcons", () => $38769f2763823b24$export$b7d8ffd86073bea);

var $eUqFw = parcelRequire("eUqFw");

var $j76Bh = parcelRequire("j76Bh");

var $lO4Or = parcelRequire("lO4Or");
const $38769f2763823b24$export$b7d8ffd86073bea = (size)=>({
        [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j76Bh))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("j76Bh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dea3ca78c255f4b6$var$_react = $dea3ca78c255f4b6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $dea3ca78c255f4b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dea3ca78c255f4b6$var$TeamsIcon = (props)=>/*#__PURE__*/ $dea3ca78c255f4b6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9 7.2a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m7.8 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0m1.8 0a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0m1.2 9.3a4.5 4.5 0 0 0-4.5-4.5h-1.378c-.484 0-1.275.127-1.875.41l.77 1.627c.14-.066.342-.129.566-.174s.421-.063.539-.063H17.1a2.7 2.7 0 0 1 2.7 2.7V18a.6.6 0 0 1-.6.6h-3.478a2.7 2.7 0 0 1-2.538-1.777l-.676-1.86A4.5 4.5 0 0 0 8.278 12H6.9a4.5 4.5 0 0 0-4.5 4.5V18a2.4 2.4 0 0 0 2.4 2.4h4.8v-1.8H4.8a.6.6 0 0 1-.6-.6v-1.5a2.7 2.7 0 0 1 2.7-2.7h1.378a2.7 2.7 0 0 1 2.538 1.777l.676 1.86a4.5 4.5 0 0 0 4.23 2.963H19.2a2.4 2.4 0 0 0 2.4-2.4z" clip-rule="evenodd"/></svg>`
    }, props));
$dea3ca78c255f4b6$var$TeamsIcon.displayName = 'TeamsIcon';
var $dea3ca78c255f4b6$var$_default = module.exports.default = $dea3ca78c255f4b6$var$TeamsIcon;

});


parcelRegister("46tzp", function(module, exports) {

$parcel$export(module.exports, "getVersionIcons", () => $fc9004aee8bf2947$export$5c5f41529027464e);

var $eUqFw = parcelRequire("eUqFw");

var $14lY4 = parcelRequire("14lY4");

var $lO4Or = parcelRequire("lO4Or");
const $fc9004aee8bf2947$export$5c5f41529027464e = (size)=>({
        [(0, $lO4Or.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($14lY4))), {
            size: size,
            label: ""
        })
    });

});

parcelRegister("4wZzs", function(module, exports) {

$parcel$export(module.exports, "getLegacyFieldIcons", () => $96cd876843d12f51$export$eddca397cc46c15);

var $eUqFw = parcelRequire("eUqFw");

var $kMHOY = parcelRequire("kMHOY");

var $hSJ9G = parcelRequire("hSJ9G");

var $lBXn2 = parcelRequire("lBXn2");

var $d3vNK = parcelRequire("d3vNK");

var $cjQam = parcelRequire("cjQam");

var $awjqo = parcelRequire("awjqo");

var $3fJGp = parcelRequire("3fJGp");

var $dZhDV = parcelRequire("dZhDV");

var $7XRtk = parcelRequire("7XRtk");

var $f4oGi = parcelRequire("f4oGi");

var $6nIG2 = parcelRequire("6nIG2");

var $2OpmI = parcelRequire("2OpmI");

var $dTV7w = parcelRequire("dTV7w");

var $b8123 = parcelRequire("b8123");

var $8CfG4 = parcelRequire("8CfG4");

var $4nce6 = parcelRequire("4nce6");

var $cI9iM = parcelRequire("cI9iM");

var $k6W9R = parcelRequire("k6W9R");

var $gk7tF = parcelRequire("gk7tF");

var $eyI8O = parcelRequire("eyI8O");

var $5KT10 = parcelRequire("5KT10");

var $jGcn0 = parcelRequire("jGcn0");

var $41WOo = parcelRequire("41WOo");

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");
const $96cd876843d12f51$var$PriorityIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222ZM14.1219 13.5914L14.0381 13.5174L12 11.48L9.96186 13.5174C9.64143 13.8378 9.13725 13.8625 8.78855 13.5914L8.70481 13.5174C8.38438 13.197 8.35973 12.6928 8.63086 12.3441L8.70481 12.2604L11.3715 9.5937C11.6919 9.27327 12.1961 9.24861 12.5448 9.51975L12.6285 9.5937L15.2952 12.2604C15.6423 12.6075 15.6423 13.1703 15.2952 13.5174C14.9748 13.8378 14.4706 13.8625 14.1219 13.5914Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$StatusIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18.2222 12C18.2222 8.56356 15.4364 5.77778 12 5.77778C8.56356 5.77778 5.77778 8.56356 5.77778 12C5.77778 15.4364 8.56356 18.2222 12 18.2222C15.4364 18.2222 18.2222 15.4364 18.2222 12ZM15.3664 11.4518L15.2952 11.3715C15.3267 11.4029 15.3553 11.4362 15.381 11.4708C15.3969 11.4923 15.4118 11.5144 15.4257 11.5372C15.4324 11.5479 15.4386 11.5588 15.4447 11.5697C15.4544 11.5873 15.4637 11.6054 15.4723 11.6239C15.4794 11.639 15.486 11.6544 15.4922 11.6699C15.4993 11.6875 15.5057 11.7051 15.5115 11.7229C15.5158 11.7361 15.5199 11.7498 15.5237 11.7636C15.5291 11.7827 15.5337 11.802 15.5377 11.8215C15.5407 11.837 15.5434 11.8525 15.5457 11.868C15.5483 11.8849 15.5504 11.9024 15.552 11.92C15.5539 11.9416 15.555 11.9626 15.5554 11.9837C15.5555 11.9886 15.5556 11.9943 15.5556 12L15.5554 12.0172C15.555 12.0382 15.5539 12.0593 15.552 12.0802L15.5556 12C15.5556 12.0439 15.5524 12.087 15.5462 12.1292C15.5436 12.1467 15.5404 12.1648 15.5366 12.1829C15.5331 12.1999 15.5293 12.2162 15.5249 12.2323C15.521 12.2463 15.5168 12.2606 15.5122 12.2748C15.5059 12.2943 15.4989 12.3135 15.4913 12.3325C15.4855 12.3467 15.4795 12.3606 15.4731 12.3744C15.4639 12.3941 15.4539 12.4138 15.4431 12.4331C15.438 12.4423 15.4326 12.4517 15.4269 12.461C15.4135 12.4829 15.3993 12.5041 15.3843 12.5246C15.3793 12.5315 15.3743 12.5382 15.3691 12.5448C15.3528 12.5655 15.3393 12.5815 15.3252 12.597L15.2952 12.6285L12.6285 15.2952C12.2814 15.6423 11.7186 15.6423 11.3715 15.2952C11.051 14.9748 11.0264 14.4706 11.2975 14.1219L11.3715 14.0381L12.52 12.8889H9.33333C8.84241 12.8889 8.44444 12.4909 8.44444 12C8.44444 11.5468 8.78355 11.1729 9.22184 11.118L9.33333 11.1111H12.5218L11.3715 9.96187C11.051 9.64144 11.0264 9.13724 11.2975 8.78853L11.3715 8.70479C11.6919 8.38436 12.1961 8.35971 12.5448 8.63085L12.6285 8.70479L15.2977 11.374C15.3221 11.3985 15.345 11.4245 15.3664 11.4518Z",
        fill: "currentColor"
    }));
// Custom icon not from Atlaskit
const $96cd876843d12f51$var$NumberGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $96cd876843d12f51$var$TypeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9299 7C10.9299 6.44772 11.3776 6 11.9299 6C12.4822 6 12.9299 6.44772 12.9299 7V10.268L15.76 8.63397C16.2383 8.35783 16.8499 8.5217 17.1261 9C17.4022 9.47829 17.2383 10.0899 16.76 10.366L13.9299 12L16.76 13.634C17.2383 13.9101 17.4022 14.5217 17.1261 15C16.8499 15.4783 16.2383 15.6422 15.76 15.366L12.9299 13.732V17C12.9299 17.5523 12.4822 18 11.9299 18C11.3776 18 10.9299 17.5523 10.9299 17V13.7321L8.09978 15.366C7.62148 15.6422 7.00989 15.4783 6.73375 15C6.45761 14.5217 6.62148 13.9101 7.09978 13.634L9.9299 12L7.09978 10.366C6.62148 10.0899 6.45761 9.47829 6.73375 9C7.00989 8.5217 7.62148 8.35783 8.09978 8.63397L10.9299 10.2679V7Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$KeyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H9V17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17V15H13V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V15H17C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13H15V11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9H15V7C15 6.44772 14.5523 6 14 6C13.4477 6 13 6.44772 13 7V9H11V7C11 6.44772 10.5523 6 10 6ZM13 13V11H11V13H13Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$var$EpicIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6C17.3284 6 18 6.67157 18 7.5V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V7.5C6 6.67157 6.67157 6 7.5 6H16.5ZM12.375 8.25C12.2625 8.25 12.165 8.30175 12.096 8.37975L9.11175 12.1088C9.1095 12.111 9.08475 12.1425 9.08475 12.1425C9.03525 12.2092 9 12.2865 9 12.375C9 12.582 9.168 12.75 9.375 12.75C9.396 12.75 9.41325 12.7537 9.43275 12.75H11.25V15.375C11.25 15.582 11.418 15.75 11.625 15.75C11.718 15.75 11.8005 15.7125 11.8658 15.657C11.8658 15.657 11.9123 15.6068 11.9295 15.582L14.88 11.8972C14.8943 11.8837 14.9033 11.868 14.9153 11.8522L14.9355 11.8275C14.9722 11.7667 15 11.7 15 11.625C15 11.418 14.832 11.25 14.625 11.25H12.75V8.625C12.75 8.418 12.582 8.25 12.375 8.25Z",
        fill: "currentColor"
    }));
const $96cd876843d12f51$export$eddca397cc46c15 = ({ size: size })=>({
        key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$KeyIcon, null),
        [(0, $lO4Or.ISSUE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$TypeIcon, null),
        [(0, $lO4Or.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awjqo))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$StatusIcon, null),
        [(0, $lO4Or.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.CREATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.UPDATED)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.RESOLUTION_DATE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$PriorityIcon, null),
        [(0, $lO4Or.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4oGi))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fJGp))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cI9iM))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($awjqo))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBXn2))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBXn2))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7XRtk))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k6W9R))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.COMPONENTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cjQam))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.STORY_POINTS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$NumberGlyph, null),
        [(0, $lO4Or.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SUBTASKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyI8O))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.EPIC_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96cd876843d12f51$var$EpicIcon, null),
        [(0, $lO4Or.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            size: size,
            label: ""
        }),
        [(0, $jGcn0.COMMENT_SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))), {
            size: size,
            label: ""
        }),
        [(0, $lO4Or.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
            size: size,
            label: ""
        }),
        [(0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE)]: (0, $41WOo.isLinkedIssuesEnabledInJwmBoardCards)() || (0, $1ybV0.ff)('jwm.board-awesome-enhancements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
            size: size,
            label: ""
        }) : // Need to force small as brand icons are bigger that normal icons.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            size: "small",
            appearance: "brand"
        }),
        [(0, $lO4Or.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            size: size,
            label: ""
        }),
        [(0, $jGcn0.CARD_COVERS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dTV7w))), {
            size: size,
            label: ""
        })
    });

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = $f21a4850a620a60b$var$CalendarIcon;
module.exports.default = $f21a4850a620a60b$var$_default;

});

parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = $d04a81b304c826a5$var$CheckboxIcon;
module.exports.default = $d04a81b304c826a5$var$_default;

});

parcelRegister("lBXn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbbb1b7540180857$var$_react = $fbbb1b7540180857$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbbb1b7540180857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbbb1b7540180857$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $fbbb1b7540180857$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="inherit"/></g></svg>`
    }, props));
$fbbb1b7540180857$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $fbbb1b7540180857$var$_default = $fbbb1b7540180857$var$ChevronDownCircleIcon;
module.exports.default = $fbbb1b7540180857$var$_default;

});

parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716z"/><rect x="7" y="9" width="10" height="2" rx="1"/><rect x="7" y="12" width="5" height="2" rx="1"/></g></svg>`
    }, props));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = $98143944cdbffe97$var$CommentIcon;
module.exports.default = $98143944cdbffe97$var$_default;

});

parcelRegister("cjQam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $025082fde694ac0f$var$_react = $025082fde694ac0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $025082fde694ac0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $025082fde694ac0f$var$ComponentIcon = (props)=>/*#__PURE__*/ $025082fde694ac0f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991zM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 17.991V10.01z"/><path d="M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67z"/></g></svg>`
    }, props));
$025082fde694ac0f$var$ComponentIcon.displayName = 'ComponentIcon';
var $025082fde694ac0f$var$_default = $025082fde694ac0f$var$ComponentIcon;
module.exports.default = $025082fde694ac0f$var$_default;

});

parcelRegister("awjqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a8bf5e62e78ca1b$var$_react = $7a8bf5e62e78ca1b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7a8bf5e62e78ca1b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $7a8bf5e62e78ca1b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7 7h10a1 1 0 010 2H7a1 1 0 110-2zm0 4h10a1 1 0 010 2H7a1 1 0 010-2zm0 4h5a1 1 0 010 2H7a1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7a8bf5e62e78ca1b$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $7a8bf5e62e78ca1b$var$_default = $7a8bf5e62e78ca1b$var$EditorAlignLeftIcon;
module.exports.default = $7a8bf5e62e78ca1b$var$_default;

});

parcelRegister("3fJGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e63580bbd9aab7$var$_react = $25e63580bbd9aab7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $25e63580bbd9aab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $25e63580bbd9aab7$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $25e63580bbd9aab7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.654 8.764a.858.858 0 01-1.213-1.213l1.214-1.214a3.717 3.717 0 015.257 0 3.714 3.714 0 01.001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 01-5.263.005.858.858 0 011.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a1.998 1.998 0 00-.001-2.831 2 2 0 00-2.83 0l-1.215 1.213zm-.808 6.472a.858.858 0 011.213 1.213l-1.214 1.214a3.717 3.717 0 01-5.257 0 3.714 3.714 0 01-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 015.263-.005.858.858 0 01-1.214 1.214 2.005 2.005 0 00-2.836.005l-.804.803L7.8 13.618a1.998 1.998 0 00.001 2.831 2 2 0 002.83 0l1.215-1.213z" fill="currentColor"/></svg>`
    }, props));
$25e63580bbd9aab7$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $25e63580bbd9aab7$var$_default = $25e63580bbd9aab7$var$EditorLinkIcon;
module.exports.default = $25e63580bbd9aab7$var$_default;

});

parcelRegister("dZhDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2eea8678fc0743c$var$_react = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2eea8678fc0743c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2eea8678fc0743c$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $a2eea8678fc0743c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.466-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.522 7 7 7 .874 0 1.614-.09 2.26-.279a.751.751 0 00-.42-1.44c-.508.147-1.11.22-1.84.22-2.648 0-5.5-1.722-5.5-5.5 0-3.085 2.417-5.5 5.5-5.5 3.24 0 5.5 1.952 5.5 4.75 0 2.045-1.043 3-1.748 3-.008 0-.752-.11-.752-.75v-4a.75.75 0 10-1.5 0v.187c-.346-.585-1.016-.952-1.795-.952C10.102 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a2eea8678fc0743c$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $a2eea8678fc0743c$var$_default = $a2eea8678fc0743c$var$EditorMentionIcon;
module.exports.default = $a2eea8678fc0743c$var$_default;

});

parcelRegister("7XRtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cc785836207fa6c$var$_react = $5cc785836207fa6c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5cc785836207fa6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5cc785836207fa6c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $5cc785836207fa6c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5cc785836207fa6c$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $5cc785836207fa6c$var$_default = $5cc785836207fa6c$var$EmojiFrequentIcon;
module.exports.default = $5cc785836207fa6c$var$_default;

});

parcelRegister("f4oGi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8a5fe38412111b$var$_react = $af8a5fe38412111b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $af8a5fe38412111b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af8a5fe38412111b$var$EmojiKeyboardIcon = (props)=>/*#__PURE__*/ $af8a5fe38412111b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M5.836 6.95l-3.825 9.97a.5.5 0 00.467.68h1.208a.5.5 0 00.47-.33l.683-1.877a.5.5 0 01.47-.33H9.12a.5.5 0 01.47.33l.683 1.878a.5.5 0 00.47.329h1.272a.5.5 0 00.468-.678L8.685 6.95a.7.7 0 00-.655-.45H6.49a.7.7 0 00-.654.45zm1.566 2.457l1.25 3.414a.2.2 0 01-.188.269H5.966a.2.2 0 01-.188-.269l1.249-3.414a.2.2 0 01.375 0zm10.148 6.465c1.222 0 2.142-1.01 2.142-2.603 0-1.594-.902-2.532-2.142-2.532-1.256 0-2.178.938-2.178 2.532 0 1.575.904 2.603 2.178 2.603zm2.161.602c-.372.833-1.276 1.433-2.445 1.433-2.567 0-4.266-2-4.266-4.638 0-2.551 1.664-4.569 4.195-4.569 1.56 0 2.284.833 2.497 1.329v-.34c0-.247.007-.392.213-.576.137-.122.344-.177.62-.165h.764a.581.581 0 01.496.165c.213.203.192.421.192.577v6.394c0 .227.008.526.023.899 0 .191-.041.336-.124.434a.628.628 0 01-.508.242h-.93c-.193 0-.45-.084-.533-.184-.083-.1-.165-.23-.183-.532a6.342 6.342 0 01-.01-.364v-.105z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$af8a5fe38412111b$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
var $af8a5fe38412111b$var$_default = $af8a5fe38412111b$var$EmojiKeyboardIcon;
module.exports.default = $af8a5fe38412111b$var$_default;

});

parcelRegister("2OpmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20c3ed57b318b9b4$var$_react = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20c3ed57b318b9b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20c3ed57b318b9b4$var$LabelIcon = (props)=>/*#__PURE__*/ $20c3ed57b318b9b4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.433 5.428l-4.207.6A2 2 0 005.53 7.727l-.6 4.207a1 1 0 00.281.849l6.895 6.894a.999.999 0 001.414 0l5.657-5.657a1 1 0 000-1.414L12.282 5.71a.998.998 0 00-.849-.283m-.647 5.858A1.666 1.666 0 118.43 8.929a1.666 1.666 0 012.357 2.357" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$20c3ed57b318b9b4$var$LabelIcon.displayName = 'LabelIcon';
var $20c3ed57b318b9b4$var$_default = $20c3ed57b318b9b4$var$LabelIcon;
module.exports.default = $20c3ed57b318b9b4$var$_default;

});

parcelRegister("dTV7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ecb853a8de6aa7$var$_react = $a1ecb853a8de6aa7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a1ecb853a8de6aa7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon = (props)=>/*#__PURE__*/ $a1ecb853a8de6aa7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 6.007v11.986C5 18.55 5.45 19 6.007 19h11.986C18.55 19 19 18.55 19 17.993V6.007C19 5.45 18.55 5 17.993 5H6.007C5.45 5 5 5.45 5 6.007zm-2 0A3.006 3.006 0 016.007 3h11.986A3.006 3.006 0 0121 6.007v11.986A3.006 3.006 0 0117.993 21H6.007A3.006 3.006 0 013 17.993V6.007z" fill-rule="nonzero"/><path d="M11.005 17H16.5c.27 0 .5-.228.5-.509v-1.634a.725.725 0 00-.167-.44L14.5 11.85a.238.238 0 00-.344-.006L11 15l-.821-.821a.248.248 0 00-.358 0l-2.465 2.465c-.195.195-.136.356.135.356h3.514z"/><circle cx="9" cy="9" r="2"/></g></svg>`
    }, props));
$a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon.displayName = 'MediaServicesScaleLargeIcon';
var $a1ecb853a8de6aa7$var$_default = $a1ecb853a8de6aa7$var$MediaServicesScaleLargeIcon;
module.exports.default = $a1ecb853a8de6aa7$var$_default;

});

parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $645e088e86b3f594$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="8" y="6" width="8" height="2" rx="1"/><rect x="8" y="9" width="8" height="2" rx="1"/><rect x="8" y="12" width="4" height="2" rx="1"/><path d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 015 20.01V3.99z" fill-rule="nonzero"/></g></svg>`
    }, props));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = $645e088e86b3f594$var$PageIcon;
module.exports.default = $645e088e86b3f594$var$_default;

});

parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});

parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $be245075b7e5aee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M17.717 17.137l-1.436-1.438a1.003 1.003 0 011.418-1.418l3.007 3.01a1.002 1.002 0 010 1.417l-3.007 3.01a1.003 1.003 0 01-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 014 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a7.982 7.982 0 01-.789 3.451l-1.438-1.44a6.11 6.11 0 00.345-2.01A6.121 6.121 0 0012 4.884a6.121 6.121 0 00-6.118 6.125 6.119 6.119 0 005.647 6.102l6.188.025zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005.003.013z" fill="currentColor"/></svg>`
    }, props));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = $be245075b7e5aee7$var$SprintIcon;
module.exports.default = $be245075b7e5aee7$var$_default;

});

parcelRegister("eyI8O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9967b301fa2e1c2$var$_react = $a9967b301fa2e1c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a9967b301fa2e1c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a9967b301fa2e1c2$var$SubtaskIcon = (props)=>/*#__PURE__*/ $a9967b301fa2e1c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0118.994 21H9.006A2.005 2.005 0 017 19h11c.555 0 1-.448 1-1V7zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0114.994 17H5.006A2.005 2.005 0 013 14.994V5.006zM5 5v10h10V5H5z"/><path d="M7.707 9.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L9 10.586 7.707 9.293z"/></g></svg>`
    }, props));
$a9967b301fa2e1c2$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $a9967b301fa2e1c2$var$_default = $a9967b301fa2e1c2$var$SubtaskIcon;
module.exports.default = $a9967b301fa2e1c2$var$_default;

});

parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("Kei82", function(module, exports) {

$parcel$export(module.exports, "loadingCellStyles", () => $b5d716c64e0ac109$export$81b1b3cccf003fa1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $b5d716c64e0ac109$export$81b1b3cccf003fa1 = {
    backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA).N20})`,
    paddingleft: '1px',
    borderRadius: `${(0, $c9TLT.borderRadius)}px`,
    width: `calc(100% - ${(0, $c9TLT.gridSize) * 2}px)`,
    height: `calc(100% - ${(0, $c9TLT.gridSize) * 2}px)`,
    marginLeft: "var(--ds-space-100, 8px)"
};
const $b5d716c64e0ac109$export$5191481abee8295e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_9povrw": (0, $9t7rW.default)(__cmplp.width - (0, $c9TLT.gridSize) * 2, "px"),
            "--_1z066df": (0, $9t7rW.default)(__cmplp.height - (0, $c9TLT.gridSize) * 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1aqf _14eot94y _2rko1l7b _1bsb5cnj _4t3i5cnj _18u0u2gc",
            __cmplp.width ? "_1bsb1fse" : "_1bsb5cnj",
            __cmplp.height ? "_4t3i14kp" : "_4t3i5cnj",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b7r1l", function(module, exports) {

$parcel$export(module.exports, "useCommentsSidebar", () => $14ddcd52da371266$export$aec60bac36c8115);

var $eUqFw = parcelRequire("eUqFw");

var $hSCS8 = parcelRequire("hSCS8");

var $jGcn0 = parcelRequire("jGcn0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");
const $14ddcd52da371266$export$aec60bac36c8115 = ({ CommentsSidebar: CommentsSidebar })=>{
    const [selectedIssueKey, setSelectedIssueKey] = (0, $kJlBc.useQueryParam)((0, $jGcn0.SELECTED_COMMENT_PARAM));
    const [, { setSidebarContent: setSidebarContent }] = (0, $hSCS8.useSidebar)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // set query param when comment cell is clicked
    const onOpen = (0, $eUqFw.useCallback)((issueKey)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar opened');
        setSelectedIssueKey(issueKey);
    }, [
        createAnalyticsEvent,
        setSelectedIssueKey
    ]);
    // close comment sidebar on [X] button click
    const onClose = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'commentsSidebar closed');
        setSelectedIssueKey(undefined);
        setSidebarContent(null);
    }, [
        createAnalyticsEvent,
        setSelectedIssueKey,
        setSidebarContent
    ]);
    // set sidebar content after query param is set
    (0, $eUqFw.useEffect)(()=>{
        if (selectedIssueKey) {
            const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CommentsSidebar, {
                issueKey: selectedIssueKey,
                onClose: onClose
            });
            setSidebarContent(newContent);
        }
    }, [
        CommentsSidebar,
        onClose,
        selectedIssueKey,
        setSidebarContent
    ]);
    return {
        selectedIssueKey: selectedIssueKey,
        onOpenCommentsSidebar: onOpen,
        onCloseCommentsSidebar: onClose
    };
};

});

parcelRegister("eMPoQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSettings", () => $ff52a6775afdd596$export$5de424af876772e4);

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $eFSs8 = parcelRequire("eFSs8");

const $ff52a6775afdd596$export$5de424af876772e4 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [getProjectData, { data: data, loading: loading, error: error }] = (0, $iZuDo.useLazyQuery)((0, $eFSs8.JIRA_SETTINGS_QUERY), {
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'jiraSettingsQuery',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: 'Failed to fetch jira settings in list view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    return {
        error: error,
        loading: loading,
        data: data,
        getProjectData: getProjectData
    };
};

});
parcelRegister("eFSs8", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_QUERY", () => $77c0dbbec0ed5a8d$export$652ac25405e90703);

var $9ypom = parcelRequire("9ypom");
const $77c0dbbec0ed5a8d$export$652ac25405e90703 = (0, $9ypom.default)`
  query JiraBusinessSettings {
    jiraSettings {
      timeTracking {
        isTimeTrackingEnabled
        hoursPerDay
        daysPerWeek
        defaultUnit
        format
      }
    }
  }
`;

});


parcelRegister("lhlwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6697d5f72505d3b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6697d5f72505d3b8$var$CategoryCell = (0, $7rh0R.lazy)(()=>(parcelRequire("h9NZL")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/category-cell/main.tsx"
});
const $6697d5f72505d3b8$var$AsyncCategoryCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "category-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6697d5f72505d3b8$var$CategoryCell, props));
var $6697d5f72505d3b8$export$2e2bcd8739ae039 = $6697d5f72505d3b8$var$AsyncCategoryCell;

});
parcelRegister("h9NZL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aQX2q');
        const value = parcelRequire('2aa7a');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aQX2q").then(()=>parcelRequire('2aa7a'));
}

});


parcelRegister("d3tIX", function(module, exports) {

$parcel$export(module.exports, "getCellRenderer", () => $ae5e863b7902fa36$export$195172c54e8df31);
$parcel$export(module.exports, "CellWithHorizontalVirtualization", () => $ae5e863b7902fa36$export$9f868e7b7b690ae0);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("aZGbv");

var $8lNor = parcelRequire("8lNor");

var $lrJe0 = parcelRequire("lrJe0");

var $eI5EY = parcelRequire("eI5EY");

var $Kei82 = parcelRequire("Kei82");

var $aXbY8 = parcelRequire("aXbY8");

var $lqO9q = parcelRequire("lqO9q");

var $8safW = parcelRequire("8safW");

var $isXgL = parcelRequire("isXgL");
const $ae5e863b7902fa36$export$195172c54e8df31 = ({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width })=>(0, $lrJe0.isFieldCellTypes)(field.type) && (0, $lrJe0.isFieldCellSupported)(field.type) && (0, $eI5EY.fg)('jsw_list_view_-_all_the_fields') ? (params)=>{
        const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
        if ((0, $aXbY8.isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN))) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testId": "business-list.ui.list-view.loading-cell",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $Kei82.loadingCellStyles)
        });
        let cellData;
        if ((0, $8lNor.isTopLevelField)(field.type)) {
            const key = (0, $8lNor.getTopLevelFieldKey)(field.type);
            if (key) cellData = rowData[key];
        } else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        cellData = rowData.fields?.find((f)=>f.fieldId === field.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $isXgL.WithCellSelection), {
            depth: rowData.depth,
            width: width,
            fieldId: field.id,
            projectId: projectId,
            issueId: rowData.issueId,
            position: rowIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3),
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            field: field,
            issue: rowData
        }, ()=>// Check for type existence was already done above
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lrJe0.FieldCell), {
                fieldType: field.type ?? '',
                ...params,
                cellData: cellData,
                onIssueUpdated: onIssueUpdated,
                fieldId: field.id,
                fieldName: field.name
            }));
    } : (params)=>{
        const { rowData: rowData, rowIndex: rowIndex, columnIndex: columnIndex } = params;
        if ((0, $aXbY8.isItemSkeleton)(rowData.issueId) || field.id.startsWith((0, $lqO9q.PLACEHOLDER_COLUMN))) // experimenting with inlining CSS here to avoid styled-components runtime perf overhead
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testId": "business-list.ui.list-view.loading-cell",
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $Kei82.loadingCellStyles)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $isXgL.WithCellSelection), {
            depth: rowData.depth,
            width: width,
            fieldId: field.id,
            projectId: projectId,
            issueId: rowData.issueId,
            position: rowIndex === 0 ? (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) : (0, $18eb89570dd03c8c$export$a3a66eb204e551b3),
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            field: field,
            issue: rowData
        }, ()=>cellRenderers[field.id](params));
    };
const $ae5e863b7902fa36$export$f6f0c3fe4ec306ea = /*#__PURE__*/ (0, $eUqFw.memo)(({ cellRenderers: cellRenderers, field: field, onIssueUpdated: onIssueUpdated, projectId: projectId, width: width, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $ae5e863b7902fa36$export$195172c54e8df31({
        cellRenderers: cellRenderers,
        field: field,
        onIssueUpdated: onIssueUpdated,
        projectId: projectId,
        width: width
    })({
        ...rest,
        onIssueUpdated: onIssueUpdated
    })));
$ae5e863b7902fa36$export$f6f0c3fe4ec306ea.displayName = 'Cell';
const $ae5e863b7902fa36$export$9f868e7b7b690ae0 = (props)=>{
    const isColumnVisible = (0, $8safW.useIsColumnVisible)(props.column);
    return isColumnVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae5e863b7902fa36$export$f6f0c3fe4ec306ea, props) : null;
};

});
parcelRegister("aZGbv", function(module, exports) {

$parcel$export(module.exports, "NodeSelectionWrapper", () => $8521b6b2ec32c74c$export$f758a58bee5c7927);
$parcel$export(module.exports, "ParticipantBadge", () => $8521b6b2ec32c74c$export$91bc13dfc76fa8fa);
$parcel$export(module.exports, "BADGE_INNER_POSITION", () => $18eb89570dd03c8c$export$86bcdda8e7a22b9d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $8521b6b2ec32c74c$var$BADGE_SIZE = 16;
// the badge text color will remain white regardless of the theme applied
const $8521b6b2ec32c74c$var$BADGE_TEXT_COLOR = 'white';
const $8521b6b2ec32c74c$export$f758a58bee5c7927 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_oor3vt": (0, $9t7rW.default)(`0 0 0 2px ${__cmplp.color} inset`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _16qs1zte _2rko1sit",
            __cmplp.className
        ])
    });
});
const $8521b6b2ec32c74c$export$91bc13dfc76fa8fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1xi2idpf _1bsb1wug _4t3i7vkz _1pbykb7n _1yt4otz2 _11q71cj8 _vchhusvi _11c8qk37 _syazu67f",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_154iidpf" : "_154id439",
            __cmplp.position === (0, $18eb89570dd03c8c$export$86bcdda8e7a22b9d) ? "_2rko1pph" : "_2rko2hs0",
            __cmplp.className
        ])
    });
});

});
const $18eb89570dd03c8c$export$86bcdda8e7a22b9d = 'inner';
const $18eb89570dd03c8c$export$a3a66eb204e551b3 = 'outer';


parcelRegister("lrJe0", function(module, exports) {

$parcel$export(module.exports, "isFieldCellSupported", () => $3aa6b48d7ccfbcb2$export$33fa2ddeaefadb7f);
$parcel$export(module.exports, "isFieldCellTypes", () => $3aa6b48d7ccfbcb2$export$6a0360e2da5b783e);
$parcel$export(module.exports, "FieldCell", () => $3aa6b48d7ccfbcb2$export$8ae908fe84f8a33b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $kzRbi = parcelRequire("kzRbi");

var $eyVJl = parcelRequire("eyVJl");

var $iwcjI = parcelRequire("iwcjI");

var $gnGlI = parcelRequire("gnGlI");

var $88U8t = parcelRequire("88U8t");

var $87lYv = parcelRequire("87lYv");

var $6l2d2 = parcelRequire("6l2d2");

var $csWQF = parcelRequire("csWQF");

var $edUxi = parcelRequire("edUxi");

var $bOyhU = parcelRequire("bOyhU");

var $cWB05 = parcelRequire("cWB05");
const $3aa6b48d7ccfbcb2$var$createFieldCellComponents = (0, $5iWql.default)(()=>({
        ...(0, $cWB05.versionCellHandler),
        ...(0, $88U8t.parentCellHandler),
        ...(0, $eyVJl.devSummaryCellHandler),
        ...(0, $1ybV0.ff)('native-goals-integration-in-list-view_h12va') ? (0, $iwcjI.goalsCellHandler) : {},
        ...(0, $bOyhU.teamCellHandler),
        ...(0, $1ybV0.ff)('jira.list.field-support-part1') ? {
            ...(0, $csWQF.resolutionCellHandler),
            ...(0, $gnGlI.groupCellHandler),
            ...(0, $edUxi.statusCategoryCellHandler),
            ...(0, $6l2d2.radioSelectCellHandler),
            ...(0, $87lYv.projectCellHandler),
            ...(0, $kzRbi.cascadingSelectCellHandler)
        } : {}
    }));
const $3aa6b48d7ccfbcb2$export$33fa2ddeaefadb7f = (fieldType)=>{
    const Components = $3aa6b48d7ccfbcb2$var$createFieldCellComponents();
    return Components[fieldType] != null;
};
const $3aa6b48d7ccfbcb2$export$6a0360e2da5b783e = (_)=>true;
const $3aa6b48d7ccfbcb2$export$8ae908fe84f8a33b = ({ fieldType: fieldType, ...cellProps })=>{
    const Components = $3aa6b48d7ccfbcb2$var$createFieldCellComponents();
    if (!$3aa6b48d7ccfbcb2$export$6a0360e2da5b783e(fieldType)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const Component = Components[fieldType];
    if (Component == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, cellProps);
};

});
parcelRegister("kzRbi", function(module, exports) {

$parcel$export(module.exports, "cascadingSelectCellHandler", () => $4fb564aabcdf3c81$export$27b118c54b403d55);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $fiEoq = parcelRequire("fiEoq");

var $l4xGf = parcelRequire("l4xGf");
const $4fb564aabcdf3c81$export$4f505fdc26f544f5 = ({ rowData: issue, cellData: field, setEditMode: setEditMode, editMode: editMode, column: { width: preferredWidth }, cellRef: cellRef })=>{
    const [cascadingSelectValue, setCascadingSelectValue] = (0, $eUqFw.useState)(field?.value ?? null);
    // Update the value when it is updated in cache (e.g. via realtime)
    (0, $eUqFw.useEffect)(()=>{
        setCascadingSelectValue(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.cascading-select.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiEoq.CascadingSelectEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        fieldAriId: field?.id ?? '',
        onChange: setCascadingSelectValue,
        preferredWidth: preferredWidth,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4xGf.CascadingSelectRead), {
            value: cascadingSelectValue
        }),
        currentValue: cascadingSelectValue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l4xGf.CascadingSelectRead), {
        value: cascadingSelectValue
    }));
};
const $4fb564aabcdf3c81$export$27b118c54b403d55 = {
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: $4fb564aabcdf3c81$export$4f505fdc26f544f5
};

});
parcelRegister("4TezD", function(module, exports) {

$parcel$export(module.exports, "WrapperCommon", () => $c5e0dade2a2fd498$export$2cd335d97b9054d6);
$parcel$export(module.exports, "CellWrapper", () => $c5e0dade2a2fd498$export$4812fadef83edffe);
$parcel$export(module.exports, "TextCellWrapper", () => $c5e0dade2a2fd498$export$aea2b0ba32a5c9ab);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c5e0dade2a2fd498$export$2cd335d97b9054d6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c5e0dade2a2fd498$var$wrapperCommonStyles
    }, props.children);
const $c5e0dade2a2fd498$export$4812fadef83edffe = ({ isEditable: isEditable, testId: testId, children: children, hasPadding: hasPadding = true, ariaLabel: ariaLabel, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c5e0dade2a2fd498$var$wrapperCommonStyles,
            $c5e0dade2a2fd498$var$cellWrapperStyles,
            isEditable && $c5e0dade2a2fd498$var$editableCellWrapperStyles,
            hasPadding && $c5e0dade2a2fd498$var$cellWrapperPaddingStyles
        ],
        testId: testId,
        "aria-label": ariaLabel,
        onCut: onCut,
        onCopy: onCopy,
        onPaste: onPaste
    }, children);
const $c5e0dade2a2fd498$export$aea2b0ba32a5c9ab = ({ isEditable: isEditable, testId: testId, ariaLabel: ariaLabel, children: children, onCut: onCut, onCopy: onCopy, onPaste: onPaste })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c5e0dade2a2fd498$var$textCellWrapperStyles,
            isEditable && $c5e0dade2a2fd498$var$editableTextCellWrapperStyles
        ],
        testId: testId,
        "aria-label": ariaLabel,
        onCut: onCut,
        onCopy: onCopy,
        onPaste: onPaste
    }, children);
const $c5e0dade2a2fd498$var$wrapperCommonStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none'
});
const $c5e0dade2a2fd498$var$cellWrapperStyles = (0, $1ZAYh.xcss)({
    boxSizing: 'border-box',
    borderRadius: 'border.radius'
});
const $c5e0dade2a2fd498$var$cellWrapperPaddingStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});
const $c5e0dade2a2fd498$var$editableCellWrapperStyles = (0, $1ZAYh.xcss)({
    cursor: 'pointer'
});
const $c5e0dade2a2fd498$var$textCellWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none',
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'form' does not exist in type 'SafeCSSObject'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    form: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-ds--text-field--input]': {
            height: '100%',
            outline: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-ds--text-field--container], [data-ds--text-field--container]:focus-within': {
            outline: 'none',
            boxShadow: 'none',
            border: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
});
const $c5e0dade2a2fd498$var$editableTextCellWrapperStyles = (0, $1ZAYh.xcss)({
    cursor: 'text'
});

});

parcelRegister("fiEoq", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEdit", () => $3c9994d572d7b4f4$export$e624ed4af58fd142);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $36Afv = parcelRequire("36Afv");
const $3c9994d572d7b4f4$export$e624ed4af58fd142 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $36Afv.CascadingSelectEditEntryPoint), {});
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.cascadingSelect.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("36Afv", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectEditEntryPoint", () => $e47a530bad5f119e$export$93e961c95d3c1b6a);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $e47a530bad5f119e$export$93e961c95d3c1b6a = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("gFNP0")), {
        moduleId: "2a2020e5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gFNP0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jvhwq');
        const value = parcelRequire('hp4vO');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jvhwq").then(()=>parcelRequire('hp4vO'));
}

});



parcelRegister("l4xGf", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectRead", () => $ccc9bc39c87cffa0$export$1e55dc71aaaa2cc4);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $yTRlI = parcelRequire("yTRlI");
const $ccc9bc39c87cffa0$export$1e55dc71aaaa2cc4 = ({ value: value })=>{
    if (value == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ccc9bc39c87cffa0$var$containerStyles
    }, (0, $yTRlI.getCascadingSelectStringValue)(value));
};
const $ccc9bc39c87cffa0$var$containerStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'block'
});

});


parcelRegister("eyVJl", function(module, exports) {

$parcel$export(module.exports, "devSummaryCellHandler", () => $f42a0eaf31349805$export$31d4252fa9154106);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $2Hkyz = parcelRequire("2Hkyz");
const $f42a0eaf31349805$export$e04e820b15fa1f63 = ({ rowData: rowData, cellData: cellData, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: false
    }, cellData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Hkyz.DevSummaryRead), {
        ...cellData,
        isHovering: false,
        issueId: rowData.issueId,
        editMode: editMode,
        setEditMode: setEditMode,
        cellRef: cellRef
    }));
const $f42a0eaf31349805$export$31d4252fa9154106 = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: $f42a0eaf31349805$export$e04e820b15fa1f63
};

});
parcelRegister("2Hkyz", function(module, exports) {

$parcel$export(module.exports, "DevSummaryRead", () => $11f65fd20dbb48e9$export$9147ca8c33d1d192);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3MV1G = parcelRequire("3MV1G");

var $c0jFd = parcelRequire("c0jFd");

var $2ld4O = parcelRequire("2ld4O");
var $8gviD = parcelRequire("8gviD");
var $lKCKu = parcelRequire("lKCKu");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $c5Qiw = parcelRequire("c5Qiw");

var $gd0Sp = parcelRequire("gd0Sp");

var $7uPRH = parcelRequire("7uPRH");

var $dpiiy = parcelRequire("dpiiy");
// Maybe we need to pass this to the cell from the list view
const $11f65fd20dbb48e9$var$popupOffset = [
    -8,
    0
];
const $11f65fd20dbb48e9$var$scopeId = 'software-list.list';
const $11f65fd20dbb48e9$export$9147ca8c33d1d192 = ({ issueId: issueId, isMerged: isMerged, isUnderReview: isUnderReview, commitCount: commitCount, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, ...props })=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const issueAri = (0, $eUqFw.useMemo)(()=>(0, $2ld4O.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const devInfoType = isMerged || isUnderReview ? (0, $8gviD.DevInfoTypes).PULLREQUEST : (0, $8gviD.DevInfoTypes).COMMIT;
    const { id: experienceId, name: experienceName } = (0, $7uPRH.experienceDetails)[devInfoType];
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $7uPRH.popupEntryPoints)[devInfoType], entryPointParams, (0, $7uPRH.metricsDev)[devInfoType]);
    const entryPointErrorBoundaryProps = (0, $eUqFw.useMemo)(()=>({
            ...(0, $7uPRH.packageDetails)[devInfoType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lKCKu.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: $11f65fd20dbb48e9$var$scopeId
                })
        }), [
        devInfoType,
        issueAri
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            issueAri: issueAri,
            devInfoType: devInfoType,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: $11f65fd20dbb48e9$var$scopeId
        }), [
        issueAri,
        devInfoType,
        stopMetric,
        onExperienceSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (editMode) entryPointActions.load();
    }, [
        editMode,
        entryPointActions
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>{
        if (!editMode) entryPointActions.preload();
    }, [
        entryPointActions,
        editMode
    ]);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>{
        entryPointActions.cancelPreload();
    }, [
        entryPointActions
    ]);
    const popupTrigger = (0, $eUqFw.useCallback)(({ ref: ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-controls': ariaControls })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            ref: ref,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            "aria-controls": ariaControls,
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpiiy.DevSummaryLozenge), {
            isMerged: isMerged,
            isUnderReview: isUnderReview,
            commitCount: commitCount,
            ...props
        })), [
        commitCount,
        isMerged,
        isUnderReview,
        props
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Tab') return true;
        return false;
    }, []);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if (!isMerged && !isUnderReview && commitCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11f65fd20dbb48e9$var$Container, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-testId": "business-fields.ui.dev-summary.cell.read.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "bottom-start",
        autoFocus: false,
        shouldUseCaptureOnOutsideClick: true,
        testId: "business-fields.ui.dev-summary.cell.read.popup",
        trigger: popupTrigger,
        isOpen: editMode,
        offset: $11f65fd20dbb48e9$var$popupOffset,
        onClose: ()=>setEditMode(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c5Qiw.DevInfoDetailsPopupSkeleton), {
                    devinfoType: devInfoType
                }),
                runtimeProps: runtimeProps
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11f65fd20dbb48e9$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ld4O", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $b5e04eaf4130b68e$export$6b0ec881a3540845);

var $huI7r = parcelRequire("huI7r");
const $b5e04eaf4130b68e$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("8gviD", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $37282c0a5dd8d9ce$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $37282c0a5dd8d9ce$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $37282c0a5dd8d9ce$export$477d4d2d93581a40);
const $37282c0a5dd8d9ce$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $37282c0a5dd8d9ce$export$39c00ace65e13f2d = {
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.BRANCH]: 'branch',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.COMMIT]: 'commit',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.MERGED]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$37282c0a5dd8d9ce$export$a100703e17b2650a.DESIGN]: 'design'
};
const $37282c0a5dd8d9ce$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("lKCKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b49a01e4d7de0f03$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e9Jo2 = parcelRequire("e9Jo2");

var $8gviD = parcelRequire("8gviD");

var $eQ4bB = parcelRequire("eQ4bB");

var $cpgno = parcelRequire("cpgno");
const $b49a01e4d7de0f03$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $eQ4bB.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8gviD.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8gviD.DevInfoTypes).DESIGN ? formatMessage((0, $cpgno.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $cpgno.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9Jo2.PopupTitle), null, formatMessage((0, $cpgno.default).errorPopupTitle, {
        devInfoType: (0, $8gviD.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Title, null, formatMessage((0, $cpgno.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$Description, null, errorMessage, devInfoType !== (0, $8gviD.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b49a01e4d7de0f03$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $cpgno.default).developmentErrorDescriptionCta))));
};
var $b49a01e4d7de0f03$export$2e2bcd8739ae039 = $b49a01e4d7de0f03$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b49a01e4d7de0f03$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yxxidpf _12r21nn1 _if291ule _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $b49a01e4d7de0f03$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1wmz _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e9Jo2", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $4d67de45504f6b7f$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $4d67de45504f6b7f$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $4d67de45504f6b7f$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $4d67de45504f6b7f$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $4d67de45504f6b7f$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $4d67de45504f6b7f$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $4d67de45504f6b7f$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $4d67de45504f6b7f$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $4d67de45504f6b7f$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $4d67de45504f6b7f$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $4d67de45504f6b7f$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $dnbhd = parcelRequire("dnbhd");
const $4d67de45504f6b7f$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$30301703d55848e7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _o5724jg8",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$80b51772092eddc0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4d67de45504f6b7f$export$80b51772092eddc0, props));
const $4d67de45504f6b7f$export$9048d548939551ee = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $dnbhd.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p8n31 _1wyb7vkz _syaz1y58 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$a0765d4427758c62 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _bfhk1wws _otyrutpp",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yxxidpf _12r21nn1 _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf",
            __cmplp.className
        ])
    });
});
const $4d67de45504f6b7f$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $kJlBc = parcelRequire("kJlBc");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});


parcelRegister("eQ4bB", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $0f663eb0f0e5c7d1$export$cdc75a6c65207319);

var $2WYJT = parcelRequire("2WYJT");


var $huI7r = parcelRequire("huI7r");

var $8gviD = parcelRequire("8gviD");
const $0f663eb0f0e5c7d1$export$166d6c8e7de25541 = (issueAri)=>(0, $huI7r.parseAri)(issueAri)?.resourceId;
const $0f663eb0f0e5c7d1$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8gviD.DevInfoTypes).COMMIT) return 0, $14a090e212ebf7a4$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8gviD.DevInfoTypes).DEPLOYMENT) return 0, $14a090e212ebf7a4$export$90cac6260ae9ced5;
    return devInfoType;
};
function $0f663eb0f0e5c7d1$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $2WYJT.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $0f663eb0f0e5c7d1$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $0f663eb0f0e5c7d1$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});
parcelRegister("2WYJT", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $87c35b59655e803f$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $87c35b59655e803f$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $87c35b59655e803f$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $87c35b59655e803f$export$506ad06ecf691cd3);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
var $gasA1 = parcelRequire("gasA1");

var $2BvS3 = parcelRequire("2BvS3");


var $fduvM = parcelRequire("fduvM");
const $87c35b59655e803f$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: (0, $fduvM.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $87c35b59655e803f$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $fduvM.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $14a090e212ebf7a4$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $87c35b59655e803f$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $fduvM.INITIAL_STATE),
    actions: $87c35b59655e803f$export$e324594224ef24da
});
const $87c35b59655e803f$export$5e6e4cfb89bdcb55 = (0, $heB5U.createContainer)($87c35b59655e803f$export$390f32400eaf98c9);
const $87c35b59655e803f$export$693f51ab225dff94 = (0, $dYfll.createSubscriber)($87c35b59655e803f$export$390f32400eaf98c9);
const $87c35b59655e803f$export$550d4b3c29100112 = (0, $ggKAj.createHook)($87c35b59655e803f$export$390f32400eaf98c9);
function $87c35b59655e803f$export$506ad06ecf691cd3(scopeId) {
    return (0, $gasA1.defaultRegistry).getStore($87c35b59655e803f$export$390f32400eaf98c9, scopeId).actions;
}

});
const $14a090e212ebf7a4$export$e18d81f044132a0e = 'branch';
const $14a090e212ebf7a4$export$74a388a09f2a004e = 'build';
const $14a090e212ebf7a4$export$2e42513c7764d5f3 = 'repository';
const $14a090e212ebf7a4$export$3f1e2b276d607490 = 'review';
const $14a090e212ebf7a4$export$90cac6260ae9ced5 = 'deployment-environment';
const $14a090e212ebf7a4$export$6f74b53d652f13f3 = 'pullrequest';
const $14a090e212ebf7a4$export$c69477f358d30f7e = 'feature-flags';
const $14a090e212ebf7a4$export$56470bdd9cd798d0 = 'remote-links';
const $14a090e212ebf7a4$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $14a090e212ebf7a4$export$b4bb784d069c9ab = 'development.details.details-header';
const $14a090e212ebf7a4$export$74189cec821240a6 = 'development.details.remote-links';

parcelRegister("fduvM", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $b00e5ffa4dd6d204$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $b00e5ffa4dd6d204$export$43a8ab4f373ff0ee);
const $b00e5ffa4dd6d204$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $b00e5ffa4dd6d204$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $b00e5ffa4dd6d204$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $b00e5ffa4dd6d204$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});



parcelRegister("cpgno", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bd4bef6d1b1266$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $44bd4bef6d1b1266$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("c5Qiw", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $6593062fea30be6d$export$9044eba4855892a5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $hMvQr = parcelRequire("hMvQr");

var $h2vSh = parcelRequire("h2vSh");

var $cGypA = parcelRequire("cGypA");

var $22SxL = parcelRequire("22SxL");

var $7qWdP = parcelRequire("7qWdP");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $6593062fea30be6d$var$customCssStyles = null;
const $6593062fea30be6d$var$skeletonStyles = null;
const $6593062fea30be6d$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $6593062fea30be6d$var$skeletonAsset = {
    [$6593062fea30be6d$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($hMvQr))),
    [$6593062fea30be6d$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($h2vSh))),
    [$6593062fea30be6d$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($7qWdP))),
    [$6593062fea30be6d$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($cGypA))),
    [$6593062fea30be6d$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($22SxL)))
};
const $6593062fea30be6d$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _1yt41lhn _vchhusvi _4t3imgvx",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $6593062fea30be6d$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _1yt41lhn _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: $6593062fea30be6d$var$skeletonAsset[devinfoType],
        className: (0, $7JEyt.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("hMvQr", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("h2vSh", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("cGypA", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("22SxL", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("7qWdP", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("7uPRH", function(module, exports) {

$parcel$export(module.exports, "metricsDev", () => $e54a6a3bc3e00198$export$9d08247a1076ddb0);
$parcel$export(module.exports, "experienceDetails", () => $e54a6a3bc3e00198$export$ba2604b0fdde2542);
$parcel$export(module.exports, "packageDetails", () => $e54a6a3bc3e00198$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPoints", () => $e54a6a3bc3e00198$export$1452632269dce6);

var $lNfG4 = parcelRequire("lNfG4");

var $9Lh4U = parcelRequire("9Lh4U");

var $8gviD = parcelRequire("8gviD");

var $8qFOR = parcelRequire("8qFOR");
const $e54a6a3bc3e00198$var$commitDetailsPopupLoad = (0, $lNfG4.metrics).interaction({
    key: 'list.commit-details-popup-load'
});
const $e54a6a3bc3e00198$var$prDetailsPopupLoad = (0, $lNfG4.metrics).interaction({
    key: 'list.pr-details-popup-load'
});
const $e54a6a3bc3e00198$export$9d08247a1076ddb0 = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: $e54a6a3bc3e00198$var$commitDetailsPopupLoad,
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: $e54a6a3bc3e00198$var$prDetailsPopupLoad
};
const $e54a6a3bc3e00198$export$ba2604b0fdde2542 = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareListCommitDetailsPopup'
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareListPrDetailsPopup'
    }
};
const $e54a6a3bc3e00198$export$48b44d9f3c6e15de = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentListCommitDetailsPopup',
        teamName: 'fusion-isotopes'
    },
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentListPrDetailsPopup',
        teamName: 'fusion-isotopes'
    }
};
const $e54a6a3bc3e00198$export$1452632269dce6 = {
    [(0, $8gviD.DevInfoTypes).COMMIT]: (0, $9Lh4U.commitDetailsEntryPoint),
    [(0, $8gviD.DevInfoTypes).PULLREQUEST]: (0, $8qFOR.pullRequestDetailsEntryPoint)
};

});
parcelRegister("9Lh4U", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $3c86546e63859b12$export$543707906869c79b);

var $cRNlw = parcelRequire("cRNlw");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $3c86546e63859b12$export$543707906869c79b = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("9ZvMF")), {
        moduleId: "0f8578e0"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cRNlw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cRNlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec06dfcbd43e202$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $eec06dfcbd43e202$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $eec06dfcbd43e202$export$2e2bcd8739ae039 = $eec06dfcbd43e202$var$node;

});

parcelRegister("9ZvMF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8Ydge');
        const value = parcelRequire('8jOtz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8Ydge").then(()=>parcelRequire('8jOtz'));
}

});


parcelRegister("8qFOR", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $00e71a60969c485e$export$37ab544e7066c095);

var $jLRNB = parcelRequire("jLRNB");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $00e71a60969c485e$export$37ab544e7066c095 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("gC0bT")), {
        moduleId: "1b74db53"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jLRNB.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("jLRNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c2342641857612$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $99c2342641857612$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $99c2342641857612$export$2e2bcd8739ae039 = $99c2342641857612$var$node;

});

parcelRegister("gC0bT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('03Ibg')
        ]);
        const value = parcelRequire('8IcTB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("03Ibg")
    ]).then(()=>parcelRequire('8IcTB'));
}

});



parcelRegister("dpiiy", function(module, exports) {

$parcel$export(module.exports, "DevSummaryLozenge", () => $3de80405a7ba4d79$export$3bb699b6db60f511);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3NqHp = parcelRequire("3NqHp");

var $dEfSO = parcelRequire("dEfSO");
const $3de80405a7ba4d79$export$3bb699b6db60f511 = ({ isUnderReview: isUnderReview, isMerged: isMerged, commitCount: commitCount, pullRequestsCount: pullRequestsCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isMerged || isUnderReview) {
        const tooltipText = formatMessage((0, $dEfSO.default).pullRequest, {
            count: pullRequestsCount
        });
        const lozengeText = isMerged ? formatMessage((0, $dEfSO.default).merged) : formatMessage((0, $dEfSO.default).underReview);
        const lozengeAppearance = isMerged ? 'success' : 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NqHp.TagListWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipText,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: lozengeAppearance
        }, lozengeText)));
    }
    if (commitCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3de80405a7ba4d79$var$linkStyles
    }, formatMessage((0, $dEfSO.default).commit, {
        count: commitCount
    }));
};
const $3de80405a7ba4d79$var$linkStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.blue',
    paddingLeft: 'space.075'
});

});
parcelRegister("3NqHp", function(module, exports) {

$parcel$export(module.exports, "TagListWrapper", () => $e05d2a11c57cc062$export$e4f5eab7c40840c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4L66F = parcelRequire("4L66F");
const $e05d2a11c57cc062$export$e4f5eab7c40840c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, isEditable: isEditable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uzc8vy": (0, $9t7rW.default)((0, $4L66F.SELECTED_CELL_BOX_SHADOW))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11vw1qnq _1e0c1txw _4cvr1h6o _1bsbupfu _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _1n261q9c _1reo15vq _18m915vq _1yt41cy0 _o5721q9c _hc7q15vq _njtz15vq _p7r1116y",
            __cmplp.isFocused ? "_16qs179s" : "_16qsglyw",
            __cmplp.isFocused ? "_bfhkvuon" : "_bfhk18uv",
            __cmplp.isEditable ?? true ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4L66F", function(module, exports) {

$parcel$export(module.exports, "SELECTED_CELL_BOX_SHADOW", () => $6eb268cb8f99047b$export$e643c5fb607dbcc5);
$parcel$export(module.exports, "DEFAULT_ROW_HEIGHT", () => $6eb268cb8f99047b$export$258441c8a79bb589);

var $PdmhA = parcelRequire("PdmhA");
const $6eb268cb8f99047b$export$95bfdfec8f6b837d = 2;
const $6eb268cb8f99047b$export$e643c5fb607dbcc5 = `0 0 0 ${$6eb268cb8f99047b$export$95bfdfec8f6b837d}px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`} inset`;
const $6eb268cb8f99047b$export$258441c8a79bb589 = 40;
const $6eb268cb8f99047b$export$3e36baaa5cb0cfb5 = [
    0,
    -$6eb268cb8f99047b$export$258441c8a79bb589
];

});


parcelRegister("dEfSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5e9b3238b6c2d3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c5e9b3238b6c2d3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    underReview: {
        "id": "business-fields.dev-summary.cell.read.lozenge.under-review",
        "defaultMessage": "Under review"
    },
    merged: {
        "id": "business-fields.dev-summary.cell.read.lozenge.merged",
        "defaultMessage": "Merged"
    },
    commit: {
        "id": "business-fields.dev-summary.cell.read.lozenge.commit",
        "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
    },
    pullRequest: {
        "id": "business-fields.dev-summary.cell.read.lozenge.pull-request",
        "defaultMessage": "{count, plural, one {# pull request} other {# pull requests}}"
    }
});

});




parcelRegister("iwcjI", function(module, exports) {

$parcel$export(module.exports, "goalsCellHandler", () => $b0b894329932ed05$export$524e25319ef30df1);

var $eUqFw = parcelRequire("eUqFw");

var $9JNni = parcelRequire("9JNni");

var $1ybV0 = parcelRequire("1ybV0");

var $gJNrI = parcelRequire("gJNrI");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");

var $4TezD = parcelRequire("4TezD");

var $b5xtc = parcelRequire("b5xtc");

var $3ylNm = parcelRequire("3ylNm");
const $b0b894329932ed05$export$aea87ff07be8100d = ({ rowData: issue, cellData: field, editMode: editMode, setEditMode: setEditMode, fieldId: fieldId, fieldName: fieldName, cellRef: cellRef })=>{
    const [selectedGoals, setSelectedGoals] = (0, $eUqFw.useState)(field?.value?.goals || []);
    const [selectedGoalsCount, setSelectedGoalsCount] = (0, $eUqFw.useState)(field?.value?.totalCount ?? 0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isEditable = field?.isEditable ?? true;
    const isFieldAssociated = (0, $3ylNm.useIsFieldAssociatedWithIssueType)({
        fieldId: fieldId,
        issueTypeId: issue.issuetype?.id
    });
    const [{ value: value }, { saveValue: saveValue }] = (0, $gJNrI.useGoalsField)({
        issueId: issue.issueId,
        issueKey: issue.key,
        fieldKey: fieldId,
        initialValue: {
            goals: field?.value?.goals || [],
            totalCount: field?.value?.totalCount || 0
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        setSelectedGoals(field?.value?.goals ?? []);
        setSelectedGoalsCount(field?.value?.totalCount ?? 0);
    }, [
        field?.value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view')) saveValue({
            goals: [
                selectedGoals?.[0] ?? null
            ],
            totalCount: selectedGoalsCount
        }, null, createAnalyticsEvent({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedGoals,
        selectedGoalsCount
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setEditMode(false);
    }, [
        setEditMode
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Tab') return true;
        return false;
    }, []);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const onGoalPicked = (0, $eUqFw.useCallback)((goal)=>{
        setSelectedGoals([
            ...selectedGoals,
            goal
        ]);
        setSelectedGoalsCount(selectedGoalsCount + 1);
    }, [
        selectedGoals,
        selectedGoalsCount
    ]);
    const onGoalUnlinked = (0, $eUqFw.useCallback)((_, remainingGoals)=>{
        setSelectedGoals(remainingGoals);
        setSelectedGoalsCount(selectedGoalsCount > 0 ? selectedGoalsCount - 1 : 0);
    }, [
        selectedGoalsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable
    }, isFieldAssociated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JNni.default), {
        issueAri: issue.id,
        editMode: editMode,
        goals: (0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') ? value.goals : selectedGoals,
        goalCount: (0, $1ybV0.ff)('hrz-716-integrate-goal-picker-into-issue-view') ? value.totalCount : selectedGoalsCount,
        onClose: onClose,
        isEditable: isEditable,
        onGoalPicked: onGoalPicked,
        onGoalUnlinked: onGoalUnlinked
    }), !isFieldAssociated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5xtc.AssociateFieldPopup), {
        isOpen: editMode,
        issueType: issue.issuetype?.name,
        issueTypeId: issue.issuetype?.id,
        fieldId: fieldId,
        fieldName: fieldName,
        onClose: onClose
    }));
};
const $b0b894329932ed05$export$524e25319ef30df1 = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: $b0b894329932ed05$export$aea87ff07be8100d
};

});
parcelRegister("9JNni", function(module, exports) {

$parcel$export(module.exports, "default", () => $302f90b11f728b97$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $6j4bv = parcelRequire("6j4bv");

var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $dWLk9 = parcelRequire("dWLk9");

var $7rATE = parcelRequire("7rATE");

var $6ixIu = parcelRequire("6ixIu");

var $lUluW = parcelRequire("lUluW");
const $302f90b11f728b97$var$POPUP_OFFSET = [
    -8,
    8
];
const $302f90b11f728b97$var$GoalsPicker = ({ issueAri: issueAri, goals: goals, goalCount: goalCount, isEditable: isEditable, editMode: editMode, onClose: onClose, onGoalPicked: onGoalPicked, onGoalUnlinked: onGoalUnlinked, shouldRenderToParent: shouldRenderToParent = false, showPlaceholder: showPlaceholder })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $lUluW.goalPickerPopoverEntryPoint), {
        cloudId: cloudId
    });
    const buttonTrigger = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    (0, $eUqFw.useEffect)(()=>{
        editMode && entryPointActions.load();
    }, [
        editMode,
        entryPointActions
    ]);
    const popupTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            role: "button",
            xcss: $302f90b11f728b97$var$triggerStyles,
            ...triggerProps,
            ref: (element)=>{
                buttonTrigger(element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ixIu.GoalsCellContent), {
            showPlaceholder: showPlaceholder,
            goals: goals,
            goalCount: goalCount,
            isEditable: isEditable
        })), [
        buttonTrigger,
        goalCount,
        goals,
        isEditable,
        showPlaceholder
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            issueAri: issueAri,
            goalCount: goalCount,
            onGoalPicked: onGoalPicked,
            onGoalUnlinked: onGoalUnlinked,
            onClose: onClose
        }), [
        goalCount,
        issueAri,
        onClose,
        onGoalPicked,
        onGoalUnlinked
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm.goals.picker.edit.popup",
            packageName: "jiraBusinessGoalPicker",
            runtimeProps: runtimeProps,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rATE.LoadingContent), null),
            errorFallback: "flag"
        }), [
        entryPointReferenceSubject,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $302f90b11f728b97$var$goalPickerStyles,
        alignItems: "center",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: editMode,
        content: content,
        trigger: popupTrigger,
        offset: $302f90b11f728b97$var$POPUP_OFFSET,
        placement: "bottom-start",
        shouldRenderToParent: shouldRenderToParent,
        onClose: onClose
    }));
};
var $302f90b11f728b97$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($302f90b11f728b97$var$GoalsPicker);
const $302f90b11f728b97$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center'
});
const $302f90b11f728b97$var$goalPickerStyles = (0, $1ZAYh.xcss)({
    minHeight: '100%',
    width: '100%'
});

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("7rATE", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $96937c76ff371ba7$export$4ab3512e4872e6ff);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $96937c76ff371ba7$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $96937c76ff371ba7$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
const $96937c76ff371ba7$var$loadingStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    width: '342px',
    padding: 'space.500'
});

});

parcelRegister("6ixIu", function(module, exports) {

$parcel$export(module.exports, "GoalsCellContent", () => $85bc4f45d09a6b3a$export$72e457a3c2c5d2a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iY7zv = parcelRequire("iY7zv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $8TTqM = parcelRequire("8TTqM");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7ERlq = parcelRequire("7ERlq");
var $cxEEX = parcelRequire("cxEEX");

var $3LRXu = parcelRequire("3LRXu");
const $85bc4f45d09a6b3a$export$72e457a3c2c5d2a = ({ goals: goals, goalCount: goalCount, isEditable: isEditable, showPlaceholder: showPlaceholder = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (goalCount > 0 && goals !== null && goals.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85bc4f45d09a6b3a$var$Wrapper, {
        "aria-label": formatMessage((0, $3LRXu.default).goalPickerAriaLabel),
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $85bc4f45d09a6b3a$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8TTqM.GoalIcon), {
        size: "16",
        appearance: (0, $8TTqM.normalizeGoalAppearance)(goals[0].status || 'PENDING')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ERlq.GoalName), {
        name: goals[0].name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cxEEX.GoalsCount), {
        goalCount: goalCount
    }));
    let noGoalsContent;
    if (showPlaceholder) // if placeholder is displayed we wouldn't show 'add goal'
    noGoalsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $85bc4f45d09a6b3a$var$noGoalsStyles
    }, formatMessage((0, $3LRXu.default).noGoals));
    else if (isEditable) noGoalsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $85bc4f45d09a6b3a$var$addGoalStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))), {
        label: "",
        spacing: "spacious"
    }), formatMessage((0, $3LRXu.default).addGoal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85bc4f45d09a6b3a$var$Wrapper, {
        "aria-label": formatMessage((0, $3LRXu.default).goalPickerAriaLabel),
        "data-testid": "business-goal-picker.ui.goals-cell-content.wrapper"
    }, noGoalsContent);
};
const $85bc4f45d09a6b3a$var$GOAL_PICKER_ADD_GOAL_DISPLAY = '--jira-goal-picker-cell-add-goal-display';
const $85bc4f45d09a6b3a$var$addGoalStyles = (0, $1ZAYh.xcss)({
    display: `var(${$85bc4f45d09a6b3a$var$GOAL_PICKER_ADD_GOAL_DISPLAY}, none)`,
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $85bc4f45d09a6b3a$var$noGoalsStyles = (0, $1ZAYh.xcss)({
    gap: 'space.100',
    alignItems: 'center',
    color: 'color.text.subtlest'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85bc4f45d09a6b3a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _80omtlke _1bsb1osq _4t3i1osq _16jlkb7n _4cvr1h6o _zulpu2gc _tj4x1txw _2ooc1txw",
            __cmplp.className
        ])
    });
});
const $85bc4f45d09a6b3a$var$iconStyles = (0, $1ZAYh.xcss)({
    width: 'space.200'
});

});
parcelRegister("8TTqM", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $fdf13b72e1d50987$export$134cbcd70c6693b8);
$parcel$export(module.exports, "normalizeGoalAppearance", () => $fdf13b72e1d50987$export$f1b3ca93191ce5cc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cI2j2 = parcelRequire("cI2j2");

var $iY7zv = parcelRequire("iY7zv");

var $9Jret = parcelRequire("9Jret");

var $a34JA = parcelRequire("a34JA");
const $fdf13b72e1d50987$var$appearanceToColorMap = {
    default: 'gray',
    off_track: 'red',
    at_risk: 'yellow',
    on_track: 'green'
};
const $fdf13b72e1d50987$var$appearanceToLabelMap = {
    default: 'GenericIconLabel',
    off_track: 'townsquare.api.goal-state.off-track',
    at_risk: 'townsquare.api.goal-state.at-risk',
    on_track: 'townsquare.api.goal-state.on-track'
};
const $fdf13b72e1d50987$export$134cbcd70c6693b8 = ({ appearance: appearance, size: size, localizedLabel: localizedLabel })=>{
    const intl = (0, $5JgJ2.default)();
    const labelMessageId = localizedLabel && (0, $a34JA.isMessageId)(localizedLabel?.messageId) ? localizedLabel.messageId : $fdf13b72e1d50987$var$appearanceToLabelMap[appearance];
    return /*#__PURE__*/ $eUqFw.createElement((0, $cI2j2.default), {
        size: size,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iY7zv))),
        label: intl.formatMessage((0, $a34JA.messages)[labelMessageId]),
        appearance: $fdf13b72e1d50987$var$appearanceToColorMap[appearance]
    });
};
const $fdf13b72e1d50987$export$f1b3ca93191ce5cc = (statusValue)=>{
    const appearanceLowercase = statusValue.toLocaleLowerCase();
    return (0, $9Jret.isGoalAppearance)(appearanceLowercase) ? appearanceLowercase : 'default';
};

});
parcelRegister("cI2j2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb8d50dcfc24c9b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $1fb8d50dcfc24c9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1fb8d50dcfc24c9b$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $1fb8d50dcfc24c9b$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $1fb8d50dcfc24c9b$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $1fb8d50dcfc24c9b$var$iconTileStyles = {
    name: "ykimcl",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
};
function $1fb8d50dcfc24c9b$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square' } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $1fb8d50dcfc24c9b$var$iconTileStyles,
            $1fb8d50dcfc24c9b$var$appearanceMap[appearance],
            $1fb8d50dcfc24c9b$var$sizeMap[size],
            $1fb8d50dcfc24c9b$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});

parcelRegister("9Jret", function(module, exports) {

$parcel$export(module.exports, "isGoalAppearance", () => $ed33bb8a36a562f3$export$86d2476abee3806b);
const $ed33bb8a36a562f3$export$d6870ac5e959c0f5 = [
    'default',
    'on_track',
    'at_risk',
    'off_track'
];
const $ed33bb8a36a562f3$export$86d2476abee3806b = (value)=>$ed33bb8a36a562f3$export$d6870ac5e959c0f5.includes(value);
const $ed33bb8a36a562f3$export$d7b4c6a971e28318 = [
    'ON_TRACK',
    'AT_RISK',
    'OFF_TRACK',
    'PENDING',
    'COMPLETED',
    'CANCELLED',
    'PAUSED'
];

});

parcelRegister("a34JA", function(module, exports) {

$parcel$export(module.exports, "isMessageId", () => $b5b67297adf6aba2$export$d28699f9b486207b);
$parcel$export(module.exports, "messages", () => $b5b67297adf6aba2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b5b67297adf6aba2$var$MESSAGE_IDS = [
    'townsquare.api.goal-state.on-track',
    'townsquare.api.goal-state.off-track',
    'townsquare.api.goal-state.at-risk',
    'townsquare.api.goal-state.pending',
    'townsquare.api.goal-state.completed',
    'townsquare.api.goal-state.cancelled',
    'townsquare.api.goal-state.paused',
    'GenericIconLabel'
];
const $b5b67297adf6aba2$export$d28699f9b486207b = (value)=>$b5b67297adf6aba2$var$MESSAGE_IDS.includes(value);
const $b5b67297adf6aba2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    GenericIconLabel: {
        id: 'Goals.icon.label.generic',
        defaultMessage: 'Goal icon',
        description: 'A generic label for the goal icon, for when a label is not supplied and cannot be inferred from the appearance prop.'
    },
    'townsquare.api.goal-state.on-track': {
        id: 'Goals.icon.label.on-track',
        defaultMessage: 'On track',
        description: 'The label for the "on track" goal status'
    },
    'townsquare.api.goal-state.off-track': {
        id: 'Goals.icon.label.off-track',
        defaultMessage: 'Off track',
        description: 'The label for the "off track" goal status'
    },
    'townsquare.api.goal-state.at-risk': {
        id: 'Goals.icon.label.at-risk',
        defaultMessage: 'At risk',
        description: 'The label for the "at risk" goal status'
    },
    'townsquare.api.goal-state.pending': {
        id: 'Goals.icon.label.pending',
        defaultMessage: 'Pending',
        description: 'The label for the "pending" goal status'
    },
    'townsquare.api.goal-state.completed': {
        id: 'Goals.icon.label.completed',
        defaultMessage: 'Completed',
        description: 'The label for the "completed" goal status'
    },
    'townsquare.api.goal-state.cancelled': {
        id: 'Goals.icon.label.cancelled',
        defaultMessage: 'Cancelled',
        description: 'The label for the "cancelled" goal status'
    },
    'townsquare.api.goal-state.paused': {
        id: 'Goals.icon.label.paused',
        defaultMessage: 'Paused',
        description: 'The label for the "paused" goal status'
    }
});

});


parcelRegister("7ERlq", function(module, exports) {

$parcel$export(module.exports, "GoalName", () => $1279a78781638498$export$4427fb3cde8dd0cf);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $1279a78781638498$export$4427fb3cde8dd0cf = ({ name: name })=>name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1279a78781638498$var$goalTextStyles,
        as: "span"
    }, name);
const $1279a78781638498$var$goalTextStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});

parcelRegister("cxEEX", function(module, exports) {

$parcel$export(module.exports, "GoalsCount", () => $901a0e7fc0437b9b$export$cb088e21a8acb84d);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $901a0e7fc0437b9b$export$cb088e21a8acb84d = ({ goalCount: goalCount })=>{
    const numberOfGoals = (0, $eUqFw.useMemo)(()=>goalCount > 1 ? `+${goalCount - 1}` : '', [
        goalCount
    ]);
    return numberOfGoals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $901a0e7fc0437b9b$var$countStyles
    }, numberOfGoals);
};
const $901a0e7fc0437b9b$var$countStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.disabled',
    fontWeight: 400,
    borderRadius: 'border.radius',
    lineHeight: 0.8632,
    padding: 'space.050',
    pointerEvents: 'none'
});

});

parcelRegister("3LRXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc93455b2bfca192$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fc93455b2bfca192$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goalPickerAriaLabel: {
        "id": "business-goal-picker.goals-cell-content.goal-picker-aria-label",
        "defaultMessage": "Link Goals"
    },
    addGoal: {
        "id": "business-goal-picker.goals-cell-content.add-goal",
        "defaultMessage": "Add goal"
    },
    noGoals: {
        "id": "business-goal-picker.goals-cell-content.no-goals",
        "defaultMessage": "None"
    }
});

});


parcelRegister("lUluW", function(module, exports) {

$parcel$export(module.exports, "goalPickerPopoverEntryPoint", () => $48f2d4f515c7ffe8$export$2917eb3a6c81ef7c);

var $gkdpR = parcelRequire("gkdpR");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $48f2d4f515c7ffe8$export$2917eb3a6c81ef7c = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("4vwmk")), {
        moduleId: "97c2ac23"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                mainGoalsPopupContentQuery: {
                    parameters: (0, $gkdpR.default),
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("gkdpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $25d0d7d36e312091$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3cc1b4b9fcab622dd86bbc5e000c7db>>
 * @relayHash 694e5076d8b794c7fd127d30ba8e0bfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f087b092d04fae3500eb388cb13b128433088d13aee1dd5bda1fd57d932b1ba
const $25d0d7d36e312091$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareWorkspaceConnection",
                            "kind": "LinkedField",
                            "name": "allWorkspacesForOrg",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareWorkspaceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareWorkspace",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainGoalsPopupContentQuery",
            "selections": [
                {
                    "concreteType": "TownsquareQueryApi",
                    "kind": "LinkedField",
                    "name": "townsquare",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "TownsquareWorkspaceConnection",
                            "kind": "LinkedField",
                            "name": "allWorkspacesForOrg",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareWorkspaceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareWorkspace",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1f087b092d04fae3500eb388cb13b128433088d13aee1dd5bda1fd57d932b1ba",
            "metadata": {},
            "name": "mainGoalsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$25d0d7d36e312091$var$node.hash = "d50a544b76c5c81094a02351bd1dd9ff";
var $25d0d7d36e312091$export$2e2bcd8739ae039 = $25d0d7d36e312091$var$node;

});

parcelRegister("4vwmk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('60Mfg')
        ]);
        const value = parcelRequire('bioJd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("60Mfg")
    ]).then(()=>parcelRequire('bioJd'));
}

});



parcelRegister("gJNrI", function(module, exports) {

$parcel$export(module.exports, "useGoalsField", () => $83d9a8d46f5a8485$export$c45dcf2640399301);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $a9yKi = parcelRequire("a9yKi");

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $dWLk9 = parcelRequire("dWLk9");

var $4Tdfn = parcelRequire("4Tdfn");
const $83d9a8d46f5a8485$export$c45dcf2640399301 = ({ fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const getDataId = (0, $eUqFw.useCallback)(// issueId can be undefined so passing this in after the saveField check to avoid TS error and ensure we actually have a valid value
    (typeName, issue)=>(0, $4Tdfn.default)({
            id: (0, $a9yKi.JiraIssuefieldvalueAri).create({
                siteId: cloudId,
                issueId: issue.toString(),
                fieldId: fieldKey
            }).toString()
        }, typeName), [
        cloudId,
        fieldKey
    ]);
    const saveField = (0, $eUqFw.useCallback)((_iKey, _fKey, valuesForOperation)=>{
        (0, $iWLL0.commitLocalUpdate)(environment, (store)=>{
            if (!issueId) return;
            const dataID = getDataId('JiraGoalsField', issueId);
            if (!dataID) return;
            const goalsField = store.get(dataID);
            if (!goalsField) return;
            const connection = (0, $cNy9K.ConnectionHandler).getConnection(goalsField, 'issue_view_goals_field_selectedGoals');
            if (connection == null) return;
            let edges = connection.getLinkedRecords('edges');
            if (!edges || edges.length === 0) {
                const newGoalDataId = getDataId('JiraGoalsField:selectedGoals(first:1):edges:0', issueId);
                if (!newGoalDataId) return;
                const newEdge = (0, $cNy9K.ConnectionHandler).createEdge(store, connection, store.create(newGoalDataId, 'JiraGoal'), 'JiraGoalEdge');
                (0, $cNy9K.ConnectionHandler).insertEdgeBefore(connection, newEdge);
                edges = connection.getLinkedRecords('edges');
            }
            if (!edges) return;
            // We should only ever have one edge
            const node = edges[0].getLinkedRecord('node');
            if (valuesForOperation.totalCount === 0) {
                const nodeId = node?.getDataID();
                const edgeId = edges[0].getDataID();
                if (!nodeId || !edgeId) return;
                // delete both the node and the edge to avoid invariant violations
                store.delete(nodeId);
                store.delete(edgeId);
                // Clear the connection to avoid invariant violations
                connection.setLinkedRecords([], 'edges');
            } else {
                node?.setValue(valuesForOperation.goals[0].id, 'id');
                node?.setValue(valuesForOperation.goals[0].name, 'name');
                node?.setValue(valuesForOperation.goals[0].status, 'status');
            }
            // We _should_ alway require the count to update
            connection?.setValue(valuesForOperation.totalCount, 'totalCount');
        });
        return Promise.resolve(undefined);
    }, [
        environment,
        getDataId,
        issueId
    ]);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: (0, $lO4Or.GOALS_CF_TYPE),
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        fieldKey: fieldKey,
        saveField: saveField
    });
    return [
        {
            error: error,
            value: value
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("a9yKi", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $c3b9111abe2b905b$export$828c4931ae562af7);

var $dq90x = parcelRequire("dq90x");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issuefieldvalue/manifest.ts
var $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dq90x.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $dq90x.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $c3b9111abe2b905b$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $c3b9111abe2b905b$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("dq90x", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $969ccd5f0840c244$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $969ccd5f0840c244$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $969ccd5f0840c244$export$39e9358142fbbc64 = "jira", $969ccd5f0840c244$export$f9e57427271adc95 = "issuefieldvalue";

});


parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: (0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? analyticsFieldTypeAlias ?? fieldType : fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(async (fieldValue, event)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            // eslint-disable-next-line jira/wrm/no-load-bridge
            await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'backlogScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $a61MH.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $ggKAj.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $heB5U.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});



parcelRegister("b5xtc", function(module, exports) {

$parcel$export(module.exports, "AssociateFieldPopup", () => $a8b42db640d93b3a$export$bd4255b1f989bfbd);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $kQAZu = parcelRequire("kQAZu");

var $atJIB = parcelRequire("atJIB");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fM3rC = parcelRequire("fM3rC");
const $a8b42db640d93b3a$var$POPUP_OFFSET = [
    -8,
    8
];
const $a8b42db640d93b3a$export$bd4255b1f989bfbd = ({ isOpen: isOpen, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName, onClose: onClose })=>{
    const project = (0, $kQAZu.useProject)();
    const { associate: associate } = (0, $atJIB.useAssociateField)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const canAssociateField = project.permissions.administerProject && project.isSimplified && issueType !== undefined && issueTypeId !== undefined;
    const popupTrigger = (0, $eUqFw.useCallback)(({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: ref,
            xcss: $a8b42db640d93b3a$var$triggerStyles
        }), []);
    const onAssociateField = (0, $eUqFw.useCallback)(()=>{
        associate({
            input: {
                projectId: String(project.id),
                fieldId: fieldId,
                issueTypeIds: [
                    Number(issueTypeId)
                ]
            },
            fieldName: fieldName,
            issueType: issueType,
            showSuccess: true,
            analyticsAttributes: {
                source: 'business-list.shared.fields.goals-cell'
            }
        });
        onClose();
    }, [
        associate,
        fieldId,
        fieldName,
        issueType,
        issueTypeId,
        onClose,
        project.id
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.100",
            xcss: $a8b42db640d93b3a$var$popupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $fM3rC.default).associateGoalsFieldBody, {
            issueType: issueType,
            fieldName: fieldName,
            bold: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, chunk)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, canAssociateField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onAssociateField,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $fM3rC.default).updateFieldAssociationAction)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: "/secure/ContactAdministrators!default.jspa",
            target: "_blank",
            onClick: onClose,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $fM3rC.default).contactAdmin))))), [
        canAssociateField,
        fieldName,
        formatMessage,
        issueType,
        onAssociateField,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        content: content,
        trigger: popupTrigger,
        offset: $a8b42db640d93b3a$var$POPUP_OFFSET,
        placement: "bottom-start",
        onClose: onClose
    });
};
const $a8b42db640d93b3a$var$popupStyles = (0, $1ZAYh.xcss)({
    width: '300px',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $a8b42db640d93b3a$var$triggerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%'
});

});
parcelRegister("atJIB", function(module, exports) {

$parcel$export(module.exports, "useAssociateField", () => $11384c76da356129$export$b4b274ed0d9c5388);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $1TrzF = parcelRequire("1TrzF");
var $6F6Wi = parcelRequire("6F6Wi");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $132VC = parcelRequire("132VC");

var $iUDvK = parcelRequire("iUDvK");

var $7OOQG = parcelRequire("7OOQG");
const $11384c76da356129$export$c18a1e642576984f = (0, $eo17r.toFlagId)('associate-field-error-flag');
const $11384c76da356129$export$5122d1806ca6643c = (0, $eo17r.toFlagId)('associate-field-success-flag');
const $11384c76da356129$export$a2a68c9b88c306f0 = (0, $eo17r.toFlagId)('refetch-fields-error-flag');
const $11384c76da356129$export$b4b274ed0d9c5388 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const { associate: associate, loading: loading, error: error } = (0, $132VC.useAssociateField)();
    const { refetchFields: refetchFields } = (0, $6F6Wi.useRefetchFields)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // the BE has a limitation where it cannot handle multiple associate calls in flight so we need a queue
    const [{ associateQueue: associateQueue }, { setAssociateQueue: setAssociateQueue, associate: associateStore, addToAssociateQueue: addToAssociateQueue }] = (0, $iUDvK.useAssociateFieldStore)();
    const associateField = (0, $eUqFw.useCallback)(({ input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess = false, analyticsAttributes: analyticsAttributes })=>new Promise((resolve, reject)=>{
            addToAssociateQueue({
                resolve: resolve,
                reject: reject,
                fieldProps: {
                    input: input,
                    fieldName: fieldName,
                    issueType: issueType,
                    showSuccess: showSuccess,
                    analyticsAttributes: analyticsAttributes
                }
            });
        }), [
        addToAssociateQueue
    ]);
    const associateNextInQueue = (0, $eUqFw.useCallback)(async ()=>{
        if (associateQueue.length === 0) return;
        const [{ resolve: resolve, reject: reject, fieldProps: { input: input, fieldName: fieldName, issueType: issueType, showSuccess: showSuccess, analyticsAttributes: analyticsAttributes = {} } }] = associateQueue;
        setAssociateQueue(associateQueue.splice(1)); // returns new array by keeping the first one only
        dismissFlag(`${$11384c76da356129$export$c18a1e642576984f}-${input.fieldId}`);
        dismissFlag(`${$11384c76da356129$export$a2a68c9b88c306f0}-${input.fieldId}`);
        const result = await associate({
            input: input
        });
        if (!result?.data?.jira?.jwmAssociateField?.success) {
            showFlag({
                id: `${$11384c76da356129$export$c18a1e642576984f}-${input.fieldId}`,
                type: 'error',
                title: formatMessage((0, $7OOQG.default).associateFieldErrorTitleV2, {
                    fieldName: fieldName
                }),
                description: (0, $7OOQG.default).associateFieldErrorMessageV2,
                actions: [
                    {
                        content: (0, $7OOQG.default).associateFieldTryAgainAction,
                        onClick: ()=>{
                            associateField({
                                input: input,
                                fieldName: fieldName,
                                issueType: issueType,
                                showSuccess: showSuccess,
                                analyticsAttributes: analyticsAttributes
                            });
                        }
                    }
                ]
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'associate failed', analyticsAttributes);
            reject(new Error('Associate field mutation did not succeed'));
            return;
        }
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'field associated', analyticsAttributes);
        if (showSuccess) showFlag({
            id: $11384c76da356129$export$5122d1806ca6643c,
            type: 'success',
            title: (0, $7OOQG.default).successTitle,
            description: [
                (0, $7OOQG.default).successDescription,
                {
                    fieldName: fieldName,
                    issueType: issueType,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                            as: "strong"
                        }, chunks)
                }
            ]
        });
        try {
            await refetchFields({
                shouldRetry: ([response])=>!(0, $1TrzF.isFieldInResponse)({
                        response: response,
                        fieldId: input.fieldId
                    })
            });
        } catch (e) {
            showFlag({
                id: `${$11384c76da356129$export$a2a68c9b88c306f0}-${input.fieldId}`,
                type: 'error',
                title: formatMessage((0, $7OOQG.default).refetchFieldsErrorTitle, {
                    fieldName: fieldName
                }),
                description: (0, $7OOQG.default).refetchFieldsErrorMessage
            });
            reject(e);
            return;
        }
        resolve(result);
    }, [
        associateQueue,
        setAssociateQueue,
        dismissFlag,
        associate,
        createAnalyticsEvent,
        showFlag,
        formatMessage,
        associateField,
        refetchFields
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (associateQueue.length > 0) associateStore(associateNextInQueue);
    }, [
        associateQueue,
        associateNextInQueue,
        associateStore
    ]);
    return {
        associate: associateField,
        loading: loading,
        error: error
    };
};

});
parcelRegister("1TrzF", function(module, exports) {

$parcel$export(module.exports, "isFieldInResponse", () => $3f712f92dfb75314$export$c323cb8dc752a295);
const $3f712f92dfb75314$export$c323cb8dc752a295 = ({ fieldId: fieldId, response: response })=>{
    const field = (response.data.jiraBusinessAvailableFields?.edges ?? []).find((issueTypeEdge)=>issueTypeEdge?.node?.fields?.edges?.find((fieldEdge)=>fieldEdge?.node?.fieldId === fieldId));
    return !!field;
};

});

parcelRegister("132VC", function(module, exports) {

$parcel$export(module.exports, "useAssociateField", () => $63e5d8bcf57ae6d0$export$b4b274ed0d9c5388);

var $iZuDo = parcelRequire("iZuDo");

var $kkYfO = parcelRequire("kkYfO");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $eZo0a = parcelRequire("eZo0a");

var $fYtpD = parcelRequire("fYtpD");

var $6vFyR = parcelRequire("6vFyR");
const $63e5d8bcf57ae6d0$export$a93d8cd30a94ee3a = 'associateJwmFieldMutation';
const $63e5d8bcf57ae6d0$var$findMutationBadRequestError = (data)=>data?.jira?.jwmAssociateField?.errors?.find((e)=>e.message);
const $63e5d8bcf57ae6d0$export$b4b274ed0d9c5388 = ()=>{
    const onExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $fYtpD.ASSOCIATE_FIELD_EXPERIENCE));
    const onExperienceFail = (0, $4G5xU.useExperienceFail)((0, $fYtpD.ASSOCIATE_FIELD_EXPERIENCE));
    const onExperienceStart = (0, $4G5xU.useExperienceStart)((0, $fYtpD.ASSOCIATE_FIELD_EXPERIENCE));
    const [associateField, { loading: loading, error: error }] = (0, $iZuDo.useMutation)((0, $6vFyR.QUERY), {
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: $63e5d8bcf57ae6d0$export$a93d8cd30a94ee3a,
                    packageName: 'jiraBusinessInlineFieldConfigSidebar',
                    teamName: 'jira-warepil'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                attributes: {
                    message: 'Failed to associate the field with issue types'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onExperienceFail('Failed to associate the field with issue types', apolloError);
        },
        onCompleted: (apolloData)=>{
            const mutationBadRequestError = $63e5d8bcf57ae6d0$var$findMutationBadRequestError(apolloData);
            if (mutationBadRequestError) {
                const isClientError = (0, $eZo0a.isClientErrorResponse)(mutationBadRequestError.extensions?.statusCode);
                isClientError ? onExperienceSuccess() : onExperienceFail('Failed to associate the field with issue types', new (0, $kkYfO.MutationError)(mutationBadRequestError));
            } else onExperienceSuccess();
        }
    });
    const associate = ({ input: input })=>{
        onExperienceStart();
        return associateField({
            variables: {
                input: input
            }
        });
    };
    return {
        associate: associate,
        loading: loading,
        error: error
    };
};

});
parcelRegister("eZo0a", function(module, exports) {

$parcel$export(module.exports, "isClientErrorResponse", () => $172434d10a1c37f0$export$fa1f4b2a472e138c);
const $172434d10a1c37f0$export$fa1f4b2a472e138c = (statusCode)=>statusCode && statusCode >= 400 && statusCode < 500 || false;

});

parcelRegister("fYtpD", function(module, exports) {

$parcel$export(module.exports, "availableFieldTypes", () => $6d86bf388d162246$export$93dbaa9aec3844f0);
$parcel$export(module.exports, "CREATE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$9eae0a16f5941351);
$parcel$export(module.exports, "ASSOCIATE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$335bd3f229a4665a);
$parcel$export(module.exports, "DELETE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$d7cc90452cff4bb3);
$parcel$export(module.exports, "UPDATE_FIELD_EXPERIENCE", () => $6d86bf388d162246$export$64421f268399035e);
$parcel$export(module.exports, "GET_FIELDS_CONFIGURATION_EXPERIENCE", () => $6d86bf388d162246$export$88bd6cc0b5f8c349);
$parcel$export(module.exports, "GET_FIELD_DETAILS_EXPERIENCE", () => $6d86bf388d162246$export$e6582dde0a4e6af7);

var $lO4Or = parcelRequire("lO4Or");

var $i5GAI = parcelRequire("i5GAI");
const $6d86bf388d162246$var$operations = {
    ...(0, $i5GAI.defaultFieldOperations),
    canModifyDefaultValue: false
};
const $6d86bf388d162246$export$93dbaa9aec3844f0 = [
    {
        key: (0, $lO4Or.TEXT_CF_TYPE),
        name: 'Short text',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.TEXT_AREA_CF_TYPE),
        name: 'Paragraph',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.DATETIME_CF_TYPE),
        name: 'Timestamp',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.SELECT_CF_TYPE),
        name: 'Dropdown',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.DATE_CF_TYPE),
        name: 'Date',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.NUMBER_CF_TYPE),
        name: 'Number',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.LABELS_CF_TYPE),
        name: 'Labels',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        name: 'Checkbox',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.PEOPLE_CF_TYPE),
        name: 'People',
        operations: $6d86bf388d162246$var$operations
    },
    {
        key: (0, $lO4Or.URL_CF_TYPE),
        name: 'Url',
        operations: $6d86bf388d162246$var$operations
    }
];
const $6d86bf388d162246$export$b8b9d90f9e5bd72b = 'jiraBusinessInlineFieldConfigSidebar';
const $6d86bf388d162246$export$9eae0a16f5941351 = {
    experience: 'createField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$335bd3f229a4665a = {
    experience: 'associateField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$d7cc90452cff4bb3 = {
    experience: 'deleteField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$64421f268399035e = {
    experience: 'updateField',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$88bd6cc0b5f8c349 = {
    experience: 'getFieldsConfiguration',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};
const $6d86bf388d162246$export$e6582dde0a4e6af7 = {
    experience: 'getFieldDetails',
    packageName: $6d86bf388d162246$export$b8b9d90f9e5bd72b,
    teamName: 'jira-warepil'
};

});
parcelRegister("i5GAI", function(module, exports) {

$parcel$export(module.exports, "defaultFieldOperations", () => $c180812904bb8272$export$bb18a87f410b7baf);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");
var $6bYiA = parcelRequire("6bYiA");

var $fiPxc = parcelRequire("fiPxc");
var $irB1C = parcelRequire("irB1C");

var $gzgf1 = parcelRequire("gzgf1");
const $c180812904bb8272$export$633d62026658d389 = [
    {
        origin: {
            appKey: 'com.saffron',
            originId: 'ASSET_1'
        },
        label: {
            value: 'Laptop'
        }
    },
    {
        origin: {
            appKey: 'com.saffron',
            originId: 'ASSET_4'
        },
        label: {
            value: 'Phone'
        }
    },
    {
        origin: {
            appKey: 'com.saffron',
            originId: 'ASSET_3'
        },
        label: {
            value: 'Tablet'
        }
    }
];
const $c180812904bb8272$export$253d647b6a0f076c = {
    key: 'jira-platform',
    name: 'Jira'
};
const $c180812904bb8272$export$bb18a87f410b7baf = {
    editable: true,
    canModifyRequired: true,
    canModifyOptions: true,
    canModifyDefaultValue: true,
    canModifyPropertyConfiguration: true,
    removable: true,
    categoriesWhitelist: [],
    canAssociateInSettings: true,
    deletable: true
};
const $c180812904bb8272$export$5d98f0df6c5b1cc5 = 'my-field-category';
const $c180812904bb8272$export$d792f0775198b54d = {
    type: (0, $lO4Or.NUMBER_CF_TYPE),
    custom: false,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0010',
    description: 'valid field description',
    name: 'Coconut chocolate',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$81815df80ae160d0 = {
    type: (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
    custom: true,
    global: false,
    key: 'validAffectedServicesField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeefoo0d',
    description: 'valid affected services description',
    name: 'Le services',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$17fc0a47da34544a = (name)=>({
        key: `mock-field-${name}`,
        externalUuid: name,
        name: name,
        type: name,
        custom: false,
        global: true,
        description: '',
        operations: {
            editable: true,
            canModifyRequired: true,
            canModifyOptions: true,
            canModifyDefaultValue: true,
            canModifyPropertyConfiguration: true,
            removable: true,
            categoriesWhitelist: [],
            canAssociateInSettings: true,
            deletable: false
        },
        provider: $c180812904bb8272$export$253d647b6a0f076c,
        availability: null
    });
const $c180812904bb8272$export$2f380d3f7e3fe5f2 = {
    type: (0, $lO4Or.ASSETS_CF_TYPE),
    custom: true,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef000e',
    description: 'valid field description',
    name: 'Laptops',
    category: 'category-1',
    required: false,
    operations: {
        editable: true,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: true
    },
    configuration: {
        assetTypes: []
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$65bc3e250c89c0e4 = {
    key: 'assignee',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0001',
    name: 'Assignee',
    type: 'assignee',
    custom: false,
    global: true,
    description: '',
    operations: {
        editable: false,
        canModifyRequired: false,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: false
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$1479adc0ff9fcde1 = {
    ...$c180812904bb8272$export$65bc3e250c89c0e4,
    custom: false,
    global: false,
    required: false,
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5
};
const $c180812904bb8272$export$c77e9a710d3e105f = (0, $irB1C.getLayoutItemFromAssociatedField)($c180812904bb8272$export$1479adc0ff9fcde1);
const $c180812904bb8272$export$4405290a0d691d5b = {
    type: (0, $lO4Or.TEXT_CF_TYPE),
    custom: false,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0011',
    description: 'valid field description',
    name: 'Coconut chocolate description',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$370d47912bf58482 = {
    type: (0, $6bYiA.DESCRIPTION_FIELD_TYPE),
    custom: false,
    global: false,
    key: 'description',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0016',
    description: '',
    name: 'Description',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$a238cb463698c900 = {
    key: 'labels',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0002',
    name: 'Labels',
    type: 'labels',
    custom: false,
    global: false,
    description: '',
    operations: {
        editable: false,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: false
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$e380d98d3b75531a = {
    ...$c180812904bb8272$export$a238cb463698c900,
    custom: false,
    global: false,
    required: false,
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5
};
const $c180812904bb8272$export$a8b9380833dc90db = {
    ...$c180812904bb8272$export$e380d98d3b75531a,
    defaultValue: 'Smurf, DarthVader'
};
const $c180812904bb8272$export$ebcf05b97fc1fa6c = (0, $irB1C.getLayoutItemFromAssociatedField)($c180812904bb8272$export$e380d98d3b75531a);
const $c180812904bb8272$export$ce5c30be6f637d4d = [
    {
        value: 'Vanilla',
        id: 1,
        optimisticId: '1',
        externalUuid: '11111111-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Chocolate',
        id: 2,
        optimisticId: '2',
        externalUuid: '22222222-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Smurf',
        id: 3,
        optimisticId: '3',
        externalUuid: '33333333-c80a-4c6d-3c3c-12345678abcd'
    }
];
const $c180812904bb8272$export$3c9e25a71acedbf4 = {
    type: (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    options: $c180812904bb8272$export$ce5c30be6f637d4d,
    custom: true,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0012',
    description: 'validField description',
    name: 'Ice cream flavor',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$7603d369ea612197 = [
    {
        value: 'Russia',
        id: 1,
        optimisticId: '1',
        externalUuid: '11111111-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Australia',
        id: 2,
        optimisticId: '2',
        externalUuid: '22222222-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Moscow',
        id: 3,
        parentId: 1,
        parentExternalUuid: '11111111-1a1a-2b2b-3c3c-12345678abcd',
        optimisticId: '3',
        externalUuid: '11112222-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Saint-Petersburg',
        id: 4,
        parentId: 1,
        parentExternalUuid: '11111111-1a1a-2b2b-3c3c-12345678abcd',
        optimisticId: '4',
        externalUuid: '11113333-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Sydney',
        id: 5,
        parentId: 2,
        parentExternalUuid: '22222222-1a1a-2b2b-3c3c-12345678abcd',
        optimisticId: '5',
        externalUuid: '22224444-1a1a-2b2b-3c3c-12345678abcd'
    },
    {
        value: 'Brisbane',
        id: 6,
        parentId: 2,
        parentExternalUuid: '22222222-1a1a-2b2b-3c3c-12345678abcd',
        optimisticId: '6',
        externalUuid: '22225555-1a1a-2b2b-3c3c-12345678abcd'
    }
];
const $c180812904bb8272$export$b9219aeff7222dce = {
    type: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
    options: $c180812904bb8272$export$7603d369ea612197,
    custom: true,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0012',
    description: 'validField description',
    name: 'Ice cream flavor',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$9e3fa07f4bce8787 = {
    type: (0, $lO4Or.DATE_CF_TYPE),
    custom: false,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0015',
    description: 'valid field description',
    name: 'Coconut chocolate',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$f0eed5a0dd5a5e10 = {
    ...$c180812904bb8272$export$9e3fa07f4bce8787,
    defaultValue: {
        useCurrentDate: true
    }
};
const $c180812904bb8272$export$671a1c8e1401ab09 = {
    ...$c180812904bb8272$export$9e3fa07f4bce8787,
    defaultValue: {
        fixedDate: '2020-08-02'
    }
};
const $c180812904bb8272$export$8a91de05ac729b08 = {
    type: (0, $lO4Or.DATETIME_CF_TYPE),
    custom: false,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0014',
    description: 'valid field description',
    name: 'Coconut chocolate',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$71557047364262e6 = {
    ...$c180812904bb8272$export$8a91de05ac729b08,
    defaultValue: {
        useCurrentTime: true
    }
};
const $c180812904bb8272$export$a26fac1726a3c1c = {
    ...$c180812904bb8272$export$8a91de05ac729b08,
    defaultValue: {
        fixedTime: '2020-08-03T09:30+1000'
    }
};
const $c180812904bb8272$export$a022a846d1d2ddae = {
    version: 1,
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: 'Place the coconut cream, white chocolate and salt in a heat- proof bowl over a saucepan half-filled with simmering water. Stir occasionally until the chocolate melts and the mixture is smooth. Remove from the heat and stir in the Malibu. Place in the fridge until firm enough to scoop (around 2 hours).'
                }
            ]
        }
    ]
};
const $c180812904bb8272$var$mockEmptyState = (message)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiPxc.default), {
            ...props,
            emptyStateText: (0, $gzgf1.mockMessageDescriptor)(message)
        });
const $c180812904bb8272$export$b6234c67914b568a = {
    name: 'example-category',
    displayName: (0, $gzgf1.mockMessageDescriptor)('Field category'),
    emptyStateText: (0, $gzgf1.mockMessageDescriptor)('There is nothing here'),
    categoryEmptyState: $c180812904bb8272$var$mockEmptyState('There is still nothing here but now in smaller font'),
    allowRequiredField: true,
    allowFieldAlias: false,
    allowFieldAliasEditing: false,
    allowedLayoutItems: []
};
const $c180812904bb8272$export$edcc6f9abf17a3df = {
    ...$c180812904bb8272$export$b6234c67914b568a,
    name: 'secondary',
    displayName: (0, $gzgf1.mockMessageDescriptor)('Field category 2')
};
const $c180812904bb8272$export$dca5b14f7963b6f9 = [
    $c180812904bb8272$export$b6234c67914b568a,
    $c180812904bb8272$export$edcc6f9abf17a3df
];
const $c180812904bb8272$export$540515d000b9c248 = {
    type: (0, $lO4Or.PEOPLE_CF_TYPE),
    custom: true,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef000e',
    description: 'valid field description',
    name: 'Magicians',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: {
        editable: true,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: true
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$e354eabab248d7cf = {
    ...$c180812904bb8272$export$540515d000b9c248,
    defaultValue: [
        {
            id: '#4321',
            name: 'Harry Potter',
            avatarUrl: ''
        },
        {
            id: '#12345',
            name: 'Voldemort'
        }
    ]
};
const $c180812904bb8272$export$7d1feb9b2c381acf = {
    type: (0, $6bYiA.TEXT_AREA_CF_TYPE),
    custom: true,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0016',
    description: '',
    name: 'Paragraph',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$9446b57ab43d95f9 = {
    type: (0, $6bYiA.ENVIRONMENT_FIELD_TYPE),
    custom: false,
    global: false,
    key: 'environment',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0016',
    description: '',
    name: 'Environment',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$ececa01d255db7bf = {
    type: (0, $lO4Or.VERSION_CF_TYPE),
    custom: true,
    global: false,
    key: 'vegemiteVersionField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0027',
    description: 'valid version description',
    name: 'Vegemite on toast',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$719069316920e397 = {
    type: (0, $lO4Or.MULTI_VERSION_CF_TYPE),
    custom: true,
    global: false,
    key: 'meatPieMultipleVersionField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0028',
    description: 'valid multi version description',
    name: 'Meat pies',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$12fb2c9ad36f331f = {
    type: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    options: $c180812904bb8272$export$ce5c30be6f637d4d,
    custom: true,
    global: false,
    key: 'MULTI_CHECKBOXES_CF_TYPE',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0013',
    description: 'MULTI_CHECKBOXES_CF_TYPE description',
    name: 'Ice cream flavor',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$6f83b1f2588c8366 = {
    type: (0, $lO4Or.SELECT_CF_TYPE),
    options: $c180812904bb8272$export$ce5c30be6f637d4d,
    custom: true,
    global: false,
    key: 'dropdown-field',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0012',
    description: 'validField description',
    name: 'Ice cream flavor',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: $c180812904bb8272$export$bb18a87f410b7baf,
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$67154cec08ca00eb = {
    type: (0, $lO4Or.GROUP_CF_TYPE),
    custom: true,
    global: false,
    key: 'group-picker-field',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0017',
    description: 'valid group picker description',
    name: 'Fairy bread',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: {
        editable: true,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: true
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$9e9a9a785c6ce31e = {
    type: (0, $lO4Or.MULTI_GROUP_CF_TYPE),
    custom: true,
    global: false,
    key: 'validField',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0018',
    description: 'valid multi group picker description',
    name: 'Lamingtons',
    category: $c180812904bb8272$export$5d98f0df6c5b1cc5,
    required: false,
    operations: {
        editable: true,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: true
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$66a3bfe05f818d21 = {
    key: 'reporter',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0001',
    name: 'Reporter',
    type: 'reporter',
    custom: false,
    global: false,
    description: '',
    operations: {
        editable: false,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: false
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$da5b63bb5f06c4fb = {
    key: 'priority',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0002',
    name: 'Priority',
    type: 'priority',
    custom: false,
    global: false,
    description: '',
    operations: {
        editable: false,
        canModifyRequired: true,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: false
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$6d3a672f3669644e = {
    ...$c180812904bb8272$export$da5b63bb5f06c4fb,
    category: 'category-1',
    required: false
};
const $c180812904bb8272$export$2ab9032c120ceabe = {
    key: 'duedate',
    externalUuid: 'deadbeef-dead-4ead-beef-deadbeef0004',
    name: 'Due date',
    type: 'duedate',
    custom: false,
    global: false,
    description: '',
    operations: {
        editable: true,
        canModifyRequired: false,
        canModifyOptions: true,
        canModifyDefaultValue: true,
        canModifyPropertyConfiguration: true,
        removable: true,
        categoriesWhitelist: [],
        canAssociateInSettings: true,
        deletable: false
    },
    provider: $c180812904bb8272$export$253d647b6a0f076c,
    availability: null
};
const $c180812904bb8272$export$45f9ec203371b878 = {
    field: $c180812904bb8272$export$ececa01d255db7bf,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onUpdate: ()=>{},
    layoutOwners: [],
    projectId: '',
    projectKey: '',
    fieldErrors: [],
    limits: {
        optionsPerField: 10
    },
    extraDefinerId: null
};

});
parcelRegister("fiPxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $711ad39c8a845377$export$2e2bcd8739ae039);

var $2qhQi = parcelRequire("2qhQi");

var $bMUZC = parcelRequire("bMUZC");
var $711ad39c8a845377$export$2e2bcd8739ae039 = (0, $2qhQi.default)((0, $bMUZC.default));

});
parcelRegister("bMUZC", function(module, exports) {

$parcel$export(module.exports, "EmptyStateMessage", () => $cc536834aff71fcd$export$11e5ba4f4669e663);
$parcel$export(module.exports, "default", () => $cc536834aff71fcd$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $awhAC = parcelRequire("awhAC");
const $cc536834aff71fcd$export$11e5ba4f4669e663 = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc536834aff71fcd$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc536834aff71fcd$var$ImageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awhAC.UpdatedEmptyImg), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc536834aff71fcd$var$Text, null, message));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cc536834aff71fcd$export$2e2bcd8739ae039 = ({ emptyStateText: emptyStateText, intl: intl, issueTypeName: issueTypeName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cc536834aff71fcd$export$11e5ba4f4669e663, {
        message: intl.formatMessage(emptyStateText, {
            issueTypeName: issueTypeName
        })
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc536834aff71fcd$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _p12fdgin _19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt4u2gc _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $cc536834aff71fcd$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1b66 _syaz2l1e",
            __cmplp.className
        ])
    });
});
const $cc536834aff71fcd$var$ImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgx0z",
            __cmplp.className
        ])
    });
});

});
parcelRegister("awhAC", function(module, exports) {

$parcel$export(module.exports, "UpdatedEmptyImg", () => $c8df65d0b55a20bb$export$37cdcaed3454078a);

var $eUqFw = parcelRequire("eUqFw");
const $c8df65d0b55a20bb$export$37cdcaed3454078a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 262 99"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M139 36h119c1.7 0 3 1.3 3 3v21c0 1.7-1.3 3-3 3H139c-1.7 0-3-1.3-3-3V39c0-1.7 1.3-3 3-3zM4 1h119c1.7 0 3 1.3 3 3v91c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z",
        fill: "var(--ds-background-input, white)",
        stroke: "var(--ds-border-accent-gray, #97a0af)",
        strokeLinecap: "round",
        strokeDasharray: "2,4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M139 1h119c1.7 0 3 1.3 3 3v21c0 1.7-1.3 3-3 3H139c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3zm0 70h119c1.7 0 3 1.3 3 3v21c0 1.7-1.3 3-3 3H139c-1.7 0-3-1.3-3-3V74c0-1.7 1.3-3 3-3z",
        fill: "var(--ds-background-accent-gray-subtlest, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M59,18c-1.7,0-3,1.3-3,3v21c0,1.7,1.3,3,3,3h119c1.7,0,3-1.3,3-3V21c0-1.7-1.3-3-3-3H59z",
        fillRule: "evenodd",
        fill: "var(--ds-background-input, white)",
        stroke: "var(--ds-border-accent-gray, #c1c7d0)",
        strokeWidth: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M171.8 36.5c-.2.1-.3.4-.2.7l2.2 3.9c.1.2.4.3.7.2.2-.1.3-.4.2-.7l-2-3.5 3.5-2c.2-.1.3-.4.2-.7-.1-.2-.4-.3-.7-.2l-3.9 2.3zm15.7 15.4c-.4-4.1-1.3-7.2-3.6-9.7-2.3-2.4-5.9-4.2-11.8-5.8l-.3 1c5.8 1.6 9.2 3.2 11.3 5.5 2.1 2.2 2.9 5 3.3 9.1l1.1-.1z",
        stroke: "var(--ds-icon, #000000)",
        strokeWidth: ".5"
    }));

});



parcelRegister("irB1C", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemFromAssociatedField", () => $c95888317fe42040$export$783d613217361d1a);
$parcel$export(module.exports, "getLayoutItemFromField", () => $c95888317fe42040$export$65e2767ed665abb);

var $gyFYN = parcelRequire("gyFYN");
const $c95888317fe42040$export$783d613217361d1a = (field)=>({
        key: (0, $gyFYN.toLayoutItemKey)((0, $gyFYN.FIELD_LAYOUT_ITEM_TYPE), field.key),
        layoutItemType: (0, $gyFYN.FIELD_LAYOUT_ITEM_TYPE),
        data: field,
        operations: field.operations,
        category: field.category
    });
const $c95888317fe42040$export$65e2767ed665abb = (field)=>({
        key: (0, $gyFYN.toLayoutItemKey)((0, $gyFYN.FIELD_LAYOUT_ITEM_TYPE), field.key),
        layoutItemType: (0, $gyFYN.FIELD_LAYOUT_ITEM_TYPE),
        data: field,
        operations: field.operations,
        category: null
    });

});
parcelRegister("gyFYN", function(module, exports) {

$parcel$export(module.exports, "toFieldType", () => $c735da2c3aa879c8$export$42a45ca5a89c0224);
$parcel$export(module.exports, "PANEL_LAYOUT_ITEM_TYPE", () => $c735da2c3aa879c8$export$14a822b4b8728ff);
$parcel$export(module.exports, "FIELD_LAYOUT_ITEM_TYPE", () => $c735da2c3aa879c8$export$57d657a79733c8ff);
$parcel$export(module.exports, "allowFieldLayoutItem", () => $c735da2c3aa879c8$export$1616501503fc215f);
$parcel$export(module.exports, "toLayoutItemKey", () => $c735da2c3aa879c8$export$d751f7a27494922b);

var $lO4Or = parcelRequire("lO4Or");
var $6bYiA = parcelRequire("6bYiA");
const $c735da2c3aa879c8$var$fieldTypesMap = {
    [(0, $lO4Or.SUMMARY_TYPE)]: (0, $lO4Or.SUMMARY_TYPE),
    [(0, $6bYiA.DESCRIPTION_FIELD_TYPE)]: (0, $6bYiA.DESCRIPTION_FIELD_TYPE),
    [(0, $lO4Or.ATTACHMENT_TYPE)]: (0, $lO4Or.ATTACHMENT_TYPE),
    [(0, $lO4Or.NUMBER_CF_TYPE)]: (0, $lO4Or.NUMBER_CF_TYPE),
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    [(0, $lO4Or.URL_CF_TYPE)]: (0, $lO4Or.URL_CF_TYPE),
    [(0, $lO4Or.TEXT_CF_TYPE)]: (0, $lO4Or.TEXT_CF_TYPE),
    [(0, $6bYiA.TEXT_AREA_CF_TYPE)]: (0, $6bYiA.TEXT_AREA_CF_TYPE),
    [(0, $lO4Or.LABELS_CF_TYPE)]: (0, $lO4Or.LABELS_CF_TYPE),
    [(0, $lO4Or.DATE_CF_TYPE)]: (0, $lO4Or.DATE_CF_TYPE),
    [(0, $lO4Or.DATETIME_CF_TYPE)]: (0, $lO4Or.DATETIME_CF_TYPE),
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    [(0, $lO4Or.SELECT_CF_TYPE)]: (0, $lO4Or.SELECT_CF_TYPE),
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: (0, $lO4Or.MULTI_VERSION_CF_TYPE),
    [(0, $lO4Or.VERSION_CF_TYPE)]: (0, $lO4Or.VERSION_CF_TYPE),
    [(0, $lO4Or.GROUP_CF_TYPE)]: (0, $lO4Or.GROUP_CF_TYPE),
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: (0, $lO4Or.MULTI_GROUP_CF_TYPE),
    [(0, $lO4Or.USER_CF_TYPE)]: (0, $lO4Or.USER_CF_TYPE),
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: (0, $lO4Or.MULTI_USER_CF_TYPE),
    [(0, $lO4Or.FLAGGED_CF_TYPE)]: (0, $lO4Or.FLAGGED_CF_TYPE),
    [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
    [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
    [(0, $lO4Or.ASSETS_CF_TYPE)]: (0, $lO4Or.ASSETS_CF_TYPE),
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: (0, $lO4Or.PEOPLE_CF_TYPE),
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
    [(0, $6bYiA.ENVIRONMENT_FIELD_TYPE)]: (0, $6bYiA.ENVIRONMENT_FIELD_TYPE)
};
const $c735da2c3aa879c8$export$42a45ca5a89c0224 = (strFieldType)=>{
    const fieldType = $c735da2c3aa879c8$var$fieldTypesMap[strFieldType];
    if (!fieldType) throw new Error(`Failed to convert string to FieldType. Invalid field type: ${strFieldType}`);
    return fieldType;
};
const $c735da2c3aa879c8$export$14a822b4b8728ff = 'PANEL';
const $c735da2c3aa879c8$export$57d657a79733c8ff = 'FIELD';
const $c735da2c3aa879c8$export$1616501503fc215f = (type)=>`${$c735da2c3aa879c8$export$57d657a79733c8ff}:${type}`;
const $c735da2c3aa879c8$export$ad2e30fb97b657d9 = (panelId)=>`${$c735da2c3aa879c8$export$14a822b4b8728ff}:${panelId}`;
const $c735da2c3aa879c8$export$d751f7a27494922b = (layoutItemType, dataKey)=>`${layoutItemType}.${dataKey}`;

});


parcelRegister("gzgf1", function(module, exports) {

$parcel$export(module.exports, "mockMessageDescriptor", () => $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89);
const $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89 = (defaultMessage)=>({
        id: `${defaultMessage}.mock-message.do-not-translate`,
        defaultMessage: defaultMessage
    });
const $5c77c50fb9ba7a0e$export$868514690068909 = {
    buttonConfirm: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('buttonConfirm'),
    buttonCancel: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('buttonCancel'),
    modalHeader: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('modalHeader'),
    issueDataWipeWarning: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('issueDataWipeWarning'),
    eventualConsistencyWarning: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('eventualConsistencyWarning'),
    noUndo: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('noUndo'),
    warningWhenOneIssueType: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('warningWhenOneIssueType'),
    warningWhenMultipleIssueTypes: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('warningWhenMultipleIssueTypes')
};
const $5c77c50fb9ba7a0e$export$ad68e102fcbf7255 = {
    issueTypesLink: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('issueTypesLink'),
    addIssueTypeDisabledTooltip: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('addIssueTypeDisabledTooltip')
};
const $5c77c50fb9ba7a0e$export$6e67bee872f4aae7 = {
    editIssueTypeSuccessTitle: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('editIssueTypeSuccessTitle'),
    editIssueTypeSuccessDescription: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('editIssueTypeSuccessDescription'),
    backToProject: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('backToProject'),
    editIssueTypeFailureTitle: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('editIssueTypeFailureTitle'),
    editIssueTypeFailureDescription: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('editIssueTypeFailureDescription'),
    descriptionLabel: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('descriptionLabel'),
    editDescriptionButtonLabel: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('editDescriptionButtonLabel'),
    descriptionPlaceholder: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('descriptionPlaceholder'),
    avatarAlt: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('avatarAlt'),
    avatarAccessibleAlt: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('avatarAccessibleAlt'),
    avatarTooltipContent: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('avatarTooltipContent'),
    avatarAriaLabel: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('avatarAriaLabel'),
    editAvatar: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('editAvatar')
};
const $5c77c50fb9ba7a0e$export$f9fa7471d556c380 = {
    sidebarHelperText: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('sidebarHelperText'),
    removeDropzoneHeader: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('removeDropzoneHeader'),
    removeDropzoneDescription: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('removeDropzoneDescription'),
    noActionFieldToolbarHeader: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('noActionFieldToolbarHeader'),
    noActionFieldToolbarDescription: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('noActionFieldToolbarDescription'),
    noActionFieldToolbarDescriptionAppField: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('noActionFieldToolbarDescriptionAppField'),
    inactiveFieldsEmptyMessage: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('inactiveFieldsEmptyMessage'),
    errorMessageTitle: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('errorMessageTitle'),
    errorMessage: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('errorMessage'),
    refreshButton: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('refreshButton'),
    sharedFieldInfoMessage: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('sharedFieldInfoMessage'),
    sharedFieldDialogMessage: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('sharedFieldDialogMessage'),
    sharedFieldLinkToDocumentationText: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('sharedFieldLinkToDocumentationText')
};
const $5c77c50fb9ba7a0e$export$f7a39081ffd65c = {
    required: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('required'),
    requiredTooltip: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('requiredTooltip'),
    requiredDisabledAndCheckedTooltip: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('requiredDisabledAndCheckedTooltip'),
    requiredDisabledAndUncheckedTooltip: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('requiredDisabledAndUncheckedTooltip'),
    requiredDisabledInAllCategoriesTooltip: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('requiredDisabledInAllCategoriesTooltip'),
    requiredDisabledInCategoryTooltip: $5c77c50fb9ba7a0e$export$d3c5cd19bcaaac89('requiredDisabledInCategoryTooltip')
};

});



parcelRegister("6vFyR", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $f1a258ade8383bbf$export$2b91517d6d5b4365);

var $9ypom = parcelRequire("9ypom");
const $f1a258ade8383bbf$export$2b91517d6d5b4365 = (0, $9ypom.default)`
mutation JwmAssociateField ($input: JiraWorkManagementAssociateFieldInput!) {
  jira {
    jwmAssociateField (input: $input) {
      success
      errors {
        extensions {
          errorType
          statusCode
        }
        message
      }
      associatedIssueTypeIds
    }
  }
}
`;

});


parcelRegister("iUDvK", function(module, exports) {

$parcel$export(module.exports, "useAssociateFieldStore", () => $1ddfb19a3467aac9$export$877fa8e9cadf66c8);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $1ddfb19a3467aac9$var$actions = {
    addAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                associatingFields: [
                    ...getState().associatingFields,
                    fieldId
                ]
            });
        },
    removeAssociatingField: (fieldId)=>({ setState: setState, getState: getState })=>{
            setState({
                associatingFields: getState().associatingFields.filter((assocFieldId)=>fieldId !== assocFieldId)
            });
        },
    setAssociateQueue: (associateQueue)=>({ setState: setState })=>{
            setState({
                associateQueue: associateQueue
            });
        },
    addToAssociateQueue: (itemToAssociate)=>({ setState: setState, getState: getState })=>{
            setState({
                associateQueue: [
                    ...getState().associateQueue,
                    itemToAssociate
                ]
            });
        },
    setIsAssociating: (isAssociating)=>({ setState: setState })=>{
            setState({
                isAssociating: isAssociating
            });
        },
    associate: (associateFunction)=>async ({ setState: setState, getState: getState })=>{
            if (!getState().isAssociating) {
                setState({
                    isAssociating: true
                });
                try {
                    await associateFunction();
                } finally{
                    setState({
                        isAssociating: false
                    });
                }
            }
        }
};
const $1ddfb19a3467aac9$var$Store = (0, $a61MH.createStore)({
    initialState: {
        associatingFields: [],
        associateQueue: [],
        isAssociating: false
    },
    actions: $1ddfb19a3467aac9$var$actions,
    name: 'JwmFieldConfigAssociatingFields'
});
const $1ddfb19a3467aac9$export$877fa8e9cadf66c8 = (0, $ggKAj.createHook)($1ddfb19a3467aac9$var$Store);

});

parcelRegister("7OOQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b599237b85b6d78$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b599237b85b6d78$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    associateFieldErrorTitleV2: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-title-v-2",
        "defaultMessage": "Unable to connect {fieldName} to issue types in this project"
    },
    associateFieldErrorMessageV2: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-error-message-v-2",
        "defaultMessage": "Check your connection, then try again."
    },
    associateFieldTryAgainAction: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.associate-field-try-again-action",
        "defaultMessage": "Try again"
    },
    refetchFieldsErrorTitle: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-title",
        "defaultMessage": "{fieldName} has been associated to issue types in the list view"
    },
    refetchFieldsErrorMessage: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.refetch-fields-error-message",
        "defaultMessage": "Wait a few moments and try refreshing your page to see the change."
    },
    successTitle: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-title",
        "defaultMessage": "Field association updated!"
    },
    successDescription: {
        "id": "business-inline-field-config-sidebar.controllers.associate-field.success-description",
        "defaultMessage": "You can now use the <strong>{fieldName}</strong> field for your <strong>{issueType}</strong> issue type"
    }
});

});


parcelRegister("fM3rC", function(module, exports) {

$parcel$export(module.exports, "default", () => $118fa4dcea501cf8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $118fa4dcea501cf8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    associateGoalsFieldBody: {
        "id": "business-fields.goals.cell.associate-field-popup.associate-goals-field-body",
        "defaultMessage": "The <bold>{fieldName}</bold> field isn't associated with the <bold>{issueType}</bold> issue type."
    },
    contactAdmin: {
        "id": "business-fields.goals.cell.associate-field-popup.contact-admin",
        "defaultMessage": "Contact Admin"
    },
    updateFieldAssociationAction: {
        "id": "business-fields.goals.cell.associate-field-popup.update-field-association-action",
        "defaultMessage": "Update field association"
    }
});

});


parcelRegister("3ylNm", function(module, exports) {

$parcel$export(module.exports, "useIsFieldAssociatedWithIssueType", () => $2931ed16cff628e3$export$cb0b144001cec81a);

var $eUqFw = parcelRequire("eUqFw");

var $gEmpR = parcelRequire("gEmpR");
const $2931ed16cff628e3$export$cb0b144001cec81a = ({ fieldId: fieldId, issueTypeId: issueTypeId })=>{
    const { typesWithFields: typesWithFields } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'VIEW'
    });
    const isFieldAssociated = (0, $eUqFw.useMemo)(()=>{
        if (issueTypeId === undefined) return false;
        const issueTypeFields = typesWithFields.find((type)=>type.issueType.id === issueTypeId)?.fields;
        return issueTypeFields?.some((issueTypeField)=>issueTypeField.id === fieldId) ?? false;
    }, [
        fieldId,
        issueTypeId,
        typesWithFields
    ]);
    return isFieldAssociated;
};

});


parcelRegister("gnGlI", function(module, exports) {

$parcel$export(module.exports, "groupCellHandler", () => $879c3fded9773908$export$b2844c90dc2ccc0f);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $k7Hy6 = parcelRequire("k7Hy6");

var $jhFiz = parcelRequire("jhFiz");
const $879c3fded9773908$export$2f128d21295c820 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [selectedGroups, setSelectedGroups] = (0, $eUqFw.useState)(field?.value ?? null);
    // Updated the value when a new updated is receive it
    (0, $eUqFw.useEffect)(()=>{
        setSelectedGroups(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const isMulti = (0, $eUqFw.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker', [
        field?.type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.group.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k7Hy6.GroupEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        inputValue: inputValue,
        onInputChange: onInputChange,
        isMulti: isMulti,
        fieldName: field?.name || '',
        onChange: setSelectedGroups,
        preferredWidth: preferredWidth,
        selectedGroups: selectedGroups,
        fieldKey: field?.fieldId || '',
        issueKey: issue.key,
        fieldType: field?.type || '',
        initialValue: field?.value ?? null,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhFiz.GroupRead), {
            isEditable: isEditable,
            selectedGroups: selectedGroups
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jhFiz.GroupRead), {
        isEditable: isEditable,
        selectedGroups: selectedGroups
    }));
};
const $879c3fded9773908$export$b2844c90dc2ccc0f = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $879c3fded9773908$export$2f128d21295c820,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $879c3fded9773908$export$2f128d21295c820
};

});
parcelRegister("k7Hy6", function(module, exports) {

$parcel$export(module.exports, "GroupEdit", () => $6535f341a418f83d$export$9036da6562372d3b);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $a6G0F = parcelRequire("a6G0F");
const $6535f341a418f83d$var$entryPointParams = {};
const $6535f341a418f83d$export$9036da6562372d3b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $a6G0F.groupEditEntryPoint), $6535f341a418f83d$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.group.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("a6G0F", function(module, exports) {

$parcel$export(module.exports, "groupEditEntryPoint", () => $9c2e5bf66234ca52$export$20cce7641ad91969);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $9c2e5bf66234ca52$export$20cce7641ad91969 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("7SuZc")), {
        moduleId: "fc335c35"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7SuZc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bq2Jx');
        const value = parcelRequire('axN2v');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bq2Jx").then(()=>parcelRequire('axN2v'));
}

});



parcelRegister("jhFiz", function(module, exports) {

$parcel$export(module.exports, "GroupRead", () => $e6b228423a375a7c$export$d8ab1fa8206677db);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $4TezD = parcelRequire("4TezD");

var $3NqHp = parcelRequire("3NqHp");
const $e6b228423a375a7c$export$d8ab1fa8206677db = ({ selectedGroups: selectedGroups, isEditable: isEditable })=>{
    const group = (0, $eUqFw.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups[0]?.name : selectedGroups?.name, [
        selectedGroups
    ]);
    const count = (0, $eUqFw.useMemo)(()=>Array.isArray(selectedGroups) ? selectedGroups.length - 1 : 0, [
        selectedGroups
    ]);
    if (group == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NqHp.TagListWrapper), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: group
    }), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: `+${count}`
    })));
};

});


parcelRegister("88U8t", function(module, exports) {

$parcel$export(module.exports, "parentCellHandler", () => $f2023e855c089ac9$export$342c67b3a001949f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $DX7su = parcelRequire("DX7su");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $4TezD = parcelRequire("4TezD");

var $fBoZM = parcelRequire("fBoZM");

var $kGTYI = parcelRequire("kGTYI");
const $f2023e855c089ac9$var$transformFieldToParent = (field)=>{
    if (field?.value?.summary == null || field?.value?.issueType == null || field?.value?.issueId == null || field?.value?.issueKey == null) return null;
    return {
        key: field?.value.issueKey,
        value: field?.value?.issueId,
        label: field?.value?.summary,
        fields: {
            summary: field?.value?.summary,
            issuetype: field?.value?.issueType
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: field?.value?.color
    };
};
const $f2023e855c089ac9$export$d5a4cc78f8c5a2cd = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, onIssueUpdated: onIssueUpdated, cellRef: cellRef })=>{
    const [parent, setParent] = (0, $eUqFw.useState)($f2023e855c089ac9$var$transformFieldToParent(field));
    const [{ value: value }] = (0, $DX7su.useParentField)({
        issueKey: (0, $6vrw7.toIssueKey)(issue.key),
        fieldKey: field?.fieldId ?? '',
        issueId: issue.issueId
    });
    if (value && value !== parent && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) setParent(value);
    // Updated the value when a new updated is receive it
    (0, $eUqFw.useEffect)(()=>{
        setParent($f2023e855c089ac9$var$transformFieldToParent(field));
    }, [
        field
    ]);
    const handleChange = (0, $eUqFw.useCallback)((newParent)=>{
        setParent((oldParent)=>{
            if (field != null) onIssueUpdated({
                fieldId: field.fieldId,
                fieldType: field.type,
                issueId: issue.issueId,
                newValue: newParent,
                oldValue: oldParent,
                issueKey: (0, $1ybV0.ff)('list-uses-new-jql-parent-project-directive_v5gfs') ? (0, $6vrw7.toIssueKey)(issue.key) : undefined
            });
            return newParent;
        });
    }, [
        field,
        issue.issueId,
        issue.key,
        onIssueUpdated
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: true
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fBoZM.ParentEdit), {
        parent: parent,
        cellRef: cellRef,
        fieldId: field.fieldId,
        issueKey: issue.key,
        issueId: issue.issueId,
        preferredWidth: preferredWidth,
        onChange: handleChange,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGTYI.ParentRead), {
            parent: parent
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGTYI.ParentRead), {
        parent: parent
    }));
};
const $f2023e855c089ac9$export$342c67b3a001949f = {
    [(0, $lO4Or.PARENT_TYPE)]: $f2023e855c089ac9$export$d5a4cc78f8c5a2cd
};

});
parcelRegister("DX7su", function(module, exports) {

$parcel$export(module.exports, "useParentField", () => $7e16df0745dc2b53$export$23f8a245702eecc6);

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $7e16df0745dc2b53$export$984ebf992eeb92e6 = async (issueKey, fieldKey, newValue)=>(0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                [fieldKey]: newValue && newValue.value ? {
                    id: newValue.value
                } : null
            }
        })
    });
const $7e16df0745dc2b53$export$aee311d2cd3543e6 = (response)=>{
    if (!response?.fields) return null;
    return response.fields.parent;
};
const $7e16df0745dc2b53$export$23f8a245702eecc6 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure } = props;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $lO4Or.PARENT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue, saveById: saveById }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: null,
        saveField: $7e16df0745dc2b53$export$984ebf992eeb92e6,
        mapNonOptimisticResponse: $7e16df0745dc2b53$export$aee311d2cd3543e6
    });
    const valueOption = value || null;
    return [
        {
            value: valueOption,
            fieldConfig: fieldConfig,
            error: error
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchData = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)('/rest/graphql/1/', {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $a61MH.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $a61MH.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $ggKAj.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});



parcelRegister("fBoZM", function(module, exports) {

$parcel$export(module.exports, "ParentEdit", () => $76aa2c2c11e640b6$export$c7e5e7ddde2d8f0);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $lDaL7 = parcelRequire("lDaL7");
const $76aa2c2c11e640b6$var$entryPointParams = {};
const $76aa2c2c11e640b6$export$c7e5e7ddde2d8f0 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $lDaL7.parentEditEntryPoint), $76aa2c2c11e640b6$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.parent.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("lDaL7", function(module, exports) {

$parcel$export(module.exports, "parentEditEntryPoint", () => $3fd04fc0c2231ccd$export$1d2363001ed1e75d);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $3fd04fc0c2231ccd$export$1d2363001ed1e75d = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("bL2TJ")), {
        moduleId: "9c7e10fe"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bL2TJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eDTV5');
        const value = parcelRequire('43A1W');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eDTV5").then(()=>parcelRequire('43A1W'));
}

});



parcelRegister("kGTYI", function(module, exports) {

$parcel$export(module.exports, "ParentRead", () => $219a374b3c6d1258$export$500e192e2d559470);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $e3dJ4 = parcelRequire("e3dJ4");

var $i0H65 = parcelRequire("i0H65");
const $219a374b3c6d1258$export$500e192e2d559470 = ({ parent: parent })=>{
    const { createOpenIssueModalHandler: createOpenIssueModalHandler } = (0, $e3dJ4.useIssueModalActions)();
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        if (parent == null || parent.key == null) return;
        return createOpenIssueModalHandler({
            key: parent.key
        })(e);
    }, [
        createOpenIssueModalHandler,
        parent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $219a374b3c6d1258$var$parentCellStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0H65.ParentViewField), {
        value: parent,
        noValueText: "",
        isMobile: false,
        onClick: handleClick
    }));
};
const $219a374b3c6d1258$var$parentCellStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%'
});

});
parcelRegister("i0H65", function(module, exports) {

$parcel$export(module.exports, "ParentViewField", () => $ef6f97e64b612d5b$export$51036c707862fc9f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $3K8W2 = parcelRequire("3K8W2");

var $iSEc1 = parcelRequire("iSEc1");
const $ef6f97e64b612d5b$var$Summary = ({ isMobile: isMobile, onClick: onClick, label: label, lozengeTheme: lozengeTheme, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$WrapperNoClick, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: lozengeTheme
    }, label);
    if (onClick != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ButtonText, {
        onClick: onClick,
        style: lozengeTheme
    }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$LinkText, {
        "data-testid": "issue-field-parent.ui.view-link",
        href: `/browse/${issueKey}`,
        "aria-label": formatMessage((0, $iSEc1.default).parentTitle, {
            label: label
        }),
        style: lozengeTheme
    }, label);
};
const $ef6f97e64b612d5b$var$ParentViewFieldNew = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $3K8W2.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $iSEc1.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Summary, {
            isMobile: isMobile,
            label: label,
            lozengeTheme: style,
            onClick: onClick,
            issueKey: key
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, noValueText);
};
const $ef6f97e64b612d5b$var$ParentViewFieldOld = (props)=>{
    const { value: value, noValueText: noValueText, isMobile: isMobile } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (value) {
        const { key: key, fields: fields } = value;
        const label = `${key} ${fields.summary}`;
        const style = value.color ? (0, $3K8W2.getLozengeThemeByColor)(value.color) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: label,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Container, {
            "data-testid": "issue-field-parent.ui.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$Icon, {
            src: fields.issuetype.iconUrl,
            alt: formatMessage((0, $iSEc1.default).icon, {
                issueType: fields?.issuetype.name || ''
            })
        }), isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$WrapperNoClick // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: style
        }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$LinkText, {
            "data-testid": "issue-field-parent.ui.view-link",
            href: `/browse/${key}`,
            "aria-label": formatMessage((0, $iSEc1.default).parentTitle, {
                label: label
            }),
            style: style
        }, label)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$EmptyValue, {
        "data-testid": "issue-field-parent.ui.view-read-view-empty-value"
    }, noValueText);
};
const $ef6f97e64b612d5b$export$51036c707862fc9f = (props)=>{
    if ((0, $eI5EY.fg)('jira_-_list_-_add_onclick_handler_to_parentview')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ParentViewFieldNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ef6f97e64b612d5b$var$ParentViewFieldOld, props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _o5721q9c _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _80omtlke _vwz47vkz _4t3i7vkz _p12f1osq _2rko1l7b _1yt4u49m _1wybdlk8 _2hwxu2gc _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$ButtonText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _80omtlke _4t3igktf _p12f1osq _2rko1l7b _1yt4u49m _11c81oud _2hwxu2gc _19itglyw _11q7glyw _syaz1kw7 _12ji1r31 _1qu21kw7 _12y31o36 _vwz44jg8 _1bto1l2s _1e0c1ule _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx12x7 _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $ef6f97e64b612d5b$var$WrapperNoClick = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _1e0c1ule _vwz47vkz _4t3i7vkz _2rko1l7b _1yt4u49m _1wybdlk8 _p12f1osq _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef6f97e64b612d5b$var$EmptyValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3K8W2", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $95b0c6b6b9af6b91$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $95b0c6b6b9af6b91$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $95b0c6b6b9af6b91$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $95b0c6b6b9af6b91$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $95b0c6b6b9af6b91$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1ybV0 = parcelRequire("1ybV0");

var $tgbCK = parcelRequire("tgbCK");
var $lPQPn = parcelRequire("lPQPn");
const $95b0c6b6b9af6b91$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $tgbCK.MAP_COLORS_TO_VALUE)[color];
const $95b0c6b6b9af6b91$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95b0c6b6b9af6b91$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $95b0c6b6b9af6b91$export$99a866ffa3af7d8b = (issueParents)=>{
    const transformedResponse = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        })) : issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`
        }));
    return transformedResponse;
};
const $95b0c6b6b9af6b91$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $95b0c6b6b9af6b91$export$9b822862d986dfdf = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $95b0c6b6b9af6b91$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $95b0c6b6b9af6b91$export$949dc67535a8ff2 = (color)=>$95b0c6b6b9af6b91$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95b0c6b6b9af6b91$var$ColorPatch = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $9t7rW.default)($95b0c6b6b9af6b91$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");

var $PdmhA = parcelRequire("PdmhA");

var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $PdmhA).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $PdmhA).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $PdmhA).G200]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $PdmhA).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $PdmhA).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $PdmhA).R200]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $PdmhA).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $PdmhA).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $PdmhA).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $PdmhA).G400]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $PdmhA).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $PdmhA).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $PdmhA).R400]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $PdmhA).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $PdmhA).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $PdmhA).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $PdmhA).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $PdmhA).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $PdmhA).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $PdmhA).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $PdmhA).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N300})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});



parcelRegister("iSEc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5298e5dcf31dbd81$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5298e5dcf31dbd81$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    parentTitle: {
        "id": "issue-field-parent.parent-title",
        "defaultMessage": "Click to visit {label}"
    },
    icon: {
        "id": "issue-field-parent.icon",
        "defaultMessage": "{issueType} icon"
    }
});

});




parcelRegister("87lYv", function(module, exports) {

$parcel$export(module.exports, "projectCellHandler", () => $d101ec26024855ff$export$ae050ab68eec4031);

var $eUqFw = parcelRequire("eUqFw");

var $hIoRx = parcelRequire("hIoRx");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $pzFOB = parcelRequire("pzFOB");

var $k4wfZ = parcelRequire("k4wfZ");
const $d101ec26024855ff$export$a0acc7707bde1d3 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
    const [project, setProject] = (0, $eUqFw.useState)(field?.value);
    const [{ value: value }] = (0, $hIoRx.useProjectField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId || '',
        initialValue: field?.value
    });
    if (value !== project) setProject(value);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4wfZ.ProjectRead), {
        project: project
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: true,
        hasPadding: false,
        testId: "business-fields.ui.project.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $pzFOB.ProjectEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        option: project,
        onChange: setProject,
        setEditMode: setEditMode,
        readContent: readContent,
        preferredWidth: preferredWidth,
        cellRef: cellRef
    }) : readContent);
};
const $d101ec26024855ff$export$ae050ab68eec4031 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $d101ec26024855ff$export$a0acc7707bde1d3
};

});
parcelRegister("hIoRx", function(module, exports) {

$parcel$export(module.exports, "useProjectField", () => $d2d345492fb3d8fc$export$85a22e7dcab3be80);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $d2d345492fb3d8fc$export$85a22e7dcab3be80 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = null })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.PROJECT_PICKER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: (0, $1ybV0.ff)('jira.list.field-support-part1') ? initialValue : null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("pzFOB", function(module, exports) {

$parcel$export(module.exports, "ProjectEdit", () => $d9ab91d190552a91$export$847a1c7fcc9fac3d);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $eHEI8 = parcelRequire("eHEI8");
const $d9ab91d190552a91$export$847a1c7fcc9fac3d = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $eHEI8.projectEditEntryPoint), {});
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.project.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("eHEI8", function(module, exports) {

$parcel$export(module.exports, "projectEditEntryPoint", () => $0948621a57ae1a07$export$a995c657f37f351f);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $0948621a57ae1a07$export$a995c657f37f351f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("lszuz")), {
        moduleId: "934d87d1"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lszuz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1Mhz3');
        const value = parcelRequire('02V79');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1Mhz3").then(()=>parcelRequire('02V79'));
}

});



parcelRegister("k4wfZ", function(module, exports) {

$parcel$export(module.exports, "ProjectRead", () => $397710b0ebf6b50a$export$c2b863d8638c3f33);

var $eUqFw = parcelRequire("eUqFw");

var $aA1aH = parcelRequire("aA1aH");
const $397710b0ebf6b50a$export$c2b863d8638c3f33 = ({ project: project })=>project ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aA1aH.ProjectReadView), {
        value: project
    }) : null;

});
parcelRegister("aA1aH", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $26d520d2a340bb02$export$5c3359f22f4596bc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kJlBc = parcelRequire("kJlBc");
const $26d520d2a340bb02$export$5c3359f22f4596bc = ({ value: value, noValueText: noValueText, onClick: onClick })=>{
    const onClickLink = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        e.stopPropagation();
        onClick && onClick(e);
    }, [
        onClick
    ]);
    if (value === undefined || value === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $26d520d2a340bb02$var$emptyValueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$EmptyValue, {
        "data-testid": "issue-field-project.ui.view-read-view-empty-value"
    }, noValueText || ''));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stopPropagation = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$ReadViewContainer, {
        "data-component-selector": "project-read-view-container"
    }, Boolean(value.avatarUrls['48x48']) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: value.avatarUrls['48x48'],
        borderColor: "transparent",
        testId: "issue-field-project.ui.project-avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26d520d2a340bb02$var$Label, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
        "data-testid": "issue-field-project.ui.view-label-link",
        onClick: onClickLink,
        onKeyPress: stopPropagation,
        href: `/projects/${value.key}`
    }, value.name)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d520d2a340bb02$var$EmptyValue = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$ReadViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _p12fuuw1 _1yt41b66",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$emptyValueContainerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26d520d2a340bb02$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $26d520d2a340bb02$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1ul9idpf _2hwxu2gc _1x211q9c _1rg815vq _1yoo15vq _1p6l1l2s _h5vp1o8l _i78x1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("6l2d2", function(module, exports) {

$parcel$export(module.exports, "radioSelectCellHandler", () => $d20d13aa2a67da56$export$cf09278854214c31);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $dC6Z4 = parcelRequire("dC6Z4");

var $gZ9FQ = parcelRequire("gZ9FQ");
const $d20d13aa2a67da56$export$b6b4cb8dcfd6af64 = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode })=>{
    const [option, setOption] = (0, $eUqFw.useState)(field?.value ?? null);
    (0, $eUqFw.useEffect)(()=>{
        setOption(field?.value || null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const handleChange = (0, $eUqFw.useCallback)((value)=>{
        setOption(value);
        setEditMode(false);
    }, [
        setEditMode,
        setOption
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        hasPadding: false
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC6Z4.RadioSelectEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        fieldName: field.name,
        option: option,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZ9FQ.RadioSelectRead), null, option?.label ?? ''),
        preferredWidth: preferredWidth,
        onChange: handleChange
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gZ9FQ.RadioSelectRead), null, option?.label ?? ''));
};
const $d20d13aa2a67da56$export$cf09278854214c31 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $d20d13aa2a67da56$export$b6b4cb8dcfd6af64
};

});
parcelRegister("dC6Z4", function(module, exports) {

$parcel$export(module.exports, "RadioSelectEdit", () => $a9d6bd5be8162ac8$export$7f25860f9e4ad119);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $4XkPy = parcelRequire("4XkPy");
const $a9d6bd5be8162ac8$var$entryPointParams = {};
const $a9d6bd5be8162ac8$export$7f25860f9e4ad119 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $4XkPy.radioSelectEntryPoint), $a9d6bd5be8162ac8$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.radio-select.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("4XkPy", function(module, exports) {

$parcel$export(module.exports, "radioSelectEntryPoint", () => $0af361e9fea841b6$export$ec67c8b087cb34f);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $0af361e9fea841b6$export$ec67c8b087cb34f = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("9mKQp")), {
        moduleId: "ff25c236"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("9mKQp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9aS9x');
        const value = parcelRequire('aGFOE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9aS9x").then(()=>parcelRequire('aGFOE'));
}

});



parcelRegister("gZ9FQ", function(module, exports) {

$parcel$export(module.exports, "RadioSelectRead", () => $515fc734764535af$export$51198f70a0069b1e);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4TezD = parcelRequire("4TezD");
const $515fc734764535af$export$51198f70a0069b1e = ({ children: children })=>{
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $515fc734764535af$var$optionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $515fc734764535af$var$optionTextStyles
    }, children)));
};
const $515fc734764535af$var$optionWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    padding: 'space.075'
});
const $515fc734764535af$var$optionTextStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("csWQF", function(module, exports) {

$parcel$export(module.exports, "resolutionCellHandler", () => $ab4d3fa78c9bbdbe$export$9762e1de55e8d420);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $9zfpT = parcelRequire("9zfpT");
const $ab4d3fa78c9bbdbe$export$8b67413bfec99fe = ({ cellData: field })=>{
    const [resolution, setResolution] = (0, $eUqFw.useState)(field?.value || null);
    (0, $eUqFw.useEffect)(()=>{
        setResolution(field?.value || null);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9zfpT.ResolutionRead), {
        resolution: resolution
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: false,
        hasPadding: true
    }, readContent);
};
const $ab4d3fa78c9bbdbe$export$9762e1de55e8d420 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $ab4d3fa78c9bbdbe$export$8b67413bfec99fe
};

});
parcelRegister("9zfpT", function(module, exports) {

$parcel$export(module.exports, "ResolutionRead", () => $bc7dd289b58e6af9$export$8741d57e18b24f9f);

var $eUqFw = parcelRequire("eUqFw");

var $4cpwW = parcelRequire("4cpwW");
const $bc7dd289b58e6af9$export$8741d57e18b24f9f = ({ resolution: resolution })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cpwW.ResolutionReadView), {
        value: resolution,
        isLabelClickEnabled: true,
        hideIcon: true
    });

});
parcelRegister("4cpwW", function(module, exports) {

$parcel$export(module.exports, "ResolutionReadView", () => $2b3e9241a4bbe969$export$dfd4dfe034c38e3f);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $9nt1B = parcelRequire("9nt1B");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iHmR = parcelRequire("3iHmR");
const $2b3e9241a4bbe969$export$dfd4dfe034c38e3f = ({ value: value, isLabelClickEnabled: isLabelClickEnabled, hideIcon: hideIcon = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasResolution = value;
    const resolutionName = value?.name || formatMessage((0, $3iHmR.default).unresolvedResolution);
    const icon = hasResolution && ((0, $1ybV0.ff)('jira.list.field-support-part1') ? !hideIcon : true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        size: "medium",
        label: resolutionName,
        testId: "issue-field-resolution.ui.read.check-icon",
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G400})`
    }) : null;
    const renderResolutionLabel = (labelName)=>{
        const resolutionStatusLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b3e9241a4bbe969$var$ResolutionStatusLabel, {
            "data-testid": "issue-field-resolution.ui.read.resolution-status-label",
            isDisabled: !isLabelClickEnabled,
            isDarkText: isLabelClickEnabled || !!hasResolution
        }, labelName);
        return !isLabelClickEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $3iHmR.default).readViewMessage),
            position: "top"
        }, resolutionStatusLabel) : resolutionStatusLabel;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b3e9241a4bbe969$var$Container, {
        addPadding: !isLabelClickEnabled,
        "data-testid": "issue-field-resolution.ui.read.label"
    }, icon, renderResolutionLabel(resolutionName));
};
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b3e9241a4bbe969$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-6kdpa7-0"
})(({ addPadding: addPadding })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        padding: addPadding ? `0 ${(0, $c9TLT.gridSize) * 2}px 0 12px` : 0,
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $c9TLT.gridSize) * 4}px`
    }));
const $2b3e9241a4bbe969$var$itemTruncateWidth = (0, $c9TLT.gridSize) * 25;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b3e9241a4bbe969$var$ResolutionStatusLabel = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-6kdpa7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDarkText ? `var(--ds-text-subtle, ${(0, $PdmhA).N500})` : `var(--ds-text-subtlest, ${(0, $PdmhA).N90})`,
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$2b3e9241a4bbe969$var$itemTruncateWidth}px`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? ':hover { cursor: not-allowed; }' : '');

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z" fill="currentColor"/></svg>`
    }, props));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = $6d3cc6c41555bcf7$var$CheckIcon;
module.exports.default = $6d3cc6c41555bcf7$var$_default;

});

parcelRegister("3iHmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4949ab11b370a82a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4949ab11b370a82a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    readViewMessage: {
        "id": "issue-field-resolution.read.read-view-message",
        "defaultMessage": "You cannot edit the resolution field"
    },
    unresolvedResolution: {
        "id": "issue-field-resolution.read.unresolved-resolution",
        "defaultMessage": "Unresolved"
    }
});

});




parcelRegister("edUxi", function(module, exports) {

$parcel$export(module.exports, "statusCategoryCellHandler", () => $721cfc681e9e68bc$export$1c03cc5b920eec85);

var $eUqFw = parcelRequire("eUqFw");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $7mdOo = parcelRequire("7mdOo");
const $721cfc681e9e68bc$export$8b895f86148e277 = ({ cellData: field })=>{
    const [statusCategory, setStatusCategory] = (0, $eUqFw.useState)(field?.value || null);
    (0, $eUqFw.useEffect)(()=>{
        setStatusCategory(field?.value || null);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: false
    }, statusCategory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mdOo.StatusCategoryRead), statusCategory));
};
const $721cfc681e9e68bc$export$1c03cc5b920eec85 = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: $721cfc681e9e68bc$export$8b895f86148e277
};

});
parcelRegister("7mdOo", function(module, exports) {

$parcel$export(module.exports, "StatusCategoryRead", () => $065e68873dd88149$export$3d1939a7f374f0ac);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $065e68873dd88149$var$appearanceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
const $065e68873dd88149$export$3d1939a7f374f0ac = ({ statusCategoryId: statusCategoryId, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "business-fields.ui.status-category.cell.read.lozenge",
        appearance: $065e68873dd88149$var$appearanceMap[(0, $8Qd0L.statusCategoryForId)(statusCategoryId)]
    }, name);

});


parcelRegister("bOyhU", function(module, exports) {

$parcel$export(module.exports, "teamCellHandler", () => $5d8668e6cb38a4b4$export$c23dfb5658df72ac);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $5JDtt = parcelRequire("5JDtt");

var $lO4Or = parcelRequire("lO4Or");

var $6vrw7 = parcelRequire("6vrw7");

var $4TezD = parcelRequire("4TezD");

var $29GZa = parcelRequire("29GZa");

var $jgB4A = parcelRequire("jgB4A");
const $5d8668e6cb38a4b4$export$2ea8e60ef5e5f6ad = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef })=>{
    const [team, setTeam] = (0, $eUqFw.useState)(field?.value);
    const [{ value: value }] = (0, $5JDtt.useTeamField)({
        issueKey: (0, $6vrw7.toIssueKey)(issue.key),
        fieldKey: field?.fieldId ?? '',
        initialValue: team
    });
    if (value !== team && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) setTeam(value);
    (0, $eUqFw.useEffect)(()=>{
        setTeam(field?.value);
    }, [
        field?.value
    ]);
    if (field == null) return null;
    const readContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgB4A.TeamRead), {
        team: team
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: true,
        hasPadding: false,
        testId: "business-fields.ui.team.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29GZa.TeamEdit), {
        issueKey: issue.key,
        fieldKey: field.fieldId,
        team: team,
        onChange: setTeam,
        setEditMode: setEditMode,
        readContent: readContent,
        preferredWidth: preferredWidth,
        cellRef: cellRef
    }) : readContent);
};
const $5d8668e6cb38a4b4$export$c23dfb5658df72ac = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $5d8668e6cb38a4b4$export$2ea8e60ef5e5f6ad
};

});
parcelRegister("5JDtt", function(module, exports) {

$parcel$export(module.exports, "useTeamField", () => $3373352d37138ba2$export$183b0f27978cd3a6);

var $illlw = parcelRequire("illlw");

var $eI5EY = parcelRequire("eI5EY");

var $fecbI = parcelRequire("fecbI");
var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $3373352d37138ba2$var$saveField = async (issueKey, fieldKey, newValue, baseUrl)=>{
    const newId = newValue?.id ?? null;
    return (0, $fecbI.defaultSaveField)(issueKey, fieldKey, newId, baseUrl);
};
const $3373352d37138ba2$export$183b0f27978cd3a6 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? initialValue || null : null,
        onSuccess: onSuccess,
        saveField: $3373352d37138ba2$var$saveField,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("29GZa", function(module, exports) {

$parcel$export(module.exports, "TeamEdit", () => $ebfbba123636b055$export$88197130b31e38af);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $3ChQh = parcelRequire("3ChQh");
const $ebfbba123636b055$export$88197130b31e38af = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $3ChQh.teamEditEntryPoint), {});
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.team.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("3ChQh", function(module, exports) {

$parcel$export(module.exports, "teamEditEntryPoint", () => $35ae6402b069a192$export$9bcf1ad2d1e96b95);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $35ae6402b069a192$export$9bcf1ad2d1e96b95 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6Pj9v")), {
        moduleId: "e322dd82"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6Pj9v", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('dybpk')
        ]);
        const value = parcelRequire('9HjnA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("dybpk")
    ]).then(()=>parcelRequire('9HjnA'));
}

});



parcelRegister("jgB4A", function(module, exports) {

$parcel$export(module.exports, "TeamRead", () => $c8adc6d9ee1b8109$export$5f2e28c402b347f);

var $eUqFw = parcelRequire("eUqFw");

var $5R1rN = parcelRequire("5R1rN");
const $c8adc6d9ee1b8109$export$5f2e28c402b347f = ({ team: team })=>team ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5R1rN.TeamPickerView), {
        defaultValue: team,
        placeholder: "",
        isEditable: false
    }) : null;

});
parcelRegister("5R1rN", function(module, exports) {

$parcel$export(module.exports, "TeamPickerView", () => $02e77c5f09326d91$export$d284ae84f659e68c);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $ldoFd = parcelRequire("ldoFd");

var $51sCz = parcelRequire("51sCz");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4xwq2 = parcelRequire("4xwq2");

var $fFRi9 = parcelRequire("fFRi9");

var $iC4qb = parcelRequire("iC4qb");
const $02e77c5f09326d91$var$ErrorView = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $iC4qb.default).teamErrorViewTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Text, {
        isDisabled: true,
        "data-testid": "issue-field-team.ui.view-error-value-text"
    }, formatMessage((0, $iC4qb.default).teamErrorViewText))));
};
const $02e77c5f09326d91$export$d284ae84f659e68c = (props)=>{
    const { defaultValue: defaultValue, isEditable: isEditable, placeholder: placeholder, noPaddingLeft: noPaddingLeft } = props;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(defaultValue)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$ReadViewContainerEmpty, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xwq2.EmptyValue), {
        "data-testid": "issue-field-team.ui.view-empty-value-text"
    }, placeholder));
    if (defaultValue.isVisible === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$ErrorView, null);
    const team = defaultValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Wrapper, {
        isEditable: isEditable,
        noPaddingLeft: noPaddingLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fFRi9.default), {
        teamId: team.id,
        trigger: "hover-click",
        position: "left-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02e77c5f09326d91$var$Text, {
        "data-testid": "issue-field-team.ui.view-team-name"
    }, team.name))));
};
var $02e77c5f09326d91$export$2e2bcd8739ae039 = $02e77c5f09326d91$export$d284ae84f659e68c;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02e77c5f09326d91$var$ReadViewContainerEmpty = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18930yh-0"
})({
    display: 'flex',
    fontSize: `${(0, $lcnyw.fontSize)()}px`,
    maxWidth: '100%',
    padding: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $lcnyw.gridSize)() * 2}px`,
    alignItems: 'center'
});
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $02e77c5f09326d91$var$Text = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-18930yh-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: (0, $lcnyw.gridSize)() * 2.5 / (0, $lcnyw.fontSize)(),
        textAlign: 'left',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text, ${0, $PdmhA.N900})`,
        alignItems: 'center',
        display: 'flex',
        padding: `${"var(--ds-space-025, 2px)"} 0`
    }));
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $02e77c5f09326d91$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-18930yh-2"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: props.isEditable ? 'pointer' : 'default',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingLeft: props.noPaddingLeft ? undefined : "var(--ds-space-075, 6px)",
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> a': {
            display: 'flex',
            alignItems: 'center'
        }
    }));

});
parcelRegister("4xwq2", function(module, exports) {

$parcel$export(module.exports, "TextContentArea", () => $1d6e9d9e18ae818d$export$ec6675e932be98e4);
$parcel$export(module.exports, "ScrollableArea", () => $1d6e9d9e18ae818d$export$83c3fa3ac4f31acf);
$parcel$export(module.exports, "EmptyValue", () => $1d6e9d9e18ae818d$export$1ebe45ee63a8a144);
$parcel$export(module.exports, "Ellipsis", () => $1d6e9d9e18ae818d$export$1297970233533a7d);
/* issue-value.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $1d6e9d9e18ae818d$export$a5b94313d6908893 = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
const $1d6e9d9e18ae818d$var$FALLBACK_ROWS = 2;
const $1d6e9d9e18ae818d$export$afe400f595924e77 = (target)=>null;
const $1d6e9d9e18ae818d$var$getTextAreaCss = {
    fontSize: '1em',
    lineHeight: 1.714,
    fontWeight: 'normal',
    marginTop: "var(--ds-space-025, 2px)",
    marginBottom: 0,
    letterSpacing: '-0.005em',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    height: 'auto',
    whiteSpace: 'pre-line'
};
const $1d6e9d9e18ae818d$export$ec6675e932be98e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1x4e _vwz478tn _k48p4jg8 _19pkv77o _otyridpf _1dyzdjp5 _18m91wug _1reo15vq _1bsb1osq _4t3i1wug _o5726vc6",
            __cmplp.className
        ])
    });
});
const $1d6e9d9e18ae818d$export$83c3fa3ac4f31acf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxRows: maxRows, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lsy6xb": (0, $9t7rW.default)(`${(__cmplp.maxRows ? __cmplp.maxRows : $1d6e9d9e18ae818d$var$FALLBACK_ROWS) * 2.5}ex`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1x4e _vwz478tn _k48p4jg8 _19pkv77o _otyridpf _1dyzdjp5 _18m91wug _1reo15vq _1bsb1osq _4t3i1wug _o5726vc6 _c71l1v1h _1ke8ftgi _1suq18uv _aaynrg55 _155a19bv",
            __cmplp.className
        ])
    });
});
const $1d6e9d9e18ae818d$export$1ebe45ee63a8a144 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $1d6e9d9e18ae818d$export$1297970233533a7d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fFRi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d635822c142a4d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $13d635822c142a4d$var$AsyncTeamProfileCardNext = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("kCgKw")), {
    ssr: false,
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$13d635822c142a4d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.profilecard-next.team-profilecard",
        packageName: "async.profilecard-next.team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-team-profilecard-next",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($13d635822c142a4d$var$AsyncTeamProfileCardNext, props)));

});
parcelRegister("kCgKw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cyrhR')
        ]);
        const value = parcelRequire('aBa6h');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cyrhR")
    ]).then(()=>parcelRequire('aBa6h'));
}

});


parcelRegister("iC4qb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0b2f105010cb38$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f0b2f105010cb38$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "issue-field-team.error-title",
        "defaultMessage": "We couldn't set the team value"
    },
    errorMessage: {
        "id": "issue-field-team.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    teamErrorViewTooltip: {
        "id": "issue-field-team.team-error-view-tooltip",
        "defaultMessage": "This team may have been deleted, or you do not have access"
    },
    teamErrorViewText: {
        "id": "issue-field-team.team-error-view-text",
        "defaultMessage": "Not available"
    },
    placeholderTeamEditSelector: {
        "id": "issue-field-team.placeholder-team-edit-selector",
        "defaultMessage": "Choose a team"
    },
    defaultNoValueText: {
        "id": "issue-field-team.default-no-value-text",
        "defaultMessage": "None"
    },
    createTeamButtonText: {
        "id": "issue-field-team.create-team-button-text",
        "defaultMessage": "Create a team"
    },
    emptyStateDescription: {
        "id": "issue-field-team.empty-state-description",
        "defaultMessage": "Create a team to assign work across Jira and track it on your team\u2019s profile"
    },
    noOptionsMessage: {
        "id": "issue-field-team.no-options-message",
        "defaultMessage": "No options"
    }
});

});




parcelRegister("cWB05", function(module, exports) {

$parcel$export(module.exports, "versionCellHandler", () => $f3afddc8ffbc0289$export$fc6264270343b1df);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $4TezD = parcelRequire("4TezD");

var $2Lr9o = parcelRequire("2Lr9o");

var $aia5v = parcelRequire("aia5v");
const $f3afddc8ffbc0289$export$710c4688cbbfc14a = ({ rowData: issue, cellData: field, column: { width: preferredWidth }, editMode: editMode, setEditMode: setEditMode, cellRef: cellRef, inputValue: inputValue, onInputChange: onInputChange })=>{
    const [selectedVersions, setSelectedVersions] = (0, $eUqFw.useState)(field?.value ?? null);
    if ((0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [{ value: fieldValue }] = (0, $gGiWF.useEditField)({
            fieldKey: field?.fieldId ?? '',
            issueKey: issue.key,
            fieldType: field?.type ?? '',
            initialValue: field?.value ?? null
        });
        // Update the value when it is updated externally (e.g. when a new value is pasted)
        if (!editMode && fieldValue !== selectedVersions) setSelectedVersions(fieldValue);
    }
    // Update the value when it is updated in cache (e.g. via realtime)
    (0, $eUqFw.useEffect)(()=>{
        setSelectedVersions(field?.value ?? null);
    }, [
        field?.value
    ]);
    const isEditable = (0, $eUqFw.useMemo)(()=>issue.fieldConfig?.isEditable || false, [
        issue.fieldConfig?.isEditable
    ]);
    const isMulti = (0, $eUqFw.useMemo)(()=>field?.type !== 'com.atlassian.jira.plugin.system.customfieldtypes:version', [
        field?.type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-fields.ui.version.cell.cell-wrapper"
    }, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Lr9o.VersionEdit), {
        cellRef: cellRef,
        setEditMode: setEditMode,
        inputValue: inputValue,
        onInputChange: onInputChange,
        isMulti: isMulti,
        fieldName: field?.name || '',
        onChange: setSelectedVersions,
        preferredWidth: preferredWidth,
        selectedVersions: selectedVersions,
        fieldKey: field?.fieldId || '',
        issueKey: issue.key,
        fieldType: field?.type || '',
        initialValue: field?.value ?? null,
        readContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aia5v.VersionRead), {
            isEditable: isEditable,
            selectedVersions: selectedVersions
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aia5v.VersionRead), {
        isEditable: isEditable,
        selectedVersions: selectedVersions
    }));
};
const $f3afddc8ffbc0289$export$fc6264270343b1df = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $f3afddc8ffbc0289$export$710c4688cbbfc14a
};

});
parcelRegister("2Lr9o", function(module, exports) {

$parcel$export(module.exports, "VersionEdit", () => $c59c9f8e4ef252b2$export$3c0e57d9b0204cdc);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $3aH4u = parcelRequire("3aH4u");
const $c59c9f8e4ef252b2$var$entryPointParams = {};
const $c59c9f8e4ef252b2$export$3c0e57d9b0204cdc = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $3aH4u.versionEditEntryPoint), $c59c9f8e4ef252b2$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jwm.business.fields.version.edit",
        packageName: "jiraBusinessFields",
        runtimeProps: props,
        fallback: props.readContent
    });
};

});
parcelRegister("3aH4u", function(module, exports) {

$parcel$export(module.exports, "versionEditEntryPoint", () => $15edf8a8ef926059$export$e4a061611063756b);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $15edf8a8ef926059$export$e4a061611063756b = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("1iLlx")), {
        moduleId: "d7202e48"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1iLlx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4HHsM');
        const value = parcelRequire('aZKML');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4HHsM").then(()=>parcelRequire('aZKML'));
}

});



parcelRegister("aia5v", function(module, exports) {

$parcel$export(module.exports, "VersionRead", () => $cf4acba683678e4c$export$6cc418351c9e7765);

var $eUqFw = parcelRequire("eUqFw");

var $9jNAz = parcelRequire("9jNAz");

var $4TezD = parcelRequire("4TezD");

var $3NqHp = parcelRequire("3NqHp");
const $cf4acba683678e4c$export$6cc418351c9e7765 = ({ selectedVersions: selectedVersions, isEditable: isEditable })=>{
    const [version, count] = (0, $eUqFw.useMemo)(()=>{
        if (Array.isArray(selectedVersions)) {
            const [firstVersion, ...others] = selectedVersions ?? [];
            return [
                firstVersion?.name,
                others.length
            ];
        }
        if (selectedVersions != null) return [
            selectedVersions.name,
            0
        ];
        return [
            undefined,
            0
        ];
    }, [
        selectedVersions
    ]);
    if (version == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.WrapperCommon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NqHp.TagListWrapper), {
        isEditable: isEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: version
    }), count > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9jNAz.default), {
        text: `+${count}`
    })));
};

});



parcelRegister("8safW", function(module, exports) {

$parcel$export(module.exports, "ColumnVisibilityProvider", () => $bfd64eb053ca9602$export$a60887dfea90a0d9);
$parcel$export(module.exports, "useColumnVisibilityUpdater", () => $bfd64eb053ca9602$export$ef90c8750ba3bb5);
$parcel$export(module.exports, "useIsColumnVisible", () => $bfd64eb053ca9602$export$3dbd1ecf42329eea);

var $eUqFw = parcelRequire("eUqFw");

var $90pMD = parcelRequire("90pMD");
const $bfd64eb053ca9602$var$VISIBILITY_OFFSET = 120;
const $bfd64eb053ca9602$var$getVisibleColumns = (scrollLeft, tableWidth, columns)=>{
    const windowLeft = scrollLeft - $bfd64eb053ca9602$var$VISIBILITY_OFFSET;
    const windowRight = scrollLeft + tableWidth + $bfd64eb053ca9602$var$VISIBILITY_OFFSET;
    const result = new Map();
    let currentOffset = 0;
    for (const column of columns){
        const columnLeft = currentOffset;
        const columnRight = columnLeft + column.width;
        const isVisible = columnRight >= windowLeft && columnLeft <= windowRight;
        result.set(column.key, isVisible);
        currentOffset = columnRight;
    }
    return result;
};
const $bfd64eb053ca9602$var$ColumnVisibilityUpdaterContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $bfd64eb053ca9602$var$ColumnVisibilityAccessorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $bfd64eb053ca9602$export$a60887dfea90a0d9 = ({ children: children, columns: columns, width: width })=>{
    const [scrollPosition, setScrollPosition] = (0, $eUqFw.useState)({
        scrollLeft: 0
    });
    const visibleColumns = (0, $eUqFw.useMemo)(()=>$bfd64eb053ca9602$var$getVisibleColumns(scrollPosition.scrollLeft, width, columns), [
        columns,
        scrollPosition.scrollLeft,
        width
    ]);
    // Use a deeply memoized value to prevent triggering a re-render when the
    // values haven't actually changed
    const memoizedVisibileColumns = (0, $90pMD.useDeepMemo)(()=>visibleColumns, [
        visibleColumns
    ]);
    const getIsColumnVisible = (0, $eUqFw.useCallback)(({ key: key })=>// We should always have a value at this point, but we'll default to
        // true as a minor performance hit is better than missing content
        memoizedVisibileColumns.get(key) ?? true, [
        memoizedVisibileColumns
    ]);
    const columnVisibilityAccessor = (0, $eUqFw.useMemo)(()=>({
            getIsColumnVisible: getIsColumnVisible
        }), [
        getIsColumnVisible
    ]);
    const columnVisibilityUpdater = (0, $eUqFw.useMemo)(()=>({
            handleScroll: ({ scrollLeft: scrollLeft })=>setScrollPosition((prev)=>scrollLeft !== prev.scrollLeft ? {
                        scrollLeft: scrollLeft
                    } : prev)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfd64eb053ca9602$var$ColumnVisibilityUpdaterContext.Provider, {
        value: columnVisibilityUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bfd64eb053ca9602$var$ColumnVisibilityAccessorContext.Provider, {
        value: columnVisibilityAccessor
    }, children));
};
const $bfd64eb053ca9602$export$ef90c8750ba3bb5 = ()=>{
    const context = (0, $eUqFw.useContext)($bfd64eb053ca9602$var$ColumnVisibilityUpdaterContext);
    if (!context) throw new Error("'useColumnVisibilityUpdater' must be used inside a 'ColumnVisibilityProvider'");
    return context;
};
const $bfd64eb053ca9602$export$3dbd1ecf42329eea = (column)=>{
    const context = (0, $eUqFw.useContext)($bfd64eb053ca9602$var$ColumnVisibilityAccessorContext);
    if (!context) throw new Error("'useIsColumnVisible' must be used inside a 'ColumnVisibilityProvider'");
    return context.getIsColumnVisible(column);
};

});

parcelRegister("isXgL", function(module, exports) {

$parcel$export(module.exports, "WithCellSelection", () => $da08e5ced1cd14f6$export$3f3bc47e8aed32cb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $i0nxo = parcelRequire("i0nxo");
var $aZGbv = parcelRequire("aZGbv");
var $4TJj0 = parcelRequire("4TJj0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lO4Or = parcelRequire("lO4Or");

var $gbsaq = parcelRequire("gbsaq");

var $jxvjJ = parcelRequire("jxvjJ");

var $en1mL = parcelRequire("en1mL");
const $da08e5ced1cd14f6$export$3f3bc47e8aed32cb = /*#__PURE__*/ (0, $eUqFw.memo)(({ projectId: projectId, fieldId: fieldId, issueId: issueId, position: position, children: children, rowIndex: rowIndex, columnIndex: columnIndex, width: width, field: field, issue: issue, depth: depth = 0 })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ nodeSelection: nodeSelection }, { sendNodeSelected: sendNodeSelected, sendClearNodeSelection: sendClearNodeSelection }] = (0, $4TJj0.useCollabStore)();
    const nodeId = (0, $eUqFw.useMemo)(()=>(0, $i0nxo.getPresenceNodeId)({
            projectId: projectId,
            viewId: 'list',
            nodeId: `${fieldId}-${issueId}`
        }), [
        projectId,
        issueId,
        fieldId
    ]);
    const selections = nodeSelection[nodeId];
    const selection = selections && selections[0];
    const isIssueType = fieldId === (0, $lO4Or.ISSUE_TYPE);
    const onSendNodeSelected = (0, $eUqFw.useCallback)(()=>sendNodeSelected({
            nodeId: nodeId
        }), [
        sendNodeSelected,
        nodeId
    ]);
    const onSendClearNodeSelection = (0, $eUqFw.useCallback)(()=>sendClearNodeSelection({
            nodeId: nodeId
        }), [
        sendClearNodeSelection,
        nodeId
    ]);
    const renderedChildren = (0, $eUqFw.useMemo)(()=>children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jxvjJ.CellNavigation), {
            columnIndex: columnIndex,
            rowIndex: rowIndex,
            field: field,
            issue: issue,
            onSendNodeSelected: onSendNodeSelected,
            onSendClearNodeSelection: onSendClearNodeSelection
        }, children()), [
        children,
        columnIndex,
        onSendClearNodeSelection,
        onSendNodeSelected,
        rowIndex,
        field,
        issue
    ]);
    if (selection) {
        const hasMoreSelections = selections && selections.length > 1; // exclude first selection of the list
        const tooltipContent = hasMoreSelections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, selections.map(({ user: user }, i)=>i !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                key: user.name
            }, user.name))) : null;
        const otherSelectionsContent = hasMoreSelections ? formatMessage((0, $en1mL.default).moreSelections, {
            count: selections.length - 1
        }) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da08e5ced1cd14f6$var$NodeWrapper, {
            isIssueType: isIssueType,
            width: width,
            depth: depth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.NodeSelectionWrapper), {
            color: selection.color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: tooltipContent,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZGbv.ParticipantBadge), {
            color: selection.color,
            position: position
        }, selection.user.name, otherSelectionsContent)), renderedChildren));
    }
    return renderedChildren;
});
const $da08e5ced1cd14f6$var$nodeWrapperBaseStyles = null;
const $da08e5ced1cd14f6$var$NodeWrapper = ({ isIssueType: isIssueType, width: width, depth: depth, children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...isIssueType && {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                paddingLeft: `${depth > 0 ? (0, $gbsaq.EXPAND_ICON_INDENT_WIDTH) * depth + 4 : 0}px`,
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: `${width - (0, $gbsaq.LIST_PADDING_LEFT)}px`
            }
        },
        ...rest,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1kw7 _4t3i1ylp"
        ])
    }, children);

});
parcelRegister("i0nxo", function(module, exports) {

$parcel$export(module.exports, "getPresenceNodeId", () => $0ed5d5739c577dad$export$b31325f2ad6cf0b5);
const $0ed5d5739c577dad$export$b31325f2ad6cf0b5 = ({ projectId: projectId, viewId: viewId, nodeId: nodeId })=>`project:${projectId}:view/${viewId}/node/${nodeId}`;

});

parcelRegister("4TJj0", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $8f55868fdda87f4e$export$4159ae80cfa2156);

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3BgyA = parcelRequire("3BgyA");

const $8f55868fdda87f4e$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $8f55868fdda87f4e$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $daf44b44f86c0150$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $8f55868fdda87f4e$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $8f55868fdda87f4e$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $8f55868fdda87f4e$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $8f55868fdda87f4e$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $8f55868fdda87f4e$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const { color: color } = (0, $3BgyA.getColorFromString)(sessionId);
        const newSelection = {
            nodeId: nodeId,
            user: user,
            color: color,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        // see JET-2794
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $8f55868fdda87f4e$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $8f55868fdda87f4e$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $8f55868fdda87f4e$var$actions = {
    setProvider: $8f55868fdda87f4e$var$setProvider,
    participantsLeft: $8f55868fdda87f4e$var$participantsLeft,
    participantsJoined: $8f55868fdda87f4e$var$participantsJoined,
    updateUserInParticipants: $8f55868fdda87f4e$var$updateUserInParticipants,
    sendNodeSelected: $8f55868fdda87f4e$var$sendNodeSelected,
    sendClearNodeSelection: $8f55868fdda87f4e$var$sendClearNodeSelection,
    setNodeSelection: $8f55868fdda87f4e$var$setNodeSelection,
    clearNodeSelection: $8f55868fdda87f4e$var$clearNodeSelection,
    stopDragAnimation: $8f55868fdda87f4e$var$stopDragAnimation
};
const $8f55868fdda87f4e$var$Store = (0, $a61MH.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $8f55868fdda87f4e$var$actions,
    name: 'JWMCollabStore'
});
const $8f55868fdda87f4e$export$4159ae80cfa2156 = (0, $ggKAj.createHook)($8f55868fdda87f4e$var$Store);

});
parcelRegister("3BgyA", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $9bfc0522bb35e6c9$export$137ec5185b12f5a2);

var $PdmhA = parcelRequire("PdmhA");
const $9bfc0522bb35e6c9$var$colors = [
    (0, $PdmhA).R300,
    (0, $PdmhA).R400,
    (0, $PdmhA).R500,
    (0, $PdmhA).Y300,
    (0, $PdmhA).Y400,
    (0, $PdmhA).Y500,
    (0, $PdmhA).G300,
    (0, $PdmhA).G400,
    (0, $PdmhA).G500,
    (0, $PdmhA).T300,
    (0, $PdmhA).T400,
    (0, $PdmhA).T500,
    (0, $PdmhA).B300,
    (0, $PdmhA).B400,
    (0, $PdmhA).B500,
    (0, $PdmhA).P300,
    (0, $PdmhA).P400,
    (0, $PdmhA).P500,
    (0, $PdmhA).N200,
    (0, $PdmhA).N500,
    (0, $PdmhA).N800
];
const $9bfc0522bb35e6c9$export$137ec5185b12f5a2 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i += 1){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash &= hash;
    /* eslint-enable no-bitwise */ }
    const index = Math.abs(hash) % $9bfc0522bb35e6c9$var$colors.length;
    return {
        index: index,
        color: $9bfc0522bb35e6c9$var$colors[index]
    };
};

});

const $daf44b44f86c0150$export$3debf01bbfa135e5 = 80;


parcelRegister("jxvjJ", function(module, exports) {

$parcel$export(module.exports, "CellNavigation", () => $66d68ca2d826b971$export$8511762758d83099);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $87KFZ = parcelRequire("87KFZ");

var $kGQen = parcelRequire("kGQen");

var $eI5EY = parcelRequire("eI5EY");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $8UbeN = parcelRequire("8UbeN");

var $8NLkb = parcelRequire("8NLkb");

var $17QbA = parcelRequire("17QbA");

var $1eMsI = parcelRequire("1eMsI");

var $cOE3G = parcelRequire("cOE3G");
const $66d68ca2d826b971$var$isNonCharacterKey = (event)=>event.key.length > 1 || event.ctrlKey || event.metaKey;
const $66d68ca2d826b971$var$copiedFromStyles = null;
const $66d68ca2d826b971$export$8511762758d83099 = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, columnIndex: columnIndex, rowIndex: rowIndex, field: field, onSendNodeSelected: onSendNodeSelected, onSendClearNodeSelection: onSendClearNodeSelection, issue: issue })=>{
    const [{ isSelected: isSelected = false, isCopiedFrom: isCopiedFrom = false }, { setSelectedCell: setSelectedCell, clearSelectedCell: clearSelectedCell, clearCopiedFromCell: clearCopiedFromCell }] = (0, $8NLkb.useCellSelected)({
        column: columnIndex,
        row: rowIndex,
        issueId: issue?.issueId,
        fieldId: field?.id
    });
    const isSelectedRef = (0, $eUqFw.useRef)(isSelected);
    const prevIsSelected = (0, $hzcvF.usePreviousWithInitial)(isSelected);
    const horizontalNavigationRef = (0, $eUqFw.useRef)(false);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const cellRef = (0, $eUqFw.useRef)(null);
    const { navigate: navigate } = (0, $8NLkb.useCellActions)();
    const [{ tableRef: tableRef }] = (0, $1eMsI.useTableRefStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [editMode, setEditModeFn] = (0, $eUqFw.useState)(false);
    const [inputValue, setInputValue] = (0, $eUqFw.useState)();
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const editModeRef = (0, $eUqFw.useRef)(editMode);
    editModeRef.current = editMode;
    const isEditable = field?.fieldConfig?.isEditable ?? true;
    const isNewKeyboardNavField = field?.type && (0, $cOE3G.getNewNavSupportedFieldTypes)().has(field.type) && (0, $eI5EY.fg)('jira_list_keyboard_nav');
    const setEditMode = (0, $eUqFw.useCallback)((nextEditMode)=>{
        if (nextEditMode === editMode) return;
        if (!isNewKeyboardNavField || isEditable) {
            setEditModeFn(nextEditMode);
            // If edit mode is set to false, refocus on cell wrapper
            if (!nextEditMode && (0, $eI5EY.fg)('list_view_cell_focus')) setTimeout(()=>{
                wrapperRef?.current?.focus();
            }, 0);
        }
    }, [
        editMode,
        isEditable,
        isNewKeyboardNavField
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // allow first render isSelected to call the fn
        if (isSelected === true && prevIsSelected === false) {
            onSendNodeSelected && onSendNodeSelected();
            horizontalNavigationRef.current = false;
        }
        if (isSelected === false && prevIsSelected === true) onSendClearNodeSelection && onSendClearNodeSelection(); // only clear if prev value is true
    }, [
        isSelected,
        onSendClearNodeSelection,
        onSendNodeSelected,
        prevIsSelected
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isSelectedRef.current = isSelected;
        if (isSelected && wrapperRef.current) wrapperRef.current.focus();
    }, [
        isSelected
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (isSelectedRef.current) clearSelectedCell();
        }, [
        clearSelectedCell
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isNewKeyboardNavField) {
            if (isSelected === false && editMode) setEditMode(false);
        }
    }, [
        editMode,
        isSelected,
        isNewKeyboardNavField,
        setEditMode
    ]);
    const handleFocus = (0, $eUqFw.useCallback)(()=>{
        setSelectedCell(columnIndex, rowIndex);
    }, [
        columnIndex,
        rowIndex,
        setSelectedCell
    ]);
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        if ((!isNewKeyboardNavField || event.relatedTarget) && !event.currentTarget?.contains(event.relatedTarget)) {
            const stop = cellRef.current?.onBlur?.(event);
            if (stop) return;
            clearSelectedCell();
        }
    }, [
        clearSelectedCell,
        isNewKeyboardNavField
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)(// eslint-disable-next-line complexity
    (event)=>{
        if (isNewKeyboardNavField) {
            const stop = cellRef.current?.onKeyDown?.(event);
            if (stop) return;
        }
        const horizontalNavKeyPressed = (0, $cOE3G.VALID_HORIZONTAL_NAV_KEYS).has(event.key);
        const isTabPressed = event.key === (0, $cOE3G.KEY_TAB);
        const isValidKey = (0, $cOE3G.VALID_NAVIGATION_KEYS).has(event.key);
        if (event.shiftKey && !isTabPressed) return;
        if (!isValidKey) {
            if (isNewKeyboardNavField && !editMode && !$66d68ca2d826b971$var$isNonCharacterKey(event)) {
                setEditMode(true);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'typeToEdit',
                    actionSubject: 'listNavigated'
                }), {
                    fieldType: field.type
                });
                setTimeout(()=>{
                    setInputValue(event.key);
                });
            }
            return;
        }
        const isScrolling = !!tableRef?.current?.table?.bodyRef?.state?.isScrolling;
        const navigationInProgress = isSelected && horizontalNavigationRef.current && horizontalNavKeyPressed;
        if (navigationInProgress || isScrolling) return;
        const fireNavigationAnalytics = ()=>{
            const EVENT_KEY = event.key === (0, $cOE3G.KEY_SPACE) ? 'Space' : event.key;
            const attributes = isNewKeyboardNavField && [
                'Enter',
                'Tab',
                'Escape',
                'Space'
            ].includes(EVENT_KEY) ? {
                isEditMode: editMode,
                fieldType: field.type
            } : {};
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: EVENT_KEY,
                actionSubject: 'listNavigated'
            }), attributes);
        };
        const handleNavigationEvent = (overrideDirection)=>{
            const direction = overrideDirection ?? (0, $cOE3G.NAV_KEYS_TO_DIRECTION)[event.key];
            if (horizontalNavKeyPressed) horizontalNavigationRef.current = true;
            navigate(direction, tableRef);
        };
        if (isNewKeyboardNavField && editMode) switch(event.key){
            case 0, $cOE3G.KEY_ENTER:
                setTimeout(()=>{
                    setEditMode(false);
                    if (!(0, $eI5EY.fg)('list_view_cell_focus')) wrapperRef?.current?.focus();
                    handleNavigationEvent((0, $gbsaq.DOWN));
                    fireNavigationAnalytics();
                }, 1);
                return;
            case 0, $cOE3G.KEY_ESCAPE:
                setTimeout(()=>{
                    setEditMode(false);
                    setInputValue(undefined);
                    if (!(0, $eI5EY.fg)('list_view_cell_focus')) wrapperRef?.current?.focus();
                });
                return;
            case 0, $cOE3G.KEY_TAB:
                setTimeout(()=>{
                    setEditMode(false);
                    if (!(0, $eI5EY.fg)('list_view_cell_focus')) wrapperRef?.current?.focus();
                    handleNavigationEvent(event.shiftKey ? (0, $gbsaq.LEFT) : (0, $gbsaq.RIGHT));
                    fireNavigationAnalytics();
                }, 1);
                return;
            case 0, $cOE3G.KEY_SPACE:
                // move selection down when pressing Space exits edit mode
                setTimeout(()=>{
                    if (!editModeRef.current) {
                        if (!(0, $eI5EY.fg)('list_view_cell_focus')) wrapperRef?.current?.focus();
                        handleNavigationEvent((0, $gbsaq.DOWN));
                        fireNavigationAnalytics();
                    }
                }, 1);
                return;
            case 0, $cOE3G.KEY_UP:
            case 0, $cOE3G.KEY_DOWN:
            case 0, $cOE3G.KEY_LEFT:
            case 0, $cOE3G.KEY_RIGHT:
                return;
            default:
        }
        const tableDataLength = tableRef?.current?.table?.props?.data?.length || 0;
        const totalColumns = tableRef?.current?.table?.props?.columns?.length || 0;
        const isFirstTableItem = columnIndex === 0 && rowIndex === 0;
        const isLastTableItem = columnIndex === totalColumns - 1 && rowIndex === tableDataLength - 1;
        const isDirectionLeft = event.key === (0, $cOE3G.KEY_LEFT) || isTabPressed && event.shiftKey;
        const isDirectionRight = event.key === (0, $cOE3G.KEY_RIGHT) || isTabPressed && !event.shiftKey;
        if (isFirstTableItem && isDirectionLeft || isLastTableItem && isDirectionRight) return;
        event.preventDefault();
        fireNavigationAnalytics();
        switch(event.key){
            case 0, $cOE3G.KEY_UP:
            case 0, $cOE3G.KEY_DOWN:
                handleNavigationEvent();
                break;
            case 0, $cOE3G.KEY_LEFT:
                if (columnIndex > 0) handleNavigationEvent();
                break;
            case 0, $cOE3G.KEY_RIGHT:
                if (columnIndex < totalColumns - 1) handleNavigationEvent();
                break;
            case 0, $cOE3G.KEY_TAB:
                handleNavigationEvent(event.shiftKey ? (0, $gbsaq.LEFT) : (0, $gbsaq.RIGHT));
                break;
            case 0, $cOE3G.KEY_ENTER:
                if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                break;
            case 0, $cOE3G.KEY_SPACE:
                if (!isNewKeyboardNavField || !editMode) wrapperRef?.current?.click();
                break;
            case 0, $cOE3G.KEY_ESCAPE:
                if (!isNewKeyboardNavField || !editMode) {
                    clearSelectedCell();
                    clearCopiedFromCell();
                    wrapperRef?.current?.blur();
                }
                break;
            default:
                break;
        }
    }, [
        isNewKeyboardNavField,
        tableRef,
        isSelected,
        editMode,
        setEditMode,
        columnIndex,
        rowIndex,
        createAnalyticsEvent,
        navigate,
        clearSelectedCell,
        clearCopiedFromCell,
        field?.type
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (isNewKeyboardNavField) {
            const stop = cellRef.current?.onClick?.(event);
            if (stop) return;
        }
        setEditMode(true);
    }, [
        setEditMode,
        isNewKeyboardNavField
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), [
        setIsHovering
    ]);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovering(false), [
        setIsHovering
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((value)=>setInputValue(value), []);
    const getClone = ()=>{
        if (/*#__PURE__*/ (0, $eUqFw.isValidElement)(children)) {
            if (isNewKeyboardNavField) return /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
                isSelected: isSelected,
                wrapperRef: wrapperRef,
                cellRef: cellRef,
                editMode: editMode,
                setEditMode: setEditMode,
                isHovering: isHovering,
                inputValue: inputValue,
                onInputChange: onInputChange
            });
            return /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
                isSelected: isSelected,
                wrapperRef: wrapperRef,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyDown: handleKeyDown
            });
        }
        return children;
    };
    if (isNewKeyboardNavField) {
        const getCellContainer = (props = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.CellContainer), {
                ref: wrapperRef,
                isFocused: isSelected,
                tabIndex: 0,
                "data-testid": (0, $87KFZ.CELL_WRAPPER_TEST_ID),
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onClick: handleClick,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                className: (0, $7JEyt.default)([
                    isCopiedFrom && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') && "_kqswh2mm _cfu11ule _1cs8stnw _1kt9b3bt _1mp4mslj _kfgtmslj _14h82wlf _rfx3glpi _1rus18uv _dsq4glyw _1g0vidpf"
                ])
            }, getClone()), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null));
        if (field && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $17QbA.ClipboardController), {
            issue: issue,
            field: field,
            isSelected: isSelected,
            onKeyDown: handleKeyDown
        }, getCellContainer());
        return getCellContainer({
            onKeyDown: handleKeyDown
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, getClone());
});

});
parcelRegister("87KFZ", function(module, exports) {

$parcel$export(module.exports, "CELL_WRAPPER_TEST_ID", () => $ad717643faeaff73$export$dec9ff238ffa9d69);
$parcel$export(module.exports, "useMultiSelectKeyDown", () => $ad717643faeaff73$export$704331f55cc6e6a4);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $ad717643faeaff73$export$dec9ff238ffa9d69 = 'business-list.ui.list-view.cell-navigation.cell-container';
const $ad717643faeaff73$export$c4f223e53a47f1c6 = (element)=>element?.getAttribute('data-testid') === $ad717643faeaff73$export$dec9ff238ffa9d69;
const $ad717643faeaff73$export$704331f55cc6e6a4 = ({ editMode: editMode = true, wasEditMode: wasEditMode = false, menuIsOpen: menuIsOpen, setMenuIsOpen: setMenuIsOpen, saveAndClose: saveAndClose, onEscapeKeyPress: onEscapeKeyPress })=>{
    const shouldCloseWithoutSaving = (0, $eUqFw.useRef)(false);
    const saveAndCloseRef = (0, $eUqFw.useRef)(saveAndClose);
    saveAndCloseRef.current = saveAndClose;
    const saveOnBlur = (0, $eUqFw.useCallback)(()=>{
        // save on blur when user did not press Escape
        if (wasEditMode && !editMode && (0, $eI5EY.fg)('jira_list_keyboard_nav')) {
            if (!shouldCloseWithoutSaving.current) {
                saveAndClose();
                // set close without saving to true because we already saved
                if ((0, $1ybV0.ff)('jira.list.field-support-part1')) shouldCloseWithoutSaving.current = true;
            } else shouldCloseWithoutSaving.current = false;
        }
    }, [
        editMode,
        saveAndClose,
        wasEditMode
    ]);
    const saveOnUnmount = (0, $eUqFw.useCallback)(()=>{
        // save on edit view unmount
        if (!shouldCloseWithoutSaving.current && (0, $eI5EY.fg)('jira_list_keyboard_nav')) saveAndCloseRef.current();
        else shouldCloseWithoutSaving.current = false;
    }, []);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (editMode) {
            // Close the menu on selecting an option
            if (menuIsOpen && [
                'Enter',
                'Tab',
                'Space'
            ].includes(event.code)) {
                setMenuIsOpen(false);
                return true;
            }
            // save and close when menu is closed
            if (!menuIsOpen && [
                'Enter',
                'Tab'
            ].includes(event.code)) {
                saveAndClose();
                // set close without saving to true because we already saved
                if ((0, $1ybV0.ff)('jira.list.field-support-part1')) shouldCloseWithoutSaving.current = true;
                return false;
            }
            // Reopen the menu when the user types or hits down arrow
            if (!menuIsOpen && (event.code === 'ArrowDown' || event.code.startsWith('Key') && !event.metaKey && !event.ctrlKey)) {
                setMenuIsOpen(true);
                return true;
            }
            if (event.code === 'Escape') {
                shouldCloseWithoutSaving.current = true;
                onEscapeKeyPress && onEscapeKeyPress();
            }
        }
        return false;
    }, [
        editMode,
        menuIsOpen,
        onEscapeKeyPress,
        saveAndClose,
        setMenuIsOpen
    ]);
    return {
        onKeyDown: onKeyDown,
        saveOnBlur: saveOnBlur,
        saveOnUnmount: saveOnUnmount
    };
};

});

parcelRegister("8NLkb", function(module, exports) {

$parcel$export(module.exports, "useCellSelected", () => $66741735f4c4d08e$export$82315ac370e9a611);
$parcel$export(module.exports, "useCellActions", () => $66741735f4c4d08e$export$98b52eeb50fa4d73);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4oWxH = parcelRequire("4oWxH");

var $gbsaq = parcelRequire("gbsaq");

var $bxcZe = parcelRequire("bxcZe");


var $l90Nb = parcelRequire("l90Nb");
const $66741735f4c4d08e$var$actions = {
    clearSelectedCell: ()=>({ setState: setState })=>{
            setState({
                selectedCell: undefined
            });
        },
    clearCopiedFromCell: ()=>({ setState: setState })=>{
            setState({
                copiedFromCell: null
            });
        },
    setSelectedCell: (columnIndex, rowIndex)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: selectedCell } = getState();
            if ((0, $l90Nb.checkIsCellSelected)(selectedCell, columnIndex, rowIndex)) return;
            setState({
                selectedCell: {
                    column: columnIndex,
                    row: rowIndex
                }
            });
        },
    setCopiedFromCell: (fieldId, issueId)=>({ setState: setState, getState: getState })=>{
            if (!fieldId || !issueId) return;
            const { copiedFromCell: copiedFromCell } = getState();
            if ((0, $l90Nb.checkIsCellCopiedFrom)(copiedFromCell, fieldId, issueId)) return;
            setState({
                copiedFromCell: {
                    fieldId: fieldId,
                    issueId: issueId
                }
            });
        },
    navigate: (direction, tableRef, dragAndDropButtonRow)=>({ setState: setState, getState: getState })=>{
            const { selectedCell: selectedCell } = getState();
            const tableRefProps = tableRef?.current?.table?.props;
            const tableData = tableRefProps?.data;
            const tableWidth = tableRefProps?.width || 0;
            const scrollLeft = tableRef?.current?.table?.bodyRef?.state?.scrollLeft || 0;
            const tableColumns = tableRefProps?.columns || [];
            const { visibleColumns: visibleColumns } = (0, $bxcZe.getColumnVisibilityIndexes)(scrollLeft, tableWidth, tableColumns);
            // Handle navigation from drag and drop button to the last cell of the row above.
            if (dragAndDropButtonRow && tableData) {
                // stay on the same cell if the new row is a group item row
                if ((0, $4oWxH.isGroupItem)(tableData?.[dragAndDropButtonRow - 1]?.issueId?.toString() || null)) return;
                (0, $l90Nb.scrollCellIntoView)(tableRef, visibleColumns, direction, {
                    column: 0,
                    row: dragAndDropButtonRow
                }, {
                    column: tableColumns.length - 1,
                    row: dragAndDropButtonRow - 1
                });
                setTimeout(()=>{
                    setState({
                        selectedCell: {
                            column: tableColumns.length - 1,
                            row: dragAndDropButtonRow - 1
                        }
                    });
                }, (0, $1b5de6ccc140bcab$export$c10811fdbc59f0be));
                return;
            }
            if (!selectedCell || !tableData) return;
            const { newColumnIndex: newColumnIndex, newRowIndex: newRowIndex } = (0, $l90Nb.getUpdatedNavigationIndexes)(selectedCell, direction, tableColumns, tableData);
            // stay on the same cell if the new row is a group item row
            if (tableData && (0, $4oWxH.isGroupItem)(tableData?.[newRowIndex]?.issueId?.toString() || null)) return;
            (0, $l90Nb.scrollCellIntoView)(tableRef, visibleColumns, direction, selectedCell, {
                column: newColumnIndex,
                row: newRowIndex
            });
            const prevCellColumn = selectedCell.column;
            // Focus on the drag and drop button only if the last column was selected
            // and the next selected column and row is the first of the next row.
            const shouldFocusOnDragAndDropButton = prevCellColumn === tableColumns.length - 1 && newColumnIndex === 0 && newRowIndex < tableData.length;
            // wait for all scroll, focus and blur events to finish before setting state
            if (shouldFocusOnDragAndDropButton) {
                const { issueId: issueId } = tableData[newRowIndex];
                setTimeout(()=>{
                    document.dispatchEvent(new CustomEvent(`${(0, $gbsaq.DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                        detail: {
                            issueId: issueId
                        }
                    }));
                }, (0, $1b5de6ccc140bcab$export$c10811fdbc59f0be));
            } else setTimeout(()=>{
                setState({
                    selectedCell: {
                        column: newColumnIndex,
                        row: newRowIndex
                    }
                });
            }, (0, $1b5de6ccc140bcab$export$c10811fdbc59f0be));
        }
};
const $66741735f4c4d08e$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: {
        selectedCell: undefined,
        copiedFromCell: null,
        prevScrolledColumnIndex: undefined
    },
    actions: $66741735f4c4d08e$var$actions,
    name: 'JwmCellNavigation'
});
const $66741735f4c4d08e$export$82315ac370e9a611 = (0, $ggKAj.createHook)($66741735f4c4d08e$export$390f32400eaf98c9, {
    // we need to use the selector to prevent unnecessary re-render in all the cells every time the focus change
    selector: (0, $l90Nb.getCellSelectedSelector)
});
const $66741735f4c4d08e$export$98b52eeb50fa4d73 = (0, $ggKAj.createActionsHook)($66741735f4c4d08e$export$390f32400eaf98c9);

});
const $1b5de6ccc140bcab$export$c10811fdbc59f0be = 50;

parcelRegister("l90Nb", function(module, exports) {

$parcel$export(module.exports, "checkIsCellSelected", () => $70b68bde1795f533$export$137ef1ae0e2f1e4f);
$parcel$export(module.exports, "checkIsCellCopiedFrom", () => $70b68bde1795f533$export$10a6e994f306d4c1);
$parcel$export(module.exports, "getCellSelectedSelector", () => $70b68bde1795f533$export$8faeda346ea872cf);
$parcel$export(module.exports, "getUpdatedNavigationIndexes", () => $70b68bde1795f533$export$e86d0c724f5bd464);
$parcel$export(module.exports, "scrollCellIntoView", () => $70b68bde1795f533$export$5d689075caa24122);

var $bnlpg = parcelRequire("bnlpg");

var $iTvqy = parcelRequire("iTvqy");

var $bj4JM = parcelRequire("bj4JM");

var $4oWxH = parcelRequire("4oWxH");

var $gbsaq = parcelRequire("gbsaq");
const $70b68bde1795f533$export$137ef1ae0e2f1e4f = (selectedCell, columnIndex, rowIndex)=>selectedCell ? selectedCell.column === columnIndex && selectedCell.row === rowIndex : false;
const $70b68bde1795f533$export$10a6e994f306d4c1 = (copiedCell, fieldId, issueId)=>{
    if (!copiedCell || !fieldId || !issueId) return false;
    return copiedCell.fieldId === fieldId && copiedCell.issueId === issueId;
};
const $70b68bde1795f533$export$8faeda346ea872cf = (0, $bj4JM.createSelector)((state, coordinate)=>({
        isCellSelected: $70b68bde1795f533$export$137ef1ae0e2f1e4f(state.selectedCell, coordinate.column, coordinate.row),
        isCellCopiedFrom: $70b68bde1795f533$export$10a6e994f306d4c1(state.copiedFromCell, coordinate.fieldId, coordinate.issueId)
    }), ({ isCellSelected: isCellSelected, isCellCopiedFrom: isCellCopiedFrom })=>({
        isSelected: isCellSelected,
        isCopiedFrom: isCellCopiedFrom ?? false
    }));
const $70b68bde1795f533$var$getNewColumnIndex = (initialCell, direction, totalColumns, totalRows)=>{
    const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
    const lastColumnIndex = totalColumns - 1;
    const lastRowIndex = totalRows - 1;
    const isFirstTableItem = initialColumnIndex === 0 && initialRowIndex === 0;
    const isLastTableItem = initialColumnIndex === lastColumnIndex && initialRowIndex === lastRowIndex;
    if (direction === (0, $gbsaq.LEFT) && !isFirstTableItem) return (initialColumnIndex || totalColumns) - 1;
    if (direction === (0, $gbsaq.RIGHT) && !isLastTableItem) return (initialColumnIndex + 1) % totalColumns;
    return initialColumnIndex;
};
const $70b68bde1795f533$var$getNewRowIndex = (initialCell, direction, tableData)=>{
    const { row: initialRowIndex } = initialCell;
    if (direction === (0, $gbsaq.UP)) {
        let newRowIndex = initialRowIndex - 1;
        while(newRowIndex > 0 && (0, $4oWxH.isGroupItem)(tableData[newRowIndex]?.issueId?.toString() || null))newRowIndex--;
        return Math.max(0, newRowIndex);
    }
    if (direction === (0, $gbsaq.DOWN)) {
        let nextRowIndex = initialRowIndex + 1;
        while(nextRowIndex < tableData.length && (0, $4oWxH.isGroupItem)(tableData[nextRowIndex]?.issueId?.toString() || null))nextRowIndex++;
        return Math.min(tableData.length - 1, nextRowIndex);
    }
    return initialRowIndex;
};
const $70b68bde1795f533$export$e86d0c724f5bd464 = (initialCell, direction, tableColumn, tableData)=>{
    const totalColumns = tableColumn.length;
    const totalRows = tableData.length;
    const newColumnIndex = $70b68bde1795f533$var$getNewColumnIndex(initialCell, direction, totalColumns, totalRows);
    if (direction === (0, $gbsaq.UP) || direction === (0, $gbsaq.DOWN)) {
        const newRowIndex = $70b68bde1795f533$var$getNewRowIndex(initialCell, direction, tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    if (direction === (0, $gbsaq.RIGHT) && newColumnIndex === 0) {
        const newRowIndex = $70b68bde1795f533$var$getNewRowIndex(initialCell, (0, $gbsaq.DOWN), tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    if (direction === (0, $gbsaq.LEFT) && newColumnIndex === totalColumns - 1) {
        const newRowIndex = $70b68bde1795f533$var$getNewRowIndex(initialCell, (0, $gbsaq.UP), tableData);
        return {
            newColumnIndex: newColumnIndex,
            newRowIndex: newRowIndex
        };
    }
    return {
        newColumnIndex: newColumnIndex,
        newRowIndex: initialCell.row
    };
};
const $70b68bde1795f533$export$5d689075caa24122 = (tableRef, visibleColumns, direction, initialCell, newCell)=>{
    const tableWidth = tableRef.current?.table?.props?.width || 0;
    const tableColumns = tableRef.current?.table?.props?.columns || [];
    const { column: initialColumnIndex, row: initialRowIndex } = initialCell;
    const { column: newColumnIndex, row: newRowIndex } = newCell;
    if (initialRowIndex !== newRowIndex) setTimeout(()=>tableRef.current?.scrollToRow(newRowIndex, 'auto'));
    if (direction === (0, $gbsaq.LEFT)) {
        const firstVisibleColumn = (0, (/*@__PURE__*/$parcel$interopDefault($bnlpg)))(visibleColumns);
        const shouldScrollColumnIntoView = firstVisibleColumn === initialColumnIndex || firstVisibleColumn === newColumnIndex || newColumnIndex > initialColumnIndex;
        if (shouldScrollColumnIntoView) {
            const scrollAmount = tableColumns.slice(0, newColumnIndex).reduce((acc, column)=>acc + column.width, 0);
            setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
        }
    }
    if (direction === (0, $gbsaq.RIGHT)) {
        const lastVisibleColumn = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(visibleColumns);
        const shouldScrollColumnIntoView = lastVisibleColumn === initialColumnIndex || lastVisibleColumn === newColumnIndex || newColumnIndex < initialColumnIndex;
        if (shouldScrollColumnIntoView) {
            const totalWidthUntilNextCell = tableColumns.slice(0, newColumnIndex + 1).reduce((acc, column)=>acc + column.width, 0);
            const scrollAmount = Math.max(0, totalWidthUntilNextCell - tableWidth);
            setTimeout(()=>tableRef.current?.scrollToLeft(scrollAmount));
        }
    }
};

});
parcelRegister("bnlpg", function(module, exports) {

module.exports = (parcelRequire("jtpa0"));

});
parcelRegister("jtpa0", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $e2d43e13ed703ec3$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $e2d43e13ed703ec3$var$head;

});




parcelRegister("17QbA", function(module, exports) {

$parcel$export(module.exports, "ClipboardController", () => $55d8fb78d038efe8$export$16d13693519be2ee);

var $eUqFw = parcelRequire("eUqFw");

var $31jh1 = parcelRequire("31jh1");

var $k82qK = parcelRequire("k82qK");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8NLkb = parcelRequire("8NLkb");
const $55d8fb78d038efe8$var$FLAG_ID = (0, $eo17r.toFlagId)('LIST_COPY_PASTE_FLAG');
const $55d8fb78d038efe8$var$UNSETTABLE_FIELD_TYPES = {
    issuekey: true,
    issuetype: true,
    priority: true,
    status: true,
    parent: true
};
const $55d8fb78d038efe8$var$canBeReset = (field)=>{
    const isEditable = field.fieldConfig?.isEditable ?? false;
    const isRequired = field.fieldConfig?.isRequired ?? false;
    if (field.type != null && field.type in $55d8fb78d038efe8$var$UNSETTABLE_FIELD_TYPES) return false;
    return isEditable && !isRequired;
};
const $55d8fb78d038efe8$export$16d13693519be2ee = ({ children: children, issue: issue, field: field, isSelected: isSelected, onKeyDown: onKeyDown })=>{
    const issueKey = issue?.key;
    const transformedField = issue?.fields?.find((f)=>{
        const fieldId = field.id === 'key' ? 'issuekey' : field.id;
        return f.fieldId === fieldId;
    });
    const { dismissFlag: dismissFlag, showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [clipboard, setClipboard] = (0, $eUqFw.useState)(null);
    const [isCutting, setIsCutting] = (0, $eUqFw.useState)(false);
    const { setCopiedFromCell: setCopiedFromCell, clearCopiedFromCell: clearCopiedFromCell } = (0, $8NLkb.useCellActions)();
    const isEditable = field.fieldConfig?.isEditable ?? true;
    const { copyCell: copyCell, renderPasteHandlerComponent: renderPasteHandlerComponent, renderCutHandlerComponent: renderCutHandlerComponent } = (0, $k82qK.useClipboard)({
        key: issueKey,
        issueId: issue?.issueId,
        issueType: issue?.issuetype
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    transformedField);
    const reportError = (0, $eUqFw.useCallback)(({ action: action, title: title, eventName: eventName, message: message, error: error })=>{
        showFlag({
            id: $55d8fb78d038efe8$var$FLAG_ID,
            type: 'error',
            title: title,
            description: message
        });
        const isValidationError = (0, $31jh1.isClientSideValidationError)(error);
        // We are handling validation errors so there is no need to log them to sentry.
        // Conscious of cost though, let's revisit this to see if it's worth keeping it.
        // https://jbusiness.atlassian.net/browse/FLINGO-824
        if (isValidationError) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), eventName || '', {
            fieldType: field.type,
            hasCopied: false,
            reason: error.message
        });
        else {
            const ugcSafeMessage = `Failed to ${action} a field of type ${field.type}`;
            (0, $guiFP.default)({
                meta: {
                    id: 'jiraClipboardController',
                    packageName: 'jiraBusinessList',
                    teamName: 'keystone'
                },
                attributes: {
                    message: ugcSafeMessage,
                    fieldType: field.type
                },
                error: new Error(ugcSafeMessage),
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        showFlag,
        createAnalyticsEvent,
        field.type
    ]);
    const onPaste = (0, $eUqFw.useCallback)((success)=>{
        dismissFlag($55d8fb78d038efe8$var$FLAG_ID);
        setClipboard(null);
        if (success) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell pasted', {
            fieldType: field.type
        });
        else reportError({
            action: 'paste',
            title: 'Unable to paste',
            message: `Failed to paste into ${field.name}`
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        field.name,
        field.type,
        reportError
    ]);
    const onCut = (0, $eUqFw.useCallback)((success)=>{
        dismissFlag($55d8fb78d038efe8$var$FLAG_ID);
        setIsCutting(false);
        if (!success) reportError({
            action: 'cut',
            title: 'Unable to cut',
            message: `Failed to cut ${field.name}, copied instead`
        });
    }, [
        dismissFlag,
        field.name,
        reportError
    ]);
    const paste = (0, $eUqFw.useCallback)((event)=>{
        const data = event.clipboardData;
        setClipboard({
            plainText: data?.getData('text/plain'),
            html: data?.getData('text/html')
        });
    }, [
        setClipboard
    ]);
    const copy = (0, $eUqFw.useCallback)(async ()=>{
        dismissFlag($55d8fb78d038efe8$var$FLAG_ID);
        try {
            setCopiedFromCell(field.id, issue?.issueId);
            await copyCell();
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell copied', {
                fieldType: field.type,
                hasCopied: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError({
                action: 'copy',
                title: 'Unable to copy',
                message: `Failed to copy ${field.name}`,
                eventName: 'cell copied',
                error: error
            });
            clearCopiedFromCell();
        }
    }, [
        clearCopiedFromCell,
        copyCell,
        createAnalyticsEvent,
        dismissFlag,
        field.id,
        field.name,
        field.type,
        issue?.issueId,
        reportError,
        setCopiedFromCell
    ]);
    const cut = (0, $eUqFw.useCallback)(async ()=>{
        dismissFlag($55d8fb78d038efe8$var$FLAG_ID);
        try {
            setCopiedFromCell(field.id, issue?.issueId);
            await copyCell();
            if ($55d8fb78d038efe8$var$canBeReset(field)) setIsCutting(true);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cell cut', {
                fieldType: field.type,
                canBeReset: $55d8fb78d038efe8$var$canBeReset(field),
                hasCopied: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            reportError({
                action: 'cut',
                title: 'Unable to cut',
                message: `Failed to cut ${field.name}`,
                eventName: 'cell cut',
                error: error
            });
            clearCopiedFromCell();
        }
    }, [
        dismissFlag,
        setCopiedFromCell,
        field,
        issue?.issueId,
        copyCell,
        createAnalyticsEvent,
        reportError,
        clearCopiedFromCell
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (isSelected && event.metaKey && event.key === 'c') {
            copy();
            return;
        }
        if (isSelected && event.metaKey && event.key === 'x') {
            cut();
            return;
        }
        onKeyDown(event);
    }, [
        copy,
        cut,
        isSelected,
        onKeyDown
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isSelected) document.addEventListener('paste', paste, true);
        else document.removeEventListener('paste', paste, true);
        return ()=>{
            document.removeEventListener('paste', paste, true);
        };
    }, [
        isSelected,
        paste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
        onKeyDown: handleKeyDown
    }), clipboard && isEditable && renderPasteHandlerComponent({
        clipboard: clipboard,
        onPaste: onPaste,
        onBeforePaste: clearCopiedFromCell
    }), isCutting && renderCutHandlerComponent({
        onCut: onCut
    }));
};

});
parcelRegister("31jh1", function(module, exports) {

$parcel$export(module.exports, "ClientSideValidationError", () => $e0e527e073c68fc8$export$5ba9b77898e6c81d);
$parcel$export(module.exports, "isClientSideValidationError", () => $e0e527e073c68fc8$export$ea2382f3076b0d69);
class $e0e527e073c68fc8$export$5ba9b77898e6c81d extends Error {
    constructor(message){
        super(message);
        this.name = 'ClientSideValidationError';
    }
}
const $e0e527e073c68fc8$export$ea2382f3076b0d69 = (error)=>error instanceof $e0e527e073c68fc8$export$5ba9b77898e6c81d;

});

parcelRegister("k82qK", function(module, exports) {

$parcel$export(module.exports, "useClipboard", () => $da90c978afa5b77c$export$2314ca2a3e892862);

var $eUqFw = parcelRequire("eUqFw");

var $31jh1 = parcelRequire("31jh1");

var $eI5EY = parcelRequire("eI5EY");

var $fGxlE = parcelRequire("fGxlE");

var $9jnJo = parcelRequire("9jnJo");
const $da90c978afa5b77c$export$2314ca2a3e892862 = (issue, field)=>{
    const copyCell = (0, $eUqFw.useCallback)(()=>{
        if (!field) throw new (0, $31jh1.ClientSideValidationError)("Can't copy, field not provided");
        const { html: html, plainText: plainText } = (0, $9jnJo.getCellValue)(field, issue);
        if (!plainText || !html) throw new (0, $31jh1.ClientSideValidationError)('Failed to get cell value, getter returned null or not available');
        return (0, $9jnJo.addToClipboard)(plainText, html);
    }, [
        field,
        issue
    ]);
    const renderPasteHandlerComponent = ({ clipboard: clipboard, onPaste: onPaste, onBeforePaste: onBeforePaste })=>{
        if (!field || !issue?.key || !issue?.issueId) return;
        const PasteHandlerComponent = (0, $fGxlE.getClipboardHandlerComponent)(field.type);
        if (!PasteHandlerComponent || !clipboard?.plainText || !clipboard?.html) return;
        const metadata = (0, $9jnJo.getFieldMetadataFromClipboard)(clipboard);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(PasteHandlerComponent, {
            issue: {
                key: issue.key,
                issueId: issue.issueId,
                issueType: issue?.issueType
            },
            field: field,
            action: "paste",
            clipboardItem: clipboard,
            onBeforeAction: onBeforePaste,
            onComplete: onPaste,
            metadata: metadata
        });
    };
    const renderCutHandlerComponent = ({ onCut: onCut })=>{
        if (!field || !issue?.key || !issue?.issueId) return;
        const CutHandlerComponent = (0, $fGxlE.getClipboardHandlerComponent)(field.type);
        if (!CutHandlerComponent) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CutHandlerComponent, {
            issue: {
                key: issue.key,
                issueId: issue.issueId
            },
            field: field,
            action: "cut",
            onComplete: onCut,
            metadata: {
                fieldId: field.fieldId,
                fieldType: field.type,
                fieldValue: null
            }
        });
    };
    if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) return {
        copyCell: (0, $9jnJo.notImplemented),
        renderPasteHandlerComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        renderCutHandlerComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    };
    return {
        copyCell: copyCell,
        renderPasteHandlerComponent: renderPasteHandlerComponent,
        renderCutHandlerComponent: renderCutHandlerComponent
    };
};

});
parcelRegister("fGxlE", function(module, exports) {

$parcel$export(module.exports, "getClipboardHandlerComponent", () => $568e885698759d2c$export$547cefce1a43344e);

var $5iWql = parcelRequire("5iWql");

var $ctkxZ = parcelRequire("ctkxZ");

var $h4XEw = parcelRequire("h4XEw");

var $jNdzl = parcelRequire("jNdzl");

var $fAOKd = parcelRequire("fAOKd");

var $itK3v = parcelRequire("itK3v");

var $ibP9o = parcelRequire("ibP9o");

var $3wSIr = parcelRequire("3wSIr");

var $1xv3U = parcelRequire("1xv3U");

var $5MhxU = parcelRequire("5MhxU");

var $9f078 = parcelRequire("9f078");

var $bN2A6 = parcelRequire("bN2A6");

var $i3YJS = parcelRequire("i3YJS");

var $gRRkp = parcelRequire("gRRkp");

var $hZbCV = parcelRequire("hZbCV");

var $6hel2 = parcelRequire("6hel2");

var $hENET = parcelRequire("hENET");

var $bde5A = parcelRequire("bde5A");

var $585wU = parcelRequire("585wU");

var $iYRy3 = parcelRequire("iYRy3");

var $9HYKH = parcelRequire("9HYKH");
const $568e885698759d2c$var$createClipboardHandlers = (0, $5iWql.default)(()=>({
        ...(0, $ctkxZ.categoryClipboardHandler),
        ...(0, $h4XEw.checkboxClipboardHandler),
        ...(0, $jNdzl.componentsClipboardHandler),
        ...(0, $9HYKH.versionClipboardHandler),
        ...(0, $ibP9o.labelsClipboardHandler),
        ...(0, $1xv3U.numberClipboardHandler),
        ...(0, $iYRy3.userClipboardHandler),
        ...(0, $iYRy3.multiUserClipboardHandler),
        ...(0, $3wSIr.multiSelectClipboardHandler),
        ...(0, $fAOKd.dateClipboardHandler),
        ...(0, $itK3v.dateTimeClipboardHandler),
        ...(0, $hENET.textClipboardHandler),
        ...(0, $i3YJS.richTextClipboardHandler),
        ...(0, $9f078.priorityClipboardHandler),
        ...(0, $gRRkp.singleSelectClipboardHandler),
        ...(0, $hZbCV.sprintClipboardHandler),
        ...(0, $bde5A.timeTrackingClipboardHandler),
        ...(0, $585wU.urlClipboardHandler),
        ...(0, $6hel2.teamClipboardHandler),
        ...(0, $5MhxU.parentClipboardHandler),
        ...(0, $bN2A6.projectClipboardHandler)
    }));
const $568e885698759d2c$export$547cefce1a43344e = (fieldType)=>{
    const handlers = $568e885698759d2c$var$createClipboardHandlers();
    if (handlers[fieldType] == null) return;
    return handlers[fieldType];
};

});
parcelRegister("ctkxZ", function(module, exports) {

$parcel$export(module.exports, "categoryClipboardHandler", () => $7eb726a413de409b$export$b2a7ae1b92d8afd3);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $69Iuh = parcelRequire("69Iuh");
const $7eb726a413de409b$var$isTransformedCategory = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
const $7eb726a413de409b$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $69Iuh.categorySupportedTypes).includes(metadata.fieldType)) return null;
    if (!$7eb726a413de409b$var$isTransformedCategory(metadata.fieldValue)) return null;
    return {
        id: metadata.fieldValue.optionId,
        value: metadata.fieldValue.value,
        color: metadata.fieldValue.color
    };
};
const $7eb726a413de409b$var$useCategoryClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: (0, $lO4Or.CATEGORY_TYPE),
        initialValue: field.value && $7eb726a413de409b$var$isTransformedCategory(field.value) ? {
            id: field.value.optionId,
            value: field.value.value,
            color: field.value?.color
        } : null
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $7eb726a413de409b$var$getPastedValue, saveValue);
};
const $7eb726a413de409b$var$CategoryClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($7eb726a413de409b$var$useCategoryClipboardHandler);
const $7eb726a413de409b$export$b2a7ae1b92d8afd3 = {
    [(0, $lO4Or.CATEGORY_TYPE)]: $7eb726a413de409b$var$CategoryClipboardHelper
};

});
parcelRegister("b3neV", function(module, exports) {

$parcel$export(module.exports, "useGenericClipboardHandler", () => $57b515a82db815e8$export$6949e645bc59f2fc);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");
function $57b515a82db815e8$export$6949e645bc59f2fc(field, getValue, saveValue, emptyValue) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const pasteHandler = (0, $eUqFw.useCallback)(async (clipboardItem, metadata)=>{
        try {
            const value = getValue(clipboardItem, metadata);
            if (!value || Array.isArray(value) && !value.length) return false;
            await saveValue(value, null, createAnalyticsEvent({
                action: 'pasted',
                actionSubject: 'field',
                actionSubjectId: field?.type
            }));
            return true;
        } catch (e) {
            return false;
        }
    }, [
        getValue,
        saveValue,
        createAnalyticsEvent,
        field?.type
    ]);
    const cutHandler = (0, $eUqFw.useCallback)(async ()=>{
        try {
            await saveValue(emptyValue ?? null, null, createAnalyticsEvent({
                action: 'cut',
                actionSubject: 'field',
                actionSubjectId: field?.type
            }));
            return true;
        } catch (e) {
            return false;
        }
    }, [
        saveValue,
        emptyValue,
        createAnalyticsEvent,
        field?.type
    ]);
    return {
        pasteHandler: pasteHandler,
        cutHandler: cutHandler
    };
}

});

parcelRegister("fdgl2", function(module, exports) {

$parcel$export(module.exports, "createClipboardHelperComponent", () => $7815b1800327a73c$export$6ac5565d32c446cd);

var $eUqFw = parcelRequire("eUqFw");
const $7815b1800327a73c$export$6ac5565d32c446cd = (useFieldPasteHandler)=>({ issue: issue, field: field, clipboardItem: clipboardItem, onComplete: onComplete, metadata: metadata, action: action, onBeforeAction: onBeforeAction })=>{
        const [hasBeenCalled, setHasBeenCalled] = (0, $eUqFw.useState)(false);
        const { pasteHandler: pasteHandler, cutHandler: cutHandler } = useFieldPasteHandler(issue, field);
        (0, $eUqFw.useEffect)(()=>{
            async function handlePaste() {
                if (!clipboardItem || hasBeenCalled) return;
                setHasBeenCalled(true);
                onBeforeAction?.();
                const success = await pasteHandler(clipboardItem, metadata);
                onComplete(success);
            }
            if (action === 'paste') handlePaste();
        }, [
            clipboardItem,
            onComplete,
            pasteHandler,
            metadata,
            hasBeenCalled,
            action,
            onBeforeAction
        ]);
        (0, $eUqFw.useEffect)(()=>{
            async function handleCut() {
                if (hasBeenCalled) return;
                setHasBeenCalled(true);
                onBeforeAction?.();
                const success = await cutHandler();
                onComplete(success);
            }
            if (action === 'cut') handleCut();
        }, [
            clipboardItem,
            onComplete,
            cutHandler,
            metadata,
            hasBeenCalled,
            action,
            onBeforeAction
        ]);
        return null;
    };

});

parcelRegister("69Iuh", function(module, exports) {

$parcel$export(module.exports, "categorySupportedTypes", () => $d49feed23d45c461$export$7a3abb279a994c7d);

var $lO4Or = parcelRequire("lO4Or");
const $d49feed23d45c461$export$7a3abb279a994c7d = [
    (0, $lO4Or.CATEGORY_TYPE)
];

});


parcelRegister("h4XEw", function(module, exports) {

$parcel$export(module.exports, "checkboxClipboardHandler", () => $ed7eae438cfded43$export$a637ce753d346a9a);

var $3kVrU = parcelRequire("3kVrU");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $gcaYz = parcelRequire("gcaYz");
const $ed7eae438cfded43$var$isTransformedCheckboxOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
const $ed7eae438cfded43$var$isTransformedCheckbox = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($ed7eae438cfded43$var$isTransformedCheckboxOption);
const $ed7eae438cfded43$var$emptyValue = [];
const $ed7eae438cfded43$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldType || !metadata?.fieldValue) return [];
    if (!$ed7eae438cfded43$var$isTransformedCheckbox(metadata?.fieldValue)) return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $gcaYz.checkboxSupportedTypes).includes(metadata.fieldType)) return [];
    return metadata?.fieldValue.filter(Boolean).map((option)=>({
            id: option.optionId,
            value: option.value ?? ''
        }));
};
const $ed7eae438cfded43$var$useCheckboxClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $3kVrU.useCheckboxSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $ed7eae438cfded43$var$getPastedValue, saveValue, $ed7eae438cfded43$var$emptyValue);
};
const $ed7eae438cfded43$var$CheckboxClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($ed7eae438cfded43$var$useCheckboxClipboardHandler);
const $ed7eae438cfded43$export$a637ce753d346a9a = {
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $ed7eae438cfded43$var$CheckboxClipboardHelper
};

});
parcelRegister("3kVrU", function(module, exports) {

$parcel$export(module.exports, "useCheckboxSelectField", () => $5ddb6026d509605f$export$64fe88e084e8ce22);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");
const $5ddb6026d509605f$export$64fe88e084e8ce22 = ({ issueKey: issueKey, initialValue: initialValue = null, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, $btjMs.getFieldType)(fieldConfig.value) || 'array';
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
parcelRegister("btjMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $2e3967e17ab00816$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $2e3967e17ab00816$export$24d1b07fa0e9f9f1);


var $f9RL0 = parcelRequire("f9RL0");

var $lO4Or = parcelRequire("lO4Or");
const $2e3967e17ab00816$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $f9RL0.specialFields)();
    return [
        ...(0, $f9RL0.customFieldsToDisplay)().filter((cf)=>!(0, $f9RL0.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $lO4Or.FLAGGED_CF_TYPE)
    ];
};
const $2e3967e17ab00816$export$f521834fc2bfcd81 = (custom)=>$2e3967e17ab00816$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $2e3967e17ab00816$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $2e3967e17ab00816$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $2e3967e17ab00816$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || $2e3967e17ab00816$export$b9089a6e41ed43aa(field) === (0, $lO4Or.DESCRIPTION_TYPE) : false;
};

});
const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("f9RL0", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $3183c1ede6a2aff4$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $3183c1ede6a2aff4$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $3183c1ede6a2aff4$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $3183c1ede6a2aff4$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $3183c1ede6a2aff4$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $3183c1ede6a2aff4$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $3183c1ede6a2aff4$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $3183c1ede6a2aff4$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $3183c1ede6a2aff4$export$6d7021166edc895c);
$parcel$export(module.exports, "PRIORITY", () => $3183c1ede6a2aff4$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $3183c1ede6a2aff4$export$79b91d4669dcadcb);
$parcel$export(module.exports, "DEV_SUMMARY", () => $3183c1ede6a2aff4$export$950d47e775e208ee);
$parcel$export(module.exports, "EPIC", () => $3183c1ede6a2aff4$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $3183c1ede6a2aff4$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $3183c1ede6a2aff4$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $3183c1ede6a2aff4$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $3183c1ede6a2aff4$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $3183c1ede6a2aff4$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $3183c1ede6a2aff4$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $3183c1ede6a2aff4$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SLA_PANEL", () => $3183c1ede6a2aff4$export$1d0e0bb6a21b800b);
$parcel$export(module.exports, "LINKED_ALERTS", () => $3183c1ede6a2aff4$export$340fac260c3e3637);
$parcel$export(module.exports, "CHAT_CHANNEL", () => $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef);
$parcel$export(module.exports, "MSTEAMS_CHANNEL", () => $3183c1ede6a2aff4$export$8631065e0909313);
$parcel$export(module.exports, "ZOOM_MEETING", () => $3183c1ede6a2aff4$export$3c4dccba7d7e0acb);
$parcel$export(module.exports, "CONFERENCE_CALL", () => $3183c1ede6a2aff4$export$cd5e9246357daec3);
$parcel$export(module.exports, "KNOWLEDGE_BASE", () => $3183c1ede6a2aff4$export$203643a6fd9496a0);
$parcel$export(module.exports, "SENTIMENT", () => $3183c1ede6a2aff4$export$9c83bd19c3ffd90d);
$parcel$export(module.exports, "ASSET_ONBOARDING", () => $3183c1ede6a2aff4$export$c5c04443c6097d6e);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS", () => $3183c1ede6a2aff4$export$26d855f4cd7e5fe9);
$parcel$export(module.exports, "SUMMARY", () => $3183c1ede6a2aff4$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $3183c1ede6a2aff4$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $3183c1ede6a2aff4$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $3183c1ede6a2aff4$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $3183c1ede6a2aff4$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $3183c1ede6a2aff4$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $3183c1ede6a2aff4$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $3183c1ede6a2aff4$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $3183c1ede6a2aff4$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $3183c1ede6a2aff4$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $3183c1ede6a2aff4$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $3183c1ede6a2aff4$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $3183c1ede6a2aff4$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $3183c1ede6a2aff4$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $3183c1ede6a2aff4$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $3183c1ede6a2aff4$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $3183c1ede6a2aff4$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $3183c1ede6a2aff4$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $3183c1ede6a2aff4$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $3183c1ede6a2aff4$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $3183c1ede6a2aff4$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $3183c1ede6a2aff4$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $3183c1ede6a2aff4$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $3183c1ede6a2aff4$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $3183c1ede6a2aff4$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");

var $lO4Or = parcelRequire("lO4Or");
const $3183c1ede6a2aff4$export$ebb48b08205007c5 = 'issuetype';
const $3183c1ede6a2aff4$export$a464614f8f5fe986 = 'summary';
const $3183c1ede6a2aff4$export$a311a3c9b207604e = 'parent';
const $3183c1ede6a2aff4$export$2a4f270075a033de = 'parent-issue';
const $3183c1ede6a2aff4$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $3183c1ede6a2aff4$export$289917d9a7031e1d = 'watches';
const $3183c1ede6a2aff4$export$81614f6dc3be5b00 = 'votes';
const $3183c1ede6a2aff4$export$72a5630aa398d6b4 = 'security';
const $3183c1ede6a2aff4$export$caf1ff54fbdf44bf = 'issuerestriction';
const $3183c1ede6a2aff4$export$f8f7545d2bb78afb = 'assignee';
const $3183c1ede6a2aff4$export$6d7021166edc895c = 'reporter';
const $3183c1ede6a2aff4$export$cf7e173386d30cdd = 'duedate';
const $3183c1ede6a2aff4$export$bb34f3538ba26c7e = 'priority';
const $3183c1ede6a2aff4$export$79b91d4669dcadcb = 'labels';
const $3183c1ede6a2aff4$export$cbedbfe2cd0caec7 = 'components';
const $3183c1ede6a2aff4$export$950d47e775e208ee = 'devSummary';
const $3183c1ede6a2aff4$export$f91d2bb4cc99fa5e = 'releases';
const $3183c1ede6a2aff4$export$a316570a0dbfd2b0 = 'sprint';
const $3183c1ede6a2aff4$export$405b6d72f2d243a9 = 'storyPointsField';
const $3183c1ede6a2aff4$export$3cb4a99a332e4186 = 'epic';
const $3183c1ede6a2aff4$export$d7e18f5730074533 = 'fixVersions';
const $3183c1ede6a2aff4$export$c435f0000304e508 = 'versions';
const $3183c1ede6a2aff4$export$ee99ef6ee562a446 = 'timetracking';
const $3183c1ede6a2aff4$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $3183c1ede6a2aff4$export$e50006273435e7d4 = 'status';
const $3183c1ede6a2aff4$export$f1a6ce22cbb7eb32 = 'resolution';
const $3183c1ede6a2aff4$export$ff39ebd4bb12b718 = 'created';
const $3183c1ede6a2aff4$export$cd8e68094cb5c3cb = 'updated';
const $3183c1ede6a2aff4$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $3183c1ede6a2aff4$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $3183c1ede6a2aff4$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $3183c1ede6a2aff4$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $3183c1ede6a2aff4$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $3183c1ede6a2aff4$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $3183c1ede6a2aff4$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $3183c1ede6a2aff4$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $3183c1ede6a2aff4$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $3183c1ede6a2aff4$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $3183c1ede6a2aff4$export$913055729e1380b2 = 'summary';
const $3183c1ede6a2aff4$export$d44826c816b5619b = 'description';
const $3183c1ede6a2aff4$export$a29989082612d0d9 = 'comment';
const $3183c1ede6a2aff4$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $3183c1ede6a2aff4$export$3b3d0889022c85b3 = 'children-issues';
const $3183c1ede6a2aff4$export$be46596bc6608f3b = 'environment';
const $3183c1ede6a2aff4$export$f528fadbfdb3c25e = 'subtasks';
const $3183c1ede6a2aff4$export$f10e53e8928b61bd = 'dataclassification';
const $3183c1ede6a2aff4$export$e0dfb65d1047c53c = (0, $lO4Or.PARENT_CF_TYPE);
const $3183c1ede6a2aff4$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $3183c1ede6a2aff4$export$cdbd1eb3b05729e0 = 'flagActions';
const $3183c1ede6a2aff4$export$c161a774ec2e7e56 = 'cardCoverActions';
const $3183c1ede6a2aff4$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$3183c1ede6a2aff4$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$3183c1ede6a2aff4$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$3183c1ede6a2aff4$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $lO4Or.TEAM_CF_TYPE),
        [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $lO4Or.PARENT_CF_TYPE),
        [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $lO4Or.BASELINE_START_CF_TYPE),
        [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $lO4Or.BASELINE_END_CF_TYPE),
        [(0, $lO4Or.COLOR_CF_TYPE)]: (0, $lO4Or.COLOR_CF_TYPE),
        [(0, $lO4Or.EPIC_COLOR_TYPE)]: (0, $lO4Or.EPIC_COLOR_TYPE),
        [(0, $lO4Or.EPIC_NAME_TYPE)]: (0, $lO4Or.EPIC_NAME_TYPE)
    };
    return fields;
};
const $3183c1ede6a2aff4$export$87934b3672715c91 = [
    (0, $lO4Or.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $lO4Or.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $3183c1ede6a2aff4$var$serviceDeskCustomFields = [
    (0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $lO4Or.ORGANIZATIONS_CF_TYPE),
    (0, $lO4Or.REQUEST_LANGUAGE_CF_TYPE),
    (0, $lO4Or.REQUEST_FEEDBACK_CF_TYPE),
    (0, $lO4Or.APPROVALS_CF_TYPE),
    (0, $lO4Or.APPROVERS_LIST_CF_TYPE),
    (0, $lO4Or.REQUEST_TYPE_CF_TYPE),
    (0, $lO4Or.CMDB_OBJECT_CF_TYPE),
    (0, $lO4Or.RESPONDERS_CF_TYPE),
    (0, $lO4Or.MAJOR_INCIDENT_CF_TYPE),
    (0, $lO4Or.ENTITLEMENT_CF_TYPE),
    (0, $lO4Or.SENTIMENT_CF_TYPE)
];
const $3183c1ede6a2aff4$export$efd443bccc4c01ed = ()=>[
        (0, $lO4Or.LABELS_CF_TYPE),
        (0, $lO4Or.TEXT_CF_TYPE),
        (0, $lO4Or.MULTI_USER_CF_TYPE),
        (0, $lO4Or.PARTICIPANTS_CF_TYPE),
        (0, $lO4Or.URL_CF_TYPE),
        (0, $lO4Or.NUMBER_CF_TYPE),
        (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $lO4Or.SELECT_CF_TYPE),
        (0, $lO4Or.MULTI_SELECT_CF_TYPE),
        (0, $lO4Or.VERSION_CF_TYPE),
        (0, $lO4Or.TEXT_AREA_CF_TYPE),
        (0, $lO4Or.MULTI_VERSION_CF_TYPE),
        (0, $lO4Or.DATE_CF_TYPE),
        (0, $lO4Or.GROUP_CF_TYPE),
        (0, $lO4Or.MULTI_GROUP_CF_TYPE),
        (0, $lO4Or.USER_CF_TYPE),
        (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
        (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
        (0, $lO4Or.DATETIME_CF_TYPE),
        (0, $lO4Or.ASSETS_CF_TYPE),
        (0, $lO4Or.SERVICE_ENTITY_CF_TYPE),
        (0, $lO4Or.PEOPLE_CF_TYPE),
        (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
        (0, $lO4Or.PROJECT_PICKER_CF_TYPE),
        (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE),
        (0, $lO4Or.READ_ONLY_CF_TYPE),
        (0, $lO4Or.EPIC_STATUS_TYPE),
        (0, $lO4Or.MESSAGE_VIEW_CF_TYPE),
        (0, $lO4Or.MESSAGE_EDIT_CF_TYPE),
        (0, $lO4Or.CATEGORY_TYPE),
        (0, $lO4Or.GOALS_CF_TYPE),
        ...$3183c1ede6a2aff4$export$87934b3672715c91,
        ...$3183c1ede6a2aff4$var$serviceDeskCustomFields
    ];
const $3183c1ede6a2aff4$export$a18b3a656ee9c709 = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $7ZZxN.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $3183c1ede6a2aff4$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $3183c1ede6a2aff4$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0,
            $3183c1ede6a2aff4$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $3183c1ede6a2aff4$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $3183c1ede6a2aff4$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $2wUFy.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $3183c1ede6a2aff4$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $3183c1ede6a2aff4$export$aebf676dfa727a1c();
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $3183c1ede6a2aff4$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $3183c1ede6a2aff4$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $3183c1ede6a2aff4$export$27e0678365e5dcff();
    }
    return $3183c1ede6a2aff4$export$27e0678365e5dcff();
};

});



parcelRegister("gcaYz", function(module, exports) {

$parcel$export(module.exports, "checkboxSupportedTypes", () => $b10ae96510d2501d$export$432ca25b66c37cc2);

var $lO4Or = parcelRequire("lO4Or");
const $b10ae96510d2501d$export$432ca25b66c37cc2 = [
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)
];

});


parcelRegister("jNdzl", function(module, exports) {

$parcel$export(module.exports, "componentsClipboardHandler", () => $0d8972d026e3d3d0$export$4edb8679282799b3);

var $eUqFw = parcelRequire("eUqFw");

var $hs4xt = parcelRequire("hs4xt");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $gFwk1 = parcelRequire("gFwk1");
const $0d8972d026e3d3d0$var$isTransformedComponentsOption = (option)=>!!option && typeof option === 'object' && 'componentId' in option && 'name' in option;
const $0d8972d026e3d3d0$var$isTransformedComponents = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($0d8972d026e3d3d0$var$isTransformedComponentsOption);
const $0d8972d026e3d3d0$var$emptyValue = [];
const $0d8972d026e3d3d0$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldType || !metadata?.fieldValue) return [];
    if (!$0d8972d026e3d3d0$var$isTransformedComponents(metadata?.fieldValue)) return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $gFwk1.componentsSupportedTypes).includes(metadata.fieldType)) return [];
    return metadata?.fieldValue.map(({ componentId: componentId, name: name })=>({
            id: componentId,
            name: name
        }));
};
const $0d8972d026e3d3d0$var$useComponentsClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $hs4xt.useComponentsField)({
        issueKey: issue.key
    });
    const saveValueFn = (0, $eUqFw.useCallback)((value, meta, analyticsEvent)=>/**
			 * Wrap saveValue to make sure the saved value is never set to `null`
			 */ saveValue(value ?? [], meta, analyticsEvent), [
        saveValue
    ]);
    return (0, $b3neV.useGenericClipboardHandler)(field, $0d8972d026e3d3d0$var$getPastedValue, saveValueFn, $0d8972d026e3d3d0$var$emptyValue);
};
const $0d8972d026e3d3d0$var$ComponentsClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($0d8972d026e3d3d0$var$useComponentsClipboardHandler);
const $0d8972d026e3d3d0$export$4edb8679282799b3 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $0d8972d026e3d3d0$var$ComponentsClipboardHelper
};

});
parcelRegister("hs4xt", function(module, exports) {

$parcel$export(module.exports, "useComponentsField", () => $4f90c282b64d4b9f$export$adf68b6acc459cc4);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

const $4f90c282b64d4b9f$export$adf68b6acc459cc4 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $ebc098a76317be78$export$98a935eb30de54ab));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    const [{ loading: loading, value: value, error: error }, { saveById: saveById, saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $ebc098a76317be78$export$98a935eb30de54ab),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};

});
const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';


parcelRegister("gFwk1", function(module, exports) {

$parcel$export(module.exports, "componentsSupportedTypes", () => $3f70833a116d9732$export$99fbea5790ee13d2);

var $lO4Or = parcelRequire("lO4Or");
const $3f70833a116d9732$export$99fbea5790ee13d2 = [
    (0, $lO4Or.COMPONENTS_TYPE)
];

});


parcelRegister("fAOKd", function(module, exports) {

$parcel$export(module.exports, "dateClipboardHandler", () => $2aa73fa7c83b6a05$export$e718187ed2d7ce50);

var $6c1W0 = parcelRequire("6c1W0");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $6xy2l = parcelRequire("6xy2l");
const $2aa73fa7c83b6a05$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !clipboardItem.plainText || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $6xy2l.dateSupportedTypes).includes(metadata.fieldType)) return null;
    return clipboardItem.plainText;
};
const $2aa73fa7c83b6a05$var$useDateClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $6c1W0.useDateField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $2aa73fa7c83b6a05$var$getPastedValue, saveValue);
};
const $2aa73fa7c83b6a05$var$DateClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($2aa73fa7c83b6a05$var$useDateClipboardHandler);
const $2aa73fa7c83b6a05$export$e718187ed2d7ce50 = {
    [(0, $lO4Or.START_DATE_TYPE)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.UPDATED)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.CREATED)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $2aa73fa7c83b6a05$var$DateClipboardHelper,
    [(0, $lO4Or.DATE_CF_TYPE)]: $2aa73fa7c83b6a05$var$DateClipboardHelper
};

});
parcelRegister("6c1W0", function(module, exports) {

$parcel$export(module.exports, "useDateField", () => $7692b2da789358d0$export$5591b0b878c1a989);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $7692b2da789358d0$export$5591b0b878c1a989 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'date';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("6xy2l", function(module, exports) {

$parcel$export(module.exports, "dateSupportedTypes", () => $ba294b5cfcdf4821$export$c1d8f1bf05dab6ae);

var $lO4Or = parcelRequire("lO4Or");
const $ba294b5cfcdf4821$export$c1d8f1bf05dab6ae = [
    (0, $lO4Or.START_DATE_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.CREATED),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.DATE_CF_TYPE)
];

});


parcelRegister("itK3v", function(module, exports) {

$parcel$export(module.exports, "dateTimeClipboardHandler", () => $4827bafd30cf6b12$export$6fbf80b68eb3090c);

var $j9Hm5 = parcelRequire("j9Hm5");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $laQ5X = parcelRequire("laQ5X");
const $4827bafd30cf6b12$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !clipboardItem.plainText || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $laQ5X.dateTimeSupportedTypes).includes(metadata.fieldType)) return null;
    return clipboardItem.plainText;
};
const $4827bafd30cf6b12$var$useDateTimeClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $j9Hm5.useDateTimeField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $4827bafd30cf6b12$var$getPastedValue, saveValue);
};
const $4827bafd30cf6b12$var$DateTimeClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($4827bafd30cf6b12$var$useDateTimeClipboardHandler);
const $4827bafd30cf6b12$export$6fbf80b68eb3090c = {
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $4827bafd30cf6b12$var$DateTimeClipboardHelper
};

});
parcelRegister("j9Hm5", function(module, exports) {

$parcel$export(module.exports, "useDateTimeField", () => $8718ed734e82bf7e$export$2c2e7f1ceedfa8fa);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $8718ed734e82bf7e$export$2c2e7f1ceedfa8fa = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.type ?? 'datetime';
    const [{ loading: loading, value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            loading: loading,
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("laQ5X", function(module, exports) {

$parcel$export(module.exports, "dateTimeSupportedTypes", () => $5882c179372923c3$export$80f63aa16e4e1227);

var $lO4Or = parcelRequire("lO4Or");
const $5882c179372923c3$export$80f63aa16e4e1227 = [
    (0, $lO4Or.DATETIME_CF_TYPE)
];

});


parcelRegister("ibP9o", function(module, exports) {

$parcel$export(module.exports, "labelsClipboardHandler", () => $3eaf5d4878c2478d$export$b0d4c8fecec395de);

var $chsVw = parcelRequire("chsVw");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $3eaf5d4878c2478d$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !clipboardItem.plainText) return null;
    if (metadata?.fieldType && metadata?.fieldType !== (0, $lO4Or.LABELS_TYPE) && metadata?.fieldType !== (0, $lO4Or.LABELS_CF_TYPE)) return null;
    return clipboardItem.plainText.split(',').map((label)=>label.trim());
};
const $3eaf5d4878c2478d$var$useLabelsClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $chsVw.useLabelsField)({
        issueKey: issue.key,
        issueId: issue.issueId,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $3eaf5d4878c2478d$var$getPastedValue, saveValue);
};
const $3eaf5d4878c2478d$var$LabelsClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($3eaf5d4878c2478d$var$useLabelsClipboardHandler);
const $3eaf5d4878c2478d$export$b0d4c8fecec395de = {
    [(0, $lO4Or.LABELS_TYPE)]: $3eaf5d4878c2478d$var$LabelsClipboardHelper,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $3eaf5d4878c2478d$var$LabelsClipboardHelper
};

});
parcelRegister("chsVw", function(module, exports) {

$parcel$export(module.exports, "useLabelsField", () => $422b17732b7d1725$export$64894e54f74d7bc5);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");


var $3qzNZ = parcelRequire("3qzNZ");
const $422b17732b7d1725$export$64894e54f74d7bc5 = ({ fieldKey: // `fieldKey` can be `labels` or `customfield_`
fieldKey, issueId: issueId, issueKey: issueKey, fieldType: fieldType, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue })=>{
    const saveLabelsFieldField = (0, $3qzNZ.useSaveLabelsField)(issueId);
    const saveField = saveLabelsFieldField;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const labelsFieldType = fieldType || (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'array');
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldType: labelsFieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue || null,
        fieldKey: fieldKey || (0, $ebc098a76317be78$export$93605f2a09aa8d26),
        saveField: saveField
    });
    return [
        {
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("3qzNZ", function(module, exports) {

$parcel$export(module.exports, "useSaveLabelsField", () => $8c72e74753e30ea2$export$212ad40ad2c2a1db);

var $lhgd8 = parcelRequire("lhgd8");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7byHA = parcelRequire("7byHA");

var $dWLk9 = parcelRequire("dWLk9");
/**
 * @deprecated (do not copy/use) TODO: find a way to get ari rather than building it
 * https://jplat.atlassian.net/browse/JIV-13978
 */ const $8c72e74753e30ea2$var$buildId = (cloudId, issueId, fieldKey)=>`ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldKey}`;
const $8c72e74753e30ea2$export$212ad40ad2c2a1db = (issueId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [commit] = (0, $iWLL0.useMutation)((0, $lhgd8.default));
    return (0, $eUqFw.useCallback)(async (_issueKey, fieldKey, value)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: $8c72e74753e30ea2$var$buildId(cloudId, issueId, fieldKey),
                        operations: [
                            {
                                operation: 'SET',
                                labels: value || []
                            }
                        ]
                    }
                },
                onCompleted (mutationData) {
                    if (mutationData.jira?.updateLabelsField) {
                        const { success: success, errors: responseErrors } = mutationData.jira?.updateLabelsField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $7byHA.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating labels'));
                    } else reject(new Error('Unknown error when mutating labels'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("lhgd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25cdafdd920c3753$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c11ab75238f9f278d90a1487bd50f054>>
 * @relayHash d660b7a8b39585d942e3868f452ae2a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d8f8d6bc107a9af3a9c530285495c2cea39cca04298631ed734969b32b449d2
const $25cdafdd920c3753$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "labels_issueFieldLabelsInlineEditViewFull_LabelsInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveLabelsField_LabelsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraLabelsFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateLabelsField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraLabelsField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000
                                                }
                                            ],
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalCount"
                                                },
                                                {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d8f8d6bc107a9af3a9c530285495c2cea39cca04298631ed734969b32b449d2",
            "metadata": {},
            "name": "useSaveLabelsField_LabelsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$25cdafdd920c3753$var$node.hash = "8ad20115daf17ea5e9001db36624cdd7";
var $25cdafdd920c3753$export$2e2bcd8739ae039 = $25cdafdd920c3753$var$node;

});




parcelRegister("3wSIr", function(module, exports) {

$parcel$export(module.exports, "multiSelectClipboardHandler", () => $6edc28b737f52a91$export$4181cf95bcdec65a);

var $acd3W = parcelRequire("acd3W");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $bNbdC = parcelRequire("bNbdC");
const $6edc28b737f52a91$var$isTransformedMultiSelectOption = (option)=>!!option && typeof option === 'object' && 'optionId' in option && 'value' in option;
const $6edc28b737f52a91$var$isTransformedMultiSelect = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($6edc28b737f52a91$var$isTransformedMultiSelectOption);
const $6edc28b737f52a91$var$emptyValue = [];
const $6edc28b737f52a91$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldType || !metadata?.fieldValue || !$6edc28b737f52a91$var$isTransformedMultiSelect(metadata?.fieldValue)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $bNbdC.multiSelectSupportedTypes).includes(metadata.fieldType)) return null;
    return metadata?.fieldValue.filter(Boolean).map(({ optionId: optionId, value: value })=>({
            id: optionId,
            value: value
        }));
};
const $6edc28b737f52a91$var$useMultiSelectClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $acd3W.useMultiSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: (0, $lO4Or.MULTI_SELECT_CF_TYPE)
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $6edc28b737f52a91$var$getPastedValue, saveValue, $6edc28b737f52a91$var$emptyValue);
};
const $6edc28b737f52a91$var$MultiSelectClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($6edc28b737f52a91$var$useMultiSelectClipboardHandler);
const $6edc28b737f52a91$export$4181cf95bcdec65a = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $6edc28b737f52a91$var$MultiSelectClipboardHelper
};

});
parcelRegister("acd3W", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectField", () => $f76affc570fb2705$export$de455e978fcfd3cf);
$parcel$export(module.exports, "useMultiSelectField", () => $f76affc570fb2705$export$a996b308983609cf);

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $btjMs = parcelRequire("btjMs");

var $bbmmE = parcelRequire("bbmmE");
const $f76affc570fb2705$var$useSelectField = ({ issueKey: issueKey, fieldKey: fieldKey, fieldDefaultSchemaType: fieldDefaultSchemaType, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField, fieldType: fieldType, initialValue: initialValue })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const resolvedFieldType = fieldType || (0, $btjMs.getFieldType)(fieldConfig.value) || fieldDefaultSchemaType;
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, saveById: saveById, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: resolvedFieldType,
        initialValue: // @ts-expect-error Fix in https://jplat.jira.atlassian.cloud/browse/JIV-17559
        initialValue,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            loading: loading,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            saveById: saveById,
            resetError: resetError
        }
    ];
};
const $f76affc570fb2705$export$de455e978fcfd3cf = (props)=>{
    const saveSingleSelectField = (0, $bbmmE.useSingleSelectMutation)();
    return $f76affc570fb2705$var$useSelectField({
        ...props,
        saveField: saveSingleSelectField,
        fieldDefaultSchemaType: 'option'
    });
};
const $f76affc570fb2705$export$a996b308983609cf = (props)=>$f76affc570fb2705$var$useSelectField({
        ...props,
        fieldDefaultSchemaType: 'array'
    });

});
parcelRegister("bbmmE", function(module, exports) {

$parcel$export(module.exports, "useSingleSelectMutation", () => $5f37b5f5d09f1a30$export$e568023bd1bde626);

var $fUAEy = parcelRequire("fUAEy");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $dWLk9 = parcelRequire("dWLk9");

var $cl42p = parcelRequire("cl42p");
function $5f37b5f5d09f1a30$export$e568023bd1bde626() {
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueContextIssueId = (0, $hJ992.useIssueId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [commit] = (0, $iWLL0.useMutation)((0, $fUAEy.default));
    return (0, $eUqFw.useCallback)(async (issueKey, fieldId, option)=>{
        const { issueId: issueId, fieldOptionAri: fieldOptionAri } = await (0, $cl42p.fetchMissingIssueAndFieldOptionData)(issueContextIssueId, option, environment, {
            cloudId: cloudId,
            issueKey: issueKey,
            fieldId: fieldId
        });
        return new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        // @todo: we shouldn't be manually constructing ARIs
                        // https://jplat.jira.atlassian.cloud/browse/JIV-16566
                        id: `ari:cloud:jira:${cloudId}:issuefieldvalue/${issueId}/${fieldId}`,
                        operation: {
                            operation: 'SET',
                            id: fieldOptionAri
                        }
                    }
                },
                onCompleted (data) {
                    if (!data.jira?.updateSingleSelectField) {
                        reject(new Error('unknown error occurred'));
                        return;
                    }
                    const { success: success, errors: errors, field: field } = data.jira.updateSingleSelectField;
                    if (!success || errors?.length) {
                        reject(errors?.[0].message ? new (0, $7byHA.ValidationError)(errors[0].message) : new Error('unknown error occurred'));
                        return;
                    }
                    resolve(field?.fieldOption ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    {
                        ari: field.fieldOption.id,
                        value: field.fieldOption.value,
                        id: field.fieldOption.optionId
                    } : null);
                },
                onError: reject
            });
        });
    }, [
        cloudId,
        commit,
        environment,
        issueContextIssueId
    ]);
}

});
parcelRegister("fUAEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e72d3b27d1cd2184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7735160732824337ac8d363f0c91a06>>
 * @relayHash 396cef6d317a9982d56bae0401d0192f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61
const $e72d3b27d1cd2184$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "fieldOption",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "optionId"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSingleSelectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleSelectFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleSelectField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleSelectField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e79778d8ae574a33e0439f2d59888b0f1b3db2a38ec6c0682cf054fcc665db61",
            "metadata": {},
            "name": "useSingleSelectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e72d3b27d1cd2184$var$node.hash = "b8d6036932768e6445d7615f80fc6acb";
var $e72d3b27d1cd2184$export$2e2bcd8739ae039 = $e72d3b27d1cd2184$var$node;

});

parcelRegister("cl42p", function(module, exports) {

$parcel$export(module.exports, "fetchMissingIssueAndFieldOptionData", () => $ccddbc32a65dc07a$export$def6f7858b27fc01);

var $9Exgj = parcelRequire("9Exgj");

var $iWLL0 = parcelRequire("iWLL0");
async function $ccddbc32a65dc07a$export$def6f7858b27fc01(issueId, option, environment, vars) {
    const skipFieldOptionAri = option === null || Boolean(option.ari);
    // we have all the data required to make the mutation. if the field option
    // value is null that means we are unsetting so an ari is not required
    if (issueId && skipFieldOptionAri) return {
        issueId: issueId,
        fieldOptionAri: option?.ari ?? null
    };
    const result = await (0, $iWLL0.fetchQuery)(environment, (0, $9Exgj.default), {
        ...vars,
        // @todo: how do we scale when the value is empty for fields with large
        //        amount of options
        // @see https://jplat.jira.atlassian.cloud/browse/JIV-16573
        searchBy: option?.value,
        skipFieldOptionAri: skipFieldOptionAri
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const jiraIssue = result?.jira?.issueByKey;
    if (!jiraIssue?.issueId) throw new Error('failed fetch issue id');
    let ari = option != null ? option?.ari : null;
    if (!skipFieldOptionAri) ari = option ? jiraIssue?.fieldsById?.edges?.[0]?.node?.fieldOptions?.edges?.find((opt)=>opt?.node?.optionId === option.id)?.node?.id : null;
    // ari being null is still valid request as the user will be unsetting it
    // so here we check for undefined only meaning that the query above returned
    // an empty options connection, or we could not match the `optionId` from the
    // nodes in the connection.
    if (ari === undefined) throw new Error('failed to fetch field option ari');
    return {
        issueId: jiraIssue.issueId,
        fieldOptionAri: ari
    };
}

});
parcelRegister("9Exgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9668a277aa11099$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed6f2e80602085b4937748ddaf953d>>
 * @relayHash 524d85ce5dded2d9716dceedb13042f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58
const $c9668a277aa11099$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchBy"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipFieldOptionAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "fieldId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "searchBy",
                        "variableName": "searchBy"
                    }
                ],
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "optionId"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraSingleSelectField"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "skipFieldOptionAri",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldsById",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v9 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b143065b2371a01a056e06ca6a0f574cd106056b83483283319b3b7d3d180d58",
            "metadata": {},
            "name": "utilsUseSingleSelectMutationMissingIssueAndFieldOptionDataQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9668a277aa11099$var$node.hash = "9fecb581bfb367efbee5768f0f78cc7a";
var $c9668a277aa11099$export$2e2bcd8739ae039 = $c9668a277aa11099$var$node;

});




parcelRegister("bNbdC", function(module, exports) {

$parcel$export(module.exports, "multiSelectSupportedTypes", () => $cc3d1e0290ef44ee$export$9cb7f11173b6b689);

var $lO4Or = parcelRequire("lO4Or");
const $cc3d1e0290ef44ee$export$9cb7f11173b6b689 = [
    (0, $lO4Or.MULTI_SELECT_CF_TYPE)
];

});


parcelRegister("1xv3U", function(module, exports) {

$parcel$export(module.exports, "numberClipboardHandler", () => $302e4f33731b293a$export$801c183086232047);

var $eY8vu = parcelRequire("eY8vu");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $302e4f33731b293a$var$getPastedValue = (clipboardItem)=>{
    if (!clipboardItem || !clipboardItem.plainText) return null;
    if (Number.isNaN(Number(clipboardItem.plainText))) return null;
    return Number(clipboardItem.plainText);
};
const $302e4f33731b293a$var$useNumberClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $eY8vu.useNumberField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $302e4f33731b293a$var$getPastedValue, saveValue);
};
const $302e4f33731b293a$var$NumberClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($302e4f33731b293a$var$useNumberClipboardHandler);
const $302e4f33731b293a$export$801c183086232047 = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $302e4f33731b293a$var$NumberClipboardHelper,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $302e4f33731b293a$var$NumberClipboardHelper,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $302e4f33731b293a$var$NumberClipboardHelper
};

});
parcelRegister("eY8vu", function(module, exports) {

$parcel$export(module.exports, "useNumberField", () => $847782734a282d47$export$23f548e970bdf099);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $847782734a282d47$export$23f548e970bdf099 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'number');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("5MhxU", function(module, exports) {

$parcel$export(module.exports, "parentClipboardHandler", () => $c175d49853243e9e$export$a8a030d8148a051e);

var $eUqFw = parcelRequire("eUqFw");

var $DX7su = parcelRequire("DX7su");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $c175d49853243e9e$var$isTransformedParentOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'issueKey' in fieldValue && 'summary' in fieldValue && 'issueType' in fieldValue && 'issueId' in fieldValue;
const $c175d49853243e9e$var$getPastedValue = (clipboardItem, metadata, issue)=>{
    if (!clipboardItem || !metadata?.fieldValue) return null;
    // only paste when level is the same for source and destination issues
    if (String(issue?.issueType?.level) !== metadata.sourceIssueTypeLevel) return null;
    if (!$c175d49853243e9e$var$isTransformedParentOption(metadata.fieldValue)) return null;
    const { issueKey: issueKey, issueId: issueId, summary: summary, issueType: issueType } = metadata.fieldValue;
    if (summary == null || issueType == null) return null;
    return {
        value: issueId,
        label: summary,
        key: issueKey,
        fields: {
            summary: summary,
            issuetype: issueType
        }
    };
};
const $c175d49853243e9e$var$useParentClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $DX7su.useParentField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        issueId: issue.issueId
    });
    const createPastedValueWithIssue = (0, $eUqFw.useMemo)(()=>(clipboardItem, metadata)=>$c175d49853243e9e$var$getPastedValue(clipboardItem, metadata, issue), [
        issue
    ]);
    return (0, $b3neV.useGenericClipboardHandler)(field, createPastedValueWithIssue, saveValue);
};
const $c175d49853243e9e$var$ParentClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($c175d49853243e9e$var$useParentClipboardHandler);
const $c175d49853243e9e$export$a8a030d8148a051e = {
    [(0, $lO4Or.PARENT_TYPE)]: $c175d49853243e9e$var$ParentClipboardHelper
};

});

parcelRegister("9f078", function(module, exports) {

$parcel$export(module.exports, "priorityClipboardHandler", () => $e76c4e2612c5e8f2$export$b89004aa95786c81);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $fT9Dl = parcelRequire("fT9Dl");
const $e76c4e2612c5e8f2$var$isTransformedPriority = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'priorityId' in fieldValue && 'iconUrl' in fieldValue;
const $e76c4e2612c5e8f2$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $fT9Dl.prioritySupportedTypes).includes(metadata.fieldType)) return null;
    if (!$e76c4e2612c5e8f2$var$isTransformedPriority(metadata.fieldValue)) return null;
    const { name: name, iconUrl: iconUrl, priorityId: priorityId } = metadata.fieldValue;
    return {
        name: name,
        iconUrl: iconUrl,
        priorityId: priorityId
    };
};
const $e76c4e2612c5e8f2$var$usePriorityClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.PRIORITY_TYPE),
        issueKey: issue.key,
        fieldType: (0, $lO4Or.PRIORITY_TYPE),
        initialValue: $e76c4e2612c5e8f2$var$isTransformedPriority(field.value) ? field.value : undefined
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $e76c4e2612c5e8f2$var$getPastedValue, saveValue);
};
const $e76c4e2612c5e8f2$var$PriorityClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($e76c4e2612c5e8f2$var$usePriorityClipboardHandler);
const $e76c4e2612c5e8f2$export$b89004aa95786c81 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $e76c4e2612c5e8f2$var$PriorityClipboardHelper
};

});
parcelRegister("fT9Dl", function(module, exports) {

$parcel$export(module.exports, "prioritySupportedTypes", () => $6f6676ccf7e9e98c$export$870d540e29b75531);

var $lO4Or = parcelRequire("lO4Or");
const $6f6676ccf7e9e98c$export$870d540e29b75531 = [
    (0, $lO4Or.PRIORITY_TYPE)
];

});


parcelRegister("bN2A6", function(module, exports) {

$parcel$export(module.exports, "projectClipboardHandler", () => $ee0fcf8e024fd6d7$export$54ffe1b6751ffaa1);

var $hIoRx = parcelRequire("hIoRx");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $ee0fcf8e024fd6d7$var$isTransformedProjectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'name' in fieldValue && 'avatarUrls' in fieldValue && 'key' in fieldValue;
const $ee0fcf8e024fd6d7$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue) return null;
    if (!$ee0fcf8e024fd6d7$var$isTransformedProjectOption(metadata.fieldValue)) return null;
    const { name: name, avatarUrls: avatarUrls, key: key } = metadata.fieldValue;
    return {
        name: name,
        avatarUrls: avatarUrls,
        key: key
    };
};
const $ee0fcf8e024fd6d7$var$useProjectClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $hIoRx.useProjectField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $ee0fcf8e024fd6d7$var$getPastedValue, saveValue);
};
const $ee0fcf8e024fd6d7$var$ProjectClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($ee0fcf8e024fd6d7$var$useProjectClipboardHandler);
const $ee0fcf8e024fd6d7$export$54ffe1b6751ffaa1 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $ee0fcf8e024fd6d7$var$ProjectClipboardHelper
};

});

parcelRegister("i3YJS", function(module, exports) {

$parcel$export(module.exports, "richTextClipboardHandler", () => $84065a9d3276b9f1$export$f1f0130932e64bf7);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $45Hde = parcelRequire("45Hde");
const $84065a9d3276b9f1$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !clipboardItem.plainText || clipboardItem.plainText === '' || !metadata) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $45Hde.richTextSupportedTypes).includes(metadata.fieldType)) return null;
    return JSON.parse(clipboardItem.plainText);
};
const $84065a9d3276b9f1$var$useRichTextClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        issueKey: issue.key,
        fieldKey: field.fieldId,
        fieldType: field.type,
        initialValue: null
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $84065a9d3276b9f1$var$getPastedValue, saveValue);
};
const $84065a9d3276b9f1$var$RichTextClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($84065a9d3276b9f1$var$useRichTextClipboardHandler);
const $84065a9d3276b9f1$export$f1f0130932e64bf7 = {
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $84065a9d3276b9f1$var$RichTextClipboardHelper
};

});
parcelRegister("45Hde", function(module, exports) {

$parcel$export(module.exports, "richTextSupportedTypes", () => $9e5ea2354de6a8fd$export$8eb80ed0ab47e2a5);

var $lO4Or = parcelRequire("lO4Or");
const $9e5ea2354de6a8fd$export$8eb80ed0ab47e2a5 = [
    (0, $lO4Or.TEXT_AREA_CF_TYPE)
];

});


parcelRegister("gRRkp", function(module, exports) {

$parcel$export(module.exports, "singleSelectClipboardHandler", () => $fa2a29b32573d899$export$40b3cfc25c74248b);

var $acd3W = parcelRequire("acd3W");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $jeePg = parcelRequire("jeePg");
const $fa2a29b32573d899$var$isTransformedSingleSelectOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'value' in fieldValue && 'optionId' in fieldValue;
const $fa2a29b32573d899$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $jeePg.singleSelectSupportedTypes).includes(metadata.fieldType)) return null;
    if (!$fa2a29b32573d899$var$isTransformedSingleSelectOption(metadata.fieldValue)) return null;
    return {
        id: metadata.fieldValue.optionId,
        value: metadata.fieldValue.value
    };
};
const $fa2a29b32573d899$var$useSingleSelectClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $acd3W.useSingleSelectField)({
        fieldKey: field.fieldId,
        issueKey: issue.key
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $fa2a29b32573d899$var$getPastedValue, saveValue);
};
const $fa2a29b32573d899$var$SingleSelectClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($fa2a29b32573d899$var$useSingleSelectClipboardHandler);
const $fa2a29b32573d899$export$40b3cfc25c74248b = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $fa2a29b32573d899$var$SingleSelectClipboardHelper
};

});
parcelRegister("jeePg", function(module, exports) {

$parcel$export(module.exports, "singleSelectSupportedTypes", () => $db02664bdc47244b$export$2bbc728e21b0f517);

var $lO4Or = parcelRequire("lO4Or");
const $db02664bdc47244b$export$2bbc728e21b0f517 = [
    (0, $lO4Or.SELECT_CF_TYPE)
];

});


parcelRegister("hZbCV", function(module, exports) {

$parcel$export(module.exports, "sprintClipboardHandler", () => $cced96e6fbfbb176$export$43b74ee26a0ff997);

var $eUqFw = parcelRequire("eUqFw");

var $aUSBv = parcelRequire("aUSBv");

var $5EG40 = parcelRequire("5EG40");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $9sISm = parcelRequire("9sISm");
const $cced96e6fbfbb176$var$isTransformedSprintOption = (option)=>option != null && typeof option === 'object' && 'sprintId' in option && 'name' in option && 'state' in option;
const $cced96e6fbfbb176$var$isTransformedSprint = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($cced96e6fbfbb176$var$isTransformedSprintOption);
const $cced96e6fbfbb176$var$emptyValue = [];
const $cced96e6fbfbb176$var$getPastedValue = (clipboardItem, metadata)=>{
    const boardId = (0, $aUSBv.getBoardId)(window.location.href);
    if (!clipboardItem || !metadata?.fieldType || !metadata?.fieldValue) return [];
    if (!$cced96e6fbfbb176$var$isTransformedSprint(metadata?.fieldValue)) return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $9sISm.sprintSupportedTypes).includes(metadata.fieldType)) return [];
    return metadata?.fieldValue.map((sprint)=>({
            id: Number(sprint.sprintId),
            name: String(sprint.name),
            state: String(sprint.state),
            boardId: Number(boardId)
        }));
};
const $cced96e6fbfbb176$var$useSprintClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $5EG40.useSprintField)({
        issueKey: issue.key,
        fieldKey: field.fieldId
    });
    const saveValueFn = (0, $eUqFw.useCallback)((value, meta, analyticsEvent)=>/**
			 * Wrap saveValue to make sure the saved value is never set to `null`
			 */ saveValue(value ?? [], meta, analyticsEvent), [
        saveValue
    ]);
    return (0, $b3neV.useGenericClipboardHandler)(field, $cced96e6fbfbb176$var$getPastedValue, saveValueFn, $cced96e6fbfbb176$var$emptyValue);
};
const $cced96e6fbfbb176$var$SprintClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($cced96e6fbfbb176$var$useSprintClipboardHandler);
const $cced96e6fbfbb176$export$43b74ee26a0ff997 = {
    [(0, $lO4Or.SPRINT_TYPE)]: $cced96e6fbfbb176$var$SprintClipboardHelper
};

});
parcelRegister("5EG40", function(module, exports) {

$parcel$export(module.exports, "useSprintField", () => $1f9070b593e0eed5$export$414b643c95e23ae5);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

var $4QywV = parcelRequire("4QywV");
const $1f9070b593e0eed5$export$218ac2eb848871c9 = async (issueKey, fieldKey, newValue)=>{
    const value = (0, $4QywV.getActiveOrFutureSprint)(newValue);
    return (0, $lRmyA.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify({
            fields: {
                // We're only saving the sprint id
                [fieldKey]: value ? value.id : null
            }
        })
    });
};
const $1f9070b593e0eed5$export$414b643c95e23ae5 = (props)=>{
    const { fieldKey: fieldKey, issueId: issueId, issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, initialValue: initialValue = [] } = props;
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = fieldConfig?.schema.custom ?? (0, $lO4Or.SPRINT_TYPE);
    const [{ error: error, value: value }, { resetError: resetError, saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        fieldType: fieldType,
        issueId: issueId,
        issueKey: issueKey,
        onSuccess: onSuccess,
        onFailure: onFailure,
        initialValue: initialValue,
        saveField: $1f9070b593e0eed5$export$218ac2eb848871c9
    });
    const currentSprint = (0, $eUqFw.useMemo)(()=>(0, $4QywV.getActiveOrFutureSprint)(value), [
        value
    ]);
    const closedSprints = (0, $eUqFw.useMemo)(()=>(0, $4QywV.getClosedSprints)(value), [
        value
    ]);
    return [
        {
            currentSprint: currentSprint,
            closedSprints: closedSprints,
            error: error,
            value: value,
            fieldConfig: fieldConfig
        },
        {
            resetError: resetError,
            saveValue: saveValue
        }
    ];
};

});
parcelRegister("4QywV", function(module, exports) {

$parcel$export(module.exports, "getActiveOrFutureSprint", () => $3b23a63751969b1d$export$976090522bae1157);
$parcel$export(module.exports, "getClosedSprints", () => $3b23a63751969b1d$export$d643f70a4819e76d);

var $aJ90T = parcelRequire("aJ90T");

var $cbDYy = parcelRequire("cbDYy");
const $3b23a63751969b1d$export$976090522bae1157 = (value)=>{
    const activeSprint = (0, $cbDYy.findSprintWithState)(value, (0, $aJ90T.ACTIVE_SPRINT_STATE));
    if (activeSprint) return activeSprint;
    const futureSprint = (0, $cbDYy.findSprintWithState)(value, (0, $aJ90T.FUTURE_SPRINT_STATE));
    if (futureSprint) return futureSprint;
    return null;
};
const $3b23a63751969b1d$export$d643f70a4819e76d = (value)=>{
    if (!value) return [];
    return value.filter((0, $cbDYy.hasState)((0, $aJ90T.CLOSED_SPRINT_STATE)));
};

});
parcelRegister("aJ90T", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $d6857bb95b01f76c$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $d6857bb95b01f76c$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $d6857bb95b01f76c$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $d6857bb95b01f76c$export$73a0206a4dc59760);
const $d6857bb95b01f76c$export$3ebc9911a79d714f = 'ACTIVE';
const $d6857bb95b01f76c$export$863e42082c6bde5 = 'FUTURE';
const $d6857bb95b01f76c$export$86cdef09a89e8c4b = 'CLOSED';
const $d6857bb95b01f76c$export$73a0206a4dc59760 = {
    ACTIVE: $d6857bb95b01f76c$export$3ebc9911a79d714f,
    CLOSED: $d6857bb95b01f76c$export$86cdef09a89e8c4b,
    FUTURE: $d6857bb95b01f76c$export$863e42082c6bde5
};

});

parcelRegister("cbDYy", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $8a075e979a5ccce6$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $8a075e979a5ccce6$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $8a075e979a5ccce6$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $8a075e979a5ccce6$export$1d0ee4320c26fb60);

var $aJ90T = parcelRequire("aJ90T");

var $iciya = parcelRequire("iciya");
const $8a075e979a5ccce6$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $8a075e979a5ccce6$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $8a075e979a5ccce6$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($8a075e979a5ccce6$export$d2fec4e2fc5f065a(state));
};
const $8a075e979a5ccce6$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $aJ90T.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $8a075e979a5ccce6$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $8a075e979a5ccce6$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $8a075e979a5ccce6$export$b9928e57702db7d9 = (items)=>items.map($8a075e979a5ccce6$export$fbb2e1641ffac377);
const $8a075e979a5ccce6$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $8a075e979a5ccce6$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $8a075e979a5ccce6$export$db10bf437c75c497 = (items)=>items.map($8a075e979a5ccce6$export$cbdf60de7f2200e7);
const $8a075e979a5ccce6$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $8a075e979a5ccce6$export$c1cb9e6f1beaee0d = (items)=>items.map($8a075e979a5ccce6$export$15c97379ebef6b30);
const $8a075e979a5ccce6$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $8a075e979a5ccce6$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $8a075e979a5ccce6$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $8a075e979a5ccce6$export$e6c9132cef5ee76f(sprint.id),
        state: $8a075e979a5ccce6$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $8a075e979a5ccce6$export$cbcaba92baa2e404 = (items)=>items.map($8a075e979a5ccce6$export$755a6a3c6172f7e);
const $8a075e979a5ccce6$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $aJ90T.ACTIVE_SPRINT_STATE)).map($8a075e979a5ccce6$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $aJ90T.FUTURE_SPRINT_STATE)).map($8a075e979a5ccce6$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $iciya.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $iciya.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("iciya", function(module, exports) {

$parcel$export(module.exports, "default", () => $2522434b5de850c0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2522434b5de850c0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});




parcelRegister("9sISm", function(module, exports) {

$parcel$export(module.exports, "sprintSupportedTypes", () => $52fd07c03bb8a48a$export$e25836d1d6e63e05);

var $lO4Or = parcelRequire("lO4Or");
const $52fd07c03bb8a48a$export$e25836d1d6e63e05 = [
    (0, $lO4Or.SPRINT_TYPE)
];

});


parcelRegister("6hel2", function(module, exports) {

$parcel$export(module.exports, "teamClipboardHandler", () => $a73426c6bbea7e32$export$c625d5eb0e1357b2);

var $5JDtt = parcelRequire("5JDtt");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $a73426c6bbea7e32$var$isTransformedTeamOption = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'id' in fieldValue && 'name' in fieldValue;
const $a73426c6bbea7e32$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue) return null;
    if (!$a73426c6bbea7e32$var$isTransformedTeamOption(metadata.fieldValue)) return null;
    const { id: id, name: name } = metadata.fieldValue;
    return {
        id: id,
        name: name
    };
};
const $a73426c6bbea7e32$var$useTeamClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $5JDtt.useTeamField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $a73426c6bbea7e32$var$getPastedValue, saveValue);
};
const $a73426c6bbea7e32$var$TeamClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($a73426c6bbea7e32$var$useTeamClipboardHandler);
const $a73426c6bbea7e32$export$c625d5eb0e1357b2 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $a73426c6bbea7e32$var$TeamClipboardHelper
};

});

parcelRegister("hENET", function(module, exports) {

$parcel$export(module.exports, "textClipboardHandler", () => $6a7815dcf43e968a$export$c09434927c21c56);

var $91l9a = parcelRequire("91l9a");

var $fWeG1 = parcelRequire("fWeG1");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $6a7815dcf43e968a$var$getPastedValue = (clipboardItem)=>{
    if (!clipboardItem || !clipboardItem.plainText) return null;
    return clipboardItem.plainText;
};
const $6a7815dcf43e968a$var$useSummaryClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $fWeG1.useSummaryField)({
        issueKey: issue.key
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $6a7815dcf43e968a$var$getPastedValue, saveValue);
};
const $6a7815dcf43e968a$var$useTextClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $91l9a.useTextCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $6a7815dcf43e968a$var$getPastedValue, saveValue);
};
const $6a7815dcf43e968a$var$SummaryClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($6a7815dcf43e968a$var$useSummaryClipboardHandler);
const $6a7815dcf43e968a$var$TextClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($6a7815dcf43e968a$var$useTextClipboardHandler);
const $6a7815dcf43e968a$export$c09434927c21c56 = {
    [(0, $lO4Or.SUMMARY_TYPE)]: $6a7815dcf43e968a$var$SummaryClipboardHelper,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $6a7815dcf43e968a$var$TextClipboardHelper
};

});
parcelRegister("91l9a", function(module, exports) {

$parcel$export(module.exports, "useTextCustomField", () => $e317f21526ba3a70$export$1e71b41e5a5c15c3);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $e317f21526ba3a70$export$1e71b41e5a5c15c3 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("fWeG1", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $6c5f7158a1132680$export$a01f0885983ceff0);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $6c5f7158a1132680$export$a01f0885983ceff0 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("bde5A", function(module, exports) {

$parcel$export(module.exports, "timeTrackingClipboardHandler", () => $c439310d2c3994e8$export$a6166b81649f40c4);

var $dKMPW = parcelRequire("dKMPW");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $3mCdi = parcelRequire("3mCdi");
const $c439310d2c3994e8$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem.plainText || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $3mCdi.timeTrackingSupportedTypes).includes(metadata.fieldType)) return null;
    const time = Number(clipboardItem.plainText);
    if (Number.isNaN(time)) return null;
    return time;
};
const $c439310d2c3994e8$var$useTimeTrackingClipboardHandler = (issue, field)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldValue = field.value;
    const hookInitialValue = fieldValue?.timeAsString && fieldValue?.timeInSeconds && {
        originalEstimate: fieldValue.timeAsString,
        originalEstimateSeconds: fieldValue.timeInSeconds
    } || {};
    const [, { saveValue: saveValue }] = (0, $dKMPW.useOriginalEstimateField)({
        issueKey: issue.key,
        issueId: issue.issueId,
        fieldId: field.fieldId,
        timeTrackingValue: hookInitialValue
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $c439310d2c3994e8$var$getPastedValue, saveValue);
};
const $c439310d2c3994e8$var$TimeTrackingClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($c439310d2c3994e8$var$useTimeTrackingClipboardHandler);
const $c439310d2c3994e8$export$a6166b81649f40c4 = {
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $c439310d2c3994e8$var$TimeTrackingClipboardHelper
};

});
parcelRegister("dKMPW", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $899c478b0ef30ec3$export$72a8b15fb4557735);
$parcel$export(module.exports, "useOriginalEstimateField", () => $899c478b0ef30ec3$export$ce089f5e05395af0);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $eDEru = parcelRequire("eDEru");

var $5zSUY = parcelRequire("5zSUY");

var $9JAdq = parcelRequire("9JAdq");
const $899c478b0ef30ec3$export$347b6dd45094a5fd = (timeTrackingValue)=>{
    const hasTimeLogged = timeTrackingValue?.timeSpentSeconds != null;
    const hasTimeRemainUpdated = timeTrackingValue?.remainingEstimateSeconds != null && timeTrackingValue?.remainingEstimateSeconds !== timeTrackingValue?.originalEstimateSeconds;
    return hasTimeLogged || hasTimeRemainUpdated;
};
const $899c478b0ef30ec3$export$72a8b15fb4557735 = async ({ issueId: issueId, newValue: newValue, timeTrackingValue: timeTrackingValue })=>{
    const hasTimeRemainingEstimate = $899c478b0ef30ec3$export$347b6dd45094a5fd(timeTrackingValue);
    // Convert the value in seconds to a time string to send to Jira.
    // 1m is always 60s, so we can do this safely.
    // we have to convert the final value to a whole number as passing decimal
    // values in minutes errors.
    const value = newValue !== null ? (0, $eDEru.secondsToWholeMinuteTimeString)(newValue) : null;
    // https://jdog.jira-dev.com/browse/BENTO-792 - The Time Estimate field is always shown,
    // because we always the return the timeoriginalestimate field from the backend. In order to
    // prevent the field from being visible but not editable when Time Tracking is missing from the
    // screen config, we use this legacy endpoint to save the field.
    return (0, $lRmyA.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $53ciZ.stringify)({
            issueId: issueId,
            timetracking_originalestimate: value,
            timetracking_targetsubfield: hasTimeRemainingEstimate ? 'timetracking_originalestimate' : undefined,
            ...(0, $9JAdq.originalEstimateBodyParams),
            singleFieldEdit: true,
            skipScreenCheck: true,
            atl_token: (0, $5zSUY.default)()
        })
    });
};
const $899c478b0ef30ec3$export$ce089f5e05395af0 = ({ issueKey: issueKey, issueId: issueId, fieldId: fieldId, timeTrackingValue: timeTrackingValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldId);
    const fieldType = fieldConfig?.schema.system || '';
    const saveClassicField = (_, __, newValue)=>$899c478b0ef30ec3$export$72a8b15fb4557735({
            issueId: issueId,
            newValue: newValue,
            timeTrackingValue: timeTrackingValue
        });
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("eDEru", function(module, exports) {

$parcel$export(module.exports, "secondsToWholeMinuteTimeString", () => $e60ef9ff18ec9e8a$export$e090c313e2cb7081);
const $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE = 60;
const $e60ef9ff18ec9e8a$export$e090c313e2cb7081 = (seconds)=>`${Math.round(seconds / $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE)}m`;
var $e60ef9ff18ec9e8a$export$2e2bcd8739ae039 = $e60ef9ff18ec9e8a$export$e090c313e2cb7081;

});

parcelRegister("9JAdq", function(module, exports) {

$parcel$export(module.exports, "originalEstimateBodyParams", () => $4291bf329eb7bdb7$export$25ca12ed4532196);
$parcel$export(module.exports, "originalEstimateEditTestId", () => $4291bf329eb7bdb7$export$85273aacc194bf89);
$parcel$export(module.exports, "originalEstimateViewTestId", () => $4291bf329eb7bdb7$export$97847a81d7704a9e);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR_NAME", () => $4291bf329eb7bdb7$export$916dec1cd99a42a1);
$parcel$export(module.exports, "READ_VIEW_CONTAINER_SELECTOR", () => $4291bf329eb7bdb7$export$5c18970ef161f5b6);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR_NAME", () => $4291bf329eb7bdb7$export$c43a88184f234cd2);
$parcel$export(module.exports, "HOVER_CONTAINER_SELECTOR", () => $4291bf329eb7bdb7$export$366394ad8172710b);
// used to verify mock is originalEstimate
const $4291bf329eb7bdb7$export$25ca12ed4532196 = {
    fieldsToForcePresent: 'timetracking'
};
const $4291bf329eb7bdb7$export$85273aacc194bf89 = 'issue-field-original-estimate.ui.edit';
const $4291bf329eb7bdb7$export$97847a81d7704a9e = 'issue-field-original-estimate.ui.view';
const $4291bf329eb7bdb7$export$916dec1cd99a42a1 = 'jira-issue-field-inline-edit-read-view-container';
const $4291bf329eb7bdb7$export$5c18970ef161f5b6 = `[data-component-selector="${$4291bf329eb7bdb7$export$916dec1cd99a42a1}"]`;
const $4291bf329eb7bdb7$export$c43a88184f234cd2 = 'jira-issue-field-original-estimate-hover-container';
const $4291bf329eb7bdb7$export$366394ad8172710b = `[data-component-selector="${$4291bf329eb7bdb7$export$c43a88184f234cd2}"]`;

});


parcelRegister("3mCdi", function(module, exports) {

$parcel$export(module.exports, "timeTrackingSupportedTypes", () => $11f6ca9dfa6c0ffd$export$de876e84f23a34b2);

var $lO4Or = parcelRequire("lO4Or");
const $11f6ca9dfa6c0ffd$export$de876e84f23a34b2 = [
    (0, $lO4Or.TIME_ESTIMATE_TYPE)
];

});


parcelRegister("585wU", function(module, exports) {

$parcel$export(module.exports, "urlClipboardHandler", () => $4cc7deb414a8dc9f$export$6e2f5cd13985078c);

var $3wLKg = parcelRequire("3wLKg");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");
const $4cc7deb414a8dc9f$var$getPastedValue = (clipboardItem)=>{
    if (!clipboardItem || !clipboardItem.plainText) return null;
    return clipboardItem.plainText;
};
const $4cc7deb414a8dc9f$var$useUrlClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $3wLKg.useUrlCustomField)({
        issueKey: issue.key,
        fieldKey: field?.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $4cc7deb414a8dc9f$var$getPastedValue, saveValue);
};
const $4cc7deb414a8dc9f$var$UrlClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($4cc7deb414a8dc9f$var$useUrlClipboardHandler);
const $4cc7deb414a8dc9f$export$6e2f5cd13985078c = {
    [(0, $lO4Or.URL_CF_TYPE)]: $4cc7deb414a8dc9f$var$UrlClipboardHelper
};

});
parcelRegister("3wLKg", function(module, exports) {

$parcel$export(module.exports, "useUrlCustomField", () => $0d8a50c570e9c30f$export$8745adc9879e9e03);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
const $0d8a50c570e9c30f$export$8745adc9879e9e03 = ({ issueKey: issueKey, fieldKey: fieldKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});


parcelRegister("iYRy3", function(module, exports) {

$parcel$export(module.exports, "userClipboardHandler", () => $96536ccc35d78029$export$5fdc9960135beb70);
$parcel$export(module.exports, "multiUserClipboardHandler", () => $96536ccc35d78029$export$6c011954430f0654);

var $dnK1q = parcelRequire("dnK1q");

var $gd2u3 = parcelRequire("gd2u3");

var $lu5Yp = parcelRequire("lu5Yp");

var $bBj5E = parcelRequire("bBj5E");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $0KeHR = parcelRequire("0KeHR");
const $96536ccc35d78029$var$isTransformedUser = (fieldValue)=>fieldValue != null && typeof fieldValue === 'object' && 'accountId' in fieldValue && 'name' in fieldValue && 'picture' in fieldValue;
const $96536ccc35d78029$var$isTransformedUserList = (fieldValue)=>fieldValue != null && Array.isArray(fieldValue) && fieldValue.length > 0 && 'accountId' in fieldValue[0] && 'name' in fieldValue[0] && 'picture' in fieldValue[0];
const $96536ccc35d78029$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $0KeHR.userSupportedTypes).includes(metadata.fieldType)) return null;
    if (!$96536ccc35d78029$var$isTransformedUser(metadata.fieldValue)) return null;
    const { accountId: accountId, name: name, picture: picture } = metadata.fieldValue;
    const pastedUser = {
        accountId: accountId,
        displayName: name,
        avatarUrl: picture,
        avatarUrls: {
            '48x48': picture
        }
    };
    return pastedUser;
};
const $96536ccc35d78029$var$getPastedValuePlural = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldValue || !metadata?.fieldType) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $0KeHR.multiUserSupportedTypes).includes(metadata.fieldType)) return null;
    if (!$96536ccc35d78029$var$isTransformedUserList(metadata.fieldValue)) return null;
    return metadata.fieldValue.map((user)=>{
        const { accountId: accountId, name: name, picture: picture } = user;
        const pastedUser = {
            accountId: accountId,
            displayName: name,
            avatarUrl: picture,
            avatarUrls: {
                '48x48': picture
            }
        };
        return pastedUser;
    });
};
const $96536ccc35d78029$var$useAssigneeClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $dnK1q.default)({
        issueKey: issue.key
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $96536ccc35d78029$var$getPastedValue, saveValue);
};
const $96536ccc35d78029$var$useReporterClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $bBj5E.useReporterField)({
        issueKey: issue.key
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $96536ccc35d78029$var$getPastedValue, saveValue);
};
const $96536ccc35d78029$var$useSingleUserClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $gd2u3.useUserCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $96536ccc35d78029$var$getPastedValue, saveValue);
};
const $96536ccc35d78029$var$useMultiUserClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $lu5Yp.useMultiUserCustomField)({
        issueKey: issue.key,
        fieldKey: field.fieldId
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $96536ccc35d78029$var$getPastedValuePlural, saveValue);
};
const $96536ccc35d78029$var$UserClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($96536ccc35d78029$var$useSingleUserClipboardHandler);
const $96536ccc35d78029$var$MultiUserClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($96536ccc35d78029$var$useMultiUserClipboardHandler);
const $96536ccc35d78029$var$AssigneeClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($96536ccc35d78029$var$useAssigneeClipboardHandler);
const $96536ccc35d78029$var$ReporterClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($96536ccc35d78029$var$useReporterClipboardHandler);
const $96536ccc35d78029$export$5fdc9960135beb70 = {
    [(0, $lO4Or.USER_CF_TYPE)]: $96536ccc35d78029$var$UserClipboardHelper,
    [(0, $lO4Or.REPORTER_TYPE)]: $96536ccc35d78029$var$ReporterClipboardHelper,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $96536ccc35d78029$var$AssigneeClipboardHelper
};
const $96536ccc35d78029$export$6c011954430f0654 = {
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $96536ccc35d78029$var$MultiUserClipboardHelper,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $96536ccc35d78029$var$MultiUserClipboardHelper
};

});
parcelRegister("dnK1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $28b7c7940962eeef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $axhXb = parcelRequire("axhXb");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");
var $kmr29 = parcelRequire("kmr29");



var $aNVyA = parcelRequire("aNVyA");
const $28b7c7940962eeef$var$getCurrentAssigneeUrl = (baseUrl, issueKey)=>`${baseUrl}/rest/api/3/issue/${issueKey}?fields=assignee`;
const $28b7c7940962eeef$var$getCurrentAssignee = async (baseUrl, issueKey)=>{
    const response = await (0, $lRmyA.performGetRequest)($28b7c7940962eeef$var$getCurrentAssigneeUrl(baseUrl, issueKey), {
        ...(0, $axhXb.default)
    });
    const { assignee: assignee } = response.fields;
    return assignee;
};
const $28b7c7940962eeef$export$e3a8121b536e7353 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $ebc098a76317be78$export$e18419056f3d184a);
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', 'user');
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$e18419056f3d184a)
    });
    const baseUrl = '';
    const onSaveSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'currentAssignee' implicitly has an 'any' type.
    (currentAssignee)=>{
        if (currentAssignee && currentAssignee.accountId === (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) $28b7c7940962eeef$var$getCurrentAssignee(baseUrl, issueKey).then((assignee)=>{
            setFieldValue(issueKey, (0, $ebc098a76317be78$export$e18419056f3d184a), assignee);
            onSuccess?.(assignee);
        }).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'currentAssigneeFetch',
                    packageName: 'jiraIssueFieldAssignee'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            onSuccess?.(currentAssignee); // In case api fail, better to show Automatic only
        });
        else onSuccess?.(currentAssignee);
    }, [
        baseUrl,
        issueKey,
        onSuccess,
        setFieldValue
    ]);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSaveSuccess,
        onFailure: onFailure,
        saveField: (0, $aNVyA.saveAssigneeField)
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};
var $28b7c7940962eeef$export$2e2bcd8739ae039 = $28b7c7940962eeef$export$e3a8121b536e7353;

});
const $7a4a7348bcf111f0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $7a4a7348bcf111f0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $7a4a7348bcf111f0$export$f5d5f6bb902f1027 = '-1';

parcelRegister("aNVyA", function(module, exports) {

$parcel$export(module.exports, "saveAssigneeField", () => $c524a0889f8bfdba$export$4966afe29c596da8);

var $lRmyA = parcelRequire("lRmyA");
const $c524a0889f8bfdba$export$4966afe29c596da8 = async (issueKey, fieldKey, newValue, baseUrl)=>{
    const userValue = newValue;
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/assignee`, {
        // the accountId field set to null will unassign the user from the issue as a fallback
        body: JSON.stringify({
            accountId: userValue?.accountId || null
        })
    });
};

});


parcelRegister("gd2u3", function(module, exports) {

$parcel$export(module.exports, "useUserCustomField", () => $294e349634183d9d$export$44f19b35a6cf5de7);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $294e349634183d9d$export$44f19b35a6cf5de7 = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("lu5Yp", function(module, exports) {

$parcel$export(module.exports, "useMultiUserCustomField", () => $41a87322807108ac$export$80bbf5398d3851fe);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $41a87322807108ac$export$80bbf5398d3851fe = ({ issueKey: issueKey, fieldKey: fieldKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.MULTI_USER_CF_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("bBj5E", function(module, exports) {

$parcel$export(module.exports, "useReporterField", () => $2e8f81ed6b967146$export$62a1425ef3dadde5);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");

const $2e8f81ed6b967146$export$62a1425ef3dadde5 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure })=>{
    const fieldKey = (0, $ebc098a76317be78$export$45cafdfd629c3ca1);
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.REPORTER_TYPE));
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("0KeHR", function(module, exports) {

$parcel$export(module.exports, "userSupportedTypes", () => $fbd64ee5f2c95200$export$ef7e74d56a5479e);
$parcel$export(module.exports, "multiUserSupportedTypes", () => $fbd64ee5f2c95200$export$60f19a2c9595ba14);

var $lO4Or = parcelRequire("lO4Or");
const $fbd64ee5f2c95200$export$ef7e74d56a5479e = [
    (0, $lO4Or.USER_CF_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.ASSIGNEE_TYPE)
];
const $fbd64ee5f2c95200$export$60f19a2c9595ba14 = [
    (0, $lO4Or.MULTI_USER_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE)
];

});


parcelRegister("9HYKH", function(module, exports) {

$parcel$export(module.exports, "versionClipboardHandler", () => $023c8b311905714b$export$ac26006c0d5889ca);

var $gGiWF = parcelRequire("gGiWF");

var $lO4Or = parcelRequire("lO4Or");

var $b3neV = parcelRequire("b3neV");

var $fdgl2 = parcelRequire("fdgl2");

var $iAXnP = parcelRequire("iAXnP");
const $023c8b311905714b$var$isTransformedSingleVersion = (option)=>!!option && typeof option === 'object' && 'id' in option && 'name' in option;
const $023c8b311905714b$var$isTransformedMultipleVersions = (fieldValue)=>Array.isArray(fieldValue) && fieldValue.every($023c8b311905714b$var$isTransformedSingleVersion);
const $023c8b311905714b$var$emptyValue = [];
const $023c8b311905714b$var$getPastedValue = (clipboardItem, metadata)=>{
    if (!clipboardItem || !metadata?.fieldType || !metadata?.fieldValue || !$023c8b311905714b$var$isTransformedMultipleVersions(metadata?.fieldValue) && !$023c8b311905714b$var$isTransformedSingleVersion(metadata?.fieldValue)) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (!(0, $iAXnP.versionSupportedTypes).includes(metadata.fieldType)) return null;
    return metadata?.fieldValue;
};
const $023c8b311905714b$var$useVersionClipboardHandler = (issue, field)=>{
    const [, { saveValue: saveValue }] = (0, $gGiWF.useEditField)({
        fieldKey: field.fieldId,
        issueKey: issue.key,
        fieldType: field.type,
        initialValue: $023c8b311905714b$var$isTransformedMultipleVersions(field.value) || $023c8b311905714b$var$isTransformedSingleVersion(field.value) ? field.value : $023c8b311905714b$var$emptyValue
    });
    return (0, $b3neV.useGenericClipboardHandler)(field, $023c8b311905714b$var$getPastedValue, saveValue, $023c8b311905714b$var$isTransformedMultipleVersions(field.value) ? $023c8b311905714b$var$emptyValue : undefined);
};
const $023c8b311905714b$var$VersionClipboardHelper = (0, $fdgl2.createClipboardHelperComponent)($023c8b311905714b$var$useVersionClipboardHandler);
const $023c8b311905714b$export$ac26006c0d5889ca = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $023c8b311905714b$var$VersionClipboardHelper
};

});


parcelRegister("9jnJo", function(module, exports) {

$parcel$export(module.exports, "getCellValue", () => $9634c483718b7af2$export$b1f6fa0c5f374def);
$parcel$export(module.exports, "addToClipboard", () => $9634c483718b7af2$export$89af511f3acca517);
$parcel$export(module.exports, "getFieldMetadataFromClipboard", () => $9634c483718b7af2$export$6de7bf511f204c08);
$parcel$export(module.exports, "notImplemented", () => $9634c483718b7af2$export$94a5f06e658f87e2);

var $7BT9O = parcelRequire("7BT9O");
const $9634c483718b7af2$var$getStringifiedRichFieldValue = (field)=>{
    const richValue = (0, $7BT9O.getRichOrStringValue)(field.type, field);
    if (!richValue) return null;
    if (typeof richValue === 'string') return {
        value: richValue
    };
    return richValue;
};
const $9634c483718b7af2$var$safelyAddRichValueToHtml = (html, richValue)=>{
    try {
        const DOM = new DOMParser().parseFromString(html, 'text/html');
        DOM.body?.querySelector('div')?.setAttribute('data-field-value', JSON.stringify(richValue));
        return DOM.body?.innerHTML || '';
    } catch (e) {
        return html;
    }
};
const $9634c483718b7af2$export$b1f6fa0c5f374def = (field, issue)=>{
    const textValue = (0, $7BT9O.getStringValue)(field.type, field);
    const richValue = $9634c483718b7af2$var$getStringifiedRichFieldValue(field);
    if (!textValue) return {};
    const html = `<div data-type="list-cell" data-issue-type-level="${issue?.issueType?.level}" data-field-id="${field.fieldId}" data-field-type="${field.type}">${textValue}</div>`;
    return {
        html: richValue ? $9634c483718b7af2$var$safelyAddRichValueToHtml(html, richValue) : html,
        plainText: textValue
    };
};
const $9634c483718b7af2$export$89af511f3acca517 = (plainText, html)=>{
    const blobPlain = new window.Blob([
        plainText
    ], {
        type: 'text/plain'
    });
    const blobHTML = new window.Blob([
        html
    ], {
        type: 'text/html'
    });
    const clipboardItem = new window.ClipboardItem({
        'text/html': blobHTML,
        'text/plain': blobPlain
    });
    return navigator.clipboard.write([
        clipboardItem
    ]);
};
const $9634c483718b7af2$export$6de7bf511f204c08 = (clipboard)=>{
    if (!clipboard?.html) return null;
    try {
        const clipboardDocument = new DOMParser().parseFromString(clipboard.html, 'text/html');
        const data = clipboardDocument.body?.querySelector('div')?.dataset;
        if (!data || !data.fieldType || !data.fieldId) return null;
        return {
            fieldType: data.fieldType,
            fieldId: data.fieldId,
            fieldValue: data.fieldValue ? JSON.parse(data.fieldValue) : null,
            sourceIssueTypeLevel: data.issueTypeLevel
        };
    } catch (e) {
        return null;
    }
};
const $9634c483718b7af2$export$94a5f06e658f87e2 = ()=>Promise.resolve(false);

});
parcelRegister("7BT9O", function(module, exports) {

$parcel$export(module.exports, "getStringValue", () => $d008083493fe3461$export$5da374e426806c6a);
$parcel$export(module.exports, "isStringValueSupported", () => $d008083493fe3461$export$c7e2e8fb7867bf39);
$parcel$export(module.exports, "getRichOrStringValue", () => $d008083493fe3461$export$efe475f7dd73bf7c);
// Used in for bulk copy

var $5iWql = parcelRequire("5iWql");

var $yTRlI = parcelRequire("yTRlI");

var $fsiWG = parcelRequire("fsiWG");

var $4Ojeu = parcelRequire("4Ojeu");

var $5OQpT = parcelRequire("5OQpT");

var $cT1pT = parcelRequire("cT1pT");

var $euJic = parcelRequire("euJic");

var $RkH8v = parcelRequire("RkH8v");

var $joDw1 = parcelRequire("joDw1");

var $9astv = parcelRequire("9astv");

var $25ch1 = parcelRequire("25ch1");

var $kmy9M = parcelRequire("kmy9M");

var $eSIrM = parcelRequire("eSIrM");

var $gos6X = parcelRequire("gos6X");

var $fvlEF = parcelRequire("fvlEF");

var $kuvVz = parcelRequire("kuvVz");

var $hYuEu = parcelRequire("hYuEu");

var $fzsEd = parcelRequire("fzsEd");

var $f9D9e = parcelRequire("f9D9e");

var $kOTJc = parcelRequire("kOTJc");

var $8B6Zu = parcelRequire("8B6Zu");

var $iZ3D5 = parcelRequire("iZ3D5");

var $lqLo4 = parcelRequire("lqLo4");

var $czRzv = parcelRequire("czRzv");

var $jG0vv = parcelRequire("jG0vv");

var $1lG3P = parcelRequire("1lG3P");

var $i2HLN = parcelRequire("i2HLN");

var $gXXVe = parcelRequire("gXXVe");

var $aPp7f = parcelRequire("aPp7f");

var $e1ahQ = parcelRequire("e1ahQ");

var $iO2v7 = parcelRequire("iO2v7");
const $d008083493fe3461$var$createStringValueHandlers = (0, $5iWql.default)(()=>({
        ...(0, $fsiWG.categoryStringValueHandler),
        ...(0, $4Ojeu.checkboxStringValueHandler),
        ...(0, $5OQpT.componentsStringValueHandler),
        ...(0, $iO2v7.versionStringValueHandler),
        ...(0, $fvlEF.parentStringValueHandler),
        ...(0, $RkH8v.devSummaryStringValueHandler),
        ...(0, $kmy9M.labelsStringValueHandler),
        ...(0, $gos6X.numberStringValueHandler),
        ...(0, $25ch1.keyStringValueHandler),
        ...(0, $gXXVe.typeStringValueHandler),
        ...(0, $e1ahQ.userStringValueHandler),
        ...(0, $jG0vv.teamStringValueHandler),
        ...(0, $9astv.groupStringValueHandler),
        ...(0, $f9D9e.resolutionStringValueHandler),
        ...(0, $euJic.dateTimeStringValueHandler),
        ...(0, $cT1pT.dateStringValueHandler),
        ...(0, $joDw1.goalStringValueHandler),
        ...(0, $1lG3P.textStringValueHandler),
        ...(0, $kuvVz.priorityStringValueHandler),
        ...(0, $fzsEd.radioSelectStringValueHandler),
        ...(0, $aPp7f.urlStringValueHandler),
        ...(0, $eSIrM.multiSelectStringValueHandler),
        ...(0, $czRzv.statusStringValueHandler),
        ...(0, $lqLo4.statusCategoryStringValueHandler),
        ...(0, $i2HLN.timeTrackingStringValueHandler),
        ...(0, $8B6Zu.singleSelectStringValueHandler),
        ...(0, $iZ3D5.sprintStringValueHandler),
        ...(0, $kOTJc.richTextStringValueHandler),
        ...(0, $hYuEu.projectStringValueHandler),
        ...(0, $yTRlI.cascadingSelectStringValueHandler)
    }));
const $d008083493fe3461$export$5da374e426806c6a = (fieldType, ...args)=>{
    const handlers = $d008083493fe3461$var$createStringValueHandlers();
    if (handlers[fieldType] == null) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return handlers[fieldType]?.(...args);
};
const $d008083493fe3461$export$c7e2e8fb7867bf39 = (fieldType)=>{
    const handlers = $d008083493fe3461$var$createStringValueHandlers();
    return handlers[fieldType] != null;
};
const $d008083493fe3461$var$createRichValueHandlers = (0, $5iWql.default)(()=>({
        ...(0, $fsiWG.categoryRichValueHandler),
        ...(0, $4Ojeu.checkboxRichValueHandler),
        ...(0, $5OQpT.componentsRichValueHandler),
        ...(0, $e1ahQ.userRichValueHandler),
        ...(0, $iO2v7.versionRichValueHandler),
        ...(0, $kuvVz.priorityRichValueHandler),
        ...(0, $eSIrM.multiSelectRichValueHandler),
        ...(0, $8B6Zu.singleSelectRichValueHandler),
        ...(0, $iZ3D5.sprintRichValueHandler),
        ...(0, $fvlEF.parentRichValueHandler),
        ...(0, $jG0vv.teamRichValueHandler),
        ...(0, $hYuEu.projectRichValueHandler)
    }));
const $d008083493fe3461$export$3c808f0df8be4abb = (fieldType)=>{
    const handlers = $d008083493fe3461$var$createRichValueHandlers();
    if (fieldType in handlers) return true;
    return false;
};
const $d008083493fe3461$export$efe475f7dd73bf7c = (fieldType, ...args)=>{
    const handlers = $d008083493fe3461$var$createRichValueHandlers();
    if ($d008083493fe3461$export$3c808f0df8be4abb(fieldType)) return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handlers[fieldType]?.(...args));
    return $d008083493fe3461$export$5da374e426806c6a(fieldType, ...args);
};

});
parcelRegister("fsiWG", function(module, exports) {

$parcel$export(module.exports, "categoryStringValueHandler", () => $77a85ca22e2302a9$export$648bd4153bebf5ec);
$parcel$export(module.exports, "categoryRichValueHandler", () => $77a85ca22e2302a9$export$c7c1e80cbae33846);

var $lO4Or = parcelRequire("lO4Or");
const $77a85ca22e2302a9$var$getCategoryStringValue = (field)=>String(field.value?.value ?? '');
const $77a85ca22e2302a9$export$648bd4153bebf5ec = {
    [(0, $lO4Or.CATEGORY_TYPE)]: $77a85ca22e2302a9$var$getCategoryStringValue
};
const $77a85ca22e2302a9$var$getCategoryRichValue = (field)=>field.value ?? null;
const $77a85ca22e2302a9$export$c7c1e80cbae33846 = {
    [(0, $lO4Or.CATEGORY_TYPE)]: $77a85ca22e2302a9$var$getCategoryRichValue
};

});

parcelRegister("4Ojeu", function(module, exports) {

$parcel$export(module.exports, "checkboxStringValueHandler", () => $5130df98e6a856b4$export$e8595eb8b08dfff6);
$parcel$export(module.exports, "checkboxRichValueHandler", () => $5130df98e6a856b4$export$8c6878c535c99dc0);

var $lO4Or = parcelRequire("lO4Or");
const $5130df98e6a856b4$var$getCheckboxValue = (field)=>String(field.value?.map((option)=>option?.value || '').join(', ') || '');
const $5130df98e6a856b4$export$e8595eb8b08dfff6 = {
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $5130df98e6a856b4$var$getCheckboxValue
};
const $5130df98e6a856b4$var$getCheckboxRichValue = (field)=>field.value ?? [];
const $5130df98e6a856b4$export$8c6878c535c99dc0 = {
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: $5130df98e6a856b4$var$getCheckboxRichValue
};

});

parcelRegister("5OQpT", function(module, exports) {

$parcel$export(module.exports, "componentsStringValueHandler", () => $81e3a86a6c9a3beb$export$8c05fcecf4920250);
$parcel$export(module.exports, "componentsRichValueHandler", () => $81e3a86a6c9a3beb$export$22a98ba00b45930);

var $lO4Or = parcelRequire("lO4Or");
const $81e3a86a6c9a3beb$var$getComponentsStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
const $81e3a86a6c9a3beb$export$8c05fcecf4920250 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $81e3a86a6c9a3beb$var$getComponentsStringValue
};
const $81e3a86a6c9a3beb$var$getComponentsRichValue = (field)=>field.value ?? [];
const $81e3a86a6c9a3beb$export$22a98ba00b45930 = {
    [(0, $lO4Or.COMPONENTS_TYPE)]: $81e3a86a6c9a3beb$var$getComponentsRichValue
};

});

parcelRegister("cT1pT", function(module, exports) {

$parcel$export(module.exports, "dateStringValueHandler", () => $ffd38bb27bd44539$export$e35cf2b38b82bde);

var $lO4Or = parcelRequire("lO4Or");
const $ffd38bb27bd44539$var$getDateValue = (field)=>field.value || '';
const $ffd38bb27bd44539$export$e35cf2b38b82bde = {
    [(0, $lO4Or.START_DATE_TYPE)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.UPDATED)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.CREATED)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $ffd38bb27bd44539$var$getDateValue,
    [(0, $lO4Or.DATE_CF_TYPE)]: $ffd38bb27bd44539$var$getDateValue
};

});

parcelRegister("euJic", function(module, exports) {

$parcel$export(module.exports, "dateTimeStringValueHandler", () => $81ef20e1a106b6db$export$3364b5b1994fef68);

var $lO4Or = parcelRequire("lO4Or");
const $81ef20e1a106b6db$var$getDateTimeValue = (field)=>field.value || '';
const $81ef20e1a106b6db$export$3364b5b1994fef68 = {
    [(0, $lO4Or.DATETIME_CF_TYPE)]: $81ef20e1a106b6db$var$getDateTimeValue
};

});

parcelRegister("RkH8v", function(module, exports) {

$parcel$export(module.exports, "devSummaryStringValueHandler", () => $77b9f098fce15627$export$92f03a013990abef);

var $lO4Or = parcelRequire("lO4Or");

var $3ZZhY = parcelRequire("3ZZhY");
const $77b9f098fce15627$var$getDevSummaryValue = (field, formatMessage)=>{
    if (formatMessage && field) {
        if (field.isMerged) return formatMessage((0, $3ZZhY.default).merged);
        if (field.isUnderReview) return formatMessage((0, $3ZZhY.default).underReview);
        if (field.commitCount) return formatMessage((0, $3ZZhY.default).commit, {
            count: field.commitCount
        });
    }
    return '';
};
const $77b9f098fce15627$export$92f03a013990abef = {
    [(0, $lO4Or.DEV_SUMMARY_CF_TYPE)]: $77b9f098fce15627$var$getDevSummaryValue
};

});
parcelRegister("3ZZhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f753c86aa311a950$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f753c86aa311a950$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    underReview: {
        "id": "business-fields.common.field-types.dev-summary.value.under-review",
        "defaultMessage": "Under review"
    },
    merged: {
        "id": "business-fields.common.field-types.dev-summary.value.merged",
        "defaultMessage": "Merged"
    },
    commit: {
        "id": "business-fields.common.field-types.dev-summary.value.commit",
        "defaultMessage": "{count, plural, one {# commit} other {# commits}}"
    }
});

});


parcelRegister("joDw1", function(module, exports) {

$parcel$export(module.exports, "goalStringValueHandler", () => $398c28294d10b3eb$export$fc09a341d50e572e);

var $lO4Or = parcelRequire("lO4Or");
const $398c28294d10b3eb$export$fc09a341d50e572e = {
    [(0, $lO4Or.GOALS_CF_TYPE)]: null
};

});

parcelRegister("9astv", function(module, exports) {

$parcel$export(module.exports, "groupStringValueHandler", () => $f2ed5e2bfd1b136c$export$520e19bcc394328a);

var $lO4Or = parcelRequire("lO4Or");
const $f2ed5e2bfd1b136c$var$getSingleGroupValue = (field)=>field.value?.name ?? '';
const $f2ed5e2bfd1b136c$var$getMultipleGroupValue = (field)=>field.value == null ? '' : field.value.map((v)=>v?.name).join(',');
const $f2ed5e2bfd1b136c$export$520e19bcc394328a = {
    [(0, $lO4Or.GROUP_CF_TYPE)]: $f2ed5e2bfd1b136c$var$getSingleGroupValue,
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: $f2ed5e2bfd1b136c$var$getMultipleGroupValue
};

});

parcelRegister("25ch1", function(module, exports) {

$parcel$export(module.exports, "keyStringValueHandler", () => $ae96f801a75f45c9$export$6a82d6d16aaf1aae);
const $ae96f801a75f45c9$var$getKeyValue = (field)=>String(field.value || '');
const $ae96f801a75f45c9$export$6a82d6d16aaf1aae = {
    key: $ae96f801a75f45c9$var$getKeyValue
};

});

parcelRegister("kmy9M", function(module, exports) {

$parcel$export(module.exports, "labelsStringValueHandler", () => $82f58d8f913c41c1$export$614150a18e87c3e9);

var $lO4Or = parcelRequire("lO4Or");
const $82f58d8f913c41c1$var$getLabelsValue = (field)=>String(field.value.join(', ') || '');
const $82f58d8f913c41c1$export$614150a18e87c3e9 = {
    [(0, $lO4Or.LABELS_TYPE)]: $82f58d8f913c41c1$var$getLabelsValue,
    [(0, $lO4Or.LABELS_CF_TYPE)]: $82f58d8f913c41c1$var$getLabelsValue
};

});

parcelRegister("eSIrM", function(module, exports) {

$parcel$export(module.exports, "multiSelectStringValueHandler", () => $6c59fa513bc1c63d$export$a8b18450ad254ab4);
$parcel$export(module.exports, "multiSelectRichValueHandler", () => $6c59fa513bc1c63d$export$5b873e39c38cc9ad);

var $lO4Or = parcelRequire("lO4Or");
const $6c59fa513bc1c63d$var$getMultiSelectStringValue = (field)=>String(field.value?.map((option)=>option?.value ?? '').join(', ') ?? '');
const $6c59fa513bc1c63d$export$a8b18450ad254ab4 = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $6c59fa513bc1c63d$var$getMultiSelectStringValue
};
const $6c59fa513bc1c63d$var$getMultiSelectRichValue = (field)=>field.value ?? [];
const $6c59fa513bc1c63d$export$5b873e39c38cc9ad = {
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: $6c59fa513bc1c63d$var$getMultiSelectRichValue
};

});

parcelRegister("gos6X", function(module, exports) {

$parcel$export(module.exports, "numberStringValueHandler", () => $7df6b6a09c279ad1$export$e0e13344aaa5277f);

var $lO4Or = parcelRequire("lO4Or");
const $7df6b6a09c279ad1$var$getNumberValue = (field)=>String(field.value || '');
const $7df6b6a09c279ad1$export$e0e13344aaa5277f = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: $7df6b6a09c279ad1$var$getNumberValue,
    [(0, $lO4Or.STORY_POINTS_TYPE)]: $7df6b6a09c279ad1$var$getNumberValue,
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: $7df6b6a09c279ad1$var$getNumberValue
};

});

parcelRegister("fvlEF", function(module, exports) {

$parcel$export(module.exports, "parentStringValueHandler", () => $b9a8c67ff7dd08e6$export$c53efd3fefacccdb);
$parcel$export(module.exports, "parentRichValueHandler", () => $b9a8c67ff7dd08e6$export$bd920f00473058fd);

var $lO4Or = parcelRequire("lO4Or");
const $b9a8c67ff7dd08e6$var$getParentValue = (field)=>field.value ? field.value.issueKey : '';
const $b9a8c67ff7dd08e6$export$c53efd3fefacccdb = {
    [(0, $lO4Or.PARENT_TYPE)]: $b9a8c67ff7dd08e6$var$getParentValue
};
const $b9a8c67ff7dd08e6$var$getParentRichValue = (field)=>field.value ?? null;
const $b9a8c67ff7dd08e6$export$bd920f00473058fd = {
    [(0, $lO4Or.PARENT_TYPE)]: $b9a8c67ff7dd08e6$var$getParentRichValue
};

});

parcelRegister("kuvVz", function(module, exports) {

$parcel$export(module.exports, "priorityStringValueHandler", () => $e8ab825cd4d4bc62$export$2fcd34cd217ed0e0);
$parcel$export(module.exports, "priorityRichValueHandler", () => $e8ab825cd4d4bc62$export$74a600c7fe980807);

var $lO4Or = parcelRequire("lO4Or");
const $e8ab825cd4d4bc62$var$getPriorityValue = (field)=>field.value?.name || '';
const $e8ab825cd4d4bc62$export$2fcd34cd217ed0e0 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $e8ab825cd4d4bc62$var$getPriorityValue
};
const $e8ab825cd4d4bc62$var$getPriorityRichValue = (field)=>field.value || null;
const $e8ab825cd4d4bc62$export$74a600c7fe980807 = {
    [(0, $lO4Or.PRIORITY_TYPE)]: $e8ab825cd4d4bc62$var$getPriorityRichValue
};

});

parcelRegister("hYuEu", function(module, exports) {

$parcel$export(module.exports, "projectStringValueHandler", () => $01bf04ea817e8d0b$export$ac54e893c65fec32);
$parcel$export(module.exports, "projectRichValueHandler", () => $01bf04ea817e8d0b$export$24de57791a81b4b0);

var $lO4Or = parcelRequire("lO4Or");
const $01bf04ea817e8d0b$var$getProjectValue = (field)=>field.value?.name ?? '';
const $01bf04ea817e8d0b$export$ac54e893c65fec32 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $01bf04ea817e8d0b$var$getProjectValue
};
const $01bf04ea817e8d0b$var$getProjectRichValue = (field)=>field.value ?? null;
const $01bf04ea817e8d0b$export$24de57791a81b4b0 = {
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: $01bf04ea817e8d0b$var$getProjectRichValue
};

});

parcelRegister("fzsEd", function(module, exports) {

$parcel$export(module.exports, "radioSelectStringValueHandler", () => $cead45896b731956$export$5716e87f97e42f22);

var $lO4Or = parcelRequire("lO4Or");
const $cead45896b731956$var$getRadioSelectValue = (field)=>field.value?.label ?? '';
const $cead45896b731956$export$5716e87f97e42f22 = {
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: $cead45896b731956$var$getRadioSelectValue
};

});

parcelRegister("f9D9e", function(module, exports) {

$parcel$export(module.exports, "resolutionStringValueHandler", () => $bc0697fe6d604839$export$ce4b64838599caf9);

var $lO4Or = parcelRequire("lO4Or");
const $bc0697fe6d604839$var$getResolutionValue = (field)=>field.value?.name ?? '';
const $bc0697fe6d604839$export$ce4b64838599caf9 = {
    [(0, $lO4Or.RESOLUTION_TYPE)]: $bc0697fe6d604839$var$getResolutionValue
};

});

parcelRegister("kOTJc", function(module, exports) {

$parcel$export(module.exports, "richTextStringValueHandler", () => $caf08f1fc6cf004b$export$b6df34212c07f1f3);

var $lO4Or = parcelRequire("lO4Or");
const $caf08f1fc6cf004b$var$getStringValue = (field)=>String(field.value || '');
const $caf08f1fc6cf004b$export$b6df34212c07f1f3 = {
    [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: $caf08f1fc6cf004b$var$getStringValue
};

});

parcelRegister("8B6Zu", function(module, exports) {

$parcel$export(module.exports, "singleSelectStringValueHandler", () => $b2e00bb5e8676378$export$6477cb7a98167465);
$parcel$export(module.exports, "singleSelectRichValueHandler", () => $b2e00bb5e8676378$export$8f1681f1304731e9);

var $lO4Or = parcelRequire("lO4Or");
const $b2e00bb5e8676378$var$getSingleSelectValue = (field)=>String(field.value?.value || '');
const $b2e00bb5e8676378$export$6477cb7a98167465 = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $b2e00bb5e8676378$var$getSingleSelectValue
};
const $b2e00bb5e8676378$var$getSingleSelectRichValue = (field)=>field.value || null;
const $b2e00bb5e8676378$export$8f1681f1304731e9 = {
    [(0, $lO4Or.SELECT_CF_TYPE)]: $b2e00bb5e8676378$var$getSingleSelectRichValue
};

});

parcelRegister("iZ3D5", function(module, exports) {

$parcel$export(module.exports, "sprintStringValueHandler", () => $e0fda199a48bfc57$export$c934a6ef333435f4);
$parcel$export(module.exports, "sprintRichValueHandler", () => $e0fda199a48bfc57$export$363144cf26cab14d);

var $lO4Or = parcelRequire("lO4Or");
const $e0fda199a48bfc57$var$getSprintStringValue = (field)=>String(field.value?.map((option)=>option?.name ?? '').join(', ') ?? '');
const $e0fda199a48bfc57$export$c934a6ef333435f4 = {
    [(0, $lO4Or.SPRINT_TYPE)]: $e0fda199a48bfc57$var$getSprintStringValue
};
const $e0fda199a48bfc57$var$getSprintRichValue = (field)=>field.value ?? [];
const $e0fda199a48bfc57$export$363144cf26cab14d = {
    [(0, $lO4Or.SPRINT_TYPE)]: $e0fda199a48bfc57$var$getSprintRichValue
};

});

parcelRegister("lqLo4", function(module, exports) {

$parcel$export(module.exports, "statusCategoryStringValueHandler", () => $162d17be218302c2$export$fbf872252a7f1d2d);

var $lO4Or = parcelRequire("lO4Or");
const $162d17be218302c2$var$getStatusCategoryValue = (field)=>field.value?.name ?? '';
const $162d17be218302c2$export$fbf872252a7f1d2d = {
    [(0, $lO4Or.STATUS_CATEGORY_TYPE)]: $162d17be218302c2$var$getStatusCategoryValue
};

});

parcelRegister("czRzv", function(module, exports) {

$parcel$export(module.exports, "statusStringValueHandler", () => $b04116f176323565$export$237f3a01398656da);

var $lO4Or = parcelRequire("lO4Or");
const $b04116f176323565$var$getStatusValue = (field)=>String(field.name || '');
const $b04116f176323565$export$237f3a01398656da = {
    [(0, $lO4Or.STATUS_TYPE)]: $b04116f176323565$var$getStatusValue
};

});

parcelRegister("jG0vv", function(module, exports) {

$parcel$export(module.exports, "teamStringValueHandler", () => $0e2610139bb58973$export$b5a765abdc307683);
$parcel$export(module.exports, "teamRichValueHandler", () => $0e2610139bb58973$export$c73de7087af53cf7);

var $lO4Or = parcelRequire("lO4Or");
const $0e2610139bb58973$var$getTeamValue = (field)=>field.value?.name ?? '';
const $0e2610139bb58973$export$b5a765abdc307683 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $0e2610139bb58973$var$getTeamValue
};
const $0e2610139bb58973$var$getTeamRichValue = (field)=>field.value ?? null;
const $0e2610139bb58973$export$c73de7087af53cf7 = {
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: $0e2610139bb58973$var$getTeamRichValue
};

});

parcelRegister("1lG3P", function(module, exports) {

$parcel$export(module.exports, "textStringValueHandler", () => $71db45eb582dfce4$export$ec13eae086c24fc4);

var $lO4Or = parcelRequire("lO4Or");
const $71db45eb582dfce4$var$getTextValue = (field)=>String(field.value || '');
const $71db45eb582dfce4$export$ec13eae086c24fc4 = {
    [(0, $lO4Or.SUMMARY_TYPE)]: $71db45eb582dfce4$var$getTextValue,
    [(0, $lO4Or.TEXT_CF_TYPE)]: $71db45eb582dfce4$var$getTextValue
};

});

parcelRegister("i2HLN", function(module, exports) {

$parcel$export(module.exports, "timeTrackingStringValueHandler", () => $913f22ca26e2507b$export$d2867bf3f48fbaac);

var $lO4Or = parcelRequire("lO4Or");
const $913f22ca26e2507b$var$getStringValue = (field)=>String(field.value?.timeInSeconds || '');
const $913f22ca26e2507b$export$d2867bf3f48fbaac = {
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: $913f22ca26e2507b$var$getStringValue
};

});

parcelRegister("gXXVe", function(module, exports) {

$parcel$export(module.exports, "typeStringValueHandler", () => $f09ccae267c636b7$export$8a5121728c374439);

var $lO4Or = parcelRequire("lO4Or");
const $f09ccae267c636b7$var$getTypeValue = (field)=>String(field.value || '');
const $f09ccae267c636b7$export$8a5121728c374439 = {
    [(0, $lO4Or.ISSUE_TYPE)]: $f09ccae267c636b7$var$getTypeValue
};

});

parcelRegister("aPp7f", function(module, exports) {

$parcel$export(module.exports, "urlStringValueHandler", () => $20a1c09842740a68$export$7f5de2e826ef2c21);

var $lO4Or = parcelRequire("lO4Or");
const $20a1c09842740a68$var$getUrlValue = (field)=>String(field.value || '');
const $20a1c09842740a68$export$7f5de2e826ef2c21 = {
    [(0, $lO4Or.URL_CF_TYPE)]: $20a1c09842740a68$var$getUrlValue
};

});

parcelRegister("e1ahQ", function(module, exports) {

$parcel$export(module.exports, "userStringValueHandler", () => $5d2f7f4334a15e66$export$160c08a2783fe34b);
$parcel$export(module.exports, "userRichValueHandler", () => $5d2f7f4334a15e66$export$5fad1a6b4b204395);

var $lO4Or = parcelRequire("lO4Or");
const $5d2f7f4334a15e66$var$getUserStringValue = (field)=>String(field.value?.name || '');
const $5d2f7f4334a15e66$var$getUsersStringValue = (field)=>String(field.value.map((user)=>user?.name).join(', ') || '');
const $5d2f7f4334a15e66$export$160c08a2783fe34b = {
    [(0, $lO4Or.USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserStringValue,
    [(0, $lO4Or.REPORTER_TYPE)]: $5d2f7f4334a15e66$var$getUserStringValue,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $5d2f7f4334a15e66$var$getUserStringValue,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUsersStringValue,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $5d2f7f4334a15e66$var$getUsersStringValue
};
const $5d2f7f4334a15e66$var$getUserRichValue = (field)=>field.value || null;
const $5d2f7f4334a15e66$var$getUserListRichValue = (field)=>field.value || [];
const $5d2f7f4334a15e66$export$5fad1a6b4b204395 = {
    [(0, $lO4Or.USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserRichValue,
    [(0, $lO4Or.REPORTER_TYPE)]: $5d2f7f4334a15e66$var$getUserRichValue,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: $5d2f7f4334a15e66$var$getUserRichValue,
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserListRichValue,
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: $5d2f7f4334a15e66$var$getUserListRichValue
};

});

parcelRegister("iO2v7", function(module, exports) {

$parcel$export(module.exports, "versionStringValueHandler", () => $5a4089cb83dd3276$export$608329dccbc25996);
$parcel$export(module.exports, "versionRichValueHandler", () => $5a4089cb83dd3276$export$534995286ab15bde);

var $lO4Or = parcelRequire("lO4Or");
const $5a4089cb83dd3276$var$getSingleVersionValue = (field)=>field.value?.name ?? '';
const $5a4089cb83dd3276$var$getMultipleVersionValue = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
const $5a4089cb83dd3276$var$getSingleVersionRichValue = (field)=>field.value ?? null;
const $5a4089cb83dd3276$var$getMultipleVersionRichValue = (field)=>field.value ?? [];
const $5a4089cb83dd3276$export$608329dccbc25996 = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getSingleVersionValue,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionValue,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionValue,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionValue
};
const $5a4089cb83dd3276$export$534995286ab15bde = {
    [(0, $lO4Or.VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getSingleVersionRichValue,
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionRichValue,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionRichValue,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $5a4089cb83dd3276$var$getMultipleVersionRichValue
};

});





parcelRegister("cOE3G", function(module, exports) {

$parcel$export(module.exports, "KEY_LEFT", () => $12410568959db5bf$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $12410568959db5bf$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_UP", () => $12410568959db5bf$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $12410568959db5bf$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_SPACE", () => $12410568959db5bf$export$e51a3576c045c8d5);
$parcel$export(module.exports, "KEY_ENTER", () => $12410568959db5bf$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_ESCAPE", () => $12410568959db5bf$export$929c2026f4dd54a2);
$parcel$export(module.exports, "KEY_TAB", () => $12410568959db5bf$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "VALID_HORIZONTAL_NAV_KEYS", () => $12410568959db5bf$export$4db3e0c7105aa3de);
$parcel$export(module.exports, "VALID_NAVIGATION_KEYS", () => $12410568959db5bf$export$dbef91493a5ef2ef);
$parcel$export(module.exports, "NAV_KEYS_TO_DIRECTION", () => $12410568959db5bf$export$678e8f968de3f1e5);
$parcel$export(module.exports, "getNewNavSupportedFieldTypes", () => $12410568959db5bf$export$a421a6d0cf26d9e);

var $5iWql = parcelRequire("5iWql");

var $jGcn0 = parcelRequire("jGcn0");

var $8lNor = parcelRequire("8lNor");

var $lO4Or = parcelRequire("lO4Or");

var $gbsaq = parcelRequire("gbsaq");
const $12410568959db5bf$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $12410568959db5bf$export$c40f9845adc73fb5 = 'ArrowRight';
const $12410568959db5bf$export$390330c10ff2b9a1 = 'ArrowUp';
const $12410568959db5bf$export$a80636c6f41931fe = 'ArrowDown';
const $12410568959db5bf$export$e51a3576c045c8d5 = ' ';
const $12410568959db5bf$export$8152f929a25a0ff4 = 'Enter';
const $12410568959db5bf$export$929c2026f4dd54a2 = 'Escape';
const $12410568959db5bf$export$10f6869ed0a7d75b = 'Tab';
const $12410568959db5bf$export$4db3e0c7105aa3de = new Set([
    $12410568959db5bf$export$fc4577f2a2af0ae3,
    $12410568959db5bf$export$c40f9845adc73fb5,
    $12410568959db5bf$export$10f6869ed0a7d75b
]);
const $12410568959db5bf$export$dbef91493a5ef2ef = new Set([
    ...$12410568959db5bf$export$4db3e0c7105aa3de,
    $12410568959db5bf$export$390330c10ff2b9a1,
    $12410568959db5bf$export$a80636c6f41931fe,
    $12410568959db5bf$export$e51a3576c045c8d5,
    $12410568959db5bf$export$8152f929a25a0ff4,
    $12410568959db5bf$export$929c2026f4dd54a2
]);
const $12410568959db5bf$export$678e8f968de3f1e5 = {
    [$12410568959db5bf$export$fc4577f2a2af0ae3]: (0, $gbsaq.LEFT),
    [$12410568959db5bf$export$c40f9845adc73fb5]: (0, $gbsaq.RIGHT),
    [$12410568959db5bf$export$390330c10ff2b9a1]: (0, $gbsaq.UP),
    [$12410568959db5bf$export$a80636c6f41931fe]: (0, $gbsaq.DOWN)
};
// todo: delete this on cleaning up jira_list_keyboard_nav
const $12410568959db5bf$var$NEW_NAV_SUPPORTED_FIELD_TYPES = new Set([
    (0, $lO4Or.ASSIGNEE_TYPE),
    (0, $lO4Or.CATEGORY_TYPE),
    (0, $lO4Or.COMPONENTS_TYPE),
    (0, $lO4Or.COMMENT_TYPE),
    (0, $jGcn0.COMMENT_SUMMARY_TYPE),
    (0, $lO4Or.CREATED),
    (0, $lO4Or.DATE_CF_TYPE),
    (0, $lO4Or.DATETIME_CF_TYPE),
    (0, $lO4Or.DUE_DATE_TYPE),
    (0, $lO4Or.ISSUE_TYPE),
    (0, $lO4Or.LABELS_TYPE),
    (0, $lO4Or.LABELS_CF_TYPE),
    (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
    (0, $lO4Or.MULTI_SELECT_CF_TYPE),
    (0, $lO4Or.MULTI_USER_CF_TYPE),
    (0, $lO4Or.NUMBER_CF_TYPE),
    (0, $lO4Or.PEOPLE_CF_TYPE),
    (0, $lO4Or.PRIORITY_TYPE),
    (0, $jGcn0.REMOTE_ISSUE_LINKS_TYPE),
    (0, $lO4Or.REPORTER_TYPE),
    (0, $lO4Or.STORY_POINTS_TYPE),
    (0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE),
    (0, $lO4Or.SPRINT_TYPE),
    (0, $lO4Or.SUMMARY_TYPE),
    (0, $lO4Or.SELECT_CF_TYPE),
    (0, $lO4Or.STATUS_TYPE),
    (0, $lO4Or.TEXT_AREA_CF_TYPE),
    (0, $lO4Or.TEXT_CF_TYPE),
    (0, $lO4Or.TIME_ESTIMATE_TYPE),
    (0, $lO4Or.UPDATED),
    (0, $lO4Or.URL_CF_TYPE),
    (0, $lO4Or.USER_CF_TYPE),
    'key'
]);
const $12410568959db5bf$export$a421a6d0cf26d9e = (0, $5iWql.default)(()=>new Set([
        ...$12410568959db5bf$var$NEW_NAV_SUPPORTED_FIELD_TYPES,
        ...(0, $8lNor.getSupportedFieldTypes)(true)
    ]));

});


parcelRegister("en1mL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa06c39bf74c60b7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fa06c39bf74c60b7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreSelections: {
        "id": "business-list.list-view.cell.with-cell-selection.more-selections",
        "defaultMessage": " + {count, plural, one {# other} other {# others}}"
    }
});

});



parcelRegister("fG10K", function(module, exports) {

$parcel$export(module.exports, "default", () => $647ccd5ad04117e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $647ccd5ad04117e7$var$CheckboxCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("eLOGf")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/checkbox-cell/main.tsx"
});
const $647ccd5ad04117e7$var$AsyncCheckboxCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "checkbox-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($647ccd5ad04117e7$var$CheckboxCell, props));
var $647ccd5ad04117e7$export$2e2bcd8739ae039 = $647ccd5ad04117e7$var$AsyncCheckboxCell;

});
parcelRegister("eLOGf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('yx28O');
        const value = parcelRequire('3JWU6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("yx28O").then(()=>parcelRequire('3JWU6'));
}

});


parcelRegister("2Mt92", function(module, exports) {

$parcel$export(module.exports, "ColumnHeader", () => $d46282cefdca340c$export$5667c09b71ee0f05);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a576Y = parcelRequire("a576Y");

var $41WOo = parcelRequire("41WOo");

var $hA1pi = parcelRequire("hA1pi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $78SWx = parcelRequire("78SWx");
var $1q8y0 = parcelRequire("1q8y0");

var $hUuH5 = parcelRequire("hUuH5");


var $lAcL9 = parcelRequire("lAcL9");

var $gQdUL = parcelRequire("gQdUL");
var $ggIv3 = parcelRequire("ggIv3");

var $eCeSD = parcelRequire("eCeSD");

var $cdECG = parcelRequire("cdECG");
const $d46282cefdca340c$var$BOUNDARY = 70;
const $d46282cefdca340c$var$MOUSE_MOVE_THROTTLE = 16;
const $d46282cefdca340c$export$cdd17a489f5a2a5c = 'business-list.ui.list-view.column-header.column-header-container';
const $d46282cefdca340c$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID = 'business-list.ui.list-view.column-header.column-header-container.drag-handle';
const $d46282cefdca340c$export$5667c09b71ee0f05 = ({ icon: icon, label: label, canSortField: canSortField = true, canHideField: canHideField = false, canEditField: canEditField = false, fieldId: fieldId, fieldType: fieldType = '', disableDrag: isDragDisabled, index: index })=>{
    const [isHovering, setIsHovering] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const ref = (0, $eUqFw.useRef)(null);
    const { status: dragStatus } = (0, $1q8y0.useReorderColumns)({
        ref: ref,
        id: fieldId,
        index: index,
        isDragDisabled: isDragDisabled
    });
    const { dropTargetJSX: dropTargetJSX } = (0, $78SWx.useFullHeightColumnDropTarget)({
        id: fieldId,
        index: index
    });
    const [{ isSelected: isSelected }] = (0, $lAcL9.useInlineFieldCreateControls)();
    const { clearIndex: clearIndex, clearIndexAfterDelay: clearIndexAfterDelay, setIndex: setIndex } = (0, $hUuH5.useInlineCreateActions)();
    const { getFieldDetails: getFieldDetails, fieldDetails: fieldDetails, called: called } = (0, $hA1pi.useFieldDetails)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canEditField && isHovering && !fieldDetails && !called) getFieldDetails(fieldId);
    }, [
        called,
        canEditField,
        fieldDetails,
        fieldId,
        getFieldDetails,
        isHovering
    ]);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ updated: MessageDescriptorV2; created: MessageDescriptorV2; priority: MessageDescriptorV2; duedate: MessageDescriptorV2; ... 5 more ...; issuetype: MessageDescriptorV2; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ updated: MessageDescriptorV2; created: MessageDescriptorV2; priority: MessageDescriptorV2; duedate: MessageDescriptorV2; ... 5 more ...; issuetype: MessageDescriptorV2; }'.
    const customLabel = (0, $eCeSD.default)[fieldId] ? formatMessage((0, $eCeSD.default)[fieldId]) : label;
    const showActions = canSortField || canHideField || canEditField;
    const editActionIsVisible = canEditField && !!fieldDetails?.operations.editable;
    const columnActions = showActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.ActionsWrapper), {
        "data-testid": "business-list.ui.list-view.column-header.actions-wrapper"
    }, canSortField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ggIv3.default), {
        columnName: fieldId,
        isVisible: isHovering,
        fieldType: fieldType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d46282cefdca340c$var$EmptyFlexDiv, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQdUL.default), {
        fieldId: fieldId,
        isVisible: isHovering,
        fieldType: fieldType,
        visibleActions: {
            sort: canSortField,
            hide: canHideField,
            edit: editActionIsVisible
        }
    })) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculateColumnIndex = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))((event)=>{
        if (!event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const width = rect.right - rect.left;
        if (x < width / 2 && x <= $d46282cefdca340c$var$BOUNDARY) setIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74), index - 1);
        else if (x >= width / 2 && x >= width - $d46282cefdca340c$var$BOUNDARY) setIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74), index);
        else clearIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74));
    }, $d46282cefdca340c$var$MOUSE_MOVE_THROTTLE), [
        index,
        setIndex,
        clearIndex
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), []);
    const handleMouseLeave = (0, $eUqFw.useCallback)(()=>{
        setIsHovering(false);
        !isSelected && clearIndexAfterDelay((0, $858485d0615f86f6$export$d6f887e0c1be1b74));
    }, [
        clearIndexAfterDelay,
        isSelected
    ]);
    const handleMouseMove = (0, $eUqFw.useCallback)((event)=>{
        event.persist(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (ref.current?.contains(event.target)) calculateColumnIndex(event);
        else clearIndex((0, $858485d0615f86f6$export$d6f887e0c1be1b74));
    }, [
        calculateColumnIndex,
        clearIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.ColumnHeaderContainer), {
        "data-testid": $d46282cefdca340c$export$cdd17a489f5a2a5c,
        ref: ref,
        dragStatus: dragStatus,
        isDragDisabled: isDragDisabled,
        ...(0, $41WOo.isJwmInlineFieldCreateEnabled)() ? {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onMouseMove: handleMouseMove
        } : {
            onMouseEnter: ()=>setIsHovering(true),
            onMouseLeave: ()=>setIsHovering(false)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.Title), null, isHovering && isDragDisabled !== true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d46282cefdca340c$var$ColumnDragHandle, {
        "data-testid": $d46282cefdca340c$var$COLUMN_HEADER_DRAG_HANDLE_TEST_ID
    }) : icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.IconWrapper), null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdECG.TextWrapper), null, customLabel)), dragStatus === 'idle' ? columnActions : null, isDragDisabled !== true ? dropTargetJSX : null);
};
// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d46282cefdca340c$var$EmptyFlexDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d46282cefdca340c$var$ColumnDragHandle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1kt9mrja _is061n3s _1mp41tcg _cfu11txw _24gj1h6o _18oh15vq _eid31b66 _fntn1b66 _sxliewfl _bc1wewfl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hA1pi", function(module, exports) {

$parcel$export(module.exports, "useFieldDetails", () => $25395f6eaa1a1d99$export$ad7ee326a4c8ec42);

var $eUqFw = parcelRequire("eUqFw");

var $kQAZu = parcelRequire("kQAZu");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $huI7r = parcelRequire("huI7r");

var $gd0Sp = parcelRequire("gd0Sp");

var $dhsRn = parcelRequire("dhsRn");

var $3ZwQn = parcelRequire("3ZwQn");

var $dVtoT = parcelRequire("dVtoT");
const $25395f6eaa1a1d99$export$3fa4bbd5b4cf486d = (0, $eo17r.toFlagId)('field-details-error-flag');
const $25395f6eaa1a1d99$export$ad7ee326a4c8ec42 = (showErrorFlag = true)=>{
    const { getFieldDetails: getFieldDetailsService, fieldDetails: fieldDetails, loading: loading, error: error, called: called } = (0, $dhsRn.useFieldDetails)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const project = (0, $kQAZu.useProject)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const projectAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(project.id)
        }), [
        project,
        cloudId
    ]);
    const cloudAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }), [
        cloudId
    ]);
    const getFieldDetails = (0, $eUqFw.useCallback)((fieldId)=>{
        getFieldDetailsService({
            fieldId: fieldId,
            cloudId: cloudAri,
            projectId: projectAri
        });
    }, [
        getFieldDetailsService,
        cloudAri,
        projectAri
    ]);
    const associatedFieldDetails = (0, $eUqFw.useMemo)(()=>(0, $3ZwQn.toAssociatedField)(fieldDetails), [
        fieldDetails
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!showErrorFlag) return;
        if (error) showFlag({
            id: $25395f6eaa1a1d99$export$3fa4bbd5b4cf486d,
            type: 'error',
            title: (0, $dVtoT.default).errorTitle,
            description: (0, $dVtoT.default).errorMessage
        });
        else dismissFlag($25395f6eaa1a1d99$export$3fa4bbd5b4cf486d);
    }, [
        error,
        showFlag,
        dismissFlag,
        showErrorFlag
    ]);
    return {
        getFieldDetails: getFieldDetails,
        fieldDetails: associatedFieldDetails,
        loading: loading,
        error: error,
        called: called
    };
};

});
parcelRegister("dhsRn", function(module, exports) {

$parcel$export(module.exports, "useFieldDetails", () => $b99058508c251e97$export$ad7ee326a4c8ec42);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $4G5xU = parcelRequire("4G5xU");

var $guiFP = parcelRequire("guiFP");

var $fYtpD = parcelRequire("fYtpD");

var $5w4X4 = parcelRequire("5w4X4");
const $b99058508c251e97$export$ad7ee326a4c8ec42 = ()=>{
    const onExperienceSuccess = (0, $4G5xU.useExperienceSuccess)((0, $fYtpD.GET_FIELD_DETAILS_EXPERIENCE));
    const onExperienceFail = (0, $4G5xU.useExperienceFail)((0, $fYtpD.GET_FIELD_DETAILS_EXPERIENCE));
    const onExperienceStart = (0, $4G5xU.useExperienceStart)((0, $fYtpD.GET_FIELD_DETAILS_EXPERIENCE));
    const [getFieldDetailsQuery, { data: data, loading: loading, error: error, called: called }] = (0, $iZuDo.useLazyQuery)((0, $5w4X4.QUERY), {
        onCompleted: ()=>{
            onExperienceSuccess();
        },
        onError: (apolloError)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'JwmCustomFieldDetails',
                    packageName: 'jiraBusinessInlineFieldConfigSidebar',
                    teamName: 'jira-warepil'
                },
                error: Array.isArray(apolloError) && apolloError.length > 0 ? apolloError[0] : apolloError,
                attributes: {
                    message: 'Failed to retrieve field details'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            onExperienceFail('Failed to retrieve field details', apolloError);
        },
        fetchPolicy: 'no-cache'
    });
    const getFieldDetails = (0, $eUqFw.useCallback)((variables)=>{
        onExperienceStart();
        getFieldDetailsQuery({
            variables: variables
        });
    }, [
        onExperienceStart,
        getFieldDetailsQuery
    ]);
    return {
        getFieldDetails: getFieldDetails,
        fieldDetails: data,
        error: error,
        loading: loading,
        called: called
    };
};

});
parcelRegister("5w4X4", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $4b28ee6a644779c6$export$2b91517d6d5b4365);

var $9ypom = parcelRequire("9ypom");
const $4b28ee6a644779c6$export$2b91517d6d5b4365 = (0, $9ypom.default)`
query JWMFieldDetails($cloudId: ID!, $projectId: ID!, $fieldId: String!) {
  jira {
    jwmCustomFieldDetails(cloudId: $cloudId, projectId: $projectId, fieldId: $fieldId) {
      fieldId
      name
      type
      description
      options(first: 100) {
        edges {
          node {
            optionId
            value
            isDisabled
            color {
              id
              colorKey
            }
          }
        }
      }
      configuration
      operations {
        editable
        removable
        deletable
        categoriesWhitelist
        canModifyRequired
        canModifyOptions
        canModifyDefaultValue
        canModifyPropertyConfiguration
        canAssociateInSettings
      }
    }
  }
}`;

});


parcelRegister("3ZwQn", function(module, exports) {

$parcel$export(module.exports, "toAssociatedField", () => $23b075b0e6543f14$export$b14a602973946199);
const $23b075b0e6543f14$export$b14a602973946199 = (data)=>{
    const fieldDetails = data?.jira?.jwmCustomFieldDetails;
    if (!fieldDetails) return;
    return {
        name: fieldDetails.name ?? '',
        key: fieldDetails.fieldId ?? '',
        externalUuid: fieldDetails.fieldId ?? '',
        type: fieldDetails.type ?? '',
        custom: true,
        global: false,
        description: fieldDetails.description ?? '',
        category: '',
        required: false,
        options: fieldDetails.options?.edges ? fieldDetails.options.edges.map((edge)=>({
                id: +String(edge?.node?.optionId),
                optimisticId: String(edge?.node?.optionId),
                value: String(edge?.node?.value),
                externalUuid: String(edge?.node?.optionId)
            })) : undefined,
        configuration: fieldDetails.configuration,
        operations: {
            editable: fieldDetails.operations?.editable ?? false,
            deletable: fieldDetails.operations?.deletable ?? false,
            removable: fieldDetails.operations?.removable ?? false,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            categoriesWhitelist: fieldDetails.operations?.categoriesWhitelist ?? [],
            canAssociateInSettings: fieldDetails.operations?.canAssociateInSettings ?? false,
            canModifyOptions: fieldDetails.operations?.canModifyOptions ?? false,
            canModifyDefaultValue: false,
            canModifyPropertyConfiguration: fieldDetails.operations?.canModifyPropertyConfiguration ?? false,
            canModifyRequired: fieldDetails.operations?.canModifyRequired ?? false
        },
        availability: null
    };
};

});

parcelRegister("dVtoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d172b07ec89405$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $72d172b07ec89405$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-inline-field-config-sidebar.controllers.field-details.error-title",
        "defaultMessage": "We couldn't load the field details"
    },
    errorMessage: {
        "id": "business-inline-field-config-sidebar.controllers.field-details.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("78SWx", function(module, exports) {

$parcel$export(module.exports, "useFullHeightColumnDropTarget", () => $02037222f73e7f06$export$2d25a320c0ca42d3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $loClp = parcelRequire("loClp");

var $4wxE1 = parcelRequire("4wxE1");
const $02037222f73e7f06$export$79660a248b11010 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1lxk _4t3iz7a8 _1e0cglyw",
            __cmplp.className
        ])
    });
});
function $02037222f73e7f06$export$2d25a320c0ca42d3({ id: id, index: index }) {
    const [closestEdge, setClosestEdge] = (0, $eUqFw.useState)(null);
    const [isDraggingAnyColumn, setIsDraggingAnyColumn] = (0, $eUqFw.useState)(false);
    const { monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements, attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge } = (0, $4wxE1.useDragAndDropAsyncModules)();
    const dropTargetRef = (0, $eUqFw.useRef)(null);
    const dropTargetJSX = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02037222f73e7f06$export$79660a248b11010, {
        ref: dropTargetRef,
        "data-testid": "business-list.controllers.drag-and-drop.use-full-height-column-drop-target.drop-target"
    }, closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loClp.DropIndicator), {
        edge: closestEdge
    }));
    (0, $eUqFw.useEffect)(()=>monitorForElements({
            canMonitor ({ source: source }) {
                return source.data.type === 'table-header';
            },
            onGenerateDragPreview () {
                if (dropTargetRef.current) dropTargetRef.current.style.display = 'block';
            },
            onDragStart () {
                setIsDraggingAnyColumn(true);
            },
            onDrop () {
                setIsDraggingAnyColumn(false);
                if (dropTargetRef.current) dropTargetRef.current.style.display = 'none';
            }
        }), [
        monitorForElements,
        setIsDraggingAnyColumn
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const dropTarget = dropTargetRef.current;
        if (!isDraggingAnyColumn || !dropTarget) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        return dropTargetForElements({
            element: dropTarget,
            getIsSticky () {
                return true;
            },
            getData ({ input: input, element: element }) {
                const data = {
                    id: id,
                    index: index
                };
                return attachClosestEdge(data, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                });
            },
            canDrop ({ source: source }) {
                return source.data.type === 'table-header';
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge(extractClosestEdge(self.data));
            },
            onDragLeave () {
                setClosestEdge(null);
            },
            onDrop () {
                setClosestEdge(null);
            }
        });
    }, [
        attachClosestEdge,
        dropTargetForElements,
        extractClosestEdge,
        id,
        index,
        isDraggingAnyColumn
    ]);
    return {
        dropTargetJSX: dropTargetJSX
    };
}

});
parcelRegister("loClp", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $fc57283f6cd57fbe$export$62ed72bc21f6b8a6);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $fvYC3 = parcelRequire("fvYC3");
const $fc57283f6cd57fbe$var$lineStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: (0, $fvYC3.line).backgroundColor,
    content: '""',
    pointerEvents: 'none'
});
const $fc57283f6cd57fbe$var$edgeStyles = {
    top: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        top: 'var(--local-line-offset)',
        right: 0,
        left: 0
    }),
    right: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        top: 0,
        right: 'var(--local-line-offset)',
        bottom: 0
    }),
    bottom: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $fvYC3.line).thickness,
        right: 0,
        bottom: 'var(--local-line-offset)',
        left: 0
    }),
    left: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $fvYC3.line).thickness,
        top: 0,
        bottom: 0,
        left: 'var(--local-line-offset)'
    })
};
function $fc57283f6cd57fbe$export$62ed72bc21f6b8a6({ edge: edge, gap: gap = '0px' }) {
    /**
   * To clearly communicate the resting place of a draggable item during a drag operation,
   * the drop indicator should be positioned half way between draggable items.
   */ const lineOffset = `calc(-0.5 * (${gap} + ${(0, $fvYC3.line).thickness}px))`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fc57283f6cd57fbe$var$lineStyles,
            edge && $fc57283f6cd57fbe$var$edgeStyles[edge]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            '--local-line-offset': lineOffset
        }
    });
}
var // This default export is intended for usage with React.lazy
$fc57283f6cd57fbe$export$2e2bcd8739ae039 = $fc57283f6cd57fbe$export$62ed72bc21f6b8a6;

});
parcelRegister("fvYC3", function(module, exports) {

$parcel$export(module.exports, "line", () => $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c);
/**
 * Design decisions for the drop indicator's main line
 */ const $eb1ef4b0dfcaaeec$export$53f1d5ea8de3d7c = {
    borderRadius: 0,
    thickness: 2,
    backgroundColor: "var(--ds-border-selected, #0C66E4)"
};

});


parcelRegister("4wxE1", function(module, exports) {

$parcel$export(module.exports, "useDragAndDropAsyncModules", () => $425bd90ad6f66715$export$c56d63ea801ce3a6);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $doIBW = parcelRequire("doIBW");
var $7shEs = parcelRequire("7shEs");

const $425bd90ad6f66715$export$d146a9e5d792fbb2 = ()=>(0, $doIBW.importForInteraction)(()=>Promise.resolve((parcelRequire("eo9PV"))), {
        moduleId: "a81eb583"
    });

const $425bd90ad6f66715$export$7c4ce555ad7d3850 = ()=>(0, $doIBW.importForInteraction)(()=>(parcelRequire("eHpB2")), {
        moduleId: "63a9d67a"
    });

const $425bd90ad6f66715$export$435d59857451154b = ()=>(0, $doIBW.importForInteraction)(()=>(parcelRequire("crxnW")), {
        moduleId: "5ef6ba42"
    });

const $425bd90ad6f66715$export$361499d975b59f21 = ()=>(0, $doIBW.importForInteraction)(()=>(parcelRequire("cEm0R")), {
        moduleId: "fbbc3330"
    });

const $425bd90ad6f66715$export$5e8458edfac77ad = ()=>(0, $doIBW.importForInteraction)(()=>(parcelRequire("zQKg1")), {
        moduleId: "8a3e47ea"
    });

const $425bd90ad6f66715$export$d75430c29c69863c = ()=>(0, $doIBW.importForInteraction)(()=>(parcelRequire("iB3X6")), {
        moduleId: "b863ce2b"
    });
const $425bd90ad6f66715$export$86880b4b2e1a2384 = 'column.widths';
const $425bd90ad6f66715$var$actions = {
    loadModules: ()=>({ setState: setState })=>{
            (0, $7shEs.waitForAllResources)([
                $425bd90ad6f66715$export$d146a9e5d792fbb2(),
                $425bd90ad6f66715$export$7c4ce555ad7d3850(),
                $425bd90ad6f66715$export$435d59857451154b(),
                $425bd90ad6f66715$export$361499d975b59f21(),
                $425bd90ad6f66715$export$5e8458edfac77ad(),
                $425bd90ad6f66715$export$d75430c29c69863c()
            ]).onComplete(([{ draggable: draggable, monitorForElements: monitorForElements, dropTargetForElements: dropTargetForElements }, { autoScroller: autoScroller }, { attachClosestEdge: attachClosestEdge, extractClosestEdge: extractClosestEdge }, // @ts-expect-error waitForAllResources has a wrong type
            { getReorderDestinationIndex: getReorderDestinationIndex }, // @ts-expect-error same as above
            { combine: combine }, // @ts-expect-error same as above
            { attachInstruction: attachInstruction, extractInstruction: extractInstruction }])=>{
                setState({
                    draggable: draggable,
                    monitorForElements: monitorForElements,
                    dropTargetForElements: dropTargetForElements,
                    autoScroller: autoScroller,
                    attachClosestEdge: attachClosestEdge,
                    extractClosestEdge: extractClosestEdge,
                    getReorderDestinationIndex: getReorderDestinationIndex,
                    combine: combine,
                    attachInstruction: attachInstruction,
                    extractInstruction: extractInstruction
                });
            });
        }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
const $425bd90ad6f66715$var$noop = ()=>()=>{};
const $425bd90ad6f66715$var$Store = (0, $a61MH.createStore)({
    initialState: {
        draggable: $425bd90ad6f66715$var$noop,
        monitorForElements: $425bd90ad6f66715$var$noop,
        dropTargetForElements: $425bd90ad6f66715$var$noop,
        autoScroller: {
            start: $425bd90ad6f66715$var$noop,
            stop: $425bd90ad6f66715$var$noop,
            updateInput: $425bd90ad6f66715$var$noop
        },
        attachClosestEdge: $425bd90ad6f66715$var$noop,
        extractClosestEdge: $425bd90ad6f66715$var$noop,
        getReorderDestinationIndex: $425bd90ad6f66715$var$noop,
        combine: $425bd90ad6f66715$var$noop,
        attachInstruction: $425bd90ad6f66715$var$noop,
        extractInstruction: $425bd90ad6f66715$var$noop
    },
    actions: $425bd90ad6f66715$var$actions,
    name: 'JWMDragAndDropAsyncModulesStore'
});
const $425bd90ad6f66715$var$useHook = (0, $ggKAj.createHook)($425bd90ad6f66715$var$Store);
const $425bd90ad6f66715$export$c56d63ea801ce3a6 = ()=>{
    const [asyncModules, { loadModules: loadModules }] = $425bd90ad6f66715$var$useHook();
    (0, $eUqFw.useEffect)(()=>{
        loadModules();
    }, [
        loadModules
    ]);
    return asyncModules;
};

});
parcelRegister("doIBW", function(module, exports) {

$parcel$export(module.exports, "importForInteraction", () => $9c101f133ada8874$export$5b50cea0b44df65b);

var $49WjJ = parcelRequire("49WjJ");

var $lzHCi = parcelRequire("lzHCi");

var $cFcvW = parcelRequire("cFcvW");
const $9c101f133ada8874$var$cache = (0, $49WjJ.createCache)(new Map());
function $9c101f133ada8874$export$5b50cea0b44df65b(loader, opts) {
    const resource = $9c101f133ada8874$var$cache.get(opts.moduleId, ()=>(0, $lzHCi.JSResource)(()=>(0, $cFcvW.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
    resource.load().catch(()=>{});
    return resource;
}

});

parcelRegister("7shEs", function(module, exports) {

$parcel$export(module.exports, "waitForAllResources", () => $56d8d7225f826ffa$export$c33694368275e0ee);
function $56d8d7225f826ffa$export$c33694368275e0ee(resources) {
    return {
        onComplete (onLoad, onError) {
            const cleanups = [];
            const values = new Array(resources.length);
            let completed = false;
            const dispose = ()=>{
                cleanups.forEach((cleanup)=>cleanup());
                cleanups.length = 0;
            };
            const done = ()=>{
                dispose();
                completed = true;
            };
            let loadedResources = 0;
            for(let i = 0; i < resources.length && !completed; i++){
                const completable = resources[i];
                cleanups.push(completable.onComplete((value)=>{
                    values[i] = value;
                    loadedResources++;
                    if (loadedResources === resources.length) {
                        onLoad(values);
                        done();
                    }
                }, (error)=>{
                    onError === null || onError === void 0 || onError(error);
                    done();
                }));
            }
            return dispose;
        }
    };
}

});

parcelRegister("eHpB2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hjT7J');
        const value = parcelRequire('5Pwiq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hjT7J").then(()=>parcelRequire('5Pwiq'));
}

});

parcelRegister("crxnW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l4v3n');
        const value = parcelRequire('fSMvP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l4v3n").then(()=>parcelRequire('fSMvP'));
}

});

parcelRegister("cEm0R", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('Zns5L');
        const value = parcelRequire('4c90u');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("Zns5L").then(()=>parcelRequire('4c90u'));
}

});

parcelRegister("zQKg1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jmPXK');
        const value = parcelRequire('3f2za');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jmPXK").then(()=>parcelRequire('3f2za'));
}

});

parcelRegister("iB3X6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('116mw');
        const value = parcelRequire('dLGEC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("116mw").then(()=>parcelRequire('dLGEC'));
}

});



parcelRegister("1q8y0", function(module, exports) {

$parcel$export(module.exports, "useReorderColumns", () => $0d4ced0bc7fb3f86$export$b250c61f32d9da58);

var $eUqFw = parcelRequire("eUqFw");

var $4wxE1 = parcelRequire("4wxE1");

var $g20qB = parcelRequire("g20qB");

var $hjMF7 = parcelRequire("hjMF7");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $0d4ced0bc7fb3f86$var$noop = ()=>{};
const $0d4ced0bc7fb3f86$export$b250c61f32d9da58 = ({ id: id, index: index, isDragDisabled: isDragDisabled, ref: ref })=>{
    const [status, setStatus] = (0, $eUqFw.useState)('idle');
    const { combine: combine, draggable: draggable } = (0, $4wxE1.useDragAndDropAsyncModules)();
    (0, $eUqFw.useEffect)(()=>{
        const el = ref.current;
        if (isDragDisabled || !el) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        let nextSiblingCleanupFn = $0d4ced0bc7fb3f86$var$noop;
        let tableBodyCleanupFn = $0d4ced0bc7fb3f86$var$noop;
        return combine(draggable({
            element: el,
            getInitialData () {
                return {
                    type: 'table-header',
                    id: id,
                    index: index
                };
            },
            onGenerateDragPreview () {
                setStatus('preview');
                // make sure the drag preview doesn't have table scroll
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const tableBody = el.closest(`.${(0, $g20qB.cl).BASE_TABLE}`)?.querySelector(`.${(0, $g20qB.cl).BASE_TABLE_BODY}`);
                if (tableBody) tableBodyCleanupFn = (0, $hjMF7.setStyle)(tableBody, {
                    overflow: 'hidden'
                });
                // hide resize handle for the drag preview
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const nextSibling = el?.nextSibling;
                if (nextSibling) nextSiblingCleanupFn = (0, $hjMF7.setStyle)(nextSibling, {
                    visibility: 'hidden'
                });
            },
            onDragStart () {
                setStatus('dragging');
                tableBodyCleanupFn();
            },
            onDrop () {
                setStatus('idle');
                nextSiblingCleanupFn();
            }
        }));
    }, [
        isDragDisabled,
        id,
        index,
        ref,
        draggable,
        combine
    ]);
    return {
        status: status
    };
};

});
parcelRegister("g20qB", function(module, exports) {

$parcel$export(module.exports, "cssVarTableHeight", () => $aeeda964183feaca$export$4c4d2d5ba926bbe5);
$parcel$export(module.exports, "cl", () => $aeeda964183feaca$export$b975d55abac2bbe3);
$parcel$export(module.exports, "INDENT_PER_LEVEL", () => $aeeda964183feaca$export$130b26c73bb9d040);
$parcel$export(module.exports, "EXPAND_DELAY_MS", () => $aeeda964183feaca$export$e5daf2bc041d74b0);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $aeeda964183feaca$export$5b388ccfa29be01);
const $aeeda964183feaca$export$4c4d2d5ba926bbe5 = '--jwm-list-height';
const $aeeda964183feaca$export$b975d55abac2bbe3 = {
    BASE_TABLE: 'BaseTable',
    BASE_TABLE_BODY: 'BaseTable__body',
    BASE_TABLE_TABLE: 'BaseTable__table',
    MULTIDRAG_COUNTER: 'jwm-multidrag-counter'
};
const $aeeda964183feaca$export$130b26c73bb9d040 = 25;
const $aeeda964183feaca$export$e5daf2bc041d74b0 = 500;
const $aeeda964183feaca$export$5b388ccfa29be01 = -1;

});

parcelRegister("hjMF7", function(module, exports) {

$parcel$export(module.exports, "setStyle", () => $848101c3f10a2435$export$37a5fde709c1db82);
/* eslint-disable no-param-reassign */ /** Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $848101c3f10a2435$export$37a5fde709c1db82(el, css) {
    const originalCss = {};
    Object.keys(css).forEach((property)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        originalCss[property] = el.style[property];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        el.style[property] = css[property];
    });
    return ()=>{
        Object.keys(originalCss).forEach((property)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            el.style[property] = originalCss[property];
        });
    };
}

});


parcelRegister("hUuH5", function(module, exports) {

$parcel$export(module.exports, "InlineCreateContainer", () => $c546f888aa885ec7$export$c61fba5cf4e215ae);
$parcel$export(module.exports, "useInlineCreateActions", () => $c546f888aa885ec7$export$5d97dcebeb3ebb31);
$parcel$export(module.exports, "useInlineIssueCreateContext", () => $c546f888aa885ec7$export$81dc4a9ada8e5cf3);
$parcel$export(module.exports, "useInlineFieldCreateContext", () => $c546f888aa885ec7$export$3b94b6fe5fe8d50d);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $c546f888aa885ec7$var$CLEAR_DELAY = 300;
const $c546f888aa885ec7$var$initialState = {
    issue: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    },
    field: {
        index: undefined,
        isIndexLocked: false,
        timeoutId: undefined
    }
};
const $c546f888aa885ec7$var$actions = {
    setIndex: (key, index)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: index
                }
            });
            dispatch($c546f888aa885ec7$var$actions.lockIndex(key));
        },
    clearIndex: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    index: undefined
                }
            });
            dispatch($c546f888aa885ec7$var$actions.unlockIndex(key));
        },
    clearIndexAfterDelay: (key)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const timeoutId = setTimeout(()=>{
                if (!getState()[key].isIndexLocked) {
                    dispatch($c546f888aa885ec7$var$actions.clearIndex(key));
                    setState({
                        [key]: {
                            ...getState()[key],
                            timeoutId: undefined
                        }
                    });
                }
            }, $c546f888aa885ec7$var$CLEAR_DELAY);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false,
                    timeoutId: timeoutId
                }
            });
        },
    lockIndex: (key)=>({ setState: setState, getState: getState })=>{
            const { timeoutId: timeoutId } = getState()[key];
            if (timeoutId) clearTimeout(timeoutId);
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: true,
                    timeoutId: undefined
                }
            });
        },
    unlockIndex: (key)=>({ setState: setState, getState: getState })=>{
            setState({
                [key]: {
                    ...getState()[key],
                    isIndexLocked: false
                }
            });
        }
};
const $c546f888aa885ec7$export$c61fba5cf4e215ae = (0, $heB5U.createContainer)();
const $c546f888aa885ec7$var$Store = (0, $a61MH.createStore)({
    initialState: $c546f888aa885ec7$var$initialState,
    actions: $c546f888aa885ec7$var$actions,
    name: 'JwmListInlineCreate',
    containedBy: $c546f888aa885ec7$export$c61fba5cf4e215ae
});
const $c546f888aa885ec7$export$1baf430619906b52 = (0, $ggKAj.createHook)($c546f888aa885ec7$var$Store);
const $c546f888aa885ec7$export$5d97dcebeb3ebb31 = (0, $ggKAj.createActionsHook)($c546f888aa885ec7$var$Store);
const $c546f888aa885ec7$var$getInlineIssueCreate = (state)=>state.issue;
const $c546f888aa885ec7$var$getInlineFieldCreate = (state)=>state.field;
const $c546f888aa885ec7$export$81dc4a9ada8e5cf3 = (0, $ggKAj.createHook)($c546f888aa885ec7$var$Store, {
    selector: $c546f888aa885ec7$var$getInlineIssueCreate
});
const $c546f888aa885ec7$export$3b94b6fe5fe8d50d = (0, $ggKAj.createHook)($c546f888aa885ec7$var$Store, {
    selector: $c546f888aa885ec7$var$getInlineFieldCreate
});

});

const $858485d0615f86f6$export$76a449e52fa0e1e8 = 'issue';
const $858485d0615f86f6$export$d6f887e0c1be1b74 = 'field';

parcelRegister("gQdUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c7f5836ca36f72$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fuZtH = parcelRequire("fuZtH");
const $d6c7f5836ca36f72$var$ActionsDropdownMenu = ({ isVisible: isVisible, ...rest })=>{
    const [isMenuOpen, setMenuOpen] = (0, $eUqFw.useState)(false);
    // Defer loading ActionsDropdownMenu until the column is hovered
    return isMenuOpen || isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fuZtH.default), {
        ...rest,
        setMenuOpen: setMenuOpen
    }) : null;
};
var $d6c7f5836ca36f72$export$2e2bcd8739ae039 = $d6c7f5836ca36f72$var$ActionsDropdownMenu;

});
parcelRegister("fuZtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb3560db7e29ea1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7bb3560db7e29ea1$var$ActionsDropdownMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("i1j3z")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/actions-dropdown-menu/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7bb3560db7e29ea1$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jwm-common-actions-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7bb3560db7e29ea1$var$ActionsDropdownMenu, props));

});
parcelRegister("i1j3z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dydm5')
        ]);
        const value = parcelRequire('gsOav');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dydm5")
    ]).then(()=>parcelRequire('gsOav'));
}

});



parcelRegister("ggIv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac91866b442541a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iaCjO = parcelRequire("iaCjO");

var $gGtKh = parcelRequire("gGtKh");

const $4ac91866b442541a$export$9951126d1499b75c = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("aNg4Q")), {
    ssr: false,
    moduleId: "./src/packages/business/list/src/ui/list-view/column-header/field-actions/sorting-indicator/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4ac91866b442541a$export$2e2bcd8739ae039 = (props)=>{
    const [sorting] = (0, $iaCjO.useSorting)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sorting-indicator",
        fallback: null
    }, (props.columnName === sorting.sortBy || props.isVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ac91866b442541a$export$9951126d1499b75c, props));
};

});
parcelRegister("aNg4Q", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dPTnA');
        const value = parcelRequire('6Jtmp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dPTnA").then(()=>parcelRequire('6Jtmp'));
}

});


parcelRegister("eCeSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c02f2a7aea43e9c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c02f2a7aea43e9c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issuetype: {
        "id": "business-list.list-view.column-header.issuetype",
        "defaultMessage": "Type"
    },
    issuekey: {
        "id": "business-list.list-view.column-header.issuekey",
        "defaultMessage": "Key"
    },
    summary: {
        "id": "business-list.list-view.column-header.summary",
        "defaultMessage": "Summary"
    },
    status: {
        "id": "business-list.list-view.column-header.status",
        "defaultMessage": "Status"
    },
    assignee: {
        "id": "business-list.list-view.column-header.assignee",
        "defaultMessage": "Assignee"
    },
    labels: {
        "id": "business-list.list-view.column-header.labels",
        "defaultMessage": "Labels"
    },
    duedate: {
        "id": "business-list.list-view.column-header.duedate",
        "defaultMessage": "Due date"
    },
    priority: {
        "id": "business-list.list-view.column-header.priority",
        "defaultMessage": "Priority"
    },
    created: {
        "id": "business-list.list-view.column-header.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "business-list.list-view.column-header.updated",
        "defaultMessage": "Updated"
    }
});

});

parcelRegister("cdECG", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderContainer", () => $55907a73f66afd6c$export$8006ab862c5622cc);
$parcel$export(module.exports, "Title", () => $55907a73f66afd6c$export$f99233281efd08a0);
$parcel$export(module.exports, "TextWrapper", () => $55907a73f66afd6c$export$7c3018f441722857);
$parcel$export(module.exports, "IconWrapper", () => $55907a73f66afd6c$export$be58b4326e23250f);
$parcel$export(module.exports, "ActionsWrapper", () => $55907a73f66afd6c$export$c8223871eecc8f3a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $55907a73f66afd6c$export$8006ab862c5622cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragDisabled: isDragDisabled, dragStatus: dragStatus, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.isDragDisabled === false && "_80om1qgj",
            __cmplp.dragStatus === 'dragging' && "_11q71caa _syaz9jg2 _80om5szm",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$f99233281efd08a0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlidpf _1reo15vq _18m915vq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$7c3018f441722857 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _o5721q9c _1bto1l2s _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _4t3i1tcg _2hwx1b66 _18u01b66",
            __cmplp.className
        ])
    });
});
const $55907a73f66afd6c$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1yb4 _18s8otz2 _x7odidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("62F3R", function(module, exports) {

$parcel$export(module.exports, "CommentsCell", () => $f8a14dd987a5d2c4$export$11f3e85eadff465c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $d3vNK = parcelRequire("d3vNK");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8UbeN = parcelRequire("8UbeN");

var $9LxEP = parcelRequire("9LxEP");
const $f8a14dd987a5d2c4$export$11f3e85eadff465c = ({ issueKey: issueKey, isSelected: isSelected = false, onClick: onClick, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, totalCount: totalCount, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); /**
                  * To be deleted when jira_list_keyboard_nav is cleaned up
                  * @deprecated Now handled in CellNavigation component
                  */ 
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onClick(issueKey);
    }, [
        onClick,
        issueKey
    ]); /**
                            * To be deleted when jira_list_keyboard_nav is cleaned up
                            * @deprecated Now handled in CellNavigation component
                            */ 
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') {
            handleClick();
            return;
        }
        onKeyDown?.(e);
    }, [
        onKeyDown,
        handleClick
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Enter') {
            onClick(issueKey);
            return true;
        }
        return false;
    }, [
        issueKey,
        onClick
    ]);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDownNew,
            onClick: ()=>true
        }), [
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]); /**
                                                                 * To be deleted when jira_list_keyboard_nav is cleaned up
                                                                 * @deprecated Now handled in CellNavigation component
                                                                 */ 
    const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    const renderedCommentCount = (0, $eUqFw.useMemo)(()=>{
        if (totalCount == null) return null;
         // No comments, add comment
        if (totalCount === 0) return formatMessage((0, $9LxEP.default).addComment);
         // Less than 100 comments, show count
        if (totalCount < 100) return formatMessage((0, $9LxEP.default).commentsCount, {
            commentCount: totalCount
        });
         // More than 99 comments, show 99+
        return formatMessage((0, $9LxEP.default).moreComments);
    }, [
        formatMessage,
        totalCount
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8a14dd987a5d2c4$export$6ce170286acaa8d3, {
        noComments: totalCount === 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
        size: "medium",
        label: formatMessage((0, $9LxEP.default).comments)
    }), renderedCommentCount));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f8a14dd987a5d2c4$var$wrapperStyles,
        onClick: handleClick
    }, cellContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.CellWrapper), {
        isFocused: isSelected,
        isEditable: true,
        onClick: handleClick,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef
    }, cellContent);
};
const $f8a14dd987a5d2c4$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { noComments: noComments, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq _7yhb1b66",
            __cmplp.noComments ? "_syazobra" : "_syaz1x9z",
            __cmplp.className
        ])
    });
});
const $f8a14dd987a5d2c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    paddingLeft: 'space.100'
});

});
parcelRegister("9LxEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd1484fdc343cd8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1cd1484fdc343cd8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    comments: {
        "id": "business-list.list-view.comments-cell.comments",
        "defaultMessage": "Comments"
    },
    commentsCount: {
        "id": "business-list.list-view.comments-cell.comments-count",
        "defaultMessage": "{commentCount, plural, one {# comment} other {# comments}}"
    },
    moreComments: {
        "id": "business-list.list-view.comments-cell.more-comments",
        "defaultMessage": "99+ comments"
    },
    addComment: {
        "id": "business-list.list-view.comments-cell.add-comment",
        "defaultMessage": "Add comment"
    }
});

});


parcelRegister("2tEhM", function(module, exports) {

$parcel$export(module.exports, "CommentsSidebar", () => $241e55154b6735ba$export$46e144cce632afca);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");



var $gJYxu = parcelRequire("gJYxu");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $c4qEZ = parcelRequire("c4qEZ");

var $fTCaK = parcelRequire("fTCaK");
const $241e55154b6735ba$var$PACKAGE_NAME = 'jwmCommentsSidebarIssueApp';

const $241e55154b6735ba$export$35dd9ab573b87c3f = (0, $7rh0R.lazy)(()=>(parcelRequire("f4xMV")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $241e55154b6735ba$export$46e144cce632afca = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, onClose: onClose })=>{
    (0, $fTCaK.useScrollToComments)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "businessCommentsSidebarInListView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: $241e55154b6735ba$var$PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($241e55154b6735ba$var$CSSAntiCorruptionLayer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($241e55154b6735ba$export$35dd9ab573b87c3f, {
        analyticsSource: (0, $0100842672acae20$export$7ca28938a07e0c33),
        issueKey: issueKey,
        onClose: onClose,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        shouldShowRootProjectsBreadcrumb: true,
        isSpaEnabled: false,
        isLoadedWithPage: false,
        viewModeOptions: {
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040)
        }
    })))));
});
/**
 * Used to fix styles of Issue App in Sidebar broken by nested selectors affecting clipboard boundary
 * inline div on feature cleanup
 * remove div on SidebarContent improvement
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $241e55154b6735ba$var$CSSAntiCorruptionLayer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fTCaK", function(module, exports) {

$parcel$export(module.exports, "useScrollToComments", () => $a71248087d725810$export$5baf464300edba1e);

var $eUqFw = parcelRequire("eUqFw");

var $k7cZh = parcelRequire("k7cZh");

var $cSEXi = parcelRequire("cSEXi");
const $a71248087d725810$var$INTERVAL = 100;
const $a71248087d725810$var$TIMEOUT = 10000;
// account for Bento's sticky header
const $a71248087d725810$var$SCROLL_PADDING = 34;
const $a71248087d725810$export$f0c653cfd7dea798 = ()=>{
    const nodes = Array.from(document.querySelectorAll(`#${(0, $cSEXi.ELID_ISSUE_HEADER)} + div h2`));
    // take the last H2 inside Bento (comments section header)
    return nodes.length ? nodes[nodes.length - 1] : null;
};
const $a71248087d725810$export$5baf464300edba1e = ({ issueKey: issueKey })=>{
    const intervalId = (0, $eUqFw.useRef)();
    const timeoutId = (0, $eUqFw.useRef)();
    const isTimeout = (0, $eUqFw.useRef)(false);
    const waitForElement = (0, $eUqFw.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $a71248087d725810$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref && (0, $k7cZh.default)(ref, {
                scrollMode: 'always',
                block: 'start',
                inline: 'nearest',
                behavior: (actions)=>actions.forEach(({ el: el, top: top })=>{
                        // eslint-disable-next-line no-param-reassign
                        el.scrollTop = top - $a71248087d725810$var$SCROLL_PADDING;
                    })
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $a71248087d725810$var$INTERVAL);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $a71248087d725810$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $a71248087d725810$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey
    ]);
};

});
parcelRegister("cSEXi", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $071d2ef9b60c04f2$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $071d2ef9b60c04f2$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $071d2ef9b60c04f2$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $071d2ef9b60c04f2$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $071d2ef9b60c04f2$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $071d2ef9b60c04f2$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $071d2ef9b60c04f2$export$23d48b936935fa57);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $071d2ef9b60c04f2$export$66553a9be1be2f7e);

var $0NycV = parcelRequire("0NycV");

var $4Xcha = parcelRequire("4Xcha");

var $anFLA = parcelRequire("anFLA");

var $hc60A = parcelRequire("hc60A");

var $eTy9x = parcelRequire("eTy9x");

var $fkvsU = parcelRequire("fkvsU");




var $hU5kA = parcelRequire("hU5kA");

var $cUHte = parcelRequire("cUHte");


var $cd8TS = parcelRequire("cd8TS");
const $071d2ef9b60c04f2$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $071d2ef9b60c04f2$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $071d2ef9b60c04f2$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $071d2ef9b60c04f2$export$18cffbebfac64f6d = 'issue-editor-end';
const $071d2ef9b60c04f2$export$ebb284f63692b8b2 = 'issue-editor-start';
const $071d2ef9b60c04f2$export$3ef7e400a3598524 = 'issue.error';
const $071d2ef9b60c04f2$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $071d2ef9b60c04f2$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $071d2ef9b60c04f2$export$66553a9be1be2f7e = 'issue.error.agg';

});
parcelRegister("0NycV", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $033d5acebc8ea430$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $033d5acebc8ea430$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $033d5acebc8ea430$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $033d5acebc8ea430$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $033d5acebc8ea430$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $033d5acebc8ea430$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $033d5acebc8ea430$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $033d5acebc8ea430$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $033d5acebc8ea430$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $033d5acebc8ea430$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $033d5acebc8ea430$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $033d5acebc8ea430$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $033d5acebc8ea430$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $033d5acebc8ea430$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $033d5acebc8ea430$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $033d5acebc8ea430$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $033d5acebc8ea430$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $033d5acebc8ea430$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $033d5acebc8ea430$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $033d5acebc8ea430$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $033d5acebc8ea430$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $033d5acebc8ea430$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $033d5acebc8ea430$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $033d5acebc8ea430$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $033d5acebc8ea430$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $033d5acebc8ea430$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $033d5acebc8ea430$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $033d5acebc8ea430$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $033d5acebc8ea430$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $033d5acebc8ea430$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $033d5acebc8ea430$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $033d5acebc8ea430$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $033d5acebc8ea430$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $033d5acebc8ea430$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $033d5acebc8ea430$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $033d5acebc8ea430$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $033d5acebc8ea430$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $033d5acebc8ea430$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $033d5acebc8ea430$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $033d5acebc8ea430$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $033d5acebc8ea430$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $033d5acebc8ea430$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $033d5acebc8ea430$export$c0657c5ed1bbfed4);
const $033d5acebc8ea430$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $033d5acebc8ea430$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $033d5acebc8ea430$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $033d5acebc8ea430$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $033d5acebc8ea430$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $033d5acebc8ea430$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $033d5acebc8ea430$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $033d5acebc8ea430$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $033d5acebc8ea430$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $033d5acebc8ea430$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $033d5acebc8ea430$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $033d5acebc8ea430$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $033d5acebc8ea430$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $033d5acebc8ea430$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $033d5acebc8ea430$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $033d5acebc8ea430$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $033d5acebc8ea430$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $033d5acebc8ea430$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $033d5acebc8ea430$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $033d5acebc8ea430$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $033d5acebc8ea430$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $033d5acebc8ea430$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $033d5acebc8ea430$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $033d5acebc8ea430$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $033d5acebc8ea430$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $033d5acebc8ea430$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $033d5acebc8ea430$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $033d5acebc8ea430$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $033d5acebc8ea430$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $033d5acebc8ea430$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $033d5acebc8ea430$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $033d5acebc8ea430$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $033d5acebc8ea430$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $033d5acebc8ea430$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $033d5acebc8ea430$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $033d5acebc8ea430$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $033d5acebc8ea430$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $033d5acebc8ea430$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $033d5acebc8ea430$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $033d5acebc8ea430$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $033d5acebc8ea430$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $033d5acebc8ea430$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $033d5acebc8ea430$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $033d5acebc8ea430$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $033d5acebc8ea430$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $033d5acebc8ea430$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $033d5acebc8ea430$export$c0657c5ed1bbfed4 = [
    $033d5acebc8ea430$export$a2a71fb6b193e549,
    $033d5acebc8ea430$export$3573d8ff428b4c8f
];

});

parcelRegister("4Xcha", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $c7ce8bed5d2ff289$export$89b6937a83edcaa6);
$parcel$export(module.exports, "EXCEEDED_LIMIT_INITIAL_LOAD", () => $c7ce8bed5d2ff289$export$763881dbba851043);
$parcel$export(module.exports, "EXCEEDED_LIMIT_AFTER_LOAD", () => $c7ce8bed5d2ff289$export$8a23145a6d5f95e3);
$parcel$export(module.exports, "WITHIN_LIMIT", () => $c7ce8bed5d2ff289$export$a7af19981a3e4baf);
$parcel$export(module.exports, "HREF", () => $c7ce8bed5d2ff289$export$74921a9774a80542);
$parcel$export(module.exports, "IN_PRODUCT_HELP", () => $c7ce8bed5d2ff289$export$cd480f5ec4739dab);
$parcel$export(module.exports, "WHAT_ARE_ISSUE_TYPES_URL", () => $c7ce8bed5d2ff289$export$470a531b30a8dea1);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_IDS", () => $c7ce8bed5d2ff289$export$3691506c72823b65);
$parcel$export(module.exports, "DISMISSED", () => $c7ce8bed5d2ff289$export$6a4add537aaf5560);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE", () => $c7ce8bed5d2ff289$export$6d6e3176028f2228);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE", () => $c7ce8bed5d2ff289$export$17d19a319fd47c32);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID", () => $c7ce8bed5d2ff289$export$9e448086914e060);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID", () => $c7ce8bed5d2ff289$export$2dd6afd9432dbc93);

var $7ZZxN = parcelRequire("7ZZxN");
const $c7ce8bed5d2ff289$var$CHILD_ISSUES_LIMIT = 500;
const $c7ce8bed5d2ff289$export$89b6937a83edcaa6 = ()=>$c7ce8bed5d2ff289$var$CHILD_ISSUES_LIMIT;
const $c7ce8bed5d2ff289$export$763881dbba851043 = 'EXCEEDED_LIMIT_INITIAL_LOAD';
const $c7ce8bed5d2ff289$export$8a23145a6d5f95e3 = 'EXCEEDED_LIMIT_AFTER_LOAD';
const $c7ce8bed5d2ff289$export$a7af19981a3e4baf = 'WITHIN_LIMIT';
const $c7ce8bed5d2ff289$export$74921a9774a80542 = 'HREF';
const $c7ce8bed5d2ff289$export$cd480f5ec4739dab = 'IN_PRODUCT_HELP';
const $c7ce8bed5d2ff289$export$470a531b30a8dea1 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/';
const $c7ce8bed5d2ff289$export$3691506c72823b65 = {
    [(0, $7ZZxN.CORE_PROJECT)]: '2uhc4ieBPinkLJlWbdhXkC',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'z6BNb3cPucF3fi5UA85Ma',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: '6feRxZzkYUHez8TwHTjSut',
    [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: null,
    [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: null
};
const $c7ce8bed5d2ff289$export$6a4add537aaf5560 = 'dismissed';
const $c7ce8bed5d2ff289$export$6d6e3176028f2228 = 'The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.';
const $c7ce8bed5d2ff289$export$17d19a319fd47c32 = "The default assignee doesn\u2019t have the Assignable User permission, or unassigned issues are turned off.";
const $c7ce8bed5d2ff289$export$9e448086914e060 = 'issue-view-child-issues-panel-inline-create';
const $c7ce8bed5d2ff289$export$2dd6afd9432dbc93 = 'issue-view-child-issues-panel-ai-breakdown-create';

});

parcelRegister("anFLA", function(module, exports) {

$parcel$export(module.exports, "EVENTS_TO_LISTEN", () => $d020b8e21ff30f0f$export$d117134317cf0005);
$parcel$export(module.exports, "REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE", () => $d020b8e21ff30f0f$export$d23f2e4951d99e4e);

const $d020b8e21ff30f0f$export$d117134317cf0005 = [
    (0, $1d129cd1c8b202ad$export$b22142e61b3fdbee),
    (0, $1d129cd1c8b202ad$export$773466d9acc404c0)
];
const $d020b8e21ff30f0f$export$d23f2e4951d99e4e = 100;

});
const $1d129cd1c8b202ad$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $1d129cd1c8b202ad$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $1d129cd1c8b202ad$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $1d129cd1c8b202ad$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $1d129cd1c8b202ad$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $1d129cd1c8b202ad$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $1d129cd1c8b202ad$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $1d129cd1c8b202ad$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';


parcelRegister("hc60A", function(module, exports) {

$parcel$export(module.exports, "ALL_ACTIVITY", () => $c4e4580e4e5263cc$export$97c6fb50aec7ca13);
$parcel$export(module.exports, "APPROVALS", () => $c4e4580e4e5263cc$export$d9f961719f63a946);
$parcel$export(module.exports, "COMMENTS", () => $c4e4580e4e5263cc$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "HISTORY", () => $c4e4580e4e5263cc$export$149eb684a26496a2);
$parcel$export(module.exports, "WORKLOG", () => $c4e4580e4e5263cc$export$df36fc05622c402);
$parcel$export(module.exports, "FORGE", () => $c4e4580e4e5263cc$export$567a44a77f893138);
$parcel$export(module.exports, "CONNECT", () => $c4e4580e4e5263cc$export$df50b52b1548c0dc);

var $fkvsU = parcelRequire("fkvsU");
const $c4e4580e4e5263cc$export$97c6fb50aec7ca13 = 'AllActivity';
const $c4e4580e4e5263cc$export$d9f961719f63a946 = 'Approvals';
const $c4e4580e4e5263cc$export$4cab9dfa8fc858f4 = 'Comments';
const $c4e4580e4e5263cc$export$149eb684a26496a2 = 'History';
const $c4e4580e4e5263cc$export$df36fc05622c402 = 'Worklog';
const $c4e4580e4e5263cc$export$567a44a77f893138 = (0, $fkvsU.FORGE_ENTITY_TYPE);
const $c4e4580e4e5263cc$export$df50b52b1548c0dc = (0, $fkvsU.CONNECT_ENTITY_TYPE);

});
parcelRegister("fkvsU", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $f4e7965032899654$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $f4e7965032899654$export$1b2059a011c9174d);
const $f4e7965032899654$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $f4e7965032899654$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $f4e7965032899654$export$38f0fc1cf1f24cba = [
    $f4e7965032899654$export$6f3804b3f188f650,
    $f4e7965032899654$export$1b2059a011c9174d
];

});


parcelRegister("eTy9x", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$724fbfb10c203824);
$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS", () => $0bfbe56dc89f06eb$export$a1162d3036fadf0e);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD_OLD", () => $0bfbe56dc89f06eb$export$9b2f842ae6d3541d);
$parcel$export(module.exports, "LOAD_NEWER_BUTTON", () => $0bfbe56dc89f06eb$export$4f2e52b6b9be5088);
$parcel$export(module.exports, "LOAD_OLDER_BUTTON", () => $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $0bfbe56dc89f06eb$export$724fbfb10c203824 = 5;
const $0bfbe56dc89f06eb$export$a1162d3036fadf0e = 100;
const $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7 = 100;
const $0bfbe56dc89f06eb$export$9b2f842ae6d3541d = 10;
const $0bfbe56dc89f06eb$export$ef42ae71539e03a7 = `${3 * (0, $c9TLT.gridSize)}px`;
const $0bfbe56dc89f06eb$export$4f2e52b6b9be5088 = 'LOAD_NEWER_BUTTON';
const $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0 = 'LOAD_OLDER_BUTTON';

});

const $b7817a5fa36c8dd6$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $b7817a5fa36c8dd6$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $b7817a5fa36c8dd6$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $b7817a5fa36c8dd6$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';

const $9e13bb906b1e3579$export$87b07f66f76af007 = 1000;
const $9e13bb906b1e3579$export$7cf28317477c9e48 = 'w';

const $b0dbf452addbddfb$export$cb17e3c17bc50301 = 'Epic';
const $b0dbf452addbddfb$export$d29cf9c8492f955d = 'Base';
const $b0dbf452addbddfb$export$7fbc739f2667a35e = 'Subtask';

parcelRegister("hU5kA", function(module, exports) {

$parcel$export(module.exports, "noPermissions", () => $da02f2b558500d9a$export$3fd167bac6ff056b);
const $da02f2b558500d9a$export$c7b3dd87fc15b364 = {
    canDeleteAllWorklogs: false,
    canDeleteOwnWorklogs: false,
    canEditAllWorklogs: false,
    canEditOwnWorklogs: false,
    canLogWork: false
};
const $da02f2b558500d9a$export$3fd167bac6ff056b = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canEditAllComments: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canLinkIssues: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canViewWatchers: false,
    canBrowseUsers: false,
    ...$da02f2b558500d9a$export$c7b3dd87fc15b364,
    canUseServiceDeskAgentFeatures: false,
    canViewDevTools: false,
    canExportIssue: false
};

});

parcelRegister("cUHte", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $e54dd57964efa8b8$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $e54dd57964efa8b8$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $e54dd57964efa8b8$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $e54dd57964efa8b8$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $e54dd57964efa8b8$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $e54dd57964efa8b8$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $e54dd57964efa8b8$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $e54dd57964efa8b8$export$2ee73dd298bdfe8a);
const $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $e54dd57964efa8b8$export$b97d963a8496fa2f = {
    key: $e54dd57964efa8b8$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$179836a99669cbe7 = {
    key: $e54dd57964efa8b8$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$8d0984a0f9f31117 = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$c1324bd586e9a53a = {
    key: $e54dd57964efa8b8$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$72fcc6cb1cdc70e0 = {
    key: $e54dd57964efa8b8$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$4052b1eae3373c3b = {
    key: $e54dd57964efa8b8$var$FETCH_USER_AUTH_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$b4e2588a18d8d980 = {
    key: $e54dd57964efa8b8$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $e54dd57964efa8b8$export$2ee73dd298bdfe8a = {
    key: $e54dd57964efa8b8$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $e54dd57964efa8b8$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

const $ab2aafcdf11a1361$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $ab2aafcdf11a1361$export$e1184c3be46bd7cb = false;
const $ab2aafcdf11a1361$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $ab2aafcdf11a1361$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("cd8TS", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $626ce0fd98ef0025$export$4ec1f3604b85d553);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $626ce0fd98ef0025$export$e65b95e776ce6f27);
const $626ce0fd98ef0025$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $626ce0fd98ef0025$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $626ce0fd98ef0025$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $626ce0fd98ef0025$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $626ce0fd98ef0025$export$e65b95e776ce6f27 = [
    $626ce0fd98ef0025$export$dd2d62bc7ec6ce51,
    $626ce0fd98ef0025$export$db1ab2b83dc17aa9,
    $626ce0fd98ef0025$export$940ce115dba33e55,
    $626ce0fd98ef0025$export$4ec1f3604b85d553
];

});




parcelRegister("atvEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb6308118097de4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $0cb6308118097de4$var$ComponentsCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("1d0Ix")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/components-cell/main.tsx"
});
const $0cb6308118097de4$var$AsyncComponentsCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "components-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cb6308118097de4$var$ComponentsCell, props));
var $0cb6308118097de4$export$2e2bcd8739ae039 = $0cb6308118097de4$var$AsyncComponentsCell;

});
parcelRegister("1d0Ix", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('96faG');
        const value = parcelRequire('1b5M9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("96faG").then(()=>parcelRequire('1b5M9'));
}

});


parcelRegister("dNtbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f848dece554a7178$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $f848dece554a7178$var$DateCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cZIjn")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/date-cell/main.tsx"
});
const $f848dece554a7178$var$AsyncDateCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "date-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f848dece554a7178$var$DateCell, props));
var $f848dece554a7178$export$2e2bcd8739ae039 = $f848dece554a7178$var$AsyncDateCell;

});
parcelRegister("cZIjn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('al3ht');
        const value = parcelRequire('5RWox');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("al3ht").then(()=>parcelRequire('5RWox'));
}

});


parcelRegister("5c3sP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc9ce689ed0af1ba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $fc9ce689ed0af1ba$var$DateTimeCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("deOKs")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/date-time-cell/main.tsx"
});
const $fc9ce689ed0af1ba$var$AsyncDateTimeCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "date-time-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc9ce689ed0af1ba$var$DateTimeCell, props));
var $fc9ce689ed0af1ba$export$2e2bcd8739ae039 = $fc9ce689ed0af1ba$var$AsyncDateTimeCell;

});
parcelRegister("deOKs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dlV0Z');
        const value = parcelRequire('bZ8ql');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dlV0Z").then(()=>parcelRequire('bZ8ql'));
}

});


parcelRegister("g3fEZ", function(module, exports) {

$parcel$export(module.exports, "KeyCell", () => $6556735293a55bfb$export$4d17c2f4d9bbf823);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $aWvIp = parcelRequire("aWvIp");

var $hUwRB = parcelRequire("hUwRB");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $hYeSy = parcelRequire("hYeSy");

var $eP9Rz = parcelRequire("eP9Rz");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $9uU8f = parcelRequire("9uU8f");

var $8UbeN = parcelRequire("8UbeN");

var $egJIx = parcelRequire("egJIx");

var $aqGaJ = parcelRequire("aqGaJ");

var $dLenM = parcelRequire("dLenM");
const $6556735293a55bfb$export$4d17c2f4d9bbf823 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueId: issueId, issueKey: issueKey, parentIssues: parentIssues, onOpenIssueModal: onOpenIssueModal, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, isHovering: isHoveringNew = false, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isCopied, setIsCopied] = (0, $eUqFw.useState)(false);
    const [isHoveringOld, setIsHovering] = (0, $eUqFw.useState)(false);
    const isHovering = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? isHoveringNew : isHoveringOld;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $egJIx.useJWMListFeatures)();
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    let prefetchIssue = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    if ((0, $1ybV0.ff)('jwm.preload-issue-view-critical-data')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ prefetchIssue: prefetchIssue } = (0, $hYeSy.usePrefetchIssueViewDataActions)());
    const handleIssueKeyMouseEnter = (0, $eUqFw.useCallback)(()=>{
        prefetchIssue(issueKey);
    }, [
        issueKey,
        prefetchIssue
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Use handleMouseLeave in CellNavigation for generic behaviour or useImperativeHandle
   *  to provide custom override behaviour for this cell
   */ const handleMouseEnter = (0, $eUqFw.useCallback)(()=>setIsHovering(true), [
        setIsHovering
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Use handleMouseEnter in CellNavigation for generic behaviour or useImperativeHandle
   *  to provide custom override behaviour for this cell
   */ const handleMouseLeave = (0, $eUqFw.useCallback)(()=>setIsHovering(false), [
        setIsHovering
    ]);
    const handleCopyClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell copyIssueLink', {});
    }, [
        createAnalyticsEvent
    ]);
    const handleCopyReset = (0, $eUqFw.useCallback)(()=>setIsCopied(false), [
        setIsCopied
    ]);
    const handleClickChange = (0, $eUqFw.useCallback)((status)=>setIsCopied(status), []);
    const onEmbedIssueClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'issue clicked', 'listEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
        event.preventDefault();
        event.stopPropagation();
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Use handleKeyDown in CellNavigation for generic behaviour or handleKeyDownNew in this
   * cell for custom behaviour
   */ const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') return;
        onKeyDown?.(e);
    }, [
        onKeyDown
    ]);
    const onIssueKeyClick = (0, $eUqFw.useCallback)(({ id: id, key: key })=>(event)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'keyCell linkClicked');
            onOpenIssueModal({
                id: id,
                key: key
            })(event);
        }, [
        createAnalyticsEvent,
        onOpenIssueModal
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated wrapperRef is now managed in CellNavigation
   */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') issueViewInteraction === 'openNewTab' ? onEmbedIssueClick(e) : onIssueKeyClick({
            id: issueId,
            key: issueKey
        })(e);
        return false;
    }, [
        issueId,
        issueKey,
        issueViewInteraction,
        onEmbedIssueClick,
        onIssueKeyClick
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, ()=>({
            onClick: ()=>true,
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    let keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKey, {
        href: `/browse/${issueKey}`,
        onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
            id: issueId,
            key: issueKey
        }),
        onMouseEnter: (0, $1ybV0.ff)('jwm.preload-issue-view-critical-data') ? handleIssueKeyMouseEnter : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        "data-testid": "business-list.ui.list-view.key-cell.issue-key"
    }, issueKey);
    if (showFlatList && parentIssues != null) keyContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKeyContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$ParentIssueKeysWrapper, null, parentIssues.map(({ id: id, key: key }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: id
        }, index > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$ParentIssueKeysDivider, null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKey, {
            href: `/browse/${key}`,
            onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
                id: id,
                key: key
            }),
            "data-testid": "business-list.ui.list-view.key-cell.parent-issue-key"
        }, key)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKeyHierarchyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9uU8f.default), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKey, {
        href: `/browse/${issueKey}`,
        onClick: issueViewInteraction === 'openNewTab' ? onEmbedIssueClick : onIssueKeyClick({
            id: issueId,
            key: issueKey
        }),
        "data-testid": "business-list.ui.list-view.key-cell.issue-key"
    }, issueKey)));
    const keyCellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, keyContent, isHovering && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$CopyIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eP9Rz.default), {
        id: `copy-${issueKey}`,
        label: formatMessage((0, $dLenM.default).copy),
        tooltipDelay: 0,
        tooltipLabel: formatMessage((0, $dLenM.default).copy),
        tooltipLabelPosition: "top",
        shouldFitContainer: true,
        value: `${window.location.origin}/browse/${issueKey}`,
        hideFieldText: true,
        remountOnChange: true,
        onCopyClick: handleCopyClick,
        onClickChange: handleClickChange,
        onCopyReset: handleCopyReset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        iconBefore: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            label: "",
            primaryColor: `var(--ds-background-success-bold, ${(0, $PdmhA).G500})`,
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            size: "small",
            label: formatMessage((0, $dLenM.default).copy)
        }),
        spacing: "none"
    }))));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6556735293a55bfb$var$issueKeyCellStyles
    }, keyCellContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6556735293a55bfb$var$IssueKeyCell, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef,
        isFocused: isSelected
    }, keyCellContent);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$CopyIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy41r8u _t9ec12hf _u5f31b66 _4t3ipxbi _v5641hdd _kqswstnw _1xi2idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKeyCell = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _u5f3u2gc _k48pbfng _syazagj8 _80omtlke _kqswh2mm _2rkoglpi _vchhusvi _sqoridpf _xm5vfdjv _1nw4t94y _qnlu1xty",
            __cmplp.className
        ])
    });
});
const $6556735293a55bfb$var$issueKeyCellStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    outline: 'none',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    fontWeight: 500,
    cursor: 'pointer',
    color: 'color.text',
    position: 'relative',
    '--copy-icon-opacity': 0,
    '--copy-icon-transform': `translate(${"var(--ds-space-negative-100, -8px)"}, 0)`,
    ':hover': {
        // @ts-expect-error - TS2353 - Object literal may only specify known properties, and ''--copy-icon-opacity'' does not exist in type 'SafeCSSObject'
        '--copy-icon-opacity': 1,
        '--copy-icon-transform': 'translate(0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $kJlBc.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazagj8 _1reo15vq _18m915vq _1bto1l2s _u5f3u2gc _30l3agj8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKeyContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$IssueKeyHierarchyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$ParentIssueKeysWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _11c81vlj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6556735293a55bfb$var$ParentIssueKeysDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41nxw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = $d0a128a0d80d703a$var$LinkIcon;
module.exports.default = $d0a128a0d80d703a$var$_default;

});

parcelRegister("j8Htg", function(module, exports) {

$parcel$export(module.exports, "openViewFromEmbed", () => $3314031ff4af418d$export$a29603f2eb9b6da6);
const $3314031ff4af418d$export$a29603f2eb9b6da6 = (param)=>{
    const cleanUrl = window.location.href.replace('/embed', '');
    const currentUrl = new URL(cleanUrl);
    if (param != null) currentUrl.searchParams.append(param.key, param.value);
    window.open(currentUrl.href, '_blank');
};

});

parcelRegister("eP9Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $447f96b73f1cfa1f$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-classname-attribute */ 
var $eUqFw = parcelRequire("eUqFw");

var $dFlYh = parcelRequire("dFlYh");
class $447f96b73f1cfa1f$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dFlYh.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            copied: false,
            copyFailed: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        };
        this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("dFlYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28c74331b850b05$export$2e2bcd8739ae039);

var $SA3Qe = parcelRequire("SA3Qe");

var $f28c74331b850b05$export$2e2bcd8739ae039 = (0, $SA3Qe.default);

});
parcelRegister("SA3Qe", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $a70a2edd0ca4f430$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $dmCPj = parcelRequire("dmCPj");

var $cf2Y4 = parcelRequire("cf2Y4");

var $8cU5f = parcelRequire("8cU5f");

var $bujW1 = parcelRequire("bujW1");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");


var $cJa0J = parcelRequire("cJa0J");

var $aV7qy = parcelRequire("aV7qy");
class $a70a2edd0ca4f430$export$71579edc8f362e35 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            id: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $eUqFw.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
                label: tooltipLabel
            })),
            onClick: onCopyClick
        });
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $cJa0J.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $cJa0J.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $eUqFw.cloneElement)((0, $eUqFw.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV7qy.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV7qy.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bujW1.default), {
            htmlFor: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $df17f23b8446e341$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a70a2edd0ca4f430$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: (0, $1ybV0.ff)('sptn-1885-fix-to-update-tooltip-content_pa23s') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel) : actualTooltipLabel
        }, copyButton || this.renderDefaultButton())));
    }
}
var $a70a2edd0ca4f430$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($a70a2edd0ca4f430$export$71579edc8f362e35);
const $a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                default: {
                    height: `${(0, $c9TLT.gridSize) * 5}px`,
                    width: `${(0, $c9TLT.gridSize) * 5}px`
                }
            }
        })
    });
$a70a2edd0ca4f430$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a70a2edd0ca4f430$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a70a2edd0ca4f430$var$FlexGrow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M10 19h8V8h-8v11zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 018 19.008V7.992z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13H5zm2 0h8V5H7v11z"/></g></svg>`
    }, props));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = $9bab72963b78cefe$var$CopyIcon;
module.exports.default = $9bab72963b78cefe$var$_default;

});

parcelRegister("bujW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1634e0d0f9f8a3e7$export$2e2bcd8739ae039);

var $8BJaJ = parcelRequire("8BJaJ");
var $1634e0d0f9f8a3e7$export$2e2bcd8739ae039 = (0, $8BJaJ.FieldLabel);

});
parcelRegister("8BJaJ", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $816236d547316819$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $c9TLT = parcelRequire("c9TLT");
const $816236d547316819$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $816236d547316819$var$LabelText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $4lTFP.h200)()} display:block;font-family:${(0, $c9TLT.fontFamily)};margin:0;${// eslint-disable-next-line jira/compiled/styled-components-usages
(0, $kwce8.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$RequiredIndicator = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $PdmhA).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$816236d547316819$var$RequiredIndicator.displayName = 'RequiredIndicator';

});


parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

var $PdmhA = parcelRequire("PdmhA");
const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $PdmhA).P400,
            '> span': {
                color: (0, $PdmhA).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

const $df17f23b8446e341$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("cJa0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4aec29dc4c903c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a4aec29dc4c903c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("aV7qy", function(module, exports) {

$parcel$export(module.exports, "Root", () => $e50c2b052b0ce017$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $e50c2b052b0ce017$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $e50c2b052b0ce017$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        userSelect: 'none'
    }) : '');
const $e50c2b052b0ce017$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});




parcelRegister("9uU8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6ff46bc289e851$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $7b6ff46bc289e851$var$defaultStrokeColor = "var(--ds-text-accent-blue-bolder, #42526E)";
const $7b6ff46bc289e851$var$HierarchyIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "5.33333",
        cy: "5.33333",
        r: "1.33333",
        stroke: props.stroke || $7b6ff46bc289e851$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "10.6667",
        cy: "10.6666",
        r: "1.33333",
        stroke: props.stroke || $7b6ff46bc289e851$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.33337 6.66669V9.33335C5.33337 10.0697 5.93033 10.6667 6.66671 10.6667H9.33337",
        stroke: props.stroke || $7b6ff46bc289e851$var$defaultStrokeColor,
        strokeWidth: "1.33333",
        fill: "none"
    }));
const $7b6ff46bc289e851$var$HierarchyIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: (customGlyphProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b6ff46bc289e851$var$HierarchyIconSVG, {
                ...customGlyphProps,
                stroke: props.stroke
            }),
        size: props.size,
        label: props.label
    });
var $7b6ff46bc289e851$export$2e2bcd8739ae039 = $7b6ff46bc289e851$var$HierarchyIcon;

});

parcelRegister("dLenM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7801a7a01c28b853$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7801a7a01c28b853$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copy: {
        "id": "business-list.list-view.key-cell.copy",
        "defaultMessage": "Copy link"
    }
});

});


parcelRegister("5kwBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1fa5c7b9dd6cf2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $7c1fa5c7b9dd6cf2$var$LabelsCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("7dk9p")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/labels-cell/main.tsx"
});
const $7c1fa5c7b9dd6cf2$var$AsyncLabelsCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "labels-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c1fa5c7b9dd6cf2$var$LabelsCell, props));
var $7c1fa5c7b9dd6cf2$export$2e2bcd8739ae039 = $7c1fa5c7b9dd6cf2$var$AsyncLabelsCell;

});
parcelRegister("7dk9p", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7Zj7L');
        const value = parcelRequire('jhtFc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7Zj7L").then(()=>parcelRequire('jhtFc'));
}

});


parcelRegister("IIbrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d3bc4404f11fac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $96d3bc4404f11fac$var$MultiSelectCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("77YyM")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/multi-select-cell/main.tsx"
});
const $96d3bc4404f11fac$var$AsyncMultiSelectCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "multi-select-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96d3bc4404f11fac$var$MultiSelectCell, props));
var $96d3bc4404f11fac$export$2e2bcd8739ae039 = $96d3bc4404f11fac$var$AsyncMultiSelectCell;

});
parcelRegister("77YyM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lvnuH');
        const value = parcelRequire('5zFB7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lvnuH").then(()=>parcelRequire('5zFB7'));
}

});


parcelRegister("jmKEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc34430ece2ee33a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $fc34430ece2ee33a$var$MultiUserCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("iuLGu")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/multi-user-cell/main.tsx"
});
const $fc34430ece2ee33a$var$AsyncMultiUserCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "multi-user-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc34430ece2ee33a$var$MultiUserCell, props));
var $fc34430ece2ee33a$export$2e2bcd8739ae039 = $fc34430ece2ee33a$var$AsyncMultiUserCell;

});
parcelRegister("iuLGu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('37w72')
        ]);
        const value = parcelRequire('tWDSG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("37w72")
    ]).then(()=>parcelRequire('tWDSG'));
}

});


parcelRegister("cMZur", function(module, exports) {

$parcel$export(module.exports, "default", () => $38b684e9a0fbcdca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $38b684e9a0fbcdca$var$NumberCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("KPUYP")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/number-cell/main.tsx"
});
const $38b684e9a0fbcdca$var$AsyncNumberCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "number-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($38b684e9a0fbcdca$var$NumberCell, props));
var $38b684e9a0fbcdca$export$2e2bcd8739ae039 = $38b684e9a0fbcdca$var$AsyncNumberCell;

});
parcelRegister("KPUYP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6YBeb');
        const value = parcelRequire('ezxf8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6YBeb").then(()=>parcelRequire('ezxf8'));
}

});


parcelRegister("fk8YW", function(module, exports) {

$parcel$export(module.exports, "default", () => $368a86d5bd919a1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $368a86d5bd919a1f$var$OriginalEstimateCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("2CchD")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/original-estimate-cell/main.tsx"
});
const $368a86d5bd919a1f$var$AsyncOriginalEstimateCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "original-estimate-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($368a86d5bd919a1f$var$OriginalEstimateCell, props));
var $368a86d5bd919a1f$export$2e2bcd8739ae039 = $368a86d5bd919a1f$var$AsyncOriginalEstimateCell;

});
parcelRegister("2CchD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lgMdq');
        const value = parcelRequire('1ZIHR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lgMdq").then(()=>parcelRequire('1ZIHR'));
}

});


parcelRegister("hgKBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a0a98749a640e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $a1a0a98749a640e1$var$PriorityCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("h3LfE")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/priority-cell/main.tsx"
});
const $a1a0a98749a640e1$var$AsyncPriorityCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "priority-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1a0a98749a640e1$var$PriorityCell, props));
var $a1a0a98749a640e1$export$2e2bcd8739ae039 = $a1a0a98749a640e1$var$AsyncPriorityCell;

});
parcelRegister("h3LfE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1vONZ');
        const value = parcelRequire('awLFp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1vONZ").then(()=>parcelRequire('awLFp'));
}

});


parcelRegister("iWW7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $58db136327b66973$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $58db136327b66973$var$RemoteIssueLinksCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("e8FI3")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/remote-issue-links-cell/main.tsx"
});
const $58db136327b66973$var$AsyncRemoteIssueLinksCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "remote-issue-links-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($58db136327b66973$var$RemoteIssueLinksCell, props));
var $58db136327b66973$export$2e2bcd8739ae039 = $58db136327b66973$var$AsyncRemoteIssueLinksCell;

});
parcelRegister("e8FI3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('5FaIp')
        ]);
        const value = parcelRequire('1R0FP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("5FaIp")
    ]).then(()=>parcelRequire('1R0FP'));
}

});


parcelRegister("7v11U", function(module, exports) {

$parcel$export(module.exports, "SelectRowCheckbox", () => $7005321b316efdaf$export$ee74d161095f15ae);
$parcel$export(module.exports, "SelectAllColumnCheckbox", () => $7005321b316efdaf$export$7ea5ed11456af816);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4E9Xv = parcelRequire("4E9Xv");

var $7Sz8O = parcelRequire("7Sz8O");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gbsaq = parcelRequire("gbsaq");

var $hRFuG = parcelRequire("hRFuG");

var $hotly = parcelRequire("hotly");
var $kh0PA = parcelRequire("kh0PA");
var $hMWPo = parcelRequire("hMWPo");

var $4NIME = parcelRequire("4NIME");
const $7005321b316efdaf$export$ee74d161095f15ae = /*#__PURE__*/ (0, $eUqFw.memo)(({ rowData: rowData, rowIndex: rowIndex, onKeyDown: onKeyDown, ...props })=>{
    const { issueId: rowIssueId, id: id } = rowData;
    const issueId = String(rowIssueId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { selectIssues: selectIssues, unselectIssues: unselectIssues }] = (0, $hotly.useBulkSelectionStore)();
    const [isRowSelected] = (0, $hotly.useIsIssueSelected)({
        issueId: issueId,
        parentIssueId: rowData.parentIssueId
    });
    const { onShiftKeyBulkSelection: onShiftKeyBulkSelection } = (0, $hMWPo.useShiftKeySelection)();
    const bulkOpsFlow = (0, $4E9Xv.useBulkOpsSessionContext)();
    const onClickCheckbox = (0, $eUqFw.useCallback)(({ isChecked: isChecked, shiftKeyPressed: shiftKeyPressed })=>{
        const bulkOpsSessionID = bulkOpsFlow?.getFlowAttributes()?.bulkOpsSessionID ?? '';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectIssue', {
            isChecked: isChecked,
            rowIndex: rowIndex,
            shiftKeyPressed: shiftKeyPressed,
            bulkOpsSessionID: bulkOpsSessionID
        });
        if (isChecked) selectIssues({
            issues: [
                issueId
            ],
            rowIndex: rowIndex
        });
        else unselectIssues({
            issues: [
                issueId
            ],
            rowIndex: rowIndex
        });
        if (shiftKeyPressed) onShiftKeyBulkSelection({
            isChecked: isChecked,
            rowIndex: rowIndex
        });
    }, [
        createAnalyticsEvent,
        issueId,
        onShiftKeyBulkSelection,
        rowIndex,
        selectIssues,
        unselectIssues,
        bulkOpsFlow
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') {
            onClickCheckbox({
                isChecked: !isRowSelected,
                shiftKeyPressed: e.shiftKey
            });
            return;
        }
        if (e.shiftKey && e.key === 'Tab' || e.key === 'ArrowLeft') {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent(`${(0, $gbsaq.DRAG_AND_DROP_BUTTON_FOCUS_EVENT)}`, {
                detail: {
                    issueId: issueId
                }
            }));
            return;
        }
        onKeyDown?.(e);
    }, [
        isRowSelected,
        onClickCheckbox,
        onKeyDown,
        issueId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const focusOnCheckbox = (e)=>{
            if (String(e.detail.issueId) !== issueId) return;
            const checkbox = document.getElementById(`${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-${issueId}`);
            checkbox?.focus();
        };
        document.addEventListener(`${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
        return ()=>{
            document.removeEventListener(`${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-focus`, focusOnCheckbox);
        };
    }, [
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7005321b316efdaf$var$SingleSelectChecboxContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRFuG.BulkSelectCheckbox), {
        id: `${(0, $gbsaq.BULK_SELECT_CHECKBOX_ID)}-${issueId}`,
        onClick: onClickCheckbox,
        isChecked: isRowSelected,
        onKeyDown: handleKeyDown,
        isDisabled: id.startsWith((0, $7Sz8O.OPTIMISTIC_ID_PREFIX)),
        label: formatMessage((0, $4NIME.default).selectIssue, {
            issueKey: rowData.key
        }),
        ...props
    }));
});
const $7005321b316efdaf$export$7ea5ed11456af816 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { isIndeterminate: isIndeterminate, onClickCheckbox: onClickCheckbox, isChecked: isChecked } = (0, $kh0PA.useSelectAllCheckbox)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRFuG.BulkSelectCheckbox), {
        onClick: onClickCheckbox,
        isChecked: isChecked || isIndeterminate,
        isIndeterminate: isIndeterminate,
        label: formatMessage((0, $4NIME.default).selectAll)
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7005321b316efdaf$var$SingleSelectChecboxContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u08jkm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kh0PA", function(module, exports) {

$parcel$export(module.exports, "useSelectAllCheckbox", () => $2e892d45a97704be$export$1f1cc91657e74385);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dSE3z = parcelRequire("dSE3z");

var $5r9Wo = parcelRequire("5r9Wo");

var $hotly = parcelRequire("hotly");

var $lEcA7 = parcelRequire("lEcA7");

var $8COV0 = parcelRequire("8COV0");
const $2e892d45a97704be$export$1f1cc91657e74385 = ()=>{
    const [{ hierarchyData: { data: data, isLoadingNextPage: isLoadingNextPage }, childrenItems: childrenItems }] = (0, $5r9Wo.useHierarchyStore)();
    const [{ areAllIssuesSelected: areAllIssuesSelected, selectedIssues: selectedIssues }, { selectAllIssues: selectAllIssues, selectAll: selectAll, clearSelection: clearSelection, unselectAll: unselectAll }] = (0, $hotly.useBulkSelectionStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { fetchingGroups: fetchingGroups, selectCollapsedGroups: selectCollapsedGroups } = (0, $lEcA7.useSelectCollapsedGroups)();
    const [groupByFieldId] = (0, $dSE3z.useGroupBy)();
    const prevGroupByFieldId = (0, $hzcvF.usePreviousWithInitial)(groupByFieldId);
    const isGrouping = groupByFieldId != null;
    (0, $eUqFw.useEffect)(()=>{
        if (prevGroupByFieldId !== groupByFieldId) // if the groupByFieldId is updated, clear the selection
        clearSelection();
    }, [
        clearSelection,
        groupByFieldId,
        prevGroupByFieldId
    ]);
    /*
        UNSELECT - if is all selected and we get new data we should unselect the "select all" checkbox
        to avoid comparing all the data we can just update the select all once we:
        - fetch a new page
        - fetch any children
    */ (0, $eUqFw.useEffect)(()=>{
        if (isLoadingNextPage && areAllIssuesSelected) unselectAll();
    }, [
        areAllIssuesSelected,
        isLoadingNextPage,
        unselectAll
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (areAllIssuesSelected) {
            if (!isGrouping) unselectAll();
            else if (isGrouping && !fetchingGroups) unselectAll();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(childrenItems),
        data.length
    ]);
    /*
        SELECT ALL - if all the issues are selected we should check the 'select all checkbox'
        to avoid comparing all the data we can just check if it's all selected when an issue is selected
    */ (0, $eUqFw.useEffect)(()=>{
        if (!areAllIssuesSelected && selectedIssues.size) {
            // if is no grouping and there are more data selected we should check if all are selected.
            if (!isGrouping && selectedIssues.size >= data.length) {
                const allIssues = (0, $8COV0.getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (allIssues.length === selectedIssues.size) selectAll();
            } else if (isGrouping) {
                // if some of the groups were not fetched and have issues, then not select all
                for(let i = 0; i < data.length; i += 1){
                    const group = data[i];
                    const hasChildren = group.childSummary?.hasChildren;
                    if (hasChildren && childrenItems[group.issueId] === undefined) return;
                }
                const allIssues = (0, $8COV0.getAllIssuesIds)({
                    data: data,
                    childrenItems: childrenItems
                });
                if (allIssues.length === selectedIssues.size) selectAll();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedIssues
    ]);
    const onClickCheckbox = (0, $eUqFw.useCallback)(({ isChecked: isChecked })=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'selectAll', {
            isChecked: isChecked
        });
        if (isChecked) {
            const allIssues = (0, $8COV0.getAllIssuesIds)({
                data: data,
                childrenItems: childrenItems
            });
            // if it's an empty project we don't want to anything
            if (!allIssues.length && !isGrouping) return;
            selectAllIssues({
                issues: allIssues
            });
            if (isGrouping) selectCollapsedGroups(data);
        } else clearSelection();
    }, [
        childrenItems,
        clearSelection,
        createAnalyticsEvent,
        data,
        isGrouping,
        selectAllIssues,
        selectCollapsedGroups
    ]);
    return {
        isChecked: areAllIssuesSelected,
        isIndeterminate: !areAllIssuesSelected && selectedIssues.size > 0,
        onClickCheckbox: onClickCheckbox
    };
};

});

parcelRegister("4NIME", function(module, exports) {

$parcel$export(module.exports, "default", () => $1151350a786d7974$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1151350a786d7974$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectAll: {
        "id": "business-list.list-view.select-row-cell.select-all",
        "defaultMessage": "Select all issues"
    },
    selectIssue: {
        "id": "business-list.list-view.select-row-cell.select-issue",
        "defaultMessage": "Select {issueKey}"
    }
});

});


parcelRegister("67zRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20c2247af285c1e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $e20c2247af285c1e$var$SingleSelectCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("d0i5L")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/single-select-cell/main.tsx"
});
const $e20c2247af285c1e$var$AsyncSingleSelectCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "single-select-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e20c2247af285c1e$var$SingleSelectCell, props));
var $e20c2247af285c1e$export$2e2bcd8739ae039 = $e20c2247af285c1e$var$AsyncSingleSelectCell;

});
parcelRegister("d0i5L", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gOZCU');
        const value = parcelRequire('6bEOm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gOZCU").then(()=>parcelRequire('6bEOm'));
}

});


parcelRegister("a0Bmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $23762982b16d0ce0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $23762982b16d0ce0$var$SprintCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("lqx7L")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/sprint-cell/main.tsx"
});
const $23762982b16d0ce0$var$AsyncSprintCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "sprint-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($23762982b16d0ce0$var$SprintCell, props));
var $23762982b16d0ce0$export$2e2bcd8739ae039 = $23762982b16d0ce0$var$AsyncSprintCell;

});
parcelRegister("lqx7L", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hpmEe')
        ]);
        const value = parcelRequire('5UIzZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hpmEe")
    ]).then(()=>parcelRequire('5UIzZ'));
}

});


parcelRegister("7lf5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6181285132726d07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $6181285132726d07$var$StatusCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4ZkPR")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/status-cell/main.tsx"
});
const $6181285132726d07$var$AsyncStatusCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "status-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6181285132726d07$var$StatusCell, props));
var $6181285132726d07$export$2e2bcd8739ae039 = $6181285132726d07$var$AsyncStatusCell;

});
parcelRegister("4ZkPR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('e5Kmd');
        const value = parcelRequire('4iyZd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("e5Kmd").then(()=>parcelRequire('4iyZd'));
}

});


parcelRegister("kmNgr", function(module, exports) {

$parcel$export(module.exports, "TextAreaCell", () => $261e7f2f10d2c9ae$export$1e25c2913c11e42f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $j8Htg = parcelRequire("j8Htg");

var $jGcn0 = parcelRequire("jGcn0");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7Vbpp = parcelRequire("7Vbpp");

var $8UbeN = parcelRequire("8UbeN");

var $kGYHy = parcelRequire("kGYHy");

var $egJIx = parcelRequire("egJIx");
const $261e7f2f10d2c9ae$export$1e25c2913c11e42f = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldKey: fieldKey, fieldType: fieldType, fieldValue: fieldValue, onClick: onClick, issueKey: issueKey, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, cellRef: cellRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { issueViewInteraction: issueViewInteraction } = (0, $egJIx.useJWMListFeatures)();
    const [textValue, setTextValue] = (0, $eUqFw.useState)('');
    const onEmbedClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'textAreaCell clicked', 'listEmbedIssue');
        (0, $j8Htg.openViewFromEmbed)({
            key: (0, $jGcn0.SELECTED_ISSUE_PARAM),
            value: issueKey
        });
    }, [
        createAnalyticsEvent,
        issueKey
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated wrapperRef is now managed in CellNavigation
   */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    const [{ value: extractedFieldValue }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const cellValue = (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour') ? extractedFieldValue : fieldValue;
    // keeping value up-to-date with bento value
    // text area value is type string
    (0, $eUqFw.useEffect)(()=>{
        // TODO: JEH-62
        (0, $kGYHy.getADFMarkup)((0, $7Vbpp.convertAdfStringToObject)(cellValue)).then((value)=>setTextValue(value));
    }, [
        cellValue
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        issueViewInteraction === 'openNewTab' ? onEmbedClick() : onClick(event);
    }, [
        issueViewInteraction,
        onClick,
        onEmbedClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Enter') {
            handleClick(event);
            return true;
        }
        return false;
    }, [
        handleClick
    ]);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onClick: ()=>true,
            onKeyDown: handleKeyDown
        }), [
        handleKeyDown
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $261e7f2f10d2c9ae$var$wrapperStyles,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $261e7f2f10d2c9ae$var$textStyles,
        as: "span"
    }, textValue));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($261e7f2f10d2c9ae$export$e6dfd72ab29f8598, {
        isFocused: isSelected,
        onClick: handleClick,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        ref: onWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, textValue));
});
const $261e7f2f10d2c9ae$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _9n9ou2gc _17kn15vq _1hrp15vq _x3fa1l2s",
            __cmplp.className
        ])
    });
});
$261e7f2f10d2c9ae$export$e6dfd72ab29f8598.displayName = 'Wrapper';
const $261e7f2f10d2c9ae$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer'
});
const $261e7f2f10d2c9ae$var$textStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});
parcelRegister("7Vbpp", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $e11eab7652408d68$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $e11eab7652408d68$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $e11eab7652408d68$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e11eab7652408d68$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $e11eab7652408d68$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $e11eab7652408d68$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $e11eab7652408d68$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $e11eab7652408d68$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $e11eab7652408d68$export$80a6e90c7b29d88c);

var $6qhKX = parcelRequire("6qhKX");
var $hYZXM = parcelRequire("hYZXM");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
const $e11eab7652408d68$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $e11eab7652408d68$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $1ybV0.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($e11eab7652408d68$export$9e9311e676291037)
    };
    return adf;
};
const $e11eab7652408d68$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $e11eab7652408d68$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $e11eab7652408d68$export$9e9311e676291037(adf);
};
const $e11eab7652408d68$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $e11eab7652408d68$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $e11eab7652408d68$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $e11eab7652408d68$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $e11eab7652408d68$export$def86d25f0c7f0bc = (adf)=>$e11eab7652408d68$export$cf4bde415465976c(adf) ? $e11eab7652408d68$export$202742e99f678c60 : adf;
const $e11eab7652408d68$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $hYZXM.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $e11eab7652408d68$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $hYZXM.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $hYZXM.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $e11eab7652408d68$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $6qhKX.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $e11eab7652408d68$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("kM8T5"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("fDLsg"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("dIRBZ"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("6qhKX", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d1e7bd2dc2348b7c$export$3dea766d36a8935f);

var $hYZXM = parcelRequire("hYZXM");
function $d1e7bd2dc2348b7c$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("kM8T5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('deyW2');
        const value = parcelRequire('9wcjJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("deyW2").then(()=>parcelRequire('9wcjJ'));
}

});

parcelRegister("fDLsg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('apXnN');
        const value = parcelRequire('fjUC0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("apXnN").then(()=>parcelRequire('fjUC0'));
}

});

parcelRegister("dIRBZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kYJkV');
        const value = parcelRequire('3M3qX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kYJkV").then(()=>parcelRequire('3M3qX'));
}

});


parcelRegister("kGYHy", function(module, exports) {

$parcel$export(module.exports, "getADFMarkup", () => $3691a2eb87a4e6e8$export$3d7eec7fcefdad14);



const $3691a2eb87a4e6e8$export$3d7eec7fcefdad14 = async (node)=>{
    if (node === null || node === undefined || typeof node === 'string') return '';
    const schemaPromise = (parcelRequire("kM8T5"));
    const wikiPromise = (parcelRequire("fDLsg"));
    const jsonPromise = (parcelRequire("dIRBZ"));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = adfTransformer.parse(node);
    return wikiTransformer.encode(pmNode);
};

});


parcelRegister("9dQoH", function(module, exports) {

$parcel$export(module.exports, "TextCell", () => $e7c0028ace51beba$export$765aced31cc89655);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $7eqzD = parcelRequire("7eqzD");

var $4TezD = parcelRequire("4TezD");

var $jwy0y = parcelRequire("jwy0y");

var $96etS = parcelRequire("96etS");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $7PAQj = parcelRequire("7PAQj");


var $g43uO = parcelRequire("g43uO");

var $105cx = parcelRequire("105cx");

var $8UbeN = parcelRequire("8UbeN");

var $kV5dc = parcelRequire("kV5dc");
const $e7c0028ace51beba$export$fc152bafe73dcaee = (props)=>{
    const { editMode: editMode, highlight: highlight, onSubmit: onSubmit, onBlur: onBlur, onChange: onChange, onKeyDown: onKeyDown, value: value, testId: testId } = props;
    if (editMode) return(// @ts-expect-error - TS2322 - Type 'FormEventHandler<HTMLInputElement> | undefined' is not assignable to type 'FormEventHandler<HTMLFormElement> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        onSubmit: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        testId: testId ? `${testId}-field` : undefined,
        autoFocus: true,
        onBlur: onBlur,
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown
    })));
    if (highlight && highlight.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PAQj.default), {
        highlight: highlight,
        text: value
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, value);
};
const $e7c0028ace51beba$export$765aced31cc89655 = ({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, testId: testId, isNudgeCell: isNudgeCell = false, isSelected: isSelected, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, issueId: issueId, editMode: editModeNew = false, setEditMode: setEditModeNew = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), cellRef: cellRef, issueType: issueType = '', issueTypeId: issueTypeId = '', fieldName: fieldName = '', inputValue: inputValue, onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const searchHighlight = (0, $96etS.useSimpleSearchHighlight)();
    const [textValueOld, setTextValueOld] = (0, $eUqFw.useState)(fieldValue || '');
    const textValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? (inputValue ?? fieldValue) || '' : textValueOld;
    const setTextValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
    const [editMode, setEditMode] = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? [
        editModeNew,
        setEditModeNew
    ] : (0, $eUqFw.useState)(false);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueId: issueId,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue,
        onFailure: ()=>{
            setTextValue(value || '');
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { ref: inlineEditNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $99a775c02d636a41$export$a1398a6ef9526001), isNudgeCell);
    (0, $eUqFw.useEffect)(()=>{
        if (wrapperRef?.current && (0, $eI5EY.fg)('jira_list_keyboard_nav')) inlineEditNudgeRef.current = wrapperRef.current;
    }, [
        inlineEditNudgeRef,
        wrapperRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (fieldValue) setTextValue(fieldValue);
    }, [
        fieldValue,
        setTextValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // when the value (from useEditField) changes, update the textValue (from the input field).
        if (value !== textValue && (0, $eI5EY.fg)('jwm_list_new_copy_paste_behaviour')) setTextValue(value || '');
    }, // we only care about value changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setTextValue,
        value
    ]);
    /**
	 * To be deleted when jira_list_keyboard_nav is cleaned up
	 * @deprecated Use handleClick in CellNavigation for generic behaviour or useImperativeHandle in this
	 * cell for custom behaviour
	 */ const handleClick = (0, $eUqFw.useCallback)(()=>{
        if (isEditable && !editMode) {
            setEditMode(true);
            setTextValue(value || '');
        }
    }, [
        editMode,
        isEditable,
        setTextValue,
        value,
        setEditMode
    ]);
    /**
	 * To be deleted when jira_list_keyboard_nav is cleaned up
	 * @deprecated Use handleKeyDown in CellNavigation for generic behaviour or handleKeyDownNew in this
	 * cell for custom behaviour
	 */ const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        if (event.key === 'Escape') {
            setTextValue(value || '');
            wrapperRef?.current?.focus();
        }
    }, [
        setTextValue,
        value,
        wrapperRef
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setTextValue(value || '');
        return false;
    }, [
        editMode,
        setTextValue,
        value
    ]);
    const saveAndClose = (0, $eUqFw.useCallback)((event)=>{
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) event.preventDefault();
        if (editMode) {
            setEditMode(false);
            if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
        }
    }, [
        editMode,
        textValue,
        value,
        saveValue,
        createAnalyticsEvent,
        setEditMode
    ]);
    const handleBlur = (0, $eUqFw.useCallback)((event)=>{
        saveAndClose(event);
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) onBlur && onBlur(event);
    }, [
        onBlur,
        saveAndClose
    ]);
    const handleChange = (0, $eUqFw.useCallback)((event)=>{
        setTextValue(event.target.value);
        resetError();
    }, [
        resetError,
        setTextValue
    ]);
    const renderNudgeWrapper = (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g43uO.InlineEditListNudgeAsync), null, children);
    /**
	 * To be deleted when jira_list_keyboard_nav is cleaned up
	 * @deprecated wrapperRef is now managed in CellNavigation
	 */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
        inlineEditNudgeRef.current = ref;
    }, [
        inlineEditNudgeRef,
        wrapperRef
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)((e)=>{
        saveAndClose(e);
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) wrapperRef?.current?.focus();
    }, [
        saveAndClose,
        wrapperRef
    ]);
    const cellOverrides = (0, $eUqFw.useCallback)(()=>({
            onKeyDown: handleKeyDownNew
        }), [
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    const textCell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7c0028ace51beba$export$fc152bafe73dcaee, {
        editMode: editMode,
        onBlur: handleBlur,
        onSubmit: handleSubmit,
        onKeyDown: (0, $eI5EY.fg)('jira_list_keyboard_nav') ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : handleKeyDown,
        onChange: handleChange,
        value: textValue,
        highlight: searchHighlight,
        testId: testId
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwy0y.FixItErrorFlag), {
        error: error,
        title: (0, $kV5dc.default).errorTitle,
        description: (0, $kV5dc.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.TextCellWrapper), {
        isEditable: isEditable
    }, textCell));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isNudgeCell,
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8UbeN.TextFieldWrapper), {
        onClick: handleClick,
        isEditable: isEditable,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        tabIndex: 0,
        onKeyDown: onKeyDown,
        ref: onWrapperRef
    }, textCell));
};

});
parcelRegister("7eqzD", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $b3ad0a6f810bebd6$export$39aecc95f0365819);

var $eUqFw = parcelRequire("eUqFw");
const $b3ad0a6f810bebd6$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("jwy0y", function(module, exports) {

$parcel$export(module.exports, "FixItErrorFlag", () => $7983440f5b9e4a73$export$68221e9bb70731fc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1Yimi = parcelRequire("1Yimi");

var $kQAZu = parcelRequire("kQAZu");

var $atJIB = parcelRequire("atJIB");

var $7byHA = parcelRequire("7byHA");

var $izafr = parcelRequire("izafr");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3OBna = parcelRequire("3OBna");
const $7983440f5b9e4a73$export$68221e9bb70731fc = ({ error: error, title: title, description: description, issueType: issueType, issueTypeId: issueTypeId, fieldId: fieldId, fieldName: fieldName })=>{
    const project = (0, $kQAZu.useProject)();
    if (project.isSimplified) {
        const ASSOCIATION_OR_PERMISSION_ERROR = `Field '${fieldId}' cannot be set. It is not on the appropriate screen, or unknown.`;
        const errorMessage = error instanceof (0, $7byHA.ValidationError) ? error.errors && error.errors[0] && error.errors[0].error || error.message : String(error);
        const isFixitError = errorMessage?.includes(ASSOCIATION_OR_PERMISSION_ERROR);
        const isEditPermissionError = isFixitError && !project.permissions.editIssues;
        if (isEditPermissionError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7983440f5b9e4a73$var$EditPermissionErrorFlag, null);
        if (isFixitError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7983440f5b9e4a73$var$FieldAssociationErrorFlag, {
            issueType: issueType,
            fieldName: fieldName,
            fieldId: fieldId,
            projectId: project.id,
            issueTypeId: issueTypeId,
            isAdmin: project.permissions.administerProject
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: title,
        description: description
    });
};
const $7983440f5b9e4a73$var$EditPermissionErrorFlag = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'editPermissionErrorFlag');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer // @ts-expect-error - TS2322 - Type '{ flag: FlagConfiguration; }' is not assignable to type 'IntrinsicAttributes'.
    ), {
        flag: {
            type: 'warning',
            title: formatMessage((0, $3OBna.default).editPermissionErrorTitle),
            actions: [
                {
                    content: formatMessage((0, $3OBna.default).editPermissionErrorAction),
                    href: '/secure/ContactAdministrators!default.jspa',
                    target: '_blank',
                    onClick: ()=>{
                        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromEditPermissionFlag');
                    }
                }
            ]
        }
    });
};
const $7983440f5b9e4a73$var$FieldAssociationErrorFlag = ({ fieldId: fieldId, fieldName: fieldName, issueType: issueType, projectId: projectId, issueTypeId: issueTypeId, isAdmin: isAdmin })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { associate: associate } = (0, $atJIB.useAssociateField)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [shouldAssociate, setShouldAssociate] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const dismissPreviousFlags = (0, $eUqFw.useRef)(true);
    const FIXIT_ERROR_FLAG_ID = `FIXIT_ERROR_FLAG_FOR_${issueTypeId}_${fieldId}`;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldAssociate) {
            setShouldAssociate(false);
            associate({
                input: {
                    projectId: String(projectId),
                    fieldId: fieldId,
                    issueTypeIds: [
                        Number(issueTypeId)
                    ]
                },
                fieldName: fieldName,
                issueType: issueType,
                showSuccess: true,
                analyticsAttributes: {
                    source: 'business-fields.common.ui.fixit-error-flag'
                }
            }) // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(()=>{});
        }
    }, [
        associate,
        fieldId,
        fieldName,
        issueType,
        issueTypeId,
        projectId,
        shouldAssociate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'fixItErrorFlag');
    }, [
        createAnalyticsEvent
    ]);
    const actions = isAdmin ? [
        {
            content: formatMessage((0, $3OBna.default).updateFieldAssociationAction),
            onClick: async ()=>{
                if (projectId) {
                    dismissFlag(FIXIT_ERROR_FLAG_ID); // When associate service is called from the flag, it triggers refetch available fields internally, but
                    // `refetch` function is `undefined`. This could be because the flag is mounted outside of the view component
                    // where the available fields service hasn't been called yet (we can only refetch a service that has been called at least once).
                    // Hence we need to make sure we call associate() inside of the cell.
                    setShouldAssociate(true);
                }
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'associateFieldFromFixItFlag');
            }
        }
    ] : [
        {
            content: formatMessage((0, $3OBna.default).editIssueTypesPermissionErrorAction),
            href: '/secure/ContactAdministrators!default.jspa',
            target: '_blank',
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'contactAdministratorFromFixitFlag');
            }
        }
    ]; // dismiss any existing flag with the same id
    if (dismissPreviousFlags.current) {
        dismissFlag(FIXIT_ERROR_FLAG_ID);
        dismissPreviousFlags.current = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer // @ts-expect-error - TS2322 - Type '{ flag: FlagConfiguration; }' is not assignable to type 'IntrinsicAttributes'.
    ), {
        flag: {
            id: FIXIT_ERROR_FLAG_ID,
            type: 'warning',
            title: [
                (0, $3OBna.default).editAssociationErrorTitle,
                {
                    fieldName: fieldName,
                    issueType: issueType,
                    normal: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7983440f5b9e4a73$var$FlagMessageWrapper, null, chunks),
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                            as: "strong"
                        }, chunks)
                }
            ],
            actions: actions
        }
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7983440f5b9e4a73$var$FlagMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3OBna", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2d4e38ff6ef256$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ce2d4e38ff6ef256$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editAssociationErrorTitle: {
        "id": "business-fields.common.fixit-error-flag.edit-association-error-title",
        "defaultMessage": "<normal><strong>{fieldName}</strong> is not associated to the <strong>{issueType}</strong> issue type</normal>"
    },
    updateFieldAssociationAction: {
        "id": "business-fields.common.fixit-error-flag.update-field-association-action",
        "defaultMessage": "Update field association"
    },
    editPermissionErrorTitle: {
        "id": "business-fields.common.fixit-error-flag.edit-permission-error-title",
        "defaultMessage": "You do not have permission to edit in this project"
    },
    editPermissionErrorAction: {
        "id": "business-fields.common.fixit-error-flag.edit-permission-error-action",
        "defaultMessage": "Contact your project admin"
    },
    editIssueTypesPermissionErrorAction: {
        "id": "business-fields.common.fixit-error-flag.edit-issue-types-permission-error-action",
        "defaultMessage": "Contact your project admin to edit issue types"
    }
});

});


parcelRegister("7PAQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea2f8628dbce2aa$export$2e2bcd8739ae039);

var $gttjd = parcelRequire("gttjd");

var $e63D2 = parcelRequire("e63D2");
var $dea2f8628dbce2aa$export$2e2bcd8739ae039 = (0, $e63D2.default);

});
parcelRegister("gttjd", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $38a0e824f156ae86$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $38a0e824f156ae86$export$a3aee8a24a54661f);

var $e1vfz = parcelRequire("e1vfz");

var $hTLlD = parcelRequire("hTLlD");

var $lyOYo = parcelRequire("lyOYo");

var $5iWql = parcelRequire("5iWql");
const $38a0e824f156ae86$export$f3f2882e8b11d731 = (0, $5iWql.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $38a0e824f156ae86$export$1633667427d99697 = (0, $5iWql.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1vfz)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $38a0e824f156ae86$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $38a0e824f156ae86$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $38a0e824f156ae86$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $38a0e824f156ae86$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $38a0e824f156ae86$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $38a0e824f156ae86$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $38a0e824f156ae86$export$f3f2882e8b11d731(text);
    const textMatches = $38a0e824f156ae86$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $38a0e824f156ae86$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(leading));
        parts.push($38a0e824f156ae86$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($38a0e824f156ae86$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("e63D2", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e295d31ad42542$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gttjd = parcelRequire("gttjd");

var $lbHMu = parcelRequire("lbHMu");
const $29e295d31ad42542$var$HighlightTextWithParser = /*#__PURE__*/ (0, $eUqFw.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $gttjd.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbHMu.default), {
        parts: parts
    });
});
var $29e295d31ad42542$export$2e2bcd8739ae039 = $29e295d31ad42542$var$HighlightTextWithParser;

});
parcelRegister("lbHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed9071505b4a281f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gda1r = parcelRequire("gda1r");
const $ed9071505b4a281f$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gda1r.Mark), {
            key: i
        }, part.content);
    }));
var $ed9071505b4a281f$export$2e2bcd8739ae039 = $ed9071505b4a281f$var$HighlightText;

});
parcelRegister("gda1r", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $8f973f57522751f3$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8f973f57522751f3$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});




parcelRegister("g43uO", function(module, exports) {

$parcel$export(module.exports, "InlineEditListNudgeAsync", () => $6fe8dd7cf033361b$export$ae0c23fe550deebc);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $ibSJJ = parcelRequire("ibSJJ");
const $6fe8dd7cf033361b$var$runtimeProps = {};
const $6fe8dd7cf033361b$var$entryPointParams = {};
const $6fe8dd7cf033361b$export$ae0c23fe550deebc = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $ibSJJ.inlineEditNudgeEntrypoint), $6fe8dd7cf033361b$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$501e36925fa10eef),
        packageName: "jiraListOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $6fe8dd7cf033361b$var$runtimeProps
    }));
};

});
parcelRegister("ibSJJ", function(module, exports) {

$parcel$export(module.exports, "inlineEditNudgeEntrypoint", () => $49d36488e8e47561$export$8073de424af508bc);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $49d36488e8e47561$export$8073de424af508bc = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("b53q6")), {
        moduleId: "1e3103f7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("b53q6", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3G9D7');
        const value = parcelRequire('5ntTS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3G9D7").then(()=>parcelRequire('5ntTS'));
}

});



parcelRegister("kV5dc", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a40443dbebc6ac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $57a40443dbebc6ac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.text-cell.error-title",
        "defaultMessage": "We couldn't save the text value."
    },
    errorMessage: {
        "id": "business-list.list-view.text-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("eggEB", function(module, exports) {

$parcel$export(module.exports, "TypeCell", () => $f67cc309a1f19bcb$export$1034b01824b6a80);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");

var $gEmpR = parcelRequire("gEmpR");

var $d3C6e = parcelRequire("d3C6e");

var $hnzPP = parcelRequire("hnzPP");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2jrDX = parcelRequire("2jrDX");

var $8UbeN = parcelRequire("8UbeN");

var $egJIx = parcelRequire("egJIx");

var $aqGaJ = parcelRequire("aqGaJ");

var $fnB7E = parcelRequire("fnB7E");
const $f67cc309a1f19bcb$var$empty = ()=>null;
const $f67cc309a1f19bcb$export$1034b01824b6a80 = /*#__PURE__*/ (0, $eUqFw.memo)(({ id: id, iconUrl: iconUrl, name: name, avatarId: avatarId = '', onChildCreateButtonClicked: onChildCreateButtonClicked, hierarchyLevel: hierarchyLevel = 0, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, cellRef: cellRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlatList: showFlatList } = (0, $aqGaJ.useHierarchyConfig)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onChildCreateButtonClicked && setTimeout(()=>{
            onChildCreateButtonClicked();
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'childCreateButton');
    }, [
        createAnalyticsEvent,
        onChildCreateButtonClicked
    ]);
    const { hasCreateSubtask: hasCreateSubtask } = (0, $egJIx.useJWMListFeatures)();
    const { data: { issueTypes: issueTypes } } = (0, $gEmpR.useIssueTypesAndFields)({
        issueOperation: 'CREATE'
    });
    const canCreateChildIssue = hierarchyLevel > 0 ? issueTypes.some((issueType)=>issueType.hierarchyLevel === hierarchyLevel - 1) : hasCreateSubtask && issueTypes.some((issueType)=>issueType.hierarchyLevel === -1);
    const canCreateChild = !(0, $d3C6e.isOptimisticIssue)(Number(id)) && !showFlatList && typeof onChildCreateButtonClicked === 'function' && canCreateChildIssue;
    const childCreateContent = canCreateChild && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jrDX.default), {
        tooltip: formatMessage((0, $fnB7E.default).createChildItem),
        label: formatMessage((0, $fnB7E.default).createChildItem),
        onClick: handleClick,
        shouldDisplayBtn: isSelected
    });
    const iconContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: iconUrl,
        alt: name,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
                url: `/secure/viewavatar?size=medium&avatarId=${avatarId}&avatarType=issuetype`,
                alt: name,
                fallback: $f67cc309a1f19bcb$var$empty
            })
    }); /**
                                                                                                                                                                                                           * To be deleted when jira_list_keyboard_nav is cleaned up
                                                                                                                                                                                                           * @deprecated Now handled in CellNavigation component
                                                                                                                                                                                                           */ 
    const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]); /**
                     * To be deleted when jira_list_keyboard_nav is cleaned up
                     * @deprecated Now handled in handleKeyDownNew
                     */ 
    const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Enter') return;
        onKeyDown?.(e);
    }, [
        onKeyDown
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (event.code === 'Enter') return true;
        return false;
    }, []); // ignore clicks to avoid entering editMode
    const handleClickNew = (0, $eUqFw.useCallback)(()=>true, []);
    const cellOverrides = (0, $eUqFw.useMemo)(()=>()=>({
                onClick: handleClickNew,
                onKeyDown: handleKeyDownNew
            }), [
        handleClickNew,
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f67cc309a1f19bcb$var$TypeWrapper, {
        "data-testid": "business-list.ui.list-view.type-cell.type-wrapper",
        canCreateChild: canCreateChild,
        isFocused: isSelected,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name
    }, iconContent), childCreateContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f67cc309a1f19bcb$var$TypeWrapperOld, {
        canCreateChild: canCreateChild,
        onBlur: onBlur,
        tabIndex: 0,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef,
        isFocused: isSelected,
        "data-testid": "business-list.ui.list-view.type-cell.type-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: name
    }, iconContent), childCreateContent);
});
/**
 * To be deleted when jira_list_keyboard_nav is cleaned up
 * @deprecated Now use TypeWrapper
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f67cc309a1f19bcb$var$TypeWrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoglpi _19bvldb6 _k8empxbi",
            __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f67cc309a1f19bcb$var$TypeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _19bvldb6 _k8empxbi",
            __cmplp ? "_1hlxu2gc" : "_1hlxidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnzPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9fc3da0c774fa7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/handler-naming */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b = (0, $c9TLT.gridSize) * 2;
class $ca9fc3da0c774fa7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            height: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        return url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$ImagePlaceholder = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $PdmhA).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fnB7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f82679cf26977614$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f82679cf26977614$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addChildItem: {
        "id": "business-list.list-view.type-cell.add-child-item",
        "defaultMessage": "Add child item"
    },
    createSubtask: {
        "id": "business-list.list-view.type-cell.create-subtask",
        "defaultMessage": "Create subtask"
    },
    createTask: {
        "id": "business-list.list-view.type-cell.create-task",
        "defaultMessage": "Create"
    },
    createChildItem: {
        "id": "business-list.list-view.type-cell.create-child-item",
        "defaultMessage": "Create child issue"
    }
});

});


parcelRegister("1NqHF", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $819bcdea9e3086de$export$110272e30ac53e5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $8GAdb = parcelRequire("8GAdb");

var $cf2Y4 = parcelRequire("cf2Y4");

var $4TezD = parcelRequire("4TezD");

var $jwy0y = parcelRequire("jwy0y");

var $eI5EY = parcelRequire("eI5EY");

var $gGiWF = parcelRequire("gGiWF");

var $8UbeN = parcelRequire("8UbeN");

var $7Bzvw = parcelRequire("7Bzvw");
const $819bcdea9e3086de$export$110272e30ac53e5 = /*#__PURE__*/ (0, $eUqFw.memo)(({ issueKey: issueKey, fieldKey: fieldKey, isEditable: isEditable, fieldValue: fieldValue, fieldType: fieldType, isSelected: isSelected = false, wrapperRef: wrapperRef, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, fieldName: fieldName = '', issueType: issueType = '', issueTypeId: issueTypeId = '', editMode: editModeNew = false, setEditMode: setEditModeNew = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), cellRef: cellRef, inputValue: inputValue = fieldValue ?? '', onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) })=>{
    const [textValueOld, setTextValueOld] = (0, $eUqFw.useState)(fieldValue || '');
    const [editMode, setEditMode] = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? [
        editModeNew,
        setEditModeNew
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useState)(false);
    const textValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? inputValue : textValueOld;
    const setTextValue = (0, $eI5EY.fg)('jira_list_keyboard_nav') ? onInputChange : setTextValueOld;
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: fieldValue
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // reset textValue when there's an error
        if (error && value !== textValue) setTextValue(value ?? '');
    }, [
        error,
        setTextValue,
        textValue,
        value
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in useEffect above
   */ const handleClick = (0, $eUqFw.useCallback)(()=>{
        if (isEditable && !editMode) {
            setEditMode(true);
            setTextValue(value || '');
        }
    }, [
        editMode,
        isEditable,
        setEditMode,
        setTextValue,
        value
    ]);
    const saveAndClose = (0, $eUqFw.useCallback)((event)=>{
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) event.preventDefault();
        if (editMode) {
            setEditMode(false);
            if (textValue !== value) saveValue(textValue, null, createAnalyticsEvent({}));
        }
    }, [
        createAnalyticsEvent,
        editMode,
        saveValue,
        setEditMode,
        textValue,
        value
    ]);
    const handleChange = (0, $eUqFw.useCallback)((event)=>{
        setTextValue(event.target.value);
        resetError();
    }, [
        resetError,
        setTextValue
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in CellNavigation component
   */ const handleKeyDown = (0, $eUqFw.useCallback)((e)=>{
        e.stopPropagation();
        !editMode && onKeyDown?.(e);
    }, [
        editMode,
        onKeyDown
    ]);
    const handleKeyDownNew = (0, $eUqFw.useCallback)((event)=>{
        if (editMode && event.code === 'Escape') setTextValue(value ?? '');
        return false;
    }, [
        editMode,
        setTextValue,
        value
    ]);
    const cellOverrides = (0, $eUqFw.useMemo)(()=>()=>({
                onKeyDown: handleKeyDownNew
            }), [
        handleKeyDownNew
    ]);
    (0, $eUqFw.useImperativeHandle)(cellRef, cellOverrides, [
        cellOverrides
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in CellNavigation component
   */ const onWrapperRef = (0, $eUqFw.useCallback)((ref)=>{
        if (wrapperRef) // eslint-disable-next-line no-param-reassign
        wrapperRef.current = ref;
    }, [
        wrapperRef
    ]);
    /**
   * To be deleted when jira_list_keyboard_nav is cleaned up
   * @deprecated Now handled in handleKeyDown
   */ const handleTextFieldKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (e.key === 'Escape') {
            e.preventDefault();
            setTextValue(value || '');
            // settimeout used here as there is a conflict with textfield autofocus
            setTimeout(()=>{
                wrapperRef?.current?.focus();
            });
        }
    }, [
        setTextValue,
        value,
        wrapperRef
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)((event)=>{
        saveAndClose(event);
        // settimeout used here as there is a conflict with textfield autofocus
        if (!(0, $eI5EY.fg)('jira_list_keyboard_nav')) setTimeout(()=>{
            wrapperRef?.current?.focus();
        });
    }, [
        saveAndClose,
        wrapperRef
    ]);
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, editMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        autoFocus: true,
        onBlur: saveAndClose,
        value: textValue,
        onChange: handleChange,
        onKeyDown: (0, $eI5EY.fg)('jira_list_keyboard_nav') ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : handleTextFieldKeyDown
    })) : value != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: value,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($819bcdea9e3086de$var$LinkText, null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($819bcdea9e3086de$var$LinkFollower, {
        "data-component-selector": "business-list.ui.list-view.url-cell.link-follower"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GAdb))), {
        label: value
    }))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwy0y.FixItErrorFlag), {
        error: error,
        title: (0, $7Bzvw.default).errorTitle,
        description: (0, $7Bzvw.default).errorMessage,
        issueType: issueType,
        issueTypeId: issueTypeId,
        fieldId: fieldKey,
        fieldName: fieldName
    }));
    if ((0, $eI5EY.fg)('jira_list_keyboard_nav')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4TezD.CellWrapper), {
        isEditable: isEditable,
        testId: "business-list.ui.list-view.url-cell.url-cell-wrapper",
        hasPadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($819bcdea9e3086de$var$Wrapper, null, cellContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($819bcdea9e3086de$var$WrapperOld, {
        isFocused: editMode || isSelected,
        onClick: handleClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: handleKeyDown,
        ref: onWrapperRef,
        tabIndex: 0,
        "data-testid": "business-list.ui.list-view.url-cell.url-cell-wrapper"
    }, cellContent);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $819bcdea9e3086de$var$LinkFollower = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _11q7txrc _1e0cglyw _4cvr1h6o _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $819bcdea9e3086de$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _p12f1osq _1bto1l2s _1reo15vq _18m915vq _1o9zkb7n",
            __cmplp.className
        ])
    });
});
const $819bcdea9e3086de$var$WrapperOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8UbeN.WrapperCommon), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _ci54u2gc _18ywh2mm _1j631txw",
            __cmplp.className
        ])
    });
});
$819bcdea9e3086de$var$WrapperOld.displayName = 'Wrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $819bcdea9e3086de$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _80om1kdv _o5721q9c _35md1txw _1fqm1h6o _1uv11osq _1gvb1osq _1yds1osq _1hw71txw _156d1y6m _6wji1h6o _bod01osq _ci54u2gc _18ywh2mm _1j631txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Bzvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c11bc7f1c1f060a6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c11bc7f1c1f060a6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTitle: {
        "id": "business-list.list-view.url-cell.error-title",
        "defaultMessage": "We couldn't save the text value."
    },
    errorMessage: {
        "id": "business-list.list-view.url-cell.error-message",
        "defaultMessage": "Check your connection, then give it another try."
    }
});

});


parcelRegister("261bh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4f7c60646d0413$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $3f7Cz = parcelRequire("3f7Cz");

var $gGtKh = parcelRequire("gGtKh");

const $6a4f7c60646d0413$var$UserCell = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("57A9G")), {
    moduleId: "./src/packages/business/list/src/ui/list-view/user-cell/main.tsx"
});
const $6a4f7c60646d0413$var$AsyncUserCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "user-cell",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3f7Cz.default), {
        shouldUseInvitePeopleModal: true,
        source: "listViewAssignee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a4f7c60646d0413$var$UserCell, props)));
var $6a4f7c60646d0413$export$2e2bcd8739ae039 = $6a4f7c60646d0413$var$AsyncUserCell;

});
parcelRegister("57A9G", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('83ZBb');
        const value = parcelRequire('gv9fI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("83ZBb").then(()=>parcelRequire('gv9fI'));
}

});





parcelRegister("8vncz", function(module, exports) {

$parcel$export(module.exports, "SeenIt", () => $e60cd27fbb1c899a$export$dbdcc139f79b9b57);

var $eUqFw = parcelRequire("eUqFw");

var $jBAQz = parcelRequire("jBAQz");
const $e60cd27fbb1c899a$export$6be99c53fabc250b = 630720000000; // ~20 years
const $e60cd27fbb1c899a$export$dbdcc139f79b9b57 = /*#__PURE__*/ (0, $eUqFw.memo)(({ flag: flag })=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $jBAQz.setFlag)(flag, $e60cd27fbb1c899a$export$6be99c53fabc250b);
    }, [
        flag
    ]);
    return null;
});

});
parcelRegister("jBAQz", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $1749c1c9732fa517$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $1749c1c9732fa517$export$5e165df1e30a1331);

var $czx3b = parcelRequire("czx3b");

var $hwbh0 = parcelRequire("hwbh0");

var $e91YZ = parcelRequire("e91YZ");

var $1Cw1V = parcelRequire("1Cw1V");

var $gYp0l = parcelRequire("gYp0l");
const $1749c1c9732fa517$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $1749c1c9732fa517$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $1749c1c9732fa517$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $gYp0l.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $gYp0l.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1Cw1V.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $gYp0l.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $1749c1c9732fa517$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $1749c1c9732fa517$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $gYp0l.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $1749c1c9732fa517$export$5e165df1e30a1331 = async (flagKey, ttl = $1749c1c9732fa517$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $gYp0l.default) {
        const value = (0, $gYp0l.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $gYp0l.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1Cw1V.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});

parcelRegister("hwbh0", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $7hlYT = parcelRequire("7hlYT");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $cc0e2b7b9a1e48d7$var$zipObject(props, values) {
    return $7hlYT(props || [], values || [], $jDLwO);
}
module.exports = $cc0e2b7b9a1e48d7$var$zipObject;

});
parcelRegister("7hlYT", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $54cb2be8ad88e749$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $54cb2be8ad88e749$var$baseZipObject;

});


parcelRegister("1Cw1V", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $27a69f89da9f41d0$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $27a69f89da9f41d0$export$d5815430bcc75df0);

var $czx3b = parcelRequire("czx3b");

var $7EhAs = parcelRequire("7EhAs");
const $27a69f89da9f41d0$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $27a69f89da9f41d0$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $27a69f89da9f41d0$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $27a69f89da9f41d0$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$27a69f89da9f41d0$var$convertToDates(response));
};

});

parcelRegister("gYp0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $16304c7221461599$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $16304c7221461599$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $89bO2.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $16304c7221461599$export$2e2bcd8739ae039 = $16304c7221461599$var$createStorage();

});



parcelRegister("fTv4c", function(module, exports) {

$parcel$export(module.exports, "useBoard", () => $1ef7ad88a18f3dc3$export$15adc93832970b54);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $kJlBc = parcelRequire("kJlBc");

var $2futN = parcelRequire("2futN");
var $fZLkL = parcelRequire("fZLkL");

var $9T0Tw = parcelRequire("9T0Tw");
const $1ef7ad88a18f3dc3$var$USER_BOARD_ROUTE_NAMES = [
    `${(0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD}`,
    `${(0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BACKLOG}`,
    `${(0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_REPORT}`
];
const $1ef7ad88a18f3dc3$var$isOnUserBoardRoute = (route)=>$1ef7ad88a18f3dc3$var$USER_BOARD_ROUTE_NAMES.includes(route.name);
const $1ef7ad88a18f3dc3$var$isOnLocationLessBoardRoute = (match, query)=>{
    const { locationless: locationless = 'false' } = query;
    return match.url.includes('RapidBoard.jspa') && JSON.parse(locationless) === true;
};
const $1ef7ad88a18f3dc3$export$50230c720b1c453e = ()=>{
    const [{ match: match, route: route, query: query }] = (0, $kJlBc.useRouter)();
    return $1ef7ad88a18f3dc3$var$isOnUserBoardRoute(route) || $1ef7ad88a18f3dc3$var$isOnLocationLessBoardRoute(match, query);
};
const $1ef7ad88a18f3dc3$export$15adc93832970b54 = ()=>{
    const isOnUserOrLocationlessBoardRoute = $1ef7ad88a18f3dc3$export$50230c720b1c453e();
    // pb -> project board
    const { data: pb, loading: pbLoading, error: pbError } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    // ub -> user board
    const { data: ub, loading: ubLoading, error: ubError } = (0, $fZLkL.useJiraUserBoardNavigationResource)();
    const projectBoard = (0, $eUqFw.useMemo)(()=>pb && (0, $9T0Tw.extractData)(pb), [
        pb
    ]);
    const userBoard = (0, $eUqFw.useMemo)(()=>ub && (0, $9T0Tw.extractUserBoard)(ub), [
        ub
    ]);
    if (isOnUserOrLocationlessBoardRoute) return {
        data: userBoard,
        loading: ubLoading,
        error: ubError
    };
    return {
        data: projectBoard,
        loading: pbLoading,
        error: pbError
    };
};

});

parcelRegister("5bIU1", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $29199b315decc1d0$export$4a39035bacc4ed76);

var $eUqFw = parcelRequire("eUqFw");

var $2futN = parcelRequire("2futN");

var $fx7mS = parcelRequire("fx7mS");
var $4tOq6 = parcelRequire("4tOq6");
var $gleuI = parcelRequire("gleuI");

var $6EvIB = parcelRequire("6EvIB");
const $29199b315decc1d0$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $4tOq6.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $gleuI.useSidebarFeatureToggled)();
    const extractedData = (0, $eUqFw.useMemo)(()=>data && (0, $6EvIB.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $eUqFw.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $fx7mS.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("fx7mS", function(module, exports) {

$parcel$export(module.exports, "useClearSidebarToggled", () => $56a5d67cb570e6e5$export$2946f555c6f48127);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $2futN = parcelRequire("2futN");

var $hzcvF = parcelRequire("hzcvF");

var $gleuI = parcelRequire("gleuI");

var $4tOq6 = parcelRequire("4tOq6");
const $56a5d67cb570e6e5$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $2futN.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $gleuI.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $4tOq6.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $eUqFw.useRef)(false);
    const previousData = (0, $hzcvF.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $eUqFw.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $eUqFw.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("gleuI", function(module, exports) {

$parcel$export(module.exports, "useFeature", () => $4a189912c2bfb976$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $4a189912c2bfb976$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $4a189912c2bfb976$export$9eef668f94562feb);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $l7y1V = parcelRequire("l7y1V");
const $4a189912c2bfb976$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $4a189912c2bfb976$var$store = (0, $a61MH.createStore)({
    name: 'feature-toggle',
    initialState: $4a189912c2bfb976$var$initialState,
    actions: $l7y1V.actions
});
const $4a189912c2bfb976$export$fc97652867e5867e = (0, $ggKAj.createHook)($4a189912c2bfb976$var$store);
const $4a189912c2bfb976$export$207b461610a7fca6 = (0, $ggKAj.createHook)($4a189912c2bfb976$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $4a189912c2bfb976$export$e7699ed698eeb9ec = (0, $ggKAj.createHook)($4a189912c2bfb976$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $4a189912c2bfb976$export$9eef668f94562feb = (0, $ggKAj.createHook)($4a189912c2bfb976$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("l7y1V", function(module, exports) {

$parcel$export(module.exports, "actions", () => $be4dec2964c48764$export$e324594224ef24da);

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");

var $hgS1t = parcelRequire("hgS1t");

var $lav2w = parcelRequire("lav2w");

var $acaKg = parcelRequire("acaKg");

var $7pTBU = parcelRequire("7pTBU");
const $be4dec2964c48764$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $be4dec2964c48764$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $acaKg.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $lav2w.filterAndSort)(data);
                (0, $lav2w.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $guiFP.default)({
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $be4dec2964c48764$var$syncFeaturesNew = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const isListViewEnabled = (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation');
        const featureMap = (0, $hgS1t.getFeatureMap)({
            isListViewEnabled: isListViewEnabled
        });
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $be4dec2964c48764$var$syncFeaturesOld = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        let featureMap = (0, $hgS1t.featureMap);
        if ((0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        const keys = new Set(Object.keys(featureMap));
        const synced = features.map((f)=>{
            const id = f.feature;
            if (keys.has(id)) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $be4dec2964c48764$var$syncFeatures = (sidebarFeatureStatus)=>(0, $eI5EY.fg)('jsw_feature_toggle_project_pages') ? $be4dec2964c48764$var$syncFeaturesNew(sidebarFeatureStatus) : $be4dec2964c48764$var$syncFeaturesOld(sidebarFeatureStatus);
const $be4dec2964c48764$var$updateFeatureNew = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $hgS1t.getFeatureMap)();
        if ((0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $lav2w.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $7pTBU.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $guiFP.default)({
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $be4dec2964c48764$var$updateFeatureOld = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        let featureMap = (0, $hgS1t.featureMap);
        if ((0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation')) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $lav2w.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $7pTBU.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $guiFP.default)({
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $be4dec2964c48764$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>(0, $eI5EY.fg)('jsw_feature_toggle_project_pages') ? $be4dec2964c48764$var$updateFeatureNew({
        boardId: boardId,
        feature: feature,
        dependentFeature: dependentFeature,
        analyticsEvent: analyticsEvent,
        onError: onError,
        onAfterUpdate: onAfterUpdate
    }) : $be4dec2964c48764$var$updateFeatureOld({
        boardId: boardId,
        feature: feature,
        dependentFeature: dependentFeature,
        analyticsEvent: analyticsEvent,
        onError: onError,
        onAfterUpdate: onAfterUpdate
    });
const $be4dec2964c48764$export$e324594224ef24da = {
    fetchFeatures: $be4dec2964c48764$var$fetchFeatures,
    updateFeature: $be4dec2964c48764$var$updateFeature,
    syncFeatures: $be4dec2964c48764$var$syncFeatures,
    clearSiderbarFeatureToggled: $be4dec2964c48764$var$clearSiderbarFeatureToggled
};

});
parcelRegister("hgS1t", function(module, exports) {

$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $e55474b5442b6fa2$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $e55474b5442b6fa2$export$143e1d685830adbe);
$parcel$export(module.exports, "listFeature", () => $e55474b5442b6fa2$export$4ddfd7a9f5527982);
$parcel$export(module.exports, "featureMap", () => $e55474b5442b6fa2$export$a712b1e96d47b856);
$parcel$export(module.exports, "getFeatureMap", () => $e55474b5442b6fa2$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $e55474b5442b6fa2$export$f5e4c120ac01b615);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $5iWql = parcelRequire("5iWql");

var $5pv0k = parcelRequire("5pv0k");

var $28ybo = parcelRequire("28ybo");

var $fD5Ev = parcelRequire("fD5Ev");

var $6nIG2 = parcelRequire("6nIG2");

var $8CfG4 = parcelRequire("8CfG4");

var $1vuAp = parcelRequire("1vuAp");

var $exb0h = parcelRequire("exb0h");
const $e55474b5442b6fa2$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $e55474b5442b6fa2$export$143e1d685830adbe = 'manage-feature-menu-item';
const $e55474b5442b6fa2$export$4ddfd7a9f5527982 = {
    'jsw.agility.list_view': {
        descriptionKey: 'listDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fD5Ev))), {
            label: ""
        }),
        statusKey: 'hasList',
        order: 35,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES).SOFTWARE_LIST
        ]
    }
};
const $e55474b5442b6fa2$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vuAp))), {
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE,
            (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pv0k))), {
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            (0, $exb0h.ROUTE_NAMES).SOFTWARE_ISSUE_NAVIGATOR,
            (0, $exb0h.ROUTE_NAMES).ISSUE
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $e55474b5442b6fa2$export$6ac50cf33852adb5 = (0, $5iWql.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled, isListViewEnabled: isListViewEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1vuAp))), {
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                (0, $exb0h.ROUTE_NAMES).SOFTWARE_TIMELINE,
                (0, $exb0h.ROUTE_NAMES).SOFTWARE_ROADMAP
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pv0k))), {
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                (0, $exb0h.ROUTE_NAMES).SOFTWARE_BACKLOG
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    (0, $exb0h.ROUTE_NAMES).SOFTWARE_ISSUE_NAVIGATOR,
                    (0, $exb0h.ROUTE_NAMES).ISSUE
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                (0, $exb0h.ROUTE_NAMES).PROJECT_PAGES
            ]
        },
        ...isListViewEnabled && $e55474b5442b6fa2$export$4ddfd7a9f5527982
    }), (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $e55474b5442b6fa2$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("5pv0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f07565d43ea9ca6$var$_react = $3f07565d43ea9ca6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3f07565d43ea9ca6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3f07565d43ea9ca6$var$BacklogIcon = (props)=>/*#__PURE__*/ $3f07565d43ea9ca6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17v2.002zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0117.006 21H4.994A1.998 1.998 0 013 19.002v-2.004z"/><path d="M5 15h12v-2H5v2zm-2-4h16v6H3v-6z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9v2.002zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0119.006 13H6.994A1.998 1.998 0 015 11.002V8.998z"/><path d="M5 5v2h12V5H5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3V4.998z"/></g></svg>`
    }, props));
$3f07565d43ea9ca6$var$BacklogIcon.displayName = 'BacklogIcon';
var $3f07565d43ea9ca6$var$_default = $3f07565d43ea9ca6$var$BacklogIcon;
module.exports.default = $3f07565d43ea9ca6$var$_default;

});

parcelRegister("28ybo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18e6d81a18ae6069$var$_react = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $18e6d81a18ae6069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $18e6d81a18ae6069$var$BoardIcon = (props)=>/*#__PURE__*/ $18e6d81a18ae6069$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18zM2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props));
$18e6d81a18ae6069$var$BoardIcon.displayName = 'BoardIcon';
var $18e6d81a18ae6069$var$_default = $18e6d81a18ae6069$var$BoardIcon;
module.exports.default = $18e6d81a18ae6069$var$_default;

});

parcelRegister("fD5Ev", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60ee1f4d4329714$var$_react = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b60ee1f4d4329714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b60ee1f4d4329714$var$BulletListIcon = (props)=>/*#__PURE__*/ $b60ee1f4d4329714$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="10" y="15" width="8" height="2" rx="1"/><rect x="6" y="15" width="2" height="2" rx="1"/><rect x="10" y="11" width="8" height="2" rx="1"/><rect x="6" y="11" width="2" height="2" rx="1"/><rect x="10" y="7" width="8" height="2" rx="1"/><rect x="6" y="7" width="2" height="2" rx="1"/></g></svg>`
    }, props));
$b60ee1f4d4329714$var$BulletListIcon.displayName = 'BulletListIcon';
var $b60ee1f4d4329714$var$_default = $b60ee1f4d4329714$var$BulletListIcon;
module.exports.default = $b60ee1f4d4329714$var$_default;

});

parcelRegister("1vuAp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1190697f0a3052c9$var$_react = $1190697f0a3052c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1190697f0a3052c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1190697f0a3052c9$var$RoadmapIcon = (props)=>/*#__PURE__*/ $1190697f0a3052c9$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 2h10a3 3 0 010 6H6a3 3 0 110-6zm0 2a1 1 0 100 2h10a1 1 0 000-2H6zm4 5h8a3 3 0 010 6h-8a3 3 0 010-6zm0 2a1 1 0 000 2h8a1 1 0 000-2h-8zm-4 5h6a3 3 0 010 6H6a3 3 0 010-6zm0 2a1 1 0 000 2h6a1 1 0 000-2H6z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$1190697f0a3052c9$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $1190697f0a3052c9$var$_default = $1190697f0a3052c9$var$RoadmapIcon;
module.exports.default = $1190697f0a3052c9$var$_default;

});


parcelRegister("lav2w", function(module, exports) {

$parcel$export(module.exports, "filterAndSort", () => $90bd3e7820b384a6$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $90bd3e7820b384a6$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $90bd3e7820b384a6$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $90bd3e7820b384a6$export$5da1e8c5ba5c0dc2);

var $7GXrf = parcelRequire("7GXrf");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $hgS1t = parcelRequire("hgS1t");
const $90bd3e7820b384a6$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $90bd3e7820b384a6$export$d0e0de50c701304c = (features)=>{
    const isListViewEnabled = (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation');
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    if ((0, $eI5EY.fg)('jsw_feature_toggle_project_pages')) {
        const featureMap = (0, $hgS1t.getFeatureMap)({
            isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
            isListViewEnabled: isListViewEnabled
        });
        return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
    }
    let featureMap = (0, $hgS1t.featureMap);
    if (isListViewEnabled) featureMap = {
        ...featureMap,
        ...(0, $hgS1t.listFeature)
    };
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $90bd3e7820b384a6$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $90bd3e7820b384a6$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $90bd3e7820b384a6$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const isListViewEnabled = (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation');
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    if ((0, $eI5EY.fg)('jsw_feature_toggle_project_pages')) {
        const featureMap = (0, $hgS1t.getFeatureMap)({
            isSimplifyNavExperimentEnabled: expConfig.get('isEnabled', false),
            isListViewEnabled: isListViewEnabled
        });
        if (filteredFeatures.length < Object.keys(featureMap).length) {
            const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
            (0, $guiFP.default)({
                error: new Error("Some feature keys don't match . Please check API response"),
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'unmatchFeatureKey'
                },
                attributes: {
                    unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
                }
            });
        }
    } else {
        let featureMap = (0, $hgS1t.featureMap);
        if (isListViewEnabled) featureMap = {
            ...featureMap,
            ...(0, $hgS1t.listFeature)
        };
        if (filteredFeatures.length < Object.keys(featureMap).length) {
            const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
            (0, $guiFP.default)({
                error: new Error("Some feature keys don't match . Please check API response"),
                meta: {
                    ...(0, $hgS1t.commonErrorAnalyticsMeta),
                    id: 'unmatchFeatureKey'
                },
                attributes: {
                    unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
                }
            });
        }
    }
};

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});


parcelRegister("acaKg", function(module, exports) {

$parcel$export(module.exports, "getBoardFeatures", () => $56d9fdff2bf76afe$export$c20100b185d41ab0);

var $lRmyA = parcelRequire("lRmyA");

var $gEHAf = parcelRequire("gEHAf");
const $56d9fdff2bf76afe$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $lRmyA.performGetRequest)((0, $gEHAf.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("gEHAf", function(module, exports) {

$parcel$export(module.exports, "getBoardFeaturesUrl", () => $bba54409f593a7bc$export$3f9939d302766b52);
const $bba54409f593a7bc$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("7pTBU", function(module, exports) {

$parcel$export(module.exports, "updateBoardFeature", () => $744e8308bd8c4834$export$61f6bbb745b3a3);

var $lRmyA = parcelRequire("lRmyA");

var $gEHAf = parcelRequire("gEHAf");
const $744e8308bd8c4834$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $lRmyA.performPutRequest)((0, $gEHAf.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("4tOq6", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $c65009790646f0d4$export$7deca16ba2d9eb74);

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $21Sgb = parcelRequire("21Sgb");
const $c65009790646f0d4$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const { software: software } = (0, $ab6rA.useAppEditions)();
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isFreeInstance = software === (0, $6WXNs.FREE_EDITION);
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    if ((0, $eI5EY.fg)('jsw_feature_toggle_project_pages')) return isJSW && isTMP && isProjectAdmin && isNewInstance;
    return isJSW && isFreeInstance && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});



parcelRegister("6EvIB", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $862aee856901356e$export$9df5fa0a366163d2);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
const $862aee856901356e$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, aiInfo: aiInfo } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasList: (0, $79xbN.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: (0, $1ybV0.ff)('jsw-calendar-view') && hasCalendar,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true
    };
};

});


parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.subProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("8pOVC", function(module, exports) {

$parcel$export(module.exports, "PageHeader", () => $eb9a6480cc47bf3c$export$53f1cd6809577fc5);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1cHiE = parcelRequire("1cHiE");

var $9hdMe = parcelRequire("9hdMe");

var $aVyY3 = parcelRequire("aVyY3");
const $eb9a6480cc47bf3c$export$53f1cd6809577fc5 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: [
            (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? $eb9a6480cc47bf3c$var$pageHeaderStylesNew : $eb9a6480cc47bf3c$var$pageHeaderStylesOld
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1cHiE.Breadcrumb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? 'start' : 'center'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: [
            $eb9a6480cc47bf3c$var$titleWrapperStyles,
            (0, $1ybV0.ff)('jsw.list.sidebar-layout-update') ? $eb9a6480cc47bf3c$var$titleWrapperStylesNew : $eb9a6480cc47bf3c$var$titleWrapperStylesOld
        ]
    }, formatMessage((0, $aVyY3.default).listViewTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: !(0, $1ybV0.ff)('jsw.list.sidebar-layout-update') && $eb9a6480cc47bf3c$var$actionsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9hdMe.default), null))));
};
const $eb9a6480cc47bf3c$var$pageHeaderStylesNew = (0, $1ZAYh.xcss)({
    paddingTop: 'space.300'
});
const $eb9a6480cc47bf3c$var$pageHeaderStylesOld = (0, $1ZAYh.xcss)({
    height: 'space.300',
    marginTop: 'space.300',
    marginLeft: 'space.300',
    zIndex: 'navigation'
});
const $eb9a6480cc47bf3c$var$titleWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    maxWidth: '100%',
    overflow: 'hidden',
    flex: '1 1 auto'
});
const $eb9a6480cc47bf3c$var$titleWrapperStylesNew = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $eb9a6480cc47bf3c$var$titleWrapperStylesOld = (0, $1ZAYh.xcss)({
    fontSize: '24px',
    fontWeight: 500,
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075'
});
const $eb9a6480cc47bf3c$var$actionsStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.300'
});

});
parcelRegister("1cHiE", function(module, exports) {

$parcel$export(module.exports, "Breadcrumb", () => $42c10109394b0990$export$dabcc1ec9dd9d1cc);

var $eUqFw = parcelRequire("eUqFw");

var $c76ap = parcelRequire("c76ap");
var $dpXKE = parcelRequire("dpXKE");

var $fDLFb = parcelRequire("fDLFb");

var $kJlBc = parcelRequire("kJlBc");

var $aeIT6 = parcelRequire("aeIT6");
const $42c10109394b0990$export$dabcc1ec9dd9d1cc = ()=>{
    const [projectKeyParam] = (0, $kJlBc.usePathParam)('projectKey');
    const { data: projectEntity } = (0, $fDLFb.useBusinessEntity)();
    const { data: project } = (0, $aeIT6.useProject)();
    const projectName = project?.name;
    const isSimplified = project?.isSimplified;
    const projectId = project?.id ? String(project.id) : projectEntity.id;
    const projectKey = project?.key ? String(project.key) : projectKeyParam;
    if (projectName == null || isSimplified == null || projectId == null || projectKey == null) // Assure that we are not rendering a broken breadcrumb
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplified
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null));
};

});

parcelRegister("9hdMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $42583891b5c27955$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $eFKPp = parcelRequire("eFKPp");

var $8cU5f = parcelRequire("8cU5f");

var $5xIu6 = parcelRequire("5xIu6");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8IelV = parcelRequire("8IelV");
const $42583891b5c27955$var$FEEDBACK_GROUP_ID = 'jsw-list-feedback';
const $42583891b5c27955$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)({
        projectType: 'software'
    });
    const onClick = (0, $eUqFw.useCallback)(()=>{
        openFeedbackModal($42583891b5c27955$var$FEEDBACK_GROUP_ID);
    }, [
        openFeedbackModal
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eFKPp))), {
            label: "",
            size: "medium"
        }),
        appearance: "subtle",
        onClick: onClick
    }, formatMessage((0, $8IelV.default).feedback));
    if ((0, $eI5EY.fg)('jsw_-_list_internal_feedback_tooltip')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        hideTooltipOnClick: true,
        testId: "spa-apps-jsw-list.ui.page-header.feedback-button.tooltip",
        content: formatMessage((0, $8IelV.default).tooltip)
    }, content);
    return content;
};
var $42583891b5c27955$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($42583891b5c27955$var$FeedbackButton);

});
parcelRegister("8IelV", function(module, exports) {

$parcel$export(module.exports, "default", () => $299dffe7e721b75c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $299dffe7e721b75c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedback: {
        "id": "spa-apps-jsw-list.page-header.feedback-button.feedback",
        "defaultMessage": "Give feedback"
    },
    tooltip: {
        "id": "spa-apps-jsw-list.page-header.feedback-button.tooltip",
        "defaultMessage": "This is for internal feedback"
    }
});

});


parcelRegister("aVyY3", function(module, exports) {

$parcel$export(module.exports, "default", () => $594df393ceec28fb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $594df393ceec28fb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    listViewTitle: {
        "id": "spa-apps-jsw-list.page-header.list-view-title",
        "defaultMessage": "List"
    }
});

});




//# sourceMappingURL=async-nextgen-list.462bd515.js.map
